import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  GenericScalar: any;
  JSONString: any;
  UUID: any;
  Upload: any;
};

export type Abattoir = {
  __typename?: 'Abattoir';
  abattoirParts: Array<AbattoirPart>;
  addressInfo?: Maybe<Scalars['GenericScalar']>;
  competentAuthority: CompetentAuthority;
  country?: Maybe<Country>;
  extraData?: Maybe<Scalars['GenericScalar']>;
  formattedAddressInfo?: Maybe<Scalars['GenericScalar']>;
  id: Scalars['ID'];
  marks?: Maybe<Scalars['GenericScalar']>;
  number: Scalars['String'];
  remarks: Scalars['String'];
  sectionParts?: Maybe<Scalars['GenericScalar']>;
  species?: Maybe<Scalars['GenericScalar']>;
  tradingName: Scalars['String'];
};

export type AbattoirConnection = {
  __typename?: 'AbattoirConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AbattoirEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Abattoir` and its cursor. */
export type AbattoirEdge = {
  __typename?: 'AbattoirEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Abattoir>;
};

export type AbattoirEstablishment = {
  __typename?: 'AbattoirEstablishment';
  additionalInfo: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type AbattoirPart = {
  __typename?: 'AbattoirPart';
  abattoirSet: Array<Abattoir>;
  id: Scalars['ID'];
  name: Scalars['String'];
  part: Scalars['String'];
  sectionNumber: Scalars['Int'];
};

export type AcceptDeliveryInput = {
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  delivery: Scalars['ID'];
};

/** As the delivery non-initiator accept the proposed action. */
export type AcceptDeliveryPayload = {
  __typename?: 'AcceptDeliveryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  delivery?: Maybe<DeliveryType>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AcceptInvitationInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  producerGroup: Scalars['Int'];
  status: Scalars['String'];
};

export type AcceptInvitationPayload = {
  __typename?: 'AcceptInvitationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  producerGroupMember?: Maybe<ProducerGroupMemberType>;
};

export type Accreditation = {
  __typename?: 'Accreditation';
  animalType: Array<AnimalType>;
  icon: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  position: Scalars['Int'];
};

/** This is the type for the IdentifierPreferences model. */
export type ActiveIdentifierPreferencesType = {
  __typename?: 'ActiveIdentifierPreferencesType';
  alternativeId: Scalars['Boolean'];
  breedrId: Scalars['Boolean'];
  brucellosisId: Scalars['Boolean'];
  eId: Scalars['Boolean'];
  herdDoggId: Scalars['Boolean'];
  name: Scalars['Boolean'];
  passportNumber: Scalars['Boolean'];
  pedigreeId: Scalars['Boolean'];
  tattoo: Scalars['Boolean'];
  trichId: Scalars['Boolean'];
  tsuBarcode: Scalars['Boolean'];
  uhfId: Scalars['Boolean'];
  visualId: Scalars['Boolean'];
};

export type ActivityConnection = {
  __typename?: 'ActivityConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ActivityEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Activity` and its cursor. */
export type ActivityEdge = {
  __typename?: 'ActivityEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ActivityLog>;
};

export type ActivityLog = ProcessedItem & {
  __typename?: 'ActivityLog';
  activityTemplate?: Maybe<ActivityTemplate>;
  activityTemplateId?: Maybe<Scalars['Int']>;
  activityType?: Maybe<ActivityType>;
  activityTypeId?: Maybe<Scalars['Int']>;
  animal?: Maybe<PublicAnimal>;
  animalsCount?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  dontShow?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  isDeletable?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Scalars['GenericScalar']>;
  payload?: Maybe<ActivityPayload>;
  subType?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  values?: Maybe<Scalars['GenericScalar']>;
};

export type ActivityPayload = {
  __typename?: 'ActivityPayload';
  data?: Maybe<Array<Maybe<ActivityPayloadData>>>;
  /** @deprecated Use now valueDescription, shortDescription and longDescription */
  description?: Maybe<Scalars['String']>;
  longDescription?: Maybe<Scalars['String']>;
  /** @deprecated Use now valueDescription, shortDescription and longDescription */
  name?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  valueDescription?: Maybe<Scalars['String']>;
};

export type ActivityPayloadData = {
  __typename?: 'ActivityPayloadData';
  fieldSlug?: Maybe<Scalars['String']>;
  fieldType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  initialValue?: Maybe<Scalars['GenericScalar']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  unitName?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['GenericScalar']>;
};

export type ActivityTemplate = {
  __typename?: 'ActivityTemplate';
  activityType?: Maybe<ActivityType>;
  allowRepeatActivity?: Maybe<Scalars['Boolean']>;
  businessUnit?: Maybe<BusinessUnit>;
  createdBy?: Maybe<User>;
  /** @deprecated This field is deprecated and not used now. */
  description?: Maybe<Scalars['String']>;
  fields: Array<ActivityTemplateField>;
  handlers?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  /** Indicates if users are allowed to delete this activity. */
  isAllowedToDelete: Scalars['Boolean'];
  isDisabled: Scalars['Boolean'];
  isFavorite?: Maybe<Scalars['Boolean']>;
  isOwn?: Maybe<Scalars['Boolean']>;
  isPublic: Scalars['Boolean'];
  isSystem?: Maybe<Scalars['Boolean']>;
  /** It will be used as a default activity's description. It's possible to use template string here. */
  longDescription?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  regions: Array<Region>;
  /** It will be used as a default activity's name. It's possible to use template string here. */
  shortDescription: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  species: Array<AnimalType>;
  /** It will be used as a default activity's name. It's possible to use template string here. */
  valueDescription: Scalars['String'];
};

export type ActivityTemplateField = {
  __typename?: 'ActivityTemplateField';
  activityTemplate: ActivityTemplate;
  fieldType: ActivityTemplateFieldFieldType;
  id: Scalars['ID'];
  initialValue?: Maybe<Scalars['GenericScalar']>;
  isRequired: Scalars['Boolean'];
  name: Scalars['String'];
  options?: Maybe<Array<Maybe<ActivityTemplateFieldOption>>>;
  position: Scalars['Int'];
  slug?: Maybe<Scalars['String']>;
  units: ActivityTemplateFieldUnits;
};

/** An enumeration. */
export enum ActivityTemplateFieldFieldType {
  AnimalId = 'ANIMAL_ID',
  AnimalIds = 'ANIMAL_IDS',
  Boolean = 'BOOLEAN',
  BusinessUnitId = 'BUSINESS_UNIT_ID',
  ContactId = 'CONTACT_ID',
  CurrencyId = 'CURRENCY_ID',
  Date = 'DATE',
  FatScore = 'FAT_SCORE',
  FieldId = 'FIELD_ID',
  GroupId = 'GROUP_ID',
  MultiSelect = 'MULTI_SELECT',
  Number = 'NUMBER',
  Select = 'SELECT',
  SireId = 'SIRE_ID',
  String = 'STRING'
}

export type ActivityTemplateFieldOption = {
  __typename?: 'ActivityTemplateFieldOption';
  activityTemplateField: ActivityTemplateField;
  id: Scalars['ID'];
  position: Scalars['Int'];
  title: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type ActivityTemplateFieldUnit = {
  __typename?: 'ActivityTemplateFieldUnit';
  fieldTypeId?: Maybe<Scalars['String']>;
  fieldTypeName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum ActivityTemplateFieldUnits {
  Acres = 'ACRES',
  Animal = 'ANIMAL',
  Animals = 'ANIMALS',
  Area = 'AREA',
  Boolean = 'BOOLEAN',
  BusinessUnit = 'BUSINESS_UNIT',
  Cm = 'CM',
  Contact = 'CONTACT',
  Count = 'COUNT',
  Currency = 'CURRENCY',
  Date = 'DATE',
  Days = 'DAYS',
  DegreesCentigrade = 'DEGREES_CENTIGRADE',
  DistanceLarge = 'DISTANCE_LARGE',
  DistanceSmall = 'DISTANCE_SMALL',
  DistanceSmaller = 'DISTANCE_SMALLER',
  FatScore = 'FAT_SCORE',
  Field = 'FIELD',
  FlOz = 'FL_OZ',
  G = 'G',
  Gallons = 'GALLONS',
  Group = 'GROUP',
  Kg = 'KG',
  KgPerDay = 'KG_PER_DAY',
  KgPerHa = 'KG_PER_HA',
  Lbs = 'LBS',
  Micron = 'MICRON',
  Ml = 'ML',
  Mm = 'MM',
  MultiSelect = 'MULTI_SELECT',
  Number = 'NUMBER',
  Oz = 'OZ',
  Percentage = 'PERCENTAGE',
  Select = 'SELECT',
  Sire = 'SIRE',
  Text = 'TEXT',
  VolumeLarge = 'VOLUME_LARGE',
  VolumeSmall = 'VOLUME_SMALL',
  WeightLarge = 'WEIGHT_LARGE',
  WeightSmall = 'WEIGHT_SMALL',
  WeightVeryLarge = 'WEIGHT_VERY_LARGE'
}

export type ActivityType = {
  __typename?: 'ActivityType';
  activityTemplatesCount?: Maybe<Scalars['Int']>;
  businessUnitTypes: Array<BusinessType>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imageSvg?: Maybe<Scalars['String']>;
  /** If true the activity logs of this type will be copied while moving between farms. */
  isCopyable: Scalars['Boolean'];
  /** If true then it is possible to create/extend activity templates with this type. */
  isExtendable: Scalars['Boolean'];
  /** If true the activity logs of this type will be visible for everyone. */
  isPublic: Scalars['Boolean'];
  /** If true this activity type will be not visible in UI. */
  isSystem: Scalars['Boolean'];
  name: Scalars['String'];
  position: Scalars['Int'];
  slug?: Maybe<Scalars['String']>;
};

export type AddAnimalsMedicineCourseInput = {
  animals?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  course: Scalars['UUID'];
};

export type AddAnimalsMedicineCoursePayload = {
  __typename?: 'AddAnimalsMedicineCoursePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddAnimalsToFinancialTransactionInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The UUID of the financial transaction to add animals to */
  id: Scalars['UUID'];
  /** Animal UUID and its optional allocated value */
  transactionAnimals: Array<InputMaybe<TransactionAnimalInputType>>;
};

/**
 * Adds an animal to a financial transaction. Only provide allocated value if
 * the allocation method is set to CUSTOM
 */
export type AddAnimalsToFinancialTransactionPayload = {
  __typename?: 'AddAnimalsToFinancialTransactionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
  financialTransaction?: Maybe<FinancialTransaction>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddDeliveryAddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  country: Scalars['Int'];
  farm: Scalars['Int'];
  locationId?: InputMaybe<Scalars['String']>;
  /** Available: FARM, ABATTOIR. Default: FARM */
  locationType?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  unitName: Scalars['String'];
};

export type AddDeliveryAddressPayload = {
  __typename?: 'AddDeliveryAddressPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryAddress?: Maybe<DeliveryAddressType>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type AddMedicineCourseInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  stages?: InputMaybe<Array<InputMaybe<MedicineCourseStageInputType>>>;
};

export type AddMedicineCoursePayload = {
  __typename?: 'AddMedicineCoursePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  medicineCourse?: Maybe<MedicineCourseObjectType>;
};

export type AddMedicineCourseStageInput = {
  amount?: InputMaybe<Scalars['Float']>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  course: Scalars['UUID'];
  daysAfter?: InputMaybe<Scalars['Int']>;
  lineItem?: InputMaybe<Scalars['UUID']>;
  units?: InputMaybe<Scalars['String']>;
};

export type AddMedicineCourseStagePayload = {
  __typename?: 'AddMedicineCourseStagePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  medicineCourseStage?: Maybe<MedicineCourseStageObjectType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddMedicineLineItemInput = {
  activeIngredient?: InputMaybe<Scalars['String']>;
  applicationMethod?: InputMaybe<Scalars['String']>;
  batchNumber?: InputMaybe<Scalars['String']>;
  businessUnit?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<Scalars['Float']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  /** Only needed when adding private medicine */
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
  /** E.g amount of bottles */
  quantity?: InputMaybe<Scalars['Int']>;
  quantityUnits?: InputMaybe<Scalars['String']>;
  /** Barcode of the private medicine */
  sku?: InputMaybe<Scalars['String']>;
  skuSource?: InputMaybe<Scalars['String']>;
  /** List of PKs for applicable animal types */
  species?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** or Purchased from */
  supplierName?: InputMaybe<Scalars['String']>;
  /** Total size of all bottles.If it is not provided, it will be calculated based on quantity * original_volume (sku should be provided in this case). */
  totalVolume?: InputMaybe<Scalars['Float']>;
  /** e.g. volume of a bottle */
  volume?: InputMaybe<Scalars['Float']>;
  volumeUnits?: InputMaybe<Scalars['String']>;
  withdrawalNotes?: InputMaybe<Scalars['String']>;
  withdrawalPeriodDaysCattleDairy?: InputMaybe<Scalars['Int']>;
  withdrawalPeriodDaysCattleMeat?: InputMaybe<Scalars['Int']>;
  withdrawalPeriodDaysPigs?: InputMaybe<Scalars['Int']>;
  withdrawalPeriodDaysSheep?: InputMaybe<Scalars['Int']>;
};

export type AddMedicineLineItemPayload = {
  __typename?: 'AddMedicineLineItemPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  lineItem?: Maybe<LineItemType>;
};

export type AddRegularWithdrawalInput = {
  amount?: InputMaybe<Scalars['Float']>;
  bankAccount: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  currency: Scalars['Int'];
  /** Available: MANUAL, DAILY, WEEKLY, MONTHLY. Default: MONTHLY */
  recurringTime: Scalars['String'];
};

export type AddRegularWithdrawalPayload = {
  __typename?: 'AddRegularWithdrawalPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  regularWithdrawal?: Maybe<RegularWithdrawalType>;
};

export type AdministerAnimalsMedicineCourseStageInput = {
  animals?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  lineItems?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  stage: Scalars['UUID'];
  withdrawal?: InputMaybe<Scalars['Int']>;
};

export type AdministerAnimalsMedicineCourseStagePayload = {
  __typename?: 'AdministerAnimalsMedicineCourseStagePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AlertObjectType = {
  __typename?: 'AlertObjectType';
  alertType: AlertType;
  animalAlert?: Maybe<AnimalAlertObjectType>;
  animalSet: Array<Animal>;
  businessUnit: BusinessUnit;
  /** The date alert was marked complete */
  completedAt?: Maybe<Scalars['Date']>;
  completedBy?: Maybe<User>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  id: Scalars['UUID'];
  isCrushReminder: Scalars['Boolean'];
  notes: Scalars['String'];
  /** The date the alert is due (or needs reminding) */
  remindAt: Scalars['Date'];
  resolutionComments: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  urgency?: Maybe<AlertUrgency>;
};

export type AlertType = {
  __typename?: 'AlertType';
  alertSet: Array<AlertObjectType>;
  code: Scalars['String'];
  disabled: Scalars['Boolean'];
  name: Scalars['String'];
  objectType: Array<Scalars['String']>;
};

/** An enumeration. */
export enum AlertUrgency {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** This object holds all American Angus EPD data for a given animal */
export type AmericanAngusEpd = {
  __typename?: 'AmericanAngusEPD';
  angusOnHolsteinValue?: Maybe<Scalars['Int']>;
  angusOnHolsteinValueRank?: Maybe<Scalars['Int']>;
  angusOnJerseyValue?: Maybe<Scalars['Int']>;
  angusOnJerseyValueRank?: Maybe<Scalars['Int']>;
  animal?: Maybe<Animal>;
  beefValue?: Maybe<Scalars['Int']>;
  beefValueRank?: Maybe<Scalars['Int']>;
  birthWeightAcc?: Maybe<Scalars['Decimal']>;
  birthWeightEpd?: Maybe<Scalars['Decimal']>;
  birthWeightPct?: Maybe<Scalars['Int']>;
  calvingEaseAcc?: Maybe<Scalars['Decimal']>;
  calvingEaseEpd?: Maybe<Scalars['Int']>;
  calvingEasePct?: Maybe<Scalars['Int']>;
  carcassWeightAcc?: Maybe<Scalars['Decimal']>;
  carcassWeightEpd?: Maybe<Scalars['Int']>;
  carcassWeightPct?: Maybe<Scalars['Int']>;
  clawAcc?: Maybe<Scalars['Decimal']>;
  clawEpd?: Maybe<Scalars['Decimal']>;
  clawPct?: Maybe<Scalars['Int']>;
  combinedValue?: Maybe<Scalars['Int']>;
  combinedValueRank?: Maybe<Scalars['Int']>;
  cowEnergyValue?: Maybe<Scalars['Int']>;
  cowEnergyValueRank?: Maybe<Scalars['Int']>;
  docilityAcc?: Maybe<Scalars['Decimal']>;
  docilityEpd?: Maybe<Scalars['Int']>;
  docilityPct?: Maybe<Scalars['Int']>;
  dryMatterIntakeAcc?: Maybe<Scalars['Decimal']>;
  dryMatterIntakeEpd?: Maybe<Scalars['Decimal']>;
  dryMatterIntakePct?: Maybe<Scalars['Int']>;
  fatAcc?: Maybe<Scalars['Decimal']>;
  fatEpd?: Maybe<Scalars['Decimal']>;
  fatPct?: Maybe<Scalars['Int']>;
  feedlotValue?: Maybe<Scalars['Int']>;
  feedlotValueRank?: Maybe<Scalars['Int']>;
  gridValue?: Maybe<Scalars['Int']>;
  gridValueRank?: Maybe<Scalars['Int']>;
  hairShedAcc?: Maybe<Scalars['Decimal']>;
  hairShedEpd?: Maybe<Scalars['Decimal']>;
  hairShedPct?: Maybe<Scalars['Int']>;
  heiferPregnancyAcc?: Maybe<Scalars['Decimal']>;
  heiferPregnancyEpd?: Maybe<Scalars['Decimal']>;
  heiferPregnancyPct?: Maybe<Scalars['Int']>;
  hoofAngleAcc?: Maybe<Scalars['Decimal']>;
  hoofAngleEpd?: Maybe<Scalars['Decimal']>;
  hoofAnglePct?: Maybe<Scalars['Int']>;
  marblingAcc?: Maybe<Scalars['Decimal']>;
  marblingEpd?: Maybe<Scalars['Decimal']>;
  marblingPct?: Maybe<Scalars['Int']>;
  maternalCalfValue?: Maybe<Scalars['Int']>;
  maternalCalfValueRank?: Maybe<Scalars['Int']>;
  matureHeightAcc?: Maybe<Scalars['Decimal']>;
  matureHeightEpd?: Maybe<Scalars['Decimal']>;
  matureHeightPct?: Maybe<Scalars['Int']>;
  matureWeightAcc?: Maybe<Scalars['Decimal']>;
  matureWeightEpd?: Maybe<Scalars['Int']>;
  matureWeightPct?: Maybe<Scalars['Int']>;
  milkAcc?: Maybe<Scalars['Decimal']>;
  milkEpd?: Maybe<Scalars['Int']>;
  milkPct?: Maybe<Scalars['Int']>;
  papAcc?: Maybe<Scalars['Decimal']>;
  papEpd?: Maybe<Scalars['Decimal']>;
  papPct?: Maybe<Scalars['Int']>;
  residualAdgAcc?: Maybe<Scalars['Decimal']>;
  residualAdgEpd?: Maybe<Scalars['Decimal']>;
  residualAdgPct?: Maybe<Scalars['Int']>;
  ribeyeAreaAcc?: Maybe<Scalars['Decimal']>;
  ribeyeAreaEpd?: Maybe<Scalars['Decimal']>;
  ribeyeAreaPct?: Maybe<Scalars['Int']>;
  scrotalCircumferenceAcc?: Maybe<Scalars['Decimal']>;
  scrotalCircumferenceEpd?: Maybe<Scalars['Decimal']>;
  scrotalCircumferencePct?: Maybe<Scalars['Int']>;
  weanedCalfValue?: Maybe<Scalars['Int']>;
  weanedCalfValueRank?: Maybe<Scalars['Int']>;
  weaningWeightAcc?: Maybe<Scalars['Decimal']>;
  weaningWeightEpd?: Maybe<Scalars['Int']>;
  weaningWeightPct?: Maybe<Scalars['Int']>;
  yearlingHeightAcc?: Maybe<Scalars['Decimal']>;
  yearlingHeightEpd?: Maybe<Scalars['Decimal']>;
  yearlingHeightPct?: Maybe<Scalars['Int']>;
  yearlingWeightAcc?: Maybe<Scalars['Decimal']>;
  yearlingWeightEpd?: Maybe<Scalars['Int']>;
  yearlingWeightPct?: Maybe<Scalars['Int']>;
};

export type AncestorType = {
  __typename?: 'AncestorType';
  ancestorIdentifier?: Maybe<Scalars['String']>;
  animalData?: Maybe<Animal>;
  depth?: Maybe<Scalars['Int']>;
};

export type Animal = AnimalInterface & ProcessedItem & {
  __typename?: 'Animal';
  age?: Maybe<Scalars['Int']>;
  /** It will return age category for the specified date */
  ageCategory?: Maybe<Scalars['String']>;
  alerts?: Maybe<Array<Maybe<AlertObjectType>>>;
  /** Amount of active animal alerts. */
  allAlertsCount?: Maybe<Scalars['Int']>;
  alternativeId?: Maybe<Scalars['String']>;
  animalBreeds: Array<AnimalBreed>;
  animalColour?: Maybe<AnimalColour>;
  animalSubtype?: Maybe<AnimalSubtypeObjectType>;
  animalType?: Maybe<AnimalType>;
  animalTypeId?: Maybe<Scalars['String']>;
  birthInformation?: Maybe<BirthInformation>;
  breedPercentages: Array<BreedPercentage>;
  breedSocietyRegistration: Scalars['Boolean'];
  breeding?: Maybe<Scalars['Boolean']>;
  breedrId?: Maybe<Scalars['String']>;
  brucellosisId?: Maybe<Scalars['String']>;
  buyerName?: Maybe<Scalars['String']>;
  children?: Maybe<Scalars['JSONString']>;
  cphCount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  /** Amount of due or overdue alerts of any urgency. */
  currentAlertsCount?: Maybe<Scalars['Int']>;
  /** Amount of due or overdue high urgency alerts. */
  currentHighUrgencyAlertsCount?: Maybe<Scalars['Int']>;
  currentWeight?: Maybe<Scalars['Float']>;
  dam?: Maybe<Animal>;
  damId?: Maybe<Scalars['String']>;
  damPassportNumber?: Maybe<Scalars['String']>;
  dateLeftFarm?: Maybe<Scalars['DateTime']>;
  dateMovedToFarm?: Maybe<Scalars['DateTime']>;
  daysToTargetWeight?: Maybe<Scalars['Float']>;
  deadAt?: Maybe<Scalars['DateTime']>;
  deliveryDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  eId?: Maybe<Scalars['String']>;
  eIdCleaned?: Maybe<Scalars['String']>;
  eIdsHistory?: Maybe<Array<Scalars['String']>>;
  /** Predicted age for specific date in months. */
  estimatedAgeOn?: Maybe<Scalars['Float']>;
  /** @deprecated [2024-02] no behaviour */
  estimatedCarcassWeight?: Maybe<Scalars['Float']>;
  /** It will return estimated weight for the specified date */
  estimatedWeightOn?: Maybe<Scalars['Float']>;
  field?: Maybe<Field>;
  fieldId?: Maybe<Scalars['UUID']>;
  gender?: Maybe<Scalars['String']>;
  group?: Maybe<Group>;
  groupId?: Maybe<Scalars['UUID']>;
  /** Daily Liveweight Gain: (w2-w1)/(t2-t1) */
  growthRate?: Maybe<Scalars['Float']>;
  /** @deprecated Use growth_rate */
  growthRateSinceConception?: Maybe<Scalars['Float']>;
  /** @deprecated Use growth_rate */
  growthRateSinceLastWeighLog?: Maybe<Scalars['Float']>;
  /**
   * True if the animal has un-copied previous keeper activity, otherwise false
   * @deprecated use previousKeeper
   */
  hasPreviousKeeperInfo?: Maybe<Scalars['Boolean']>;
  herdDoggId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  images?: Maybe<Array<Maybe<AnimalImage>>>;
  impactStatus?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use isRegulatorySynced! */
  isBcmsSynced?: Maybe<Scalars['Boolean']>;
  /** Could be true only for female animals. */
  isBirthed: Scalars['Boolean'];
  isCastrated: Scalars['Boolean'];
  isDead?: Maybe<Scalars['Boolean']>;
  isMale: Scalars['Boolean'];
  isOnFarm: Scalars['Boolean'];
  isPedigree: Scalars['Boolean'];
  isPregnant?: Maybe<Scalars['Boolean']>;
  isRegulatorySynced?: Maybe<Scalars['Boolean']>;
  isSoftDeleted?: Maybe<Scalars['Boolean']>;
  killFatScore: Scalars['String'];
  killFatScoreInt?: Maybe<Scalars['Float']>;
  killQuality: Scalars['String'];
  killQualityInt?: Maybe<Scalars['Float']>;
  killWeight?: Maybe<Scalars['Float']>;
  lastRegulatorySyncedDate?: Maybe<Scalars['DateTime']>;
  lastWeight?: Maybe<WeightActivityLog>;
  latestPurchasePrice?: Maybe<Scalars['Float']>;
  linkToMySire?: Maybe<Sire>;
  location?: Maybe<DeliveryAddressType>;
  lot?: Maybe<LotInfo>;
  metaData?: Maybe<Scalars['JSONString']>;
  name?: Maybe<Scalars['String']>;
  notifications?: Maybe<NotificationConnection>;
  offerId?: Maybe<Scalars['Int']>;
  owner?: Maybe<BusinessUnit>;
  ownerId?: Maybe<Scalars['String']>;
  ownersHistory?: Maybe<Scalars['JSONString']>;
  parentageChecked?: Maybe<Scalars['Boolean']>;
  passportNumber?: Maybe<Scalars['String']>;
  pedigree?: Maybe<Scalars['String']>;
  pedigreeId?: Maybe<Scalars['String']>;
  performanceCategory?: Maybe<Scalars['String']>;
  /** @deprecated Use predictedDateReady! */
  predicatedDateReady?: Maybe<Scalars['Date']>;
  predictedDateReady?: Maybe<Scalars['Date']>;
  predictedWeightAtDelivery?: Maybe<Scalars['Float']>;
  predictedWeights?: Maybe<Array<Maybe<WeightActivityLog>>>;
  pregnancyDueDate?: Maybe<Scalars['Date']>;
  previousKeeper?: Maybe<AnimalPreviousKeeperType>;
  registrationStatus: Scalars['Boolean'];
  relatedMeatLabels?: Maybe<Array<Scalars['String']>>;
  /** @deprecated This field is deprecated and not used now. */
  rflId?: Maybe<Scalars['String']>;
  sexClassification?: Maybe<SexClassification>;
  sire?: Maybe<Animal>;
  sireId?: Maybe<Scalars['String']>;
  sireIsPedigree: Scalars['Boolean'];
  sirePassportNumber?: Maybe<Scalars['String']>;
  sireStuds?: Maybe<Scalars['String']>;
  softDeletedAt?: Maybe<Scalars['DateTime']>;
  studSiredId?: Maybe<Scalars['String']>;
  tags: Array<AnimalTagType>;
  targetDailyLiveWeightGain?: Maybe<Scalars['Float']>;
  targetLiveWeight?: Maybe<Scalars['Float']>;
  tattoo?: Maybe<Scalars['String']>;
  trichId?: Maybe<Scalars['String']>;
  trioVerified?: Maybe<Scalars['Boolean']>;
  tsuBarcode?: Maybe<Scalars['String']>;
  uhfId?: Maybe<Scalars['String']>;
  unreadNotificationsCount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  visualId?: Maybe<Scalars['String']>;
  visualIdsHistory?: Maybe<Array<Scalars['String']>>;
  withdrawalEnd?: Maybe<Scalars['DateTime']>;
  withdrawalStart?: Maybe<Scalars['DateTime']>;
};


export type AnimalAgeCategoryArgs = {
  date: Scalars['Date'];
};


export type AnimalEstimatedAgeOnArgs = {
  date: Scalars['Date'];
};


export type AnimalEstimatedWeightOnArgs = {
  date: Scalars['Date'];
};


export type AnimalNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type AnimalAlert = EntityAlertInterface & {
  __typename?: 'AnimalAlert';
  alert: AlertObjectType;
  animal?: Maybe<Animal>;
  entityType: Scalars['String'];
  id: Scalars['UUID'];
};

export type AnimalAlertObjectType = {
  __typename?: 'AnimalAlertObjectType';
  alert: AlertObjectType;
  animal?: Maybe<Animal>;
  id: Scalars['UUID'];
};

export type AnimalBreed = {
  __typename?: 'AnimalBreed';
  animalType?: Maybe<AnimalType>;
  birthWeight?: Maybe<Scalars['Float']>;
  breedrCode?: Maybe<Scalars['String']>;
  classification?: Maybe<Scalars['String']>;
  groups: Array<Group>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  newClassification?: Maybe<AnimalBreedNewClassification>;
  regBreedCode?: Maybe<Scalars['String']>;
  regName?: Maybe<Scalars['String']>;
  region?: Maybe<Region>;
  version?: Maybe<Scalars['String']>;
};

export type AnimalBreedGender = {
  __typename?: 'AnimalBreedGender';
  breedCode?: Maybe<Scalars['String']>;
  breedName?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  isMale?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum AnimalBreedNewClassification {
  BW = 'B___W',
  Continental = 'CONTINENTAL',
  International = 'INTERNATIONAL',
  Native = 'NATIVE'
}

export type AnimalColour = {
  __typename?: 'AnimalColour';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type AnimalConditionType = {
  __typename?: 'AnimalConditionType';
  id: Scalars['UUID'];
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type AnimalConnection = {
  __typename?: 'AnimalConnection';
  animals?: Maybe<Array<Animal>>;
  animalsCount?: Maybe<Scalars['Int']>;
};

export type AnimalConnection2 = {
  __typename?: 'AnimalConnection2';
  count?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AnimalConnection2Edge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  serverTime?: Maybe<Scalars['DateTime']>;
};

/** A Relay edge containing a `AnimalConnection2` and its cursor. */
export type AnimalConnection2Edge = {
  __typename?: 'AnimalConnection2Edge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Animal>;
};

export type AnimalErrorParameter = {
  animal?: InputMaybe<Scalars['UUID']>;
  /** passport number or vid if eid is not available */
  animalIdentifier?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  liveSession?: InputMaybe<Scalars['UUID']>;
  message: Scalars['String'];
};

/** Binds a localised column label to the data column to be exported. */
export type AnimalExportColumnInput = {
  column: AnimalExportFieldEnum;
  label: Scalars['String'];
};

/** Requestable column of the animal export. */
export enum AnimalExportFieldEnum {
  Age = 'AGE',
  AlternativeId = 'ALTERNATIVE_ID',
  AnimalId = 'ANIMAL_ID',
  BreedrId = 'BREEDR_ID',
  BreedCode = 'BREED_CODE',
  BreedName = 'BREED_NAME',
  BrucellosisId = 'BRUCELLOSIS_ID',
  CurrentEstimatedWeight = 'CURRENT_ESTIMATED_WEIGHT',
  DailyLiveWeightGain = 'DAILY_LIVE_WEIGHT_GAIN',
  DamAnimalId = 'DAM_ANIMAL_ID',
  DateLeftFarm = 'DATE_LEFT_FARM',
  DaysOnFarm = 'DAYS_ON_FARM',
  DaysSinceWeighed = 'DAYS_SINCE_WEIGHED',
  DeadAt = 'DEAD_AT',
  DeliveryDate = 'DELIVERY_DATE',
  Dob = 'DOB',
  Dof = 'DOF',
  Eid = 'EID',
  FieldName = 'FIELD_NAME',
  GroupName = 'GROUP_NAME',
  HerdDoggId = 'HERD_DOGG_ID',
  IsPregnant = 'IS_PREGNANT',
  KillFatScore = 'KILL_FAT_SCORE',
  KillQuality = 'KILL_QUALITY',
  KillWeight = 'KILL_WEIGHT',
  LastSynced = 'LAST_SYNCED',
  LatestMeasuredWeight = 'LATEST_MEASURED_WEIGHT',
  Name = 'NAME',
  PedigreeId = 'PEDIGREE_ID',
  PregnancyDueDate = 'PREGNANCY_DUE_DATE',
  PreviousKeeperName = 'PREVIOUS_KEEPER_NAME',
  Sex = 'SEX',
  SexClassification = 'SEX_CLASSIFICATION',
  SireAnimalId = 'SIRE_ANIMAL_ID',
  SyncStatus = 'SYNC_STATUS',
  Tags = 'TAGS',
  TattooId = 'TATTOO_ID',
  TrichId = 'TRICH_ID',
  TsuBarcode = 'TSU_BARCODE',
  UhfId = 'UHF_ID',
  UpdatedAt = 'UPDATED_AT',
  Vid = 'VID',
  WithdrawalStatus = 'WITHDRAWAL_STATUS'
}

export type AnimalFilterAlertObjectType = {
  __typename?: 'AnimalFilterAlertObjectType';
  animalFilter?: Maybe<AnimalFilterObjectType>;
  count?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum AnimalFilterColor {
  Amber = 'AMBER',
  Green = 'GREEN',
  Red = 'RED'
}

export type AnimalFilterObjectType = {
  __typename?: 'AnimalFilterObjectType';
  ageFrom?: Maybe<Scalars['Float']>;
  ageTo?: Maybe<Scalars['Float']>;
  animalType?: Maybe<AnimalType>;
  breeds: Array<AnimalBreed>;
  businessUnit: BusinessUnit;
  color: AnimalFilterColor;
  createdBy: User;
  currentWeightFrom?: Maybe<Scalars['Float']>;
  currentWeightTo?: Maybe<Scalars['Float']>;
  daysSinceLastWeightFrom?: Maybe<Scalars['Float']>;
  daysSinceLastWeightTo?: Maybe<Scalars['Float']>;
  deliveryFrom?: Maybe<Scalars['Date']>;
  deliveryTo?: Maybe<Scalars['Date']>;
  dobFrom?: Maybe<Scalars['Date']>;
  dobTo?: Maybe<Scalars['Date']>;
  dofFrom?: Maybe<Scalars['Date']>;
  dofTo?: Maybe<Scalars['Date']>;
  fields: Array<Field>;
  groups: Array<Group>;
  growthRateFrom?: Maybe<Scalars['Float']>;
  growthRateTo?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  inWithdrawal?: Maybe<Scalars['Boolean']>;
  isAlert: Scalars['Boolean'];
  /** @deprecated Use isRegulatorySynced! */
  isBcmsSynced?: Maybe<Scalars['Boolean']>;
  isMale?: Maybe<Scalars['Boolean']>;
  isPregnant?: Maybe<Scalars['Boolean']>;
  isRegulatorySynced?: Maybe<Scalars['Boolean']>;
  lastRegulatorySyncedDate?: Maybe<Scalars['Date']>;
  lastRegulatorySyncedDateFrom?: Maybe<Scalars['Date']>;
  lastRegulatorySyncedDateTo?: Maybe<Scalars['Date']>;
  lastWeightFrom?: Maybe<Scalars['Float']>;
  lastWeightTo?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  pregnancyDueDateFrom?: Maybe<Scalars['Date']>;
  pregnancyDueDateTo?: Maybe<Scalars['Date']>;
  sexClassifications: Array<SexClassification>;
};

export type AnimalImage = {
  __typename?: 'AnimalImage';
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  image?: Maybe<Scalars['String']>;
};

export type AnimalInterface = {
  /** It will return age category for the specified date */
  ageCategory?: Maybe<Scalars['String']>;
  animalBreeds: Array<AnimalBreed>;
  animalColour?: Maybe<AnimalColour>;
  animalType?: Maybe<AnimalType>;
  breedPercentages: Array<BreedPercentage>;
  breeding?: Maybe<Scalars['Boolean']>;
  cphCount?: Maybe<Scalars['Int']>;
  currentWeight?: Maybe<Scalars['Float']>;
  damPassportNumber?: Maybe<Scalars['String']>;
  dateMovedToFarm?: Maybe<Scalars['DateTime']>;
  daysToTargetWeight?: Maybe<Scalars['Float']>;
  dob?: Maybe<Scalars['DateTime']>;
  eId?: Maybe<Scalars['String']>;
  eIdCleaned?: Maybe<Scalars['String']>;
  /** Predicted age for specific date in months. */
  estimatedAgeOn?: Maybe<Scalars['Float']>;
  /** @deprecated [2024-02] no behaviour */
  estimatedCarcassWeight?: Maybe<Scalars['Float']>;
  /** It will return estimated weight for the specified date */
  estimatedWeightOn?: Maybe<Scalars['Float']>;
  gender?: Maybe<Scalars['String']>;
  /** Daily Liveweight Gain: (w2-w1)/(t2-t1) */
  growthRate?: Maybe<Scalars['Float']>;
  /** @deprecated Use growth_rate */
  growthRateSinceConception?: Maybe<Scalars['Float']>;
  /** @deprecated Use growth_rate */
  growthRateSinceLastWeighLog?: Maybe<Scalars['Float']>;
  images?: Maybe<Array<Maybe<AnimalImage>>>;
  isArchived?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use isRegulatorySynced! */
  isBcmsSynced?: Maybe<Scalars['Boolean']>;
  isCastrated: Scalars['Boolean'];
  isMale: Scalars['Boolean'];
  isPregnant?: Maybe<Scalars['Boolean']>;
  isRegulatorySynced?: Maybe<Scalars['Boolean']>;
  isSoftDeleted?: Maybe<Scalars['Boolean']>;
  lastRegulatorySyncedDate?: Maybe<Scalars['DateTime']>;
  lastWeight?: Maybe<WeightActivityLog>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  passportNumber?: Maybe<Scalars['String']>;
  /** @deprecated Use predictedDateReady! */
  predicatedDateReady?: Maybe<Scalars['Date']>;
  predictedDateReady?: Maybe<Scalars['Date']>;
  predictedWeightAtDelivery?: Maybe<Scalars['Float']>;
  pregnancyDueDate?: Maybe<Scalars['Date']>;
  sexClassification?: Maybe<SexClassification>;
  sirePassportNumber?: Maybe<Scalars['String']>;
  softDeletedAt?: Maybe<Scalars['DateTime']>;
  targetDailyLiveWeightGain?: Maybe<Scalars['Float']>;
  targetLiveWeight?: Maybe<Scalars['Float']>;
  visualId?: Maybe<Scalars['String']>;
  withdrawalEnd?: Maybe<Scalars['DateTime']>;
};


export type AnimalInterfaceAgeCategoryArgs = {
  date: Scalars['Date'];
};


export type AnimalInterfaceEstimatedAgeOnArgs = {
  date: Scalars['Date'];
};


export type AnimalInterfaceEstimatedWeightOnArgs = {
  date: Scalars['Date'];
};

export type AnimalOffspringObjectType = {
  __typename?: 'AnimalOffspringObjectType';
  animals?: Maybe<Array<Maybe<PublicAnimal>>>;
  summary?: Maybe<SummaryMetrics>;
};

/** Associated to the animnalsPage api. */
export type AnimalPagePaginatedType = {
  __typename?: 'AnimalPagePaginatedType';
  animals?: Maybe<Array<Animal>>;
  count?: Maybe<Scalars['Int']>;
  hasNext?: Maybe<Scalars['Boolean']>;
  hasPrev?: Maybe<Scalars['Boolean']>;
  lastFetchTime?: Maybe<Scalars['DateTime']>;
  page?: Maybe<Scalars['Int']>;
  pages?: Maybe<Scalars['Int']>;
};

export type AnimalPreviousKeeperType = {
  __typename?: 'AnimalPreviousKeeperType';
  address: Scalars['String'];
  contact?: Maybe<ContactObjectType>;
  name: Scalars['String'];
  regulatoryId?: Maybe<Scalars['String']>;
};

/** The initial farm data download. */
export type AnimalSnapshotType = {
  __typename?: 'AnimalSnapshotType';
  url?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum AnimalSorting {
  AgeAsc = 'AGE_ASC',
  AgeDesc = 'AGE_DESC',
  CurrentWeight = 'CURRENT_WEIGHT',
  CurrentWeightDesc = 'CURRENT_WEIGHT_DESC',
  DailyLiveWeightGainAsc = 'DAILY_LIVE_WEIGHT_GAIN_ASC',
  DailyLiveWeightGainDesc = 'DAILY_LIVE_WEIGHT_GAIN_DESC',
  DamPassportNumberAsc = 'DAM_PASSPORT_NUMBER_ASC',
  DamPassportNumberDesc = 'DAM_PASSPORT_NUMBER_DESC',
  DateLeftFarmAsc = 'DATE_LEFT_FARM_ASC',
  DateLeftFarmDesc = 'DATE_LEFT_FARM_DESC',
  DeadAtAsc = 'DEAD_AT_ASC',
  DeadAtDesc = 'DEAD_AT_DESC',
  DeliveryDateAsc = 'DELIVERY_DATE_ASC',
  DeliveryDateDesc = 'DELIVERY_DATE_DESC',
  DobAsc = 'DOB_ASC',
  DobDesc = 'DOB_DESC',
  DofAsc = 'DOF_ASC',
  DofDesc = 'DOF_DESC',
  EIdAsc = 'E_ID_ASC',
  EIdDesc = 'E_ID_DESC',
  FieldNameAsc = 'FIELD_NAME_ASC',
  FieldNameDesc = 'FIELD_NAME_DESC',
  GroupNameAsc = 'GROUP_NAME_ASC',
  GroupNameDesc = 'GROUP_NAME_DESC',
  Id = 'ID',
  IdDesc = 'ID_DESC',
  LastRegulatorySyncDateAsc = 'LAST_REGULATORY_SYNC_DATE_ASC',
  LastRegulatorySyncDateDesc = 'LAST_REGULATORY_SYNC_DATE_DESC',
  LatestMeasuredWeightAsc = 'LATEST_MEASURED_WEIGHT_ASC',
  LatestMeasuredWeightDesc = 'LATEST_MEASURED_WEIGHT_DESC',
  PassportNumberAsc = 'PASSPORT_NUMBER_ASC',
  PassportNumberDesc = 'PASSPORT_NUMBER_DESC',
  SirePassportNumberAsc = 'SIRE_PASSPORT_NUMBER_ASC',
  SirePassportNumberDesc = 'SIRE_PASSPORT_NUMBER_DESC',
  TimeOnFarmAsc = 'TIME_ON_FARM_ASC',
  TimeOnFarmDesc = 'TIME_ON_FARM_DESC',
  UpdatedAt = 'UPDATED_AT',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VisualIdAsc = 'VISUAL_ID_ASC',
  VisualIdDesc = 'VISUAL_ID_DESC'
}

/** An enumeration. */
export enum AnimalStatus {
  Active = 'ACTIVE',
  Any = 'ANY',
  Dead = 'DEAD',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Removed = 'REMOVED'
}

/** An enumeration. */
export enum AnimalSubtypeObjectType {
  Boars = 'BOARS',
  Bull = 'BULL',
  BullCalf = 'BULL_CALF',
  Cow = 'COW',
  Ewe = 'EWE',
  Fatteners = 'FATTENERS',
  Gilts = 'GILTS',
  Growers = 'GROWERS',
  Heifer = 'HEIFER',
  Hogget = 'HOGGET',
  Lamb = 'LAMB',
  Piglet = 'PIGLET',
  Ram = 'RAM',
  Sow = 'SOW',
  Steer = 'STEER',
  Weaner = 'WEANER',
  Wether = 'WETHER'
}

export type AnimalTagAssignmentInputType = {
  intValue?: InputMaybe<Scalars['Int']>;
  isPresent: Scalars['Boolean'];
  strValue?: InputMaybe<Scalars['String']>;
  tag: Scalars['ID'];
};

export enum AnimalTagGenders {
  Female = 'FEMALE',
  Male = 'MALE',
  MaleAndFemale = 'MALE_AND_FEMALE'
}

export type AnimalTagOverviewConnection = {
  __typename?: 'AnimalTagOverviewConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AnimalTagOverviewEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AnimalTagOverview` and its cursor. */
export type AnimalTagOverviewEdge = {
  __typename?: 'AnimalTagOverviewEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AnimalTagOverviewType>;
};

/** Adds various expensive annotations to a tag field. */
export type AnimalTagOverviewType = TagSchemaInterface & {
  __typename?: 'AnimalTagOverviewType';
  animalTypes?: Maybe<Array<AnimalType>>;
  averageAge?: Maybe<Scalars['Decimal']>;
  averageDaysOnFarm?: Maybe<Scalars['Decimal']>;
  averageEstimatedWeight?: Maybe<Scalars['Decimal']>;
  averageRecordedWeight?: Maybe<Scalars['Decimal']>;
  breeds?: Maybe<Array<AnimalBreed>>;
  color?: Maybe<Scalars['String']>;
  genderType: AnimalTagGenders;
  /** @deprecated [2024-01] use tag_id */
  id: Scalars['ID'];
  isRemovable: Scalars['Boolean'];
  name: Scalars['String'];
  numAliveAnimals: Scalars['Int'];
  ownership: AnimalTagOwnership;
  /** @deprecated [2024-01] use TagSchemaInterface */
  schema: AnimalTagSchemaType;
  slug: Scalars['String'];
  tagId: Scalars['ID'];
  textColor?: Maybe<Scalars['String']>;
  valueType: AnimalTagValueEnum;
};

export enum AnimalTagOwnership {
  BusinessUnit = 'BUSINESS_UNIT',
  SupplyChain = 'SUPPLY_CHAIN',
  System = 'SYSTEM'
}

/** Basic schema definition for a tag. */
export type AnimalTagSchemaType = TagSchemaInterface & {
  __typename?: 'AnimalTagSchemaType';
  animalTypes?: Maybe<Array<AnimalType>>;
  color?: Maybe<Scalars['String']>;
  /** @deprecated [2024-01] use tag_id */
  id: Scalars['ID'];
  isRemovable: Scalars['Boolean'];
  name: Scalars['String'];
  ownership: AnimalTagOwnership;
  slug: Scalars['String'];
  tagId: Scalars['ID'];
  textColor?: Maybe<Scalars['String']>;
  valueType: AnimalTagValueEnum;
};

/**
 * Tag assignments associated to an animal.  This could contain, for example,
 * the date that a tag was assigned, rather simply that the tag itself is
 * associated to the animal.
 */
export type AnimalTagType = TagSchemaInterface & {
  __typename?: 'AnimalTagType';
  animalTypes?: Maybe<Array<AnimalType>>;
  color?: Maybe<Scalars['String']>;
  isRemovable: Scalars['Boolean'];
  name: Scalars['String'];
  ownership: AnimalTagOwnership;
  /** @deprecated [2024-01] use TagSchemaInterface */
  schema: AnimalTagSchemaType;
  slug: Scalars['String'];
  tagId: Scalars['ID'];
  textColor?: Maybe<Scalars['String']>;
  valueId: Scalars['ID'];
  valueType: AnimalTagValueEnum;
};

export enum AnimalTagValueEnum {
  Integer = 'INTEGER',
  None = 'NONE',
  String = 'STRING'
}

export type AnimalType = {
  __typename?: 'AnimalType';
  batchName?: Maybe<BatchNameObjectType>;
  breeds?: Maybe<Array<Maybe<AnimalBreed>>>;
  categoriesOfSale?: Maybe<Array<Maybe<CategoryOfSale>>>;
  colour: Scalars['String'];
  emptyStates: Array<EmptyStateObjectType>;
  enabled: Scalars['Boolean'];
  enabledPredictions: Scalars['Boolean'];
  gestationDays: Scalars['Int'];
  groups: Array<Group>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  integrationsystemSet: Array<IntegrationSystemType>;
  name: Scalars['String'];
  position: Scalars['Int'];
  sexclassificationSet: Array<SexClassification>;
  slug?: Maybe<Scalars['String']>;
  stockitemSet: Array<StockItemListType>;
};

export type AnimalTypePublic = {
  __typename?: 'AnimalTypePublic';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type AnimalsCount = {
  __typename?: 'AnimalsCount';
  deadAnimals?: Maybe<Scalars['Int']>;
  liveAnimals?: Maybe<Scalars['Int']>;
  movedOffFarmAnimals?: Maybe<Scalars['Int']>;
  totalAnimals?: Maybe<Scalars['Int']>;
};

export type AnimalsExportAsyncInput = {
  animalIds?: InputMaybe<Array<Scalars['ID']>>;
  animalTags?: InputMaybe<Array<Scalars['ID']>>;
  animalTypes?: InputMaybe<Array<Scalars['Int']>>;
  breed?: InputMaybe<Scalars['ID']>;
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  columns: Array<AnimalExportColumnInput>;
  dateHint?: InputMaybe<UploadCsvDateHintEnumType>;
  eId?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<Scalars['UUID']>;
  isInWithdrawal?: InputMaybe<Scalars['Boolean']>;
  isMale?: InputMaybe<Scalars['Boolean']>;
  isPregnant?: InputMaybe<Scalars['Boolean']>;
  isRegulatorySynced?: InputMaybe<Scalars['Boolean']>;
  maxAgeMonths?: InputMaybe<Scalars['Int']>;
  maxDaysSinceWeighed?: InputMaybe<Scalars['Int']>;
  maxDeliveryDate?: InputMaybe<Scalars['DateTime']>;
  maxDob?: InputMaybe<Scalars['DateTime']>;
  maxDof?: InputMaybe<Scalars['DateTime']>;
  maxEstimatedWeight?: InputMaybe<Scalars['Float']>;
  maxGrowthRate?: InputMaybe<Scalars['Float']>;
  maxLastWeight?: InputMaybe<Scalars['Float']>;
  maxPregnancyDueDate?: InputMaybe<Scalars['DateTime']>;
  maxRegulatorySyncDate?: InputMaybe<Scalars['DateTime']>;
  minAgeMonths?: InputMaybe<Scalars['Int']>;
  minDaysSinceWeighed?: InputMaybe<Scalars['Int']>;
  minDeliveryDate?: InputMaybe<Scalars['DateTime']>;
  minDob?: InputMaybe<Scalars['DateTime']>;
  minDof?: InputMaybe<Scalars['DateTime']>;
  minEstimatedWeight?: InputMaybe<Scalars['Float']>;
  minGrowthRate?: InputMaybe<Scalars['Float']>;
  minLastWeight?: InputMaybe<Scalars['Float']>;
  minPregnancyDueDate?: InputMaybe<Scalars['DateTime']>;
  minRegulatorySyncDate?: InputMaybe<Scalars['DateTime']>;
  minUpdated?: InputMaybe<Scalars['DateTime']>;
  orderBy?: InputMaybe<Array<AnimalSorting>>;
  passportNumber?: InputMaybe<Scalars['String']>;
  pedigreeId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  searchIds?: InputMaybe<Array<IdentifierType>>;
  sexClassification?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AnimalStatus>;
  tzName?: InputMaybe<Scalars['String']>;
  visualId?: InputMaybe<Scalars['String']>;
};

/**
 * Trigger an asyncrhonous task which bundles up an entire list of animals.
 * This uses the same pararameters as the animals api.  Paramters which are
 * None or not specified are considered to mean 'any match', just like animals
 * api.
 */
export type AnimalsExportAsyncPayload = {
  __typename?: 'AnimalsExportAsyncPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
  export?: Maybe<ExportResult>;
};

export type AnimalsPaginatedConnection = {
  __typename?: 'AnimalsPaginatedConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AnimalsPaginatedEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AnimalsPaginated` and its cursor. */
export type AnimalsPaginatedEdge = {
  __typename?: 'AnimalsPaginatedEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Animal>;
};

export type AphisImportCsvInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  csvFile?: InputMaybe<Scalars['Upload']>;
  /** BusinessUnit ID */
  farm?: InputMaybe<Scalars['Int']>;
};

export type AphisImportCsvPayload = {
  __typename?: 'AphisImportCsvPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  task?: Maybe<FarmSystemTaskType>;
};

export type ApproveEmailInput = {
  approveEmailHash?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ApproveEmailPayload = {
  __typename?: 'ApproveEmailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AttachDeliveryAffidavitInput = {
  affidavit: Scalars['Upload'];
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  delivery: Scalars['ID'];
};

/**
 * As a delivery initiator attach an affidavit document.  Affidavits are hard
 * documents which are shared between participants and provide some kind of
 * certified assertion about the animals in a delivery.
 */
export type AttachDeliveryAffidavitPayload = {
  __typename?: 'AttachDeliveryAffidavitPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  delivery?: Maybe<DeliveryType>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type BalanceAccountType = {
  __typename?: 'BalanceAccountType';
  balance: Scalars['Float'];
  businessUnit?: Maybe<BusinessUnit>;
  createdAt: Scalars['DateTime'];
  currency?: Maybe<Currency>;
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type BandChartData = {
  __typename?: 'BandChartData';
  timestamp?: Maybe<Scalars['String']>;
  value?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type BankAccountDetailsObjectType = {
  __typename?: 'BankAccountDetailsObjectType';
  accountName: Scalars['String'];
  accountNo: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  isBusinessAccount: Scalars['Boolean'];
  sortCode: Scalars['String'];
};

export type BankAccountType = {
  __typename?: 'BankAccountType';
  accountInfo?: Maybe<Scalars['JSONString']>;
  balanceAccount?: Maybe<BalanceAccountType>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  currency?: Maybe<Currency>;
  id: Scalars['ID'];
  token?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

/**
 * In JS::
 *     bars.set("male", [
 *         {
 *         data: [
 *             { x: "cattle", y: 40 },
 *             { x: "sheep", y: 60 },
 *         ],
 *         labels: ["species", "number"],
 *         },
 *     ]);
 *
 * From::
 *
 *     {
 *         title: "My Bar Chart",
 *         bars: [
 *             {
 *                 label: "Sheep",
 *                 data: [{x:"Male", y: 40}, {x: "Female", y: 65}]
 *             },
 *             {
 *                 label: "Cattle",
 *                 data: [{x:"Male", y: 40}, {x: "Female", y: 65}]
 *             }
 *         ]
 *     }
 *
 * This is a list of lists to facilitate stacked bar charts.
 */
export type BarChartDataObjectType = {
  __typename?: 'BarChartDataObjectType';
  bars: Array<SeriesObjectType>;
  title: Scalars['String'];
};

export type Batch = {
  __typename?: 'Batch';
  animalBreeds: Array<AnimalBreed>;
  animalType?: Maybe<AnimalType>;
  animalTypeId?: Maybe<Scalars['String']>;
  averageDobInBatch?: Maybe<Scalars['DateTime']>;
  batchDateOnFarm?: Maybe<Scalars['DateTime']>;
  businessUnit: BusinessUnit;
  businessUnitId?: Maybe<Scalars['String']>;
  businessUnitTarget?: Maybe<BusinessUnitTarget>;
  businessUnitTargetId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  gendersInBatch?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isBatch?: Maybe<Scalars['Boolean']>;
  isPurchased: Scalars['Boolean'];
  name: Scalars['String'];
  numberOfUnidentifiedAnimalsInBatch?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type BatchNameObjectType = {
  __typename?: 'BatchNameObjectType';
  name?: Maybe<Scalars['String']>;
  plural?: Maybe<Scalars['String']>;
};

export enum BatchUploadCategoryEnumType {
  Activity = 'ACTIVITY',
  Animal = 'ANIMAL',
  Unknown = 'UNKNOWN'
}

/** An column based upload schema to be used with the bulk import mutations. */
export type BatchUploadFormat = {
  __typename?: 'BatchUploadFormat';
  /**
   * Present if the upload associates to an activity.  Prefer to use categories and activity type.
   * @deprecated [2023-12] Use activity type and category slug
   */
  activityTemplateId?: Maybe<Scalars['Int']>;
  /** Suggested related activity type to group this schema under */
  activityType?: Maybe<ActivityType>;
  animalTypes: Array<Maybe<AnimalType>>;
  /** Suggestion of how to group this upload format on the user interface.  Clients must be tolerant of values they are not expecting. */
  categorySlug?: Maybe<Scalars['String']>;
  columns: Array<BatchUploadFormatColumn>;
  /**
   * Associates to entity_type on uploadCsv.
   * @deprecated [2023-12] Not relevant.
   */
  entityType: BatchUploadCategoryEnumType;
  /** If the upload format can/should have fields re-ordered and skipped or not.  This will tend to be false on formats which are expected to exactly equal a third party schema. */
  isMappable: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  options: Array<BatchUploadFormatOption>;
  slug: Scalars['String'];
};

export type BatchUploadFormatColumn = {
  __typename?: 'BatchUploadFormatColumn';
  /** @deprecated Removed. */
  activityField?: Maybe<ActivityPayloadData>;
  /** Suggestion of how to group fields on the front-end. */
  categorySlug?: Maybe<Scalars['String']>;
  isRequired: Scalars['Boolean'];
  isRequiredConditionally: Scalars['Boolean'];
  /** Human readable name suggestion for the column. */
  label: Scalars['String'];
  /** @deprecated [2023-01] Replaced by slug */
  name: Scalars['String'];
  position: Scalars['Int'];
  /** Developer-readable slug for the column.  Client sends this as the field mapping. */
  slug: Scalars['String'];
};

export type BatchUploadFormatOption = {
  __typename?: 'BatchUploadFormatOption';
  choices: Array<Maybe<OptionChoice>>;
  dataSubtype?: Maybe<BulkUploadFormatOptionDataSubTypeEnum>;
  dataType: BulkUploadFormatOptionDataTypeEnum;
  default?: Maybe<Scalars['String']>;
  helpText?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  slug: Scalars['String'];
};

export type BcmsConnectionType = FarmSystemType & {
  __typename?: 'BcmsConnectionType';
  credentials?: Maybe<Scalars['GenericScalar']>;
  errorMessage?: Maybe<Scalars['String']>;
  farm?: Maybe<BusinessUnit>;
  id?: Maybe<Scalars['Int']>;
  integrationSystem?: Maybe<IntegrationSystemType>;
  location?: Maybe<DeliveryAddressType>;
  status?: Maybe<Scalars['String']>;
};

export type BcmsImportCsvInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  csvFile?: InputMaybe<Scalars['Upload']>;
  /** BusinessUnit ID */
  farm?: InputMaybe<Scalars['Int']>;
};

export type BcmsImportCsvPayload = {
  __typename?: 'BcmsImportCsvPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  task?: Maybe<FarmSystemTaskType>;
};

export enum BcmsRequestReasonType {
  Password = 'PASSWORD',
  UserId = 'USER_ID',
  UserIdAndPassword = 'USER_ID_AND_PASSWORD'
}

export type BcmsServiceRequestGeneratePdfInput = {
  addressOne: Scalars['String'];
  addressTwo: Scalars['String'];
  businessName: Scalars['String'];
  businessUnit: Scalars['Int'];
  city: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  contactName: Scalars['String'];
  email: Scalars['String'];
  holdingId: Scalars['String'];
  phoneNumber: Scalars['String'];
  postcode: Scalars['String'];
  requestReason: BcmsRequestReasonType;
  submitDate?: InputMaybe<Scalars['Date']>;
};

export type BcmsServiceRequestGeneratePdfPayload = {
  __typename?: 'BcmsServiceRequestGeneratePdfPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  url?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum BirthAbnormality {
  No = 'NO',
  Yes = 'YES'
}

export type BirthAnimalInput = {
  alternativeId?: InputMaybe<Scalars['String']>;
  animalId?: InputMaybe<Scalars['ID']>;
  animalType: Scalars['ID'];
  birthAbnormalities?: InputMaybe<BirthAbnormality>;
  birthPresentation?: InputMaybe<BirthPresentation>;
  birthSize?: InputMaybe<BirthSize>;
  birthVigor?: InputMaybe<BirthVigor>;
  birthWeight?: InputMaybe<Scalars['Float']>;
  birthingDifficulty?: InputMaybe<BirthingDifficulties>;
  breeds: Array<Scalars['ID']>;
  brucellosisId?: InputMaybe<Scalars['String']>;
  businessUnit: Scalars['ID'];
  calfColour?: InputMaybe<BirthColour>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  conditions?: InputMaybe<Array<Scalars['ID']>>;
  dam?: InputMaybe<Scalars['ID']>;
  deathDestinationAddress?: InputMaybe<Scalars['String']>;
  deathDestinationName?: InputMaybe<Scalars['String']>;
  deathDestinationPostcode?: InputMaybe<Scalars['String']>;
  deathDisposalCost?: InputMaybe<Scalars['Float']>;
  deathReason?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dob: Scalars['DateTime'];
  eId?: InputMaybe<Scalars['String']>;
  field: Scalars['ID'];
  group?: InputMaybe<Scalars['ID']>;
  herdDoggId?: InputMaybe<Scalars['String']>;
  isDead?: InputMaybe<Scalars['Boolean']>;
  isMale: Scalars['Boolean'];
  litterSize?: InputMaybe<LitterSize>;
  name?: InputMaybe<Scalars['String']>;
  passportNumber: Scalars['String'];
  pedigreeId?: InputMaybe<Scalars['String']>;
  tagValues?: InputMaybe<Array<AnimalTagAssignmentInputType>>;
  tattoo?: InputMaybe<Scalars['String']>;
  trichId?: InputMaybe<Scalars['String']>;
  tsuBarcode?: InputMaybe<Scalars['String']>;
  uhfId?: InputMaybe<Scalars['String']>;
  visualId?: InputMaybe<Scalars['String']>;
};

/**
 * Create a new on farm asset with validation appropriate for an animal born
 * on farm.
 */
export type BirthAnimalPayload = {
  __typename?: 'BirthAnimalPayload';
  animal?: Maybe<Animal>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum BirthColour {
  Black = 'BLACK',
  BlackWhite = 'BLACK_WHITE',
  BlueRoan = 'BLUE_ROAN',
  DarkBlueRoan = 'DARK_BLUE_ROAN',
  DarkBrown = 'DARK_BROWN',
  DarkBrownWhite = 'DARK_BROWN_WHITE',
  LightBlueRoan = 'LIGHT_BLUE_ROAN',
  LightBrown = 'LIGHT_BROWN',
  LightBrownWhite = 'LIGHT_BROWN_WHITE',
  Other = 'OTHER',
  Red = 'RED',
  White = 'WHITE'
}

export type BirthInformation = {
  __typename?: 'BirthInformation';
  animal?: Maybe<Animal>;
  birthAbnormalities?: Maybe<Scalars['String']>;
  birthPresentation?: Maybe<Scalars['String']>;
  birthSize?: Maybe<Scalars['String']>;
  birthVigor?: Maybe<Scalars['String']>;
  birthWeight?: Maybe<Scalars['Float']>;
  birthingDifficulty?: Maybe<Scalars['String']>;
  calfColour?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  id: Scalars['UUID'];
  isStillborn: Scalars['Boolean'];
  litterSize: Scalars['String'];
  updated: Scalars['DateTime'];
};

export type BirthInformationInput = {
  /** Available: NO,YES. Default: None */
  birthAbnormalities?: InputMaybe<Scalars['String']>;
  /** Available: NORMAL,ABNORMAL. Default: None */
  birthPresentation?: InputMaybe<Scalars['String']>;
  /** Available: AVERAGE,SMALL,LARGE. Default: None */
  birthSize?: InputMaybe<Scalars['String']>;
  /** Available: STOOD_WITHIN_30_MINUTES,SUCKED_WITH_1_HOUR,SUCKED_WITH_3_HOURS,DIED_WITHIN_3_HOURS. Default: None */
  birthVigor?: InputMaybe<Scalars['String']>;
  birthWeight?: InputMaybe<Scalars['Float']>;
  /** Available: NORMAL,MODERATE_BY_FARMER,MODERATE_VETERINARY,DIFFICULT,CESAREAN. Default: None */
  birthingDifficulty?: InputMaybe<Scalars['String']>;
  /** Available: BLACK,BLACK_WHITE,BLUE_ROAN,DARK_BLUE_ROAN,DARK_BROWN,DARK_BROWN_WHITE,LIGHT_BLUE_ROAN,LIGHT_BROWN,LIGHT_BROWN_WHITE,RED,WHITE,OTHER. Default: None */
  calfColour?: InputMaybe<Scalars['String']>;
  /** Available: 1,2,3,OTHER. Default: None */
  litterSize?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum BirthPresentation {
  Abnormal = 'ABNORMAL',
  Normal = 'NORMAL'
}

/** An enumeration. */
export enum BirthSize {
  Average = 'AVERAGE',
  Large = 'LARGE',
  Small = 'SMALL'
}

/** An enumeration. */
export enum BirthVigor {
  DiedWithin_3Horus = 'DIED_WITHIN_3_HORUS',
  StoodWithin_30Minutes = 'STOOD_WITHIN_30_MINUTES',
  SuckedWith_1Hour = 'SUCKED_WITH_1_HOUR',
  SuckedWith_3Hours = 'SUCKED_WITH_3_HOURS'
}

/** An enumeration. */
export enum BirthingDifficulties {
  Cesarean = 'CESAREAN',
  Difficult = 'DIFFICULT',
  ModerateByFarmer = 'MODERATE_BY_FARMER',
  ModerateVeterinary = 'MODERATE_VETERINARY',
  Normal = 'NORMAL'
}

export type BlockchainAnimalData = {
  __typename?: 'BlockchainAnimalData';
  breed?: Maybe<Scalars['String']>;
  carcassGrading?: Maybe<Array<BlockchainCarcassGradingInfo>>;
  deathCreatedBy?: Maybe<Scalars['String']>;
  deathDate?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  error?: Maybe<Scalars['String']>;
  isDead?: Maybe<Scalars['String']>;
  isMale?: Maybe<Scalars['Boolean']>;
  medication?: Maybe<Array<BlockchainMedicationInfo>>;
  movements?: Maybe<Array<BlockchainMoveInfo>>;
  name?: Maybe<Scalars['String']>;
  ownerHoldingId?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  passportNumber?: Maybe<Scalars['String']>;
  weights?: Maybe<Array<BlockchainWeightInfo>>;
};

export type BlockchainCarcassGradingInfo = {
  __typename?: 'BlockchainCarcassGradingInfo';
  coldWeight?: Maybe<Scalars['String']>;
  condemnedWeight?: Maybe<Scalars['String']>;
  conformation?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  fatScore?: Maybe<Scalars['String']>;
  grading?: Maybe<Scalars['String']>;
  holdingId?: Maybe<Scalars['String']>;
  hotWeight?: Maybe<Scalars['String']>;
  killNumber?: Maybe<Scalars['String']>;
  lotNumber?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type BlockchainMedicationInfo = {
  __typename?: 'BlockchainMedicationInfo';
  activeIngredient?: Maybe<Scalars['String']>;
  batchNumber?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  dosage?: Maybe<Scalars['String']>;
  dosageUnits?: Maybe<Scalars['String']>;
  holdingId?: Maybe<Scalars['String']>;
  medicineName?: Maybe<Scalars['String']>;
  withdrawalDays?: Maybe<Scalars['String']>;
};

export type BlockchainMoveInfo = {
  __typename?: 'BlockchainMoveInfo';
  createdBy?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  fromFarmName?: Maybe<Scalars['String']>;
  fromHoldingId?: Maybe<Scalars['String']>;
  toHoldingId?: Maybe<Scalars['String']>;
  toOwnerId?: Maybe<Scalars['String']>;
  toOwnerName?: Maybe<Scalars['String']>;
};

export type BlockchainWeightInfo = {
  __typename?: 'BlockchainWeightInfo';
  createdBy?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  holdingId?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type BreedPercentage = {
  __typename?: 'BreedPercentage';
  breed: AnimalBreed;
  /** Percentage of breed in animal */
  percentage?: Maybe<Scalars['Int']>;
};

export type BreedrBankAccountDetailsObjectType = {
  __typename?: 'BreedrBankAccountDetailsObjectType';
  accountName: Scalars['String'];
  accountNo: Scalars['String'];
  sortCode: Scalars['String'];
};

/**
 * This object holds all Breedseek data for a given animal. Breedseek data is a percentage
 * breakdown of the animal's breed, backed by DNA testing.
 */
export type BreedseekData = {
  __typename?: 'BreedseekData';
  akaushi: Scalars['Decimal'];
  angus: Scalars['Decimal'];
  animal?: Maybe<Animal>;
  barcode: Scalars['String'];
  beefmasters: Scalars['Decimal'];
  brangus: Scalars['Decimal'];
  hereford: Scalars['Decimal'];
  holstein: Scalars['Decimal'];
  jersey: Scalars['Decimal'];
  orderRef?: Maybe<Scalars['String']>;
  redAngus: Scalars['Decimal'];
  santaGertrudis: Scalars['Decimal'];
  testRef?: Maybe<Scalars['String']>;
  wagyu: Scalars['Decimal'];
};

export enum BulkUploadFormatOptionDataSubTypeEnum {
  AnimalMatchingColumn = 'ANIMAL_MATCHING_COLUMN'
}

export enum BulkUploadFormatOptionDataTypeEnum {
  Boolean = 'BOOLEAN',
  Select = 'SELECT'
}

export type BulletObjectType = {
  __typename?: 'BulletObjectType';
  id: Scalars['ID'];
  order: Scalars['Int'];
  text: Scalars['String'];
};

export type BusinessType = {
  __typename?: 'BusinessType';
  activityTypes: Array<ActivityType>;
  id: Scalars['ID'];
  /** @deprecated Use query mainReport. */
  mainReport?: Maybe<ReportType>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type BusinessUnit = BusinessUnitInterface & {
  __typename?: 'BusinessUnit';
  accreditations: Array<Accreditation>;
  activityTemplates: Array<ActivityTemplate>;
  address?: Maybe<Scalars['String']>;
  addressExtra?: Maybe<Scalars['String']>;
  animalDetails: Array<FarmAnimalType>;
  animalFilters: Array<AnimalFilterObjectType>;
  /** @deprecated [2024-01] Available matching columns are now provided as a list of choices with the relevant BulkFormat */
  animalMatchingColumns?: Maybe<Array<Maybe<IdentifierEnumType>>>;
  animalTypes?: Maybe<Array<Maybe<AnimalType>>>;
  backgroundPhoto?: Maybe<Scalars['String']>;
  balance?: Maybe<BalanceAccountType>;
  birthDataForm?: Maybe<Array<Maybe<FormType>>>;
  businessType?: Maybe<BusinessType>;
  businessUnitAccreditations: Array<BusinessUnitAccreditation>;
  businessUnitTargets: Array<BusinessUnitTarget>;
  /** @deprecated RFL */
  canCreateRfl: Scalars['Boolean'];
  carcassGradingExtractor?: Maybe<BusinessUnitCarcassGradingExtractor>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  county?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  dateJoined: Scalars['Date'];
  deliveryAddress: Array<DeliveryAddressType>;
  description?: Maybe<Scalars['String']>;
  effectiveSubscriptionPlan?: Maybe<SubscriptionPlan>;
  employeeCnt?: Maybe<Scalars['Int']>;
  enableBcmsPushTransactions: Scalars['Boolean'];
  farmAnimalTypes: Array<AnimalType>;
  farmId?: Maybe<Scalars['String']>;
  financialTransactions?: Maybe<FinancialTransactionConnection>;
  foggles?: Maybe<Array<Maybe<Scalars['String']>>>;
  growthStage?: Maybe<Array<Scalars['String']>>;
  guid?: Maybe<Scalars['UUID']>;
  herdDoggIntegration?: Maybe<HerdDoggIntegrationObjectType>;
  holdingId?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifierPreferencesActiveIds?: Maybe<ActiveIdentifierPreferencesType>;
  identifierPreferencesPrimaryId?: Maybe<IdentifierEnumType>;
  identifierPreferencesSecondaryId?: Maybe<IdentifierEnumType>;
  isOrganic?: Maybe<Scalars['Boolean']>;
  killOut?: Maybe<Scalars['Int']>;
  /** @deprecated Use primary_location */
  locationData?: Maybe<Scalars['GenericScalar']>;
  locationsCount?: Maybe<Scalars['Int']>;
  lotExpiryInDays?: Maybe<Scalars['Int']>;
  marketType: Array<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organisation?: Maybe<Organisation>;
  phone?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  preferredBusinessUnits: Array<PreferredBusinessUnit>;
  primaryLocation?: Maybe<DeliveryAddressType>;
  profilePhoto?: Maybe<Scalars['String']>;
  ratingAverage?: Maybe<Scalars['Float']>;
  region?: Maybe<Region>;
  regulatorySystem?: Maybe<IntegrationSystemType>;
  regulatorySystemAvailable?: Maybe<Scalars['Boolean']>;
  requireBirthData?: Maybe<Scalars['Boolean']>;
  settings?: Maybe<BusinessUnitSettingsType>;
  statuses: Array<BusinessUnitStatus>;
  /** @deprecated Obsolete */
  subscriptionPlan?: Maybe<BusinessUnitSubscription>;
  subscriptionPlanFeatures?: Maybe<Array<SubscriptionPlanFeature>>;
  tbStatus?: Maybe<BusinessUnitTbStatus>;
  /** @deprecated Obsolete */
  tradingPlan?: Maybe<TradingPlan>;
  tradingTypes: Array<TradingType>;
  unitsOfMeasurement?: Maybe<Array<Maybe<UnitOfMeasurement>>>;
  userPermissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  users: Array<User>;
  /** From 0 to 1. 1 is 100% */
  vatRate?: Maybe<Scalars['Float']>;
  warnings?: Maybe<Scalars['GenericScalar']>;
  workers: Array<BusinessUnitUser>;
};


export type BusinessUnitAnimalTypesArgs = {
  aliveOnly?: InputMaybe<Scalars['Boolean']>;
  permittedOnly?: InputMaybe<Scalars['Boolean']>;
};


export type BusinessUnitFinancialTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type BusinessUnitAccreditation = {
  __typename?: 'BusinessUnitAccreditation';
  accreditation: Accreditation;
  businessUnit: BusinessUnit;
  dateUploaded: Scalars['Date'];
  documents?: Maybe<Array<Maybe<BusinessUnitAccreditationDocument>>>;
  expires?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isApproved: Scalars['Boolean'];
  membershipId?: Maybe<Scalars['String']>;
  uploadedBy?: Maybe<User>;
};

export type BusinessUnitAccreditationDocument = {
  __typename?: 'BusinessUnitAccreditationDocument';
  file?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum BusinessUnitCarcassGradingExtractor {
  A = 'A_',
  Dunbia = 'DUNBIA'
}

export type BusinessUnitCountType = {
  __typename?: 'BusinessUnitCountType';
  count?: Maybe<Scalars['Int']>;
  errors?: Maybe<Array<Maybe<ValidationErrorType>>>;
};

export type BusinessUnitInfo = {
  __typename?: 'BusinessUnitInfo';
  accreditations?: Maybe<Array<Maybe<Accreditation>>>;
  address?: Maybe<Scalars['String']>;
  addressExtra?: Maybe<Scalars['String']>;
  backgroundPhoto?: Maybe<Scalars['String']>;
  businessType?: Maybe<BusinessType>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  county?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  farmId?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isMember?: Maybe<Scalars['Boolean']>;
  locationsCount?: Maybe<Scalars['Int']>;
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<UserPublicInfo>;
  phone?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  profilePhoto?: Maybe<Scalars['String']>;
  /** Available statuses: ENGLAND_EDGE_AREA_SIX_MONTH, ENGLAND_EDGE_AREA_ANNUAL, ENGLAND_HIGH_RISK_AREA, ENGLAND_LOW_RISK_AREA, SCOTLAND_ISLE_OF_MAN_OTF, WALES_HIGH_TB, WALES_INTERMEDIATE_TB, WALES_LOW_TB */
  tbStatus?: Maybe<Scalars['String']>;
  unitsOfMeasurement?: Maybe<Array<Maybe<UnitOfMeasurement>>>;
};

export type BusinessUnitInterface = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type BusinessUnitSettingsFaqType = {
  __typename?: 'BusinessUnitSettingsFaqType';
  countries: Array<Country>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  isActive: Scalars['Boolean'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum BusinessUnitSettingsSizeUnit {
  Acre = 'ACRE',
  Ha = 'HA'
}

export type BusinessUnitSettingsType = {
  __typename?: 'BusinessUnitSettingsType';
  sizeUnit: BusinessUnitSettingsSizeUnit;
};

export type BusinessUnitStatus = {
  __typename?: 'BusinessUnitStatus';
  /** @deprecated removed */
  businessunitSet: Array<BusinessUnit>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type BusinessUnitSubscription = {
  __typename?: 'BusinessUnitSubscription';
  archived: Scalars['Boolean'];
  billingPeriodStart?: Maybe<Scalars['Date']>;
  businessUnit?: Maybe<BusinessUnit>;
  businessUnitId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  discountCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  paymentCoupon?: Maybe<Coupon>;
  paymentCouponId?: Maybe<Scalars['Int']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethodId?: Maybe<Scalars['Int']>;
  status: BusinessUnitSubscriptionStatus;
  subscriptionPlan?: Maybe<SubscriptionPlan>;
  subscriptionPlanId?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum BusinessUnitSubscriptionStatus {
  AwaitingPayment = 'AWAITING_PAYMENT',
  Created = 'CREATED',
  Failed = 'FAILED',
  Paid = 'PAID'
}

export type BusinessUnitTarget = {
  __typename?: 'BusinessUnitTarget';
  animalType?: Maybe<AnimalType>;
  businessUnit: BusinessUnit;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['GenericScalar']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  targetWeightType: BusinessUnitTargetTargetWeightType;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum BusinessUnitTargetTargetWeightType {
  Carcass = 'CARCASS',
  LiveWeight = 'LIVE_WEIGHT'
}

/** An enumeration. */
export enum BusinessUnitTbStatus {
  EnglandEdgeAreaAnnual = 'ENGLAND_EDGE_AREA_ANNUAL',
  EnglandEdgeAreaSixMonth = 'ENGLAND_EDGE_AREA_SIX_MONTH',
  EnglandHighRiskArea = 'ENGLAND_HIGH_RISK_AREA',
  EnglandLowRiskArea = 'ENGLAND_LOW_RISK_AREA',
  ScotlandIsleOfManOtf = 'SCOTLAND_ISLE_OF_MAN_OTF',
  WalesHighTb = 'WALES_HIGH_TB',
  WalesIntermediateTb = 'WALES_INTERMEDIATE_TB',
  WalesLowTb = 'WALES_LOW_TB'
}

export type BusinessUnitUser = {
  __typename?: 'BusinessUnitUser';
  businessUnit: BusinessUnit;
  id: Scalars['ID'];
  isOwner?: Maybe<Scalars['Boolean']>;
  role: Role;
  status: BusinessUnitUserStatus;
  user: User;
};

/** An enumeration. */
export enum BusinessUnitUserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Invited = 'INVITED'
}

export type CalfColourObjectType = {
  __typename?: 'CalfColourObjectType';
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum CalfulatorBreedClassification {
  BW = 'B___W',
  Continental = 'CONTINENTAL',
  International = 'INTERNATIONAL',
  Native = 'NATIVE'
}

export type CalfulatorObjectType = {
  __typename?: 'CalfulatorObjectType';
  basePrice: Scalars['Float'];
  basePriceDivisor: Scalars['Float'];
  birthWeight: Scalars['Float'];
  breedClassification: CalfulatorBreedClassification;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  description: Scalars['String'];
  firstFiftyAmberFactor: Scalars['Float'];
  firstFiftyGreenFactor: Scalars['Float'];
  firstFiftyRedFactor: Scalars['Float'];
  id: Scalars['ID'];
  isMale: Scalars['Boolean'];
  overFiftyAmberFactor: Scalars['Float'];
  overFiftyGreenFactor: Scalars['Float'];
  overFiftyRedFactor: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type CancelFarmSystemTaskInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  farmSystemTask?: InputMaybe<Scalars['Int']>;
};

export type CancelFarmSystemTaskPayload = {
  __typename?: 'CancelFarmSystemTaskPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CategoryOfSale = {
  __typename?: 'CategoryOfSale';
  category: Scalars['String'];
  id: Scalars['Int'];
  position: Scalars['Int'];
};

export type CategoryOfSaleConnection = {
  __typename?: 'CategoryOfSaleConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CategoryOfSaleEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CategoryOfSale` and its cursor. */
export type CategoryOfSaleEdge = {
  __typename?: 'CategoryOfSaleEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CategoryOfSale>;
};

export type ChartDataItem = {
  __typename?: 'ChartDataItem';
  animals?: Maybe<Scalars['Int']>;
  data?: Maybe<Scalars['Float']>;
};

export type ChartDataObjectType = {
  __typename?: 'ChartDataObjectType';
  title: Scalars['String'];
  value: Scalars['Float'];
};

export type ChartObjectType = {
  __typename?: 'ChartObjectType';
  dataParam: Scalars['String'];
  layoutSize: Scalars['Int'];
  reportType: Scalars['String'];
};

export type CheckCommitDeliveryInput = {
  actionedAt?: InputMaybe<Scalars['DateTime']>;
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  delivery: Scalars['ID'];
};

/**
 * As the delivvery initiator check actions that will be performed on commit
 * and return validation errors.  This does not necessarily guarantee that
 * the commit action will proceed without errors.
 */
export type CheckCommitDeliveryPayload = {
  __typename?: 'CheckCommitDeliveryPayload';
  animalErrors?: Maybe<Array<DeliveryAnimalErrorType>>;
  clientMutationId?: Maybe<Scalars['String']>;
  delivery?: Maybe<DeliveryType>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CheckFieldInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  fieldArea: FeatureCollectionInputType;
  location: Scalars['Int'];
  name: Scalars['String'];
};

export type CheckFieldPayload = {
  __typename?: 'CheckFieldPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  valid?: Maybe<Scalars['Boolean']>;
};

export enum CheckoutPurposeEnumType {
  Activate = 'ACTIVATE',
  Pro = 'PRO'
}

export type Choice = {
  __typename?: 'Choice';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type CloseLotInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type CloseLotPayload = {
  __typename?: 'CloseLotPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  lot?: Maybe<OwnLot>;
};

export type CommitDeliveryAsyncInput = {
  actionedAt?: InputMaybe<Scalars['DateTime']>;
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  delivery: Scalars['ID'];
};

/** Trigger an async commit and return a task reference. */
export type CommitDeliveryAsyncPayload = {
  __typename?: 'CommitDeliveryAsyncPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  delivery?: Maybe<DeliveryType>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
  task?: Maybe<DeliveryTaskType>;
};

export type CommitDeliveryInput = {
  actionedAt?: InputMaybe<Scalars['DateTime']>;
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  delivery: Scalars['ID'];
};

/**
 * As the delivvery initiator apply the actions specified by a created
 * delivery.  Errors stop the transaction.
 */
export type CommitDeliveryPayload = {
  __typename?: 'CommitDeliveryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  delivery?: Maybe<DeliveryType>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CommonFarmSystemType = FarmSystemType & {
  __typename?: 'CommonFarmSystemType';
  credentials?: Maybe<Scalars['GenericScalar']>;
  errorMessage?: Maybe<Scalars['String']>;
  farm?: Maybe<BusinessUnit>;
  id?: Maybe<Scalars['Int']>;
  integrationSystem?: Maybe<IntegrationSystemType>;
  status?: Maybe<Scalars['String']>;
};

export type CompatMoveAnimalsOffFarmInput = {
  animals: Array<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  fromBusinessUnit: Scalars['ID'];
  fromBusinessUnitName?: InputMaybe<Scalars['String']>;
  holdingId?: InputMaybe<Scalars['String']>;
  newKeeperAddress?: InputMaybe<Scalars['String']>;
  newKeeperEmail?: InputMaybe<Scalars['String']>;
  newKeeperPostcode?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  toBusinessUnit?: InputMaybe<Scalars['ID']>;
  toBusinessUnitName?: InputMaybe<Scalars['String']>;
};

/**
 * Drop in replacement for mark off farm activity interface.  Avoid because
 * it's confusing and causes issues.  This may do an out or a between movement
 * depending on the data provided.
 */
export type CompatMoveAnimalsOffFarmPayload = {
  __typename?: 'CompatMoveAnimalsOffFarmPayload';
  animals?: Maybe<Array<Animal>>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CompetentAuthority = {
  __typename?: 'CompetentAuthority';
  abattoirSet: Array<Abattoir>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CompleteInvitationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  hashCode: Scalars['String'];
  password: Scalars['String'];
};

export type CompleteInvitationPayload = {
  __typename?: 'CompleteInvitationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** An enumeration. */
export enum ContactContactType {
  Farm = 'FARM',
  Other = 'OTHER'
}

export type ContactObjectType = {
  __typename?: 'ContactObjectType';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  businessUnit: BusinessUnit;
  city?: Maybe<Scalars['String']>;
  contactType: ContactContactType;
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  farmId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  organisationName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ContactsConnection = {
  __typename?: 'ContactsConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContactsEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Contacts` and its cursor. */
export type ContactsEdge = {
  __typename?: 'ContactsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ContactObjectType>;
};

export type ConvertBatchInput = {
  animalData: Array<InputMaybe<CreateBatchAnimalObjectType>>;
  batch: Scalars['UUID'];
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ConvertBatchPayload = {
  __typename?: 'ConvertBatchPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  importId?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Country = {
  __typename?: 'Country';
  /** @deprecated removed */
  abattoirSet: Array<Abattoir>;
  code: Scalars['String'];
  /** @deprecated removed */
  contactSet: Array<ContactObjectType>;
  /** @deprecated removed */
  currencySet: Array<Currency>;
  /** @deprecated removed */
  deliveryaddressSet: Array<DeliveryAddressType>;
  /** @deprecated removed */
  emptystateSet: Array<EmptyStateObjectType>;
  id: Scalars['ID'];
  /** @deprecated removed */
  integrationsystemSet: Array<IntegrationSystemType>;
  isoAlpha2?: Maybe<Scalars['String']>;
  isoAlpha3?: Maybe<Scalars['String']>;
  isoNumber?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  region?: Maybe<Region>;
  /** @deprecated removed */
  sexclassificationSet: Array<SexClassification>;
  subCode?: Maybe<Scalars['String']>;
  visualIdPrefix?: Maybe<Scalars['String']>;
};

export type Coupon = {
  __typename?: 'Coupon';
  currency?: Maybe<Currency>;
  id: Scalars['ID'];
  isPercent: Scalars['Boolean'];
  /** Name of the coupon displayed to customers on, for instance invoices, or receipts. */
  name?: Maybe<Scalars['String']>;
  priceOff: Scalars['Float'];
};

export type CreateAnimalFilterInput = {
  ageFrom?: InputMaybe<Scalars['Decimal']>;
  ageTo?: InputMaybe<Scalars['Decimal']>;
  animalType?: InputMaybe<Scalars['Int']>;
  breeds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  currentWeightFrom?: InputMaybe<Scalars['Decimal']>;
  currentWeightTo?: InputMaybe<Scalars['Decimal']>;
  daysSinceLastWeightFrom?: InputMaybe<Scalars['Decimal']>;
  daysSinceLastWeightTo?: InputMaybe<Scalars['Decimal']>;
  deliveryFrom?: InputMaybe<Scalars['Date']>;
  deliveryTo?: InputMaybe<Scalars['Date']>;
  dobFrom?: InputMaybe<Scalars['Date']>;
  dobTo?: InputMaybe<Scalars['Date']>;
  dofFrom?: InputMaybe<Scalars['Date']>;
  dofTo?: InputMaybe<Scalars['Date']>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  growthRateFrom?: InputMaybe<Scalars['Decimal']>;
  growthRateTo?: InputMaybe<Scalars['Decimal']>;
  inWithdrawal?: InputMaybe<Scalars['Boolean']>;
  isAlert?: InputMaybe<Scalars['Boolean']>;
  isMale?: InputMaybe<Scalars['Boolean']>;
  isPregnant?: InputMaybe<Scalars['Boolean']>;
  isRegulatorySynced?: InputMaybe<Scalars['Boolean']>;
  lastRegulatorySyncedDateFrom?: InputMaybe<Scalars['Date']>;
  lastRegulatorySyncedDateTo?: InputMaybe<Scalars['Date']>;
  lastWeightFrom?: InputMaybe<Scalars['Decimal']>;
  lastWeightTo?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  pregnancyDueDateFrom?: InputMaybe<Scalars['Date']>;
  pregnancyDueDateTo?: InputMaybe<Scalars['Date']>;
  sexClassifications?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CreateAnimalFilterPayload = {
  __typename?: 'CreateAnimalFilterPayload';
  animalFilter?: Maybe<AnimalFilterObjectType>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type CreateAnimalInput = {
  alternativeId?: InputMaybe<Scalars['String']>;
  animalBreeds: Array<InputMaybe<Scalars['UUID']>>;
  /** Available: RAM, EWE, WETHER, LAMB, HOGGET, HEIFER, BULL_CALF, STEER, BULL, COW, SOW, GILTS, BOARS, PIGLET, WEANER, GROWERS, FATTENERS. Default: None */
  animalSubtype?: InputMaybe<Scalars['String']>;
  animalType: Scalars['Int'];
  birthInformation?: InputMaybe<BirthInformationInput>;
  breedSocietyRegistration?: InputMaybe<Scalars['Boolean']>;
  breeding?: InputMaybe<Scalars['Boolean']>;
  brucellosisId?: InputMaybe<Scalars['String']>;
  businessUnit?: InputMaybe<Scalars['Int']>;
  children?: InputMaybe<Scalars['GenericScalar']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  conditions?: InputMaybe<Array<Scalars['ID']>>;
  dam?: InputMaybe<Scalars['UUID']>;
  damPassportNumber?: InputMaybe<Scalars['String']>;
  dateMovedToFarm?: InputMaybe<Scalars['DateTime']>;
  deathDestinationAddress?: InputMaybe<Scalars['String']>;
  deathDestinationName?: InputMaybe<Scalars['String']>;
  deathDestinationPostcode?: InputMaybe<Scalars['String']>;
  deathDisposalCost?: InputMaybe<Scalars['Float']>;
  deathReason?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dob: Scalars['DateTime'];
  eId?: InputMaybe<Scalars['String']>;
  eIdsHistory?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  field?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<Scalars['UUID']>;
  herdDoggId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  imageFiles?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  isCastrated?: InputMaybe<Scalars['Boolean']>;
  isDead?: InputMaybe<Scalars['Boolean']>;
  /** Add birth activity log, if true. */
  isLogBirth?: InputMaybe<Scalars['Boolean']>;
  isMale?: InputMaybe<Scalars['Boolean']>;
  isPedigree?: InputMaybe<Scalars['Boolean']>;
  killFatScore?: InputMaybe<Scalars['String']>;
  killQuality?: InputMaybe<Scalars['String']>;
  killWeight?: InputMaybe<Scalars['Float']>;
  linkToMySire?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  passportNumber?: InputMaybe<Scalars['String']>;
  pedigreeId?: InputMaybe<Scalars['String']>;
  previousKeeper?: InputMaybe<Scalars['Int']>;
  /** Price paid for the animal in business units preferred currency */
  purchasePrice?: InputMaybe<Scalars['Float']>;
  registrationStatus?: InputMaybe<Scalars['Boolean']>;
  relatedMeatLabels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sire?: InputMaybe<Scalars['UUID']>;
  sireIsPedigree?: InputMaybe<Scalars['Boolean']>;
  sirePassportNumber?: InputMaybe<Scalars['String']>;
  sireStuds?: InputMaybe<Scalars['String']>;
  studSiredId?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['ID']>>;
  tattoo?: InputMaybe<Scalars['String']>;
  trichId?: InputMaybe<Scalars['String']>;
  tsuBarcode?: InputMaybe<Scalars['String']>;
  uhfId?: InputMaybe<Scalars['String']>;
  visualId?: InputMaybe<Scalars['String']>;
  visualIdsHistory?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * Flexible but low level method for animal creation.  Prefer to use
 * createBirth or deliverAnimal where appropriate.
 */
export type CreateAnimalPayload = {
  __typename?: 'CreateAnimalPayload';
  animal?: Maybe<Animal>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type CreateAnimalsAlertsInput = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  alertType: Scalars['String'];
  animals: Array<InputMaybe<Scalars['UUID']>>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  isCrushReminder?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  remindAt: Scalars['Date'];
  /** Available options: HIGH, MEDIUM, LOW */
  urgency: Scalars['String'];
};

export type CreateAnimalsAlertsPayload = {
  __typename?: 'CreateAnimalsAlertsPayload';
  animalAlerts?: Maybe<Array<Maybe<AnimalAlertObjectType>>>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type CreateBankAccountInput = {
  accountInfo?: InputMaybe<Scalars['GenericScalar']>;
  balanceAccount: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};

export type CreateBankAccountPayload = {
  __typename?: 'CreateBankAccountPayload';
  bankAccount?: Maybe<BankAccountType>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type CreateBankDetailsInput = {
  accountName: Scalars['String'];
  accountNo: Scalars['String'];
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  isBusinessAccount: Scalars['Boolean'];
  sortCode: Scalars['String'];
};

export type CreateBankDetailsPayload = {
  __typename?: 'CreateBankDetailsPayload';
  bankDetails?: Maybe<BankAccountDetailsObjectType>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type CreateBatchAnimalObjectType = {
  animalBreeds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  dateMovedToFarm?: InputMaybe<Scalars['Date']>;
  dob?: InputMaybe<Scalars['Date']>;
  eId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isCastrated?: InputMaybe<Scalars['Boolean']>;
  isMale?: InputMaybe<Scalars['Boolean']>;
  passportNumber?: InputMaybe<Scalars['String']>;
  visualId?: InputMaybe<Scalars['String']>;
};

export type CreateBatchInput = {
  animalBreeds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  animalType?: InputMaybe<Scalars['Int']>;
  averageDobInBatch?: InputMaybe<Scalars['Date']>;
  batchDateOnFarm?: InputMaybe<Scalars['Date']>;
  businessUnit: Scalars['Int'];
  businessUnitTarget?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<Scalars['UUID']>;
  gendersInBatch?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  imageFiles?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  isPurchased?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  numberOfUnidentifiedAnimalsInBatch: Scalars['Int'];
  targetDate?: InputMaybe<Scalars['Date']>;
  targetWeight?: InputMaybe<Scalars['Float']>;
};

export type CreateBatchPayload = {
  __typename?: 'CreateBatchPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  group?: Maybe<Group>;
};

export type CreateBusinessUnitAccreditationInput = {
  accreditation: Scalars['Int'];
  businessUnit?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  documentFiles?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  expires?: InputMaybe<Scalars['Date']>;
  membershipId?: InputMaybe<Scalars['String']>;
};

export type CreateBusinessUnitAccreditationPayload = {
  __typename?: 'CreateBusinessUnitAccreditationPayload';
  businessUnitAccreditation?: Maybe<BusinessUnitAccreditation>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type CreateBusinessUnitTargetInput = {
  animalType: Scalars['Int'];
  businessUnit?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['GenericScalar']>;
  name: Scalars['String'];
  targetWeightType?: InputMaybe<Scalars['String']>;
};

export type CreateBusinessUnitTargetPayload = {
  __typename?: 'CreateBusinessUnitTargetPayload';
  businessUnitTarget?: Maybe<BusinessUnitTarget>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type CreateContactInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  businessUnit: Scalars['Int'];
  city?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  contactType: Scalars['String'];
  country?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  farmId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organisationName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type CreateContactPayload = {
  __typename?: 'CreateContactPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  contact?: Maybe<ContactObjectType>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type CreateDeliveryInput = {
  arrivedAt?: InputMaybe<Scalars['DateTime']>;
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  destinationContact?: InputMaybe<Scalars['ID']>;
  destinationPartner?: InputMaybe<Scalars['ID']>;
  destinationPartnerAddress?: InputMaybe<Scalars['ID']>;
  direction: DeliveryDirectionEnum;
  name: Scalars['String'];
  reason?: InputMaybe<Scalars['ID']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  sourceContact?: InputMaybe<Scalars['ID']>;
  sourcePartner?: InputMaybe<Scalars['ID']>;
  sourcePartnerAddress?: InputMaybe<Scalars['ID']>;
};

/**
 * Create a delivery used to perform a movement.  The delivery has limited
 * effect until it is committed.
 */
export type CreateDeliveryPayload = {
  __typename?: 'CreateDeliveryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  delivery?: Maybe<DeliveryType>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateDistributionListInput = {
  /** Current BU of user's session */
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  suppliers: Array<Scalars['Int']>;
};

export type CreateDistributionListPayload = {
  __typename?: 'CreateDistributionListPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  distributionList?: Maybe<DistributionListObjectType>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type CreateDownloadInput = {
  businessUnitId: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  dashboardSlug: Scalars['String'];
  downloadSlug: Scalars['String'];
  outputTz?: InputMaybe<Scalars['String']>;
  variables?: InputMaybe<Scalars['GenericScalar']>;
};

export type CreateDownloadPayload = {
  __typename?: 'CreateDownloadPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  downloadId?: Maybe<Scalars['ID']>;
  /** @deprecated unused */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateFarmSystemInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  credentials?: InputMaybe<Scalars['GenericScalar']>;
  farm: Scalars['Int'];
  integrationSystem: Scalars['Int'];
};

export type CreateFarmSystemPayload = {
  __typename?: 'CreateFarmSystemPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  farmSystem?: Maybe<FarmSystemType>;
};

export type CreateFieldInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  colour?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fieldArea?: InputMaybe<FeatureCollectionInputType>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  imageFiles?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  isOrganic?: InputMaybe<Scalars['Boolean']>;
  isYard?: InputMaybe<Scalars['Boolean']>;
  location: Scalars['Int'];
  name: Scalars['String'];
  pastureTypes?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size?: InputMaybe<Scalars['Float']>;
};

export type CreateFieldPayload = {
  __typename?: 'CreateFieldPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  field?: Maybe<Field>;
};

export type CreateFinancialTransactionInput = {
  amount: Scalars['Float'];
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  counterparty: Scalars['String'];
  date: Scalars['DateTime'];
  label: Scalars['String'];
  notes: Scalars['String'];
  recordType: TransactionRecordEnumType;
  totalWeight?: InputMaybe<Scalars['Float']>;
  transactionAnimals?: InputMaybe<Array<InputMaybe<TransactionAnimalInputType>>>;
  valueAllocationMethod: ValueAllocationMethodEnumType;
};

/** Creates a Financial Transaction object. Can return the object just created. */
export type CreateFinancialTransactionPayload = {
  __typename?: 'CreateFinancialTransactionPayload';
  animalErrors?: Maybe<Array<FinancialTransactionAnimalErrorObjectType>>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
  financialTransaction?: Maybe<FinancialTransaction>;
};

export type CreateGroupInput = {
  animalBreeds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  animalType?: InputMaybe<Scalars['Int']>;
  businessUnit: Scalars['Int'];
  businessUnitTarget?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  imageFiles?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  name?: InputMaybe<Scalars['String']>;
  targetDate?: InputMaybe<Scalars['Date']>;
  targetWeight?: InputMaybe<Scalars['Float']>;
};

export type CreateGroupPayload = {
  __typename?: 'CreateGroupPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  group?: Maybe<Group>;
};

export type CreateLiveSessionInput = {
  animalErrors?: InputMaybe<Array<InputMaybe<AnimalErrorParameter>>>;
  animalType?: InputMaybe<Scalars['Int']>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** When the session was created on the device by the user */
  createdOnDeviceAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  /** Represents an Animal and additional inputs specific to that Animal in the context of the session. */
  sessionAnimals?: InputMaybe<Array<InputMaybe<LiveSessionAnimalInputType>>>;
  sessionOwner: Scalars['Int'];
  /** Indicates where the session is in its lifecycle. Note that whatever choice is passed as input here, the backend will always set it to 'SAVED' when updating the database. */
  sessionStatus?: InputMaybe<SessionStatus>;
};

/**
 * Creates a Live Session. Use the UpdateLiveSession mutation to make changes and
 * DeleteLiveSession to permanently remove it.
 */
export type CreateLiveSessionPayload = {
  __typename?: 'CreateLiveSessionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  liveSession?: Maybe<LiveSession>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateLotInput = {
  animalType?: InputMaybe<Scalars['Int']>;
  animals: Array<InputMaybe<Scalars['UUID']>>;
  businessUnit: Scalars['Int'];
  categoryOfSale?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryAddress?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  /** List of Distribution List IDs */
  distributionLists?: InputMaybe<Array<Scalars['Int']>>;
  isTacAccepted?: InputMaybe<Scalars['Boolean']>;
  lotImages?: InputMaybe<Array<InputMaybe<LotImageInput>>>;
  name?: InputMaybe<Scalars['String']>;
  preMovementTestDate?: InputMaybe<Scalars['DateTime']>;
  price: Scalars['Float'];
  priceUnit: Scalars['String'];
  tbRequirements: Scalars['String'];
  tradingType: Scalars['Int'];
};

export type CreateLotPayload = {
  __typename?: 'CreateLotPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  lot?: Maybe<OwnLot>;
};

export type CreateOfferForLotInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  collectionDate?: InputMaybe<Scalars['Date']>;
  comment?: InputMaybe<Scalars['String']>;
  hasAcceptedListing?: InputMaybe<Scalars['Boolean']>;
  isTacAccepted?: InputMaybe<Scalars['Boolean']>;
  lot: Scalars['Int'];
  price: Scalars['Float'];
  /** Available Options: TOTAL, HEAD, KG */
  priceUnit?: InputMaybe<Scalars['String']>;
  totalPriceOnCreation?: InputMaybe<Scalars['Float']>;
};

export type CreateOfferForLotPayload = {
  __typename?: 'CreateOfferForLotPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  offer?: Maybe<Offer>;
};

export type CreatePreferredBuyersInput = {
  animalTypes?: InputMaybe<Array<Scalars['Int']>>;
  /** Current BU of user's session */
  businessUnit: Scalars['Int'];
  buyers?: InputMaybe<Array<Scalars['Int']>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Emails in order to invite new user: new user, business unit, preferred business unit will be created. */
  emails?: InputMaybe<Array<Scalars['String']>>;
};

export type CreatePreferredBuyersPayload = {
  __typename?: 'CreatePreferredBuyersPayload';
  buyers?: Maybe<Array<Maybe<PreferredBusinessUnit>>>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type CreatePreferredSuppliersInput = {
  animalTypes?: InputMaybe<Array<Scalars['Int']>>;
  /** Current BU of user's session */
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Emails in order to invite new user: new user, business unit, preferred business unit will be created. */
  emails?: InputMaybe<Array<Scalars['String']>>;
  fieldsman?: InputMaybe<Scalars['Int']>;
  priceAdjustment?: InputMaybe<Scalars['Decimal']>;
  suppliers?: InputMaybe<Array<Scalars['Int']>>;
};

export type CreatePreferredSuppliersPayload = {
  __typename?: 'CreatePreferredSuppliersPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  suppliers?: Maybe<Array<Maybe<PreferredBusinessUnit>>>;
};

export type CreateProducerGroupInput = {
  backgroundPhotoFile?: InputMaybe<Scalars['Upload']>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  invitedMembers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  newMembers?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  profilePhotoFile?: InputMaybe<Scalars['Upload']>;
};

export type CreateProducerGroupPayload = {
  __typename?: 'CreateProducerGroupPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  producerGroup?: Maybe<ProducerGroupType>;
};

export type CreateSireInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  passportNumber: Scalars['String'];
  pedigree?: InputMaybe<Scalars['Boolean']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  sire?: InputMaybe<Scalars['String']>;
};

export type CreateSirePayload = {
  __typename?: 'CreateSirePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  sire?: Maybe<Sire>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateStripeCheckoutSessionInput = {
  activationTokenId?: InputMaybe<Scalars['ID']>;
  businessUnitId: Scalars['Int'];
  cancelUrl?: InputMaybe<Scalars['String']>;
  catalogOption?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<CheckoutPurposeEnumType>;
  returnUrl: Scalars['String'];
};

/**
 * Begin a session on stripe's checkout portal for a particular purpose.
 * The user can go there to buy new products.
 */
export type CreateStripeCheckoutSessionPayload = {
  __typename?: 'CreateStripeCheckoutSessionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sessionUrl: Scalars['String'];
};

export type CreateStripePortalSessionInput = {
  businessUnitId: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  portalType?: InputMaybe<Scalars['String']>;
  returnUrl: Scalars['String'];
};

/**
 * Begin a session on stripe's portal.  The user can go there to edit
 * existing products.
 */
export type CreateStripePortalSessionPayload = {
  __typename?: 'CreateStripePortalSessionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sessionUrl: Scalars['String'];
};

export type CreateTagInput = {
  animalTypes?: InputMaybe<Array<Scalars['ID']>>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  color: Scalars['String'];
  name: Scalars['String'];
  textColor?: InputMaybe<Scalars['String']>;
};

/** Add a custom schema field. */
export type CreateTagPayload = {
  __typename?: 'CreateTagPayload';
  animalTag?: Maybe<AnimalTagSchemaType>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateUpdateInProgressCrushAppSessionInput = {
  animalType?: InputMaybe<Scalars['Int']>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  sessionConfig?: InputMaybe<Scalars['GenericScalar']>;
  user: Scalars['Int'];
};

/** create a crush session object with session config only */
export type CreateUpdateInProgressCrushAppSessionPayload = {
  __typename?: 'CreateUpdateInProgressCrushAppSessionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  crushAppSession?: Maybe<CrushAppSessionObjectType>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type CreateWeightInput = {
  animal: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  recordedAt: Scalars['DateTime'];
  unit: WeightUnitEnum;
  value: Scalars['Decimal'];
};

/** Store a weight measurement. */
export type CreateWeightPayload = {
  __typename?: 'CreateWeightPayload';
  animal?: Maybe<Animal>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
  weight?: Maybe<MeasuredWeightEventType>;
};

export type CrushActionErrors = {
  __typename?: 'CrushActionErrors';
  action: Scalars['String'];
  metadata?: Maybe<Scalars['GenericScalar']>;
  validationErrors?: Maybe<Array<Maybe<CrushActionValidationErrors>>>;
};

export type CrushActionValidationErrors = {
  __typename?: 'CrushActionValidationErrors';
  code: Scalars['String'];
  errorMessages: Array<Maybe<Scalars['String']>>;
  field: Scalars['String'];
};

export type CrushAnimalNotSaved = {
  __typename?: 'CrushAnimalNotSaved';
  actionErrors?: Maybe<Array<Maybe<CrushActionErrors>>>;
  animal?: Maybe<Animal>;
  newAnimalId?: Maybe<Scalars['String']>;
};

export type CrushAnimalSaved = {
  __typename?: 'CrushAnimalSaved';
  animal?: Maybe<Animal>;
};

/** Note: if you change fields here it could affect on LogActivityBulk mutation. */
export type CrushAppActivityItem = {
  activityTemplate: Scalars['Int'];
  animals?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  date?: InputMaybe<Scalars['DateTime']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  /**
   * The value of payload should be valid JSON
   *         in the following format:
   *           {
   *             "name": "New Activity",
   *             "description": "some notes...",
   *             "data": [
   *               {
   *                 "id": 1,
   *                 "value": "my value"
   *               },
   *               ...
   *             ]
   *     }
   */
  payload: Scalars['GenericScalar'];
};

export type CrushAppAnimalAlertItem = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  alertType: Scalars['String'];
  animals: Array<InputMaybe<Scalars['UUID']>>;
  isCrushReminder?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  remindAt: Scalars['Date'];
  /** Available options: HIGH, MEDIUM, LOW */
  urgency: Scalars['String'];
};

/** Note: if you change fields here it could affect on create/update animal mutation. */
export type CrushAppAnimalItem = {
  alternativeId?: InputMaybe<Scalars['String']>;
  animalBreeds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Available: RAM, EWE, WETHER, LAMB, HOGGET, HEIFER, BULL_CALF, STEER, BULL, COW, SOW, GILTS, BOARS, PIGLET, WEANER, GROWERS, FATTENERS. Default: None */
  animalSubtype?: InputMaybe<Scalars['String']>;
  animalType?: InputMaybe<Scalars['Int']>;
  birthInformation?: InputMaybe<BirthInformationInput>;
  breedSocietyRegistration?: InputMaybe<Scalars['Boolean']>;
  breeding?: InputMaybe<Scalars['Boolean']>;
  brucellosisId?: InputMaybe<Scalars['String']>;
  children?: InputMaybe<Scalars['GenericScalar']>;
  dam?: InputMaybe<Scalars['UUID']>;
  damPassportNumber?: InputMaybe<Scalars['String']>;
  dateMovedToFarm?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['DateTime']>;
  eId?: InputMaybe<Scalars['String']>;
  eIdsHistory?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  field?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<Scalars['UUID']>;
  herdDoggId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  imageFiles?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  isCastrated?: InputMaybe<Scalars['Boolean']>;
  /** Add birth activity log, if true. */
  isLogBirth?: InputMaybe<Scalars['Boolean']>;
  isMale?: InputMaybe<Scalars['Boolean']>;
  isPedigree?: InputMaybe<Scalars['Boolean']>;
  killFatScore?: InputMaybe<Scalars['Float']>;
  killQuality?: InputMaybe<Scalars['Float']>;
  killWeight?: InputMaybe<Scalars['Float']>;
  linkToMySire?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  passportNumber?: InputMaybe<Scalars['String']>;
  pedigree?: InputMaybe<Scalars['String']>;
  pedigreeId?: InputMaybe<Scalars['String']>;
  previousKeeper?: InputMaybe<Scalars['Int']>;
  purchasePrice?: InputMaybe<Scalars['Float']>;
  registrationStatus?: InputMaybe<Scalars['Boolean']>;
  relatedMeatLabels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sire?: InputMaybe<Scalars['UUID']>;
  sireIsPedigree?: InputMaybe<Scalars['Boolean']>;
  sirePassportNumber?: InputMaybe<Scalars['String']>;
  sireStuds?: InputMaybe<Scalars['String']>;
  studSiredId?: InputMaybe<Scalars['String']>;
  tagValues?: InputMaybe<Array<AnimalTagAssignmentInputType>>;
  tattoo?: InputMaybe<Scalars['String']>;
  trichId?: InputMaybe<Scalars['String']>;
  tsuBarcode?: InputMaybe<Scalars['String']>;
  uhfId?: InputMaybe<Scalars['String']>;
  visualId?: InputMaybe<Scalars['String']>;
  visualIdsHistory?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CrushAppAnimalsToFieldItem = {
  animals?: InputMaybe<Array<Scalars['UUID']>>;
  field?: InputMaybe<Scalars['UUID']>;
};

/** Note: if you change fields here it could affect on create/update group mutation. */
export type CrushAppGroupItem = {
  animalBreeds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  animalType: Scalars['Int'];
  businessUnitTarget?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  imageFiles?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  name: Scalars['String'];
  targetWeight?: InputMaybe<Scalars['Float']>;
};

export type CrushAppMarkAsDoneAnimalAlertItem = {
  animalAlerts?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  completedAt: Scalars['Date'];
  resolutionComments?: InputMaybe<Scalars['String']>;
};

export type CrushAppSessionConnection = {
  __typename?: 'CrushAppSessionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CrushAppSessionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CrushAppSession` and its cursor. */
export type CrushAppSessionEdge = {
  __typename?: 'CrushAppSessionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CrushAppSessionObjectType>;
};

export type CrushAppSessionObjectType = {
  __typename?: 'CrushAppSessionObjectType';
  animalType?: Maybe<AnimalType>;
  animals?: Maybe<Array<Animal>>;
  animalsNotSaved?: Maybe<Array<Maybe<CrushAnimalNotSaved>>>;
  businessUnit?: Maybe<BusinessUnit>;
  createdAt: Scalars['DateTime'];
  groupsNotSaved?: Maybe<Array<Maybe<CrushGroupsNotSaved>>>;
  id: Scalars['UUID'];
  sessionConfig?: Maybe<Scalars['GenericScalar']>;
  status?: Maybe<CrushAppSessionStatus>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
};

/** An enumeration. */
export enum CrushAppSessionStatus {
  Deleted = 'DELETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Saved = 'SAVED',
  SavedWithErrors = 'SAVED_WITH_ERRORS'
}

export type CrushAppSnoozeAnimalAlertItem = {
  animalAlerts?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  remindAt: Scalars['Date'];
};

export type CrushGroupsNotSaved = {
  __typename?: 'CrushGroupsNotSaved';
  code: Scalars['String'];
  errorMessage: Scalars['String'];
  field: Scalars['String'];
  index: Scalars['Int'];
};

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String'];
  country?: Maybe<Country>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DashboardObjectType = {
  __typename?: 'DashboardObjectType';
  charts: Array<ChartObjectType>;
  filters?: Maybe<Array<Maybe<FilterObjectType>>>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DeleteActivityBulkInput = {
  activities?: InputMaybe<Array<Scalars['UUID']>>;
  animals?: InputMaybe<Array<Scalars['UUID']>>;
  businessUnit?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DeleteActivityBulkPayload = {
  __typename?: 'DeleteActivityBulkPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteAnimalFilterInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeleteAnimalFilterPayload = {
  __typename?: 'DeleteAnimalFilterPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteAnimalsMedicineCourseInput = {
  animals?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  course: Scalars['UUID'];
};

export type DeleteAnimalsMedicineCoursePayload = {
  __typename?: 'DeleteAnimalsMedicineCoursePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteBankAccountInput = {
  bankAccount: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DeleteBankAccountPayload = {
  __typename?: 'DeleteBankAccountPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type DeleteBankDetailsInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeleteBankDetailsPayload = {
  __typename?: 'DeleteBankDetailsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteBusinessUnitAccreditationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeleteBusinessUnitAccreditationPayload = {
  __typename?: 'DeleteBusinessUnitAccreditationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteBusinessUnitTargetInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids: Array<InputMaybe<Scalars['Int']>>;
};

export type DeleteBusinessUnitTargetPayload = {
  __typename?: 'DeleteBusinessUnitTargetPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteCrushAppSessionInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  user: Scalars['Int'];
};

/** delete a crush session object with session config only */
export type DeleteCrushAppSessionPayload = {
  __typename?: 'DeleteCrushAppSessionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteDeliveryAddressInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeleteDeliveryAddressPayload = {
  __typename?: 'DeleteDeliveryAddressPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteDeliveryAnimalsInput = {
  animals: Array<Scalars['ID']>;
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  delivery: Scalars['ID'];
};

/**
 * Remove animals from a delivery regardless of where that animal is grouped.
 * The animal record will be maintained with respect to the lifecycle choice
 * made when attaching the animal.  The typical case is that animals created
 * with deliverNewAnimal will be deleted from the database as they are
 * unattached.
 */
export type DeleteDeliveryAnimalsPayload = {
  __typename?: 'DeleteDeliveryAnimalsPayload';
  animals?: Maybe<Array<Animal>>;
  clientMutationId?: Maybe<Scalars['String']>;
  delivery?: Maybe<DeliveryType>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteDeliveryInput = {
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  delivery: Scalars['ID'];
};

/**
 * Delete a delivery.  A delivery can only be deleted before it is committed;
 * otherwise you must undo.  Note that on an inward delivery this will delete
 * all associated animals and transactions whether they were created for the
 * delivery or not.  The client is responsible for perfoming any special
 * behaviour for animals that should not be deleted.
 */
export type DeleteDeliveryPayload = {
  __typename?: 'DeleteDeliveryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteDiscountGridInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  discountGridId: Scalars['Int'];
};

export type DeleteDiscountGridPayload = {
  __typename?: 'DeleteDiscountGridPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteDistributionListInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeleteDistributionListPayload = {
  __typename?: 'DeleteDistributionListPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteFarmSystemInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  farmSystem: Scalars['Int'];
};

export type DeleteFarmSystemPayload = {
  __typename?: 'DeleteFarmSystemPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteFieldImageInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of field image */
  id: Scalars['UUID'];
};

export type DeleteFieldImagePayload = {
  __typename?: 'DeleteFieldImagePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteFieldInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export type DeleteFieldPayload = {
  __typename?: 'DeleteFieldPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteFinancialTransactionInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** Deletes a financial transaction */
export type DeleteFinancialTransactionPayload = {
  __typename?: 'DeleteFinancialTransactionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteGroupImageInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of group image */
  id: Scalars['UUID'];
};

export type DeleteGroupImagePayload = {
  __typename?: 'DeleteGroupImagePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  producerGroup: Scalars['Int'];
};

export type DeleteGroupPayload = {
  __typename?: 'DeleteGroupPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteGroupWithAnimalsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
};

export type DeleteGroupWithAnimalsPayload = {
  __typename?: 'DeleteGroupWithAnimalsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteLiveSessionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export type DeleteLiveSessionPayload = {
  __typename?: 'DeleteLiveSessionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteMedicineCourseInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export type DeleteMedicineCoursePayload = {
  __typename?: 'DeleteMedicineCoursePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteMedicineCourseStageInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export type DeleteMedicineCourseStagePayload = {
  __typename?: 'DeleteMedicineCourseStagePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeletePostInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  post?: InputMaybe<Scalars['Int']>;
};

export type DeletePostPayload = {
  __typename?: 'DeletePostPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteRegularWithdrawalInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  regularWithdrawal: Scalars['Int'];
};

export type DeleteRegularWithdrawalPayload = {
  __typename?: 'DeleteRegularWithdrawalPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type DeleteSireInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export type DeleteSirePayload = {
  __typename?: 'DeleteSirePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sire?: Maybe<Sire>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteTagInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  tag: Scalars['ID'];
};

/** Remove tag from the schema. */
export type DeleteTagPayload = {
  __typename?: 'DeleteTagPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteUserFromFarmInput = {
  businessUnitUser: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DeleteUserFromFarmPayload = {
  __typename?: 'DeleteUserFromFarmPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteWeightInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Remove an existing measured weight. */
export type DeleteWeightPayload = {
  __typename?: 'DeleteWeightPayload';
  animal?: Maybe<Animal>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeliverAnimalOutInput = {
  animal: Scalars['ID'];
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  delivery: Scalars['ID'];
  destinationContact?: InputMaybe<Scalars['ID']>;
  destinationPartner?: InputMaybe<Scalars['ID']>;
  destinationPartnerAddress?: InputMaybe<Scalars['ID']>;
  reattach?: InputMaybe<Scalars['Boolean']>;
};

/** Preapre an animal on an outward delivery.  See deliverAnimalsOut. */
export type DeliverAnimalOutPayload = {
  __typename?: 'DeliverAnimalOutPayload';
  animal?: Maybe<Animal>;
  clientMutationId?: Maybe<Scalars['String']>;
  delivery?: Maybe<DeliveryType>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeliverAnimalsOutInput = {
  animals: Array<Scalars['ID']>;
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  delivery: Scalars['ID'];
  destinationContact?: InputMaybe<Scalars['ID']>;
  destinationPartner?: InputMaybe<Scalars['ID']>;
  destinationPartnerAddress?: InputMaybe<Scalars['ID']>;
  reattach?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Preapre an animal on an outward delivery.  The animal must be created
 * already.  The delivery source is not specified; it's assumed from the
 * animal's current properties.  This API is addative: it will not remove any
 * animals. See commitDelivery for nuances of any such behaviour.
 *
 * If using `reattach` take great care that you are sending the proper
 * addresses you want the animal to be associated to.  If the addresses are
 * empty then the animal will be moved to the default consignment.
 */
export type DeliverAnimalsOutPayload = {
  __typename?: 'DeliverAnimalsOutPayload';
  animals?: Maybe<Array<Animal>>;
  clientMutationId?: Maybe<Scalars['String']>;
  delivery?: Maybe<DeliveryType>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeliverExistingAnimalInput = {
  animal: Scalars['ID'];
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  delivery: Scalars['ID'];
  managed?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Prepare an animal on an inward delivery.  The animal is already created but
 * still stored on the delivery for later editing.  For a pull delivery a
 * different mutation is needed.
 *
 * This is effectively a backwards compatibility feature in that (some) legacy
 * animals will be able to attach to deliveries retroactively.  You should
 * prefer the other mutations where possible.
 *
 * The attachment is configured by trying to find existing movement structures
 * which will now become owned by the delivery, for example the DOA activity
 * and initial move on record.  This is pretty risky, hence the recommendation
 * to use other means to create and move on animals.
 *
 * The source for the animal is determined by the previous keeper record if
 * there is one.
 */
export type DeliverExistingAnimalPayload = {
  __typename?: 'DeliverExistingAnimalPayload';
  animal?: Maybe<Animal>;
  clientMutationId?: Maybe<Scalars['String']>;
  delivery?: Maybe<DeliveryType>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeliverExistingAnimalsInput = {
  animals?: InputMaybe<Array<Scalars['ID']>>;
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  delivery: Scalars['ID'];
  managed?: InputMaybe<Scalars['Boolean']>;
};

/** See deliverExistingAnimal. */
export type DeliverExistingAnimalsPayload = {
  __typename?: 'DeliverExistingAnimalsPayload';
  animals?: Maybe<Animal>;
  clientMutationId?: Maybe<Scalars['String']>;
  delivery?: Maybe<DeliveryType>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeliverNewAnimalInput = {
  alternativeId?: InputMaybe<Scalars['String']>;
  animalId?: InputMaybe<Scalars['UUID']>;
  animalType: Scalars['String'];
  birthWeight?: InputMaybe<Scalars['Decimal']>;
  breeds: Array<Scalars['ID']>;
  brucellosisId?: InputMaybe<Scalars['String']>;
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  conditions?: InputMaybe<Array<Scalars['ID']>>;
  dam?: InputMaybe<Scalars['ID']>;
  dateMovedToFarm?: InputMaybe<Scalars['DateTime']>;
  deathDestinationAddress?: InputMaybe<Scalars['String']>;
  deathDestinationName?: InputMaybe<Scalars['String']>;
  deathDestinationPostcode?: InputMaybe<Scalars['String']>;
  deathDisposalCost?: InputMaybe<Scalars['Decimal']>;
  deathReason?: InputMaybe<Scalars['String']>;
  delivery: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  dob: Scalars['DateTime'];
  eId?: InputMaybe<Scalars['String']>;
  field: Scalars['ID'];
  group?: InputMaybe<Scalars['ID']>;
  herdDoggId?: InputMaybe<Scalars['String']>;
  isCastrated?: InputMaybe<Scalars['Boolean']>;
  isDead: Scalars['Boolean'];
  isMale: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  passportNumber: Scalars['String'];
  pedigreeId?: InputMaybe<Scalars['String']>;
  /** Used as the consignment sourceContact for the consignment; provided for compatibility. */
  previousKeeper?: InputMaybe<Scalars['ID']>;
  purchasePrice?: InputMaybe<Scalars['Decimal']>;
  sireGroup?: InputMaybe<Scalars['ID']>;
  sourceContact?: InputMaybe<Scalars['ID']>;
  tagValues?: InputMaybe<Array<AnimalTagAssignmentInputType>>;
  tattoo?: InputMaybe<Scalars['String']>;
  trichId?: InputMaybe<Scalars['String']>;
  tsuBarcode?: InputMaybe<Scalars['String']>;
  uhfId?: InputMaybe<Scalars['String']>;
  visualId?: InputMaybe<Scalars['String']>;
};

/**
 * Create an animal as part of a delivery.  This is effectively a create and
 * attach.
 *
 * The source for the generated consignment is determined from the source
 * contact or, if not given, the previous keeper (both of which reference a
 * Contact).  Source contact is the preferred means since the source contact
 * will overwrite the previous keeper anyway.  Previous keeper remains for
 * strict compatibility.  If no sources are provided then the delivery default
 * source will be used on commit.
 */
export type DeliverNewAnimalPayload = {
  __typename?: 'DeliverNewAnimalPayload';
  animal?: Maybe<Animal>;
  clientMutationId?: Maybe<Scalars['String']>;
  delivery?: Maybe<DeliveryType>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeliverPulledAnimalInput = {
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  delivery: Scalars['ID'];
  identifiers: Array<PulledAnimalIdentifierInput>;
  sourcePartner: Scalars['ID'];
  sourcePartnerAddress?: InputMaybe<Scalars['ID']>;
};

/**
 * Attach an animal reference to a pull delivery.  The animal need not be
 * created on farm as yet; we will figure out an animal to pull from the
 * partner farm.
 */
export type DeliverPulledAnimalPayload = {
  __typename?: 'DeliverPulledAnimalPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  delivery?: Maybe<DeliveryType>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeliveryAddressInterface = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  id: Scalars['ID'];
  locationId?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  unitName?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum DeliveryAddressLocationType {
  Abattoir = 'ABATTOIR',
  Farm = 'FARM'
}

export type DeliveryAddressType = DeliveryAddressInterface & {
  __typename?: 'DeliveryAddressType';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  farm?: Maybe<BusinessUnit>;
  id: Scalars['ID'];
  isDeleted: Scalars['Boolean'];
  locationId?: Maybe<Scalars['String']>;
  locationType?: Maybe<DeliveryAddressLocationType>;
  pointLocation?: Maybe<Array<Maybe<Scalars['Float']>>>;
  postcode?: Maybe<Scalars['String']>;
  primary: Scalars['Boolean'];
  unitName?: Maybe<Scalars['String']>;
};

export type DeliveryAffidavitConnection = {
  __typename?: 'DeliveryAffidavitConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DeliveryAffidavitEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DeliveryAffidavit` and its cursor. */
export type DeliveryAffidavitEdge = {
  __typename?: 'DeliveryAffidavitEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DeliveryAffidavitType>;
};

export type DeliveryAffidavitType = {
  __typename?: 'DeliveryAffidavitType';
  name: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

/**
 * Associates error data to a specific animal record.  Animals may only be on
 * a delivery once so it's not strictly necessary to know which consignment or
 * animal record they are associated to.
 */
export type DeliveryAnimalErrorType = {
  __typename?: 'DeliveryAnimalErrorType';
  animalId?: Maybe<Scalars['ID']>;
  errors?: Maybe<Array<ValidationError>>;
  passportNumber: Scalars['String'];
};

export type DeliveryConnection = {
  __typename?: 'DeliveryConnection';
  count?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DeliveryEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type DeliveryConsignmentConnection = {
  __typename?: 'DeliveryConsignmentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DeliveryConsignmentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DeliveryConsignment` and its cursor. */
export type DeliveryConsignmentEdge = {
  __typename?: 'DeliveryConsignmentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DeliveryConsignmentType>;
};

export type DeliveryConsignmentType = {
  __typename?: 'DeliveryConsignmentType';
  animalCount: Scalars['Int'];
  animals?: Maybe<AnimalConnection2>;
  /** See source. */
  destination?: Maybe<DeliveryLocationType>;
  id: Scalars['ID'];
  /** Source, default source, or committed source depending on state.  Some properties may be hidden due to permissions. */
  source?: Maybe<DeliveryLocationType>;
};


export type DeliveryConsignmentTypeAnimalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export enum DeliveryDirectionEnum {
  Inward = 'INWARD',
  Outward = 'OUTWARD'
}

/** A Relay edge containing a `Delivery` and its cursor. */
export type DeliveryEdge = {
  __typename?: 'DeliveryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DeliveryType>;
};

/**
 * Static data for a delivery location.  This is populated by the
 * transactional data copied from the master data of contact or partner on
 * commit of the delivery.
 */
export type DeliveryLocationDetailsObjectType = {
  __typename?: 'DeliveryLocationDetailsObjectType';
  address: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  postcode: Scalars['String'];
};

/**
 * An instrumented list type which indicates whether the list of locations has
 * been truncated.  The underlying data source here will be addresses
 * associated to consignments within the delivery.
 */
export type DeliveryLocationSummaryType = {
  __typename?: 'DeliveryLocationSummaryType';
  hasMore: Scalars['Boolean'];
  locations?: Maybe<Array<DeliveryLocationType>>;
};

/**
 * Source or destination of a delivery.  Certain fields would only be visible
 * on an initiator since they represent stateful data owned by the initiator,
 * however there are statically encoded fields which do not change after
 * commit.  These details should be used once a delivery is committed.
 */
export type DeliveryLocationType = {
  __typename?: 'DeliveryLocationType';
  /** Related partner address. */
  address?: Maybe<DeliveryPartnerAddressType>;
  /** Initiator view of the contact to generate the address from.  Note that a referenced entity can change after commit. */
  contact?: Maybe<ContactObjectType>;
  /** Details are statically encoded and persist after entities have been deleted etc. */
  details: DeliveryLocationDetailsObjectType;
  /** True if the details object is expected to be accurate. */
  hasDetails: Scalars['Boolean'];
  locationType: DeliveryLocationTypeEnum;
  /** @deprecated [2023-06] Use contact instead. */
  ownerContact?: Maybe<ContactObjectType>;
  /** @deprecated [2023-06] Use partner instead. */
  ownerPartner?: Maybe<DeliveryPartnerType>;
  /** Related chain partner. */
  partner?: Maybe<DeliveryPartnerType>;
};

export enum DeliveryLocationTypeEnum {
  Contact = 'CONTACT',
  Partner = 'PARTNER'
}

/** Expensive object for deliveries. */
export type DeliveryOverviewType = {
  __typename?: 'DeliveryOverviewType';
  affidavits?: Maybe<DeliveryAffidavitConnection>;
  animalCount: Scalars['Int'];
  animalTypes?: Maybe<Array<AnimalType>>;
  animals?: Maybe<AnimalConnection2>;
  consignments?: Maybe<DeliveryConsignmentConnection>;
  delivery: DeliveryType;
};


/** Expensive object for deliveries. */
export type DeliveryOverviewTypeAffidavitsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Expensive object for deliveries. */
export type DeliveryOverviewTypeAnimalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Expensive object for deliveries. */
export type DeliveryOverviewTypeConsignmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type DeliveryPartnerAddressConnection = {
  __typename?: 'DeliveryPartnerAddressConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DeliveryPartnerAddressEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DeliveryPartnerAddress` and its cursor. */
export type DeliveryPartnerAddressEdge = {
  __typename?: 'DeliveryPartnerAddressEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DeliveryPartnerAddressType>;
};

export enum DeliveryPartnerAddressSortingEnum {
  AddressIdAsc = 'ADDRESS_ID_ASC',
  AddressNameAsc = 'ADDRESS_NAME_ASC',
  PartnerIdAsc = 'PARTNER_ID_ASC',
  PartnerNameAsc = 'PARTNER_NAME_ASC'
}

/**
 * High-level partner address to be used with a delivery.  This abastracts
 * access to specific holdings of a foreign business unit.
 */
export type DeliveryPartnerAddressType = {
  __typename?: 'DeliveryPartnerAddressType';
  id: Scalars['ID'];
  name: Scalars['String'];
  partner?: Maybe<DeliveryPartnerType>;
};

export type DeliveryPartnerConnection = {
  __typename?: 'DeliveryPartnerConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DeliveryPartnerEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DeliveryPartner` and its cursor. */
export type DeliveryPartnerEdge = {
  __typename?: 'DeliveryPartnerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DeliveryPartnerType>;
};

/** High-level contact to be used with a delivery. */
export type DeliveryPartnerType = {
  __typename?: 'DeliveryPartnerType';
  /** Limited list of addresses.  Likely you should access addresses via the deliveryPartnerAddresses api. */
  addresses?: Maybe<Array<DeliveryPartnerAddressType>>;
  code: Scalars['String'];
  id: Scalars['ID'];
};

export type DeliveryReasonConnection = {
  __typename?: 'DeliveryReasonConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DeliveryReasonEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DeliveryReason` and its cursor. */
export type DeliveryReasonEdge = {
  __typename?: 'DeliveryReasonEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DeliveryReasonType>;
};

/** Reason for a delivery. */
export type DeliveryReasonType = {
  __typename?: 'DeliveryReasonType';
  directions: Array<DeliveryDirectionEnum>;
  id: Scalars['UUID'];
  slug: Scalars['String'];
  title: Scalars['String'];
};

export enum DeliverySortingEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  NameAsc = 'NAME_ASC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum DeliveryStatusEnum {
  Committed = 'COMMITTED',
  Complete = 'COMPLETE',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Undone = 'UNDONE'
}

export enum DeliveryTaskStatusEnumType {
  Complete = 'COMPLETE',
  Created = 'CREATED',
  Failed = 'FAILED'
}

export type DeliveryTaskType = {
  __typename?: 'DeliveryTaskType';
  id: Scalars['ID'];
  status: DeliveryTaskStatusEnumType;
};

/**
 * A business unit's view on a delivery.  The viewer may be a partner or the
 * initiator.  This is a type which is designed to be listable so it's
 * generally cheap to render.
 */
export type DeliveryType = {
  __typename?: 'DeliveryType';
  /**
   * Sources across each consignment applicable to the viewing participant.
   * @deprecated [2024-04] invalid experiment
   */
  actualSources?: Maybe<Array<DeliveryLocationType>>;
  animalCount: Scalars['Int'];
  animalTypes?: Maybe<Array<AnimalType>>;
  arrivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  /** Default delivery destination.  See defaultSource. */
  defaultDestination?: Maybe<DeliveryLocationType>;
  /** Default delivery source.  Partners do not have default locations! */
  defaultSource?: Maybe<DeliveryLocationType>;
  /**
   * Default delivery destination.  See source.
   * @deprecated [2024-02] misleading, use defaultDestination
   */
  destination?: Maybe<DeliveryLocationType>;
  destinationSummary: DeliveryLocationSummaryType;
  /** Direction relative to the viewing business unit. */
  direction: DeliveryDirectionEnum;
  id: Scalars['ID'];
  name: Scalars['String'];
  reason?: Maybe<DeliveryReasonType>;
  sentAt?: Maybe<Scalars['DateTime']>;
  /**
   * Default delivery source.  Partners do not have default locations!
   * @deprecated [2024-02] misleading, use defaultSource
   */
  source?: Maybe<DeliveryLocationType>;
  sourceSummary: DeliveryLocationSummaryType;
  status: DeliveryStatusEnum;
  updatedAt: Scalars['DateTime'];
};

export type DiagnosePregnancyInput = {
  animal: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  date: Scalars['DateTime'];
  daysSinceConception?: InputMaybe<Scalars['Int']>;
  isPositive: Scalars['Boolean'];
  numOffspring?: InputMaybe<Scalars['Int']>;
  sire?: InputMaybe<Scalars['ID']>;
};

/**
 * Log a pregnancy test for the animal.  Animals own pregnancy status is
 * reflected and history is logged.
 */
export type DiagnosePregnancyPayload = {
  __typename?: 'DiagnosePregnancyPayload';
  animal?: Maybe<Animal>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Deprecated.  RFL. */
export type DiscountGrid = {
  __typename?: 'DiscountGrid';
  businessUnit?: Maybe<BusinessUnit>;
  createdAt: Scalars['DateTime'];
  file: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DisposeMedicineLineItemInput = {
  amount?: InputMaybe<Scalars['Float']>;
  businessUnit?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  lineItem?: InputMaybe<Scalars['UUID']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type DisposeMedicineLineItemPayload = {
  __typename?: 'DisposeMedicineLineItemPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  lineItem?: Maybe<LineItemType>;
};

export type DistributionListConnection = {
  __typename?: 'DistributionListConnection';
  count?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DistributionListEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DistributionList` and its cursor. */
export type DistributionListEdge = {
  __typename?: 'DistributionListEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DistributionListObjectType>;
};

export type DistributionListObjectType = {
  __typename?: 'DistributionListObjectType';
  businessUnit: BusinessUnit;
  id: Scalars['ID'];
  name: Scalars['String'];
  suppliers?: Maybe<Array<Maybe<SearchBusinessUnit>>>;
};

/** Debugging information for the current query. */
export type DjangoDebug = {
  __typename?: 'DjangoDebug';
  /** Raise exceptions for this API query. */
  exceptions?: Maybe<Array<Maybe<DjangoDebugException>>>;
  /** Executed SQL queries for this API query. */
  sql?: Maybe<Array<Maybe<DjangoDebugSql>>>;
};

/** Represents a single exception raised. */
export type DjangoDebugException = {
  __typename?: 'DjangoDebugException';
  /** The class of the exception */
  excType: Scalars['String'];
  /** The message of the exception */
  message: Scalars['String'];
  /** The stack trace */
  stack: Scalars['String'];
};

/** Represents a single database query made to a Django managed DB. */
export type DjangoDebugSql = {
  __typename?: 'DjangoDebugSQL';
  /** The Django database alias (e.g. 'default'). */
  alias: Scalars['String'];
  /** Duration of this database query in seconds. */
  duration: Scalars['Float'];
  /** Postgres connection encoding if available. */
  encoding?: Maybe<Scalars['String']>;
  /** Whether this database query was a SELECT. */
  isSelect: Scalars['Boolean'];
  /** Whether this database query took more than 10 seconds. */
  isSlow: Scalars['Boolean'];
  /** Postgres isolation level if available. */
  isoLevel?: Maybe<Scalars['String']>;
  /** JSON encoded database query parameters. */
  params: Scalars['String'];
  /** The raw SQL of this query, without params. */
  rawSql: Scalars['String'];
  /** The actual SQL sent to this database. */
  sql?: Maybe<Scalars['String']>;
  /** Start time of this database query. */
  startTime: Scalars['Float'];
  /** Stop time of this database query. */
  stopTime: Scalars['Float'];
  /** Postgres transaction ID if available. */
  transId?: Maybe<Scalars['String']>;
  /** Postgres transaction status if available. */
  transStatus?: Maybe<Scalars['String']>;
  /** The type of database being used (e.g. postrgesql, mysql, sqlite). */
  vendor: Scalars['String'];
};

export type DownloadConnection = {
  __typename?: 'DownloadConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DownloadEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Download` and its cursor. */
export type DownloadEdge = {
  __typename?: 'DownloadEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DownloadObjectType>;
};

export type DownloadLink = {
  __typename?: 'DownloadLink';
  link?: Maybe<Scalars['String']>;
};

export type DownloadObjectType = {
  __typename?: 'DownloadObjectType';
  createdAt: Scalars['DateTime'];
  downloadedFile?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  status: DownloadStatus;
  updatedAt: Scalars['DateTime'];
};

/**
 * Forward reference to download a chart.  Pass variables to the
 * createDownload api.
 */
export type DownloadOptionsObjectType = {
  __typename?: 'DownloadOptionsObjectType';
  slug: Scalars['String'];
  variables: Scalars['GenericScalar'];
};

/** An enumeration. */
export enum DownloadStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING'
}

export type EditBankAccountInput = {
  accountInfo?: InputMaybe<Scalars['GenericScalar']>;
  balanceAccount: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  token: Scalars['String'];
};

export type EditBankAccountPayload = {
  __typename?: 'EditBankAccountPayload';
  bankAccount?: Maybe<BankAccountType>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type EditDeliveryAddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  country: Scalars['Int'];
  farm: Scalars['Int'];
  id: Scalars['Int'];
  locationId?: InputMaybe<Scalars['String']>;
  /** Available: FARM, ABATTOIR. Default: FARM */
  locationType?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  unitName: Scalars['String'];
};

export type EditDeliveryAddressPayload = {
  __typename?: 'EditDeliveryAddressPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryAddress?: Maybe<DeliveryAddressType>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type EditProducerGroupInput = {
  backgroundPhotoFile?: InputMaybe<Scalars['Upload']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  deletedAdmins?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  deletedMembers?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  description?: InputMaybe<Scalars['String']>;
  invitedMembers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  newAdmins?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  newMembers?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  producerGroup: Scalars['Int'];
  profilePhotoFile?: InputMaybe<Scalars['Upload']>;
};

export type EditProducerGroupPayload = {
  __typename?: 'EditProducerGroupPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  producerGroup?: Maybe<ProducerGroupType>;
};

export type EditRegularWithdrawalInput = {
  amount?: InputMaybe<Scalars['Float']>;
  bankAccount?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['Int']>;
  /** Available: MANUAL, DAILY, WEEKLY, MONTHLY. Default: MONTHLY */
  recurringTime?: InputMaybe<Scalars['String']>;
  regularWithdrawal: Scalars['Int'];
};

export type EditRegularWithdrawalPayload = {
  __typename?: 'EditRegularWithdrawalPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  regularWithdrawal?: Maybe<RegularWithdrawalType>;
};

/** An enumeration. */
export enum EmptyStateButton {
  AddConnectedSystem = 'ADD_CONNECTED_SYSTEM',
  AnimalListView = 'ANIMAL_LIST_VIEW',
  BcmsRequestCredentials = 'BCMS_REQUEST_CREDENTIALS',
  Bluetooth = 'BLUETOOTH',
  ConnectedSystems = 'CONNECTED_SYSTEMS',
  CreateGroup = 'CREATE_GROUP',
  CreateMessage = 'CREATE_MESSAGE',
  CrushMode = 'CRUSH_MODE',
  Email = 'EMAIL',
  FarmAddresses = 'FARM_ADDRESSES',
  FieldCreate = 'FIELD_CREATE',
  FieldList = 'FIELD_LIST',
  GroupListView = 'GROUP_LIST_VIEW',
  HelpCentre = 'HELP_CENTRE',
  Homepage = 'HOMEPAGE',
  LogBirth = 'LOG_BIRTH',
  MedicineCabinetAdd = 'MEDICINE_CABINET_ADD',
  MedicineCabinetView = 'MEDICINE_CABINET_VIEW',
  Messages = 'MESSAGES',
  ScanPassport = 'SCAN_PASSPORT',
  Settings = 'SETTINGS',
  Url = 'URL',
  UserManagement = 'USER_MANAGEMENT'
}

export type EmptyStateObjectType = {
  __typename?: 'EmptyStateObjectType';
  animalType?: Maybe<AnimalType>;
  button?: Maybe<EmptyStateButton>;
  buttonLabel: Scalars['String'];
  /** Required only if button is 'Url' or 'Email' */
  buttonLink: Scalars['String'];
  countries: Array<Country>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  isDisabled: Scalars['Boolean'];
  name: Scalars['String'];
  page: EmptyStatePage;
  platform: Array<Scalars['String']>;
  showButton: Scalars['Boolean'];
  text: Scalars['String'];
};

/** An enumeration. */
export enum EmptyStatePage {
  Addresses = 'ADDRESSES',
  AddressBook = 'ADDRESS_BOOK',
  Animals = 'ANIMALS',
  Connections = 'CONNECTIONS',
  DeadWeight = 'DEAD_WEIGHT',
  Fields = 'FIELDS',
  Groups = 'GROUPS',
  LogBirth = 'LOG_BIRTH',
  Medicines = 'MEDICINES',
  TradingLiveweight = 'TRADING_LIVEWEIGHT'
}

export type Entity = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type EntityAlertConnection = {
  __typename?: 'EntityAlertConnection';
  activeAlertsCount?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EntityAlertEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};


export type EntityAlertConnectionActiveAlertsCountArgs = {
  businessUnitId: Scalars['Int'];
};

/** A Relay edge containing a `EntityAlert` and its cursor. */
export type EntityAlertEdge = {
  __typename?: 'EntityAlertEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EntityAlertInterface>;
};

export type EntityAlertInterface = {
  alert: AlertObjectType;
  entityType: Scalars['String'];
  id: Scalars['UUID'];
};

export type EstimatedFuturePriceType = {
  __typename?: 'EstimatedFuturePriceType';
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  futurePrice?: Maybe<Scalars['Decimal']>;
};

export type ExportAnimalsAsyncInput = {
  animalTagIds?: InputMaybe<Array<Scalars['ID']>>;
  animalTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Leave this field empty to get all business unit animals. */
  animals?: InputMaybe<Array<Scalars['UUID']>>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** If True - returns only archived, otherwise - only alive and on-farm.Ignored if animals are sent explicitly. */
  isArchived?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
};

/** Deprecated version of animal export. */
export type ExportAnimalsAsyncPayload = {
  __typename?: 'ExportAnimalsAsyncPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  export?: Maybe<ExportResult>;
};

export type ExportResult = {
  __typename?: 'ExportResult';
  id: Scalars['ID'];
  isReady: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type FarmAnimalDetailInput = {
  accreditations: Array<InputMaybe<Scalars['Int']>>;
  animalNumber?: InputMaybe<Scalars['Int']>;
  animalType: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  conventional?: InputMaybe<Scalars['Boolean']>;
  extensive?: InputMaybe<Scalars['Boolean']>;
  farm: Scalars['Int'];
  healthStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  intensive?: InputMaybe<Scalars['Boolean']>;
  organic?: InputMaybe<Scalars['Boolean']>;
  pedigree?: InputMaybe<Scalars['Boolean']>;
  /** Available: DAIRY_BEEF_FINISHER, cattle, DAIRY_BEEF_REARER, cattle, DAIRY_BEEF_GROWER, cattle, DAIRY_BEEF_GROWER_FINISHER, cattle, SUCKLER_BORN_AND_BRED, cattle, SUCKLER_FINISHER, cattle, SUCKLER_GROWER_FINISHER, cattle, BULL_BEEF, cattle, WAGU, cattle, DAIRY_SHEEP, sheep, UPLAND_BREEDING_EWE_FLOCK, sheep, UPLAND_BREEDING_EWE_AND_LAMB_FINISHER, sheep, HILL_BREEDING_EWE_FLOCK, sheep, HILL_BREEDING_EWE_AND_LAMB_FINISHER, sheep, UPLAND_STORE_LAMB_FINISHER, sheep, STORE_LAMB_FINISHER, sheep, LOWLAND_BREEDING_EWE_FLOCK, sheep, LOWLAND_BREEDING_EWE_AND_LAMB_FINISHER, sheep, LOWLAND_STORE_LAMB_FINISHER, sheep, OUTDOOR_BRED, pigs, OUTDOOR_REARED, pigs, INDOOR_BORN_AND_BRED, pigs, INDOOR_FINISHED, pigs, BREEDING, pigs, FINISHER, pigs, DAIRY_GOAT, goats. Default: DAIRY_BEEF_FINISHER */
  systemType?: InputMaybe<Scalars['String']>;
};

export type FarmAnimalDetailPayload = {
  __typename?: 'FarmAnimalDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  farmAnimalDetail?: Maybe<FarmAnimalType>;
};

export type FarmAnimalType = {
  __typename?: 'FarmAnimalType';
  accreditations: Array<Accreditation>;
  animalNumber?: Maybe<Scalars['Int']>;
  animalType?: Maybe<AnimalType>;
  conventional: Scalars['Boolean'];
  extensive: Scalars['Boolean'];
  farm?: Maybe<BusinessUnit>;
  farmAnimalTypeAccreditations: Array<FarmAnimalTypeAccreditation>;
  healthStatuses?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  intensive: Scalars['Boolean'];
  organic: Scalars['Boolean'];
  pedigree: Scalars['Boolean'];
  systemType?: Maybe<FarmAnimalTypeSystemType>;
};

export type FarmAnimalTypeAccreditation = {
  __typename?: 'FarmAnimalTypeAccreditation';
  accreditation: Accreditation;
  dateUploaded: Scalars['Date'];
  expires?: Maybe<Scalars['Date']>;
  farmAnimalType: FarmAnimalType;
  id: Scalars['ID'];
  isApproved: Scalars['Boolean'];
  membershipId?: Maybe<Scalars['String']>;
  uploadedBy?: Maybe<User>;
};

/** An enumeration. */
export enum FarmAnimalTypeSystemType {
  Breeding = 'BREEDING',
  BullBeef = 'BULL_BEEF',
  DairyBeefFinisher = 'DAIRY_BEEF_FINISHER',
  DairyBeefGrower = 'DAIRY_BEEF_GROWER',
  DairyBeefGrowerFinisher = 'DAIRY_BEEF_GROWER_FINISHER',
  DairyBeefRearer = 'DAIRY_BEEF_REARER',
  DairyGoat = 'DAIRY_GOAT',
  DairySheep = 'DAIRY_SHEEP',
  Finisher = 'FINISHER',
  HillBreedingEweAndLambFinisher = 'HILL_BREEDING_EWE_AND_LAMB_FINISHER',
  HillBreedingEweFlock = 'HILL_BREEDING_EWE_FLOCK',
  IndoorBornAndBred = 'INDOOR_BORN_AND_BRED',
  IndoorFinished = 'INDOOR_FINISHED',
  LowlandBreedingEweAndLambFinisher = 'LOWLAND_BREEDING_EWE_AND_LAMB_FINISHER',
  LowlandBreedingEweFlock = 'LOWLAND_BREEDING_EWE_FLOCK',
  LowlandStoreLambFinisher = 'LOWLAND_STORE_LAMB_FINISHER',
  OutdoorBred = 'OUTDOOR_BRED',
  OutdoorReared = 'OUTDOOR_REARED',
  StoreLambFinisher = 'STORE_LAMB_FINISHER',
  SucklerBornAndBred = 'SUCKLER_BORN_AND_BRED',
  SucklerFinisher = 'SUCKLER_FINISHER',
  SucklerGrowerFinisher = 'SUCKLER_GROWER_FINISHER',
  UplandBreedingEweAndLambFinisher = 'UPLAND_BREEDING_EWE_AND_LAMB_FINISHER',
  UplandBreedingEweFlock = 'UPLAND_BREEDING_EWE_FLOCK',
  UplandStoreLambFinisher = 'UPLAND_STORE_LAMB_FINISHER',
  Wagu = 'WAGU'
}

export type FarmDetailChoices = {
  __typename?: 'FarmDetailChoices';
  healthStatuses?: Maybe<Array<Maybe<FarmDetailHealthItem>>>;
  systemTypes?: Maybe<Array<Maybe<FarmDetailSystemItem>>>;
};

export type FarmDetailHealthItem = {
  __typename?: 'FarmDetailHealthItem';
  animalType?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type FarmDetailSystemItem = {
  __typename?: 'FarmDetailSystemItem';
  animalType?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type FarmMovementConnection = {
  __typename?: 'FarmMovementConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FarmMovementEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FarmMovement` and its cursor. */
export type FarmMovementEdge = {
  __typename?: 'FarmMovementEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<FarmMovementType>;
};

export enum FarmMovementSortingEnumType {
  AnimalId = 'ANIMAL_ID',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  MovementId = 'MOVEMENT_ID'
}

/** A farms own movement. */
export type FarmMovementType = {
  __typename?: 'FarmMovementType';
  destination?: Maybe<MovementLocationType>;
  id: Scalars['ID'];
  movedAt: Scalars['DateTime'];
  movementType: MovementType;
  passportNumber: Scalars['String'];
  source?: Maybe<MovementLocationType>;
};

export type FarmPlanImportXlsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** BusinessUnit ID */
  farm?: InputMaybe<Scalars['Int']>;
  xlsFile?: InputMaybe<Scalars['Upload']>;
};

export type FarmPlanImportXlsPayload = {
  __typename?: 'FarmPlanImportXLSPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  task?: Maybe<FarmSystemTaskType>;
};

/** An enumeration. */
export enum FarmSystemTaskAction {
  ImportActivities = 'IMPORT_ACTIVITIES',
  ImportAnimals = 'IMPORT_ANIMALS'
}

/** An enumeration. */
export enum FarmSystemTaskStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  ManualStart = 'MANUAL_START',
  Pending = 'PENDING'
}

export type FarmSystemTaskType = {
  __typename?: 'FarmSystemTaskType';
  action: FarmSystemTaskAction;
  createdItems?: Maybe<Array<Maybe<ProcessedItem>>>;
  doneAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isAborted: Scalars['Boolean'];
  newNumberItems: Scalars['Int'];
  processedNumberItems: Scalars['Int'];
  producedFromTask?: Maybe<FarmSystemTaskType>;
  producedTask?: Maybe<FarmSystemTaskType>;
  status: FarmSystemTaskStatus;
  totalNumberItems: Scalars['Int'];
  uncreatedItems?: Maybe<Array<Maybe<UnprocessedItem>>>;
  updatedItems?: Maybe<Array<Maybe<ProcessedItem>>>;
  updatedNumberItems: Scalars['Int'];
};

export type FarmSystemType = {
  credentials?: Maybe<Scalars['GenericScalar']>;
  errorMessage?: Maybe<Scalars['String']>;
  farm?: Maybe<BusinessUnit>;
  id?: Maybe<Scalars['Int']>;
  integrationSystem?: Maybe<IntegrationSystemType>;
  status?: Maybe<Scalars['String']>;
};

export type FavoriteActivityTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type FavoriteActivityTemplatePayload = {
  __typename?: 'FavoriteActivityTemplatePayload';
  activityTemplate?: Maybe<ActivityTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

/** An enumeration. */
export enum FavouriteItemType {
  Activity = 'ACTIVITY',
  Report = 'REPORT'
}

export type FavouriteObjectType = {
  __typename?: 'FavouriteObjectType';
  businessUnit?: Maybe<BusinessUnit>;
  id: Scalars['UUID'];
  itemDescription: Scalars['String'];
  itemId: Scalars['String'];
  itemName: Scalars['String'];
  itemType: FavouriteItemType;
  user: User;
};

export type FeatureCollectionInputType = {
  features?: InputMaybe<Array<InputMaybe<FeatureInputType>>>;
  type?: InputMaybe<Scalars['String']>;
};

export type FeatureCollectionObjectType = {
  __typename?: 'FeatureCollectionObjectType';
  features?: Maybe<Array<Maybe<FeatureObjectType>>>;
  type?: Maybe<Scalars['String']>;
};

export type FeatureInputType = {
  geometry?: InputMaybe<GeometryInputType>;
  properties?: InputMaybe<Scalars['JSONString']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FeatureObjectType = {
  __typename?: 'FeatureObjectType';
  geometry?: Maybe<GeometryObjectType>;
  properties?: Maybe<Scalars['JSONString']>;
  type?: Maybe<Scalars['String']>;
};

export type Field = {
  __typename?: 'Field';
  /** Active animal alerts for this field. */
  animalAlerts?: Maybe<Array<Maybe<AnimalAlertObjectType>>>;
  /** Amount of active animal alerts for this field. */
  animalAlertsCount?: Maybe<Scalars['Int']>;
  /** @deprecated [2024-01] Use animals connection instead. */
  animals?: Maybe<Array<Maybe<Animal>>>;
  avgAge?: Maybe<Scalars['Decimal']>;
  avgDlwg?: Maybe<Scalars['Decimal']>;
  avgEstimatedWeight?: Maybe<Scalars['Decimal']>;
  avgRecordedWeight?: Maybe<Scalars['Decimal']>;
  batches?: Maybe<Array<Maybe<Batch>>>;
  businessUnitId?: Maybe<Scalars['String']>;
  colour?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fieldArea?: Maybe<FeatureCollectionObjectType>;
  fieldDensity?: Maybe<Scalars['Decimal']>;
  fieldSize?: Maybe<Scalars['Float']>;
  groupsCount?: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  image?: Maybe<Scalars['String']>;
  images: Array<FieldImage>;
  isDeleted: Scalars['Boolean'];
  isHoldingPen: Scalars['Boolean'];
  isOrganic: Scalars['Boolean'];
  isYard: Scalars['Boolean'];
  itemtransactionSet: Array<ItemTransactionType>;
  location?: Maybe<DeliveryAddressType>;
  name: Scalars['String'];
  notifications?: Maybe<NotificationConnection>;
  pastureTypes: Array<PastureType>;
  size?: Maybe<Scalars['Float']>;
  sizeUnit: FieldSizeUnit;
  summaryMetrics?: Maybe<Array<Maybe<SummaryMetrics>>>;
  tasks?: Maybe<TaskConnection>;
  tasksCount?: Maybe<Scalars['Int']>;
};


export type FieldNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type FieldTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type FieldImage = {
  __typename?: 'FieldImage';
  createdAt: Scalars['DateTime'];
  field: Field;
  id: Scalars['UUID'];
  image?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum FieldSizeUnit {
  Acre = 'ACRE',
  Ha = 'HA'
}

export type FilterObjectType = {
  __typename?: 'FilterObjectType';
  displayName?: Maybe<Scalars['String']>;
  filterName?: Maybe<Scalars['String']>;
  filterType?: Maybe<Scalars['String']>;
};

export type FinancialTransaction = {
  __typename?: 'FinancialTransaction';
  /** The amount of money this transaction represents. Positive values only. The transaction type decides if this is a revenue or expense for the business unit. This value is in the currency of its business unit */
  amount: Scalars['Decimal'];
  animalsCount?: Maybe<Scalars['Int']>;
  /** The name of the counterparty involved in this transaction(i.e. buyer, seller or supplier depending on record type) */
  counterparty: Scalars['String'];
  /** When this record was first created */
  createdAt: Scalars['DateTime'];
  /** The date to associate with this transaction. We use a DateTimeField to allow for more flexibility in the future and easier internationalisation. */
  date: Scalars['DateTime'];
  id: Scalars['UUID'];
  /** A short title to label this transaction */
  label: Scalars['String'];
  notes: Scalars['String'];
  recordType?: Maybe<TransactionRecordEnumType>;
  /** The total weight of the animals associated to this transaction as measured in bulk. The field exists on this model temporarily until a better place for it can be found. This value is in the unit of weight of the business unit */
  totalWeight?: Maybe<Scalars['Float']>;
  /** Animals and relevant data to the given transaction */
  transactionAnimals?: Maybe<FinancialTransactionAnimalConnection>;
  /** When this record was last updated */
  updatedAt: Scalars['DateTime'];
  valueAllocationMethod?: Maybe<ValueAllocationMethodEnumType>;
};


export type FinancialTransactionTransactionAnimalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/**
 * This object represents an animal associated with a financial transaction
 * record. It holds information about the given animal at the point in time
 * relevant to this associated transaction.
 */
export type FinancialTransactionAnimal = {
  __typename?: 'FinancialTransactionAnimal';
  /** The amount (in relevant currency) of the transaction allocated to this animal */
  allocatedValue: Scalars['Float'];
  animal?: Maybe<Animal>;
  /** When the associated weight value field was last updated. If the animal has been given more weight data since this date the weight value and allocations may need refreshing. */
  weightLastUpdated?: Maybe<Scalars['DateTime']>;
  /** The weight (in relevant unit) for this animal used to calculate its allocated value in 'by weight' scenarios */
  weightValue?: Maybe<Scalars['Float']>;
};

/** Paginated list of TransactionAnimal objects */
export type FinancialTransactionAnimalConnection = {
  __typename?: 'FinancialTransactionAnimalConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FinancialTransactionAnimalEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FinancialTransactionAnimal` and its cursor. */
export type FinancialTransactionAnimalEdge = {
  __typename?: 'FinancialTransactionAnimalEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<FinancialTransactionAnimal>;
};

/**
 * Associates an error for a financial transaction with a specific animal
 * record
 */
export type FinancialTransactionAnimalErrorObjectType = {
  __typename?: 'FinancialTransactionAnimalErrorObjectType';
  animal?: Maybe<Animal>;
  errors?: Maybe<Array<ValidationError>>;
};

export type FinancialTransactionConnection = {
  __typename?: 'FinancialTransactionConnection';
  count?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FinancialTransactionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FinancialTransaction` and its cursor. */
export type FinancialTransactionEdge = {
  __typename?: 'FinancialTransactionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<FinancialTransaction>;
};

/** An enumeration. */
export enum FinancialTransactionsSortByEnumType {
  Amount = 'AMOUNT',
  AnimalsCount = 'ANIMALS_COUNT',
  Date = 'DATE',
  Label = 'LABEL',
  RecordType = 'RECORD_TYPE'
}

/** GraphQL Scheme for django forms. */
export type FormType = {
  __typename?: 'FormType';
  choices?: Maybe<Array<Maybe<Choice>>>;
  editable?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  labelId?: Maybe<Scalars['String']>;
  maxDigits?: Maybe<Scalars['Int']>;
  maxValue?: Maybe<Scalars['Float']>;
  minValue?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type ForwardContract = {
  __typename?: 'ForwardContract';
  businessUnit?: Maybe<BusinessUnit>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  details?: Maybe<Scalars['JSONString']>;
  id: Scalars['ID'];
  offer: Offer;
  status: ForwardContractStatus;
  updatedAt: Scalars['DateTime'];
  want: OwnWant;
};

/** An enumeration. */
export enum ForwardContractStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type GeometryInputType = {
  coordinates?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['Float']>>>>>>>;
  type?: InputMaybe<Scalars['String']>;
};

export type GeometryObjectType = {
  __typename?: 'GeometryObjectType';
  coordinates?: Maybe<Array<Maybe<Array<Maybe<Array<Maybe<Scalars['Float']>>>>>>>;
  type?: Maybe<Scalars['String']>;
};

export type GlobalFoggleType = {
  __typename?: 'GlobalFoggleType';
  description: Scalars['String'];
  featureName: Scalars['String'];
  globalState?: Maybe<Scalars['Int']>;
};

export type Group = Entity & {
  __typename?: 'Group';
  ageMaxMonths?: Maybe<Scalars['Int']>;
  ageMinMonths?: Maybe<Scalars['Int']>;
  /** Active animal alerts for this group. */
  animalAlerts?: Maybe<Array<Maybe<AnimalAlertObjectType>>>;
  /** Amount of active animal alerts for this group. */
  animalAlertsCount?: Maybe<Scalars['Int']>;
  animalBreeds: Array<AnimalBreed>;
  animalType?: Maybe<AnimalType>;
  animalTypeId?: Maybe<Scalars['String']>;
  animals?: Maybe<Array<Maybe<Animal>>>;
  /** @deprecated Obsolete */
  animalsNumberCache?: Maybe<Scalars['Int']>;
  animalsOffFarmCount?: Maybe<Scalars['Int']>;
  animalsToSaleCount?: Maybe<Scalars['Int']>;
  averageAge?: Maybe<Scalars['Float']>;
  averageDobInBatch?: Maybe<Scalars['DateTime']>;
  avgDlwg?: Maybe<Scalars['Decimal']>;
  avgEstimatedWeight?: Maybe<Scalars['Decimal']>;
  avgRecordedWeight?: Maybe<Scalars['Decimal']>;
  batchDateOnFarm?: Maybe<Scalars['DateTime']>;
  businessUnit: BusinessUnit;
  businessUnitId?: Maybe<Scalars['String']>;
  businessUnitTarget?: Maybe<BusinessUnitTarget>;
  businessUnitTargetId?: Maybe<Scalars['String']>;
  category: GroupCategory;
  createdAt: Scalars['DateTime'];
  /** @deprecated Use weight_info */
  currentWeightInfo?: Maybe<GroupWeightInfo>;
  daysTillTarget?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  field?: Maybe<Field>;
  gendersInBatch?: Maybe<Scalars['String']>;
  growthRate?: Maybe<Scalars['Float']>;
  hasNotifications?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /** Count of active identified animals in the group. */
  identifiedAnimalsCount?: Maybe<Scalars['Int']>;
  images: Array<GroupImage>;
  isBatch?: Maybe<Scalars['Boolean']>;
  isDeleted: Scalars['Boolean'];
  isPurchased: Scalars['Boolean'];
  itemtransactionSet: Array<ItemTransactionType>;
  /** @deprecated Now group does not have link to Lot! */
  lot?: Maybe<Lot>;
  maxAge?: Maybe<Scalars['DateTime']>;
  maxDaysOnFarm?: Maybe<Scalars['Int']>;
  minAge?: Maybe<Scalars['DateTime']>;
  minDaysOnFarm?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  notifications?: Maybe<NotificationConnection>;
  numberOfUnidentifiedAnimalsInBatch?: Maybe<Scalars['Int']>;
  summaryMetrics?: Maybe<Array<Maybe<SummaryMetrics>>>;
  targetDate?: Maybe<Scalars['Date']>;
  targetWeight?: Maybe<Scalars['Float']>;
  tasks?: Maybe<TaskConnection>;
  /** @deprecated Obsolete */
  tasksCnt?: Maybe<Scalars['Int']>;
  timeOnFarm?: Maybe<Scalars['DateTime']>;
  unreadNotificationsCount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  weightInfo?: Maybe<GroupWeightInfo>;
};


export type GroupNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type GroupTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum GroupCategory {
  BreedingStock = 'BREEDING_STOCK',
  Culls = 'CULLS',
  Dairy = 'DAIRY',
  Pets = 'PETS',
  Terminal = 'TERMINAL',
  Youngstock = 'YOUNGSTOCK'
}

export type GroupCategoryObjectType = {
  __typename?: 'GroupCategoryObjectType';
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type GroupChartData = {
  __typename?: 'GroupChartData';
  age?: Maybe<Array<Maybe<ChartDataItem>>>;
  growth?: Maybe<Array<Maybe<ChartDataItem>>>;
  sales?: Maybe<Array<Maybe<ChartDataItem>>>;
};

/**
 * Wraps a group query set with a count.  This duplicates what a connection
 * provides so we should look to migrate to Connections when possible.
 */
export type GroupExtendedList = {
  __typename?: 'GroupExtendedList';
  groups?: Maybe<Array<Group>>;
  groupsCount?: Maybe<Scalars['Int']>;
};

export type GroupImage = {
  __typename?: 'GroupImage';
  createdAt: Scalars['DateTime'];
  group: Group;
  id: Scalars['UUID'];
  image?: Maybe<Scalars['String']>;
};

export type GroupReportType = {
  __typename?: 'GroupReportType';
  id: Scalars['ID'];
  position: Scalars['Int'];
  reportSet: Array<ReportType>;
  title: Scalars['String'];
};

export type GroupWeightInfo = {
  __typename?: 'GroupWeightInfo';
  avgWeight?: Maybe<Scalars['Float']>;
  maxWeight?: Maybe<Scalars['Float']>;
  minWeight?: Maybe<Scalars['Float']>;
};

export type HerdDoggIntegrationObjectType = {
  __typename?: 'HerdDoggIntegrationObjectType';
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  isConnected?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
};

export type HowDidYouHearAboutBreedrChoices = {
  __typename?: 'HowDidYouHearAboutBreedrChoices';
  choice?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum IdentifierEnumType {
  AlternativeId = 'ALTERNATIVE_ID',
  BreedrId = 'BREEDR_ID',
  BrucellosisId = 'BRUCELLOSIS_ID',
  EId = 'E_ID',
  HerdDoggId = 'HERD_DOGG_ID',
  Name = 'NAME',
  PassportNumber = 'PASSPORT_NUMBER',
  PedigreeId = 'PEDIGREE_ID',
  Tattoo = 'TATTOO',
  TrichId = 'TRICH_ID',
  TsuBarcode = 'TSU_BARCODE',
  UhfId = 'UHF_ID',
  VisualId = 'VISUAL_ID'
}

/** An enumeration. */
export enum IdentifierType {
  AlternativeId = 'ALTERNATIVE_ID',
  BreedrId = 'BREEDR_ID',
  BrucellosisId = 'BRUCELLOSIS_ID',
  EId = 'E_ID',
  HerdDoggId = 'HERD_DOGG_ID',
  Name = 'NAME',
  PassportNumber = 'PASSPORT_NUMBER',
  PedigreeId = 'PEDIGREE_ID',
  Tattoo = 'TATTOO',
  TrichId = 'TRICH_ID',
  TsuBarcode = 'TSU_BARCODE',
  UhfId = 'UHF_ID',
  VisualId = 'VISUAL_ID'
}

export type ImportCsvInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  fields: Array<Scalars['String']>;
  formatSlug?: InputMaybe<Scalars['String']>;
  /** ID from uploadCsv mutation */
  id: Scalars['Int'];
  isFirstRowColumnNames?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<UploadCsvOptionInput>>;
};

/** Initiates processing of an uploaded csv. */
export type ImportCsvPayload = {
  __typename?: 'ImportCsvPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  taskId?: Maybe<Scalars['String']>;
  uploadTaskId?: Maybe<Scalars['ID']>;
};

/** Status details for an in-progress or completed import task. */
export type ImportResult = {
  __typename?: 'ImportResult';
  /** @deprecated [2023-12] obsolete */
  animals?: Maybe<Array<Animal>>;
  businessUnitId?: Maybe<Scalars['Int']>;
  /** @deprecated [2023-04] Never used */
  createdGroupsCount?: Maybe<Scalars['Int']>;
  /** @deprecated [2023-04] Use rowErrors */
  errorRows?: Maybe<Scalars['GenericScalar']>;
  /** Whole-file errors */
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  /** @deprecated [2023-04] use rejectedRowsUrl */
  failedActivitiesUrl?: Maybe<Scalars['String']>;
  /** @deprecated [2023-12] use rejectedRowsUrl */
  failedAnimalsUrl?: Maybe<Scalars['String']>;
  /** @deprecated [2024-02] obsolete */
  importedActivitiesCount?: Maybe<Scalars['Int']>;
  /** @deprecated [2023-12] obsolete */
  importedAnimalIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** @deprecated [2024-02] obsolete */
  importedAnimalsCount?: Maybe<Scalars['Int']>;
  isDone?: Maybe<Scalars['Boolean']>;
  processedRows?: Maybe<Scalars['Int']>;
  rejectedRowsUrl?: Maybe<Scalars['String']>;
  results?: Maybe<ImportResultRowConnection>;
  /** Per-row errors */
  rowErrors?: Maybe<Array<ImportResultError>>;
  totalRows?: Maybe<Scalars['Int']>;
  /** @deprecated [2023-04] Obsolete */
  updatedAnimals?: Maybe<Scalars['GenericScalar']>;
};


/** Status details for an in-progress or completed import task. */
export type ImportResultResultsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ImportResultError = {
  __typename?: 'ImportResultError';
  errors?: Maybe<Array<ValidationError>>;
  rowIndex?: Maybe<Scalars['Int']>;
};

/** Detail associated to a single command within a list of bulk commands. */
export type ImportResultRow = {
  __typename?: 'ImportResultRow';
  errors?: Maybe<Array<ValidationError>>;
  /** Row index in the file including headers. */
  rowIndex?: Maybe<Scalars['Int']>;
};

export type ImportResultRowConnection = {
  __typename?: 'ImportResultRowConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ImportResultRowEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ImportResultRow` and its cursor. */
export type ImportResultRowEdge = {
  __typename?: 'ImportResultRowEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ImportResultRow>;
};

/** An enumeration. */
export enum IntegrationSystemSystemType {
  Farm = 'FARM',
  Regulatory = 'REGULATORY'
}

export type IntegrationSystemType = {
  __typename?: 'IntegrationSystemType';
  fields: Array<SystemCredentialFieldType>;
  helpLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAutomatedSystem: Scalars['Boolean'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  systemType: IntegrationSystemSystemType;
  website?: Maybe<Scalars['String']>;
};

export type IntercomCarousel = {
  __typename?: 'IntercomCarousel';
  carouselId: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  key: Scalars['String'];
};

export type InventoryInfoType = {
  __typename?: 'InventoryInfoType';
  /** The active ingredients of this medicine */
  activeIngredients?: Maybe<Scalars['String']>;
  /** The medicine batch number */
  batchNumber?: Maybe<Scalars['String']>;
  /** The medicine batch number */
  id?: Maybe<Scalars['String']>;
  /** The medicine name */
  name?: Maybe<Scalars['String']>;
  /** The medicine stock item id */
  stockItemId?: Maybe<Scalars['String']>;
  /** The total original volume of all bottles of this medicine */
  totalOriginalVolume?: Maybe<Scalars['Float']>;
  /** The total remaining volume of all bottles of this medicine */
  totalRemainingVolume?: Maybe<Scalars['Float']>;
  /** The volume units for this medicine */
  volumeUnits?: Maybe<Scalars['String']>;
  withdrawalNotes?: Maybe<Scalars['String']>;
  /** @deprecated Use withdrawalPeriodDays* instead */
  withdrawalPeriodDays?: Maybe<Scalars['Int']>;
  withdrawalPeriodDaysCattleDairy?: Maybe<Scalars['Int']>;
  withdrawalPeriodDaysCattleMeat?: Maybe<Scalars['Int']>;
  withdrawalPeriodDaysPigs?: Maybe<Scalars['Int']>;
  withdrawalPeriodDaysSheep?: Maybe<Scalars['Int']>;
};

export type InviteUserInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['Int']>;
};

export type InviteUserPayload = {
  __typename?: 'InviteUserPayload';
  businessUnitUser?: Maybe<BusinessUnitUser>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type Invoice = {
  __typename?: 'Invoice';
  /** @deprecated Unused */
  acceptPayByInvoice?: Maybe<Scalars['Boolean']>;
  businessUnit?: Maybe<BusinessUnitInfo>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  /** BU who buys */
  createdFor?: Maybe<BusinessUnit>;
  currency?: Maybe<Currency>;
  details?: Maybe<Scalars['String']>;
  finalPrice?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  invoiceNumber: Scalars['String'];
  offer?: Maybe<Offer>;
  /** Latest payment method */
  paymentMethod?: Maybe<PaymentMethod>;
  price?: Maybe<Scalars['Float']>;
  priceUnit: InvoicePriceUnit;
  shippingDetails?: Maybe<Scalars['GenericScalar']>;
  status: InvoiceStatus;
  totalPrice?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum InvoicePriceUnit {
  Head = 'HEAD',
  Kg = 'KG',
  Total = 'TOTAL'
}

/** An enumeration. */
export enum InvoiceStatus {
  AwaitingConfirm = 'AWAITING_CONFIRM',
  Failed = 'FAILED',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type ItemTransactionConnection = {
  __typename?: 'ItemTransactionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ItemTransactionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ItemTransaction` and its cursor. */
export type ItemTransactionEdge = {
  __typename?: 'ItemTransactionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ItemTransactionType>;
};

/** An enumeration. */
export enum ItemTransactionTransactionType {
  Add = 'ADD',
  Administer = 'ADMINISTER',
  Dispose = 'DISPOSE',
  Remove = 'REMOVE'
}

export type ItemTransactionType = {
  __typename?: 'ItemTransactionType';
  activity?: Maybe<ActivityLog>;
  batchNumber: Scalars['String'];
  cost?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  longDescription?: Maybe<Scalars['String']>;
  medicineName: Scalars['String'];
  quantity?: Maybe<Scalars['Int']>;
  quantityUnits: Scalars['String'];
  reason: Scalars['String'];
  shortDescription?: Maybe<Scalars['String']>;
  sku: Scalars['String'];
  supplierName: Scalars['String'];
  totalAmount?: Maybe<Scalars['Float']>;
  transactionType?: Maybe<ItemTransactionTransactionType>;
  valueDescription?: Maybe<Scalars['String']>;
  volumeUnits: Scalars['String'];
};

export type LabelNumberObjectType = {
  __typename?: 'LabelNumberObjectType';
  x: Scalars['String'];
  y: Scalars['Float'];
};

export type LeaveGroupInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  producerGroup: Scalars['Int'];
};

export type LeaveGroupPayload = {
  __typename?: 'LeaveGroupPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum LineItemSkuSource {
  Noah = 'NOAH',
  Private = 'PRIVATE'
}

export type LineItemType = {
  __typename?: 'LineItemType';
  batchNumber: Scalars['String'];
  bottleNumber: Scalars['String'];
  businessUnit: BusinessUnit;
  cost?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  expiryDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['UUID']>;
  itemtransactionSet: Array<ItemTransactionType>;
  name?: Maybe<Scalars['String']>;
  notes: Scalars['String'];
  /** It is the number of items inside one package. E.g if it is a pack of pills, then it will be the number of pills in this pack; if it is a bottle of some liquid that it will be number of bottles in this pack, usually - 1 bottle. */
  originalQuantity?: Maybe<Scalars['Int']>;
  /** It is size of each of item in package. E.g if it is package of 10 pills, each one has 200mg, this field will store 200. Or if it is bottle - 100 ml, there will be stored 100. */
  originalVolume?: Maybe<Scalars['Float']>;
  purchaseDate?: Maybe<Scalars['DateTime']>;
  /** Number of packages user has bought. E.g 5 bottles. */
  quantity?: Maybe<Scalars['Int']>;
  /** The type of container e.g. bottle, pill, vial, syringe */
  quantityUnits: Scalars['String'];
  sku: Scalars['String'];
  skuSource: LineItemSkuSource;
  stockItem: StockItemListType;
  /** or "purchased from" */
  supplierName: Scalars['String'];
  /** It is current total volume (quantity * original_volume). Eg. if user bought 5 (quantity) bottles,each one - 100ml, then this field will store - 500 */
  totalVolume?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  /** The unit of the container e.g. g, mg, l, ml */
  volumeUnits: Scalars['String'];
};

export type LinkHerdDoggAccountInput = {
  authenticationCode: Scalars['String'];
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type LinkHerdDoggAccountPayload = {
  __typename?: 'LinkHerdDoggAccountPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum LitterSize {
  One = 'ONE',
  Other = 'OTHER',
  Three = 'THREE',
  Two = 'TWO'
}

export type LitterSizeObjectType = {
  __typename?: 'LitterSizeObjectType';
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type LiveAnimalSaleInput = {
  animals: Array<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  contact: Scalars['ID'];
  date: Scalars['DateTime'];
  note?: InputMaybe<Scalars['String']>;
  pricePerHead: Scalars['Decimal'];
};

/**
 * Performs a move-out and also records a live animal sale activity.  This is a
 * transitional mutation which allows the old interface to recording the
 * activity but also adds movement semantics to it.
 */
export type LiveAnimalSalePayload = {
  __typename?: 'LiveAnimalSalePayload';
  animals?: Maybe<Array<Animal>>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Represents a Live Session, which is a collection of Animals and data specific
 * to that animal in this session.
 */
export type LiveSession = {
  __typename?: 'LiveSession';
  animalErrors: Array<LiveSessionAnimalError>;
  animalType?: Maybe<AnimalType>;
  /**
   * List of Animal Objects in the session
   * @deprecated (09/2023) Use sessionAnimals instead: sessionAnimals contains more information about the animal in the context of the session
   */
  animals?: Maybe<Array<Animal>>;
  businessUnit?: Maybe<BusinessUnit>;
  /** The time at which the session was first saved to the server */
  createdAt: Scalars['DateTime'];
  /** The time at which the session was created on the device */
  createdOnDeviceAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  /** A paginated list of objects that represent sets of Animals and additional data specific to each Animal in the context of the session */
  sessionAnimals?: Maybe<SessionAnimalConnection>;
  sessionErrors: Array<LiveSessionError>;
  sessionOwner?: Maybe<User>;
  sessionStatus?: Maybe<SessionStatus>;
  /** The time at which the session was last updated on the server */
  updatedAt: Scalars['DateTime'];
};


/**
 * Represents a Live Session, which is a collection of Animals and data specific
 * to that animal in this session.
 */
export type LiveSessionSessionAnimalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type LiveSessionAnimalError = {
  __typename?: 'LiveSessionAnimalError';
  animal?: Maybe<Animal>;
  animalIdentifier?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  isDeleted: Scalars['Boolean'];
  liveSession?: Maybe<LiveSession>;
  message: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/**
 * An object representing an Animal (by its UUID) and additional data
 * specific to that animal in the context of the relevant LiveSession.
 */
export type LiveSessionAnimalInputType = {
  /** The UUID of the animal that was scanned in the given session */
  animal: Scalars['UUID'];
  /** The time the animal was scanned in the session */
  scannedAt: Scalars['DateTime'];
};

export type LiveSessionConnection = {
  __typename?: 'LiveSessionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LiveSessionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LiveSession` and its cursor. */
export type LiveSessionEdge = {
  __typename?: 'LiveSessionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<LiveSession>;
};

export type LiveSessionError = {
  __typename?: 'LiveSessionError';
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  isDeleted: Scalars['Boolean'];
  liveSession: LiveSession;
  message: Scalars['String'];
};

export type LoadCrushAppSessionInput = {
  animalType?: InputMaybe<Scalars['Int']>;
  animals?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  sessionConfig: Scalars['GenericScalar'];
};

/** Save sessions on backend and remove from local state */
export type LoadCrushAppSessionPayload = {
  __typename?: 'LoadCrushAppSessionPayload';
  animalType?: Maybe<Array<Maybe<AnimalType>>>;
  clientMutationId?: Maybe<Scalars['String']>;
  crushAppSession?: Maybe<CrushAppSessionObjectType>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type LocationSearchBusinessUnit = {
  __typename?: 'LocationSearchBusinessUnit';
  city?: Maybe<Scalars['String']>;
  unitName?: Maybe<Scalars['String']>;
};

export type LogActivityBulkInput = {
  activityTemplate: Scalars['Int'];
  animals?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  /**
   * The value of payload should be valid JSON
   *     in the following format:
   *       {
   *         "name": "New Activity",
   *         "description": "some notes...",
   *         "data": [
   *           {
   *             "id": 1,
   *             "value": "my value"
   *           },
   *           ...
   *         ]
   *       }
   */
  payload: Scalars['GenericScalar'];
};

export type LogActivityBulkPayload = {
  __typename?: 'LogActivityBulkPayload';
  animals?: Maybe<Array<Animal>>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type LogBirthIntoBatchInput = {
  animalData?: InputMaybe<Array<InputMaybe<CreateAnimalInput>>>;
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  dam: Scalars['UUID'];
  group: Scalars['UUID'];
  numberLiveBorn?: InputMaybe<Scalars['Int']>;
  numberStillBorn?: InputMaybe<Scalars['Int']>;
};

export type LogBirthIntoBatchPayload = {
  __typename?: 'LogBirthIntoBatchPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type LogStillBirthInput = {
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  dam: Scalars['UUID'];
  numberStillBorn: Scalars['Int'];
};

export type LogStillBirthPayload = {
  __typename?: 'LogStillBirthPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Lot = {
  /** @deprecated Not using now, will be removed in next release. */
  actualCloseDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated Not using now, will be removed in next release. */
  actualSellPrice?: Maybe<Scalars['Float']>;
  animalsAverageAge?: Maybe<Scalars['Float']>;
  animalsAverageCurrentWeight?: Maybe<Scalars['Float']>;
  animalsAverageGrowthRate?: Maybe<Scalars['Decimal']>;
  animalsAverageTimesWeighed?: Maybe<Scalars['Float']>;
  animalsCount?: Maybe<Scalars['Int']>;
  animalsCountBreedAndGender?: Maybe<Array<Maybe<AnimalBreedGender>>>;
  animalsMaxNumberMoves?: Maybe<Scalars['Int']>;
  animalsNumberSires?: Maybe<Scalars['Int']>;
  animalsNumberWithdrawals?: Maybe<Scalars['Int']>;
  breeds?: Maybe<Array<Maybe<AnimalBreed>>>;
  businessUnit?: Maybe<BusinessUnitInfo>;
  businessUnitId?: Maybe<Scalars['Int']>;
  categoryOfSale?: Maybe<CategoryOfSale>;
  currency?: Maybe<Currency>;
  currencyId?: Maybe<Scalars['Int']>;
  declaredAnimalsCount?: Maybe<Scalars['Int']>;
  /** deliveredAnimals that were duplicated from the original and delivered to the Buyer */
  deliveredAnimals?: Maybe<Array<Maybe<Animal>>>;
  deliveryAddress?: Maybe<DeliveryAddressType>;
  description?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  gradingFile?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  images?: Maybe<Array<Maybe<LotImage>>>;
  imagesThumb?: Maybe<Array<Maybe<LotImageThumbnailType>>>;
  isBreedrGuaranteed: Scalars['Boolean'];
  isExpired?: Maybe<Scalars['Boolean']>;
  isPublic: Scalars['Boolean'];
  isTbFree?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  offersPendingCount?: Maybe<Scalars['Int']>;
  plannedCloseDate?: Maybe<Scalars['DateTime']>;
  preMovementTestDate?: Maybe<Scalars['DateTime']>;
  price?: Maybe<Scalars['Float']>;
  /** @deprecated Not using now, will be removed in next release. */
  pricePerItem?: Maybe<Scalars['Float']>;
  pricePerKgOnCreation?: Maybe<Scalars['Float']>;
  priceUnit?: Maybe<Scalars['String']>;
  publicLink?: Maybe<Scalars['String']>;
  referenceCode?: Maybe<Scalars['String']>;
  /** Available types: INDIVIDUAL, EVERYONE, PREFERRED_SUPPLIERS, PREFERRED_BUYERS, PRODUCER_GROUPS */
  shareType?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  /** Available statuses: BUYER_MADE_PAYMENT_TO_BREEDR, BREEDR_RECEIVED_PAYMENT, SELLER_SENT_ANIMALS, BUYER_RECEIVED_ANIMALS, BREEDR_MADE_PAYMENT, COMPLETED, AWAITING_ANIMALS, ASSIGNED_ANIMALS, MOVED_ANIMALS, AWAITING_GRADING, AWAITING_ACCEPTANCE, CREATED, AWAITING_PAYMENT, SOLD, CLOSED */
  status?: Maybe<Scalars['String']>;
  tbRequirements?: Maybe<Scalars['String']>;
  totalPrice?: Maybe<Scalars['Float']>;
  tradingType?: Maybe<TradingType>;
  tradingTypeId?: Maybe<Scalars['Int']>;
  unreadNotificationsCount?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum LotBreedingStatus {
  Offspring = 'OFFSPRING',
  Pregnant = 'PREGNANT',
  Single = 'SINGLE'
}

export type LotBuyerReceivedAnimalsInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type LotBuyerReceivedAnimalsPayload = {
  __typename?: 'LotBuyerReceivedAnimalsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  lot?: Maybe<OwnLot>;
};

export type LotImage = {
  __typename?: 'LotImage';
  id: Scalars['ID'];
  lot: OwnLot;
  photo: Scalars['String'];
  position?: Maybe<Scalars['Int']>;
  thumbnailMedium?: Maybe<Scalars['String']>;
  thumbnailSmall?: Maybe<Scalars['String']>;
};

export type LotImageInput = {
  image: Scalars['Upload'];
  position: Scalars['Int'];
};

export type LotImageOrderInput = {
  id: Scalars['Int'];
  position: Scalars['Int'];
};

export type LotImageThumbnailType = {
  __typename?: 'LotImageThumbnailType';
  imageAspectRatio512x512?: Maybe<Scalars['String']>;
  imageAspectRatio1024x1024?: Maybe<Scalars['String']>;
  imageSquare32x32?: Maybe<Scalars['String']>;
  imageSquare64x64?: Maybe<Scalars['String']>;
  imageSquare96x96?: Maybe<Scalars['String']>;
  imageSquare128x128?: Maybe<Scalars['String']>;
};

export type LotInfo = {
  __typename?: 'LotInfo';
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum LotPedigreeStatus {
  Birth = 'BIRTH',
  None = 'NONE',
  Sire = 'SIRE',
  SireNotReg = 'SIRE_NOT_REG',
  Society = 'SOCIETY'
}

export type LotSellerSentAnimalsInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type LotSellerSentAnimalsPayload = {
  __typename?: 'LotSellerSentAnimalsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  lot?: Maybe<OwnLot>;
};

export type MarkAnimalsAsDeadInput = {
  animals?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  businessUnit?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deathReason?: InputMaybe<Scalars['String']>;
  destinationAddress?: InputMaybe<Scalars['String']>;
  destinationName?: InputMaybe<Scalars['String']>;
  destinationPostcode?: InputMaybe<Scalars['String']>;
  disposalCost?: InputMaybe<Scalars['Float']>;
};

/**
 * Records an animal death.  This triggers regulatory behaviour and is a
 * movement underneath.
 */
export type MarkAnimalsAsDeadPayload = {
  __typename?: 'MarkAnimalsAsDeadPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type MarkAsDoneAnimalsAlertsInput = {
  animalAlerts?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  completedAt: Scalars['Date'];
  resolutionComments?: InputMaybe<Scalars['String']>;
};

export type MarkAsDoneAnimalsAlertsPayload = {
  __typename?: 'MarkAsDoneAnimalsAlertsPayload';
  animalAlerts?: Maybe<Array<Maybe<AnimalAlertObjectType>>>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type MarkAsPaidLotOfferInput = {
  businessUnitId: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  offer: Scalars['Int'];
};

export type MarkAsPaidLotOfferPayload = {
  __typename?: 'MarkAsPaidLotOfferPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  offer?: Maybe<Offer>;
};

export type MarkReadMessageInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  messages: Array<InputMaybe<Scalars['Int']>>;
};

export type MarkReadMessagePayload = {
  __typename?: 'MarkReadMessagePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  messages?: Maybe<Message>;
};

export type MarkReadNotificationsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  notifications: Array<InputMaybe<Scalars['Int']>>;
};

export type MarkReadNotificationsPayload = {
  __typename?: 'MarkReadNotificationsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
};

export type MeasuredWeightEventType = {
  __typename?: 'MeasuredWeightEventType';
  id: Scalars['ID'];
  rawUnit?: Maybe<WeightUnitEnum>;
  rawValue: Scalars['Decimal'];
  recordedAt: Scalars['DateTime'];
};

export type MeasurementChartData = {
  __typename?: 'MeasurementChartData';
  age?: Maybe<Scalars['Int']>;
  avg?: Maybe<Scalars['Float']>;
  dailyLiveWeightGain?: Maybe<Scalars['Float']>;
  daysToTarget?: Maybe<Scalars['Int']>;
  daysToTargetWeight?: Maybe<Scalars['Int']>;
  diffTargetDailyLiveWeightGain?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  onTargetWeight?: Maybe<Scalars['Float']>;
  targetDailyLiveWeightGain?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type MedicineActiveIngredientType = {
  __typename?: 'MedicineActiveIngredientType';
  ingredient?: Maybe<Scalars['String']>;
  noahId?: Maybe<Scalars['String']>;
};

export type MedicineApplicationMethodType = {
  __typename?: 'MedicineApplicationMethodType';
  applicationMethod?: Maybe<Scalars['String']>;
};

export type MedicineCourseObjectType = {
  __typename?: 'MedicineCourseObjectType';
  businessUnit?: Maybe<BusinessUnit>;
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  stages?: Maybe<Array<Maybe<MedicineCourseStageObjectType>>>;
};

export type MedicineCourseStageInputType = {
  amount?: InputMaybe<Scalars['Float']>;
  daysAfter?: InputMaybe<Scalars['Int']>;
  lineItem?: InputMaybe<Scalars['UUID']>;
  units?: InputMaybe<Scalars['String']>;
};

export type MedicineCourseStageObjectType = {
  __typename?: 'MedicineCourseStageObjectType';
  amount?: Maybe<Scalars['Float']>;
  daysAfter?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['UUID']>;
  units?: Maybe<Scalars['String']>;
};

export type MedicineGtinType = {
  __typename?: 'MedicineGTINType';
  description?: Maybe<Scalars['String']>;
  doNotSync?: Maybe<Scalars['Boolean']>;
  gtinNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  quantityUnits?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['Float']>;
  volumeUnits?: Maybe<Scalars['String']>;
};

export type MedicineType = {
  __typename?: 'MedicineType';
  activeIngredient?: Maybe<MedicineActiveIngredientType>;
  applicableAnimalTypes?: Maybe<Array<Maybe<AnimalType>>>;
  applicationMethod?: Maybe<MedicineApplicationMethodType>;
  barcode?: Maybe<Scalars['String']>;
  commonName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  gtin?: Maybe<Array<Maybe<MedicineGtinType>>>;
  id?: Maybe<Scalars['UUID']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  manName?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  medicineActiveIngredients?: Maybe<Array<Maybe<MedicineActiveIngredientType>>>;
  medicinewithdrawalSet?: Maybe<Array<Maybe<MedicineWithdrawalType>>>;
  noahId?: Maybe<Scalars['String']>;
};

export type MedicineWithdrawalType = {
  __typename?: 'MedicineWithdrawalType';
  animalType?: Maybe<AnimalType>;
  id?: Maybe<Scalars['Int']>;
  medicine?: Maybe<MedicineType>;
  notes?: Maybe<Scalars['String']>;
  useWithdrawalPeriod?: Maybe<Scalars['Boolean']>;
  withdrawalPeriodDays?: Maybe<Scalars['Int']>;
  withdrawalType?: Maybe<Scalars['String']>;
};

export type MergeAnimalTagsInput = {
  animals: Array<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  tagValues: Array<AnimalTagAssignmentInputType>;
};

export type MergeAnimalTagsPayload = {
  __typename?: 'MergeAnimalTagsPayload';
  animals?: Maybe<Array<Animal>>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
};

export type MergeGroupsToGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  group: Scalars['UUID'];
  /** List of groups' IDs */
  groups: Array<InputMaybe<Scalars['UUID']>>;
};

export type MergeGroupsToGroupPayload = {
  __typename?: 'MergeGroupsToGroupPayload';
  animals?: Maybe<Array<Animal>>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  groups?: Maybe<Array<Group>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Message = {
  __typename?: 'Message';
  addressee?: Maybe<User>;
  attachment?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /** Is read by current user */
  isRead?: Maybe<Scalars['Boolean']>;
  metaData?: Maybe<Scalars['JSONString']>;
  /** User ids whom read this notification/message */
  readBy?: Maybe<Array<Maybe<Scalars['Int']>>>;
  referenceId?: Maybe<Scalars['String']>;
  /** Base type name which this entity related to. Available choices are: LOT, WANT, ANIMAL, GROUP, OFFER */
  relatedToSlug?: Maybe<Scalars['String']>;
  sender?: Maybe<User>;
  title?: Maybe<Scalars['String']>;
  type: NotificationType;
  updatedAt: Scalars['DateTime'];
};

export type MessageConnection = {
  __typename?: 'MessageConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MessageEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  unreadTotalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Message` and its cursor. */
export type MessageEdge = {
  __typename?: 'MessageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Message>;
};

export type MoveAnimalsToFieldInput = {
  animals: Array<InputMaybe<Scalars['UUID']>>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  field?: InputMaybe<Scalars['UUID']>;
};

/** Perform an integrated movement to a field within the same farm. */
export type MoveAnimalsToFieldPayload = {
  __typename?: 'MoveAnimalsToFieldPayload';
  animals?: Maybe<Array<Animal>>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  fields?: Maybe<Array<Field>>;
  /** @deprecated Never used. */
  groups?: Maybe<Array<Maybe<Group>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type MoveAnimalsToGroupInput = {
  /** List of animals' IDs */
  animals: Array<InputMaybe<Scalars['UUID']>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  group?: InputMaybe<Scalars['UUID']>;
};

export type MoveAnimalsToGroupPayload = {
  __typename?: 'MoveAnimalsToGroupPayload';
  activities?: Maybe<Array<Maybe<ActivityLog>>>;
  animals?: Maybe<Array<Animal>>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  groups?: Maybe<Array<Group>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type MoveGroupsToFieldInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  field: Scalars['UUID'];
  /** List of groups' IDs */
  groups: Array<InputMaybe<Scalars['UUID']>>;
};

/**
 * Move animals in groups to a field.  This is a bulk operation that also
 * factors for moving batches.
 */
export type MoveGroupsToFieldPayload = {
  __typename?: 'MoveGroupsToFieldPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  fields?: Maybe<Array<Field>>;
  groups?: Maybe<Array<Group>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type MovementLocationType = {
  __typename?: 'MovementLocationType';
  regulatoryId?: Maybe<Scalars['String']>;
};

export enum MovementType {
  Between = 'BETWEEN',
  Birth = 'BIRTH',
  Death = 'DEATH',
  In = 'IN',
  Internal = 'INTERNAL',
  Out = 'OUT'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** As the delivery non-initiator accept the proposed action. */
  acceptDelivery?: Maybe<AcceptDeliveryPayload>;
  acceptInvitation?: Maybe<AcceptInvitationPayload>;
  addAnimalsMedicineCourse?: Maybe<AddAnimalsMedicineCoursePayload>;
  /**
   * Adds an animal to a financial transaction. Only provide allocated value if
   * the allocation method is set to CUSTOM
   */
  addAnimalsToFinancialTransaction?: Maybe<AddAnimalsToFinancialTransactionPayload>;
  addDeliveryAddress?: Maybe<AddDeliveryAddressPayload>;
  addMedicineCourse?: Maybe<AddMedicineCoursePayload>;
  addMedicineCourseStage?: Maybe<AddMedicineCourseStagePayload>;
  addMedicineLineItem?: Maybe<AddMedicineLineItemPayload>;
  addRegularWithdrawal?: Maybe<AddRegularWithdrawalPayload>;
  administerAnimalsMedicineCourseStage?: Maybe<AdministerAnimalsMedicineCourseStagePayload>;
  /**
   * Trigger an asyncrhonous task which bundles up an entire list of animals.
   * This uses the same pararameters as the animals api.  Paramters which are
   * None or not specified are considered to mean 'any match', just like animals
   * api.
   */
  animalsExportAsync?: Maybe<AnimalsExportAsyncPayload>;
  aphisImportCsv?: Maybe<AphisImportCsvPayload>;
  approveEmail?: Maybe<ApproveEmailPayload>;
  /**
   * As a delivery initiator attach an affidavit document.  Affidavits are hard
   * documents which are shared between participants and provide some kind of
   * certified assertion about the animals in a delivery.
   */
  attachDeliveryAffidavit?: Maybe<AttachDeliveryAffidavitPayload>;
  bcmsImportCsv?: Maybe<BcmsImportCsvPayload>;
  bcmsServiceRequestGeneratePdf?: Maybe<BcmsServiceRequestGeneratePdfPayload>;
  /**
   * Create a new on farm asset with validation appropriate for an animal born
   * on farm.
   */
  birthAnimal?: Maybe<BirthAnimalPayload>;
  cancelFarmSystemTask?: Maybe<CancelFarmSystemTaskPayload>;
  /**
   * As the delivvery initiator check actions that will be performed on commit
   * and return validation errors.  This does not necessarily guarantee that
   * the commit action will proceed without errors.
   */
  checkCommitDelivery?: Maybe<CheckCommitDeliveryPayload>;
  checkField?: Maybe<CheckFieldPayload>;
  closeLot?: Maybe<CloseLotPayload>;
  /**
   * As the delivvery initiator apply the actions specified by a created
   * delivery.  Errors stop the transaction.
   */
  commitDelivery?: Maybe<CommitDeliveryPayload>;
  /** Trigger an async commit and return a task reference. */
  commitDeliveryAsync?: Maybe<CommitDeliveryAsyncPayload>;
  /**
   * Drop in replacement for mark off farm activity interface.  Avoid because
   * it's confusing and causes issues.  This may do an out or a between movement
   * depending on the data provided.
   */
  compatMoveAnimalsOffFarm?: Maybe<CompatMoveAnimalsOffFarmPayload>;
  completeInvite?: Maybe<CompleteInvitationPayload>;
  convertBatch?: Maybe<ConvertBatchPayload>;
  /**
   * Flexible but low level method for animal creation.  Prefer to use
   * createBirth or deliverAnimal where appropriate.
   */
  createAnimal?: Maybe<CreateAnimalPayload>;
  createAnimalFilter?: Maybe<CreateAnimalFilterPayload>;
  createAnimalsAlerts?: Maybe<CreateAnimalsAlertsPayload>;
  createBankAccount?: Maybe<CreateBankAccountPayload>;
  createBankDetails?: Maybe<CreateBankDetailsPayload>;
  createBatch?: Maybe<CreateBatchPayload>;
  createBusinessUnitAccreditation?: Maybe<CreateBusinessUnitAccreditationPayload>;
  createBusinessUnitTarget?: Maybe<CreateBusinessUnitTargetPayload>;
  createContact?: Maybe<CreateContactPayload>;
  /**
   * Create a delivery used to perform a movement.  The delivery has limited
   * effect until it is committed.
   */
  createDelivery?: Maybe<CreateDeliveryPayload>;
  createDistributionList?: Maybe<CreateDistributionListPayload>;
  createDownload?: Maybe<CreateDownloadPayload>;
  createFarmSystem?: Maybe<CreateFarmSystemPayload>;
  createField?: Maybe<CreateFieldPayload>;
  /** Creates a Financial Transaction object. Can return the object just created. */
  createFinancialTransaction?: Maybe<CreateFinancialTransactionPayload>;
  createGroup?: Maybe<CreateGroupPayload>;
  /**
   * Creates a Live Session. Use the UpdateLiveSession mutation to make changes and
   * DeleteLiveSession to permanently remove it.
   */
  createLiveSession?: Maybe<CreateLiveSessionPayload>;
  createLot?: Maybe<CreateLotPayload>;
  createOfferForLot?: Maybe<CreateOfferForLotPayload>;
  createPreferredBuyers?: Maybe<CreatePreferredBuyersPayload>;
  createPreferredSuppliers?: Maybe<CreatePreferredSuppliersPayload>;
  createProducerGroup?: Maybe<CreateProducerGroupPayload>;
  createSire?: Maybe<CreateSirePayload>;
  /**
   * Begin a session on stripe's checkout portal for a particular purpose.
   * The user can go there to buy new products.
   */
  createStripeCheckoutSession?: Maybe<CreateStripeCheckoutSessionPayload>;
  /**
   * Begin a session on stripe's portal.  The user can go there to edit
   * existing products.
   */
  createStripePortalSession?: Maybe<CreateStripePortalSessionPayload>;
  /** Add a custom schema field. */
  createTag?: Maybe<CreateTagPayload>;
  /** create a crush session object with session config only */
  createUpdateInProgressCrushAppSession?: Maybe<CreateUpdateInProgressCrushAppSessionPayload>;
  /** Store a weight measurement. */
  createWeight?: Maybe<CreateWeightPayload>;
  debug?: Maybe<DjangoDebug>;
  deleteActivityBulk?: Maybe<DeleteActivityBulkPayload>;
  deleteAnimalFilter?: Maybe<DeleteAnimalFilterPayload>;
  deleteAnimalsMedicineCourse?: Maybe<DeleteAnimalsMedicineCoursePayload>;
  deleteBankAccount?: Maybe<DeleteBankAccountPayload>;
  deleteBankDetails?: Maybe<DeleteBankDetailsPayload>;
  deleteBusinessUnitAccreditation?: Maybe<DeleteBusinessUnitAccreditationPayload>;
  deleteBusinessUnitTarget?: Maybe<DeleteBusinessUnitTargetPayload>;
  /** delete a crush session object with session config only */
  deleteCrushAppSession?: Maybe<DeleteCrushAppSessionPayload>;
  /**
   * Delete a delivery.  A delivery can only be deleted before it is committed;
   * otherwise you must undo.  Note that on an inward delivery this will delete
   * all associated animals and transactions whether they were created for the
   * delivery or not.  The client is responsible for perfoming any special
   * behaviour for animals that should not be deleted.
   */
  deleteDelivery?: Maybe<DeleteDeliveryPayload>;
  deleteDeliveryAddress?: Maybe<DeleteDeliveryAddressPayload>;
  /**
   * Remove animals from a delivery regardless of where that animal is grouped.
   * The animal record will be maintained with respect to the lifecycle choice
   * made when attaching the animal.  The typical case is that animals created
   * with deliverNewAnimal will be deleted from the database as they are
   * unattached.
   */
  deleteDeliveryAnimals?: Maybe<DeleteDeliveryAnimalsPayload>;
  /** @deprecated RFL */
  deleteDiscountGrid?: Maybe<DeleteDiscountGridPayload>;
  deleteDistributionList?: Maybe<DeleteDistributionListPayload>;
  deleteFarmSystem?: Maybe<DeleteFarmSystemPayload>;
  deleteField?: Maybe<DeleteFieldPayload>;
  deleteFieldImage?: Maybe<DeleteFieldImagePayload>;
  /** Deletes a financial transaction */
  deleteFinancialTransaction?: Maybe<DeleteFinancialTransactionPayload>;
  deleteGroup?: Maybe<DeleteGroupPayload>;
  deleteGroupImage?: Maybe<DeleteGroupImagePayload>;
  deleteGroupWithAnimals?: Maybe<DeleteGroupWithAnimalsPayload>;
  deleteLiveSession?: Maybe<DeleteLiveSessionPayload>;
  deleteMedicineCourse?: Maybe<DeleteMedicineCoursePayload>;
  deleteMedicineCourseStage?: Maybe<DeleteMedicineCourseStagePayload>;
  deletePost?: Maybe<DeletePostPayload>;
  deleteRegularWithdrawal?: Maybe<DeleteRegularWithdrawalPayload>;
  deleteSire?: Maybe<DeleteSirePayload>;
  /** Remove tag from the schema. */
  deleteTag?: Maybe<DeleteTagPayload>;
  deleteUserFromFarm?: Maybe<DeleteUserFromFarmPayload>;
  /** Remove an existing measured weight. */
  deleteWeight?: Maybe<DeleteWeightPayload>;
  /** Preapre an animal on an outward delivery.  See deliverAnimalsOut. */
  deliverAnimalOut?: Maybe<DeliverAnimalOutPayload>;
  /**
   * Preapre an animal on an outward delivery.  The animal must be created
   * already.  The delivery source is not specified; it's assumed from the
   * animal's current properties.  This API is addative: it will not remove any
   * animals. See commitDelivery for nuances of any such behaviour.
   *
   * If using `reattach` take great care that you are sending the proper
   * addresses you want the animal to be associated to.  If the addresses are
   * empty then the animal will be moved to the default consignment.
   */
  deliverAnimalsOut?: Maybe<DeliverAnimalsOutPayload>;
  /**
   * Prepare an animal on an inward delivery.  The animal is already created but
   * still stored on the delivery for later editing.  For a pull delivery a
   * different mutation is needed.
   *
   * This is effectively a backwards compatibility feature in that (some) legacy
   * animals will be able to attach to deliveries retroactively.  You should
   * prefer the other mutations where possible.
   *
   * The attachment is configured by trying to find existing movement structures
   * which will now become owned by the delivery, for example the DOA activity
   * and initial move on record.  This is pretty risky, hence the recommendation
   * to use other means to create and move on animals.
   *
   * The source for the animal is determined by the previous keeper record if
   * there is one.
   */
  deliverExistingAnimal?: Maybe<DeliverExistingAnimalPayload>;
  /** See deliverExistingAnimal. */
  deliverExistingAnimals?: Maybe<DeliverExistingAnimalsPayload>;
  /**
   * Create an animal as part of a delivery.  This is effectively a create and
   * attach.
   *
   * The source for the generated consignment is determined from the source
   * contact or, if not given, the previous keeper (both of which reference a
   * Contact).  Source contact is the preferred means since the source contact
   * will overwrite the previous keeper anyway.  Previous keeper remains for
   * strict compatibility.  If no sources are provided then the delivery default
   * source will be used on commit.
   */
  deliverNewAnimal?: Maybe<DeliverNewAnimalPayload>;
  /**
   * Attach an animal reference to a pull delivery.  The animal need not be
   * created on farm as yet; we will figure out an animal to pull from the
   * partner farm.
   */
  deliverPulledAnimal?: Maybe<DeliverPulledAnimalPayload>;
  /**
   * Log a pregnancy test for the animal.  Animals own pregnancy status is
   * reflected and history is logged.
   */
  diagnosePregnancy?: Maybe<DiagnosePregnancyPayload>;
  disposeMedicineLineItem?: Maybe<DisposeMedicineLineItemPayload>;
  editBankAccount?: Maybe<EditBankAccountPayload>;
  editDeliveryAddress?: Maybe<EditDeliveryAddressPayload>;
  editProducerGroup?: Maybe<EditProducerGroupPayload>;
  editRegularWithdrawal?: Maybe<EditRegularWithdrawalPayload>;
  /**
   * Deprecated version of animal export.
   * @deprecated 2023-09 replaced by animalsExportAsync
   */
  exportAnimalsAsync?: Maybe<ExportAnimalsAsyncPayload>;
  farmAnimalDetail?: Maybe<FarmAnimalDetailPayload>;
  farmPlanImportXls?: Maybe<FarmPlanImportXlsPayload>;
  /** Add/remove given activity template from user favorites */
  favoriteActivityTemplate?: Maybe<FavoriteActivityTemplatePayload>;
  /** Initiates processing of an uploaded csv. */
  importCsv?: Maybe<ImportCsvPayload>;
  inviteUser?: Maybe<InviteUserPayload>;
  leaveGroup?: Maybe<LeaveGroupPayload>;
  linkHerdDoggAccount?: Maybe<LinkHerdDoggAccountPayload>;
  /**
   * Performs a move-out and also records a live animal sale activity.  This is a
   * transitional mutation which allows the old interface to recording the
   * activity but also adds movement semantics to it.
   */
  liveAnimalSale?: Maybe<LiveAnimalSalePayload>;
  /** Save sessions on backend and remove from local state */
  loadCrushAppSession?: Maybe<LoadCrushAppSessionPayload>;
  /** Creates bulk activities */
  logActivityBulk?: Maybe<LogActivityBulkPayload>;
  logBirthIntoBatch?: Maybe<LogBirthIntoBatchPayload>;
  logStillBirth?: Maybe<LogStillBirthPayload>;
  lotBuyerReceivedAnimals?: Maybe<LotBuyerReceivedAnimalsPayload>;
  lotSellerSentAnimals?: Maybe<LotSellerSentAnimalsPayload>;
  /**
   * Records an animal death.  This triggers regulatory behaviour and is a
   * movement underneath.
   */
  markAnimalsAsDead?: Maybe<MarkAnimalsAsDeadPayload>;
  markAsDoneAnimalsAlerts?: Maybe<MarkAsDoneAnimalsAlertsPayload>;
  markAsPaidLotOffer?: Maybe<MarkAsPaidLotOfferPayload>;
  markReadMessage?: Maybe<MarkReadMessagePayload>;
  markReadNotifications?: Maybe<MarkReadNotificationsPayload>;
  mergeAnimalTags?: Maybe<MergeAnimalTagsPayload>;
  mergeGroupsToGroup?: Maybe<MergeGroupsToGroupPayload>;
  /** Perform an integrated movement to a field within the same farm. */
  moveAnimalsToField?: Maybe<MoveAnimalsToFieldPayload>;
  moveAnimalsToGroup?: Maybe<MoveAnimalsToGroupPayload>;
  /**
   * Move animals in groups to a field.  This is a bulk operation that also
   * factors for moving batches.
   */
  moveGroupsToField?: Maybe<MoveGroupsToFieldPayload>;
  offerMarkAsRead?: Maybe<OfferMarkAsReadPayload>;
  /**
   * Create a new on farm asset with validation appropriate for an animal which
   * has been purchased or otherwise not born on farm.
   */
  onboardAnimal?: Maybe<OnboardAnimalPayload>;
  postToGroup?: Maybe<PostToGroupPayload>;
  reInviteUser?: Maybe<ReInviteUserPayload>;
  registerDeviceId?: Maybe<RegisterDeviceIdPayload>;
  /**
   * Soft-deletes a regulatory approval.  The integration is not informed but the
   * underlying state is not impacted.
   */
  regulatoryTransactionApprovalsAbort?: Maybe<RegulatoryTransactionApprovalsAbortPayload>;
  regulatoryTransactionApprovalsChangeDate?: Maybe<RegulatoryTransactionApprovalsChangeDatePayload>;
  /**
   * On approved sends the request to the regulator.  On cancel will discard the
   * approval and attempt to restore the state before moving.
   */
  regulatoryTransactionApprovalsResponse?: Maybe<RegulatoryTransactionApprovalsResponsePayload>;
  regulatoryTransactionApprovalsRetry?: Maybe<RegulatoryTransactionApprovalsRetryPayload>;
  /**
   * As the delivery partner reject a proposed delivery action or undo a
   * completed action.
   */
  rejectDelivery?: Maybe<RejectDeliveryPayload>;
  /** Remove animals from a financial transaction. */
  removeAnimalsFromFinancialTransaction?: Maybe<RemoveAnimalsFromFinancialTransactionPayload>;
  responseToLotOffer?: Maybe<ResponseToLotOfferPayload>;
  restoreAnimals?: Maybe<RestoreAnimalsPayload>;
  /**
   * Oboslete.  Do not use..
   * @deprecated Obsolete
   */
  retrieveChannel?: Maybe<RetrieveChannelPayload>;
  saveCrushAppSession?: Maybe<SaveCrushAppSessionPayload>;
  saveCrushAppSessionEnhanced?: Maybe<SaveCrushAppSessionEnhancedPayload>;
  sendApprove?: Maybe<SendApprovePayload>;
  sendCode?: Maybe<SendCodePayload>;
  sendCompleteBcmsSetupEmail?: Maybe<SendCompleteBcmsSetupEmailPayload>;
  /** @deprecated Obsolete */
  sendMessage?: Maybe<SendMessagePayload>;
  sendResetPasswordEmail?: Maybe<SendResetPasswordEmailPayload>;
  setFavourite?: Maybe<SetFavouritePayload>;
  signUp?: Maybe<SignUpPayload>;
  /**
   * Obsolete.  Simplified signup for just a user and password.
   * @deprecated use signUp.
   */
  signUpUser?: Maybe<SignUpUserPayload>;
  snoozeAnimalsAlerts?: Maybe<SnoozeAnimalsAlertsPayload>;
  softDeleteAnimals?: Maybe<SoftDeleteAnimalsPayload>;
  splitField?: Maybe<SplitFieldPayload>;
  startFarmSystemTask?: Maybe<StartFarmSystemTaskPayload>;
  termsAndConditionsAccept?: Maybe<TermsAndConditionsAcceptPayload>;
  transferOwnership?: Maybe<TransferOwnershipPayload>;
  truTestImportXls?: Maybe<TruTestImportXlsPayload>;
  /** As a delivery participant revert a completed operation. */
  undoDelivery?: Maybe<UndoDeliveryPayload>;
  unlinkHerdDoggAccount?: Maybe<UnlinkHerdDoggAccountPayload>;
  unregisterDeviceId?: Maybe<UnRegisterDeviceIdPayload>;
  unsetFavourite?: Maybe<UnsetFavouritePayload>;
  updateAnimal?: Maybe<UpdateAnimalPayload>;
  updateAnimalFilter?: Maybe<UpdateAnimalFilterPayload>;
  updateBankDetails?: Maybe<UpdateBankDetailsPayload>;
  updateBatch?: Maybe<UpdateBatchPayload>;
  updateBusinessUnitAccreditation?: Maybe<UpdateBusinessUnitAccreditationPayload>;
  updateBusinessUnitSettings?: Maybe<UpdateBusinessUnitSettingsPayload>;
  updateBusinessUnitTarget?: Maybe<UpdateBusinessUnitTargetPayload>;
  updateBusinessUnitUser?: Maybe<UpdateBusinessUnitUserPayload>;
  updateContact?: Maybe<UpdateContactPayload>;
  /** Edit an existing delivery as the delivery owner. */
  updateDelivery?: Maybe<UpdateDeliveryPayload>;
  updateDistributionList?: Maybe<UpdateDistributionListPayload>;
  updateEmail?: Maybe<UpdateEmailPayload>;
  updateFarmSystem?: Maybe<UpdateFarmSystemPayload>;
  updateField?: Maybe<UpdateFieldPayload>;
  /**
   * Updates a financial transaction. Business unit cannot be changed.
   * Animals associated to the transaction must be added/removed separately
   * using specialised mutations.
   */
  updateFinancialTransaction?: Maybe<UpdateFinancialTransactionPayload>;
  updateGroup?: Maybe<UpdateGroupPayload>;
  updateIdentifierPreferences?: Maybe<UpdateIdentifierPreferencesPayload>;
  /** Updates a LiveSession by its UUID */
  updateLiveSession?: Maybe<UpdateLiveSessionPayload>;
  updateLot?: Maybe<UpdateLotPayload>;
  updateMedicineCourse?: Maybe<UpdateMedicineCoursePayload>;
  updateMedicineCourseStage?: Maybe<UpdateMedicineCourseStagePayload>;
  updateMobileClientState?: Maybe<UpdateMobileClientStatePayload>;
  updateNotificationSettings?: Maybe<UpdateNotificationSettingsPayload>;
  updateOrganisation?: Maybe<UpdateOrganisationPayload>;
  /**
   * Edit an existing delivery as the partner.  The partner is not able to
   * update the same fields that the owner can so we have a separate mutation
   * here.
   */
  updatePartnerDelivery?: Maybe<UpdatePartnerDeliveryPayload>;
  updatePassword?: Maybe<UpdatePasswordPayload>;
  updatePost?: Maybe<UpdatePostPayload>;
  updatePreferredBusinessUnit?: Maybe<UpdatePreferredBusinessUnitPayload>;
  updatePreferredBusinessUnitStatus?: Maybe<UpdatePreferredBusinessUnitStatusPayload>;
  /**
   * Updates the previous keeper of an animal.  This is a separate mutation
   * because it has awkward interactions with activities but it is essentially a
   * property of the animal.
   */
  updatePreviousKeeper?: Maybe<UpdatePreviousKeeperPayload>;
  updateSire?: Maybe<UpdateSirePayload>;
  /** Edit the tag. */
  updateTag?: Maybe<UpdateTagPayload>;
  updateUserInfo?: Maybe<UpdateUserPayload>;
  /** Stores an upload file for later processing with importCsv. */
  uploadCsv?: Maybe<UploadCsvPayload>;
  /** @deprecated RFL */
  uploadDiscountGrid?: Maybe<UploadDiscountGridPayload>;
  /** Universal mutation to upload file source for Farm System Tasks */
  uploadFileSource?: Maybe<UploadFileSourcePayload>;
};


export type MutationAcceptDeliveryArgs = {
  input: AcceptDeliveryInput;
};


export type MutationAcceptInvitationArgs = {
  input: AcceptInvitationInput;
};


export type MutationAddAnimalsMedicineCourseArgs = {
  input: AddAnimalsMedicineCourseInput;
};


export type MutationAddAnimalsToFinancialTransactionArgs = {
  input: AddAnimalsToFinancialTransactionInput;
};


export type MutationAddDeliveryAddressArgs = {
  input: AddDeliveryAddressInput;
};


export type MutationAddMedicineCourseArgs = {
  input: AddMedicineCourseInput;
};


export type MutationAddMedicineCourseStageArgs = {
  input: AddMedicineCourseStageInput;
};


export type MutationAddMedicineLineItemArgs = {
  input: AddMedicineLineItemInput;
};


export type MutationAddRegularWithdrawalArgs = {
  input: AddRegularWithdrawalInput;
};


export type MutationAdministerAnimalsMedicineCourseStageArgs = {
  input: AdministerAnimalsMedicineCourseStageInput;
};


export type MutationAnimalsExportAsyncArgs = {
  input: AnimalsExportAsyncInput;
};


export type MutationAphisImportCsvArgs = {
  input: AphisImportCsvInput;
};


export type MutationApproveEmailArgs = {
  input: ApproveEmailInput;
};


export type MutationAttachDeliveryAffidavitArgs = {
  input: AttachDeliveryAffidavitInput;
};


export type MutationBcmsImportCsvArgs = {
  input: BcmsImportCsvInput;
};


export type MutationBcmsServiceRequestGeneratePdfArgs = {
  input: BcmsServiceRequestGeneratePdfInput;
};


export type MutationBirthAnimalArgs = {
  input: BirthAnimalInput;
};


export type MutationCancelFarmSystemTaskArgs = {
  input: CancelFarmSystemTaskInput;
};


export type MutationCheckCommitDeliveryArgs = {
  input: CheckCommitDeliveryInput;
};


export type MutationCheckFieldArgs = {
  input: CheckFieldInput;
};


export type MutationCloseLotArgs = {
  input: CloseLotInput;
};


export type MutationCommitDeliveryArgs = {
  input: CommitDeliveryInput;
};


export type MutationCommitDeliveryAsyncArgs = {
  input: CommitDeliveryAsyncInput;
};


export type MutationCompatMoveAnimalsOffFarmArgs = {
  input: CompatMoveAnimalsOffFarmInput;
};


export type MutationCompleteInviteArgs = {
  input: CompleteInvitationInput;
};


export type MutationConvertBatchArgs = {
  input: ConvertBatchInput;
};


export type MutationCreateAnimalArgs = {
  input: CreateAnimalInput;
};


export type MutationCreateAnimalFilterArgs = {
  input: CreateAnimalFilterInput;
};


export type MutationCreateAnimalsAlertsArgs = {
  input: CreateAnimalsAlertsInput;
};


export type MutationCreateBankAccountArgs = {
  input: CreateBankAccountInput;
};


export type MutationCreateBankDetailsArgs = {
  input: CreateBankDetailsInput;
};


export type MutationCreateBatchArgs = {
  input: CreateBatchInput;
};


export type MutationCreateBusinessUnitAccreditationArgs = {
  input: CreateBusinessUnitAccreditationInput;
};


export type MutationCreateBusinessUnitTargetArgs = {
  input: CreateBusinessUnitTargetInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateDeliveryArgs = {
  input: CreateDeliveryInput;
};


export type MutationCreateDistributionListArgs = {
  input: CreateDistributionListInput;
};


export type MutationCreateDownloadArgs = {
  input: CreateDownloadInput;
};


export type MutationCreateFarmSystemArgs = {
  input: CreateFarmSystemInput;
};


export type MutationCreateFieldArgs = {
  input: CreateFieldInput;
};


export type MutationCreateFinancialTransactionArgs = {
  input: CreateFinancialTransactionInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateLiveSessionArgs = {
  input: CreateLiveSessionInput;
};


export type MutationCreateLotArgs = {
  input: CreateLotInput;
};


export type MutationCreateOfferForLotArgs = {
  input: CreateOfferForLotInput;
};


export type MutationCreatePreferredBuyersArgs = {
  input: CreatePreferredBuyersInput;
};


export type MutationCreatePreferredSuppliersArgs = {
  input: CreatePreferredSuppliersInput;
};


export type MutationCreateProducerGroupArgs = {
  input: CreateProducerGroupInput;
};


export type MutationCreateSireArgs = {
  input: CreateSireInput;
};


export type MutationCreateStripeCheckoutSessionArgs = {
  input: CreateStripeCheckoutSessionInput;
};


export type MutationCreateStripePortalSessionArgs = {
  input: CreateStripePortalSessionInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationCreateUpdateInProgressCrushAppSessionArgs = {
  input: CreateUpdateInProgressCrushAppSessionInput;
};


export type MutationCreateWeightArgs = {
  input: CreateWeightInput;
};


export type MutationDeleteActivityBulkArgs = {
  input: DeleteActivityBulkInput;
};


export type MutationDeleteAnimalFilterArgs = {
  input: DeleteAnimalFilterInput;
};


export type MutationDeleteAnimalsMedicineCourseArgs = {
  input: DeleteAnimalsMedicineCourseInput;
};


export type MutationDeleteBankAccountArgs = {
  input: DeleteBankAccountInput;
};


export type MutationDeleteBankDetailsArgs = {
  input: DeleteBankDetailsInput;
};


export type MutationDeleteBusinessUnitAccreditationArgs = {
  input: DeleteBusinessUnitAccreditationInput;
};


export type MutationDeleteBusinessUnitTargetArgs = {
  input: DeleteBusinessUnitTargetInput;
};


export type MutationDeleteCrushAppSessionArgs = {
  input: DeleteCrushAppSessionInput;
};


export type MutationDeleteDeliveryArgs = {
  input: DeleteDeliveryInput;
};


export type MutationDeleteDeliveryAddressArgs = {
  input: DeleteDeliveryAddressInput;
};


export type MutationDeleteDeliveryAnimalsArgs = {
  input: DeleteDeliveryAnimalsInput;
};


export type MutationDeleteDiscountGridArgs = {
  input: DeleteDiscountGridInput;
};


export type MutationDeleteDistributionListArgs = {
  input: DeleteDistributionListInput;
};


export type MutationDeleteFarmSystemArgs = {
  input: DeleteFarmSystemInput;
};


export type MutationDeleteFieldArgs = {
  input: DeleteFieldInput;
};


export type MutationDeleteFieldImageArgs = {
  input: DeleteFieldImageInput;
};


export type MutationDeleteFinancialTransactionArgs = {
  input: DeleteFinancialTransactionInput;
};


export type MutationDeleteGroupArgs = {
  input: DeleteGroupInput;
};


export type MutationDeleteGroupImageArgs = {
  input: DeleteGroupImageInput;
};


export type MutationDeleteGroupWithAnimalsArgs = {
  input: DeleteGroupWithAnimalsInput;
};


export type MutationDeleteLiveSessionArgs = {
  input: DeleteLiveSessionInput;
};


export type MutationDeleteMedicineCourseArgs = {
  input: DeleteMedicineCourseInput;
};


export type MutationDeleteMedicineCourseStageArgs = {
  input: DeleteMedicineCourseStageInput;
};


export type MutationDeletePostArgs = {
  input: DeletePostInput;
};


export type MutationDeleteRegularWithdrawalArgs = {
  input: DeleteRegularWithdrawalInput;
};


export type MutationDeleteSireArgs = {
  input: DeleteSireInput;
};


export type MutationDeleteTagArgs = {
  input: DeleteTagInput;
};


export type MutationDeleteUserFromFarmArgs = {
  input: DeleteUserFromFarmInput;
};


export type MutationDeleteWeightArgs = {
  input: DeleteWeightInput;
};


export type MutationDeliverAnimalOutArgs = {
  input: DeliverAnimalOutInput;
};


export type MutationDeliverAnimalsOutArgs = {
  input: DeliverAnimalsOutInput;
};


export type MutationDeliverExistingAnimalArgs = {
  input: DeliverExistingAnimalInput;
};


export type MutationDeliverExistingAnimalsArgs = {
  input: DeliverExistingAnimalsInput;
};


export type MutationDeliverNewAnimalArgs = {
  input: DeliverNewAnimalInput;
};


export type MutationDeliverPulledAnimalArgs = {
  input: DeliverPulledAnimalInput;
};


export type MutationDiagnosePregnancyArgs = {
  input: DiagnosePregnancyInput;
};


export type MutationDisposeMedicineLineItemArgs = {
  input: DisposeMedicineLineItemInput;
};


export type MutationEditBankAccountArgs = {
  input: EditBankAccountInput;
};


export type MutationEditDeliveryAddressArgs = {
  input: EditDeliveryAddressInput;
};


export type MutationEditProducerGroupArgs = {
  input: EditProducerGroupInput;
};


export type MutationEditRegularWithdrawalArgs = {
  input: EditRegularWithdrawalInput;
};


export type MutationExportAnimalsAsyncArgs = {
  input: ExportAnimalsAsyncInput;
};


export type MutationFarmAnimalDetailArgs = {
  input: FarmAnimalDetailInput;
};


export type MutationFarmPlanImportXlsArgs = {
  input: FarmPlanImportXlsInput;
};


export type MutationFavoriteActivityTemplateArgs = {
  input: FavoriteActivityTemplateInput;
};


export type MutationImportCsvArgs = {
  input: ImportCsvInput;
};


export type MutationInviteUserArgs = {
  input: InviteUserInput;
};


export type MutationLeaveGroupArgs = {
  input: LeaveGroupInput;
};


export type MutationLinkHerdDoggAccountArgs = {
  input: LinkHerdDoggAccountInput;
};


export type MutationLiveAnimalSaleArgs = {
  input: LiveAnimalSaleInput;
};


export type MutationLoadCrushAppSessionArgs = {
  input: LoadCrushAppSessionInput;
};


export type MutationLogActivityBulkArgs = {
  input: LogActivityBulkInput;
};


export type MutationLogBirthIntoBatchArgs = {
  input: LogBirthIntoBatchInput;
};


export type MutationLogStillBirthArgs = {
  input: LogStillBirthInput;
};


export type MutationLotBuyerReceivedAnimalsArgs = {
  input: LotBuyerReceivedAnimalsInput;
};


export type MutationLotSellerSentAnimalsArgs = {
  input: LotSellerSentAnimalsInput;
};


export type MutationMarkAnimalsAsDeadArgs = {
  input: MarkAnimalsAsDeadInput;
};


export type MutationMarkAsDoneAnimalsAlertsArgs = {
  input: MarkAsDoneAnimalsAlertsInput;
};


export type MutationMarkAsPaidLotOfferArgs = {
  input: MarkAsPaidLotOfferInput;
};


export type MutationMarkReadMessageArgs = {
  input: MarkReadMessageInput;
};


export type MutationMarkReadNotificationsArgs = {
  input: MarkReadNotificationsInput;
};


export type MutationMergeAnimalTagsArgs = {
  input: MergeAnimalTagsInput;
};


export type MutationMergeGroupsToGroupArgs = {
  input: MergeGroupsToGroupInput;
};


export type MutationMoveAnimalsToFieldArgs = {
  input: MoveAnimalsToFieldInput;
};


export type MutationMoveAnimalsToGroupArgs = {
  input: MoveAnimalsToGroupInput;
};


export type MutationMoveGroupsToFieldArgs = {
  input: MoveGroupsToFieldInput;
};


export type MutationOfferMarkAsReadArgs = {
  input: OfferMarkAsReadInput;
};


export type MutationOnboardAnimalArgs = {
  input: OnboardAnimalInput;
};


export type MutationPostToGroupArgs = {
  input: PostToGroupInput;
};


export type MutationReInviteUserArgs = {
  input: ReInviteUserInput;
};


export type MutationRegisterDeviceIdArgs = {
  input: RegisterDeviceIdInput;
};


export type MutationRegulatoryTransactionApprovalsAbortArgs = {
  input: RegulatoryTransactionApprovalsAbortInput;
};


export type MutationRegulatoryTransactionApprovalsChangeDateArgs = {
  input: RegulatoryTransactionApprovalsChangeDateInput;
};


export type MutationRegulatoryTransactionApprovalsResponseArgs = {
  input: RegulatoryTransactionApprovalsResponseInput;
};


export type MutationRegulatoryTransactionApprovalsRetryArgs = {
  input: RegulatoryTransactionApprovalsRetryInput;
};


export type MutationRejectDeliveryArgs = {
  input: RejectDeliveryInput;
};


export type MutationRemoveAnimalsFromFinancialTransactionArgs = {
  input: RemoveAnimalsFromFinancialTransactionInput;
};


export type MutationResponseToLotOfferArgs = {
  input: ResponseToLotOfferInput;
};


export type MutationRestoreAnimalsArgs = {
  input: RestoreAnimalsInput;
};


export type MutationRetrieveChannelArgs = {
  input: RetrieveChannelInput;
};


export type MutationSaveCrushAppSessionArgs = {
  input: SaveCrushAppSessionInput;
};


export type MutationSaveCrushAppSessionEnhancedArgs = {
  input: SaveCrushAppSessionEnhancedInput;
};


export type MutationSendApproveArgs = {
  input: SendApproveInput;
};


export type MutationSendCodeArgs = {
  input: SendCodeInput;
};


export type MutationSendCompleteBcmsSetupEmailArgs = {
  input: SendCompleteBcmsSetupEmailInput;
};


export type MutationSendMessageArgs = {
  input: SendMessageInput;
};


export type MutationSendResetPasswordEmailArgs = {
  input: SendResetPasswordEmailInput;
};


export type MutationSetFavouriteArgs = {
  input: SetFavouriteInput;
};


export type MutationSignUpArgs = {
  input: SignUpInput;
};


export type MutationSignUpUserArgs = {
  input: SignUpUserInput;
};


export type MutationSnoozeAnimalsAlertsArgs = {
  input: SnoozeAnimalsAlertsInput;
};


export type MutationSoftDeleteAnimalsArgs = {
  input: SoftDeleteAnimalsInput;
};


export type MutationSplitFieldArgs = {
  input: SplitFieldInput;
};


export type MutationStartFarmSystemTaskArgs = {
  input: StartFarmSystemTaskInput;
};


export type MutationTermsAndConditionsAcceptArgs = {
  input: TermsAndConditionsAcceptInput;
};


export type MutationTransferOwnershipArgs = {
  input: TransferOwnershipInput;
};


export type MutationTruTestImportXlsArgs = {
  input: TruTestImportXlsInput;
};


export type MutationUndoDeliveryArgs = {
  input: UndoDeliveryInput;
};


export type MutationUnlinkHerdDoggAccountArgs = {
  input: UnlinkHerdDoggAccountInput;
};


export type MutationUnregisterDeviceIdArgs = {
  input: UnRegisterDeviceIdInput;
};


export type MutationUnsetFavouriteArgs = {
  input: UnsetFavouriteInput;
};


export type MutationUpdateAnimalArgs = {
  input: UpdateAnimalInput;
};


export type MutationUpdateAnimalFilterArgs = {
  input: UpdateAnimalFilterInput;
};


export type MutationUpdateBankDetailsArgs = {
  input: UpdateBankDetailsInput;
};


export type MutationUpdateBatchArgs = {
  input: UpdateBatchInput;
};


export type MutationUpdateBusinessUnitAccreditationArgs = {
  input: UpdateBusinessUnitAccreditationInput;
};


export type MutationUpdateBusinessUnitSettingsArgs = {
  input: UpdateBusinessUnitSettingsInput;
};


export type MutationUpdateBusinessUnitTargetArgs = {
  input: UpdateBusinessUnitTargetInput;
};


export type MutationUpdateBusinessUnitUserArgs = {
  input: UpdateBusinessUnitUserInput;
};


export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};


export type MutationUpdateDeliveryArgs = {
  input: UpdateDeliveryInput;
};


export type MutationUpdateDistributionListArgs = {
  input: UpdateDistributionListInput;
};


export type MutationUpdateEmailArgs = {
  input: UpdateEmailInput;
};


export type MutationUpdateFarmSystemArgs = {
  input: UpdateFarmSystemInput;
};


export type MutationUpdateFieldArgs = {
  input: UpdateFieldInput;
};


export type MutationUpdateFinancialTransactionArgs = {
  input: UpdateFinancialTransactionInput;
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationUpdateIdentifierPreferencesArgs = {
  input: UpdateIdentifierPreferencesInput;
};


export type MutationUpdateLiveSessionArgs = {
  input: UpdateLiveSessionInput;
};


export type MutationUpdateLotArgs = {
  input: UpdateLotInput;
};


export type MutationUpdateMedicineCourseArgs = {
  input: UpdateMedicineCourseInput;
};


export type MutationUpdateMedicineCourseStageArgs = {
  input: UpdateMedicineCourseStageInput;
};


export type MutationUpdateMobileClientStateArgs = {
  input: UpdateMobileClientStateInput;
};


export type MutationUpdateNotificationSettingsArgs = {
  input: UpdateNotificationSettingsInput;
};


export type MutationUpdateOrganisationArgs = {
  input: UpdateOrganisationInput;
};


export type MutationUpdatePartnerDeliveryArgs = {
  input: UpdatePartnerDeliveryInput;
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationUpdatePostArgs = {
  input: UpdatePostInput;
};


export type MutationUpdatePreferredBusinessUnitArgs = {
  input: UpdatePreferredBusinessUnitInput;
};


export type MutationUpdatePreferredBusinessUnitStatusArgs = {
  input: UpdatePreferredBusinessUnitStatusInput;
};


export type MutationUpdatePreviousKeeperArgs = {
  input: UpdatePreviousKeeperInput;
};


export type MutationUpdateSireArgs = {
  input: UpdateSireInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


export type MutationUpdateUserInfoArgs = {
  input: UpdateUserInput;
};


export type MutationUploadCsvArgs = {
  input: UploadCsvInput;
};


export type MutationUploadDiscountGridArgs = {
  input: UploadDiscountGridInput;
};


export type MutationUploadFileSourceArgs = {
  input: UploadFileSourceInput;
};

/** This object holds all Neogen EPD data for a given animal */
export type NeogenEpd = {
  __typename?: 'NeogenEPD';
  animal?: Maybe<Animal>;
  averageDailyGainAcc?: Maybe<Scalars['Decimal']>;
  averageDailyGainEpd?: Maybe<Scalars['Decimal']>;
  averageDailyGainPct?: Maybe<Scalars['Int']>;
  birthWeightAcc?: Maybe<Scalars['Decimal']>;
  birthWeightEpd?: Maybe<Scalars['Decimal']>;
  birthWeightPct?: Maybe<Scalars['Int']>;
  fatAcc?: Maybe<Scalars['Decimal']>;
  fatEpd?: Maybe<Scalars['Decimal']>;
  fatPct?: Maybe<Scalars['Int']>;
  fx?: Maybe<Scalars['Decimal']>;
  hotCarcassWeightAcc?: Maybe<Scalars['Decimal']>;
  hotCarcassWeightEpd?: Maybe<Scalars['Decimal']>;
  hotCarcassWeightPct?: Maybe<Scalars['Int']>;
  marblingAcc?: Maybe<Scalars['Decimal']>;
  marblingEpd?: Maybe<Scalars['Decimal']>;
  marblingPct?: Maybe<Scalars['Int']>;
  milkAcc?: Maybe<Scalars['Decimal']>;
  milkEpd?: Maybe<Scalars['Decimal']>;
  milkPct?: Maybe<Scalars['Int']>;
  residualFeedIntakeAcc?: Maybe<Scalars['Decimal']>;
  residualFeedIntakeEpd?: Maybe<Scalars['Decimal']>;
  residualFeedIntakePct?: Maybe<Scalars['Int']>;
  ribeyeAreaAcc?: Maybe<Scalars['Decimal']>;
  ribeyeAreaEpd?: Maybe<Scalars['Decimal']>;
  ribeyeAreaPct?: Maybe<Scalars['Int']>;
  totalIndex?: Maybe<Scalars['Decimal']>;
  weaningWeightAcc?: Maybe<Scalars['Decimal']>;
  weaningWeightEpd?: Maybe<Scalars['Decimal']>;
  weaningWeightPct?: Maybe<Scalars['Int']>;
};

export type NewsletterEmailSettings = {
  __typename?: 'NewsletterEmailSettings';
  /** Newsletter frequency */
  frequency?: Maybe<Scalars['String']>;
  isEmail?: Maybe<Scalars['Boolean']>;
  /** Also may be interpreted as 'post' type */
  isMarketing?: Maybe<Scalars['Boolean']>;
};

export type Notification = {
  __typename?: 'Notification';
  addressee?: Maybe<BusinessUnit>;
  attachment?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['GenericScalar']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /** Is read by current user */
  isRead?: Maybe<Scalars['Boolean']>;
  metaData?: Maybe<Scalars['JSONString']>;
  /** User ids whom read this notification/message */
  readBy?: Maybe<Array<Maybe<Scalars['Int']>>>;
  referenceId?: Maybe<Scalars['String']>;
  /** Base type name which this entity related to. Available choices are: LOT, WANT, ANIMAL, GROUP, OFFER */
  relatedToSlug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  toSpecificUser?: Maybe<User>;
  type: NotificationType;
  updatedAt: Scalars['DateTime'];
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NotificationEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  unreadAnimalsCount?: Maybe<Scalars['Int']>;
  unreadCount?: Maybe<Scalars['Int']>;
  unreadFavouriteCount?: Maybe<Scalars['Int']>;
  unreadFieldsCount?: Maybe<Scalars['Int']>;
  unreadGroupsCount?: Maybe<Scalars['Int']>;
  unreadIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  unreadLotsCount?: Maybe<Scalars['Int']>;
  unreadMyAnimalsCount?: Maybe<Scalars['Int']>;
  unreadMyTradingCount?: Maybe<Scalars['Int']>;
  unreadPurchasesCount?: Maybe<Scalars['Int']>;
  unreadWantsCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Notification` and its cursor. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Notification>;
};

export type NotificationSettingItem = {
  __typename?: 'NotificationSettingItem';
  isEmail?: Maybe<Scalars['Boolean']>;
  /** Is push notifications enabled */
  isSiteNotification?: Maybe<Scalars['Boolean']>;
  notificationTypes?: Maybe<Array<Maybe<NotificationSettingItemType>>>;
};

export type NotificationSettingItemType = {
  __typename?: 'NotificationSettingItemType';
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  animalActivity?: Maybe<NotificationSettingItem>;
  dailyDigest?: Maybe<NotificationSettingItem>;
  id: Scalars['ID'];
  integrations?: Maybe<NotificationSettingItem>;
  isMarketingEmails: Scalars['Boolean'];
  isNewsEmails: Scalars['Boolean'];
  isProductEmails: Scalars['Boolean'];
  isResearchEmails: Scalars['Boolean'];
  isSystemEmails: Scalars['Boolean'];
  newsletter?: Maybe<NewsletterEmailSettings>;
  systemNotificationSettings?: Maybe<Scalars['JSONString']>;
  trading?: Maybe<NotificationSettingItem>;
  user?: Maybe<User>;
};

/** An enumeration. */
export enum NotificationType {
  File = 'FILE',
  Image = 'IMAGE',
  Text = 'TEXT'
}

export type NotificationTypeItem = {
  __typename?: 'NotificationTypeItem';
  category?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Offer = {
  __typename?: 'Offer';
  actualStatus?: Maybe<Scalars['String']>;
  businessUnit?: Maybe<BusinessUnit>;
  collectionDate?: Maybe<Scalars['Date']>;
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  currency?: Maybe<Currency>;
  /** @deprecated Deprecated */
  forwardcontractSet: Array<ForwardContract>;
  hasAcceptedListing: Scalars['Boolean'];
  hasFeedback?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  invoice?: Maybe<Invoice>;
  /** @deprecated Do not use it now */
  invoiceId?: Maybe<Scalars['Int']>;
  /** @deprecated Do not use it now */
  invoiceStatus?: Maybe<Scalars['String']>;
  /** it will be not null if this offer is made to lot */
  lot?: Maybe<Lot>;
  /** @deprecated Do not use it now */
  lotBasedOnWant?: Maybe<PublicLot>;
  /** @deprecated Do not use it now */
  lotId?: Maybe<Scalars['Int']>;
  /** @deprecated Do not use it now */
  lotStatus?: Maybe<Scalars['String']>;
  notifications?: Maybe<NotificationConnection>;
  offeredNumber: Scalars['Int'];
  price?: Maybe<Scalars['Float']>;
  priceUnit?: Maybe<OfferPriceUnit>;
  /** @deprecated Do not use it now, use produced_lot_interface */
  producedLot?: Maybe<PublicLot>;
  /** Lot that was created using want after accepting this offer */
  producedLotInterface?: Maybe<Lot>;
  /** @deprecated Do not use it now */
  purchaseOfferId?: Maybe<Scalars['Int']>;
  /** @deprecated Do not use it now */
  purchaseOfferStatus?: Maybe<Scalars['String']>;
  readBy: Array<User>;
  responseDate?: Maybe<Scalars['DateTime']>;
  status: OfferStatus;
  totalPriceOnCreation?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  unreadNotificationsCount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  /**
   * it will be not null if this offer is made to want
   * @deprecated RFL
   */
  want?: Maybe<Want>;
};


export type OfferNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type OfferConnection = {
  __typename?: 'OfferConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OfferEdge>>;
  offersCount?: Maybe<Scalars['Int']>;
  offersUnreadCount?: Maybe<Scalars['Int']>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Offer` and its cursor. */
export type OfferEdge = {
  __typename?: 'OfferEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Offer>;
};

export type OfferMarkAsReadInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type OfferMarkAsReadPayload = {
  __typename?: 'OfferMarkAsReadPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum OfferPriceUnit {
  Head = 'HEAD',
  Kg = 'KG',
  Total = 'TOTAL'
}

/** An enumeration. */
export enum OfferStatus {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type OnboardAnimalInput = {
  alternativeId?: InputMaybe<Scalars['String']>;
  animalId?: InputMaybe<Scalars['UUID']>;
  animalType: Scalars['String'];
  arrivedAt: Scalars['DateTime'];
  birthWeight?: InputMaybe<Scalars['Decimal']>;
  breeds: Array<Scalars['ID']>;
  brucellosisId?: InputMaybe<Scalars['String']>;
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  conditions?: InputMaybe<Array<Scalars['ID']>>;
  dam?: InputMaybe<Scalars['ID']>;
  deathDestinationAddress?: InputMaybe<Scalars['String']>;
  deathDestinationName?: InputMaybe<Scalars['String']>;
  deathDestinationPostcode?: InputMaybe<Scalars['String']>;
  deathDisposalCost?: InputMaybe<Scalars['Decimal']>;
  deathReason?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dob: Scalars['DateTime'];
  eId?: InputMaybe<Scalars['String']>;
  field: Scalars['ID'];
  group?: InputMaybe<Scalars['ID']>;
  herdDoggId?: InputMaybe<Scalars['String']>;
  isCastrated?: InputMaybe<Scalars['Boolean']>;
  isDead: Scalars['Boolean'];
  isMale: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  passportNumber: Scalars['String'];
  pedigreeId?: InputMaybe<Scalars['String']>;
  previousKeeper?: InputMaybe<Scalars['ID']>;
  purchasePrice?: InputMaybe<Scalars['Decimal']>;
  sireGroup?: InputMaybe<Scalars['ID']>;
  tagValues?: InputMaybe<Array<AnimalTagAssignmentInputType>>;
  tattoo?: InputMaybe<Scalars['String']>;
  trichId?: InputMaybe<Scalars['String']>;
  tsuBarcode?: InputMaybe<Scalars['String']>;
  uhfId?: InputMaybe<Scalars['String']>;
  visualId?: InputMaybe<Scalars['String']>;
};

/**
 * Create a new on farm asset with validation appropriate for an animal which
 * has been purchased or otherwise not born on farm.
 */
export type OnboardAnimalPayload = {
  __typename?: 'OnboardAnimalPayload';
  animal?: Maybe<Animal>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type OptionChoice = {
  __typename?: 'OptionChoice';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type OrderBy = {
  desc?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Organisation = {
  __typename?: 'Organisation';
  businessType?: Maybe<BusinessType>;
  businessUnits: Array<BusinessUnit>;
  country?: Maybe<Country>;
  currency?: Maybe<Currency>;
  id: Scalars['ID'];
  members: Array<User>;
  name?: Maybe<Scalars['String']>;
  numberOfFarms?: Maybe<Scalars['Int']>;
  owner?: Maybe<User>;
};

export type OrganisationBusinessUnits = {
  __typename?: 'OrganisationBusinessUnits';
  businessUnits?: Maybe<Array<Maybe<BusinessUnit>>>;
  organisation?: Maybe<Organisation>;
};

export type OrganisationMember = {
  __typename?: 'OrganisationMember';
  id: Scalars['ID'];
  organisation?: Maybe<Organisation>;
  user?: Maybe<User>;
};

export type OwnLot = Lot & {
  __typename?: 'OwnLot';
  /** Accepted offer */
  acceptedOffer?: Maybe<Offer>;
  accreditations: Array<Accreditation>;
  /** @deprecated Not using now, will be removed in next release. */
  actualCloseDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated Not using now, will be removed in next release. */
  actualSellPrice?: Maybe<Scalars['Float']>;
  advertDetails?: Maybe<Scalars['JSONString']>;
  animalType?: Maybe<AnimalType>;
  animals?: Maybe<Array<Maybe<Animal>>>;
  animalsAverageAge?: Maybe<Scalars['Float']>;
  animalsAverageCurrentWeight?: Maybe<Scalars['Float']>;
  animalsAverageGrowthRate?: Maybe<Scalars['Decimal']>;
  animalsAverageTimesWeighed?: Maybe<Scalars['Float']>;
  animalsCount?: Maybe<Scalars['Int']>;
  animalsCountBreedAndGender?: Maybe<Array<Maybe<AnimalBreedGender>>>;
  animalsMaxNumberMoves?: Maybe<Scalars['Int']>;
  animalsNumberSires?: Maybe<Scalars['Int']>;
  animalsNumberWithdrawals?: Maybe<Scalars['Int']>;
  assignedAnimals: Array<Animal>;
  breedingStatus?: Maybe<LotBreedingStatus>;
  breeds?: Maybe<Array<Maybe<AnimalBreed>>>;
  businessUnit?: Maybe<BusinessUnitInfo>;
  businessUnitId?: Maybe<Scalars['Int']>;
  canRespondToOffer?: Maybe<Scalars['Boolean']>;
  categoryOfSale?: Maybe<CategoryOfSale>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  currency?: Maybe<Currency>;
  currencyId?: Maybe<Scalars['Int']>;
  declaredAnimalsCount?: Maybe<Scalars['Int']>;
  /** deliveredAnimals that were duplicated from the original and delivered to the Buyer */
  deliveredAnimals?: Maybe<Array<Maybe<Animal>>>;
  deliveryAddress?: Maybe<DeliveryAddressType>;
  description?: Maybe<Scalars['String']>;
  distributionLists: Array<DistributionListObjectType>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  fromOffer?: Maybe<Offer>;
  /** @deprecated RFL */
  fromWant?: Maybe<Want>;
  gradingFile?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  images?: Maybe<Array<Maybe<LotImage>>>;
  imagesThumb?: Maybe<Array<Maybe<LotImageThumbnailType>>>;
  isAcceptOffers: Scalars['Boolean'];
  isAuction: Scalars['Boolean'];
  isBreedrGuaranteed: Scalars['Boolean'];
  isBvdFree: Scalars['Boolean'];
  isCarcass: Scalars['Boolean'];
  isExpired?: Maybe<Scalars['Boolean']>;
  isPublic: Scalars['Boolean'];
  isTbFree?: Maybe<Scalars['Boolean']>;
  isWetChecked: Scalars['Boolean'];
  lotConfigurableSellerMessage?: Maybe<Scalars['String']>;
  lotOffers: Array<Offer>;
  metaData?: Maybe<Scalars['JSONString']>;
  name?: Maybe<Scalars['String']>;
  offers?: Maybe<Array<Maybe<Offer>>>;
  offersPendingCount?: Maybe<Scalars['Int']>;
  pedigreeStatus?: Maybe<LotPedigreeStatus>;
  plannedCloseDate?: Maybe<Scalars['DateTime']>;
  preMovementTestDate?: Maybe<Scalars['DateTime']>;
  price?: Maybe<Scalars['Float']>;
  /** @deprecated Not using now, will be removed in next release. */
  pricePerItem?: Maybe<Scalars['Float']>;
  pricePerKgOnCreation?: Maybe<Scalars['Float']>;
  priceUnit?: Maybe<Scalars['String']>;
  producedByOffer?: Maybe<Offer>;
  publicLink?: Maybe<Scalars['String']>;
  referenceCode?: Maybe<Scalars['String']>;
  shareToGroups: Array<ProducerGroupType>;
  /** Available types: INDIVIDUAL, EVERYONE, PREFERRED_SUPPLIERS, PREFERRED_BUYERS, PRODUCER_GROUPS */
  shareType?: Maybe<Scalars['String']>;
  sharedTo: Array<BusinessUnit>;
  shippingDetails?: Maybe<Scalars['JSONString']>;
  startDate?: Maybe<Scalars['DateTime']>;
  /** Available statuses: BUYER_MADE_PAYMENT_TO_BREEDR, BREEDR_RECEIVED_PAYMENT, SELLER_SENT_ANIMALS, BUYER_RECEIVED_ANIMALS, BREEDR_MADE_PAYMENT, COMPLETED, AWAITING_ANIMALS, ASSIGNED_ANIMALS, MOVED_ANIMALS, AWAITING_GRADING, AWAITING_ACCEPTANCE, CREATED, AWAITING_PAYMENT, SOLD, CLOSED */
  status?: Maybe<Scalars['String']>;
  tbRequirements?: Maybe<Scalars['String']>;
  totalPrice?: Maybe<Scalars['Float']>;
  tradingType?: Maybe<TradingType>;
  tradingTypeId?: Maybe<Scalars['Int']>;
  unreadNotificationsCount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type OwnLotConnection = {
  __typename?: 'OwnLotConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OwnLotEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OwnLot` and its cursor. */
export type OwnLotEdge = {
  __typename?: 'OwnLotEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OwnLot>;
};

/** Deprecated.  RFL. */
export type OwnWant = Want & {
  __typename?: 'OwnWant';
  acceptedAnimalsCount?: Maybe<Scalars['Int']>;
  acceptedNumber?: Maybe<Scalars['Int']>;
  accreditations?: Maybe<Array<Maybe<Accreditation>>>;
  actualBuyPrice?: Maybe<Scalars['Float']>;
  advertDetails?: Maybe<Scalars['GenericScalar']>;
  animalType?: Maybe<AnimalType>;
  animalTypeId?: Maybe<Scalars['Int']>;
  awaitingAcceptanceOffersCount?: Maybe<Scalars['Int']>;
  awaitingGradingOffersCount?: Maybe<Scalars['Int']>;
  awaitingPaymentOffersCount?: Maybe<Scalars['Int']>;
  breedingStatus?: Maybe<Scalars['String']>;
  breeds?: Maybe<Array<Maybe<AnimalBreed>>>;
  businessUnit?: Maybe<BusinessUnitInfo>;
  businessUnitId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  currency?: Maybe<Currency>;
  currencyId?: Maybe<Scalars['Int']>;
  dateNeeded?: Maybe<Scalars['DateTime']>;
  deliveredAnimalsCount?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  discountGrid?: Maybe<DiscountGrid>;
  distributionLists: Array<DistributionListObjectType>;
  files?: Maybe<Array<Maybe<WantFile>>>;
  forwardcontractSet: Array<ForwardContract>;
  hideRequestedNumber: Scalars['Boolean'];
  id?: Maybe<Scalars['Int']>;
  isAcceptOffers?: Maybe<Scalars['Boolean']>;
  isBvdFree?: Maybe<Scalars['Boolean']>;
  isCarcass?: Maybe<Scalars['Boolean']>;
  isForwardContractAllowed?: Maybe<Scalars['Boolean']>;
  isPedigree?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  isStandardDeductions?: Maybe<Scalars['Boolean']>;
  isTbFree?: Maybe<Scalars['Boolean']>;
  isWetChecked: Scalars['Boolean'];
  lastStatus?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['GenericScalar']>;
  name?: Maybe<Scalars['String']>;
  offer?: Maybe<Offer>;
  offerDeadline?: Maybe<Scalars['DateTime']>;
  offerId?: Maybe<Scalars['Int']>;
  pedigreeStatus?: Maybe<Scalars['String']>;
  pendingAnimalsCount?: Maybe<Scalars['Int']>;
  pendingOffersCount?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  priceDetails?: Maybe<Scalars['GenericScalar']>;
  priceNotes?: Maybe<Scalars['String']>;
  priceUnit?: Maybe<Scalars['String']>;
  /** @deprecated Deprecated */
  privateShareCount?: Maybe<Scalars['Int']>;
  /** @deprecated Deprecated */
  privateShareMaxDistance?: Maybe<Scalars['Int']>;
  /** @deprecated Deprecated */
  privateSharePostcode?: Maybe<Scalars['String']>;
  /** Lot created from Wanted item */
  producedLots: Array<OwnLot>;
  recurringDetails?: Maybe<Scalars['GenericScalar']>;
  reference: Scalars['String'];
  requestedNumber?: Maybe<Scalars['Int']>;
  rflId?: Maybe<Scalars['String']>;
  shareToGroups?: Maybe<Array<Maybe<ProducerGroupType>>>;
  shareType?: Maybe<Scalars['String']>;
  sharedTo?: Maybe<Array<Maybe<BusinessUnitInfo>>>;
  shippingTerms?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['Float']>;
  tradingType?: Maybe<TradingType>;
  tradingTypeId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  usage?: Maybe<Scalars['String']>;
  wantOffers: Array<Offer>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PageInfoObjectType = {
  __typename?: 'PageInfoObjectType';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PaginationObjectType = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type PastureType = {
  __typename?: 'PastureType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  businessUnit?: Maybe<BusinessUnitInfo>;
  businessUnitId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserPublicInfo>;
  createdById?: Maybe<Scalars['Int']>;
  extraData?: Maybe<Scalars['GenericScalar']>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  provider: PaymentMethodProvider;
  token?: Maybe<Scalars['String']>;
  type: PaymentMethodType;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum PaymentMethodProvider {
  Manual = 'MANUAL',
  None = 'NONE',
  Revenuecat = 'REVENUECAT',
  Stripe = 'STRIPE'
}

/** An enumeration. */
export enum PaymentMethodType {
  Card = 'CARD',
  Unknown = 'UNKNOWN'
}

export type PendoUser = {
  __typename?: 'PendoUser';
  data?: Maybe<Scalars['GenericScalar']>;
};

export type PerformanceChartData = {
  __typename?: 'PerformanceChartData';
  avg?: Maybe<Array<Maybe<BandChartData>>>;
  contexts?: Maybe<Array<Maybe<Scalars['String']>>>;
  dates?: Maybe<Array<Maybe<TimestampChartData>>>;
  high?: Maybe<Array<Maybe<BandChartData>>>;
  low?: Maybe<Array<Maybe<BandChartData>>>;
  measurements?: Maybe<Array<Maybe<MeasurementChartData>>>;
  predictions?: Maybe<Array<Maybe<WeightChartData>>>;
  references?: Maybe<Array<Maybe<ReferenceChartData>>>;
  targetWeights?: Maybe<Array<Maybe<WeightChartData>>>;
};

export type PieChartDataObjectType = {
  __typename?: 'PieChartDataObjectType';
  data: Array<LabelNumberObjectType>;
  title: Scalars['String'];
};

export type PostToGroupInput = {
  attachment?: InputMaybe<Scalars['Upload']>;
  body: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  producerGroupMember: Scalars['Int'];
  title: Scalars['String'];
};

export type PostToGroupPayload = {
  __typename?: 'PostToGroupPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  post?: Maybe<PostType>;
};

export type PostType = {
  __typename?: 'PostType';
  attachment?: Maybe<Scalars['String']>;
  author?: Maybe<BusinessUnitUser>;
  body?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  producerGroup: ProducerGroupType;
  publish: Scalars['DateTime'];
  title: Scalars['String'];
  updated: Scalars['DateTime'];
};

export type PreferredBusinessUnit = {
  __typename?: 'PreferredBusinessUnit';
  animalTypes: Array<AnimalType>;
  buyer: PublicBusinessUnit;
  buyerId?: Maybe<Scalars['Int']>;
  commonStatus?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdByBusinessUnit?: Maybe<PublicBusinessUnit>;
  createdById?: Maybe<Scalars['Int']>;
  fieldsman?: Maybe<UserPublicInfo>;
  id: Scalars['ID'];
  priceAdjustment?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  supplier: PublicBusinessUnit;
  supplierId?: Maybe<Scalars['Int']>;
  tacDescription?: Maybe<Scalars['String']>;
  tacTitle?: Maybe<Scalars['String']>;
  termsAcceptedAt?: Maybe<Scalars['DateTime']>;
};

export type ProcessedItem = {
  id?: Maybe<Scalars['UUID']>;
};

/** An enumeration. */
export enum ProducerGroupMemberStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ProducerGroupMemberType = {
  __typename?: 'ProducerGroupMemberType';
  businessUnitUser: BusinessUnitUser;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAdmin: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  profilePhoto?: Maybe<Scalars['String']>;
  status: ProducerGroupMemberStatus;
};

export type ProducerGroupType = {
  __typename?: 'ProducerGroupType';
  backgroundPhoto?: Maybe<Scalars['String']>;
  businessUnitUsers: Array<BusinessUnitUser>;
  /** @deprecated Sendbird Is obsolete */
  channelUrl?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isMyGroup?: Maybe<Scalars['Boolean']>;
  memberTypeId?: Maybe<Scalars['Int']>;
  members: Array<ProducerGroupMemberType>;
  name: Scalars['String'];
  owner?: Maybe<BusinessUnitUser>;
  profilePhoto?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type PublicAnimal = AnimalInterface & {
  __typename?: 'PublicAnimal';
  /** It will return age category for the specified date */
  ageCategory?: Maybe<Scalars['String']>;
  animalBreeds: Array<AnimalBreed>;
  animalColour?: Maybe<AnimalColour>;
  animalType?: Maybe<AnimalType>;
  birthInformation?: Maybe<PublicBirthInformation>;
  breedPercentages: Array<BreedPercentage>;
  breeding?: Maybe<Scalars['Boolean']>;
  cphCount?: Maybe<Scalars['Int']>;
  currentWeight?: Maybe<Scalars['Float']>;
  damPassportNumber?: Maybe<Scalars['String']>;
  dateMovedToFarm?: Maybe<Scalars['DateTime']>;
  daysToTargetWeight?: Maybe<Scalars['Float']>;
  dob?: Maybe<Scalars['DateTime']>;
  eId?: Maybe<Scalars['String']>;
  eIdCleaned?: Maybe<Scalars['String']>;
  /** Predicted age for specific date in months. */
  estimatedAgeOn?: Maybe<Scalars['Float']>;
  /** @deprecated [2024-02] no behaviour */
  estimatedCarcassWeight?: Maybe<Scalars['Float']>;
  /** It will return estimated weight for the specified date */
  estimatedWeightOn?: Maybe<Scalars['Float']>;
  gender?: Maybe<Scalars['String']>;
  /** Daily Liveweight Gain: (w2-w1)/(t2-t1) */
  growthRate?: Maybe<Scalars['Float']>;
  /** @deprecated Use growth_rate */
  growthRateSinceConception?: Maybe<Scalars['Float']>;
  /** @deprecated Use growth_rate */
  growthRateSinceLastWeighLog?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['UUID']>;
  images?: Maybe<Array<Maybe<AnimalImage>>>;
  isArchived?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use isRegulatorySynced! */
  isBcmsSynced?: Maybe<Scalars['Boolean']>;
  isCastrated: Scalars['Boolean'];
  isMale: Scalars['Boolean'];
  isPregnant?: Maybe<Scalars['Boolean']>;
  isRegulatorySynced?: Maybe<Scalars['Boolean']>;
  isSoftDeleted?: Maybe<Scalars['Boolean']>;
  lastRegulatorySyncedDate?: Maybe<Scalars['DateTime']>;
  lastWeight?: Maybe<WeightActivityLog>;
  location?: Maybe<PublicDeliveryAddressType>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  passportNumber?: Maybe<Scalars['String']>;
  /** @deprecated Use predictedDateReady! */
  predicatedDateReady?: Maybe<Scalars['Date']>;
  predictedDateReady?: Maybe<Scalars['Date']>;
  predictedWeightAtDelivery?: Maybe<Scalars['Float']>;
  pregnancyDueDate?: Maybe<Scalars['Date']>;
  sexClassification?: Maybe<SexClassification>;
  sirePassportNumber?: Maybe<Scalars['String']>;
  softDeletedAt?: Maybe<Scalars['DateTime']>;
  targetDailyLiveWeightGain?: Maybe<Scalars['Float']>;
  targetLiveWeight?: Maybe<Scalars['Float']>;
  visualId?: Maybe<Scalars['String']>;
  withdrawalEnd?: Maybe<Scalars['DateTime']>;
};


export type PublicAnimalAgeCategoryArgs = {
  date: Scalars['Date'];
};


export type PublicAnimalEstimatedAgeOnArgs = {
  date: Scalars['Date'];
};


export type PublicAnimalEstimatedWeightOnArgs = {
  date: Scalars['Date'];
};

/**
 * PublicBirthInformationObjectType
 * A set of birthinformation that does not contain links to private information via the Animal class.
 */
export type PublicBirthInformation = {
  __typename?: 'PublicBirthInformation';
  birthAbnormalities?: Maybe<Scalars['String']>;
  birthPresentation?: Maybe<Scalars['String']>;
  birthSize?: Maybe<Scalars['String']>;
  birthVigor?: Maybe<Scalars['String']>;
  birthWeight?: Maybe<Scalars['Float']>;
  birthingDifficulty?: Maybe<Scalars['String']>;
  calfColour?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isStillborn: Scalars['Boolean'];
  litterSize: Scalars['String'];
};

export type PublicBusinessUnit = BusinessUnitInterface & {
  __typename?: 'PublicBusinessUnit';
  id: Scalars['ID'];
  name: Scalars['String'];
  primaryLocation?: Maybe<PublicDeliveryAddressType>;
};

export type PublicDeliveryAddressType = DeliveryAddressInterface & {
  __typename?: 'PublicDeliveryAddressType';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  id: Scalars['ID'];
  locationId?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  unitName?: Maybe<Scalars['String']>;
};

export type PublicLot = Lot & {
  __typename?: 'PublicLot';
  /** @deprecated Not using now, will be removed in next release. */
  actualCloseDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated Not using now, will be removed in next release. */
  actualSellPrice?: Maybe<Scalars['Float']>;
  animalType?: Maybe<AnimalType>;
  animals?: Maybe<Array<Maybe<PublicAnimal>>>;
  animalsAverageAge?: Maybe<Scalars['Float']>;
  animalsAverageCurrentWeight?: Maybe<Scalars['Float']>;
  animalsAverageGrowthRate?: Maybe<Scalars['Decimal']>;
  animalsAverageTimesWeighed?: Maybe<Scalars['Float']>;
  animalsCount?: Maybe<Scalars['Int']>;
  animalsCountBreedAndGender?: Maybe<Array<Maybe<AnimalBreedGender>>>;
  animalsMaxNumberMoves?: Maybe<Scalars['Int']>;
  animalsNumberSires?: Maybe<Scalars['Int']>;
  animalsNumberWithdrawals?: Maybe<Scalars['Int']>;
  breeds?: Maybe<Array<Maybe<AnimalBreed>>>;
  businessUnit?: Maybe<BusinessUnitInfo>;
  businessUnitId?: Maybe<Scalars['Int']>;
  categoryOfSale?: Maybe<CategoryOfSale>;
  createdBy?: Maybe<UserPublicInfo>;
  currency?: Maybe<Currency>;
  currencyId?: Maybe<Scalars['Int']>;
  declaredAnimalsCount?: Maybe<Scalars['Int']>;
  /** deliveredAnimals that were duplicated from the original and delivered to the Buyer */
  deliveredAnimals?: Maybe<Array<Maybe<Animal>>>;
  deliveryAddress?: Maybe<DeliveryAddressType>;
  description?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Float']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  gradingFile?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  images?: Maybe<Array<Maybe<LotImage>>>;
  imagesThumb?: Maybe<Array<Maybe<LotImageThumbnailType>>>;
  isAcceptedMyOffer?: Maybe<Scalars['Boolean']>;
  isBreedrGuaranteed: Scalars['Boolean'];
  isExpired?: Maybe<Scalars['Boolean']>;
  isPublic: Scalars['Boolean'];
  isTbFree?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  offers?: Maybe<Array<Maybe<Offer>>>;
  offersPendingCount?: Maybe<Scalars['Int']>;
  plannedCloseDate?: Maybe<Scalars['DateTime']>;
  preMovementTestDate?: Maybe<Scalars['DateTime']>;
  price?: Maybe<Scalars['Float']>;
  /** @deprecated Not using now, will be removed in next release. */
  pricePerItem?: Maybe<Scalars['Float']>;
  pricePerKgOnCreation?: Maybe<Scalars['Float']>;
  priceUnit?: Maybe<Scalars['String']>;
  publicLink?: Maybe<Scalars['String']>;
  referenceCode?: Maybe<Scalars['String']>;
  /** Available types: INDIVIDUAL, EVERYONE, PREFERRED_SUPPLIERS, PREFERRED_BUYERS, PRODUCER_GROUPS */
  shareType?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  /** Available statuses: BUYER_MADE_PAYMENT_TO_BREEDR, BREEDR_RECEIVED_PAYMENT, SELLER_SENT_ANIMALS, BUYER_RECEIVED_ANIMALS, BREEDR_MADE_PAYMENT, COMPLETED, AWAITING_ANIMALS, ASSIGNED_ANIMALS, MOVED_ANIMALS, AWAITING_GRADING, AWAITING_ACCEPTANCE, CREATED, AWAITING_PAYMENT, SOLD, CLOSED */
  status?: Maybe<Scalars['String']>;
  tbRequirements?: Maybe<Scalars['String']>;
  totalPrice?: Maybe<Scalars['Float']>;
  tradingType?: Maybe<TradingType>;
  tradingTypeId?: Maybe<Scalars['Int']>;
  unreadNotificationsCount?: Maybe<Scalars['Int']>;
};


export type PublicLotDistanceArgs = {
  businessUnitId?: InputMaybe<Scalars['Int']>;
};


export type PublicLotIsAcceptedMyOfferArgs = {
  businessUnitId: Scalars['Int'];
};


export type PublicLotOffersArgs = {
  businessUnitId: Scalars['Int'];
};

export type PublicLotConnection = {
  __typename?: 'PublicLotConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PublicLotEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PublicLot` and its cursor. */
export type PublicLotEdge = {
  __typename?: 'PublicLotEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PublicLot>;
};

/** Deprecated.  RFL. */
export type PublicWant = Want & {
  __typename?: 'PublicWant';
  acceptedNumber?: Maybe<Scalars['Int']>;
  accreditations?: Maybe<Array<Maybe<Accreditation>>>;
  advertDetails?: Maybe<Scalars['GenericScalar']>;
  animalType?: Maybe<AnimalType>;
  animalTypeId?: Maybe<Scalars['Int']>;
  breedingStatus?: Maybe<Scalars['String']>;
  breeds?: Maybe<Array<Maybe<AnimalBreed>>>;
  businessUnit?: Maybe<BusinessUnitInfo>;
  businessUnitId?: Maybe<Scalars['Int']>;
  currency?: Maybe<Currency>;
  currencyId?: Maybe<Scalars['Int']>;
  dateNeeded?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discountGrid?: Maybe<DiscountGrid>;
  files?: Maybe<Array<Maybe<WantFile>>>;
  id?: Maybe<Scalars['Int']>;
  isAcceptOffers?: Maybe<Scalars['Boolean']>;
  isBvdFree?: Maybe<Scalars['Boolean']>;
  isCarcass?: Maybe<Scalars['Boolean']>;
  isForwardContractAllowed?: Maybe<Scalars['Boolean']>;
  isPedigree?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  isStandardDeductions?: Maybe<Scalars['Boolean']>;
  isTbFree?: Maybe<Scalars['Boolean']>;
  lastStatus?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['GenericScalar']>;
  name?: Maybe<Scalars['String']>;
  pedigreeStatus?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  priceDetails?: Maybe<Scalars['GenericScalar']>;
  priceNotes?: Maybe<Scalars['String']>;
  priceUnit?: Maybe<Scalars['String']>;
  privateShareCount?: Maybe<Scalars['Int']>;
  privateShareMaxDistance?: Maybe<Scalars['Int']>;
  privateSharePostcode?: Maybe<Scalars['String']>;
  recurringDetails?: Maybe<Scalars['GenericScalar']>;
  requestedNumber?: Maybe<Scalars['Int']>;
  rflId?: Maybe<Scalars['String']>;
  shareType?: Maybe<Scalars['String']>;
  shippingTerms?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['Float']>;
  tradingType?: Maybe<TradingType>;
  tradingTypeId?: Maybe<Scalars['Int']>;
  usage?: Maybe<Scalars['String']>;
};

export type PulledAnimalIdentifierInput = {
  type: IdentifierType;
  value: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  abattoirEstablishments?: Maybe<Array<Maybe<AbattoirEstablishment>>>;
  abattoirParts?: Maybe<Array<Maybe<AbattoirPart>>>;
  abattoirs?: Maybe<AbattoirConnection>;
  accreditation?: Maybe<Array<Maybe<Accreditation>>>;
  activities?: Maybe<ActivityConnection>;
  activityTemplateField?: Maybe<ActivityTemplateField>;
  activityTemplateFieldUnits?: Maybe<Array<Maybe<ActivityTemplateFieldUnit>>>;
  activityTemplates?: Maybe<Array<Maybe<ActivityTemplate>>>;
  activityTypes?: Maybe<Array<Maybe<ActivityType>>>;
  alertTypes?: Maybe<Array<Maybe<AlertType>>>;
  alerts?: Maybe<EntityAlertConnection>;
  americanAngusEpd?: Maybe<AmericanAngusEpd>;
  ancestorTree?: Maybe<Array<Maybe<AncestorType>>>;
  animal?: Maybe<Animal>;
  animalAlerts?: Maybe<Array<Maybe<AnimalAlertObjectType>>>;
  /** @deprecated Use businessUnitBreeds! */
  animalBreeds?: Maybe<Array<Maybe<AnimalBreed>>>;
  animalConditions: Array<AnimalConditionType>;
  animalFilterAlerts?: Maybe<Array<Maybe<AnimalFilterAlertObjectType>>>;
  animalFilters?: Maybe<Array<Maybe<AnimalFilterObjectType>>>;
  animalOffspring?: Maybe<AnimalOffspringObjectType>;
  animalSnapshot?: Maybe<AnimalSnapshotType>;
  animalTags?: Maybe<AnimalTagOverviewConnection>;
  animalTypes?: Maybe<Array<Maybe<AnimalType>>>;
  animalTypesPublic?: Maybe<Array<Maybe<AnimalTypePublic>>>;
  animals?: Maybe<AnimalConnection2>;
  animalsCount?: Maybe<AnimalsCount>;
  /** @deprecated Use animals */
  animalsExtended?: Maybe<AnimalConnection>;
  /** @deprecated Use animals */
  animalsPage?: Maybe<AnimalPagePaginatedType>;
  /** @deprecated Use animals */
  animalsPaginated?: Maybe<AnimalsPaginatedConnection>;
  bankDetails?: Maybe<BankAccountDetailsObjectType>;
  barChartData?: Maybe<BarChartDataObjectType>;
  batchUploadFormat?: Maybe<BatchUploadFormat>;
  batchUploadFormats?: Maybe<Array<BatchUploadFormat>>;
  birthInformation?: Maybe<BirthInformation>;
  blockchainAnimalDataByKillNumber?: Maybe<BlockchainAnimalData>;
  blockchainAnimalDataByPassport?: Maybe<BlockchainAnimalData>;
  breedrBankDetails?: Maybe<BreedrBankAccountDetailsObjectType>;
  breedseek?: Maybe<BreedseekData>;
  businessTypes?: Maybe<Array<Maybe<BusinessType>>>;
  businessUnit?: Maybe<BusinessUnit>;
  businessUnitBreeds?: Maybe<Array<Maybe<AnimalBreed>>>;
  businessUnitInfo?: Maybe<BusinessUnitInfo>;
  businessUnitStatistic?: Maybe<Statistic>;
  businessUnitStatuses?: Maybe<Array<Maybe<BusinessUnitStatus>>>;
  businessUnitTargets?: Maybe<Array<Maybe<BusinessUnitTarget>>>;
  businessUnitUsers?: Maybe<Array<Maybe<BusinessUnitUser>>>;
  businessUnits?: Maybe<Array<Maybe<BusinessUnit>>>;
  buyingLot?: Maybe<PublicLot>;
  buyingLots?: Maybe<PublicLotConnection>;
  calfColours?: Maybe<Array<Maybe<CalfColourObjectType>>>;
  calfulatorInputs?: Maybe<Array<Maybe<CalfulatorObjectType>>>;
  categoriesOfSale?: Maybe<CategoryOfSaleConnection>;
  chartData?: Maybe<ChartDataObjectType>;
  competentAuthorities?: Maybe<Array<Maybe<CompetentAuthority>>>;
  contact?: Maybe<ContactObjectType>;
  contacts?: Maybe<Array<Maybe<ContactObjectType>>>;
  contacts2?: Maybe<ContactsConnection>;
  countBusinessUnits?: Maybe<BusinessUnitCountType>;
  countries?: Maybe<Array<Maybe<Country>>>;
  crushAppSession?: Maybe<CrushAppSessionObjectType>;
  crushAppSessions?: Maybe<CrushAppSessionConnection>;
  currencies?: Maybe<Array<Maybe<Currency>>>;
  dashboard?: Maybe<DashboardObjectType>;
  /** @deprecated Unused */
  dashboards?: Maybe<Array<Maybe<DashboardObjectType>>>;
  debug?: Maybe<DjangoDebug>;
  deliveries?: Maybe<DeliveryConnection>;
  delivery?: Maybe<DeliveryOverviewType>;
  deliveryAddresses?: Maybe<Array<Maybe<DeliveryAddressType>>>;
  /** Returns a list of addresses of delivery partners.  This is to paginate over long sets of partners. */
  deliveryPartnerAddresses?: Maybe<DeliveryPartnerAddressConnection>;
  /** Returns a list of delivery partners that are neighbours of the given business unit. */
  deliveryPartners?: Maybe<DeliveryPartnerConnection>;
  deliveryReasons?: Maybe<DeliveryReasonConnection>;
  deliveryTask?: Maybe<DeliveryTaskType>;
  /** @deprecated RFL */
  discountGrids?: Maybe<Array<Maybe<DiscountGrid>>>;
  distributionList?: Maybe<DistributionListObjectType>;
  distributionLists?: Maybe<DistributionListConnection>;
  download?: Maybe<DownloadObjectType>;
  downloads?: Maybe<DownloadConnection>;
  emptyState?: Maybe<EmptyStateObjectType>;
  estimatedFuturePriceBasedOnWeight?: Maybe<EstimatedFuturePriceType>;
  exportResult?: Maybe<ExportResult>;
  farmDetailChoices?: Maybe<FarmDetailChoices>;
  farmMovements?: Maybe<FarmMovementConnection>;
  farmSystemTask?: Maybe<FarmSystemTaskType>;
  farmSystems?: Maybe<Array<Maybe<FarmSystemType>>>;
  favourites?: Maybe<Array<Maybe<FavouriteObjectType>>>;
  field?: Maybe<Field>;
  fields?: Maybe<Array<Field>>;
  financialTransaction?: Maybe<FinancialTransaction>;
  financialTransactions?: Maybe<FinancialTransactionConnection>;
  /** Download invoice for pay */
  getInvoiceLink?: Maybe<DownloadLink>;
  getRegularWithdrawals?: Maybe<Array<Maybe<RegularWithdrawalType>>>;
  getWithdrawTransactionHistory?: Maybe<Array<Maybe<WithdrawTransactionHistoryType>>>;
  globalFoggle?: Maybe<GlobalFoggleType>;
  group?: Maybe<Group>;
  groupCategories?: Maybe<Array<Maybe<GroupCategoryObjectType>>>;
  groupChartData?: Maybe<GroupChartData>;
  groups?: Maybe<Array<Group>>;
  groupsExtended?: Maybe<GroupExtendedList>;
  hasUnsyncedAnimals?: Maybe<Scalars['Boolean']>;
  howDidYouHearAboutBreedrChoices?: Maybe<Array<Maybe<HowDidYouHearAboutBreedrChoices>>>;
  importResult?: Maybe<ImportResult>;
  integrationSystems?: Maybe<Array<Maybe<IntegrationSystemType>>>;
  intercomCarousels?: Maybe<Array<Maybe<IntercomCarousel>>>;
  inventoryInfo?: Maybe<Array<Maybe<InventoryInfoType>>>;
  invoice?: Maybe<Invoice>;
  isCphUnique?: Maybe<Scalars['Boolean']>;
  itemTransactions?: Maybe<ItemTransactionConnection>;
  lineItem?: Maybe<LineItemType>;
  lineItems?: Maybe<Array<Maybe<LineItemType>>>;
  litterSizes?: Maybe<Array<Maybe<LitterSizeObjectType>>>;
  liveSessions?: Maybe<LiveSessionConnection>;
  mainReport?: Maybe<ReportType>;
  medicine?: Maybe<MedicineType>;
  medicines?: Maybe<Array<Maybe<MedicineType>>>;
  messages?: Maybe<MessageConnection>;
  myAccountBalance?: Maybe<BalanceAccountType>;
  myBankAccounts?: Maybe<Array<Maybe<BankAccountType>>>;
  myLot?: Maybe<OwnLot>;
  myLots?: Maybe<OwnLotConnection>;
  /** @deprecated RFL */
  myWant?: Maybe<Want>;
  /** @deprecated RFL */
  myWants?: Maybe<WantConnection>;
  neogenEpd?: Maybe<NeogenEpd>;
  notificationSettings?: Maybe<NotificationSettings>;
  notificationTypes?: Maybe<Array<Maybe<NotificationTypeItem>>>;
  notifications?: Maybe<NotificationConnection>;
  offers?: Maybe<OfferConnection>;
  /** Gets all business units in organisation related to input bu */
  organisationBusinessUnits?: Maybe<Array<Maybe<BusinessUnit>>>;
  organisations?: Maybe<Array<Maybe<OrganisationBusinessUnits>>>;
  pastureTypes?: Maybe<Array<Maybe<PastureType>>>;
  pendoUser: PendoUser;
  performanceChartData?: Maybe<PerformanceChartData>;
  pieChartData?: Maybe<PieChartDataObjectType>;
  posts?: Maybe<Array<Maybe<PostType>>>;
  preferredBusinessUnit?: Maybe<PreferredBusinessUnit>;
  preferredBusinessUnits?: Maybe<Array<Maybe<PreferredBusinessUnit>>>;
  producerGroup?: Maybe<ProducerGroupType>;
  producerGroups?: Maybe<Array<Maybe<ProducerGroupType>>>;
  publicLot?: Maybe<PublicLot>;
  publicLots?: Maybe<PublicLotConnection>;
  /** @deprecated Use quicksightReport */
  quicksightEmbedUrl?: Maybe<Url>;
  quicksightReport?: Maybe<QuicksightReportType>;
  regions?: Maybe<Array<Maybe<Region>>>;
  regulatoryApprovals: RegulatoryApprovalConnection;
  regulatoryTransactionApprovalSummary?: Maybe<Array<Maybe<RegulatoryTransactionApprovalSummaryType>>>;
  regulatoryTransactionApprovals?: Maybe<Array<Maybe<RegulatoryTransactionApprovalType>>>;
  regulatoryTransactionApprovalsWithWarning?: Maybe<Array<Maybe<RegulatoryTransactionApprovalType>>>;
  regulatoryTransactionWarnings?: Maybe<Array<Maybe<RegulatoryTransactionWarningsObjectType>>>;
  /**
   * Embed URL
   * @deprecated Obsolete, no functionality.
   */
  reportEmbedUrl?: Maybe<Url>;
  reports?: Maybe<Array<ReportType>>;
  roles?: Maybe<Array<Maybe<Role>>>;
  searchBusinessUnits?: Maybe<Array<Maybe<SearchBusinessUnit>>>;
  searchUser?: Maybe<Array<Maybe<UserPublicInfo>>>;
  /** @deprecated Obsolete */
  sendBirdUser?: Maybe<SendBirdUser>;
  settingsFaq?: Maybe<BusinessUnitSettingsFaqType>;
  sexClassifications?: Maybe<Array<Maybe<SexClassification>>>;
  sire?: Maybe<Sire>;
  sires?: Maybe<Array<Maybe<Sire>>>;
  /** @deprecated Obsolete, no functionality. */
  sisenseEmbedUrl?: Maybe<Url>;
  smokeTest?: Maybe<Scalars['String']>;
  stockItem?: Maybe<StockItemListType>;
  stockItems?: Maybe<Array<Maybe<StockItemListType>>>;
  stocktakeAnimals?: Maybe<StocktakeObjectTypeConnection>;
  subscriptionCatalog?: Maybe<SubscriptionCatalogType>;
  subscriptionInvoices?: Maybe<SubscriptionInvoiceConnection>;
  subscriptionStatus: SubscriptionStatusType;
  supplyChainPages?: Maybe<Array<Maybe<SupplyChainPageObjectType>>>;
  tableData?: Maybe<TableDataObjectType>;
  targetWeightType?: Maybe<Array<Maybe<TargetWeightType>>>;
  termsAndConditions?: Maybe<TermsAndConditionsObjectType>;
  tradingTypes?: Maybe<Array<Maybe<TradingType>>>;
  userExists?: Maybe<Scalars['Boolean']>;
  userInfo?: Maybe<User>;
  videoGroups?: Maybe<Array<Maybe<VideoGroupType>>>;
  /** @deprecated RFL */
  wantTemplates?: Maybe<Array<Maybe<WantTemplate>>>;
};


export type QueryAbattoirsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  tradingName?: InputMaybe<Scalars['String']>;
};


export type QueryActivitiesArgs = {
  activityTemplateSlug?: InputMaybe<Scalars['String']>;
  activityTemplateSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  activityTypeSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  after?: InputMaybe<Scalars['String']>;
  animal?: InputMaybe<Scalars['UUID']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnit?: InputMaybe<Scalars['Int']>;
  field?: InputMaybe<Scalars['UUID']>;
  first?: InputMaybe<Scalars['Int']>;
  group?: InputMaybe<Scalars['UUID']>;
  isChartable?: InputMaybe<Scalars['Boolean']>;
  isSystemOnly?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  lot?: InputMaybe<Scalars['Int']>;
  publicOnly?: InputMaybe<Scalars['Boolean']>;
  updatedFrom?: InputMaybe<Scalars['DateTime']>;
};


export type QueryActivityTemplateFieldArgs = {
  id: Scalars['Int'];
};


export type QueryActivityTemplatesArgs = {
  animalTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  businessUnit?: InputMaybe<Scalars['Int']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  isOwnOnly?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Scalars['String']>;
  species?: InputMaybe<Scalars['Int']>;
};


export type QueryActivityTypesArgs = {
  businessUnit: Scalars['Int'];
};


export type QueryAlertsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnitId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  isDueOverdueOnly?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAmericanAngusEpdArgs = {
  animal: Scalars['UUID'];
};


export type QueryAncestorTreeArgs = {
  animalId: Scalars['UUID'];
  depth: Scalars['Int'];
};


export type QueryAnimalArgs = {
  id: Scalars['UUID'];
};


export type QueryAnimalAlertsArgs = {
  animalId?: InputMaybe<Scalars['UUID']>;
  businessUnitId: Scalars['Int'];
};


export type QueryAnimalConditionsArgs = {
  businessUnit: Scalars['Int'];
};


export type QueryAnimalFilterAlertsArgs = {
  businessUnitId: Scalars['Int'];
};


export type QueryAnimalFiltersArgs = {
  animalTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  businessUnitId: Scalars['Int'];
};


export type QueryAnimalOffspringArgs = {
  animalId: Scalars['String'];
  businessUnitId: Scalars['Int'];
};


export type QueryAnimalSnapshotArgs = {
  businessUnitId: Scalars['Int'];
  fileVersion?: InputMaybe<Scalars['String']>;
};


export type QueryAnimalTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  animalTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  businessUnitId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryAnimalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  animalIds?: InputMaybe<Array<Scalars['ID']>>;
  animalTags?: InputMaybe<Array<Scalars['ID']>>;
  animalTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  breed?: InputMaybe<Scalars['ID']>;
  businessUnitId: Scalars['Int'];
  eId?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<Scalars['UUID']>;
  first?: InputMaybe<Scalars['Int']>;
  group?: InputMaybe<Scalars['UUID']>;
  isInWithdrawal?: InputMaybe<Scalars['Boolean']>;
  isMale?: InputMaybe<Scalars['Boolean']>;
  isPregnant?: InputMaybe<Scalars['Boolean']>;
  isRegulatorySynced?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  maxAgeMonths?: InputMaybe<Scalars['Int']>;
  maxDaysSinceWeighed?: InputMaybe<Scalars['Int']>;
  maxDeliveryDate?: InputMaybe<Scalars['DateTime']>;
  maxDob?: InputMaybe<Scalars['DateTime']>;
  maxDof?: InputMaybe<Scalars['DateTime']>;
  maxEstimatedWeight?: InputMaybe<Scalars['Float']>;
  maxGrowthRate?: InputMaybe<Scalars['Float']>;
  maxLastWeight?: InputMaybe<Scalars['Float']>;
  maxPregnancyDueDate?: InputMaybe<Scalars['DateTime']>;
  maxRegulatorySyncDate?: InputMaybe<Scalars['DateTime']>;
  minAgeMonths?: InputMaybe<Scalars['Int']>;
  minDaysSinceWeighed?: InputMaybe<Scalars['Int']>;
  minDeliveryDate?: InputMaybe<Scalars['DateTime']>;
  minDob?: InputMaybe<Scalars['DateTime']>;
  minDof?: InputMaybe<Scalars['DateTime']>;
  minEstimatedWeight?: InputMaybe<Scalars['Float']>;
  minGrowthRate?: InputMaybe<Scalars['Float']>;
  minLastWeight?: InputMaybe<Scalars['Float']>;
  minPregnancyDueDate?: InputMaybe<Scalars['DateTime']>;
  minRegulatorySyncDate?: InputMaybe<Scalars['DateTime']>;
  minUpdated?: InputMaybe<Scalars['DateTime']>;
  orderBy?: InputMaybe<Array<AnimalSorting>>;
  passportNumber?: InputMaybe<Scalars['String']>;
  pedigreeId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  searchIds?: InputMaybe<Array<IdentifierType>>;
  sexClassification?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AnimalStatus>;
  visualId?: InputMaybe<Scalars['String']>;
};


export type QueryAnimalsCountArgs = {
  animalTypeId?: InputMaybe<Scalars['Int']>;
  animalTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  businessUnit?: InputMaybe<Scalars['Int']>;
};


export type QueryAnimalsExtendedArgs = {
  animalTags?: InputMaybe<Array<Scalars['ID']>>;
  animalTypeId?: InputMaybe<Scalars['Int']>;
  animalTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  businessUnitId?: InputMaybe<Scalars['Int']>;
  field?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<Scalars['UUID']>;
  isDead?: InputMaybe<Scalars['Boolean']>;
  isMale?: InputMaybe<Scalars['Boolean']>;
  isOnFarm?: InputMaybe<Scalars['Boolean']>;
  isPregnant?: InputMaybe<Scalars['Boolean']>;
  isWasOwned?: InputMaybe<Scalars['Boolean']>;
  maxDob?: InputMaybe<Scalars['DateTime']>;
  maxDof?: InputMaybe<Scalars['DateTime']>;
  minDob?: InputMaybe<Scalars['DateTime']>;
  minDof?: InputMaybe<Scalars['DateTime']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedFrom?: InputMaybe<Scalars['DateTime']>;
};


export type QueryAnimalsPageArgs = {
  animalTags?: InputMaybe<Array<Scalars['ID']>>;
  animalTypeId?: InputMaybe<Scalars['Int']>;
  animalTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  businessUnit?: InputMaybe<Scalars['Int']>;
  fetchDead?: InputMaybe<Scalars['Boolean']>;
  fetchRemoved?: InputMaybe<Scalars['Boolean']>;
  fetchSoftDeleted?: InputMaybe<Scalars['Boolean']>;
  field?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<Scalars['UUID']>;
  isMale?: InputMaybe<Scalars['Boolean']>;
  isPregnant?: InputMaybe<Scalars['Boolean']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  maxDob?: InputMaybe<Scalars['DateTime']>;
  maxDof?: InputMaybe<Scalars['DateTime']>;
  minDob?: InputMaybe<Scalars['DateTime']>;
  minDof?: InputMaybe<Scalars['DateTime']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryAnimalsPaginatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  animalTags?: InputMaybe<Array<Scalars['ID']>>;
  animalTypeId?: InputMaybe<Scalars['Int']>;
  animalTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  before?: InputMaybe<Scalars['String']>;
  businessUnit?: InputMaybe<Scalars['Int']>;
  fetchDead?: InputMaybe<Scalars['Boolean']>;
  fetchRemoved?: InputMaybe<Scalars['Boolean']>;
  fetchSoftDeleted?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
};


export type QueryBankDetailsArgs = {
  businessUnitId?: InputMaybe<Scalars['Int']>;
};


export type QueryBarChartDataArgs = {
  businessUnitId: Scalars['Int'];
  chartSlug: Scalars['String'];
  dashboardSlug: Scalars['String'];
  filters?: InputMaybe<Scalars['GenericScalar']>;
};


export type QueryBatchUploadFormatArgs = {
  businessUnit: Scalars['ID'];
  slug: Scalars['String'];
};


export type QueryBatchUploadFormatsArgs = {
  animalTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  businessUnitId: Scalars['Int'];
  onlyUploadable?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBirthInformationArgs = {
  id: Scalars['UUID'];
};


export type QueryBlockchainAnimalDataByKillNumberArgs = {
  date: Scalars['Date'];
  killNumber: Scalars['String'];
};


export type QueryBlockchainAnimalDataByPassportArgs = {
  passportNumber: Scalars['String'];
};


export type QueryBreedseekArgs = {
  animal: Scalars['UUID'];
};


export type QueryBusinessUnitArgs = {
  businessUnit: Scalars['Int'];
};


export type QueryBusinessUnitBreedsArgs = {
  animalTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  businessUnitId?: InputMaybe<Scalars['Int']>;
};


export type QueryBusinessUnitInfoArgs = {
  businessUnit: Scalars['Int'];
};


export type QueryBusinessUnitStatisticArgs = {
  businessUnit: Scalars['Int'];
  periodStatus: Scalars['String'];
};


export type QueryBusinessUnitTargetsArgs = {
  animalTypeId?: InputMaybe<Scalars['Int']>;
  businessUnitId?: InputMaybe<Scalars['Int']>;
};


export type QueryBusinessUnitUsersArgs = {
  businessUnitId?: InputMaybe<Scalars['Int']>;
};


export type QueryBuyingLotArgs = {
  businessUnit: Scalars['Int'];
  id: Scalars['Int'];
};


export type QueryBuyingLotsArgs = {
  after?: InputMaybe<Scalars['String']>;
  animalType?: InputMaybe<Scalars['Float']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnit?: InputMaybe<Scalars['Int']>;
  categoryOfSale?: InputMaybe<Scalars['Float']>;
  distance?: InputMaybe<Scalars['Float']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  isBreedrGuaranteed?: InputMaybe<Scalars['Boolean']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  showExpired?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCategoriesOfSaleArgs = {
  after?: InputMaybe<Scalars['String']>;
  animalType?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryChartDataArgs = {
  businessUnitId: Scalars['Int'];
  chartSlug: Scalars['String'];
  dashboardSlug: Scalars['String'];
  filters?: InputMaybe<Scalars['GenericScalar']>;
};


export type QueryContactArgs = {
  businessUnitId: Scalars['Int'];
  id: Scalars['Int'];
};


export type QueryContactsArgs = {
  businessUnit: Scalars['Int'];
  contactType?: InputMaybe<Scalars['String']>;
};


export type QueryContacts2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnit: Scalars['ID'];
  contactType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCountBusinessUnitsArgs = {
  includePreferredSuppliers?: InputMaybe<Scalars['Boolean']>;
  postcode: Scalars['String'];
  radius: Scalars['Int'];
};


export type QueryCrushAppSessionArgs = {
  businessUnitId: Scalars['Int'];
  id: Scalars['UUID'];
};


export type QueryCrushAppSessionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  animalTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  before?: InputMaybe<Scalars['String']>;
  businessUnitId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryDashboardArgs = {
  dashboardSlug: Scalars['String'];
};


export type QueryDeliveriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnit: Scalars['ID'];
  direction?: InputMaybe<DeliveryDirectionEnum>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<DeliverySortingEnum>>>;
  status?: InputMaybe<DeliveryStatusEnum>;
  statuses?: InputMaybe<Array<DeliveryStatusEnum>>;
};


export type QueryDeliveryArgs = {
  businessUnit: Scalars['ID'];
  delivery: Scalars['ID'];
};


export type QueryDeliveryAddressesArgs = {
  businessUnit: Scalars['Int'];
};


export type QueryDeliveryPartnerAddressesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnit: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DeliveryPartnerAddressSortingEnum>>;
};


export type QueryDeliveryPartnersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnit: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryDeliveryReasonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnit: Scalars['ID'];
  directions?: InputMaybe<Array<DeliveryDirectionEnum>>;
  first?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryDeliveryTaskArgs = {
  businessUnit: Scalars['ID'];
  task: Scalars['ID'];
};


export type QueryDiscountGridsArgs = {
  businessUnit: Scalars['Int'];
};


export type QueryDistributionListArgs = {
  businessUnit: Scalars['Int'];
  id: Scalars['Int'];
};


export type QueryDistributionListsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnit: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryDownloadArgs = {
  businessUnitId: Scalars['Int'];
  id: Scalars['ID'];
};


export type QueryDownloadsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnitId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryEmptyStateArgs = {
  animalType: Scalars['Int'];
  businessUnitId: Scalars['Int'];
  page: Scalars['String'];
  platform: Scalars['String'];
};


export type QueryEstimatedFuturePriceBasedOnWeightArgs = {
  collectionDate: Scalars['Date'];
  lot: Scalars['Int'];
  offerPricePerWeightUnit: Scalars['Float'];
};


export type QueryExportResultArgs = {
  exportId: Scalars['ID'];
};


export type QueryFarmMovementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  animal?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnit: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxDate?: InputMaybe<Scalars['DateTime']>;
  minDate?: InputMaybe<Scalars['DateTime']>;
  orderBy?: InputMaybe<Array<FarmMovementSortingEnumType>>;
};


export type QueryFarmSystemTaskArgs = {
  taskId: Scalars['Int'];
};


export type QueryFarmSystemsArgs = {
  farm: Scalars['Int'];
  isAutomatedSystem?: InputMaybe<Scalars['Boolean']>;
  systemType?: InputMaybe<Scalars['String']>;
};


export type QueryFavouritesArgs = {
  businessUnitId?: InputMaybe<Scalars['Int']>;
  itemType?: InputMaybe<Scalars['String']>;
};


export type QueryFieldArgs = {
  id: Scalars['UUID'];
};


export type QueryFieldsArgs = {
  businessUnitId?: InputMaybe<Scalars['Int']>;
};


export type QueryFinancialTransactionArgs = {
  businessUnit: Scalars['Int'];
  id: Scalars['UUID'];
};


export type QueryFinancialTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnit: Scalars['ID'];
  desc?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<FinancialTransactionsSortByEnumType>;
};


export type QueryGetInvoiceLinkArgs = {
  businessUnit: Scalars['Int'];
  invoice: Scalars['Int'];
};


export type QueryGetRegularWithdrawalsArgs = {
  businessUnit: Scalars['Int'];
};


export type QueryGetWithdrawTransactionHistoryArgs = {
  balanceAccount: Scalars['Int'];
};


export type QueryGlobalFoggleArgs = {
  featureName: Scalars['String'];
};


export type QueryGroupArgs = {
  businessUnit: Scalars['Int'];
  group: Scalars['UUID'];
};


export type QueryGroupChartDataArgs = {
  animals?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  businessUnit: Scalars['Int'];
  group: Scalars['UUID'];
};


export type QueryGroupsArgs = {
  animalTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  businessUnitId?: InputMaybe<Scalars['Int']>;
  fieldId?: InputMaybe<Scalars['ID']>;
};


export type QueryGroupsExtendedArgs = {
  animalTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  businessUnitId?: InputMaybe<Scalars['Int']>;
  fieldId?: InputMaybe<Scalars['ID']>;
};


export type QueryHasUnsyncedAnimalsArgs = {
  businessUnitId: Scalars['Int'];
};


export type QueryImportResultArgs = {
  task: Scalars['String'];
};


export type QueryIntegrationSystemsArgs = {
  farm: Scalars['Int'];
  isAutomatedSystem?: InputMaybe<Scalars['Boolean']>;
  systemType?: InputMaybe<Scalars['String']>;
};


export type QueryInventoryInfoArgs = {
  businessUnitId: Scalars['Int'];
  sku?: InputMaybe<Scalars['String']>;
};


export type QueryInvoiceArgs = {
  id: Scalars['Int'];
};


export type QueryIsCphUniqueArgs = {
  cph: Scalars['String'];
};


export type QueryItemTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  batchNumber?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnitId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  stockItemId: Scalars['UUID'];
};


export type QueryLineItemArgs = {
  businessUnitId: Scalars['Int'];
  id: Scalars['UUID'];
};


export type QueryLineItemsArgs = {
  businessUnitId: Scalars['Int'];
  stockItemId?: InputMaybe<Scalars['UUID']>;
};


export type QueryLiveSessionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnitId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMainReportArgs = {
  businessUnit: Scalars['Int'];
};


export type QueryMedicineArgs = {
  businessUnitId?: InputMaybe<Scalars['Int']>;
  gtinNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  skuSource?: InputMaybe<Scalars['String']>;
};


export type QueryMedicinesArgs = {
  barcode?: InputMaybe<Scalars['String']>;
  businessUnitId?: InputMaybe<Scalars['Int']>;
  commonName?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  skuSource?: InputMaybe<Scalars['String']>;
};


export type QueryMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  isSent?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMyAccountBalanceArgs = {
  businessUnit: Scalars['Int'];
};


export type QueryMyBankAccountsArgs = {
  balanceAccount: Scalars['Int'];
};


export type QueryMyLotArgs = {
  businessUnit: Scalars['Int'];
  id: Scalars['Int'];
};


export type QueryMyLotsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnit: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMyWantArgs = {
  id: Scalars['Int'];
};


export type QueryMyWantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnit: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryNeogenEpdArgs = {
  animal: Scalars['UUID'];
};


export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnit: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  notifyTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryOffersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lot?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  want?: InputMaybe<Scalars['Int']>;
};


export type QueryOrganisationBusinessUnitsArgs = {
  businessUnit: Scalars['Int'];
};


export type QueryPendoUserArgs = {
  businessUnitId: Scalars['Int'];
  format: Scalars['Int'];
};


export type QueryPerformanceChartDataArgs = {
  animal: Scalars['UUID'];
};


export type QueryPieChartDataArgs = {
  businessUnitId: Scalars['Int'];
  chartSlug: Scalars['String'];
  dashboardSlug: Scalars['String'];
  filters?: InputMaybe<Scalars['GenericScalar']>;
};


export type QueryPostsArgs = {
  group: Scalars['Int'];
};


export type QueryPreferredBusinessUnitArgs = {
  businessUnit: Scalars['Int'];
  id: Scalars['Int'];
};


export type QueryPreferredBusinessUnitsArgs = {
  businessUnit: Scalars['Int'];
};


export type QueryProducerGroupArgs = {
  businessUnit: Scalars['Int'];
  groupId: Scalars['Int'];
};


export type QueryProducerGroupsArgs = {
  businessUnit: Scalars['Int'];
};


export type QueryPublicLotArgs = {
  id: Scalars['Int'];
};


export type QueryPublicLotsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryQuicksightEmbedUrlArgs = {
  businessUnit: Scalars['Int'];
  embedUrl: Scalars['String'];
};


export type QueryQuicksightReportArgs = {
  businessUnit: Scalars['Int'];
  report: Scalars['ID'];
};


export type QueryRegionsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryRegulatoryApprovalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnitId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryRegulatoryTransactionApprovalSummaryArgs = {
  businessUnitId: Scalars['Int'];
};


export type QueryRegulatoryTransactionApprovalsArgs = {
  businessUnitId: Scalars['Int'];
  statuses?: InputMaybe<Array<Scalars['String']>>;
  transactionType: Scalars['String'];
};


export type QueryRegulatoryTransactionApprovalsWithWarningArgs = {
  businessUnitId: Scalars['Int'];
  transactionType: Scalars['String'];
};


export type QueryRegulatoryTransactionWarningsArgs = {
  businessUnitId: Scalars['Int'];
};


export type QueryReportEmbedUrlArgs = {
  animal?: InputMaybe<Scalars['Int']>;
  animalTypes?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  animals?: InputMaybe<Array<Scalars['Int']>>;
  businessUnit: Scalars['Int'];
  embedUrl: Scalars['String'];
  producerGroup?: InputMaybe<Scalars['Int']>;
};


export type QueryReportsArgs = {
  businessUnit?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Scalars['String']>;
  species?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchBusinessUnitsArgs = {
  excludeBusinessUnitId?: InputMaybe<Scalars['Int']>;
  excludeBusinessUnitIds?: InputMaybe<Array<Scalars['Int']>>;
  preferredSuppliersBuyerId?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QuerySearchUserArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySettingsFaqArgs = {
  businessUnitId: Scalars['Int'];
};


export type QuerySexClassificationsArgs = {
  animalTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  businessUnitId: Scalars['Int'];
};


export type QuerySireArgs = {
  businessUnitId: Scalars['Int'];
  id: Scalars['UUID'];
};


export type QuerySiresArgs = {
  businessUnitId: Scalars['Int'];
};


export type QuerySisenseEmbedUrlArgs = {
  embedUrl: Scalars['String'];
};


export type QuerySmokeTestArgs = {
  task: Scalars['String'];
};


export type QueryStockItemArgs = {
  businessUnitId: Scalars['Int'];
  id: Scalars['UUID'];
};


export type QueryStockItemsArgs = {
  businessUnitId: Scalars['Int'];
};


export type QueryStocktakeAnimalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  animalTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  before?: InputMaybe<Scalars['String']>;
  businessUnit?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  onFarmDate?: InputMaybe<Scalars['Date']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


export type QuerySubscriptionCatalogArgs = {
  businessUnit: Scalars['ID'];
  purpose: SubscriptionCatalogPurposeEnum;
};


export type QuerySubscriptionInvoicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnit: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySubscriptionStatusArgs = {
  businessUnitId: Scalars['Int'];
};


export type QuerySupplyChainPagesArgs = {
  businessUnit: Scalars['Int'];
};


export type QueryTableDataArgs = {
  businessUnitId: Scalars['Int'];
  chartSlug: Scalars['String'];
  dashboardSlug: Scalars['String'];
  filters?: InputMaybe<Scalars['GenericScalar']>;
  orderBy?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationObjectType>;
};


export type QueryTermsAndConditionsArgs = {
  tacType: Scalars['String'];
};


export type QueryUserExistsArgs = {
  email: Scalars['String'];
};


export type QueryWantTemplatesArgs = {
  businessUnit: Scalars['Int'];
};

export type QuicksightParameter = {
  __typename?: 'QuicksightParameter';
  code?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Quicksight report including a private url to embed the report. */
export type QuicksightReportType = {
  __typename?: 'QuicksightReportType';
  embedUrl: Scalars['String'];
  parameters: Array<QuicksightParameter>;
};

export type ReInviteUserInput = {
  businessUnitUser: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ReInviteUserPayload = {
  __typename?: 'ReInviteUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ReferenceChartData = {
  __typename?: 'ReferenceChartData';
  context?: Maybe<Array<Maybe<Scalars['String']>>>;
  label?: Maybe<Scalars['String']>;
  /** @deprecated RFL feature is obsolete. */
  rfl?: Maybe<Scalars['Boolean']>;
  timestamp?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type Region = {
  __typename?: 'Region';
  code: Scalars['String'];
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export type RegisterDeviceIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
};

export type RegisterDeviceIdPayload = {
  __typename?: 'RegisterDeviceIdPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum RegularWithdrawalRecurringTime {
  Daily = 'DAILY',
  Manual = 'MANUAL',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type RegularWithdrawalType = {
  __typename?: 'RegularWithdrawalType';
  amount: Scalars['Float'];
  bankAccount?: Maybe<BankAccountType>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  currency?: Maybe<Currency>;
  id: Scalars['ID'];
  recurringTime: RegularWithdrawalRecurringTime;
  updatedAt: Scalars['DateTime'];
};

export type RegulatoryAddressType = {
  __typename?: 'RegulatoryAddressType';
  description: Scalars['String'];
  regulatoryId: Scalars['String'];
};

export type RegulatoryApprovalConnection = {
  __typename?: 'RegulatoryApprovalConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RegulatoryApprovalEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RegulatoryApproval` and its cursor. */
export type RegulatoryApprovalEdge = {
  __typename?: 'RegulatoryApprovalEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<RegulatoryApprovalType>;
};

/** Cleaner replacement for the RegulatoryTransactionApproval type above. */
export type RegulatoryApprovalType = {
  __typename?: 'RegulatoryApprovalType';
  animal?: Maybe<Animal>;
  destination?: Maybe<RegulatoryAddressType>;
  id: Scalars['ID'];
  movedAt: Scalars['DateTime'];
  regulatoryType: RegulatoryApprovalTypeEnumType;
  source?: Maybe<RegulatoryAddressType>;
  transactions: Array<RegulatoryTransactionType>;
};

export enum RegulatoryApprovalTypeEnumType {
  Birth = 'BIRTH',
  Death = 'DEATH',
  MoveBetween = 'MOVE_BETWEEN',
  MoveOff = 'MOVE_OFF',
  MoveOn = 'MOVE_ON'
}

/** An enumeration. */
export enum RegulatoryTransactionApprovalApprovalStatus {
  Aborted = 'ABORTED',
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Pending = 'PENDING'
}

export type RegulatoryTransactionApprovalSummaryType = {
  __typename?: 'RegulatoryTransactionApprovalSummaryType';
  failed?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  inProgress?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Int']>;
  successful?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type RegulatoryTransactionApprovalType = {
  __typename?: 'RegulatoryTransactionApprovalType';
  actualStatus?: Maybe<Scalars['String']>;
  animal?: Maybe<Animal>;
  approvalStatus: RegulatoryTransactionApprovalApprovalStatus;
  businessUnit: BusinessUnit;
  createdAt: Scalars['DateTime'];
  departureLocation?: Maybe<DeliveryAddressType>;
  dependsOnRegulatoryTransactionApproval?: Maybe<RegulatoryTransactionApprovalType>;
  destination?: Maybe<RegulatoryAddressType>;
  destinationLocation?: Maybe<DeliveryAddressType>;
  id: Scalars['UUID'];
  integrationSystem: IntegrationSystemType;
  linkedToRegulatoryTransactionApproval?: Maybe<RegulatoryTransactionApprovalType>;
  /** Link to Lot if it is was created during trading flow. */
  lot?: Maybe<OwnLot>;
  reasonOfFailure?: Maybe<Scalars['String']>;
  regulatoryTransactions: Array<RegulatoryTransactionType>;
  source?: Maybe<RegulatoryAddressType>;
  sourceActivity?: Maybe<ActivityLog>;
  transactionTypes: Array<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type RegulatoryTransactionApprovalsAbortInput = {
  businessUnit?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  regulatoryTransactionApprovals?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  transactionType?: InputMaybe<Scalars['String']>;
};

/**
 * Soft-deletes a regulatory approval.  The integration is not informed but the
 * underlying state is not impacted.
 */
export type RegulatoryTransactionApprovalsAbortPayload = {
  __typename?: 'RegulatoryTransactionApprovalsAbortPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  regulatoryTransactionApprovals?: Maybe<Array<Maybe<RegulatoryTransactionApprovalType>>>;
};

export type RegulatoryTransactionApprovalsChangeDateInput = {
  businessUnit?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  regulatoryTransactionApprovals?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  transactionDate?: InputMaybe<Scalars['DateTime']>;
  transactionType?: InputMaybe<Scalars['String']>;
};

export type RegulatoryTransactionApprovalsChangeDatePayload = {
  __typename?: 'RegulatoryTransactionApprovalsChangeDatePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  regulatoryTransactionApprovals?: Maybe<Array<Maybe<RegulatoryTransactionApprovalType>>>;
};

export type RegulatoryTransactionApprovalsResponseInput = {
  businessUnit?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  regulatoryTransactionApprovals?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Available values: APPROVED or CANCELED */
  response?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<Scalars['String']>;
};

/**
 * On approved sends the request to the regulator.  On cancel will discard the
 * approval and attempt to restore the state before moving.
 */
export type RegulatoryTransactionApprovalsResponsePayload = {
  __typename?: 'RegulatoryTransactionApprovalsResponsePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  regulatoryTransactionApprovals?: Maybe<Array<Maybe<RegulatoryTransactionApprovalType>>>;
};

export type RegulatoryTransactionApprovalsRetryInput = {
  businessUnit?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  regulatoryTransactionApprovals?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  transactionType?: InputMaybe<Scalars['String']>;
};

export type RegulatoryTransactionApprovalsRetryPayload = {
  __typename?: 'RegulatoryTransactionApprovalsRetryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  regulatoryTransactionApprovals?: Maybe<Array<Maybe<RegulatoryTransactionApprovalType>>>;
};

/** An enumeration. */
export enum RegulatoryTransactionStatus {
  Created = 'CREATED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export type RegulatoryTransactionType = {
  __typename?: 'RegulatoryTransactionType';
  id: Scalars['UUID'];
  status: RegulatoryTransactionStatus;
  type: RegulatoryTransactionTypeEnumType;
};

export enum RegulatoryTransactionTypeEnumType {
  Birth = 'BIRTH',
  Death = 'DEATH',
  MoveBetween = 'MOVE_BETWEEN',
  MoveOff = 'MOVE_OFF',
  MoveOn = 'MOVE_ON'
}

export type RegulatoryTransactionWarningsObjectType = {
  __typename?: 'RegulatoryTransactionWarningsObjectType';
  count?: Maybe<Scalars['Int']>;
  lapseOfTime?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type RejectDeliveryInput = {
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  delivery: Scalars['ID'];
};

/**
 * As the delivery partner reject a proposed delivery action or undo a
 * completed action.
 */
export type RejectDeliveryPayload = {
  __typename?: 'RejectDeliveryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  delivery?: Maybe<DeliveryType>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RemoveAnimalsFromFinancialTransactionInput = {
  /** List of animal UUIDs to remove from the transaction */
  animals: Array<InputMaybe<Scalars['UUID']>>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The UUID of the financial transaction to remove animals from */
  id: Scalars['UUID'];
};

/** Remove animals from a financial transaction. */
export type RemoveAnimalsFromFinancialTransactionPayload = {
  __typename?: 'RemoveAnimalsFromFinancialTransactionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
  financialTransaction?: Maybe<FinancialTransaction>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum ReportEngine {
  Breedr = 'BREEDR',
  Quicksight = 'QUICKSIGHT',
  Sisense = 'SISENSE'
}

export type ReportType = {
  __typename?: 'ReportType';
  applyProducerGroup: Scalars['Boolean'];
  businessTypes: Array<BusinessType>;
  businessUnit?: Maybe<BusinessUnit>;
  defaultFilters: Scalars['JSONString'];
  group?: Maybe<GroupReportType>;
  id: Scalars['ID'];
  needUpgrade?: Maybe<Scalars['Boolean']>;
  position: Scalars['Int'];
  regions: Array<Region>;
  reportType?: Maybe<ReportEngine>;
  slug?: Maybe<Scalars['String']>;
  species: Array<AnimalType>;
  subscriptionPlans: Array<SubscriptionPlan>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type ResponseToLotOfferInput = {
  amount?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  offer: Scalars['Int'];
  status: Scalars['String'];
};

export type ResponseToLotOfferPayload = {
  __typename?: 'ResponseToLotOfferPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  offer?: Maybe<Offer>;
};

export type RestoreAnimalsInput = {
  animals: Array<Scalars['ID']>;
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type RestoreAnimalsPayload = {
  __typename?: 'RestoreAnimalsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RetrieveChannelInput = {
  channelName?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  metaData?: InputMaybe<Scalars['String']>;
  users: Array<Scalars['Int']>;
};

/** Oboslete.  Do not use.. */
export type RetrieveChannelPayload = {
  __typename?: 'RetrieveChannelPayload';
  channelUrl?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SaveCrushAppSessionEnhancedInput = {
  activities?: InputMaybe<Array<InputMaybe<CrushAppActivityItem>>>;
  animalAlerts?: InputMaybe<Array<InputMaybe<CrushAppAnimalAlertItem>>>;
  animalTypeId?: InputMaybe<Scalars['Int']>;
  animals?: InputMaybe<Array<InputMaybe<CrushAppAnimalItem>>>;
  animalsToField?: InputMaybe<Array<InputMaybe<CrushAppAnimalsToFieldItem>>>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Array<InputMaybe<CrushAppGroupItem>>>;
  markAsDoneAnimalAlerts?: InputMaybe<Array<InputMaybe<CrushAppMarkAsDoneAnimalAlertItem>>>;
  sessionConfig?: InputMaybe<Scalars['GenericScalar']>;
  sessionId?: InputMaybe<Scalars['UUID']>;
  snoozeAnimalAlerts?: InputMaybe<Array<InputMaybe<CrushAppSnoozeAnimalAlertItem>>>;
};

export type SaveCrushAppSessionEnhancedPayload = {
  __typename?: 'SaveCrushAppSessionEnhancedPayload';
  activities?: Maybe<Array<Maybe<ActivityLog>>>;
  animalAlerts?: Maybe<Array<Maybe<AnimalAlertObjectType>>>;
  animalType?: Maybe<Array<Maybe<AnimalType>>>;
  animals?: Maybe<Array<Animal>>;
  animalsNotSaved?: Maybe<Array<Maybe<CrushAnimalNotSaved>>>;
  animalsSaved?: Maybe<Array<Maybe<CrushAnimalSaved>>>;
  clientMutationId?: Maybe<Scalars['String']>;
  crushAppSession?: Maybe<CrushAppSessionObjectType>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  fields?: Maybe<Array<Field>>;
  groups?: Maybe<Array<Group>>;
  groupsNotSaved?: Maybe<Array<Maybe<CrushGroupsNotSaved>>>;
};

export type SaveCrushAppSessionInput = {
  activities?: InputMaybe<Array<InputMaybe<CrushAppActivityItem>>>;
  animalAlerts?: InputMaybe<Array<InputMaybe<CrushAppAnimalAlertItem>>>;
  animalTypeId?: InputMaybe<Scalars['Int']>;
  animals?: InputMaybe<Array<InputMaybe<CrushAppAnimalItem>>>;
  animalsToField?: InputMaybe<Array<InputMaybe<CrushAppAnimalsToFieldItem>>>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Array<InputMaybe<CrushAppGroupItem>>>;
  markAsDoneAnimalAlerts?: InputMaybe<Array<InputMaybe<CrushAppMarkAsDoneAnimalAlertItem>>>;
  sessionConfig?: InputMaybe<Scalars['GenericScalar']>;
  sessionId?: InputMaybe<Scalars['UUID']>;
  snoozeAnimalAlerts?: InputMaybe<Array<InputMaybe<CrushAppSnoozeAnimalAlertItem>>>;
};

export type SaveCrushAppSessionPayload = {
  __typename?: 'SaveCrushAppSessionPayload';
  activities?: Maybe<Array<Maybe<ActivityLog>>>;
  animalAlerts?: Maybe<Array<Maybe<AnimalAlertObjectType>>>;
  animalType?: Maybe<Array<Maybe<AnimalType>>>;
  animals?: Maybe<Array<Animal>>;
  clientMutationId?: Maybe<Scalars['String']>;
  crushAppSession?: Maybe<CrushAppSessionObjectType>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  fields?: Maybe<Array<Field>>;
  groups?: Maybe<Array<Group>>;
};

export type ScotMovesConnectionType = FarmSystemType & {
  __typename?: 'ScotMovesConnectionType';
  credentials?: Maybe<Scalars['GenericScalar']>;
  errorMessage?: Maybe<Scalars['String']>;
  farm?: Maybe<BusinessUnit>;
  id?: Maybe<Scalars['Int']>;
  integrationSystem?: Maybe<IntegrationSystemType>;
  location?: Maybe<DeliveryAddressType>;
  status?: Maybe<Scalars['String']>;
};

export type SearchBusinessUnit = {
  __typename?: 'SearchBusinessUnit';
  id?: Maybe<Scalars['Int']>;
  location?: Maybe<LocationSearchBusinessUnit>;
  name?: Maybe<Scalars['String']>;
  profilePhoto?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<UserPublicInfo>>>;
};

export type SearchableFieldObjectType = {
  __typename?: 'SearchableFieldObjectType';
  field?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type SendApproveInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
};

export type SendApprovePayload = {
  __typename?: 'SendApprovePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Obsolete. */
export type SendBirdUser = {
  __typename?: 'SendBirdUser';
  accessToken?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type SendCodeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type SendCodePayload = {
  __typename?: 'SendCodePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  status?: Maybe<Scalars['String']>;
};

export type SendCompleteBcmsSetupEmailInput = {
  businessUnitId?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SendCompleteBcmsSetupEmailPayload = {
  __typename?: 'SendCompleteBcmsSetupEmailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SendMessageInput = {
  addressees: Array<InputMaybe<Scalars['Int']>>;
  body?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type SendMessagePayload = {
  __typename?: 'SendMessagePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SendResetPasswordEmailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SendResetPasswordEmailPayload = {
  __typename?: 'SendResetPasswordEmailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SeriesObjectType = {
  __typename?: 'SeriesObjectType';
  data: Array<LabelNumberObjectType>;
  label: Scalars['String'];
};

/**
 * This object represents an animal in a live session and other data particular
 * to that Animal and the relevant session. At the moment, this is the animal
 * itself and the time it was scanned. There is scope for new fields to be
 * added here in the future.
 */
export type SessionAnimal = {
  __typename?: 'SessionAnimal';
  animal?: Maybe<Animal>;
  /** The time at which this animal was scanned into the live session */
  scannedAt?: Maybe<Scalars['DateTime']>;
};

/** Paginated list of SessionAnimal objects */
export type SessionAnimalConnection = {
  __typename?: 'SessionAnimalConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SessionAnimalEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SessionAnimal` and its cursor. */
export type SessionAnimalEdge = {
  __typename?: 'SessionAnimalEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SessionAnimal>;
};

/** An enumeration. */
export enum SessionStatus {
  Deleted = 'DELETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Saved = 'SAVED',
  SavedWithErrors = 'SAVED_WITH_ERRORS'
}

export type SetFavouriteInput = {
  businessUnit?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  itemDescription: Scalars['String'];
  itemId: Scalars['Int'];
  itemName: Scalars['String'];
  itemType: Scalars['String'];
};

export type SetFavouritePayload = {
  __typename?: 'SetFavouritePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  favourite?: Maybe<FavouriteObjectType>;
};

export type SexClassification = {
  __typename?: 'SexClassification';
  animalType: AnimalType;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type SignUpInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  animalsCount?: InputMaybe<Scalars['String']>;
  breedrUseCase?: InputMaybe<Array<Scalars['String']>>;
  businessName?: InputMaybe<Scalars['String']>;
  businessSpecialization?: InputMaybe<Array<Scalars['String']>>;
  city: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  country: Scalars['Int'];
  email: Scalars['String'];
  farmName: Scalars['String'];
  firstName: Scalars['String'];
  holdingId?: InputMaybe<Scalars['String']>;
  howDidYouHearAboutBreedr: Scalars['Int'];
  howDidYouHearAboutBreedrOther?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  password: Scalars['String'];
  paymentReturnUrl?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  postcode: Scalars['String'];
  referralCode?: InputMaybe<Scalars['String']>;
  revenuecatUserId?: InputMaybe<Scalars['String']>;
  species?: InputMaybe<Array<Scalars['ID']>>;
  state?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
};

export type SignUpPayload = {
  __typename?: 'SignUpPayload';
  businessUnit?: Maybe<BusinessUnit>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SignUpUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
};

/** Obsolete.  Simplified signup for just a user and password. */
export type SignUpUserPayload = {
  __typename?: 'SignUpUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  isInvited?: Maybe<Scalars['Boolean']>;
  organisation?: Maybe<Organisation>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export enum SignupPaymentMode {
  NoCapture = 'NO_CAPTURE',
  Revenuecat = 'REVENUECAT'
}

export type Sire = {
  __typename?: 'Sire';
  animalSet: Array<Animal>;
  businessUnit?: Maybe<BusinessUnit>;
  created: Scalars['DateTime'];
  id?: Maybe<Scalars['UUID']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  passportNumber: Scalars['String'];
  passportNumberCleaned?: Maybe<Scalars['String']>;
  pedigree: Scalars['Boolean'];
  registrationNumber: Scalars['String'];
  sire: Scalars['String'];
  updated: Scalars['DateTime'];
};

export type SnoozeAnimalsAlertsInput = {
  animalAlerts?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  remindAt: Scalars['Date'];
};

export type SnoozeAnimalsAlertsPayload = {
  __typename?: 'SnoozeAnimalsAlertsPayload';
  animalAlerts?: Maybe<Array<Maybe<AnimalAlertObjectType>>>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type SoftDeleteAnimalsInput = {
  animals: Array<Scalars['ID']>;
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SoftDeleteAnimalsPayload = {
  __typename?: 'SoftDeleteAnimalsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SplitFieldInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Float']>;
};

export type SplitFieldPayload = {
  __typename?: 'SplitFieldPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  field?: Maybe<Array<Field>>;
};

export type StartFarmSystemTaskInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  farmSystemTask?: InputMaybe<Scalars['Int']>;
};

export type StartFarmSystemTaskPayload = {
  __typename?: 'StartFarmSystemTaskPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  id?: Maybe<Scalars['Int']>;
};

export type Statistic = {
  __typename?: 'Statistic';
  animalsPurchased?: Maybe<Scalars['Int']>;
  animalsSold?: Maybe<Scalars['Int']>;
  income?: Maybe<Scalars['Float']>;
  nextDeliveryDate?: Maybe<Scalars['DateTime']>;
  purchases?: Maybe<Scalars['Int']>;
};

export type StockItemListType = {
  __typename?: 'StockItemListType';
  activeIngredient: Scalars['String'];
  applicationMethod: Scalars['String'];
  businessUnit?: Maybe<BusinessUnit>;
  createdAt: Scalars['DateTime'];
  id?: Maybe<Scalars['UUID']>;
  lineItems: Array<LineItemType>;
  manufacturer: Scalars['String'];
  manufacturerName: Scalars['String'];
  medicineType?: Maybe<StockItemMedicineType>;
  name: Scalars['String'];
  numberOfBatches?: Maybe<Scalars['Int']>;
  quantityUnits?: Maybe<Scalars['String']>;
  remainingVolume?: Maybe<Scalars['Float']>;
  species: Array<AnimalType>;
  totalQuantity?: Maybe<Scalars['Int']>;
  totalVolume?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  withdrawal?: Maybe<Array<Maybe<MedicineWithdrawalType>>>;
  withdrawalNotes: Scalars['String'];
  withdrawalPeriodDaysCattleDairy?: Maybe<Scalars['Int']>;
  withdrawalPeriodDaysCattleMeat?: Maybe<Scalars['Int']>;
  withdrawalPeriodDaysPigs?: Maybe<Scalars['Int']>;
  withdrawalPeriodDaysSheep?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum StockItemMedicineType {
  Feed = 'FEED',
  Medicine = 'MEDICINE'
}

export type StocktakeObjectType = AnimalInterface & {
  __typename?: 'StocktakeObjectType';
  age?: Maybe<Scalars['Int']>;
  /** It will return age category for the specified date */
  ageCategory?: Maybe<Scalars['String']>;
  alerts?: Maybe<Array<Maybe<AlertObjectType>>>;
  /** Amount of active animal alerts. */
  allAlertsCount?: Maybe<Scalars['Int']>;
  alternativeId?: Maybe<Scalars['String']>;
  animalBreeds: Array<AnimalBreed>;
  animalColour?: Maybe<AnimalColour>;
  animalSubtype?: Maybe<AnimalSubtypeObjectType>;
  animalType?: Maybe<AnimalType>;
  animalTypeId?: Maybe<Scalars['String']>;
  birthInformation?: Maybe<BirthInformation>;
  breedPercentages: Array<BreedPercentage>;
  breedSocietyRegistration: Scalars['Boolean'];
  breeding?: Maybe<Scalars['Boolean']>;
  breedrId?: Maybe<Scalars['String']>;
  brucellosisId?: Maybe<Scalars['String']>;
  buyerName?: Maybe<Scalars['String']>;
  children?: Maybe<Scalars['JSONString']>;
  cphCount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  /** Amount of due or overdue alerts of any urgency. */
  currentAlertsCount?: Maybe<Scalars['Int']>;
  /** Amount of due or overdue high urgency alerts. */
  currentHighUrgencyAlertsCount?: Maybe<Scalars['Int']>;
  currentWeight?: Maybe<Scalars['Float']>;
  dam?: Maybe<Animal>;
  damId?: Maybe<Scalars['String']>;
  damPassportNumber?: Maybe<Scalars['String']>;
  dateLeftFarm?: Maybe<Scalars['DateTime']>;
  dateMovedToFarm?: Maybe<Scalars['DateTime']>;
  daysToTargetWeight?: Maybe<Scalars['Float']>;
  deadAt?: Maybe<Scalars['DateTime']>;
  deliveryDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  eId?: Maybe<Scalars['String']>;
  eIdCleaned?: Maybe<Scalars['String']>;
  eIdsHistory?: Maybe<Array<Scalars['String']>>;
  /** Predicted age for specific date in months. */
  estimatedAgeOn?: Maybe<Scalars['Float']>;
  /** @deprecated [2024-02] no behaviour */
  estimatedCarcassWeight?: Maybe<Scalars['Float']>;
  /** It will return estimated weight for the specified date */
  estimatedWeightOn?: Maybe<Scalars['Float']>;
  field?: Maybe<Field>;
  fieldId?: Maybe<Scalars['UUID']>;
  gender?: Maybe<Scalars['String']>;
  group?: Maybe<Group>;
  groupId?: Maybe<Scalars['UUID']>;
  /** Daily Liveweight Gain: (w2-w1)/(t2-t1) */
  growthRate?: Maybe<Scalars['Float']>;
  /** @deprecated Use growth_rate */
  growthRateSinceConception?: Maybe<Scalars['Float']>;
  /** @deprecated Use growth_rate */
  growthRateSinceLastWeighLog?: Maybe<Scalars['Float']>;
  /**
   * True if the animal has un-copied previous keeper activity, otherwise false
   * @deprecated use previousKeeper
   */
  hasPreviousKeeperInfo?: Maybe<Scalars['Boolean']>;
  herdDoggId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  images?: Maybe<Array<Maybe<AnimalImage>>>;
  impactStatus?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use isRegulatorySynced! */
  isBcmsSynced?: Maybe<Scalars['Boolean']>;
  /** Could be true only for female animals. */
  isBirthed: Scalars['Boolean'];
  isCastrated: Scalars['Boolean'];
  isDead?: Maybe<Scalars['Boolean']>;
  isMale: Scalars['Boolean'];
  isOnFarm: Scalars['Boolean'];
  isPedigree: Scalars['Boolean'];
  isPregnant?: Maybe<Scalars['Boolean']>;
  isRegulatorySynced?: Maybe<Scalars['Boolean']>;
  isSoftDeleted?: Maybe<Scalars['Boolean']>;
  killFatScore: Scalars['String'];
  killFatScoreInt?: Maybe<Scalars['Float']>;
  killQuality: Scalars['String'];
  killQualityInt?: Maybe<Scalars['Float']>;
  killWeight?: Maybe<Scalars['Float']>;
  lastRegulatorySyncedDate?: Maybe<Scalars['DateTime']>;
  lastWeight?: Maybe<WeightActivityLog>;
  latestPurchasePrice?: Maybe<Scalars['Float']>;
  linkToMySire?: Maybe<Sire>;
  location?: Maybe<DeliveryAddressType>;
  lot?: Maybe<LotInfo>;
  metaData?: Maybe<Scalars['JSONString']>;
  name?: Maybe<Scalars['String']>;
  notifications?: Maybe<NotificationConnection>;
  offerId?: Maybe<Scalars['Int']>;
  owner?: Maybe<BusinessUnit>;
  ownerId?: Maybe<Scalars['String']>;
  ownersHistory?: Maybe<Scalars['JSONString']>;
  parentageChecked?: Maybe<Scalars['Boolean']>;
  passportNumber?: Maybe<Scalars['String']>;
  pedigree?: Maybe<Scalars['String']>;
  pedigreeId?: Maybe<Scalars['String']>;
  performanceCategory?: Maybe<Scalars['String']>;
  /** @deprecated Use predictedDateReady! */
  predicatedDateReady?: Maybe<Scalars['Date']>;
  predictedDateReady?: Maybe<Scalars['Date']>;
  predictedWeightAtDelivery?: Maybe<Scalars['Float']>;
  predictedWeights?: Maybe<Array<Maybe<WeightActivityLog>>>;
  pregnancyDueDate?: Maybe<Scalars['Date']>;
  previousKeeper?: Maybe<AnimalPreviousKeeperType>;
  registrationStatus: Scalars['Boolean'];
  relatedMeatLabels?: Maybe<Array<Scalars['String']>>;
  /** @deprecated This field is deprecated and not used now. */
  rflId?: Maybe<Scalars['String']>;
  sexClassification?: Maybe<SexClassification>;
  sire?: Maybe<Animal>;
  sireId?: Maybe<Scalars['String']>;
  sireIsPedigree: Scalars['Boolean'];
  sirePassportNumber?: Maybe<Scalars['String']>;
  sireStuds?: Maybe<Scalars['String']>;
  softDeletedAt?: Maybe<Scalars['DateTime']>;
  studSiredId?: Maybe<Scalars['String']>;
  tags: Array<AnimalTagType>;
  targetDailyLiveWeightGain?: Maybe<Scalars['Float']>;
  targetLiveWeight?: Maybe<Scalars['Float']>;
  tattoo?: Maybe<Scalars['String']>;
  trichId?: Maybe<Scalars['String']>;
  trioVerified?: Maybe<Scalars['Boolean']>;
  tsuBarcode?: Maybe<Scalars['String']>;
  uhfId?: Maybe<Scalars['String']>;
  unreadNotificationsCount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  visualId?: Maybe<Scalars['String']>;
  visualIdsHistory?: Maybe<Array<Scalars['String']>>;
  withdrawalEnd?: Maybe<Scalars['DateTime']>;
  withdrawalStart?: Maybe<Scalars['DateTime']>;
};


export type StocktakeObjectTypeAgeCategoryArgs = {
  date: Scalars['Date'];
};


export type StocktakeObjectTypeEstimatedAgeOnArgs = {
  date: Scalars['Date'];
};


export type StocktakeObjectTypeEstimatedWeightOnArgs = {
  date: Scalars['Date'];
};


export type StocktakeObjectTypeNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type StocktakeObjectTypeConnection = {
  __typename?: 'StocktakeObjectTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StocktakeObjectTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StocktakeObjectType` and its cursor. */
export type StocktakeObjectTypeEdge = {
  __typename?: 'StocktakeObjectTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StocktakeObjectType>;
};

/**
 * Behaviour of a token.  A 'voucher' token is bound to a single template
 * whereas an 'options' token requires that an catalog choice is selected from
 * the subscription catalog associated to the token.
 */
export enum SubscriptionActivationTokenBehaviourEnum {
  Options = 'OPTIONS',
  Voucher = 'VOUCHER'
}

/**
 * A user's built-in voucher representing a one-time activation of a
 * subscription.  This is designed to allow creation of a subscription with a
 * free trial period where the voucher is created on sign-up for later use.
 */
export type SubscriptionActivationTokenType = {
  __typename?: 'SubscriptionActivationTokenType';
  behaviour: SubscriptionActivationTokenBehaviourEnum;
  catalog?: Maybe<SubscriptionCatalogType>;
  id: Scalars['ID'];
};

/**
 * Identifies a choice within a catalog.  The usage of a slug here makes it
 * possible for the front-end to hard-code their choices and have the specific
 * template confiuration be in charge of how that is represented in different
 * environments and over time.
 */
export type SubscriptionCatalogChoiceType = {
  __typename?: 'SubscriptionCatalogChoiceType';
  slug: Scalars['String'];
};

/** An enumeration. */
export enum SubscriptionCatalogPurposeEnum {
  FirstPro = 'FIRST_PRO',
  NewPro = 'NEW_PRO'
}

/**
 * A catalog of choices for a subscription plan.  This is intended to present a
 * list of mututally exlcusive choices in an 'honesty pricing' model but could
 * be expanded to more general behaviour too.
 */
export type SubscriptionCatalogType = {
  __typename?: 'SubscriptionCatalogType';
  choices?: Maybe<Array<SubscriptionCatalogChoiceType>>;
  id: Scalars['ID'];
};

export type SubscriptionInvoice = {
  __typename?: 'SubscriptionInvoice';
  amountPaid: Scalars['Float'];
  businessUnitSubscription?: Maybe<BusinessUnitSubscription>;
  createdAt: Scalars['DateTime'];
  currency?: Maybe<Currency>;
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  invoicePdf?: Maybe<Scalars['String']>;
  paid: Scalars['Boolean'];
  paymentSystem: Scalars['String'];
  subscriptionData?: Maybe<Scalars['JSONString']>;
};

export type SubscriptionInvoiceConnection = {
  __typename?: 'SubscriptionInvoiceConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SubscriptionInvoiceEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SubscriptionInvoice` and its cursor. */
export type SubscriptionInvoiceEdge = {
  __typename?: 'SubscriptionInvoiceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SubscriptionInvoice>;
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  /** @deprecated Deprecated */
  currency?: Maybe<Currency>;
  description: Scalars['String'];
  /** @deprecated Deprecated */
  duration: Scalars['Int'];
  features: Array<SubscriptionPlanFeature>;
  id: Scalars['ID'];
  /** @deprecated Deprecated */
  interval: SubscriptionPlanInterval;
  isActive: Scalars['Boolean'];
  /** @deprecated Deprecated */
  isRecurring: Scalars['Boolean'];
  name: Scalars['String'];
  /** @deprecated Deprecated */
  price: Scalars['Int'];
  prices: Array<SubscriptionPrice>;
  /** @deprecated Deprecated */
  tradingPlan?: Maybe<TradingPlan>;
  /**
   * Days
   * @deprecated Deprecated
   */
  trialPeriod: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type SubscriptionPlanFeature = {
  __typename?: 'SubscriptionPlanFeature';
  isActive: Scalars['Boolean'];
  slug: Scalars['String'];
};

/** An enumeration. */
export enum SubscriptionPlanInterval {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type SubscriptionPrice = {
  __typename?: 'SubscriptionPrice';
  currency?: Maybe<Currency>;
  description: Scalars['String'];
  duration: Scalars['Int'];
  id: Scalars['ID'];
  interval: SubscriptionPricingInterval;
  isActive: Scalars['Boolean'];
  isRecurring: Scalars['Boolean'];
  name: Scalars['String'];
  price: Scalars['Int'];
  /**
   * Days
   * @deprecated Deprecated
   */
  trialPeriod: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum SubscriptionPricingInterval {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** Primary object for determining the subscription status of a business unit. */
export type SubscriptionStatusType = {
  __typename?: 'SubscriptionStatusType';
  activationTokens: Array<SubscriptionActivationTokenType>;
  animalTypes: Array<AnimalType>;
  features: Array<Scalars['String']>;
  hasStripeState: Scalars['Boolean'];
  hasStripeSubscriptions: Scalars['Boolean'];
  /** @deprecated [2024-01] never worked */
  isSubscribed: Scalars['Boolean'];
  tier: SubscriptionTierType;
};

/** Symbolic 'tier' of subscription used for marketing reasons. */
export enum SubscriptionTierType {
  Enterprise = 'ENTERPRISE',
  None = 'NONE',
  Pro = 'PRO'
}

export type SummaryMetrics = {
  __typename?: 'SummaryMetrics';
  animalTypeId?: Maybe<Scalars['Int']>;
  animalsCount?: Maybe<Scalars['Int']>;
  breedrCode?: Maybe<Scalars['String']>;
  femaleCount?: Maybe<Scalars['Int']>;
  maleCount?: Maybe<Scalars['Int']>;
  regBreedCode?: Maybe<Scalars['String']>;
};

export type SupplyChainPageObjectType = {
  __typename?: 'SupplyChainPageObjectType';
  accreditation: Scalars['String'];
  banner?: Maybe<Scalars['String']>;
  bullets?: Maybe<Array<BulletObjectType>>;
  id: Scalars['ID'];
  subregion: Scalars['String'];
  text: Scalars['String'];
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum SystemCredentialFieldFieldType {
  Email = 'EMAIL',
  Location = 'LOCATION',
  Password = 'PASSWORD',
  Text = 'TEXT'
}

export type SystemCredentialFieldType = {
  __typename?: 'SystemCredentialFieldType';
  fieldLabel: Scalars['String'];
  fieldName: Scalars['String'];
  fieldType: SystemCredentialFieldFieldType;
  id: Scalars['ID'];
  inputMask: Scalars['String'];
  integrationSystem: IntegrationSystemType;
  maxLength?: Maybe<Scalars['Int']>;
  minLength?: Maybe<Scalars['Int']>;
  placeholder: Scalars['String'];
};

export type TableColumnDataObjectType = {
  __typename?: 'TableColumnDataObjectType';
  accessor: Scalars['String'];
  displayName: Scalars['String'];
  sortable?: Maybe<Scalars['Boolean']>;
};

/**
 * {
 *     title: "My Test Table",
 *     columns: [{display_name: "Field Name", accessor: "field_name", sortable: True},...]
 *     data: [
 *             {
 *                 "field_name": "Big Field",
 *                 "species": "Cattle",
 *                 "number_of_animals": "80"
 *             },
 *             {
 *                 "field_name": "Small Field",
 *                 "species": "Cattle",
 *                 "number_of_animals": "18"
 *             },
 *             {
 *                 "field_name": "Sheep field",
 *                 "species": "Sheep",
 *                 "number_of_animals": "105"
 *             }
 *     ]
 * }
 */
export type TableDataObjectType = {
  __typename?: 'TableDataObjectType';
  columns: Array<TableColumnDataObjectType>;
  data: Array<Scalars['GenericScalar']>;
  download?: Maybe<DownloadOptionsObjectType>;
  pageInfo?: Maybe<PageInfoObjectType>;
  searchableField?: Maybe<SearchableFieldObjectType>;
  title: Scalars['String'];
};

/** Accessors for tag schema which makes nesting depth less. */
export type TagSchemaInterface = {
  animalTypes?: Maybe<Array<AnimalType>>;
  color?: Maybe<Scalars['String']>;
  isRemovable: Scalars['Boolean'];
  name: Scalars['String'];
  ownership: AnimalTagOwnership;
  slug: Scalars['String'];
  tagId: Scalars['ID'];
  textColor?: Maybe<Scalars['String']>;
  valueType: AnimalTagValueEnum;
};

export type TargetWeightType = {
  __typename?: 'TargetWeightType';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Task = {
  __typename?: 'Task';
  assignedBy?: Maybe<User>;
  assignedTo?: Maybe<User>;
  attachments: Array<TaskAttachment>;
  comments: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  dueDatetime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  relatedEntryId?: Maybe<Scalars['UUID']>;
  updatedAt: Scalars['DateTime'];
};

export type TaskAttachment = {
  __typename?: 'TaskAttachment';
  file: Scalars['String'];
  id: Scalars['ID'];
  task: Task;
  uploadedAt: Scalars['DateTime'];
  uploadedBy?: Maybe<User>;
};

export type TaskConnection = {
  __typename?: 'TaskConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TaskEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Task` and its cursor. */
export type TaskEdge = {
  __typename?: 'TaskEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Task>;
};

export type TermsAndConditionsAcceptInput = {
  businessUnitId: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type TermsAndConditionsAcceptPayload = {
  __typename?: 'TermsAndConditionsAcceptPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type TermsAndConditionsObjectType = {
  __typename?: 'TermsAndConditionsObjectType';
  description: Scalars['String'];
  descriptionMarkdown: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type TimestampChartData = {
  __typename?: 'TimestampChartData';
  timestamp?: Maybe<Scalars['String']>;
};

export type TradingPlan = {
  __typename?: 'TradingPlan';
  /** @deprecated Obsolete */
  businessUnits: Array<BusinessUnit>;
  /** In percents: 0-1 */
  commission: Scalars['Float'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  /** In BU's currency */
  minimumFeeAmount: Scalars['Float'];
  name: Scalars['String'];
  paidBy: TradingPlanPaidBy;
  /** @deprecated Obsolete */
  subscriptionplanSet: Array<SubscriptionPlan>;
};

/** An enumeration. */
export enum TradingPlanPaidBy {
  Buyer = 'BUYER',
  Seller = 'SELLER'
}

/** An enumeration. */
export enum TradingStartUpMessageStartUpType {
  Buyer = 'BUYER',
  Seller = 'SELLER'
}

export type TradingStartUpMessageType = {
  __typename?: 'TradingStartUpMessageType';
  helpUser?: Maybe<User>;
  id: Scalars['ID'];
  startUpMessage: Scalars['String'];
  startUpType: TradingStartUpMessageStartUpType;
};

export type TradingType = {
  __typename?: 'TradingType';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  templates: Array<WantTemplate>;
};

export type TransactionAnimalInputType = {
  allocatedValue?: InputMaybe<Scalars['Float']>;
  /** The UUID of the animal to associate to this record */
  animal: Scalars['UUID'];
};

/** An enumeration. */
export enum TransactionRecordEnumType {
  Expense = 'EXPENSE',
  Purchase = 'PURCHASE',
  Sale = 'SALE'
}

export type TransferOwnershipInput = {
  businessUnit: Scalars['Int'];
  businessUnitUser: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type TransferOwnershipPayload = {
  __typename?: 'TransferOwnershipPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type TruTestImportXlsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** BusinessUnit ID */
  farm?: InputMaybe<Scalars['Int']>;
  xlsFile?: InputMaybe<Scalars['Upload']>;
};

export type TruTestImportXlsPayload = {
  __typename?: 'TruTestImportXlsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  task?: Maybe<FarmSystemTaskType>;
};

export type UnRegisterDeviceIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
};

export type UnRegisterDeviceIdPayload = {
  __typename?: 'UnRegisterDeviceIdPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UndoDeliveryInput = {
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  delivery: Scalars['ID'];
};

/** As a delivery participant revert a completed operation. */
export type UndoDeliveryPayload = {
  __typename?: 'UndoDeliveryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  delivery?: Maybe<DeliveryType>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UnitOfMeasurement = {
  __typename?: 'UnitOfMeasurement';
  businessUnit: BusinessUnit;
  code: Scalars['String'];
  id: Scalars['ID'];
  longDescription: Scalars['String'];
  measurementType: UnitOfMeasurementBusinessUnitMeasurementType;
};

/** An enumeration. */
export enum UnitOfMeasurementBusinessUnitMeasurementType {
  Area = 'AREA',
  DistanceLarge = 'DISTANCE_LARGE',
  DistanceSmall = 'DISTANCE_SMALL',
  DistanceSmaller = 'DISTANCE_SMALLER',
  VolumeLarge = 'VOLUME_LARGE',
  VolumeSmall = 'VOLUME_SMALL',
  WeightLarge = 'WEIGHT_LARGE',
  WeightSmall = 'WEIGHT_SMALL',
  WeightVeryLarge = 'WEIGHT_VERY_LARGE'
}

export type UnlinkHerdDoggAccountInput = {
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type UnlinkHerdDoggAccountPayload = {
  __typename?: 'UnlinkHerdDoggAccountPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UnprocessedAnimal = UnprocessedItem & {
  __typename?: 'UnprocessedAnimal';
  breed?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  eId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  passportNumber?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['String']>;
};

export type UnprocessedItem = {
  id?: Maybe<Scalars['String']>;
};

export type UnsetFavouriteInput = {
  businessUnit?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export type UnsetFavouritePayload = {
  __typename?: 'UnsetFavouritePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  favourite?: Maybe<FavouriteObjectType>;
};

export type UpdateAnimalFilterInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isAlert?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type UpdateAnimalFilterPayload = {
  __typename?: 'UpdateAnimalFilterPayload';
  animalFilter?: Maybe<AnimalFilterObjectType>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type UpdateAnimalInput = {
  alternativeId?: InputMaybe<Scalars['String']>;
  animalBreeds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Available: RAM, EWE, WETHER, LAMB, HOGGET, HEIFER, BULL_CALF, STEER, BULL, COW, SOW, GILTS, BOARS, PIGLET, WEANER, GROWERS, FATTENERS. Default: None */
  animalSubtype?: InputMaybe<Scalars['String']>;
  animalType?: InputMaybe<Scalars['Int']>;
  birthInformation?: InputMaybe<BirthInformationInput>;
  breedSocietyRegistration?: InputMaybe<Scalars['Boolean']>;
  breeding?: InputMaybe<Scalars['Boolean']>;
  brucellosisId?: InputMaybe<Scalars['String']>;
  children?: InputMaybe<Scalars['GenericScalar']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  dam?: InputMaybe<Scalars['UUID']>;
  damPassportNumber?: InputMaybe<Scalars['String']>;
  dateMovedToFarm?: InputMaybe<Scalars['DateTime']>;
  /** List of uploaded Images IDs to delete */
  deleteImages?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['DateTime']>;
  eId?: InputMaybe<Scalars['String']>;
  eIdsHistory?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  group?: InputMaybe<Scalars['UUID']>;
  herdDoggId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  imageFiles?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  isBirthed?: InputMaybe<Scalars['Boolean']>;
  isCastrated?: InputMaybe<Scalars['Boolean']>;
  isMale?: InputMaybe<Scalars['Boolean']>;
  isPedigree?: InputMaybe<Scalars['Boolean']>;
  killFatScore?: InputMaybe<Scalars['String']>;
  killQuality?: InputMaybe<Scalars['String']>;
  killWeight?: InputMaybe<Scalars['Float']>;
  linkToMySire?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  passportNumber?: InputMaybe<Scalars['String']>;
  pedigreeId?: InputMaybe<Scalars['String']>;
  registrationStatus?: InputMaybe<Scalars['Boolean']>;
  relatedMeatLabels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sire?: InputMaybe<Scalars['UUID']>;
  sireIsPedigree?: InputMaybe<Scalars['Boolean']>;
  sirePassportNumber?: InputMaybe<Scalars['String']>;
  sireStuds?: InputMaybe<Scalars['String']>;
  studSiredId?: InputMaybe<Scalars['String']>;
  tagValues?: InputMaybe<Array<AnimalTagAssignmentInputType>>;
  tattoo?: InputMaybe<Scalars['String']>;
  trichId?: InputMaybe<Scalars['String']>;
  tsuBarcode?: InputMaybe<Scalars['String']>;
  uhfId?: InputMaybe<Scalars['String']>;
  updateFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visualId?: InputMaybe<Scalars['String']>;
  visualIdsHistory?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateAnimalPayload = {
  __typename?: 'UpdateAnimalPayload';
  animal?: Maybe<Animal>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type UpdateBankDetailsInput = {
  accountName: Scalars['String'];
  accountNo: Scalars['String'];
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isBusinessAccount: Scalars['Boolean'];
  sortCode: Scalars['String'];
};

export type UpdateBankDetailsPayload = {
  __typename?: 'UpdateBankDetailsPayload';
  bankDetails?: Maybe<BankAccountDetailsObjectType>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type UpdateBatchInput = {
  animalBreeds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  animalType?: InputMaybe<Scalars['Int']>;
  averageDobInBatch?: InputMaybe<Scalars['Date']>;
  batchDateOnFarm?: InputMaybe<Scalars['Date']>;
  businessUnitTarget?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  gendersInBatch?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  imageFiles?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  isPurchased?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  numberOfUnidentifiedAnimalsInBatch?: InputMaybe<Scalars['Int']>;
  targetDate?: InputMaybe<Scalars['Date']>;
  targetWeight?: InputMaybe<Scalars['Float']>;
};

export type UpdateBatchPayload = {
  __typename?: 'UpdateBatchPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  group?: Maybe<Group>;
};

export type UpdateBusinessUnitAccreditationInput = {
  accreditation: Scalars['Int'];
  businessUnit?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  expires?: InputMaybe<Scalars['Date']>;
  id: Scalars['Int'];
};

export type UpdateBusinessUnitAccreditationPayload = {
  __typename?: 'UpdateBusinessUnitAccreditationPayload';
  businessUnitAccreditation?: Maybe<BusinessUnitAccreditation>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type UpdateBusinessUnitSettingsInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  enableBcmsPushTransactions?: InputMaybe<Scalars['Boolean']>;
  killOut?: InputMaybe<Scalars['Int']>;
  tbStatus?: InputMaybe<Scalars['String']>;
};

export type UpdateBusinessUnitSettingsPayload = {
  __typename?: 'UpdateBusinessUnitSettingsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  enableBcmsPushTransactions?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  killOut?: Maybe<Scalars['Int']>;
  tbStatus?: Maybe<Scalars['String']>;
};

export type UpdateBusinessUnitTargetInput = {
  animalType: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['GenericScalar']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  targetWeightType?: InputMaybe<Scalars['String']>;
};

export type UpdateBusinessUnitTargetPayload = {
  __typename?: 'UpdateBusinessUnitTargetPayload';
  businessUnitTarget?: Maybe<BusinessUnitTarget>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type UpdateBusinessUnitUserInput = {
  businessUnitUser: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  role: Scalars['Int'];
  status: Scalars['String'];
};

export type UpdateBusinessUnitUserPayload = {
  __typename?: 'UpdateBusinessUnitUserPayload';
  businessUnitUser?: Maybe<BusinessUnitUser>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type UpdateContactInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  businessUnit: Scalars['Int'];
  city?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  contactType: Scalars['String'];
  country?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  farmId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  organisationName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type UpdateContactPayload = {
  __typename?: 'UpdateContactPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  contact?: Maybe<ContactObjectType>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type UpdateDeliveryInput = {
  arrivedAt?: InputMaybe<Scalars['DateTime']>;
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  delivery: Scalars['ID'];
  destinationContact?: InputMaybe<Scalars['ID']>;
  destinationPartner?: InputMaybe<Scalars['ID']>;
  destinationPartnerAddress?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['ID']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  sourceContact?: InputMaybe<Scalars['ID']>;
  sourcePartner?: InputMaybe<Scalars['ID']>;
  sourcePartnerAddress?: InputMaybe<Scalars['ID']>;
};

/** Edit an existing delivery as the delivery owner. */
export type UpdateDeliveryPayload = {
  __typename?: 'UpdateDeliveryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  delivery?: Maybe<DeliveryType>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateDistributionListInput = {
  /** Current BU of user's session */
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  suppliers: Array<Scalars['Int']>;
};

export type UpdateDistributionListPayload = {
  __typename?: 'UpdateDistributionListPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  distributionList?: Maybe<DistributionListObjectType>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type UpdateEmailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
};

export type UpdateEmailPayload = {
  __typename?: 'UpdateEmailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateFarmSystemInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  credentials?: InputMaybe<Scalars['GenericScalar']>;
  farm: Scalars['Int'];
  farmSystem: Scalars['Int'];
  integrationSystem: Scalars['Int'];
};

export type UpdateFarmSystemPayload = {
  __typename?: 'UpdateFarmSystemPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  farmSystem?: Maybe<FarmSystemType>;
};

export type UpdateFieldInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  colour?: InputMaybe<Scalars['String']>;
  /** List of uploaded Images IDs to delete */
  deleteImages?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  fieldArea?: InputMaybe<FeatureCollectionInputType>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id: Scalars['UUID'];
  imageFiles?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  isOrganic?: InputMaybe<Scalars['Boolean']>;
  isYard?: InputMaybe<Scalars['Boolean']>;
  location: Scalars['Int'];
  name: Scalars['String'];
  pastureTypes?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size?: InputMaybe<Scalars['Float']>;
};

export type UpdateFieldPayload = {
  __typename?: 'UpdateFieldPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  field?: Maybe<Field>;
};

export type UpdateFinancialTransactionInput = {
  amount?: InputMaybe<Scalars['Float']>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  counterparty?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  label?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  recordType?: InputMaybe<TransactionRecordEnumType>;
  totalWeight?: InputMaybe<Scalars['Float']>;
  valueAllocationMethod?: InputMaybe<ValueAllocationMethodEnumType>;
};

/**
 * Updates a financial transaction. Business unit cannot be changed.
 * Animals associated to the transaction must be added/removed separately
 * using specialised mutations.
 */
export type UpdateFinancialTransactionPayload = {
  __typename?: 'UpdateFinancialTransactionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
  financialTransaction?: Maybe<FinancialTransaction>;
};

export type UpdateGroupInput = {
  animalBreeds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  animalType?: InputMaybe<Scalars['Int']>;
  businessUnitTarget?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** List of uploaded Images IDs to delete */
  deleteImages?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  imageFiles?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  name?: InputMaybe<Scalars['String']>;
  targetDate?: InputMaybe<Scalars['Date']>;
  targetWeight?: InputMaybe<Scalars['Float']>;
};

export type UpdateGroupPayload = {
  __typename?: 'UpdateGroupPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  group?: Maybe<Group>;
};

export type UpdateIdentifierPreferencesInput = {
  alternativeId?: InputMaybe<Scalars['Boolean']>;
  breedrId?: InputMaybe<Scalars['Boolean']>;
  brucellosisId?: InputMaybe<Scalars['Boolean']>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  eId?: InputMaybe<Scalars['Boolean']>;
  herdDoggId?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['Boolean']>;
  passportNumber?: InputMaybe<Scalars['Boolean']>;
  pedigreeId?: InputMaybe<Scalars['Boolean']>;
  primaryId?: InputMaybe<IdentifierType>;
  secondaryId?: InputMaybe<IdentifierType>;
  tattoo?: InputMaybe<Scalars['Boolean']>;
  trichId?: InputMaybe<Scalars['Boolean']>;
  tsuBarcode?: InputMaybe<Scalars['Boolean']>;
  uhfId?: InputMaybe<Scalars['Boolean']>;
  visualId?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateIdentifierPreferencesPayload = {
  __typename?: 'UpdateIdentifierPreferencesPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateLiveSessionInput = {
  animalErrors?: InputMaybe<Array<InputMaybe<AnimalErrorParameter>>>;
  animalType?: InputMaybe<Scalars['Int']>;
  businessUnit?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  /** Represents an Animal and additional inputs specific to that Animal in the context of the session. */
  sessionAnimals?: InputMaybe<Array<InputMaybe<LiveSessionAnimalInputType>>>;
  sessionOwner?: InputMaybe<Scalars['Int']>;
  sessionStatus?: InputMaybe<SessionStatus>;
};

/** Updates a LiveSession by its UUID */
export type UpdateLiveSessionPayload = {
  __typename?: 'UpdateLiveSessionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  liveSession?: Maybe<LiveSession>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateLotInput = {
  animals: Array<InputMaybe<Scalars['UUID']>>;
  categoryOfSale?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  deleteImages?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  deliveryAddress?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  lotImages?: InputMaybe<Array<InputMaybe<LotImageInput>>>;
  lotImagesOrder?: InputMaybe<Array<InputMaybe<LotImageOrderInput>>>;
  name?: InputMaybe<Scalars['String']>;
  preMovementTestDate?: InputMaybe<Scalars['DateTime']>;
  price: Scalars['Float'];
  priceUnit: Scalars['String'];
  tbRequirements: Scalars['String'];
  tradingType: Scalars['Int'];
};

export type UpdateLotPayload = {
  __typename?: 'UpdateLotPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  lot?: Maybe<OwnLot>;
};

export type UpdateMedicineCourseInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type UpdateMedicineCoursePayload = {
  __typename?: 'UpdateMedicineCoursePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  medicineCourse?: Maybe<MedicineCourseObjectType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateMedicineCourseStageInput = {
  amount?: InputMaybe<Scalars['Float']>;
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  course: Scalars['UUID'];
  daysAfter?: InputMaybe<Scalars['Int']>;
  id: Scalars['UUID'];
  lineItem?: InputMaybe<Scalars['UUID']>;
  units?: InputMaybe<Scalars['String']>;
};

export type UpdateMedicineCourseStagePayload = {
  __typename?: 'UpdateMedicineCourseStagePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  medicineCourseStage?: Maybe<MedicineCourseStageObjectType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateMobileClientStateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: Scalars['GenericScalar'];
};

export type UpdateMobileClientStatePayload = {
  __typename?: 'UpdateMobileClientStatePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['GenericScalar']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateNotificationSettingsInput = {
  animalActivity?: InputMaybe<Scalars['GenericScalar']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  dailyDigest?: InputMaybe<Scalars['GenericScalar']>;
  integrations?: InputMaybe<Scalars['GenericScalar']>;
  isMarketingEmails?: InputMaybe<Scalars['Boolean']>;
  isNewsEmails?: InputMaybe<Scalars['Boolean']>;
  isProductEmails?: InputMaybe<Scalars['Boolean']>;
  isResearchEmails?: InputMaybe<Scalars['Boolean']>;
  isSystemEmails?: InputMaybe<Scalars['Boolean']>;
  newsletter?: InputMaybe<Scalars['GenericScalar']>;
  trading?: InputMaybe<Scalars['GenericScalar']>;
};

export type UpdateNotificationSettingsPayload = {
  __typename?: 'UpdateNotificationSettingsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  notificationSettings?: Maybe<NotificationSettings>;
};

export type UpdateOrganisationInput = {
  businessType?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['Int']>;
  members?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name: Scalars['String'];
  numberOfFarms?: InputMaybe<Scalars['Int']>;
  organisationId: Scalars['Int'];
};

export type UpdateOrganisationPayload = {
  __typename?: 'UpdateOrganisationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  organisation?: Maybe<Organisation>;
};

export type UpdatePartnerDeliveryInput = {
  businessUnit: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  delivery: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['ID']>;
};

/**
 * Edit an existing delivery as the partner.  The partner is not able to
 * update the same fields that the owner can so we have a separate mutation
 * here.
 */
export type UpdatePartnerDeliveryPayload = {
  __typename?: 'UpdatePartnerDeliveryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  delivery?: Maybe<DeliveryType>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdatePasswordInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  confirmPassword: Scalars['String'];
  oldPassword: Scalars['String'];
  password: Scalars['String'];
};

export type UpdatePasswordPayload = {
  __typename?: 'UpdatePasswordPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdatePostInput = {
  attachment?: InputMaybe<Scalars['Upload']>;
  body?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  post: Scalars['Int'];
  producerGroupMember: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdatePostPayload = {
  __typename?: 'UpdatePostPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  post?: Maybe<PostType>;
};

export type UpdatePreferredBusinessUnitInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  fieldsman?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  priceAdjustment?: InputMaybe<Scalars['Decimal']>;
};

export type UpdatePreferredBusinessUnitPayload = {
  __typename?: 'UpdatePreferredBusinessUnitPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  preferredBusinessUnit?: Maybe<PreferredBusinessUnit>;
};

export type UpdatePreferredBusinessUnitStatusInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  status: Scalars['String'];
};

export type UpdatePreferredBusinessUnitStatusPayload = {
  __typename?: 'UpdatePreferredBusinessUnitStatusPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  preferredBusinessUnit?: Maybe<PreferredBusinessUnit>;
};

export type UpdatePreviousKeeperInput = {
  animal: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  contact: Scalars['ID'];
};

/**
 * Updates the previous keeper of an animal.  This is a separate mutation
 * because it has awkward interactions with activities but it is essentially a
 * property of the animal.
 */
export type UpdatePreviousKeeperPayload = {
  __typename?: 'UpdatePreviousKeeperPayload';
  animal?: Maybe<Animal>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateSireInput = {
  businessUnit?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  passportNumber?: InputMaybe<Scalars['String']>;
  pedigree?: InputMaybe<Scalars['Boolean']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  sire?: InputMaybe<Scalars['String']>;
};

export type UpdateSirePayload = {
  __typename?: 'UpdateSirePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  sire?: Maybe<Sire>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateTagInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  tag: Scalars['ID'];
  textColor?: InputMaybe<Scalars['String']>;
};

/** Edit the tag. */
export type UpdateTagPayload = {
  __typename?: 'UpdateTagPayload';
  animalTag?: Maybe<AnimalTagSchemaType>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ValidationError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateUserInput = {
  about?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  imageFile?: InputMaybe<Scalars['Upload']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  marketingEmails?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['GenericScalar']>;
  newsEmails?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  productEmails?: InputMaybe<Scalars['Boolean']>;
  researchEmails?: InputMaybe<Scalars['Boolean']>;
  systemEmails?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  user?: Maybe<User>;
};

export enum UploadCsvDateHintEnumType {
  International = 'INTERNATIONAL',
  Usa = 'USA'
}

export type UploadCsvInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  csvFile?: InputMaybe<Scalars['Upload']>;
  dateHint?: InputMaybe<UploadCsvDateHintEnumType>;
  tzName?: InputMaybe<Scalars['String']>;
};

export type UploadCsvOptionInput = {
  slug: Scalars['String'];
  value: Scalars['GenericScalar'];
};

/** Stores an upload file for later processing with importCsv. */
export type UploadCsvPayload = {
  __typename?: 'UploadCsvPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  /** @deprecated [2022-09] Use batchUploadFormats.  This does not have enough information. */
  fields?: Maybe<Scalars['GenericScalar']>;
  id?: Maybe<Scalars['Int']>;
  /** The first couple of rows from the file. */
  rows?: Maybe<Scalars['GenericScalar']>;
  totalColumns?: Maybe<Scalars['Int']>;
  totalRows?: Maybe<Scalars['Int']>;
};

export type UploadDiscountGridInput = {
  businessUnit: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  name: Scalars['String'];
};

export type UploadDiscountGridPayload = {
  __typename?: 'UploadDiscountGridPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  discountGrid?: Maybe<DiscountGrid>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type UploadFileSourceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  farmSystem?: InputMaybe<Scalars['Int']>;
  file?: InputMaybe<Scalars['Upload']>;
};

export type UploadFileSourcePayload = {
  __typename?: 'UploadFileSourcePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  id?: Maybe<Scalars['Int']>;
};

export type Url = {
  __typename?: 'Url';
  parameters?: Maybe<Array<QuicksightParameter>>;
  url?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  about?: Maybe<Scalars['String']>;
  alertSet: Array<AlertObjectType>;
  animalFilters: Array<AnimalFilterObjectType>;
  animalSet: Array<Animal>;
  approvedEmail: Scalars['Boolean'];
  approvedStatus: Scalars['Boolean'];
  assignByTasks: Array<Task>;
  assignToTasks: Array<Task>;
  businessUnits: Array<BusinessUnit>;
  calfulatorSet: Array<CalfulatorObjectType>;
  createdTasks: Array<Task>;
  dateJoined: Scalars['DateTime'];
  deviceIds?: Maybe<Array<Scalars['String']>>;
  email: Scalars['String'];
  farmSystemTasks: Array<FarmSystemTaskType>;
  favourites: Array<FavouriteObjectType>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imagesThumb?: Maybe<UserImageThumbnailType>;
  intercomUserHash?: Maybe<Scalars['String']>;
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean'];
  isTermsAccepted: Scalars['Boolean'];
  itemtransactionSet: Array<ItemTransactionType>;
  jobTitle: Scalars['String'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  marketingEmails: Scalars['Boolean'];
  messages: Array<Message>;
  metaData?: Maybe<Scalars['JSONString']>;
  /** Mobile client state data. */
  mobileClientState?: Maybe<Scalars['GenericScalar']>;
  newsEmails: Scalars['Boolean'];
  notificationSettings?: Maybe<NotificationSettings>;
  organisation?: Maybe<Organisation>;
  organisations: Array<OrganisationMember>;
  /** Hash where key is BU ID and value is list of permissions */
  permissions?: Maybe<Scalars['GenericScalar']>;
  phone?: Maybe<Scalars['String']>;
  productEmails: Scalars['Boolean'];
  researchEmails: Scalars['Boolean'];
  /** @deprecated Obsolete */
  sendbirdAccessToken?: Maybe<Scalars['String']>;
  sentMessages: Array<Message>;
  status?: Maybe<Scalars['String']>;
  systemEmails: Scalars['Boolean'];
  tasksAttachments: Array<TaskAttachment>;
  tradingstartupmessageSet: Array<TradingStartUpMessageType>;
  workers: Array<BusinessUnitUser>;
};

export type UserImageThumbnailType = {
  __typename?: 'UserImageThumbnailType';
  imageAspectRatio512x512?: Maybe<Scalars['String']>;
  imageAspectRatio1024x1024?: Maybe<Scalars['String']>;
  imageSquare32x32?: Maybe<Scalars['String']>;
  imageSquare64x64?: Maybe<Scalars['String']>;
  imageSquare96x96?: Maybe<Scalars['String']>;
  imageSquare128x128?: Maybe<Scalars['String']>;
};

export type UserPublicInfo = {
  __typename?: 'UserPublicInfo';
  businessUnitUserId?: Maybe<Scalars['Int']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type ValidationError = {
  __typename?: 'ValidationError';
  code: Scalars['String'];
  field: Scalars['String'];
  message: Scalars['String'];
};

export type ValidationErrorType = {
  __typename?: 'ValidationErrorType';
  code?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** An enumeration. */
export enum ValueAllocationMethodEnumType {
  ByWeight = 'BY_WEIGHT',
  Custom = 'CUSTOM',
  PerHead = 'PER_HEAD'
}

export type VideoGroupType = {
  __typename?: 'VideoGroupType';
  id: Scalars['ID'];
  position: Scalars['Int'];
  slug: Scalars['String'];
  title: Scalars['String'];
  videos?: Maybe<Array<Maybe<VideoType>>>;
};

export type VideoType = {
  __typename?: 'VideoType';
  description: Scalars['String'];
  disabled: Scalars['Boolean'];
  groups: Array<VideoGroupType>;
  id: Scalars['ID'];
  platform: Array<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  /** Is set as the default youtube thumbnail - goto youtube studio to change default or replace */
  thumbnail: Scalars['String'];
  title: Scalars['String'];
  /** The youtube link of the form www.youtu.be/ZZZZZZZ */
  url: Scalars['String'];
  youtubeId: Scalars['String'];
};

/** Deprecated.  RFL. */
export type Want = {
  acceptedNumber?: Maybe<Scalars['Int']>;
  accreditations?: Maybe<Array<Maybe<Accreditation>>>;
  advertDetails?: Maybe<Scalars['GenericScalar']>;
  animalType?: Maybe<AnimalType>;
  animalTypeId?: Maybe<Scalars['Int']>;
  breedingStatus?: Maybe<Scalars['String']>;
  breeds?: Maybe<Array<Maybe<AnimalBreed>>>;
  businessUnit?: Maybe<BusinessUnitInfo>;
  businessUnitId?: Maybe<Scalars['Int']>;
  currency?: Maybe<Currency>;
  currencyId?: Maybe<Scalars['Int']>;
  dateNeeded?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discountGrid?: Maybe<DiscountGrid>;
  files?: Maybe<Array<Maybe<WantFile>>>;
  id?: Maybe<Scalars['Int']>;
  isAcceptOffers?: Maybe<Scalars['Boolean']>;
  isBvdFree?: Maybe<Scalars['Boolean']>;
  isCarcass?: Maybe<Scalars['Boolean']>;
  isForwardContractAllowed?: Maybe<Scalars['Boolean']>;
  isPedigree?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  isStandardDeductions?: Maybe<Scalars['Boolean']>;
  isTbFree?: Maybe<Scalars['Boolean']>;
  lastStatus?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['GenericScalar']>;
  name?: Maybe<Scalars['String']>;
  pedigreeStatus?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  priceDetails?: Maybe<Scalars['GenericScalar']>;
  priceNotes?: Maybe<Scalars['String']>;
  priceUnit?: Maybe<Scalars['String']>;
  privateShareCount?: Maybe<Scalars['Int']>;
  privateShareMaxDistance?: Maybe<Scalars['Int']>;
  privateSharePostcode?: Maybe<Scalars['String']>;
  recurringDetails?: Maybe<Scalars['GenericScalar']>;
  requestedNumber?: Maybe<Scalars['Int']>;
  rflId?: Maybe<Scalars['String']>;
  shareType?: Maybe<Scalars['String']>;
  shippingTerms?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['Float']>;
  tradingType?: Maybe<TradingType>;
  tradingTypeId?: Maybe<Scalars['Int']>;
  usage?: Maybe<Scalars['String']>;
};

/** Deprecated.  RFL. */
export type WantConnection = {
  __typename?: 'WantConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WantEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  wantsCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Want` and its cursor. */
export type WantEdge = {
  __typename?: 'WantEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Want>;
};

/** Deprecated.  RFL. */
export type WantFile = {
  __typename?: 'WantFile';
  file: Scalars['String'];
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  want: OwnWant;
};

/** Deprecated.  RFL. */
export type WantTemplate = {
  __typename?: 'WantTemplate';
  advertDetails?: Maybe<Scalars['GenericScalar']>;
  breeds?: Maybe<Array<Maybe<AnimalBreed>>>;
  businessUnit?: Maybe<BusinessUnitInfo>;
  businessUnitId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  dateNeeded?: Maybe<Scalars['DateTime']>;
  discountGrid?: Maybe<DiscountGrid>;
  distributionLists: Array<DistributionListObjectType>;
  hideRequestedNumber: Scalars['Boolean'];
  id?: Maybe<Scalars['Int']>;
  isPublic: Scalars['Boolean'];
  location?: Maybe<Scalars['GenericScalar']>;
  name?: Maybe<Scalars['String']>;
  offerDeadline?: Maybe<Scalars['DateTime']>;
  price?: Maybe<Scalars['Float']>;
  priceNotes?: Maybe<Scalars['String']>;
  priceUnit?: Maybe<WantTemplatePriceUnit>;
  privateShareMaxDistance?: Maybe<Scalars['Int']>;
  privateSharePostcode?: Maybe<Scalars['String']>;
  reference: Scalars['String'];
  requestedNumber?: Maybe<Scalars['Int']>;
  shareToGroups: Array<ProducerGroupType>;
  shareType?: Maybe<Scalars['String']>;
  sharedTo?: Maybe<Array<Maybe<BusinessUnitInfo>>>;
  shippingTerms: WantTemplateShippingTerms;
  tradingType?: Maybe<TradingType>;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum WantTemplatePriceUnit {
  Head = 'HEAD',
  Kg = 'KG',
  Total = 'TOTAL'
}

/** An enumeration. */
export enum WantTemplateShippingTerms {
  PaidByBuyer = 'PAID_BY_BUYER',
  PaidBySeller = 'PAID_BY_SELLER'
}

export type WeightActivityLog = {
  __typename?: 'WeightActivityLog';
  date?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Float']>;
};

export type WeightChartData = {
  __typename?: 'WeightChartData';
  timestamp?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export enum WeightUnitEnum {
  Kg = 'KG',
  Lb = 'LB'
}

export type WithdrawTransactionHistoryType = {
  __typename?: 'WithdrawTransactionHistoryType';
  amount: Scalars['Float'];
  balanceAccount?: Maybe<BalanceAccountType>;
  body?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currency?: Maybe<Currency>;
  id: Scalars['ID'];
  paymentPayload?: Maybe<Scalars['JSONString']>;
  paymentResponse?: Maybe<Scalars['JSONString']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type AnimalFragment = { __typename?: 'Animal', id?: any | null, currentWeight?: number | null, dateMovedToFarm?: any | null, dob?: any | null, eId?: string | null, brucellosisId?: string | null, tattoo?: string | null, tsuBarcode?: string | null, pedigreeId?: string | null, trichId?: string | null, herdDoggId?: string | null, name?: string | null, breedrId?: string | null, uhfId?: string | null, alternativeId?: string | null, growthRate?: number | null, isCastrated: boolean, latestPurchasePrice?: number | null, isMale: boolean, isPregnant?: boolean | null, lastRegulatorySyncedDate?: any | null, passportNumber?: string | null, performanceCategory?: string | null, pregnancyDueDate?: any | null, targetLiveWeight?: number | null, visualId?: string | null, isRegulatorySynced?: boolean | null, deliveryDate?: any | null, sirePassportNumber?: string | null, damPassportNumber?: string | null, damId?: string | null, withdrawalEnd?: any | null, dateLeftFarm?: any | null, deadAt?: any | null, updatedAt: any, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null, newClassification?: AnimalBreedNewClassification | null }>, breedPercentages: Array<{ __typename?: 'BreedPercentage', percentage?: number | null, breed: { __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null } }>, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, group?: { __typename?: 'Group', id: string, name: string } | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', unitName?: string | null } | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, linkToMySire?: { __typename?: 'Sire', id?: any | null, name: string, pedigree: boolean, passportNumber: string } | null, birthInformation?: { __typename?: 'BirthInformation', birthWeight?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string } | null, tags: Array<{ __typename?: 'AnimalTagType', color?: string | null, name: string, tagId: string, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }>, previousKeeper?: { __typename?: 'AnimalPreviousKeeperType', name: string } | null };

export type MarkAnimalsAsDeadMutationVariables = Exact<{
  input: MarkAnimalsAsDeadInput;
}>;


export type MarkAnimalsAsDeadMutation = { __typename?: 'Mutation', markAnimalsAsDead?: { __typename?: 'MarkAnimalsAsDeadPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type GetAnimalQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetAnimalQuery = { __typename?: 'Query', animal?: { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, dob?: any | null } | null };

export type BreedseekDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type BreedseekDataQuery = { __typename?: 'Query', breedseek?: { __typename?: 'BreedseekData', barcode: string, testRef?: string | null, orderRef?: string | null, akaushi: any, angus: any, beefmasters: any, brangus: any, hereford: any, holstein: any, jersey: any, redAngus: any, santaGertrudis: any, wagyu: any, animal?: { __typename?: 'Animal', id?: any | null } | null } | null };

export type AmericanAngusEpdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AmericanAngusEpdQuery = { __typename?: 'Query', americanAngusEpd?: { __typename?: 'AmericanAngusEPD', angusOnHolsteinValue?: number | null, angusOnHolsteinValueRank?: number | null, angusOnJerseyValue?: number | null, angusOnJerseyValueRank?: number | null, beefValue?: number | null, beefValueRank?: number | null, birthWeightAcc?: any | null, birthWeightEpd?: any | null, birthWeightPct?: number | null, calvingEaseAcc?: any | null, calvingEaseEpd?: number | null, calvingEasePct?: number | null, carcassWeightAcc?: any | null, carcassWeightEpd?: number | null, carcassWeightPct?: number | null, clawAcc?: any | null, clawEpd?: any | null, clawPct?: number | null, combinedValue?: number | null, combinedValueRank?: number | null, cowEnergyValue?: number | null, cowEnergyValueRank?: number | null, docilityAcc?: any | null, docilityEpd?: number | null, docilityPct?: number | null, dryMatterIntakeAcc?: any | null, dryMatterIntakeEpd?: any | null, dryMatterIntakePct?: number | null, fatAcc?: any | null, fatEpd?: any | null, fatPct?: number | null, feedlotValue?: number | null, feedlotValueRank?: number | null, gridValue?: number | null, gridValueRank?: number | null, hairShedAcc?: any | null, hairShedEpd?: any | null, hairShedPct?: number | null, heiferPregnancyAcc?: any | null, heiferPregnancyEpd?: any | null, heiferPregnancyPct?: number | null, hoofAngleAcc?: any | null, hoofAngleEpd?: any | null, hoofAnglePct?: number | null, marblingAcc?: any | null, marblingEpd?: any | null, marblingPct?: number | null, maternalCalfValue?: number | null, maternalCalfValueRank?: number | null, matureHeightAcc?: any | null, matureHeightEpd?: any | null, matureHeightPct?: number | null, matureWeightAcc?: any | null, matureWeightEpd?: number | null, matureWeightPct?: number | null, milkAcc?: any | null, milkEpd?: number | null, milkPct?: number | null, papAcc?: any | null, papEpd?: any | null, papPct?: number | null, residualAdgAcc?: any | null, residualAdgEpd?: any | null, residualAdgPct?: number | null, ribeyeAreaAcc?: any | null, ribeyeAreaEpd?: any | null, ribeyeAreaPct?: number | null, scrotalCircumferenceAcc?: any | null, scrotalCircumferenceEpd?: any | null, scrotalCircumferencePct?: number | null, weanedCalfValue?: number | null, weanedCalfValueRank?: number | null, weaningWeightAcc?: any | null, weaningWeightEpd?: number | null, weaningWeightPct?: number | null, yearlingHeightAcc?: any | null, yearlingHeightEpd?: any | null, yearlingHeightPct?: number | null, yearlingWeightAcc?: any | null, yearlingWeightEpd?: number | null, yearlingWeightPct?: number | null } | null };

export type NeogenEpdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type NeogenEpdQuery = { __typename?: 'Query', neogenEpd?: { __typename?: 'NeogenEPD', averageDailyGainAcc?: any | null, averageDailyGainEpd?: any | null, averageDailyGainPct?: number | null, birthWeightAcc?: any | null, birthWeightEpd?: any | null, birthWeightPct?: number | null, fatAcc?: any | null, fatEpd?: any | null, fatPct?: number | null, fx?: any | null, hotCarcassWeightAcc?: any | null, hotCarcassWeightEpd?: any | null, hotCarcassWeightPct?: number | null, marblingAcc?: any | null, marblingEpd?: any | null, marblingPct?: number | null, milkAcc?: any | null, milkEpd?: any | null, milkPct?: number | null, residualFeedIntakeAcc?: any | null, residualFeedIntakeEpd?: any | null, residualFeedIntakePct?: number | null, ribeyeAreaAcc?: any | null, ribeyeAreaEpd?: any | null, ribeyeAreaPct?: number | null, totalIndex?: any | null, weaningWeightAcc?: any | null, weaningWeightEpd?: any | null, weaningWeightPct?: number | null } | null };

export type GetAnimalsQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
  animalIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetAnimalsQuery = { __typename?: 'Query', animals?: { __typename?: 'AnimalConnection2', count?: number | null, edges: Array<{ __typename?: 'AnimalConnection2Edge', node?: { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, dob?: any | null, isDead?: boolean | null, lot?: { __typename?: 'LotInfo', id?: number | null, isExpired?: boolean | null } | null } | null } | null> } | null };

export type GetAnimalsPageQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
  animalIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  animalTypeIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  animalTags?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  searchIds?: InputMaybe<Array<IdentifierType> | IdentifierType>;
  group?: InputMaybe<Scalars['UUID']>;
  field?: InputMaybe<Scalars['UUID']>;
  isMale?: InputMaybe<Scalars['Boolean']>;
  isPregnant?: InputMaybe<Scalars['Boolean']>;
  minUpdated?: InputMaybe<Scalars['DateTime']>;
  minDob?: InputMaybe<Scalars['DateTime']>;
  maxDob?: InputMaybe<Scalars['DateTime']>;
  minDof?: InputMaybe<Scalars['DateTime']>;
  maxDof?: InputMaybe<Scalars['DateTime']>;
  orderBy?: InputMaybe<Array<AnimalSorting> | AnimalSorting>;
  status?: InputMaybe<AnimalStatus>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  breed?: InputMaybe<Scalars['ID']>;
}>;


export type GetAnimalsPageQuery = { __typename?: 'Query', animals?: { __typename?: 'AnimalConnection2', count?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'AnimalConnection2Edge', node?: { __typename?: 'Animal', id?: any | null, currentWeight?: number | null, dateMovedToFarm?: any | null, dob?: any | null, eId?: string | null, brucellosisId?: string | null, tattoo?: string | null, tsuBarcode?: string | null, pedigreeId?: string | null, trichId?: string | null, herdDoggId?: string | null, name?: string | null, breedrId?: string | null, uhfId?: string | null, alternativeId?: string | null, growthRate?: number | null, isCastrated: boolean, latestPurchasePrice?: number | null, isMale: boolean, isPregnant?: boolean | null, lastRegulatorySyncedDate?: any | null, passportNumber?: string | null, performanceCategory?: string | null, pregnancyDueDate?: any | null, targetLiveWeight?: number | null, visualId?: string | null, isRegulatorySynced?: boolean | null, deliveryDate?: any | null, sirePassportNumber?: string | null, damPassportNumber?: string | null, damId?: string | null, withdrawalEnd?: any | null, dateLeftFarm?: any | null, deadAt?: any | null, updatedAt: any, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null, newClassification?: AnimalBreedNewClassification | null }>, breedPercentages: Array<{ __typename?: 'BreedPercentage', percentage?: number | null, breed: { __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null } }>, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, group?: { __typename?: 'Group', id: string, name: string } | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', unitName?: string | null } | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, linkToMySire?: { __typename?: 'Sire', id?: any | null, name: string, pedigree: boolean, passportNumber: string } | null, birthInformation?: { __typename?: 'BirthInformation', birthWeight?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string } | null, tags: Array<{ __typename?: 'AnimalTagType', color?: string | null, name: string, tagId: string, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }>, previousKeeper?: { __typename?: 'AnimalPreviousKeeperType', name: string } | null } | null } | null> } | null };

export type GetExportResultQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetExportResultQuery = { __typename?: 'Query', exportResult?: { __typename?: 'ExportResult', isReady: boolean, url?: string | null } | null };

export type ExportAnimalsAsyncMutationVariables = Exact<{
  input: ExportAnimalsAsyncInput;
}>;


export type ExportAnimalsAsyncMutation = { __typename?: 'Mutation', exportAnimalsAsync?: { __typename?: 'ExportAnimalsAsyncPayload', export?: { __typename?: 'ExportResult', id: string } | null, errors?: Array<{ __typename?: 'ValidationError', code: string, message: string } | null> | null } | null };

export type AnimalsExportAsyncMutationVariables = Exact<{
  input: AnimalsExportAsyncInput;
}>;


export type AnimalsExportAsyncMutation = { __typename?: 'Mutation', animalsExportAsync?: { __typename?: 'AnimalsExportAsyncPayload', export?: { __typename?: 'ExportResult', id: string, isReady: boolean, url?: string | null } | null } | null };

export type DamAnimalsQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
  animalIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  isMale?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Array<AnimalSorting> | AnimalSorting>;
  animalTypeIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type DamAnimalsQuery = { __typename?: 'Query', animals?: { __typename?: 'AnimalConnection2', edges: Array<{ __typename?: 'AnimalConnection2Edge', node?: { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, eId?: string | null } | null } | null> } | null };

export type SiresQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
}>;


export type SiresQuery = { __typename?: 'Query', sires?: Array<{ __typename?: 'Sire', id?: any | null, name: string, passportNumber: string } | null> | null };

export type AnimalConditionsQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
}>;


export type AnimalConditionsQuery = { __typename?: 'Query', animalConditions: Array<{ __typename?: 'AnimalConditionType', id: any, slug: string, title: string }> };

export type GetFamilyTreeQueryVariables = Exact<{
  animalID: Scalars['UUID'];
  depth: Scalars['Int'];
}>;


export type GetFamilyTreeQuery = { __typename?: 'Query', ancestorTree?: Array<{ __typename?: 'AncestorType', ancestorIdentifier?: string | null, depth?: number | null, animalData?: { __typename?: 'Animal', id?: any | null, isMale: boolean, isDead?: boolean | null, dateLeftFarm?: any | null, deadAt?: any | null, passportNumber?: string | null, pedigreeId?: string | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, tattoo?: string | null, tsuBarcode?: string | null, trichId?: string | null, herdDoggId?: string | null, name?: string | null, breedrId?: string | null, uhfId?: string | null, alternativeId?: string | null, sirePassportNumber?: string | null, damPassportNumber?: string | null } | null } | null> | null };

export type SignUpMutationVariables = Exact<{
  input: SignUpInput;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp?: { __typename?: 'SignUpPayload', success?: boolean | null, clientMutationId?: string | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UserExistsQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type UserExistsQuery = { __typename?: 'Query', userExists?: boolean | null };

export type BlockchainAnimalFragmentFragment = { __typename?: 'BlockchainAnimalData', breed?: string | null, dob?: any | null, isMale?: boolean | null, name?: string | null, ownerId?: string | null, ownerName?: string | null, ownerHoldingId?: string | null, passportNumber?: string | null, isDead?: string | null, deathDate?: string | null, deathCreatedBy?: string | null, error?: string | null, movements?: Array<{ __typename?: 'BlockchainMoveInfo', createdBy?: string | null, fromFarmName?: string | null, fromHoldingId?: string | null, toOwnerId?: string | null, toOwnerName?: string | null, toHoldingId?: string | null, date?: any | null }> | null, weights?: Array<{ __typename?: 'BlockchainWeightInfo', date?: any | null, value?: string | null, unit?: string | null, holdingId?: string | null, createdBy?: string | null }> | null, medication?: Array<{ __typename?: 'BlockchainMedicationInfo', date?: any | null, medicineName?: string | null, batchNumber?: string | null, dosage?: string | null, dosageUnits?: string | null, activeIngredient?: string | null, withdrawalDays?: string | null, holdingId?: string | null, createdBy?: string | null }> | null, carcassGrading?: Array<{ __typename?: 'BlockchainCarcassGradingInfo', date?: any | null, hotWeight?: string | null, coldWeight?: string | null, grading?: string | null, fatScore?: string | null, conformation?: string | null, condemnedWeight?: string | null, value?: string | null, killNumber?: string | null, lotNumber?: string | null, createdBy?: string | null, holdingId?: string | null }> | null };

export type GetBlockchainAnimalDataByPassportQueryVariables = Exact<{
  passportNumber: Scalars['String'];
}>;


export type GetBlockchainAnimalDataByPassportQuery = { __typename?: 'Query', blockchainAnimalDataByPassport?: { __typename?: 'BlockchainAnimalData', breed?: string | null, dob?: any | null, isMale?: boolean | null, name?: string | null, ownerId?: string | null, ownerName?: string | null, ownerHoldingId?: string | null, passportNumber?: string | null, isDead?: string | null, deathDate?: string | null, deathCreatedBy?: string | null, error?: string | null, movements?: Array<{ __typename?: 'BlockchainMoveInfo', createdBy?: string | null, fromFarmName?: string | null, fromHoldingId?: string | null, toOwnerId?: string | null, toOwnerName?: string | null, toHoldingId?: string | null, date?: any | null }> | null, weights?: Array<{ __typename?: 'BlockchainWeightInfo', date?: any | null, value?: string | null, unit?: string | null, holdingId?: string | null, createdBy?: string | null }> | null, medication?: Array<{ __typename?: 'BlockchainMedicationInfo', date?: any | null, medicineName?: string | null, batchNumber?: string | null, dosage?: string | null, dosageUnits?: string | null, activeIngredient?: string | null, withdrawalDays?: string | null, holdingId?: string | null, createdBy?: string | null }> | null, carcassGrading?: Array<{ __typename?: 'BlockchainCarcassGradingInfo', date?: any | null, hotWeight?: string | null, coldWeight?: string | null, grading?: string | null, fatScore?: string | null, conformation?: string | null, condemnedWeight?: string | null, value?: string | null, killNumber?: string | null, lotNumber?: string | null, createdBy?: string | null, holdingId?: string | null }> | null } | null };

export type GetBlockchainAnimalDataByKillNumberQueryVariables = Exact<{
  killNumber: Scalars['String'];
  date: Scalars['Date'];
}>;


export type GetBlockchainAnimalDataByKillNumberQuery = { __typename?: 'Query', blockchainAnimalDataByKillNumber?: { __typename?: 'BlockchainAnimalData', breed?: string | null, dob?: any | null, isMale?: boolean | null, name?: string | null, ownerId?: string | null, ownerName?: string | null, ownerHoldingId?: string | null, passportNumber?: string | null, isDead?: string | null, deathDate?: string | null, deathCreatedBy?: string | null, error?: string | null, movements?: Array<{ __typename?: 'BlockchainMoveInfo', createdBy?: string | null, fromFarmName?: string | null, fromHoldingId?: string | null, toOwnerId?: string | null, toOwnerName?: string | null, toHoldingId?: string | null, date?: any | null }> | null, weights?: Array<{ __typename?: 'BlockchainWeightInfo', date?: any | null, value?: string | null, unit?: string | null, holdingId?: string | null, createdBy?: string | null }> | null, medication?: Array<{ __typename?: 'BlockchainMedicationInfo', date?: any | null, medicineName?: string | null, batchNumber?: string | null, dosage?: string | null, dosageUnits?: string | null, activeIngredient?: string | null, withdrawalDays?: string | null, holdingId?: string | null, createdBy?: string | null }> | null, carcassGrading?: Array<{ __typename?: 'BlockchainCarcassGradingInfo', date?: any | null, hotWeight?: string | null, coldWeight?: string | null, grading?: string | null, fatScore?: string | null, conformation?: string | null, condemnedWeight?: string | null, value?: string | null, killNumber?: string | null, lotNumber?: string | null, createdBy?: string | null, holdingId?: string | null }> | null } | null };

export type GetBreedrBankDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBreedrBankDetailsQuery = { __typename?: 'Query', breedrBankDetails?: { __typename?: 'BreedrBankAccountDetailsObjectType', accountNo: string, accountName: string, sortCode: string } | null };

export type CreatePreferredSuppliersMutationVariables = Exact<{
  input: CreatePreferredSuppliersInput;
}>;


export type CreatePreferredSuppliersMutation = { __typename?: 'Mutation', createPreferredSuppliers?: { __typename?: 'CreatePreferredSuppliersPayload', errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UpdatePreferredBusinessUnitStatusMutationVariables = Exact<{
  input: UpdatePreferredBusinessUnitStatusInput;
}>;


export type UpdatePreferredBusinessUnitStatusMutation = { __typename?: 'Mutation', updatePreferredBusinessUnitStatus?: { __typename?: 'UpdatePreferredBusinessUnitStatusPayload', preferredBusinessUnit?: { __typename?: 'PreferredBusinessUnit', id: string, commonStatus?: string | null, supplier: { __typename?: 'PublicBusinessUnit', id: string } } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UpdatePreferredBusinessUnitMutationVariables = Exact<{
  input: UpdatePreferredBusinessUnitInput;
}>;


export type UpdatePreferredBusinessUnitMutation = { __typename?: 'Mutation', updatePreferredBusinessUnit?: { __typename?: 'UpdatePreferredBusinessUnitPayload', preferredBusinessUnit?: { __typename?: 'PreferredBusinessUnit', id: string } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UpdateBusinessUnitSettingsMutationVariables = Exact<{
  input: UpdateBusinessUnitSettingsInput;
}>;


export type UpdateBusinessUnitSettingsMutation = { __typename?: 'Mutation', updateBusinessUnitSettings?: { __typename?: 'UpdateBusinessUnitSettingsPayload', enableBcmsPushTransactions?: boolean | null, killOut?: number | null, tbStatus?: string | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type TermsAndConditionsAcceptMutationVariables = Exact<{
  input: TermsAndConditionsAcceptInput;
}>;


export type TermsAndConditionsAcceptMutation = { __typename?: 'Mutation', termsAndConditionsAccept?: { __typename?: 'TermsAndConditionsAcceptPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type BuFragmentFragment = { __typename?: 'BusinessUnit', id: string, name: string, profilePhoto?: string | null, warnings?: any | null, tbStatus?: BusinessUnitTbStatus | null, postcode?: string | null, canCreateRfl: boolean, locationsCount?: number | null, foggles?: Array<string | null> | null, identifierPreferencesPrimaryId?: IdentifierEnumType | null, identifierPreferencesSecondaryId?: IdentifierEnumType | null, organisation?: { __typename?: 'Organisation', id: string } | null, tradingTypes: Array<{ __typename?: 'TradingType', id: string, slug: string, name: string }>, businessType?: { __typename?: 'BusinessType', id: string, slug: string } | null, regulatorySystem?: { __typename?: 'IntegrationSystemType', id: string, slug: string, name: string } | null, deliveryAddress: Array<{ __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null, postcode?: string | null, addressLine1?: string | null }>, primaryLocation?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, postcode?: string | null } | null, currency?: { __typename?: 'Currency', id: string, name: string, code: string } | null, unitsOfMeasurement?: Array<{ __typename?: 'UnitOfMeasurement', id: string, code: string, measurementType: UnitOfMeasurementBusinessUnitMeasurementType } | null> | null, country?: { __typename?: 'Country', id: string, code: string, name: string, isoAlpha2?: string | null, isoNumber?: number | null, visualIdPrefix?: string | null, region?: { __typename?: 'Region', code: string, name: string } | null } | null, farmAnimalTypes: Array<{ __typename?: 'AnimalType', colour: string, enabled: boolean, id: string, image?: string | null, name: string, position: number, slug?: string | null }>, effectiveSubscriptionPlan?: { __typename?: 'SubscriptionPlan', name: string } | null, identifierPreferencesActiveIds?: { __typename?: 'ActiveIdentifierPreferencesType', alternativeId: boolean, passportNumber: boolean, visualId: boolean, eId: boolean, name: boolean, trichId: boolean, tsuBarcode: boolean, pedigreeId: boolean, tattoo: boolean, herdDoggId: boolean, breedrId: boolean, uhfId: boolean, brucellosisId: boolean } | null, herdDoggIntegration?: { __typename?: 'HerdDoggIntegrationObjectType', isConnected?: boolean | null } | null };

export type BusinessUnitTargetFragment = { __typename?: 'BusinessUnitTarget', id: string, name: string, details?: any | null, animalType?: { __typename?: 'AnimalType', id: string } | null };

export type GetBusinessUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessUnitsQuery = { __typename?: 'Query', businessUnits?: Array<{ __typename?: 'BusinessUnit', id: string, name: string, profilePhoto?: string | null, warnings?: any | null, tbStatus?: BusinessUnitTbStatus | null, postcode?: string | null, canCreateRfl: boolean, locationsCount?: number | null, foggles?: Array<string | null> | null, identifierPreferencesPrimaryId?: IdentifierEnumType | null, identifierPreferencesSecondaryId?: IdentifierEnumType | null, organisation?: { __typename?: 'Organisation', id: string } | null, tradingTypes: Array<{ __typename?: 'TradingType', id: string, slug: string, name: string }>, businessType?: { __typename?: 'BusinessType', id: string, slug: string } | null, regulatorySystem?: { __typename?: 'IntegrationSystemType', id: string, slug: string, name: string } | null, deliveryAddress: Array<{ __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null, postcode?: string | null, addressLine1?: string | null }>, primaryLocation?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, postcode?: string | null } | null, currency?: { __typename?: 'Currency', id: string, name: string, code: string } | null, unitsOfMeasurement?: Array<{ __typename?: 'UnitOfMeasurement', id: string, code: string, measurementType: UnitOfMeasurementBusinessUnitMeasurementType } | null> | null, country?: { __typename?: 'Country', id: string, code: string, name: string, isoAlpha2?: string | null, isoNumber?: number | null, visualIdPrefix?: string | null, region?: { __typename?: 'Region', code: string, name: string } | null } | null, farmAnimalTypes: Array<{ __typename?: 'AnimalType', colour: string, enabled: boolean, id: string, image?: string | null, name: string, position: number, slug?: string | null }>, effectiveSubscriptionPlan?: { __typename?: 'SubscriptionPlan', name: string } | null, identifierPreferencesActiveIds?: { __typename?: 'ActiveIdentifierPreferencesType', alternativeId: boolean, passportNumber: boolean, visualId: boolean, eId: boolean, name: boolean, trichId: boolean, tsuBarcode: boolean, pedigreeId: boolean, tattoo: boolean, herdDoggId: boolean, breedrId: boolean, uhfId: boolean, brucellosisId: boolean } | null, herdDoggIntegration?: { __typename?: 'HerdDoggIntegrationObjectType', isConnected?: boolean | null } | null } | null> | null };

export type BuStrippedFragment = { __typename?: 'BusinessUnit', id: string, name: string };

export type GetStrippedBusinessUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStrippedBusinessUnitsQuery = { __typename?: 'Query', businessUnits?: Array<{ __typename?: 'BusinessUnit', id: string, name: string } | null> | null };

export type GetBusinessUnitQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
}>;


export type GetBusinessUnitQuery = { __typename?: 'Query', businessUnit?: { __typename?: 'BusinessUnit', id: string, name: string, profilePhoto?: string | null, warnings?: any | null, tbStatus?: BusinessUnitTbStatus | null, postcode?: string | null, canCreateRfl: boolean, locationsCount?: number | null, foggles?: Array<string | null> | null, identifierPreferencesPrimaryId?: IdentifierEnumType | null, identifierPreferencesSecondaryId?: IdentifierEnumType | null, organisation?: { __typename?: 'Organisation', id: string } | null, tradingTypes: Array<{ __typename?: 'TradingType', id: string, slug: string, name: string }>, businessType?: { __typename?: 'BusinessType', id: string, slug: string } | null, regulatorySystem?: { __typename?: 'IntegrationSystemType', id: string, slug: string, name: string } | null, deliveryAddress: Array<{ __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null, postcode?: string | null, addressLine1?: string | null }>, primaryLocation?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, postcode?: string | null } | null, currency?: { __typename?: 'Currency', id: string, name: string, code: string } | null, unitsOfMeasurement?: Array<{ __typename?: 'UnitOfMeasurement', id: string, code: string, measurementType: UnitOfMeasurementBusinessUnitMeasurementType } | null> | null, country?: { __typename?: 'Country', id: string, code: string, name: string, isoAlpha2?: string | null, isoNumber?: number | null, visualIdPrefix?: string | null, region?: { __typename?: 'Region', code: string, name: string } | null } | null, farmAnimalTypes: Array<{ __typename?: 'AnimalType', colour: string, enabled: boolean, id: string, image?: string | null, name: string, position: number, slug?: string | null }>, effectiveSubscriptionPlan?: { __typename?: 'SubscriptionPlan', name: string } | null, identifierPreferencesActiveIds?: { __typename?: 'ActiveIdentifierPreferencesType', alternativeId: boolean, passportNumber: boolean, visualId: boolean, eId: boolean, name: boolean, trichId: boolean, tsuBarcode: boolean, pedigreeId: boolean, tattoo: boolean, herdDoggId: boolean, breedrId: boolean, uhfId: boolean, brucellosisId: boolean } | null, herdDoggIntegration?: { __typename?: 'HerdDoggIntegrationObjectType', isConnected?: boolean | null } | null } | null };

export type GetBusinessUnitUsersQueryVariables = Exact<{
  businessUnitId?: InputMaybe<Scalars['Int']>;
}>;


export type GetBusinessUnitUsersQuery = { __typename?: 'Query', businessUnitUsers?: Array<{ __typename?: 'BusinessUnitUser', id: string, status: BusinessUnitUserStatus, isOwner?: boolean | null, role: { __typename?: 'Role', id: string, name: string }, businessUnit: { __typename?: 'BusinessUnit', id: string, name: string }, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, image?: string | null, phone?: string | null, lastLogin?: any | null, jobTitle: string, intercomUserHash?: string | null } } | null> | null };

export type GetBusinessUnitSettingsQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
}>;


export type GetBusinessUnitSettingsQuery = { __typename?: 'Query', businessUnit?: { __typename?: 'BusinessUnit', id: string, killOut?: number | null, enableBcmsPushTransactions: boolean, tbStatus?: BusinessUnitTbStatus | null, dateJoined: any } | null };

export type GetBusinessUnitSizeUnitQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
}>;


export type GetBusinessUnitSizeUnitQuery = { __typename?: 'Query', businessUnit?: { __typename?: 'BusinessUnit', id: string, settings?: { __typename?: 'BusinessUnitSettingsType', sizeUnit: BusinessUnitSettingsSizeUnit } | null } | null };

export type SearchBusinessUnitsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  excludeBusinessUnitId?: InputMaybe<Scalars['Int']>;
  preferredSuppliersBuyerId?: InputMaybe<Scalars['Int']>;
}>;


export type SearchBusinessUnitsQuery = { __typename?: 'Query', searchBusinessUnits?: Array<{ __typename?: 'SearchBusinessUnit', id?: number | null, name?: string | null, location?: { __typename?: 'LocationSearchBusinessUnit', city?: string | null, unitName?: string | null } | null } | null> | null };

export type SearchPreferredBusinessUnitsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  excludeBusinessUnitIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  preferredSuppliersBuyerId?: InputMaybe<Scalars['Int']>;
}>;


export type SearchPreferredBusinessUnitsQuery = { __typename?: 'Query', searchBusinessUnits?: Array<{ __typename?: 'SearchBusinessUnit', id?: number | null, name?: string | null, location?: { __typename?: 'LocationSearchBusinessUnit', city?: string | null, unitName?: string | null } | null } | null> | null };

export type GetPreferredBusinessUnitsQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
}>;


export type GetPreferredBusinessUnitsQuery = { __typename?: 'Query', preferredBusinessUnits?: Array<{ __typename?: 'PreferredBusinessUnit', id: string, priceAdjustment?: number | null, commonStatus?: string | null, tacTitle?: string | null, tacDescription?: string | null, supplier: { __typename?: 'PublicBusinessUnit', id: string, name: string, primaryLocation?: { __typename?: 'PublicDeliveryAddressType', id: string, city?: string | null, unitName?: string | null } | null }, buyer: { __typename?: 'PublicBusinessUnit', id: string, name: string, primaryLocation?: { __typename?: 'PublicDeliveryAddressType', id: string, city?: string | null, unitName?: string | null } | null }, fieldsman?: { __typename?: 'UserPublicInfo', id: number, firstName: string, lastName: string } | null } | null> | null };

export type GetPreferredBusinessUnitQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
  id: Scalars['Int'];
}>;


export type GetPreferredBusinessUnitQuery = { __typename?: 'Query', preferredBusinessUnit?: { __typename?: 'PreferredBusinessUnit', id: string, priceAdjustment?: number | null, supplier: { __typename?: 'PublicBusinessUnit', id: string, name: string }, fieldsman?: { __typename?: 'UserPublicInfo', id: number } | null } | null };

export type EmptyStateQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
  page: Scalars['String'];
  platform: Scalars['String'];
  animalType: Scalars['Int'];
}>;


export type EmptyStateQuery = { __typename?: 'Query', emptyState?: { __typename?: 'EmptyStateObjectType', id: string, text: string, image?: string | null, page: EmptyStatePage, showButton: boolean, button?: EmptyStateButton | null, buttonLink: string, buttonLabel: string } | null };

export type GetSupportedSystemsCustomImportQueryVariables = Exact<{
  farm: Scalars['Int'];
  systemType?: InputMaybe<Scalars['String']>;
  isAutomatedSystem?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetSupportedSystemsCustomImportQuery = { __typename?: 'Query', integrationSystems?: Array<{ __typename?: 'IntegrationSystemType', id: string, name: string, logo?: string | null } | null> | null };

export type ImportResultQueryVariables = Exact<{
  task: Scalars['String'];
}>;


export type ImportResultQuery = { __typename?: 'Query', importResult?: { __typename?: 'ImportResult', isDone?: boolean | null, processedRows?: number | null, errorRows?: any | null, failedAnimalsUrl?: string | null, failedActivitiesUrl?: string | null, importedAnimalsCount?: number | null, createdGroupsCount?: number | null, updatedAnimals?: any | null, importedActivitiesCount?: number | null, animals?: Array<{ __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> }> | null } | null };

export type TaskDetailsFragmentFragment = { __typename?: 'FarmSystemTaskType', id: string, action: FarmSystemTaskAction, status: FarmSystemTaskStatus, totalNumberItems: number, updatedNumberItems: number, processedNumberItems: number, newNumberItems: number, producedTask?: { __typename?: 'FarmSystemTaskType', id: string, newNumberItems: number } | null, producedFromTask?: { __typename?: 'FarmSystemTaskType', createdItems?: Array<{ __typename?: 'ActivityLog', date?: any | null, animal?: { __typename?: 'PublicAnimal', passportNumber?: string | null } | null, payload?: { __typename?: 'ActivityPayload', description?: string | null, data?: Array<{ __typename?: 'ActivityPayloadData', name?: string | null, value?: any | null, unitName?: string | null } | null> | null } | null } | { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null } | null, createdItems?: Array<{ __typename?: 'ActivityLog', date?: any | null, animal?: { __typename?: 'PublicAnimal', passportNumber?: string | null } | null, payload?: { __typename?: 'ActivityPayload', description?: string | null, data?: Array<{ __typename?: 'ActivityPayloadData', name?: string | null, value?: any | null, unitName?: string | null } | null> | null } | null } | { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null, updatedItems?: Array<{ __typename?: 'ActivityLog' } | { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null, uncreatedItems?: Array<{ __typename?: 'UnprocessedAnimal', id?: string | null, passportNumber?: string | null, date?: string | null, weight?: string | null, breed?: string | null, eId?: string | null, dob?: string | null, sex?: string | null } | null> | null };

export type BcmsImportCsvMutationVariables = Exact<{
  input: BcmsImportCsvInput;
}>;


export type BcmsImportCsvMutation = { __typename?: 'Mutation', bcmsImportCsv?: { __typename?: 'BcmsImportCsvPayload', task?: { __typename?: 'FarmSystemTaskType', id: string, action: FarmSystemTaskAction, status: FarmSystemTaskStatus, totalNumberItems: number, updatedNumberItems: number, processedNumberItems: number, newNumberItems: number, producedTask?: { __typename?: 'FarmSystemTaskType', id: string, newNumberItems: number } | null, producedFromTask?: { __typename?: 'FarmSystemTaskType', createdItems?: Array<{ __typename?: 'ActivityLog', date?: any | null, animal?: { __typename?: 'PublicAnimal', passportNumber?: string | null } | null, payload?: { __typename?: 'ActivityPayload', description?: string | null, data?: Array<{ __typename?: 'ActivityPayloadData', name?: string | null, value?: any | null, unitName?: string | null } | null> | null } | null } | { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null } | null, createdItems?: Array<{ __typename?: 'ActivityLog', date?: any | null, animal?: { __typename?: 'PublicAnimal', passportNumber?: string | null } | null, payload?: { __typename?: 'ActivityPayload', description?: string | null, data?: Array<{ __typename?: 'ActivityPayloadData', name?: string | null, value?: any | null, unitName?: string | null } | null> | null } | null } | { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null, updatedItems?: Array<{ __typename?: 'ActivityLog' } | { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null, uncreatedItems?: Array<{ __typename?: 'UnprocessedAnimal', id?: string | null, passportNumber?: string | null, date?: string | null, weight?: string | null, breed?: string | null, eId?: string | null, dob?: string | null, sex?: string | null } | null> | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type TruTestImportXlsMutationVariables = Exact<{
  input: TruTestImportXlsInput;
}>;


export type TruTestImportXlsMutation = { __typename?: 'Mutation', truTestImportXls?: { __typename?: 'TruTestImportXlsPayload', task?: { __typename?: 'FarmSystemTaskType', id: string, action: FarmSystemTaskAction, status: FarmSystemTaskStatus, totalNumberItems: number, updatedNumberItems: number, processedNumberItems: number, newNumberItems: number, producedTask?: { __typename?: 'FarmSystemTaskType', id: string, newNumberItems: number } | null, producedFromTask?: { __typename?: 'FarmSystemTaskType', createdItems?: Array<{ __typename?: 'ActivityLog', date?: any | null, animal?: { __typename?: 'PublicAnimal', passportNumber?: string | null } | null, payload?: { __typename?: 'ActivityPayload', description?: string | null, data?: Array<{ __typename?: 'ActivityPayloadData', name?: string | null, value?: any | null, unitName?: string | null } | null> | null } | null } | { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null } | null, createdItems?: Array<{ __typename?: 'ActivityLog', date?: any | null, animal?: { __typename?: 'PublicAnimal', passportNumber?: string | null } | null, payload?: { __typename?: 'ActivityPayload', description?: string | null, data?: Array<{ __typename?: 'ActivityPayloadData', name?: string | null, value?: any | null, unitName?: string | null } | null> | null } | null } | { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null, updatedItems?: Array<{ __typename?: 'ActivityLog' } | { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null, uncreatedItems?: Array<{ __typename?: 'UnprocessedAnimal', id?: string | null, passportNumber?: string | null, date?: string | null, weight?: string | null, breed?: string | null, eId?: string | null, dob?: string | null, sex?: string | null } | null> | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type FarmPlanImportXlsMutationVariables = Exact<{
  input: FarmPlanImportXlsInput;
}>;


export type FarmPlanImportXlsMutation = { __typename?: 'Mutation', farmPlanImportXls?: { __typename?: 'FarmPlanImportXLSPayload', task?: { __typename?: 'FarmSystemTaskType', id: string, action: FarmSystemTaskAction, status: FarmSystemTaskStatus, totalNumberItems: number, updatedNumberItems: number, processedNumberItems: number, newNumberItems: number, producedTask?: { __typename?: 'FarmSystemTaskType', id: string, newNumberItems: number } | null, producedFromTask?: { __typename?: 'FarmSystemTaskType', createdItems?: Array<{ __typename?: 'ActivityLog', date?: any | null, animal?: { __typename?: 'PublicAnimal', passportNumber?: string | null } | null, payload?: { __typename?: 'ActivityPayload', description?: string | null, data?: Array<{ __typename?: 'ActivityPayloadData', name?: string | null, value?: any | null, unitName?: string | null } | null> | null } | null } | { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null } | null, createdItems?: Array<{ __typename?: 'ActivityLog', date?: any | null, animal?: { __typename?: 'PublicAnimal', passportNumber?: string | null } | null, payload?: { __typename?: 'ActivityPayload', description?: string | null, data?: Array<{ __typename?: 'ActivityPayloadData', name?: string | null, value?: any | null, unitName?: string | null } | null> | null } | null } | { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null, updatedItems?: Array<{ __typename?: 'ActivityLog' } | { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null, uncreatedItems?: Array<{ __typename?: 'UnprocessedAnimal', id?: string | null, passportNumber?: string | null, date?: string | null, weight?: string | null, breed?: string | null, eId?: string | null, dob?: string | null, sex?: string | null } | null> | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type AphisImportCsvMutationVariables = Exact<{
  input: AphisImportCsvInput;
}>;


export type AphisImportCsvMutation = { __typename?: 'Mutation', aphisImportCsv?: { __typename?: 'AphisImportCsvPayload', task?: { __typename?: 'FarmSystemTaskType', id: string, action: FarmSystemTaskAction, status: FarmSystemTaskStatus, totalNumberItems: number, updatedNumberItems: number, processedNumberItems: number, newNumberItems: number, producedTask?: { __typename?: 'FarmSystemTaskType', id: string, newNumberItems: number } | null, producedFromTask?: { __typename?: 'FarmSystemTaskType', createdItems?: Array<{ __typename?: 'ActivityLog', date?: any | null, animal?: { __typename?: 'PublicAnimal', passportNumber?: string | null } | null, payload?: { __typename?: 'ActivityPayload', description?: string | null, data?: Array<{ __typename?: 'ActivityPayloadData', name?: string | null, value?: any | null, unitName?: string | null } | null> | null } | null } | { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null } | null, createdItems?: Array<{ __typename?: 'ActivityLog', date?: any | null, animal?: { __typename?: 'PublicAnimal', passportNumber?: string | null } | null, payload?: { __typename?: 'ActivityPayload', description?: string | null, data?: Array<{ __typename?: 'ActivityPayloadData', name?: string | null, value?: any | null, unitName?: string | null } | null> | null } | null } | { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null, updatedItems?: Array<{ __typename?: 'ActivityLog' } | { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null, uncreatedItems?: Array<{ __typename?: 'UnprocessedAnimal', id?: string | null, passportNumber?: string | null, date?: string | null, weight?: string | null, breed?: string | null, eId?: string | null, dob?: string | null, sex?: string | null } | null> | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type StartFarmSystemTaskMutationVariables = Exact<{
  input: StartFarmSystemTaskInput;
}>;


export type StartFarmSystemTaskMutation = { __typename?: 'Mutation', startFarmSystemTask?: { __typename?: 'StartFarmSystemTaskPayload', id?: number | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type CancelFarmSystemTaskMutationVariables = Exact<{
  input: CancelFarmSystemTaskInput;
}>;


export type CancelFarmSystemTaskMutation = { __typename?: 'Mutation', cancelFarmSystemTask?: { __typename?: 'CancelFarmSystemTaskPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type GetSupportedSystemsQueryVariables = Exact<{
  farm: Scalars['Int'];
  systemType?: InputMaybe<Scalars['String']>;
  isAutomatedSystem?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetSupportedSystemsQuery = { __typename?: 'Query', integrationSystems?: Array<{ __typename?: 'IntegrationSystemType', id: string, name: string, logo?: string | null, helpLink?: string | null, slug: string, fields: Array<{ __typename?: 'SystemCredentialFieldType', id: string, fieldLabel: string, fieldName: string, fieldType: SystemCredentialFieldFieldType, inputMask: string, minLength?: number | null, maxLength?: number | null, placeholder: string }> } | null> | null };

export type GetTaskInfoQueryVariables = Exact<{
  taskId: Scalars['Int'];
}>;


export type GetTaskInfoQuery = { __typename?: 'Query', farmSystemTask?: { __typename?: 'FarmSystemTaskType', id: string, action: FarmSystemTaskAction, status: FarmSystemTaskStatus, totalNumberItems: number, updatedNumberItems: number, processedNumberItems: number, newNumberItems: number, producedTask?: { __typename?: 'FarmSystemTaskType', id: string, newNumberItems: number } | null, producedFromTask?: { __typename?: 'FarmSystemTaskType', createdItems?: Array<{ __typename?: 'ActivityLog', date?: any | null, animal?: { __typename?: 'PublicAnimal', passportNumber?: string | null } | null, payload?: { __typename?: 'ActivityPayload', description?: string | null, data?: Array<{ __typename?: 'ActivityPayloadData', name?: string | null, value?: any | null, unitName?: string | null } | null> | null } | null } | { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null } | null, createdItems?: Array<{ __typename?: 'ActivityLog', date?: any | null, animal?: { __typename?: 'PublicAnimal', passportNumber?: string | null } | null, payload?: { __typename?: 'ActivityPayload', description?: string | null, data?: Array<{ __typename?: 'ActivityPayloadData', name?: string | null, value?: any | null, unitName?: string | null } | null> | null } | null } | { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null, updatedItems?: Array<{ __typename?: 'ActivityLog' } | { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null, uncreatedItems?: Array<{ __typename?: 'UnprocessedAnimal', id?: string | null, passportNumber?: string | null, date?: string | null, weight?: string | null, breed?: string | null, eId?: string | null, dob?: string | null, sex?: string | null } | null> | null } | null };

export type LinkHerdDoggAccountMutationVariables = Exact<{
  input: LinkHerdDoggAccountInput;
}>;


export type LinkHerdDoggAccountMutation = { __typename?: 'Mutation', linkHerdDoggAccount?: { __typename?: 'LinkHerdDoggAccountPayload', success?: boolean | null } | null };

export type UnlinkHerdDoggAccountMutationVariables = Exact<{
  input: UnlinkHerdDoggAccountInput;
}>;


export type UnlinkHerdDoggAccountMutation = { __typename?: 'Mutation', unlinkHerdDoggAccount?: { __typename?: 'UnlinkHerdDoggAccountPayload', success?: boolean | null } | null };

export type LineItemFragmentFragment = { __typename?: 'LineItemType', id?: any | null, name?: string | null, sku: string, batchNumber: string, quantity?: number | null, totalVolume?: number | null, originalVolume?: number | null, expiryDate?: any | null, bottleNumber: string, cost?: number | null, purchaseDate?: any | null, supplierName: string, volumeUnits: string };

export type StockItemFragmentFragment = { __typename?: 'StockItemListType', id?: any | null, name: string, totalQuantity?: number | null, totalVolume?: number | null, manufacturer: string, manufacturerName: string, applicationMethod: string, activeIngredient: string, species: Array<{ __typename?: 'AnimalType', id: string, name: string }>, withdrawal?: Array<{ __typename?: 'MedicineWithdrawalType', id?: number | null, withdrawalPeriodDays?: number | null, withdrawalType?: string | null, animalType?: { __typename?: 'AnimalType', id: string, name: string, slug?: string | null } | null } | null> | null, lineItems: Array<{ __typename?: 'LineItemType', id?: any | null, name?: string | null, sku: string, batchNumber: string, quantity?: number | null, totalVolume?: number | null, originalVolume?: number | null, expiryDate?: any | null, bottleNumber: string, cost?: number | null, purchaseDate?: any | null, supplierName: string, volumeUnits: string }> };

export type GetStockItemQueryVariables = Exact<{
  id: Scalars['UUID'];
  businessUnitId: Scalars['Int'];
}>;


export type GetStockItemQuery = { __typename?: 'Query', stockItem?: { __typename?: 'StockItemListType', id?: any | null, name: string, totalQuantity?: number | null, totalVolume?: number | null, manufacturer: string, manufacturerName: string, applicationMethod: string, activeIngredient: string, species: Array<{ __typename?: 'AnimalType', id: string, name: string }>, withdrawal?: Array<{ __typename?: 'MedicineWithdrawalType', id?: number | null, withdrawalPeriodDays?: number | null, withdrawalType?: string | null, animalType?: { __typename?: 'AnimalType', id: string, name: string, slug?: string | null } | null } | null> | null, lineItems: Array<{ __typename?: 'LineItemType', id?: any | null, name?: string | null, sku: string, batchNumber: string, quantity?: number | null, totalVolume?: number | null, originalVolume?: number | null, expiryDate?: any | null, bottleNumber: string, cost?: number | null, purchaseDate?: any | null, supplierName: string, volumeUnits: string }> } | null };

export type LineItemsQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
}>;


export type LineItemsQuery = { __typename?: 'Query', lineItems?: Array<{ __typename?: 'LineItemType', id?: any | null, name?: string | null, sku: string, purchaseDate?: any | null, expiryDate?: any | null, batchNumber: string, quantity?: number | null, totalVolume?: number | null, originalVolume?: number | null, quantityUnits: string, stockItem: { __typename?: 'StockItemListType', id?: any | null, name: string } } | null> | null };

export type GetMedicineActivitiesQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
  stockItemId: Scalars['UUID'];
  batchNumber?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetMedicineActivitiesQuery = { __typename?: 'Query', itemTransactions?: { __typename?: 'ItemTransactionConnection', edges: Array<{ __typename?: 'ItemTransactionEdge', node?: { __typename?: 'ItemTransactionType', id?: number | null, date?: any | null, batchNumber: string, valueDescription?: string | null, shortDescription?: string | null, longDescription?: string | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type GetInventoryInfoQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
}>;


export type GetInventoryInfoQuery = { __typename?: 'Query', inventoryInfo?: Array<{ __typename?: 'InventoryInfoType', id?: string | null, activeIngredients?: string | null, batchNumber?: string | null, name?: string | null, stockItemId?: string | null, totalOriginalVolume?: number | null, totalRemainingVolume?: number | null, volumeUnits?: string | null, withdrawalNotes?: string | null } | null> | null };

export type ActivityTypeFragmentFragment = { __typename?: 'ActivityType', id: string, image?: string | null, imageSvg?: string | null, slug?: string | null, name: string, isPublic: boolean, isSystem: boolean, activityTemplatesCount?: number | null };

export type ActivityTemplateFragmentFragment = { __typename?: 'ActivityTemplate', id: string, name: string, slug?: string | null, description?: string | null, businessUnit?: { __typename?: 'BusinessUnit', id: string, name: string } | null, fields: Array<{ __typename?: 'ActivityTemplateField', id: string, name: string, slug?: string | null, units: ActivityTemplateFieldUnits, fieldType: ActivityTemplateFieldFieldType, position: number, initialValue?: any | null, isRequired: boolean, options?: Array<{ __typename?: 'ActivityTemplateFieldOption', id: string, title: string, value?: string | null } | null> | null }>, activityType?: { __typename?: 'ActivityType', id: string, image?: string | null, imageSvg?: string | null, slug?: string | null, name: string, isPublic: boolean, isSystem: boolean, position: number, activityTemplatesCount?: number | null } | null };

export type ActivityTypeShortFragmentFragment = { __typename?: 'ActivityType', id: string, slug?: string | null, image?: string | null };

export type ActivityLogFragmentFragment = { __typename?: 'ActivityLog', id?: any | null, date?: any | null, dontShow?: boolean | null, isDeletable?: boolean | null, payload?: { __typename?: 'ActivityPayload', valueDescription?: string | null, shortDescription?: string | null, longDescription?: string | null, data?: Array<{ __typename?: 'ActivityPayloadData', fieldSlug?: string | null } | null> | null } | null, activityType?: { __typename?: 'ActivityType', id: string, slug?: string | null, image?: string | null } | null, activityTemplate?: { __typename?: 'ActivityTemplate', id: string, activityType?: { __typename?: 'ActivityType', id: string, slug?: string | null, image?: string | null } | null } | null };

export type HistoryAnimalFragmentFragment = { __typename?: 'ActivityLog', id?: any | null, date?: any | null, dontShow?: boolean | null, isDeletable?: boolean | null, payload?: { __typename?: 'ActivityPayload', name?: string | null, description?: string | null, data?: Array<{ __typename?: 'ActivityPayloadData', value?: any | null, unitName?: string | null, fieldSlug?: string | null } | null> | null } | null, activityType?: { __typename?: 'ActivityType', id: string, slug?: string | null, image?: string | null } | null, activityTemplate?: { __typename?: 'ActivityTemplate', id: string, activityType?: { __typename?: 'ActivityType', id: string, slug?: string | null, image?: string | null } | null } | null };

export type ImportActivityFragmentFragment = { __typename?: 'ActivityLog', date?: any | null, animal?: { __typename?: 'PublicAnimal', passportNumber?: string | null } | null, payload?: { __typename?: 'ActivityPayload', description?: string | null, data?: Array<{ __typename?: 'ActivityPayloadData', name?: string | null, value?: any | null, unitName?: string | null } | null> | null } | null };

export type LogActivityBulkMutationMutationVariables = Exact<{
  input: LogActivityBulkInput;
}>;


export type LogActivityBulkMutationMutation = { __typename?: 'Mutation', logActivityBulk?: { __typename?: 'LogActivityBulkPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type DeleteActivityBulkMutationMutationVariables = Exact<{
  input: DeleteActivityBulkInput;
}>;


export type DeleteActivityBulkMutationMutation = { __typename?: 'Mutation', deleteActivityBulk?: { __typename?: 'DeleteActivityBulkPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type GetActivityTypesQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
}>;


export type GetActivityTypesQuery = { __typename?: 'Query', activityTypes?: Array<{ __typename?: 'ActivityType', id: string, image?: string | null, imageSvg?: string | null, slug?: string | null, name: string, isPublic: boolean, isSystem: boolean, activityTemplatesCount?: number | null } | null> | null };

export type GetActivityTemplatesQueryVariables = Exact<{
  businessUnit?: InputMaybe<Scalars['Int']>;
  species?: InputMaybe<Scalars['Int']>;
}>;


export type GetActivityTemplatesQuery = { __typename?: 'Query', activityTemplates?: Array<{ __typename?: 'ActivityTemplate', id: string, name: string, slug?: string | null, description?: string | null, businessUnit?: { __typename?: 'BusinessUnit', id: string, name: string } | null, fields: Array<{ __typename?: 'ActivityTemplateField', id: string, name: string, slug?: string | null, units: ActivityTemplateFieldUnits, fieldType: ActivityTemplateFieldFieldType, position: number, initialValue?: any | null, isRequired: boolean, options?: Array<{ __typename?: 'ActivityTemplateFieldOption', id: string, title: string, value?: string | null } | null> | null }>, activityType?: { __typename?: 'ActivityType', id: string, image?: string | null, imageSvg?: string | null, slug?: string | null, name: string, isPublic: boolean, isSystem: boolean, position: number, activityTemplatesCount?: number | null } | null } | null> | null };

export type GetActivityLogQueryVariables = Exact<{
  animal?: InputMaybe<Scalars['UUID']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  activityTemplateSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  activityTypeSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetActivityLogQuery = { __typename?: 'Query', activities?: { __typename?: 'ActivityConnection', edges: Array<{ __typename?: 'ActivityEdge', node?: { __typename?: 'ActivityLog', id?: any | null, date?: any | null, dontShow?: boolean | null, isDeletable?: boolean | null, payload?: { __typename?: 'ActivityPayload', valueDescription?: string | null, shortDescription?: string | null, longDescription?: string | null, data?: Array<{ __typename?: 'ActivityPayloadData', fieldSlug?: string | null } | null> | null } | null, activityType?: { __typename?: 'ActivityType', id: string, slug?: string | null, image?: string | null } | null, activityTemplate?: { __typename?: 'ActivityTemplate', id: string, activityType?: { __typename?: 'ActivityType', id: string, slug?: string | null, image?: string | null } | null } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetActivityLogOldQueryVariables = Exact<{
  animal?: InputMaybe<Scalars['UUID']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  activityTemplateSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  activityTypeSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetActivityLogOldQuery = { __typename?: 'Query', activities?: { __typename?: 'ActivityConnection', edges: Array<{ __typename?: 'ActivityEdge', node?: { __typename?: 'ActivityLog', id?: any | null, date?: any | null, dontShow?: boolean | null, isDeletable?: boolean | null, payload?: { __typename?: 'ActivityPayload', name?: string | null, description?: string | null, data?: Array<{ __typename?: 'ActivityPayloadData', value?: any | null, unitName?: string | null, fieldSlug?: string | null } | null> | null } | null, activityType?: { __typename?: 'ActivityType', id: string, slug?: string | null, image?: string | null } | null, activityTemplate?: { __typename?: 'ActivityTemplate', id: string, activityType?: { __typename?: 'ActivityType', id: string, slug?: string | null, image?: string | null } | null } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetActivityLogNewQueryVariables = Exact<{
  animal?: InputMaybe<Scalars['UUID']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  activityTemplateSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  activityTypeSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  isChartable?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetActivityLogNewQuery = { __typename?: 'Query', activities?: { __typename?: 'ActivityConnection', edges: Array<{ __typename?: 'ActivityEdge', node?: { __typename?: 'ActivityLog', id?: any | null, date?: any | null, dontShow?: boolean | null, isDeletable?: boolean | null, payload?: { __typename?: 'ActivityPayload', valueDescription?: string | null, shortDescription?: string | null, longDescription?: string | null, data?: Array<{ __typename?: 'ActivityPayloadData', fieldSlug?: string | null } | null> | null } | null, activityType?: { __typename?: 'ActivityType', id: string, slug?: string | null, image?: string | null } | null, activityTemplate?: { __typename?: 'ActivityTemplate', id: string, activityType?: { __typename?: 'ActivityType', id: string, slug?: string | null, image?: string | null } | null } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type AnimalTypeFragmentFragment = { __typename?: 'AnimalType', id: string, name: string, slug?: string | null };

export type AnimalBreedsFragmentFragment = { __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null, regName?: string | null, regBreedCode?: string | null, animalType?: { __typename?: 'AnimalType', id: string, name: string, slug?: string | null } | null };

export type AnimalFragmentFragment = { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> };

export type PublicAnimalFragmentFragment = { __typename?: 'PublicAnimal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, visualId?: string | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, sirePassportNumber?: string | null, dateMovedToFarm?: any | null, growthRate?: number | null, cphCount?: number | null, targetDailyLiveWeightGain?: number | null, withdrawalEnd?: any | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null }>, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null };

export type SingleAnimalFragmentFragment = { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, offerId?: number | null, currentWeight?: number | null, visualId?: string | null, eId?: string | null, growthRate?: number | null, performanceCategory?: string | null, sirePassportNumber?: string | null, damPassportNumber?: string | null, rflId?: string | null, deliveryDate?: any | null, buyerName?: string | null, dateMovedToFarm?: any | null, daysToTargetWeight?: number | null, withdrawalEnd?: any | null, isRegulatorySynced?: boolean | null, targetDailyLiveWeightGain?: number | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, isPregnant?: boolean | null, pregnancyDueDate?: any | null, brucellosisId?: string | null, tattoo?: string | null, tsuBarcode?: string | null, pedigreeId?: string | null, trichId?: string | null, breedrId?: string | null, uhfId?: string | null, name?: string | null, herdDoggId?: string | null, alternativeId?: string | null, lastWeight?: { __typename?: 'WeightActivityLog', value?: number | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, breedPercentages: Array<{ __typename?: 'BreedPercentage', percentage?: number | null, breed: { __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null } }>, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null } | null, animalColour?: { __typename?: 'AnimalColour', id?: number | null, code?: string | null, name?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, animalType?: { __typename?: 'AnimalType', id: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, color?: string | null, name: string, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> };

export type AnimalFiltersFragmentFragment = { __typename?: 'AnimalFilterObjectType', id: string, name: string, isMale?: boolean | null, ageFrom?: number | null, ageTo?: number | null, currentWeightFrom?: number | null, currentWeightTo?: number | null, lastWeightFrom?: number | null, lastWeightTo?: number | null, daysSinceLastWeightFrom?: number | null, daysSinceLastWeightTo?: number | null, dobFrom?: any | null, dobTo?: any | null, dofFrom?: any | null, dofTo?: any | null, growthRateFrom?: number | null, growthRateTo?: number | null, deliveryFrom?: any | null, deliveryTo?: any | null, lastRegulatorySyncedDateFrom?: any | null, lastRegulatorySyncedDateTo?: any | null, isRegulatorySynced?: boolean | null, inWithdrawal?: boolean | null, color: AnimalFilterColor, isAlert: boolean, isPregnant?: boolean | null, pregnancyDueDateFrom?: any | null, pregnancyDueDateTo?: any | null, animalType?: { __typename?: 'AnimalType', id: string, image?: string | null, colour: string } | null, breeds: Array<{ __typename?: 'AnimalBreed', id: any }>, sexClassifications: Array<{ __typename?: 'SexClassification', slug: string, title: string }>, fields: Array<{ __typename?: 'Field', id: any }>, groups: Array<{ __typename?: 'Group', id: string }> };

export type UnprocessedAnimalFragmentFragment = { __typename?: 'UnprocessedAnimal', id?: string | null, passportNumber?: string | null, date?: string | null, weight?: string | null, breed?: string | null, eId?: string | null, dob?: string | null, sex?: string | null };

export type AnimalOffspringFragmentFragment = { __typename?: 'PublicAnimal', id?: any | null, dob?: any | null, isArchived?: boolean | null, isMale: boolean, ownerId?: string | null, passportNumber?: string | null, sirePassportNumber?: string | null, visualId?: string | null, birthInformation?: { __typename?: 'PublicBirthInformation', birthAbnormalities?: string | null, birthingDifficulty?: string | null, birthPresentation?: string | null, birthSize?: string | null, birthVigor?: string | null, birthWeight?: number | null } | null };

export type CreateAnimalFilterMutationVariables = Exact<{
  input: CreateAnimalFilterInput;
}>;


export type CreateAnimalFilterMutation = { __typename?: 'Mutation', createAnimalFilter?: { __typename?: 'CreateAnimalFilterPayload', animalFilter?: { __typename?: 'AnimalFilterObjectType', id: string, name: string, isMale?: boolean | null, ageFrom?: number | null, ageTo?: number | null, currentWeightFrom?: number | null, currentWeightTo?: number | null, lastWeightFrom?: number | null, lastWeightTo?: number | null, daysSinceLastWeightFrom?: number | null, daysSinceLastWeightTo?: number | null, dobFrom?: any | null, dobTo?: any | null, dofFrom?: any | null, dofTo?: any | null, growthRateFrom?: number | null, growthRateTo?: number | null, deliveryFrom?: any | null, deliveryTo?: any | null, lastRegulatorySyncedDateFrom?: any | null, lastRegulatorySyncedDateTo?: any | null, isRegulatorySynced?: boolean | null, inWithdrawal?: boolean | null, color: AnimalFilterColor, isAlert: boolean, isPregnant?: boolean | null, pregnancyDueDateFrom?: any | null, pregnancyDueDateTo?: any | null, animalType?: { __typename?: 'AnimalType', id: string, image?: string | null, colour: string } | null, breeds: Array<{ __typename?: 'AnimalBreed', id: any }>, sexClassifications: Array<{ __typename?: 'SexClassification', slug: string, title: string }>, fields: Array<{ __typename?: 'Field', id: any }>, groups: Array<{ __typename?: 'Group', id: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UpdateAnimalFilterMutationVariables = Exact<{
  input: UpdateAnimalFilterInput;
}>;


export type UpdateAnimalFilterMutation = { __typename?: 'Mutation', updateAnimalFilter?: { __typename?: 'UpdateAnimalFilterPayload', animalFilter?: { __typename?: 'AnimalFilterObjectType', id: string } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type DeleteAnimalFilterMutationVariables = Exact<{
  input: DeleteAnimalFilterInput;
}>;


export type DeleteAnimalFilterMutation = { __typename?: 'Mutation', deleteAnimalFilter?: { __typename?: 'DeleteAnimalFilterPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type GetAnimalBreedsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnimalBreedsQuery = { __typename?: 'Query', animalBreeds?: Array<{ __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null, regName?: string | null, regBreedCode?: string | null, animalType?: { __typename?: 'AnimalType', id: string, name: string, slug?: string | null } | null } | null> | null };

export type GetBusinessUnitBreedsQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
  animalTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type GetBusinessUnitBreedsQuery = { __typename?: 'Query', businessUnitBreeds?: Array<{ __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null, regName?: string | null, regBreedCode?: string | null, animalType?: { __typename?: 'AnimalType', id: string, name: string, slug?: string | null } | null } | null> | null };

export type GetAnimalTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnimalTypesQuery = { __typename?: 'Query', animalTypes?: Array<{ __typename?: 'AnimalType', id: string, name: string, slug?: string | null } | null> | null };

export type GetAnimalCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnimalCategoriesQuery = { __typename?: 'Query', animalTypes?: Array<{ __typename?: 'AnimalType', id: string, name: string, categoriesOfSale?: Array<{ __typename?: 'CategoryOfSale', id: number, category: string, position: number } | null> | null } | null> | null };

export type GetAnimalsListQueryVariables = Exact<{
  animalTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  businessUnitId?: InputMaybe<Scalars['Int']>;
  isDead?: InputMaybe<Scalars['Boolean']>;
  isWasOwned?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Scalars['UUID']>;
  updatedFrom?: InputMaybe<Scalars['DateTime']>;
  isOnFarm?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAnimalsListQuery = { __typename?: 'Query', animalsExtended?: { __typename?: 'AnimalConnection', animalsCount?: number | null, animals?: Array<{ __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> }> | null } | null };

export type GetAnimalsListWithPredictedDataQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  businessUnitId?: InputMaybe<Scalars['Int']>;
  isDead?: InputMaybe<Scalars['Boolean']>;
  isWasOwned?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Scalars['UUID']>;
  updatedFrom?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['Date'];
}>;


export type GetAnimalsListWithPredictedDataQuery = { __typename?: 'Query', animalsExtended?: { __typename?: 'AnimalConnection', animalsCount?: number | null, animals?: Array<{ __typename?: 'Animal', estimatedAgeOn?: number | null, estimatedWeightOn?: number | null, id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> }> | null } | null };

export type GetAnimalByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetAnimalByIdQuery = { __typename?: 'Query', animal?: { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, offerId?: number | null, currentWeight?: number | null, visualId?: string | null, eId?: string | null, growthRate?: number | null, performanceCategory?: string | null, sirePassportNumber?: string | null, damPassportNumber?: string | null, rflId?: string | null, deliveryDate?: any | null, buyerName?: string | null, dateMovedToFarm?: any | null, daysToTargetWeight?: number | null, withdrawalEnd?: any | null, isRegulatorySynced?: boolean | null, targetDailyLiveWeightGain?: number | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, isPregnant?: boolean | null, pregnancyDueDate?: any | null, brucellosisId?: string | null, tattoo?: string | null, tsuBarcode?: string | null, pedigreeId?: string | null, trichId?: string | null, breedrId?: string | null, uhfId?: string | null, name?: string | null, herdDoggId?: string | null, alternativeId?: string | null, lastWeight?: { __typename?: 'WeightActivityLog', value?: number | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, breedPercentages: Array<{ __typename?: 'BreedPercentage', percentage?: number | null, breed: { __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null } }>, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null } | null, animalColour?: { __typename?: 'AnimalColour', id?: number | null, code?: string | null, name?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, animalType?: { __typename?: 'AnimalType', id: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, color?: string | null, name: string, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null };

export type GetPerformanceChartDataQueryVariables = Exact<{
  animal: Scalars['UUID'];
}>;


export type GetPerformanceChartDataQuery = { __typename?: 'Query', performanceChartData?: { __typename?: 'PerformanceChartData', contexts?: Array<string | null> | null, dates?: Array<{ __typename?: 'TimestampChartData', timestamp?: string | null } | null> | null, measurements?: Array<{ __typename?: 'MeasurementChartData', timestamp?: string | null, value?: number | null, high?: number | null, avg?: number | null, low?: number | null, age?: number | null, onTargetWeight?: number | null, dailyLiveWeightGain?: number | null, targetDailyLiveWeightGain?: number | null, diffTargetDailyLiveWeightGain?: number | null, daysToTarget?: number | null, daysToTargetWeight?: number | null } | null> | null, predictions?: Array<{ __typename?: 'WeightChartData', timestamp?: string | null, value?: number | null } | null> | null, low?: Array<{ __typename?: 'BandChartData', timestamp?: string | null, value?: Array<number | null> | null } | null> | null, avg?: Array<{ __typename?: 'BandChartData', timestamp?: string | null, value?: Array<number | null> | null } | null> | null, high?: Array<{ __typename?: 'BandChartData', timestamp?: string | null, value?: Array<number | null> | null } | null> | null, references?: Array<{ __typename?: 'ReferenceChartData', timestamp?: string | null, value?: number | null, label?: string | null, rfl?: boolean | null, context?: Array<string | null> | null } | null> | null, targetWeights?: Array<{ __typename?: 'WeightChartData', timestamp?: string | null, value?: number | null } | null> | null } | null };

export type HasUnsyncedAnimalsQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
}>;


export type HasUnsyncedAnimalsQuery = { __typename?: 'Query', hasUnsyncedAnimals?: boolean | null };

export type AnimalFiltersQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
}>;


export type AnimalFiltersQuery = { __typename?: 'Query', animalFilters?: Array<{ __typename?: 'AnimalFilterObjectType', id: string, name: string, isMale?: boolean | null, ageFrom?: number | null, ageTo?: number | null, currentWeightFrom?: number | null, currentWeightTo?: number | null, lastWeightFrom?: number | null, lastWeightTo?: number | null, daysSinceLastWeightFrom?: number | null, daysSinceLastWeightTo?: number | null, dobFrom?: any | null, dobTo?: any | null, dofFrom?: any | null, dofTo?: any | null, growthRateFrom?: number | null, growthRateTo?: number | null, deliveryFrom?: any | null, deliveryTo?: any | null, lastRegulatorySyncedDateFrom?: any | null, lastRegulatorySyncedDateTo?: any | null, isRegulatorySynced?: boolean | null, inWithdrawal?: boolean | null, color: AnimalFilterColor, isAlert: boolean, isPregnant?: boolean | null, pregnancyDueDateFrom?: any | null, pregnancyDueDateTo?: any | null, animalType?: { __typename?: 'AnimalType', id: string, image?: string | null, colour: string } | null, breeds: Array<{ __typename?: 'AnimalBreed', id: any }>, sexClassifications: Array<{ __typename?: 'SexClassification', slug: string, title: string }>, fields: Array<{ __typename?: 'Field', id: any }>, groups: Array<{ __typename?: 'Group', id: string }> } | null> | null };

export type AnimalFilterAlertsQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
}>;


export type AnimalFilterAlertsQuery = { __typename?: 'Query', animalFilterAlerts?: Array<{ __typename?: 'AnimalFilterAlertObjectType', count?: number | null, animalFilter?: { __typename?: 'AnimalFilterObjectType', id: string, name: string, color: AnimalFilterColor, animalType?: { __typename?: 'AnimalType', id: string, name: string } | null } | null } | null> | null };

export type AnimalSexClassificationsQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
  animalTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type AnimalSexClassificationsQuery = { __typename?: 'Query', sexClassifications?: Array<{ __typename?: 'SexClassification', slug: string, title: string, animalType: { __typename?: 'AnimalType', id: string } } | null> | null };

export type GetAnimalOffspringQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
  animalId: Scalars['String'];
}>;


export type GetAnimalOffspringQuery = { __typename?: 'Query', animalOffspring?: { __typename?: 'AnimalOffspringObjectType', summary?: { __typename?: 'SummaryMetrics', animalsCount?: number | null, maleCount?: number | null, femaleCount?: number | null } | null, animals?: Array<{ __typename?: 'PublicAnimal', id?: any | null, dob?: any | null, isArchived?: boolean | null, isMale: boolean, ownerId?: string | null, passportNumber?: string | null, sirePassportNumber?: string | null, visualId?: string | null, birthInformation?: { __typename?: 'PublicBirthInformation', birthAbnormalities?: string | null, birthingDifficulty?: string | null, birthPresentation?: string | null, birthSize?: string | null, birthVigor?: string | null, birthWeight?: number | null } | null } | null> | null } | null };

export type GetAnimalCountQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
}>;


export type GetAnimalCountQuery = { __typename?: 'Query', animalsCount?: { __typename?: 'AnimalsCount', totalAnimals?: number | null } | null };

export type PastureTypeFragmentFragment = { __typename?: 'PastureType', id: string, name: string };

export type FieldFragmentFragment = { __typename?: 'Field', id: any, name: string, description?: string | null, size?: number | null, sizeUnit: FieldSizeUnit, isOrganic: boolean, isYard: boolean, isHoldingPen: boolean, fieldDensity?: any | null, avgDlwg?: any | null, avgEstimatedWeight?: any | null, avgRecordedWeight?: any | null, avgAge?: any | null, animals?: Array<{ __typename?: 'Animal', id?: any | null } | null> | null, location?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, unitName?: string | null, country?: { __typename?: 'Country', id: string, code: string, name: string } | null } | null, pastureTypes: Array<{ __typename?: 'PastureType', id: string, name: string }>, summaryMetrics?: Array<{ __typename?: 'SummaryMetrics', breedrCode?: string | null, regBreedCode?: string | null, animalsCount?: number | null, maleCount?: number | null, femaleCount?: number | null, animalTypeId?: number | null } | null> | null };

export type CreateFieldMutationVariables = Exact<{
  input: CreateFieldInput;
}>;


export type CreateFieldMutation = { __typename?: 'Mutation', createField?: { __typename?: 'CreateFieldPayload', errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null, field?: { __typename?: 'Field', id: any, name: string, description?: string | null, size?: number | null, sizeUnit: FieldSizeUnit, isOrganic: boolean, isYard: boolean, isHoldingPen: boolean, fieldDensity?: any | null, avgDlwg?: any | null, avgEstimatedWeight?: any | null, avgRecordedWeight?: any | null, avgAge?: any | null, animals?: Array<{ __typename?: 'Animal', id?: any | null } | null> | null, location?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, unitName?: string | null, country?: { __typename?: 'Country', id: string, code: string, name: string } | null } | null, pastureTypes: Array<{ __typename?: 'PastureType', id: string, name: string }>, summaryMetrics?: Array<{ __typename?: 'SummaryMetrics', breedrCode?: string | null, regBreedCode?: string | null, animalsCount?: number | null, maleCount?: number | null, femaleCount?: number | null, animalTypeId?: number | null } | null> | null } | null } | null };

export type UpdateFieldOldMutationVariables = Exact<{
  input: UpdateFieldInput;
}>;


export type UpdateFieldOldMutation = { __typename?: 'Mutation', updateField?: { __typename?: 'UpdateFieldPayload', errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null, field?: { __typename?: 'Field', id: any, name: string, description?: string | null, size?: number | null, sizeUnit: FieldSizeUnit, isOrganic: boolean, isYard: boolean, isHoldingPen: boolean, fieldDensity?: any | null, avgDlwg?: any | null, avgEstimatedWeight?: any | null, avgRecordedWeight?: any | null, avgAge?: any | null, animals?: Array<{ __typename?: 'Animal', id?: any | null } | null> | null, location?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, unitName?: string | null, country?: { __typename?: 'Country', id: string, code: string, name: string } | null } | null, pastureTypes: Array<{ __typename?: 'PastureType', id: string, name: string }>, summaryMetrics?: Array<{ __typename?: 'SummaryMetrics', breedrCode?: string | null, regBreedCode?: string | null, animalsCount?: number | null, maleCount?: number | null, femaleCount?: number | null, animalTypeId?: number | null } | null> | null } | null } | null };

export type DeleteFieldMutationVariables = Exact<{
  input: DeleteFieldInput;
}>;


export type DeleteFieldMutation = { __typename?: 'Mutation', deleteField?: { __typename?: 'DeleteFieldPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type MoveAnimalsToFieldMutationVariables = Exact<{
  input: MoveAnimalsToFieldInput;
}>;


export type MoveAnimalsToFieldMutation = { __typename?: 'Mutation', moveAnimalsToField?: { __typename?: 'MoveAnimalsToFieldPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type GetFieldsListQueryVariables = Exact<{
  businessUnitId?: InputMaybe<Scalars['Int']>;
}>;


export type GetFieldsListQuery = { __typename?: 'Query', fields?: Array<{ __typename?: 'Field', id: any, name: string, description?: string | null, size?: number | null, sizeUnit: FieldSizeUnit, isOrganic: boolean, isYard: boolean, isHoldingPen: boolean, fieldDensity?: any | null, avgDlwg?: any | null, avgEstimatedWeight?: any | null, avgRecordedWeight?: any | null, avgAge?: any | null, animals?: Array<{ __typename?: 'Animal', id?: any | null } | null> | null, location?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, unitName?: string | null, country?: { __typename?: 'Country', id: string, code: string, name: string } | null } | null, pastureTypes: Array<{ __typename?: 'PastureType', id: string, name: string }>, summaryMetrics?: Array<{ __typename?: 'SummaryMetrics', breedrCode?: string | null, regBreedCode?: string | null, animalsCount?: number | null, maleCount?: number | null, femaleCount?: number | null, animalTypeId?: number | null } | null> | null }> | null };

export type GetPastureTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPastureTypesQuery = { __typename?: 'Query', pastureTypes?: Array<{ __typename?: 'PastureType', id: string, name: string } | null> | null };

export type GetFieldQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetFieldQuery = { __typename?: 'Query', field?: { __typename?: 'Field', id: any, name: string, description?: string | null, size?: number | null, sizeUnit: FieldSizeUnit, isOrganic: boolean, isYard: boolean, isHoldingPen: boolean, fieldDensity?: any | null, avgDlwg?: any | null, avgEstimatedWeight?: any | null, avgRecordedWeight?: any | null, avgAge?: any | null, animals?: Array<{ __typename?: 'Animal', id?: any | null } | null> | null, location?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, unitName?: string | null, country?: { __typename?: 'Country', id: string, code: string, name: string } | null } | null, pastureTypes: Array<{ __typename?: 'PastureType', id: string, name: string }>, summaryMetrics?: Array<{ __typename?: 'SummaryMetrics', breedrCode?: string | null, regBreedCode?: string | null, animalsCount?: number | null, maleCount?: number | null, femaleCount?: number | null, animalTypeId?: number | null } | null> | null } | null };

export type GetAnimalsFromFieldQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetAnimalsFromFieldQuery = { __typename?: 'Query', field?: { __typename?: 'Field', id: any, animals?: Array<{ __typename?: 'Animal', id?: any | null, visualId?: string | null, eId?: string | null, passportNumber?: string | null, dob?: any | null, dateMovedToFarm?: any | null, currentWeight?: number | null, targetDailyLiveWeightGain?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, rflId?: string | null, deliveryDate?: any | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, isMale: boolean, isCastrated: boolean, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }>, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null } | null> | null } | null };

export type GroupFragmentFragment = { __typename?: 'Group', id: string, name: string, animalsNumberCache?: number | null, targetWeight?: number | null, animalsToSaleCount?: number | null, animalAlertsCount?: number | null, category: GroupCategory, avgEstimatedWeight?: any | null, avgRecordedWeight?: any | null, avgDlwg?: any | null, targetDate?: any | null, daysTillTarget?: number | null, businessUnitTarget?: { __typename?: 'BusinessUnitTarget', id: string, details?: any | null } | null, summaryMetrics?: Array<{ __typename?: 'SummaryMetrics', breedrCode?: string | null, regBreedCode?: string | null, animalsCount?: number | null, maleCount?: number | null, femaleCount?: number | null } | null> | null, animalType?: { __typename?: 'AnimalType', id: string, image?: string | null, colour: string, name: string } | null };

export type SingleGroupFragmentFragment = { __typename?: 'Group', id: string, name: string, animalsNumberCache?: number | null, targetWeight?: number | null, minAge?: any | null, maxAge?: any | null, timeOnFarm?: any | null, growthRate?: number | null, category: GroupCategory, minDaysOnFarm?: number | null, maxDaysOnFarm?: number | null, avgEstimatedWeight?: any | null, avgRecordedWeight?: any | null, avgDlwg?: any | null, targetDate?: any | null, daysTillTarget?: number | null, animals?: Array<{ __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, withdrawalEnd?: any | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, dob?: any | null, isCastrated: boolean, rflId?: string | null, eId?: string | null, visualId?: string | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, deliveryDate?: any | null, buyerName?: string | null, currentWeight?: number | null, growthRate?: number | null, dateMovedToFarm?: any | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null } | null> | null, weightInfo?: { __typename?: 'GroupWeightInfo', minWeight?: number | null, maxWeight?: number | null } | null, summaryMetrics?: Array<{ __typename?: 'SummaryMetrics', breedrCode?: string | null, regBreedCode?: string | null, animalsCount?: number | null, maleCount?: number | null, femaleCount?: number | null } | null> | null, animalType?: { __typename?: 'AnimalType', id: string, image?: string | null, colour: string, name: string } | null };

export type BatchPropertiesFragment = { __typename?: 'Group', id: string, name: string, targetWeight?: number | null, category: GroupCategory, targetDate?: any | null, numberOfUnidentifiedAnimalsInBatch?: number | null, batchDateOnFarm?: any | null, averageDobInBatch?: any | null, isBatch?: boolean | null, gendersInBatch?: string | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null }> };

export type CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup?: { __typename?: 'CreateGroupPayload', group?: { __typename?: 'Group', id: string, name: string, animalsNumberCache?: number | null, targetWeight?: number | null, animalsToSaleCount?: number | null, animalAlertsCount?: number | null, category: GroupCategory, avgEstimatedWeight?: any | null, avgRecordedWeight?: any | null, avgDlwg?: any | null, targetDate?: any | null, daysTillTarget?: number | null, businessUnitTarget?: { __typename?: 'BusinessUnitTarget', id: string, details?: any | null } | null, summaryMetrics?: Array<{ __typename?: 'SummaryMetrics', breedrCode?: string | null, regBreedCode?: string | null, animalsCount?: number | null, maleCount?: number | null, femaleCount?: number | null } | null> | null, animalType?: { __typename?: 'AnimalType', id: string, image?: string | null, colour: string, name: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UpdateGroupMutationVariables = Exact<{
  input: UpdateGroupInput;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', updateGroup?: { __typename?: 'UpdateGroupPayload', group?: { __typename?: 'Group', id: string, name: string, animalsNumberCache?: number | null, targetWeight?: number | null, animalsToSaleCount?: number | null, animalAlertsCount?: number | null, category: GroupCategory, avgEstimatedWeight?: any | null, avgRecordedWeight?: any | null, avgDlwg?: any | null, targetDate?: any | null, daysTillTarget?: number | null, businessUnitTarget?: { __typename?: 'BusinessUnitTarget', id: string, details?: any | null } | null, summaryMetrics?: Array<{ __typename?: 'SummaryMetrics', breedrCode?: string | null, regBreedCode?: string | null, animalsCount?: number | null, maleCount?: number | null, femaleCount?: number | null } | null> | null, animalType?: { __typename?: 'AnimalType', id: string, image?: string | null, colour: string, name: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type DeleteGroupWithAnimalsMutationVariables = Exact<{
  input: DeleteGroupWithAnimalsInput;
}>;


export type DeleteGroupWithAnimalsMutation = { __typename?: 'Mutation', deleteGroupWithAnimals?: { __typename?: 'DeleteGroupWithAnimalsPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type AssignAnimalsToGroupMutationVariables = Exact<{
  input: MoveAnimalsToGroupInput;
}>;


export type AssignAnimalsToGroupMutation = { __typename?: 'Mutation', moveAnimalsToGroup?: { __typename?: 'MoveAnimalsToGroupPayload', success?: boolean | null, groups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, animals?: Array<{ __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, offerId?: number | null, currentWeight?: number | null, visualId?: string | null, eId?: string | null, growthRate?: number | null, performanceCategory?: string | null, sirePassportNumber?: string | null, damPassportNumber?: string | null, rflId?: string | null, deliveryDate?: any | null, buyerName?: string | null, dateMovedToFarm?: any | null, daysToTargetWeight?: number | null, withdrawalEnd?: any | null, isRegulatorySynced?: boolean | null, targetDailyLiveWeightGain?: number | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, isPregnant?: boolean | null, pregnancyDueDate?: any | null, brucellosisId?: string | null, tattoo?: string | null, tsuBarcode?: string | null, pedigreeId?: string | null, trichId?: string | null, breedrId?: string | null, uhfId?: string | null, name?: string | null, herdDoggId?: string | null, alternativeId?: string | null, lastWeight?: { __typename?: 'WeightActivityLog', value?: number | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, breedPercentages: Array<{ __typename?: 'BreedPercentage', percentage?: number | null, breed: { __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null } }>, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null } | null, animalColour?: { __typename?: 'AnimalColour', id?: number | null, code?: string | null, name?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, animalType?: { __typename?: 'AnimalType', id: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, color?: string | null, name: string, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> }> | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type MoveGroupsToFieldMutationVariables = Exact<{
  input: MoveGroupsToFieldInput;
}>;


export type MoveGroupsToFieldMutation = { __typename?: 'Mutation', moveGroupsToField?: { __typename?: 'MoveGroupsToFieldPayload', success?: boolean | null, groups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type CreateBatchMutationVariables = Exact<{
  input: CreateBatchInput;
}>;


export type CreateBatchMutation = { __typename?: 'Mutation', createBatch?: { __typename?: 'CreateBatchPayload', group?: { __typename?: 'Group', id: string, name: string } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UpdateBatchMutationVariables = Exact<{
  input: UpdateBatchInput;
}>;


export type UpdateBatchMutation = { __typename?: 'Mutation', updateBatch?: { __typename?: 'UpdateBatchPayload', group?: { __typename?: 'Group', id: string, name: string } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type GetGroupsListQueryVariables = Exact<{
  businessUnitId?: InputMaybe<Scalars['Int']>;
  animalTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type GetGroupsListQuery = { __typename?: 'Query', groupsExtended?: { __typename?: 'GroupExtendedList', groups?: Array<{ __typename?: 'Group', id: string, name: string, targetWeight?: number | null, category: GroupCategory, targetDate?: any | null, numberOfUnidentifiedAnimalsInBatch?: number | null, batchDateOnFarm?: any | null, averageDobInBatch?: any | null, isBatch?: boolean | null, gendersInBatch?: string | null, animalsNumberCache?: number | null, animalsToSaleCount?: number | null, animalAlertsCount?: number | null, avgEstimatedWeight?: any | null, avgRecordedWeight?: any | null, avgDlwg?: any | null, daysTillTarget?: number | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null }>, businessUnitTarget?: { __typename?: 'BusinessUnitTarget', id: string, details?: any | null } | null, summaryMetrics?: Array<{ __typename?: 'SummaryMetrics', breedrCode?: string | null, regBreedCode?: string | null, animalsCount?: number | null, maleCount?: number | null, femaleCount?: number | null } | null> | null, animalType?: { __typename?: 'AnimalType', id: string, image?: string | null, colour: string, name: string } | null }> | null } | null };

export type GetGroupQueryVariables = Exact<{
  group: Scalars['UUID'];
  businessUnit: Scalars['Int'];
}>;


export type GetGroupQuery = { __typename?: 'Query', group?: { __typename?: 'Group', id: string, name: string, targetWeight?: number | null, category: GroupCategory, targetDate?: any | null, numberOfUnidentifiedAnimalsInBatch?: number | null, batchDateOnFarm?: any | null, averageDobInBatch?: any | null, isBatch?: boolean | null, gendersInBatch?: string | null, animalsNumberCache?: number | null, minAge?: any | null, maxAge?: any | null, timeOnFarm?: any | null, growthRate?: number | null, minDaysOnFarm?: number | null, maxDaysOnFarm?: number | null, avgEstimatedWeight?: any | null, avgRecordedWeight?: any | null, avgDlwg?: any | null, daysTillTarget?: number | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null }>, animals?: Array<{ __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, withdrawalEnd?: any | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, dob?: any | null, isCastrated: boolean, rflId?: string | null, eId?: string | null, visualId?: string | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, deliveryDate?: any | null, buyerName?: string | null, currentWeight?: number | null, growthRate?: number | null, dateMovedToFarm?: any | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null } | null> | null, weightInfo?: { __typename?: 'GroupWeightInfo', minWeight?: number | null, maxWeight?: number | null } | null, summaryMetrics?: Array<{ __typename?: 'SummaryMetrics', breedrCode?: string | null, regBreedCode?: string | null, animalsCount?: number | null, maleCount?: number | null, femaleCount?: number | null } | null> | null, animalType?: { __typename?: 'AnimalType', id: string, image?: string | null, colour: string, name: string } | null } | null };

export type GetBatchTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBatchTermsQuery = { __typename?: 'Query', animalTypes?: Array<{ __typename?: 'AnimalType', id: string, name: string, batchName?: { __typename?: 'BatchNameObjectType', name?: string | null, plural?: string | null } | null } | null> | null };

export type GetBatchByIdQueryVariables = Exact<{
  group: Scalars['UUID'];
  businessUnit: Scalars['Int'];
}>;


export type GetBatchByIdQuery = { __typename?: 'Query', group?: { __typename?: 'Group', id: string, name: string, targetWeight?: number | null, category: GroupCategory, targetDate?: any | null, numberOfUnidentifiedAnimalsInBatch?: number | null, batchDateOnFarm?: any | null, averageDobInBatch?: any | null, isBatch?: boolean | null, gendersInBatch?: string | null, animalsNumberCache?: number | null, minAge?: any | null, maxAge?: any | null, timeOnFarm?: any | null, growthRate?: number | null, minDaysOnFarm?: number | null, maxDaysOnFarm?: number | null, avgEstimatedWeight?: any | null, avgRecordedWeight?: any | null, avgDlwg?: any | null, daysTillTarget?: number | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null }>, animals?: Array<{ __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, withdrawalEnd?: any | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, dob?: any | null, isCastrated: boolean, rflId?: string | null, eId?: string | null, visualId?: string | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, deliveryDate?: any | null, buyerName?: string | null, currentWeight?: number | null, growthRate?: number | null, dateMovedToFarm?: any | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null } | null> | null, weightInfo?: { __typename?: 'GroupWeightInfo', minWeight?: number | null, maxWeight?: number | null } | null, summaryMetrics?: Array<{ __typename?: 'SummaryMetrics', breedrCode?: string | null, regBreedCode?: string | null, animalsCount?: number | null, maleCount?: number | null, femaleCount?: number | null } | null> | null, animalType?: { __typename?: 'AnimalType', id: string, image?: string | null, colour: string, name: string } | null } | null };

export type OrganisationFragment = { __typename?: 'Organisation', id: string, name?: string | null };

export type GetOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationsQuery = { __typename?: 'Query', organisations?: Array<{ __typename?: 'OrganisationBusinessUnits', organisation?: { __typename?: 'Organisation', id: string, name?: string | null } | null, businessUnits?: Array<{ __typename?: 'BusinessUnit', id: string, name: string, profilePhoto?: string | null, warnings?: any | null, tbStatus?: BusinessUnitTbStatus | null, postcode?: string | null, canCreateRfl: boolean, locationsCount?: number | null, foggles?: Array<string | null> | null, identifierPreferencesPrimaryId?: IdentifierEnumType | null, identifierPreferencesSecondaryId?: IdentifierEnumType | null, organisation?: { __typename?: 'Organisation', id: string } | null, tradingTypes: Array<{ __typename?: 'TradingType', id: string, slug: string, name: string }>, businessType?: { __typename?: 'BusinessType', id: string, slug: string } | null, regulatorySystem?: { __typename?: 'IntegrationSystemType', id: string, slug: string, name: string } | null, deliveryAddress: Array<{ __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null, postcode?: string | null, addressLine1?: string | null }>, primaryLocation?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, postcode?: string | null } | null, currency?: { __typename?: 'Currency', id: string, name: string, code: string } | null, unitsOfMeasurement?: Array<{ __typename?: 'UnitOfMeasurement', id: string, code: string, measurementType: UnitOfMeasurementBusinessUnitMeasurementType } | null> | null, country?: { __typename?: 'Country', id: string, code: string, name: string, isoAlpha2?: string | null, isoNumber?: number | null, visualIdPrefix?: string | null, region?: { __typename?: 'Region', code: string, name: string } | null } | null, farmAnimalTypes: Array<{ __typename?: 'AnimalType', colour: string, enabled: boolean, id: string, image?: string | null, name: string, position: number, slug?: string | null }>, effectiveSubscriptionPlan?: { __typename?: 'SubscriptionPlan', name: string } | null, identifierPreferencesActiveIds?: { __typename?: 'ActiveIdentifierPreferencesType', alternativeId: boolean, passportNumber: boolean, visualId: boolean, eId: boolean, name: boolean, trichId: boolean, tsuBarcode: boolean, pedigreeId: boolean, tattoo: boolean, herdDoggId: boolean, breedrId: boolean, uhfId: boolean, brucellosisId: boolean } | null, herdDoggIntegration?: { __typename?: 'HerdDoggIntegrationObjectType', isConnected?: boolean | null } | null } | null> | null } | null> | null };

export type GetOrganisationBusinessUnitsQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
}>;


export type GetOrganisationBusinessUnitsQuery = { __typename?: 'Query', organisationBusinessUnits?: Array<{ __typename?: 'BusinessUnit', id: string, name: string, profilePhoto?: string | null, warnings?: any | null, tbStatus?: BusinessUnitTbStatus | null, postcode?: string | null, canCreateRfl: boolean, locationsCount?: number | null, foggles?: Array<string | null> | null, identifierPreferencesPrimaryId?: IdentifierEnumType | null, identifierPreferencesSecondaryId?: IdentifierEnumType | null, organisation?: { __typename?: 'Organisation', id: string, name?: string | null } | null, tradingTypes: Array<{ __typename?: 'TradingType', id: string, slug: string, name: string }>, businessType?: { __typename?: 'BusinessType', id: string, slug: string } | null, regulatorySystem?: { __typename?: 'IntegrationSystemType', id: string, slug: string, name: string } | null, deliveryAddress: Array<{ __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null, postcode?: string | null, addressLine1?: string | null }>, primaryLocation?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, postcode?: string | null } | null, currency?: { __typename?: 'Currency', id: string, name: string, code: string } | null, unitsOfMeasurement?: Array<{ __typename?: 'UnitOfMeasurement', id: string, code: string, measurementType: UnitOfMeasurementBusinessUnitMeasurementType } | null> | null, country?: { __typename?: 'Country', id: string, code: string, name: string, isoAlpha2?: string | null, isoNumber?: number | null, visualIdPrefix?: string | null, region?: { __typename?: 'Region', code: string, name: string } | null } | null, farmAnimalTypes: Array<{ __typename?: 'AnimalType', colour: string, enabled: boolean, id: string, image?: string | null, name: string, position: number, slug?: string | null }>, effectiveSubscriptionPlan?: { __typename?: 'SubscriptionPlan', name: string } | null, identifierPreferencesActiveIds?: { __typename?: 'ActiveIdentifierPreferencesType', alternativeId: boolean, passportNumber: boolean, visualId: boolean, eId: boolean, name: boolean, trichId: boolean, tsuBarcode: boolean, pedigreeId: boolean, tattoo: boolean, herdDoggId: boolean, breedrId: boolean, uhfId: boolean, brucellosisId: boolean } | null, herdDoggIntegration?: { __typename?: 'HerdDoggIntegrationObjectType', isConnected?: boolean | null } | null } | null> | null };

export type ProducerGroupFragmentFragment = { __typename?: 'ProducerGroupType', id: string, name: string, description?: string | null, profilePhoto?: string | null, backgroundPhoto?: string | null, isMyGroup?: boolean | null, status?: string | null, members: Array<{ __typename?: 'ProducerGroupMemberType', id: string, profilePhoto?: string | null, firstName?: string | null, lastName?: string | null, isAdmin: boolean, status: ProducerGroupMemberStatus }> };

export type GetProducerGroupsQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
}>;


export type GetProducerGroupsQuery = { __typename?: 'Query', producerGroups?: Array<{ __typename?: 'ProducerGroupType', id: string, name: string, description?: string | null, profilePhoto?: string | null, backgroundPhoto?: string | null, isMyGroup?: boolean | null, status?: string | null, members: Array<{ __typename?: 'ProducerGroupMemberType', id: string, profilePhoto?: string | null, firstName?: string | null, lastName?: string | null, isAdmin: boolean, status: ProducerGroupMemberStatus }> } | null> | null };

export type RegulatoryTransactionApprovalFragmentFragment = { __typename?: 'RegulatoryTransactionApprovalType', id: any, reasonOfFailure?: string | null, createdAt: any, actualStatus?: string | null, approvalStatus: RegulatoryTransactionApprovalApprovalStatus, destination?: { __typename?: 'RegulatoryAddressType', regulatoryId: string, description: string } | null, source?: { __typename?: 'RegulatoryAddressType', regulatoryId: string, description: string } | null, destinationLocation?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sourceActivity?: { __typename?: 'ActivityLog', date?: any | null, animal?: { __typename?: 'PublicAnimal', id?: any | null, dob?: any | null, visualId?: string | null, damPassportNumber?: string | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null } | null } | null };

export type RegulatoryTransactionApprovalsResponseMutationVariables = Exact<{
  input: RegulatoryTransactionApprovalsResponseInput;
}>;


export type RegulatoryTransactionApprovalsResponseMutation = { __typename?: 'Mutation', regulatoryTransactionApprovalsResponse?: { __typename?: 'RegulatoryTransactionApprovalsResponsePayload', regulatoryTransactionApprovals?: Array<{ __typename?: 'RegulatoryTransactionApprovalType', id: any, actualStatus?: string | null } | null> | null, errors?: Array<{ __typename?: 'ValidationError', field: string, code: string } | null> | null } | null };

export type RegulatoryTransactionApprovalsRetryMutationVariables = Exact<{
  input: RegulatoryTransactionApprovalsRetryInput;
}>;


export type RegulatoryTransactionApprovalsRetryMutation = { __typename?: 'Mutation', regulatoryTransactionApprovalsRetry?: { __typename?: 'RegulatoryTransactionApprovalsRetryPayload', regulatoryTransactionApprovals?: Array<{ __typename?: 'RegulatoryTransactionApprovalType', id: any, actualStatus?: string | null } | null> | null, errors?: Array<{ __typename?: 'ValidationError', field: string, code: string } | null> | null } | null };

export type RegulatoryTransactionApprovalsChangeDateMutationVariables = Exact<{
  input: RegulatoryTransactionApprovalsChangeDateInput;
}>;


export type RegulatoryTransactionApprovalsChangeDateMutation = { __typename?: 'Mutation', regulatoryTransactionApprovalsChangeDate?: { __typename?: 'RegulatoryTransactionApprovalsChangeDatePayload', regulatoryTransactionApprovals?: Array<{ __typename?: 'RegulatoryTransactionApprovalType', id: any, actualStatus?: string | null, sourceActivity?: { __typename?: 'ActivityLog', date?: any | null } | null } | null> | null, errors?: Array<{ __typename?: 'ValidationError', field: string, code: string } | null> | null } | null };

export type RegulatoryTransactionApprovalsAbortMutationVariables = Exact<{
  input: RegulatoryTransactionApprovalsAbortInput;
}>;


export type RegulatoryTransactionApprovalsAbortMutation = { __typename?: 'Mutation', regulatoryTransactionApprovalsAbort?: { __typename?: 'RegulatoryTransactionApprovalsAbortPayload', regulatoryTransactionApprovals?: Array<{ __typename?: 'RegulatoryTransactionApprovalType', id: any, actualStatus?: string | null, reasonOfFailure?: string | null } | null> | null, errors?: Array<{ __typename?: 'ValidationError', field: string, code: string } | null> | null } | null };

export type RegulatoryTransactionApprovalSummaryQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
}>;


export type RegulatoryTransactionApprovalSummaryQuery = { __typename?: 'Query', regulatoryTransactionApprovalSummary?: Array<{ __typename?: 'RegulatoryTransactionApprovalSummaryType', id?: string | null, type?: string | null, pending?: number | null, inProgress?: number | null, failed?: number | null, successful?: number | null } | null> | null };

export type RegulatoryTransactionApprovalsQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
  transactionType: Scalars['String'];
  statuses?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type RegulatoryTransactionApprovalsQuery = { __typename?: 'Query', regulatoryTransactionApprovals?: Array<{ __typename?: 'RegulatoryTransactionApprovalType', id: any, reasonOfFailure?: string | null, createdAt: any, actualStatus?: string | null, approvalStatus: RegulatoryTransactionApprovalApprovalStatus, destination?: { __typename?: 'RegulatoryAddressType', regulatoryId: string, description: string } | null, source?: { __typename?: 'RegulatoryAddressType', regulatoryId: string, description: string } | null, destinationLocation?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sourceActivity?: { __typename?: 'ActivityLog', date?: any | null, animal?: { __typename?: 'PublicAnimal', id?: any | null, dob?: any | null, visualId?: string | null, damPassportNumber?: string | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null } | null } | null } | null> | null };

export type RegulatoryTransactionApprovalsWithWarningQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
  transactionType: Scalars['String'];
}>;


export type RegulatoryTransactionApprovalsWithWarningQuery = { __typename?: 'Query', regulatoryTransactionApprovalsWithWarning?: Array<{ __typename?: 'RegulatoryTransactionApprovalType', id: any, reasonOfFailure?: string | null, createdAt: any, actualStatus?: string | null, approvalStatus: RegulatoryTransactionApprovalApprovalStatus, destination?: { __typename?: 'RegulatoryAddressType', regulatoryId: string, description: string } | null, source?: { __typename?: 'RegulatoryAddressType', regulatoryId: string, description: string } | null, destinationLocation?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sourceActivity?: { __typename?: 'ActivityLog', date?: any | null, animal?: { __typename?: 'PublicAnimal', id?: any | null, dob?: any | null, visualId?: string | null, damPassportNumber?: string | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null } | null } | null } | null> | null };

export type RegulatoryTransactionWarningsQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
}>;


export type RegulatoryTransactionWarningsQuery = { __typename?: 'Query', regulatoryTransactionWarnings?: Array<{ __typename?: 'RegulatoryTransactionWarningsObjectType', type?: string | null, count?: number | null, lapseOfTime?: number | null } | null> | null };

export type ReportsFragmentFragment = { __typename?: 'ReportType', id: string, title: string, slug?: string | null, applyProducerGroup: boolean, url: string, position: number, needUpgrade?: boolean | null, reportType?: ReportEngine | null, businessUnit?: { __typename?: 'BusinessUnit', id: string } | null, group?: { __typename?: 'GroupReportType', id: string, title: string, position: number } | null, subscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', id: string, name: string, price: number, description: string }>, species: Array<{ __typename?: 'AnimalType', id: string }> };

export type GetReportsListQueryVariables = Exact<{
  businessUnit?: InputMaybe<Scalars['Int']>;
  species?: InputMaybe<Scalars['Int']>;
}>;


export type GetReportsListQuery = { __typename?: 'Query', reports?: Array<{ __typename?: 'ReportType', id: string, title: string, slug?: string | null, applyProducerGroup: boolean, url: string, position: number, needUpgrade?: boolean | null, reportType?: ReportEngine | null, businessUnit?: { __typename?: 'BusinessUnit', id: string } | null, group?: { __typename?: 'GroupReportType', id: string, title: string, position: number } | null, subscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', id: string, name: string, price: number, description: string }>, species: Array<{ __typename?: 'AnimalType', id: string }> }> | null };

export type GetReportUrlQueryVariables = Exact<{
  embedUrl: Scalars['String'];
}>;


export type GetReportUrlQuery = { __typename?: 'Query', sisenseEmbedUrl?: { __typename?: 'Url', url?: string | null } | null };

export type GetMainReportQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
}>;


export type GetMainReportQuery = { __typename?: 'Query', mainReport?: { __typename?: 'ReportType', id: string, title: string, url: string } | null };

export type GetQuicksightEmbedUrlQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
  embedUrl: Scalars['String'];
}>;


export type GetQuicksightEmbedUrlQuery = { __typename?: 'Query', quicksightEmbedUrl?: { __typename?: 'Url', url?: string | null, parameters?: Array<{ __typename?: 'QuicksightParameter', code?: string | null, value?: string | null }> | null } | null };

export type IntegrationSystemFragmentFragment = { __typename?: 'IntegrationSystemType', id: string, name: string, logo?: string | null, helpLink?: string | null, slug: string, fields: Array<{ __typename?: 'SystemCredentialFieldType', id: string, fieldLabel: string, fieldName: string, fieldType: SystemCredentialFieldFieldType, inputMask: string, minLength?: number | null, maxLength?: number | null, placeholder: string }> };

type FarmSystemFragment_BcmsConnectionType_Fragment = { __typename?: 'BcmsConnectionType', id?: number | null, errorMessage?: string | null, credentials?: any | null, status?: string | null, location?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, unitName?: string | null } | null, integrationSystem?: { __typename?: 'IntegrationSystemType', id: string, name: string, logo?: string | null, helpLink?: string | null, slug: string, fields: Array<{ __typename?: 'SystemCredentialFieldType', id: string, fieldLabel: string, fieldName: string, fieldType: SystemCredentialFieldFieldType, inputMask: string, minLength?: number | null, maxLength?: number | null, placeholder: string }> } | null };

type FarmSystemFragment_CommonFarmSystemType_Fragment = { __typename?: 'CommonFarmSystemType', id?: number | null, errorMessage?: string | null, credentials?: any | null, status?: string | null, integrationSystem?: { __typename?: 'IntegrationSystemType', id: string, name: string, logo?: string | null, helpLink?: string | null, slug: string, fields: Array<{ __typename?: 'SystemCredentialFieldType', id: string, fieldLabel: string, fieldName: string, fieldType: SystemCredentialFieldFieldType, inputMask: string, minLength?: number | null, maxLength?: number | null, placeholder: string }> } | null };

type FarmSystemFragment_ScotMovesConnectionType_Fragment = { __typename?: 'ScotMovesConnectionType', id?: number | null, errorMessage?: string | null, credentials?: any | null, status?: string | null, integrationSystem?: { __typename?: 'IntegrationSystemType', id: string, name: string, logo?: string | null, helpLink?: string | null, slug: string, fields: Array<{ __typename?: 'SystemCredentialFieldType', id: string, fieldLabel: string, fieldName: string, fieldType: SystemCredentialFieldFieldType, inputMask: string, minLength?: number | null, maxLength?: number | null, placeholder: string }> } | null };

export type FarmSystemFragmentFragment = FarmSystemFragment_BcmsConnectionType_Fragment | FarmSystemFragment_CommonFarmSystemType_Fragment | FarmSystemFragment_ScotMovesConnectionType_Fragment;

export type CreateFarmSystemMutationVariables = Exact<{
  input: CreateFarmSystemInput;
}>;


export type CreateFarmSystemMutation = { __typename?: 'Mutation', createFarmSystem?: { __typename?: 'CreateFarmSystemPayload', farmSystem?: { __typename?: 'BcmsConnectionType', id?: number | null, errorMessage?: string | null, credentials?: any | null, status?: string | null, location?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, unitName?: string | null } | null, integrationSystem?: { __typename?: 'IntegrationSystemType', id: string, name: string, logo?: string | null, helpLink?: string | null, slug: string, fields: Array<{ __typename?: 'SystemCredentialFieldType', id: string, fieldLabel: string, fieldName: string, fieldType: SystemCredentialFieldFieldType, inputMask: string, minLength?: number | null, maxLength?: number | null, placeholder: string }> } | null } | { __typename?: 'CommonFarmSystemType', id?: number | null, errorMessage?: string | null, credentials?: any | null, status?: string | null, integrationSystem?: { __typename?: 'IntegrationSystemType', id: string, name: string, logo?: string | null, helpLink?: string | null, slug: string, fields: Array<{ __typename?: 'SystemCredentialFieldType', id: string, fieldLabel: string, fieldName: string, fieldType: SystemCredentialFieldFieldType, inputMask: string, minLength?: number | null, maxLength?: number | null, placeholder: string }> } | null } | { __typename?: 'ScotMovesConnectionType', id?: number | null, errorMessage?: string | null, credentials?: any | null, status?: string | null, integrationSystem?: { __typename?: 'IntegrationSystemType', id: string, name: string, logo?: string | null, helpLink?: string | null, slug: string, fields: Array<{ __typename?: 'SystemCredentialFieldType', id: string, fieldLabel: string, fieldName: string, fieldType: SystemCredentialFieldFieldType, inputMask: string, minLength?: number | null, maxLength?: number | null, placeholder: string }> } | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UpdateFarmSystemMutationVariables = Exact<{
  input: UpdateFarmSystemInput;
}>;


export type UpdateFarmSystemMutation = { __typename?: 'Mutation', updateFarmSystem?: { __typename?: 'UpdateFarmSystemPayload', farmSystem?: { __typename?: 'BcmsConnectionType', id?: number | null, errorMessage?: string | null, credentials?: any | null, status?: string | null, location?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, unitName?: string | null } | null, integrationSystem?: { __typename?: 'IntegrationSystemType', id: string, name: string, logo?: string | null, helpLink?: string | null, slug: string, fields: Array<{ __typename?: 'SystemCredentialFieldType', id: string, fieldLabel: string, fieldName: string, fieldType: SystemCredentialFieldFieldType, inputMask: string, minLength?: number | null, maxLength?: number | null, placeholder: string }> } | null } | { __typename?: 'CommonFarmSystemType', id?: number | null, errorMessage?: string | null, credentials?: any | null, status?: string | null, integrationSystem?: { __typename?: 'IntegrationSystemType', id: string, name: string, logo?: string | null, helpLink?: string | null, slug: string, fields: Array<{ __typename?: 'SystemCredentialFieldType', id: string, fieldLabel: string, fieldName: string, fieldType: SystemCredentialFieldFieldType, inputMask: string, minLength?: number | null, maxLength?: number | null, placeholder: string }> } | null } | { __typename?: 'ScotMovesConnectionType', id?: number | null, errorMessage?: string | null, credentials?: any | null, status?: string | null, integrationSystem?: { __typename?: 'IntegrationSystemType', id: string, name: string, logo?: string | null, helpLink?: string | null, slug: string, fields: Array<{ __typename?: 'SystemCredentialFieldType', id: string, fieldLabel: string, fieldName: string, fieldType: SystemCredentialFieldFieldType, inputMask: string, minLength?: number | null, maxLength?: number | null, placeholder: string }> } | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type DeleteFarmSystemMutationVariables = Exact<{
  input: DeleteFarmSystemInput;
}>;


export type DeleteFarmSystemMutation = { __typename?: 'Mutation', deleteFarmSystem?: { __typename?: 'DeleteFarmSystemPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type BcmsServiceRequestGeneratePdfMutationVariables = Exact<{
  input: BcmsServiceRequestGeneratePdfInput;
}>;


export type BcmsServiceRequestGeneratePdfMutation = { __typename?: 'Mutation', bcmsServiceRequestGeneratePdf?: { __typename?: 'BcmsServiceRequestGeneratePdfPayload', url?: string | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type CreateBankDetailsMutationVariables = Exact<{
  input: CreateBankDetailsInput;
}>;


export type CreateBankDetailsMutation = { __typename?: 'Mutation', createBankDetails?: { __typename?: 'CreateBankDetailsPayload', bankDetails?: { __typename?: 'BankAccountDetailsObjectType', id?: number | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UpdateBankDetailsMutationVariables = Exact<{
  input: UpdateBankDetailsInput;
}>;


export type UpdateBankDetailsMutation = { __typename?: 'Mutation', updateBankDetails?: { __typename?: 'UpdateBankDetailsPayload', bankDetails?: { __typename?: 'BankAccountDetailsObjectType', id?: number | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UpdateIdentifierPreferencesMutationVariables = Exact<{
  input: UpdateIdentifierPreferencesInput;
}>;


export type UpdateIdentifierPreferencesMutation = { __typename?: 'Mutation', updateIdentifierPreferences?: { __typename?: 'UpdateIdentifierPreferencesPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type GetFarmSystemsQueryVariables = Exact<{
  farm: Scalars['Int'];
}>;


export type GetFarmSystemsQuery = { __typename?: 'Query', farmSystems?: Array<{ __typename?: 'BcmsConnectionType', id?: number | null, errorMessage?: string | null, credentials?: any | null, status?: string | null, location?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, unitName?: string | null } | null, integrationSystem?: { __typename?: 'IntegrationSystemType', id: string, name: string, logo?: string | null, helpLink?: string | null, slug: string, fields: Array<{ __typename?: 'SystemCredentialFieldType', id: string, fieldLabel: string, fieldName: string, fieldType: SystemCredentialFieldFieldType, inputMask: string, minLength?: number | null, maxLength?: number | null, placeholder: string }> } | null } | { __typename?: 'CommonFarmSystemType', id?: number | null, errorMessage?: string | null, credentials?: any | null, status?: string | null, integrationSystem?: { __typename?: 'IntegrationSystemType', id: string, name: string, logo?: string | null, helpLink?: string | null, slug: string, fields: Array<{ __typename?: 'SystemCredentialFieldType', id: string, fieldLabel: string, fieldName: string, fieldType: SystemCredentialFieldFieldType, inputMask: string, minLength?: number | null, maxLength?: number | null, placeholder: string }> } | null } | { __typename?: 'ScotMovesConnectionType', id?: number | null, errorMessage?: string | null, credentials?: any | null, status?: string | null, integrationSystem?: { __typename?: 'IntegrationSystemType', id: string, name: string, logo?: string | null, helpLink?: string | null, slug: string, fields: Array<{ __typename?: 'SystemCredentialFieldType', id: string, fieldLabel: string, fieldName: string, fieldType: SystemCredentialFieldFieldType, inputMask: string, minLength?: number | null, maxLength?: number | null, placeholder: string }> } | null } | null> | null };

export type GetSettingsFaqQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
}>;


export type GetSettingsFaqQuery = { __typename?: 'Query', settingsFaq?: { __typename?: 'BusinessUnitSettingsFaqType', id?: number | null, title: string, description: string } | null };

export type GetTermsQueryVariables = Exact<{
  tacType: Scalars['String'];
}>;


export type GetTermsQuery = { __typename?: 'Query', termsAndConditions?: { __typename?: 'TermsAndConditionsObjectType', id: string, title: string, description: string, type?: string | null } | null };

export type GetBankDetailsQueryVariables = Exact<{
  businessUnitId?: InputMaybe<Scalars['Int']>;
}>;


export type GetBankDetailsQuery = { __typename?: 'Query', bankDetails?: { __typename?: 'BankAccountDetailsObjectType', id?: number | null, accountNo: string, accountName: string, sortCode: string, isBusinessAccount: boolean } | null };

export type GetIdentifierPreferencesQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
}>;


export type GetIdentifierPreferencesQuery = { __typename?: 'Query', businessUnit?: { __typename?: 'BusinessUnit', guid?: any | null, identifierPreferencesPrimaryId?: IdentifierEnumType | null, identifierPreferencesSecondaryId?: IdentifierEnumType | null, identifierPreferencesActiveIds?: { __typename?: 'ActiveIdentifierPreferencesType', passportNumber: boolean, visualId: boolean, eId: boolean, name: boolean, trichId: boolean, tsuBarcode: boolean, pedigreeId: boolean, tattoo: boolean, herdDoggId: boolean, breedrId: boolean, uhfId: boolean, brucellosisId: boolean, alternativeId: boolean } | null } | null };

export type SireFragmentFragment = { __typename?: 'Sire', id?: any | null, name: string, passportNumber: string, registrationNumber: string, pedigree: boolean, sire: string };

export type ErrorFragmentFragment = { __typename?: 'ValidationError', field: string, message: string };

export type DeleteSireMutationVariables = Exact<{
  input: DeleteSireInput;
}>;


export type DeleteSireMutation = { __typename?: 'Mutation', deleteSire?: { __typename?: 'DeleteSirePayload', success?: boolean | null } | null };

export type CreateSireMutationVariables = Exact<{
  input: CreateSireInput;
}>;


export type CreateSireMutation = { __typename?: 'Mutation', createSire?: { __typename?: 'CreateSirePayload', success?: boolean | null, sire?: { __typename?: 'Sire', id?: any | null, name: string, passportNumber: string, registrationNumber: string, pedigree: boolean, sire: string } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UpdateSireMutationVariables = Exact<{
  input: UpdateSireInput;
}>;


export type UpdateSireMutation = { __typename?: 'Mutation', updateSire?: { __typename?: 'UpdateSirePayload', success?: boolean | null, sire?: { __typename?: 'Sire', id?: any | null, name: string, passportNumber: string, registrationNumber: string, pedigree: boolean, sire: string } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type GetSiresListQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
}>;


export type GetSiresListQuery = { __typename?: 'Query', sires?: Array<{ __typename?: 'Sire', id?: any | null, name: string, passportNumber: string, registrationNumber: string, pedigree: boolean, sire: string } | null> | null };

export type GetSireByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
  businessUnitId: Scalars['Int'];
}>;


export type GetSireByIdQuery = { __typename?: 'Query', sire?: { __typename?: 'Sire', id?: any | null, name: string, passportNumber: string, registrationNumber: string, pedigree: boolean, sire: string } | null };

export type UserInfoFragmentFragment = { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, image?: string | null, phone?: string | null, lastLogin?: any | null, jobTitle: string, intercomUserHash?: string | null };

export type OwnerFragmentFragment = { __typename?: 'UserPublicInfo', id: number, email?: string | null, image?: string | null, firstName: string, lastName: string, businessUnitUserId?: number | null };

export type BusinessUnitUserFragment = { __typename?: 'BusinessUnitUser', id: string, status: BusinessUnitUserStatus, isOwner?: boolean | null, role: { __typename?: 'Role', id: string, name: string }, businessUnit: { __typename?: 'BusinessUnit', id: string, name: string }, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, image?: string | null, phone?: string | null, lastLogin?: any | null, jobTitle: string, intercomUserHash?: string | null } };

export type UpdateEmailMutationVariables = Exact<{
  input: UpdateEmailInput;
}>;


export type UpdateEmailMutation = { __typename?: 'Mutation', updateEmail?: { __typename?: 'UpdateEmailPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword?: { __typename?: 'UpdatePasswordPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UpdateUserDataMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserDataMutation = { __typename?: 'Mutation', updateUserInfo?: { __typename?: 'UpdateUserPayload', user?: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, image?: string | null, phone?: string | null, lastLogin?: any | null, jobTitle: string, intercomUserHash?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type InviteUserMutationVariables = Exact<{
  input: InviteUserInput;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser?: { __typename?: 'InviteUserPayload', businessUnitUser?: { __typename?: 'BusinessUnitUser', id: string, status: BusinessUnitUserStatus, isOwner?: boolean | null, role: { __typename?: 'Role', id: string, name: string }, businessUnit: { __typename?: 'BusinessUnit', id: string, name: string }, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, image?: string | null, phone?: string | null, lastLogin?: any | null, jobTitle: string, intercomUserHash?: string | null } } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type TransferUserOwnershipMutationVariables = Exact<{
  input: TransferOwnershipInput;
}>;


export type TransferUserOwnershipMutation = { __typename?: 'Mutation', transferOwnership?: { __typename?: 'TransferOwnershipPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type SentResetPasswordEmailMutationVariables = Exact<{
  input: SendResetPasswordEmailInput;
}>;


export type SentResetPasswordEmailMutation = { __typename?: 'Mutation', sendResetPasswordEmail?: { __typename?: 'SendResetPasswordEmailPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type CompleteInviteMutationVariables = Exact<{
  input: CompleteInvitationInput;
}>;


export type CompleteInviteMutation = { __typename?: 'Mutation', completeInvite?: { __typename?: 'CompleteInvitationPayload', token?: string | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type ResentInviteMutationVariables = Exact<{
  input: ReInviteUserInput;
}>;


export type ResentInviteMutation = { __typename?: 'Mutation', reInviteUser?: { __typename?: 'ReInviteUserPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type DeleteUserFromFarmMutationVariables = Exact<{
  input: DeleteUserFromFarmInput;
}>;


export type DeleteUserFromFarmMutation = { __typename?: 'Mutation', deleteUserFromFarm?: { __typename?: 'DeleteUserFromFarmPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UpdateBusinessUnitUserMutationVariables = Exact<{
  input: UpdateBusinessUnitUserInput;
}>;


export type UpdateBusinessUnitUserMutation = { __typename?: 'Mutation', updateBusinessUnitUser?: { __typename?: 'UpdateBusinessUnitUserPayload', businessUnitUser?: { __typename?: 'BusinessUnitUser', id: string, status: BusinessUnitUserStatus, isOwner?: boolean | null, role: { __typename?: 'Role', id: string, name: string }, businessUnit: { __typename?: 'BusinessUnit', id: string, name: string }, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, image?: string | null, phone?: string | null, lastLogin?: any | null, jobTitle: string, intercomUserHash?: string | null } } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', userInfo?: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, image?: string | null, phone?: string | null, lastLogin?: any | null, jobTitle: string, intercomUserHash?: string | null } | null };

export type SearchUserQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type SearchUserQuery = { __typename?: 'Query', searchUser?: Array<{ __typename?: 'UserPublicInfo', id: number, email?: string | null, image?: string | null, firstName: string, lastName: string, businessUnitUserId?: number | null } | null> | null };

export type RolesListQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesListQuery = { __typename?: 'Query', roles?: Array<{ __typename?: 'Role', id: string, name: string } | null> | null };

export type PageInfoFragment = { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null };

export type DeliveryLocationFragment = { __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null };

export type DeliveryFragment = { __typename?: 'DeliveryType', id: string, name: string, status: DeliveryStatusEnum, animalCount: number, direction: DeliveryDirectionEnum, sentAt?: any | null, arrivedAt?: any | null, createdAt: any, updatedAt: any, animalTypes?: Array<{ __typename?: 'AnimalType', id: string, name: string }> | null, reason?: { __typename?: 'DeliveryReasonType', id: any, title: string } | null, destinationSummary: { __typename?: 'DeliveryLocationSummaryType', locations?: Array<{ __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null }> | null }, sourceSummary: { __typename?: 'DeliveryLocationSummaryType', locations?: Array<{ __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null }> | null }, defaultDestination?: { __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null } | null, defaultSource?: { __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null } | null };

export type ConsignmentAnimalFragment = { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, eId?: string | null, visualId?: string | null, dob?: any | null, dateMovedToFarm?: any | null, isMale: boolean, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, lastWeight?: { __typename?: 'WeightActivityLog', value?: number | null, date?: any | null } | null };

export type CommitDeliveryMutationVariables = Exact<{
  input: CommitDeliveryInput;
}>;


export type CommitDeliveryMutation = { __typename?: 'Mutation', commitDelivery?: { __typename?: 'CommitDeliveryPayload', clientMutationId?: string | null, success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string }> | null, delivery?: { __typename?: 'DeliveryType', id: string, name: string, status: DeliveryStatusEnum, animalCount: number, direction: DeliveryDirectionEnum, sentAt?: any | null, arrivedAt?: any | null, createdAt: any, updatedAt: any, animalTypes?: Array<{ __typename?: 'AnimalType', id: string, name: string }> | null, reason?: { __typename?: 'DeliveryReasonType', id: any, title: string } | null, destinationSummary: { __typename?: 'DeliveryLocationSummaryType', locations?: Array<{ __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null }> | null }, sourceSummary: { __typename?: 'DeliveryLocationSummaryType', locations?: Array<{ __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null }> | null }, defaultDestination?: { __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null } | null, defaultSource?: { __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null } | null } | null } | null };

export type CreateDeliveryMutationVariables = Exact<{
  input: CreateDeliveryInput;
}>;


export type CreateDeliveryMutation = { __typename?: 'Mutation', createDelivery?: { __typename?: 'CreateDeliveryPayload', clientMutationId?: string | null, success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string }> | null, delivery?: { __typename?: 'DeliveryType', id: string, name: string, status: DeliveryStatusEnum, animalCount: number, direction: DeliveryDirectionEnum, sentAt?: any | null, arrivedAt?: any | null, createdAt: any, updatedAt: any, animalTypes?: Array<{ __typename?: 'AnimalType', id: string, name: string }> | null, reason?: { __typename?: 'DeliveryReasonType', id: any, title: string } | null, destinationSummary: { __typename?: 'DeliveryLocationSummaryType', locations?: Array<{ __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null }> | null }, sourceSummary: { __typename?: 'DeliveryLocationSummaryType', locations?: Array<{ __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null }> | null }, defaultDestination?: { __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null } | null, defaultSource?: { __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null } | null } | null } | null };

export type UpdateDeliveryMutationVariables = Exact<{
  input: UpdateDeliveryInput;
}>;


export type UpdateDeliveryMutation = { __typename?: 'Mutation', updateDelivery?: { __typename?: 'UpdateDeliveryPayload', clientMutationId?: string | null, success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string }> | null, delivery?: { __typename?: 'DeliveryType', id: string, name: string, status: DeliveryStatusEnum, animalCount: number, direction: DeliveryDirectionEnum, sentAt?: any | null, arrivedAt?: any | null, createdAt: any, updatedAt: any, animalTypes?: Array<{ __typename?: 'AnimalType', id: string, name: string }> | null, reason?: { __typename?: 'DeliveryReasonType', id: any, title: string } | null, destinationSummary: { __typename?: 'DeliveryLocationSummaryType', locations?: Array<{ __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null }> | null }, sourceSummary: { __typename?: 'DeliveryLocationSummaryType', locations?: Array<{ __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null }> | null }, defaultDestination?: { __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null } | null, defaultSource?: { __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null } | null } | null } | null };

export type DeleteDeliveryMutationVariables = Exact<{
  input: DeleteDeliveryInput;
}>;


export type DeleteDeliveryMutation = { __typename?: 'Mutation', deleteDelivery?: { __typename?: 'DeleteDeliveryPayload', clientMutationId?: string | null, success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string }> | null } | null };

export type AddAnimalsToDeliveryMutationVariables = Exact<{
  input: DeliverAnimalsOutInput;
}>;


export type AddAnimalsToDeliveryMutation = { __typename?: 'Mutation', deliverAnimalsOut?: { __typename?: 'DeliverAnimalsOutPayload', errors?: Array<{ __typename?: 'ValidationError', field: string, message: string }> | null, delivery?: { __typename?: 'DeliveryType', id: string } | null } | null };

export type RemoveAnimalsFromDeliveryMutationVariables = Exact<{
  input: DeleteDeliveryAnimalsInput;
}>;


export type RemoveAnimalsFromDeliveryMutation = { __typename?: 'Mutation', deleteDeliveryAnimals?: { __typename?: 'DeleteDeliveryAnimalsPayload', errors?: Array<{ __typename?: 'ValidationError', field: string, message: string }> | null, delivery?: { __typename?: 'DeliveryType', id: string } | null } | null };

export type CreateAndAddAnimalToDeliveryMutationVariables = Exact<{
  input: DeliverNewAnimalInput;
}>;


export type CreateAndAddAnimalToDeliveryMutation = { __typename?: 'Mutation', deliverNewAnimal?: { __typename?: 'DeliverNewAnimalPayload', delivery?: { __typename?: 'DeliveryType', id: string } | null, animal?: { __typename?: 'Animal', id?: any | null, currentWeight?: number | null, dateMovedToFarm?: any | null, dob?: any | null, eId?: string | null, brucellosisId?: string | null, tattoo?: string | null, tsuBarcode?: string | null, pedigreeId?: string | null, trichId?: string | null, herdDoggId?: string | null, name?: string | null, breedrId?: string | null, uhfId?: string | null, alternativeId?: string | null, growthRate?: number | null, isCastrated: boolean, latestPurchasePrice?: number | null, isMale: boolean, isPregnant?: boolean | null, lastRegulatorySyncedDate?: any | null, passportNumber?: string | null, performanceCategory?: string | null, pregnancyDueDate?: any | null, targetLiveWeight?: number | null, visualId?: string | null, isRegulatorySynced?: boolean | null, deliveryDate?: any | null, sirePassportNumber?: string | null, damPassportNumber?: string | null, damId?: string | null, withdrawalEnd?: any | null, dateLeftFarm?: any | null, deadAt?: any | null, updatedAt: any, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null, newClassification?: AnimalBreedNewClassification | null }>, breedPercentages: Array<{ __typename?: 'BreedPercentage', percentage?: number | null, breed: { __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null } }>, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, group?: { __typename?: 'Group', id: string, name: string } | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', unitName?: string | null } | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, linkToMySire?: { __typename?: 'Sire', id?: any | null, name: string, pedigree: boolean, passportNumber: string } | null, birthInformation?: { __typename?: 'BirthInformation', birthWeight?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string } | null, tags: Array<{ __typename?: 'AnimalTagType', color?: string | null, name: string, tagId: string, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }>, previousKeeper?: { __typename?: 'AnimalPreviousKeeperType', name: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string }> | null } | null };

export type UpdateAnimalMutationVariables = Exact<{
  input: UpdateAnimalInput;
}>;


export type UpdateAnimalMutation = { __typename?: 'Mutation', updateAnimal?: { __typename?: 'UpdateAnimalPayload', animal?: { __typename?: 'Animal', id?: any | null, currentWeight?: number | null, dateMovedToFarm?: any | null, dob?: any | null, eId?: string | null, brucellosisId?: string | null, tattoo?: string | null, tsuBarcode?: string | null, pedigreeId?: string | null, trichId?: string | null, herdDoggId?: string | null, name?: string | null, breedrId?: string | null, uhfId?: string | null, alternativeId?: string | null, growthRate?: number | null, isCastrated: boolean, latestPurchasePrice?: number | null, isMale: boolean, isPregnant?: boolean | null, lastRegulatorySyncedDate?: any | null, passportNumber?: string | null, performanceCategory?: string | null, pregnancyDueDate?: any | null, targetLiveWeight?: number | null, visualId?: string | null, isRegulatorySynced?: boolean | null, deliveryDate?: any | null, sirePassportNumber?: string | null, damPassportNumber?: string | null, damId?: string | null, withdrawalEnd?: any | null, dateLeftFarm?: any | null, deadAt?: any | null, updatedAt: any, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null, newClassification?: AnimalBreedNewClassification | null }>, breedPercentages: Array<{ __typename?: 'BreedPercentage', percentage?: number | null, breed: { __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null } }>, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, group?: { __typename?: 'Group', id: string, name: string } | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', unitName?: string | null } | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, linkToMySire?: { __typename?: 'Sire', id?: any | null, name: string, pedigree: boolean, passportNumber: string } | null, birthInformation?: { __typename?: 'BirthInformation', birthWeight?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string } | null, tags: Array<{ __typename?: 'AnimalTagType', color?: string | null, name: string, tagId: string, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }>, previousKeeper?: { __typename?: 'AnimalPreviousKeeperType', name: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UndoDeliveryMutationVariables = Exact<{
  input: UndoDeliveryInput;
}>;


export type UndoDeliveryMutation = { __typename?: 'Mutation', undoDelivery?: { __typename?: 'UndoDeliveryPayload', success?: boolean | null, delivery?: { __typename?: 'DeliveryType', id: string } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, code: string, message: string }> | null } | null };

export type DeliveryPartnerAddressesQueryVariables = Exact<{
  businessUnit: Scalars['ID'];
  orderBy?: InputMaybe<Array<DeliveryPartnerAddressSortingEnum> | DeliveryPartnerAddressSortingEnum>;
}>;


export type DeliveryPartnerAddressesQuery = { __typename?: 'Query', deliveryPartnerAddresses?: { __typename?: 'DeliveryPartnerAddressConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'DeliveryPartnerAddressEdge', node?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null } | null> } | null };

export type DeliveriesQueryVariables = Exact<{
  businessUnit: Scalars['ID'];
  status?: InputMaybe<DeliveryStatusEnum>;
  direction?: InputMaybe<DeliveryDirectionEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<DeliverySortingEnum>> | InputMaybe<DeliverySortingEnum>>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type DeliveriesQuery = { __typename?: 'Query', deliveries?: { __typename?: 'DeliveryConnection', count?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'DeliveryEdge', node?: { __typename?: 'DeliveryType', id: string, name: string, status: DeliveryStatusEnum, animalCount: number, direction: DeliveryDirectionEnum, sentAt?: any | null, arrivedAt?: any | null, createdAt: any, updatedAt: any, animalTypes?: Array<{ __typename?: 'AnimalType', id: string, name: string }> | null, reason?: { __typename?: 'DeliveryReasonType', id: any, title: string } | null, destinationSummary: { __typename?: 'DeliveryLocationSummaryType', locations?: Array<{ __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null }> | null }, sourceSummary: { __typename?: 'DeliveryLocationSummaryType', locations?: Array<{ __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null }> | null }, defaultDestination?: { __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null } | null, defaultSource?: { __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null } | null } | null } | null> } | null };

export type DeliveryQueryVariables = Exact<{
  businessUnit: Scalars['ID'];
  delivery: Scalars['ID'];
}>;


export type DeliveryQuery = { __typename?: 'Query', delivery?: { __typename?: 'DeliveryOverviewType', delivery: { __typename?: 'DeliveryType', id: string, name: string, status: DeliveryStatusEnum, animalCount: number, direction: DeliveryDirectionEnum, sentAt?: any | null, arrivedAt?: any | null, createdAt: any, updatedAt: any, animalTypes?: Array<{ __typename?: 'AnimalType', id: string, name: string }> | null, reason?: { __typename?: 'DeliveryReasonType', id: any, title: string } | null, destinationSummary: { __typename?: 'DeliveryLocationSummaryType', locations?: Array<{ __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null }> | null }, sourceSummary: { __typename?: 'DeliveryLocationSummaryType', locations?: Array<{ __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null }> | null }, defaultDestination?: { __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null } | null, defaultSource?: { __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null } | null }, consignments?: { __typename?: 'DeliveryConsignmentConnection', edges: Array<{ __typename?: 'DeliveryConsignmentEdge', node?: { __typename?: 'DeliveryConsignmentType', animalCount: number, animals?: { __typename?: 'AnimalConnection2', edges: Array<{ __typename?: 'AnimalConnection2Edge', node?: { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, eId?: string | null, visualId?: string | null, dob?: any | null, dateMovedToFarm?: any | null, isMale: boolean, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, lastWeight?: { __typename?: 'WeightActivityLog', value?: number | null, date?: any | null } | null } | null } | null> } | null, destination?: { __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string } } | null } | null } | null> } | null } | null };

export type DeliveryReasonsQueryVariables = Exact<{
  businessUnit: Scalars['ID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  directions?: InputMaybe<Array<DeliveryDirectionEnum> | DeliveryDirectionEnum>;
}>;


export type DeliveryReasonsQuery = { __typename?: 'Query', deliveryReasons?: { __typename?: 'DeliveryReasonConnection', edges: Array<{ __typename?: 'DeliveryReasonEdge', node?: { __typename?: 'DeliveryReasonType', id: any, title: string } | null } | null> } | null };

export type DraftDeliveryQueryVariables = Exact<{
  businessUnit: Scalars['ID'];
  delivery: Scalars['ID'];
}>;


export type DraftDeliveryQuery = { __typename?: 'Query', delivery?: { __typename?: 'DeliveryOverviewType', delivery: { __typename?: 'DeliveryType', id: string, name: string, status: DeliveryStatusEnum, animalCount: number, direction: DeliveryDirectionEnum, sentAt?: any | null, arrivedAt?: any | null, createdAt: any, updatedAt: any, animalTypes?: Array<{ __typename?: 'AnimalType', id: string, name: string }> | null, reason?: { __typename?: 'DeliveryReasonType', id: any, title: string } | null, destinationSummary: { __typename?: 'DeliveryLocationSummaryType', locations?: Array<{ __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null }> | null }, sourceSummary: { __typename?: 'DeliveryLocationSummaryType', locations?: Array<{ __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null }> | null }, defaultDestination?: { __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null } | null, defaultSource?: { __typename?: 'DeliveryLocationType', details: { __typename?: 'DeliveryLocationDetailsObjectType', name: string, address: string, email: string, postcode: string }, address?: { __typename?: 'DeliveryPartnerAddressType', id: string, name: string } | null, contact?: { __typename?: 'ContactObjectType', id: string } | null, partner?: { __typename?: 'DeliveryPartnerType', id: string, addresses?: Array<{ __typename?: 'DeliveryPartnerAddressType', id: string, name: string }> | null } | null } | null } } | null };

export type DraftDeliveryAnimalsQueryVariables = Exact<{
  businessUnit: Scalars['ID'];
  delivery: Scalars['ID'];
}>;


export type DraftDeliveryAnimalsQuery = { __typename?: 'Query', delivery?: { __typename?: 'DeliveryOverviewType', delivery: { __typename?: 'DeliveryType', id: string }, animals?: { __typename?: 'AnimalConnection2', edges: Array<{ __typename?: 'AnimalConnection2Edge', cursor: string, node?: { __typename?: 'Animal', id?: any | null, currentWeight?: number | null, dateMovedToFarm?: any | null, dob?: any | null, eId?: string | null, brucellosisId?: string | null, tattoo?: string | null, tsuBarcode?: string | null, pedigreeId?: string | null, trichId?: string | null, herdDoggId?: string | null, name?: string | null, breedrId?: string | null, uhfId?: string | null, alternativeId?: string | null, growthRate?: number | null, isCastrated: boolean, latestPurchasePrice?: number | null, isMale: boolean, isPregnant?: boolean | null, lastRegulatorySyncedDate?: any | null, passportNumber?: string | null, performanceCategory?: string | null, pregnancyDueDate?: any | null, targetLiveWeight?: number | null, visualId?: string | null, isRegulatorySynced?: boolean | null, deliveryDate?: any | null, sirePassportNumber?: string | null, damPassportNumber?: string | null, damId?: string | null, withdrawalEnd?: any | null, dateLeftFarm?: any | null, deadAt?: any | null, updatedAt: any, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null, newClassification?: AnimalBreedNewClassification | null }>, breedPercentages: Array<{ __typename?: 'BreedPercentage', percentage?: number | null, breed: { __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null } }>, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, group?: { __typename?: 'Group', id: string, name: string } | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', unitName?: string | null } | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, linkToMySire?: { __typename?: 'Sire', id?: any | null, name: string, pedigree: boolean, passportNumber: string } | null, birthInformation?: { __typename?: 'BirthInformation', birthWeight?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string } | null, tags: Array<{ __typename?: 'AnimalTagType', color?: string | null, name: string, tagId: string, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }>, previousKeeper?: { __typename?: 'AnimalPreviousKeeperType', name: string } | null } | null } | null> } | null } | null };

export type CheckIfAnimalExistsQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
  visualId?: InputMaybe<Scalars['String']>;
  eId?: InputMaybe<Scalars['String']>;
  passportNumber?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  searchIds?: InputMaybe<Array<IdentifierType> | IdentifierType>;
}>;


export type CheckIfAnimalExistsQuery = { __typename?: 'Query', animals?: { __typename?: 'AnimalConnection2', edges: Array<{ __typename?: 'AnimalConnection2Edge', node?: { __typename?: 'Animal', id?: any | null, brucellosisId?: string | null, eId?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, trichId?: string | null, tsuBarcode?: string | null, uhfId?: string | null, visualId?: string | null } | null } | null> } | null };

export type CreateStripePortalSessionMutationVariables = Exact<{
  input: CreateStripePortalSessionInput;
}>;


export type CreateStripePortalSessionMutation = { __typename?: 'Mutation', createStripePortalSession?: { __typename?: 'CreateStripePortalSessionPayload', clientMutationId?: string | null, sessionUrl: string } | null };

export type CreateStripeCheckoutSessionMutationVariables = Exact<{
  input: CreateStripeCheckoutSessionInput;
}>;


export type CreateStripeCheckoutSessionMutation = { __typename?: 'Mutation', createStripeCheckoutSession?: { __typename?: 'CreateStripeCheckoutSessionPayload', clientMutationId?: string | null, sessionUrl: string } | null };

export type GetSubscriptionFeaturesQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
}>;


export type GetSubscriptionFeaturesQuery = { __typename?: 'Query', businessUnit?: { __typename?: 'BusinessUnit', id: string, subscriptionPlanFeatures?: Array<{ __typename?: 'SubscriptionPlanFeature', slug: string, isActive: boolean }> | null } | null };

export type SubscriptionStatusQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
}>;


export type SubscriptionStatusQuery = { __typename?: 'Query', subscriptionStatus: { __typename?: 'SubscriptionStatusType', hasStripeState: boolean, hasStripeSubscriptions: boolean, isSubscribed: boolean, activationTokens: Array<{ __typename?: 'SubscriptionActivationTokenType', id: string, behaviour: SubscriptionActivationTokenBehaviourEnum }> } };

export type UpdateFieldMutationVariables = Exact<{
  input: UpdateFieldInput;
}>;


export type UpdateFieldMutation = { __typename?: 'Mutation', updateField?: { __typename?: 'UpdateFieldPayload', errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null, field?: { __typename?: 'Field', id: any, name: string, description?: string | null, isOrganic: boolean, isYard: boolean, isHoldingPen: boolean, size?: number | null, sizeUnit: FieldSizeUnit, fieldDensity?: any | null, avgDlwg?: any | null, avgEstimatedWeight?: any | null, avgRecordedWeight?: any | null, avgAge?: any | null, location?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, unitName?: string | null, country?: { __typename?: 'Country', name: string } | null } | null, pastureTypes: Array<{ __typename?: 'PastureType', id: string, name: string }>, summaryMetrics?: Array<{ __typename?: 'SummaryMetrics', breedrCode?: string | null, animalsCount?: number | null, femaleCount?: number | null, maleCount?: number | null, animalTypeId?: number | null } | null> | null } | null } | null };

export type FieldNamesQueryVariables = Exact<{
  businessUnitId?: InputMaybe<Scalars['Int']>;
}>;


export type FieldNamesQuery = { __typename?: 'Query', fields?: Array<{ __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null }> | null };

export type FieldsQueryVariables = Exact<{
  businessUnitId?: InputMaybe<Scalars['Int']>;
}>;


export type FieldsQuery = { __typename?: 'Query', fields?: Array<{ __typename?: 'Field', id: any, name: string, isOrganic: boolean, isYard: boolean, sizeUnit: FieldSizeUnit, fieldDensity?: any | null, avgAge?: any | null, avgDlwg?: any | null, avgEstimatedWeight?: any | null, description?: string | null, animalAlertsCount?: number | null, location?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, unitName?: string | null, country?: { __typename?: 'Country', id: string, code: string, name: string } | null } | null, summaryMetrics?: Array<{ __typename?: 'SummaryMetrics', breedrCode?: string | null, regBreedCode?: string | null, animalsCount?: number | null, maleCount?: number | null, femaleCount?: number | null, animalTypeId?: number | null } | null> | null }> | null };

export type FieldQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type FieldQuery = { __typename?: 'Query', field?: { __typename?: 'Field', id: any, name: string, description?: string | null, isOrganic: boolean, isYard: boolean, isHoldingPen: boolean, size?: number | null, sizeUnit: FieldSizeUnit, fieldDensity?: any | null, avgDlwg?: any | null, avgEstimatedWeight?: any | null, avgRecordedWeight?: any | null, avgAge?: any | null, location?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, unitName?: string | null, country?: { __typename?: 'Country', name: string } | null } | null, pastureTypes: Array<{ __typename?: 'PastureType', id: string, name: string }>, summaryMetrics?: Array<{ __typename?: 'SummaryMetrics', breedrCode?: string | null, animalsCount?: number | null, femaleCount?: number | null, maleCount?: number | null, animalTypeId?: number | null } | null> | null } | null };

export type FinancialTransactionsQueryVariables = Exact<{
  businessUnit: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<FinancialTransactionsSortByEnumType>;
  desc?: InputMaybe<Scalars['Boolean']>;
}>;


export type FinancialTransactionsQuery = { __typename?: 'Query', financialTransactions?: { __typename?: 'FinancialTransactionConnection', count?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'FinancialTransactionEdge', node?: { __typename?: 'FinancialTransaction', id: any, label: string, animalsCount?: number | null, amount: any, date: any, recordType?: TransactionRecordEnumType | null } | null } | null> } | null };

export type BatchQueryVariables = Exact<{
  group: Scalars['UUID'];
  businessUnit: Scalars['Int'];
}>;


export type BatchQuery = { __typename?: 'Query', group?: { __typename?: 'Group', id: string, animalsNumberCache?: number | null, averageDobInBatch?: any | null, category: GroupCategory, gendersInBatch?: string | null, numberOfUnidentifiedAnimalsInBatch?: number | null, isBatch?: boolean | null, targetWeight?: number | null, targetDate?: any | null, daysTillTarget?: number | null, avgDlwg?: any | null, timeOnFarm?: any | null, name: string, animalType?: { __typename?: 'AnimalType', id: string, name: string } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any }>, summaryMetrics?: Array<{ __typename?: 'SummaryMetrics', femaleCount?: number | null, maleCount?: number | null, breedrCode?: string | null } | null> | null } | null };

export type GroupQueryVariables = Exact<{
  group: Scalars['UUID'];
  businessUnit: Scalars['Int'];
}>;


export type GroupQuery = { __typename?: 'Query', group?: { __typename?: 'Group', id: string, name: string, targetWeight?: number | null, category: GroupCategory, targetDate?: any | null, timeOnFarm?: any | null, minAge?: any | null, maxAge?: any | null, minDaysOnFarm?: number | null, maxDaysOnFarm?: number | null, avgEstimatedWeight?: any | null, avgRecordedWeight?: any | null, avgDlwg?: any | null, daysTillTarget?: number | null, isBatch?: boolean | null, animalType?: { __typename?: 'AnimalType', id: string, colour: string, image?: string | null } | null, weightInfo?: { __typename?: 'GroupWeightInfo', minWeight?: number | null, maxWeight?: number | null } | null, summaryMetrics?: Array<{ __typename?: 'SummaryMetrics', breedrCode?: string | null, animalsCount?: number | null, femaleCount?: number | null, maleCount?: number | null } | null> | null, animals?: Array<{ __typename?: 'Animal', id?: any | null } | null> | null } | null };

export type GroupsInfoQueryVariables = Exact<{
  businessUnitId?: InputMaybe<Scalars['Int']>;
  animalTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type GroupsInfoQuery = { __typename?: 'Query', groupsExtended?: { __typename?: 'GroupExtendedList', groupsCount?: number | null, groups?: Array<{ __typename?: 'Group', id: string, name: string, isBatch?: boolean | null }> | null } | null };

export type GetGroupsCountQueryVariables = Exact<{
  businessUnitId?: InputMaybe<Scalars['Int']>;
}>;


export type GetGroupsCountQuery = { __typename?: 'Query', groupsExtended?: { __typename?: 'GroupExtendedList', groupsCount?: number | null } | null };

export type ActivityTypeFieldsFragment = { __typename?: 'ActivityType', id: string, image?: string | null, imageSvg?: string | null, slug?: string | null, name: string, isPublic: boolean, isSystem: boolean, position: number, activityTemplatesCount?: number | null };

export type UploadCsvMutationVariables = Exact<{
  input: UploadCsvInput;
}>;


export type UploadCsvMutation = { __typename?: 'Mutation', uploadCsv?: { __typename?: 'UploadCsvPayload', id?: number | null, rows?: any | null, fields?: any | null, totalColumns?: number | null, totalRows?: number | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type ImportCsvMutationVariables = Exact<{
  input: ImportCsvInput;
}>;


export type ImportCsvMutation = { __typename?: 'Mutation', importCsv?: { __typename?: 'ImportCsvPayload', taskId?: string | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type GetBatchUploadFormatsQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
}>;


export type GetBatchUploadFormatsQuery = { __typename?: 'Query', batchUploadFormats?: Array<{ __typename?: 'BatchUploadFormat', activityTemplateId?: number | null, categorySlug?: string | null, name?: string | null, slug: string, animalTypes: Array<{ __typename?: 'AnimalType', id: string } | null>, columns: Array<{ __typename?: 'BatchUploadFormatColumn', isRequired: boolean, label: string, name: string }>, activityType?: { __typename?: 'ActivityType', id: string, image?: string | null, imageSvg?: string | null, slug?: string | null, name: string, isPublic: boolean, isSystem: boolean, position: number, activityTemplatesCount?: number | null } | null }> | null };

export type GetBatchUploadFormatQueryVariables = Exact<{
  businessUnitId: Scalars['ID'];
  slug: Scalars['String'];
}>;


export type GetBatchUploadFormatQuery = { __typename?: 'Query', batchUploadFormat?: { __typename?: 'BatchUploadFormat', activityTemplateId?: number | null, name?: string | null, slug: string, animalTypes: Array<{ __typename?: 'AnimalType', id: string } | null>, columns: Array<{ __typename?: 'BatchUploadFormatColumn', isRequired: boolean, label: string, name: string }>, activityType?: { __typename?: 'ActivityType', id: string, image?: string | null, imageSvg?: string | null, slug?: string | null, name: string, isPublic: boolean, isSystem: boolean, position: number, activityTemplatesCount?: number | null } | null } | null };

export type GetActivityTypesNewQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
}>;


export type GetActivityTypesNewQuery = { __typename?: 'Query', activityTypes?: Array<{ __typename?: 'ActivityType', id: string, image?: string | null, imageSvg?: string | null, slug?: string | null, name: string, isPublic: boolean, isSystem: boolean, position: number, activityTemplatesCount?: number | null } | null> | null };

export type GetLandingReportQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
}>;


export type GetLandingReportQuery = { __typename?: 'Query', mainReport?: { __typename?: 'ReportType', id: string, title: string, url: string, reportType?: ReportEngine | null } | null };

export type DashboardsQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardsQuery = { __typename?: 'Query', dashboards?: Array<{ __typename?: 'DashboardObjectType', title: string, slug: string, filters?: Array<{ __typename?: 'FilterObjectType', filterType?: string | null, filterName?: string | null } | null> | null } | null> | null };

export type DashboardQueryVariables = Exact<{
  dashboardSlug: Scalars['String'];
}>;


export type DashboardQuery = { __typename?: 'Query', dashboard?: { __typename?: 'DashboardObjectType', title: string, slug: string, charts: Array<{ __typename?: 'ChartObjectType', reportType: string, dataParam: string, layoutSize: number }>, filters?: Array<{ __typename?: 'FilterObjectType', filterType?: string | null, filterName?: string | null } | null> | null } | null };

export type CreateDownloadMutationVariables = Exact<{
  input: CreateDownloadInput;
}>;


export type CreateDownloadMutation = { __typename?: 'Mutation', createDownload?: { __typename?: 'CreateDownloadPayload', downloadId?: string | null, success?: boolean | null } | null };

export type TableDataQueryVariables = Exact<{
  chartSlug: Scalars['String'];
  dashboardSlug: Scalars['String'];
  businessUnitId: Scalars['Int'];
  orderBy?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationObjectType>;
  filters?: InputMaybe<Scalars['GenericScalar']>;
}>;


export type TableDataQuery = { __typename?: 'Query', tableData?: { __typename?: 'TableDataObjectType', title: string, data: Array<any>, pageInfo?: { __typename?: 'PageInfoObjectType', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } | null, download?: { __typename?: 'DownloadOptionsObjectType', slug: string, variables: any } | null, columns: Array<{ __typename?: 'TableColumnDataObjectType', displayName: string, accessor: string, sortable?: boolean | null }>, searchableField?: { __typename?: 'SearchableFieldObjectType', field?: string | null, label?: string | null } | null } | null };

export type ChartDataQueryVariables = Exact<{
  chartSlug: Scalars['String'];
  dashboardSlug: Scalars['String'];
  businessUnitId: Scalars['Int'];
  filters?: InputMaybe<Scalars['GenericScalar']>;
}>;


export type ChartDataQuery = { __typename?: 'Query', chartData?: { __typename?: 'ChartDataObjectType', title: string, value: number } | null };

export type PieChartDataQueryVariables = Exact<{
  chartSlug: Scalars['String'];
  dashboardSlug: Scalars['String'];
  businessUnitId: Scalars['Int'];
  filters?: InputMaybe<Scalars['GenericScalar']>;
}>;


export type PieChartDataQuery = { __typename?: 'Query', pieChartData?: { __typename?: 'PieChartDataObjectType', title: string, data: Array<{ __typename?: 'LabelNumberObjectType', x: string, y: number }> } | null };

export type BarChartDataQueryVariables = Exact<{
  chartSlug: Scalars['String'];
  dashboardSlug: Scalars['String'];
  businessUnitId: Scalars['Int'];
  filters?: InputMaybe<Scalars['GenericScalar']>;
}>;


export type BarChartDataQuery = { __typename?: 'Query', barChartData?: { __typename?: 'BarChartDataObjectType', title: string, bars: Array<{ __typename?: 'SeriesObjectType', label: string, data: Array<{ __typename?: 'LabelNumberObjectType', x: string, y: number }> }> } | null };

export type DownloadsQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
}>;


export type DownloadsQuery = { __typename?: 'Query', downloads?: { __typename?: 'DownloadConnection', edges: Array<{ __typename?: 'DownloadEdge', node?: { __typename?: 'DownloadObjectType', id: any, name: string, status: DownloadStatus, downloadedFile?: string | null } | null } | null> } | null };

export type ContactFragmentFragment = { __typename?: 'ContactObjectType', id: string, contactType: ContactContactType, organisationName?: string | null, farmId?: string | null, name: string, addressLine1?: string | null, addressLine2?: string | null, postcode?: string | null, city?: string | null, state?: string | null, email?: string | null, phoneNumber?: string | null, country?: { __typename?: 'Country', id: string, name: string, isoAlpha2?: string | null, code: string } | null };

export type CreateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact?: { __typename?: 'CreateContactPayload', contact?: { __typename?: 'ContactObjectType', id: string, contactType: ContactContactType, organisationName?: string | null, farmId?: string | null, name: string, addressLine1?: string | null, addressLine2?: string | null, postcode?: string | null, city?: string | null, state?: string | null, email?: string | null, phoneNumber?: string | null, country?: { __typename?: 'Country', id: string, name: string, isoAlpha2?: string | null, code: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UpdateContactMutationVariables = Exact<{
  input: UpdateContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact?: { __typename?: 'UpdateContactPayload', contact?: { __typename?: 'ContactObjectType', id: string, contactType: ContactContactType, organisationName?: string | null, farmId?: string | null, name: string, addressLine1?: string | null, addressLine2?: string | null, postcode?: string | null, city?: string | null, state?: string | null, email?: string | null, phoneNumber?: string | null, country?: { __typename?: 'Country', id: string, name: string, isoAlpha2?: string | null, code: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type ContactsQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
  contactType?: InputMaybe<Scalars['String']>;
}>;


export type ContactsQuery = { __typename?: 'Query', contacts?: Array<{ __typename?: 'ContactObjectType', id: string, contactType: ContactContactType, organisationName?: string | null, farmId?: string | null, name: string, addressLine1?: string | null, addressLine2?: string | null, postcode?: string | null, city?: string | null, state?: string | null, email?: string | null, phoneNumber?: string | null, country?: { __typename?: 'Country', id: string, name: string, isoAlpha2?: string | null, code: string } | null } | null> | null };

export type ContactQueryVariables = Exact<{
  id: Scalars['Int'];
  businessUnitId: Scalars['Int'];
}>;


export type ContactQuery = { __typename?: 'Query', contact?: { __typename?: 'ContactObjectType', id: string, contactType: ContactContactType, organisationName?: string | null, farmId?: string | null, name: string, addressLine1?: string | null, addressLine2?: string | null, postcode?: string | null, city?: string | null, state?: string | null, email?: string | null, phoneNumber?: string | null, country?: { __typename?: 'Country', id: string, name: string, isoAlpha2?: string | null, code: string } | null } | null };

export type SupplyChainsQueryVariables = Exact<{
  buId: Scalars['Int'];
}>;


export type SupplyChainsQuery = { __typename?: 'Query', supplyChainPages?: Array<{ __typename?: 'SupplyChainPageObjectType', id: string, title: string, banner?: string | null, accreditation: string, subregion: string, text: string, bullets?: Array<{ __typename?: 'BulletObjectType', id: string, text: string, order: number }> | null } | null> | null };

export type MergeAnimalTagsMutationVariables = Exact<{
  input: MergeAnimalTagsInput;
}>;


export type MergeAnimalTagsMutation = { __typename?: 'Mutation', mergeAnimalTags?: { __typename?: 'MergeAnimalTagsPayload', animals?: Array<{ __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, offerId?: number | null, currentWeight?: number | null, visualId?: string | null, eId?: string | null, growthRate?: number | null, performanceCategory?: string | null, sirePassportNumber?: string | null, damPassportNumber?: string | null, rflId?: string | null, deliveryDate?: any | null, buyerName?: string | null, dateMovedToFarm?: any | null, daysToTargetWeight?: number | null, withdrawalEnd?: any | null, isRegulatorySynced?: boolean | null, targetDailyLiveWeightGain?: number | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, isPregnant?: boolean | null, pregnancyDueDate?: any | null, brucellosisId?: string | null, tattoo?: string | null, tsuBarcode?: string | null, pedigreeId?: string | null, trichId?: string | null, breedrId?: string | null, uhfId?: string | null, name?: string | null, herdDoggId?: string | null, alternativeId?: string | null, lastWeight?: { __typename?: 'WeightActivityLog', value?: number | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, breedPercentages: Array<{ __typename?: 'BreedPercentage', percentage?: number | null, breed: { __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null } }>, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null } | null, animalColour?: { __typename?: 'AnimalColour', id?: number | null, code?: string | null, name?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, animalType?: { __typename?: 'AnimalType', id: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, color?: string | null, name: string, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> }> | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string }> | null } | null };

export type CreateTagMutationVariables = Exact<{
  input: CreateTagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag?: { __typename?: 'CreateTagPayload', animalTag?: { __typename?: 'AnimalTagSchemaType', id: string, slug: string, name: string, color?: string | null, ownership: AnimalTagOwnership, animalTypes?: Array<{ __typename?: 'AnimalType', id: string }> | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string }> | null } | null };

export type UpdateTagMutationVariables = Exact<{
  input: UpdateTagInput;
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag?: { __typename?: 'UpdateTagPayload', animalTag?: { __typename?: 'AnimalTagSchemaType', id: string, slug: string, name: string, color?: string | null, ownership: AnimalTagOwnership, animalTypes?: Array<{ __typename?: 'AnimalType', id: string }> | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string }> | null } | null };

export type DeleteTagMutationVariables = Exact<{
  input: DeleteTagInput;
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag?: { __typename?: 'DeleteTagPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string }> | null } | null };

export type AnimalTagsQueryVariables = Exact<{
  buId: Scalars['Int'];
  tagIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type AnimalTagsQuery = { __typename?: 'Query', animalTags?: { __typename?: 'AnimalTagOverviewConnection', edges: Array<{ __typename?: 'AnimalTagOverviewEdge', node?: { __typename?: 'AnimalTagOverviewType', id: string, name: string, color?: string | null, numAliveAnimals: number, ownership: AnimalTagOwnership, schema: { __typename?: 'AnimalTagSchemaType', id: string, isRemovable: boolean } } | null } | null> } | null };

export type AnimalTagQueryVariables = Exact<{
  buId: Scalars['Int'];
  tagIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type AnimalTagQuery = { __typename?: 'Query', animalTags?: { __typename?: 'AnimalTagOverviewConnection', edges: Array<{ __typename?: 'AnimalTagOverviewEdge', node?: { __typename?: 'AnimalTagOverviewType', id: string, name: string, color?: string | null, numAliveAnimals: number, ownership: AnimalTagOwnership, averageAge?: any | null, averageDaysOnFarm?: any | null, averageRecordedWeight?: any | null, averageEstimatedWeight?: any | null } | null } | null> } | null };

export type GetAnimalsWithTagsQueryVariables = Exact<{
  businessUnitId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  isMale?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  searchIds?: InputMaybe<Array<IdentifierType> | IdentifierType>;
  isPregnant?: InputMaybe<Scalars['Boolean']>;
  minDob?: InputMaybe<Scalars['DateTime']>;
  maxDob?: InputMaybe<Scalars['DateTime']>;
  minDof?: InputMaybe<Scalars['DateTime']>;
  maxDof?: InputMaybe<Scalars['DateTime']>;
  animalTags?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  animalIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  orderBy?: InputMaybe<Array<AnimalSorting> | AnimalSorting>;
  field?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<Scalars['UUID']>;
}>;


export type GetAnimalsWithTagsQuery = { __typename?: 'Query', animals?: { __typename?: 'AnimalConnection2', count?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null }, edges: Array<{ __typename?: 'AnimalConnection2Edge', node?: { __typename?: 'Animal', id?: any | null, currentWeight?: number | null, dateMovedToFarm?: any | null, dob?: any | null, eId?: string | null, brucellosisId?: string | null, tattoo?: string | null, tsuBarcode?: string | null, pedigreeId?: string | null, trichId?: string | null, herdDoggId?: string | null, name?: string | null, breedrId?: string | null, uhfId?: string | null, alternativeId?: string | null, growthRate?: number | null, isCastrated: boolean, latestPurchasePrice?: number | null, isMale: boolean, isPregnant?: boolean | null, lastRegulatorySyncedDate?: any | null, passportNumber?: string | null, performanceCategory?: string | null, pregnancyDueDate?: any | null, targetLiveWeight?: number | null, visualId?: string | null, isRegulatorySynced?: boolean | null, deliveryDate?: any | null, sirePassportNumber?: string | null, damPassportNumber?: string | null, damId?: string | null, withdrawalEnd?: any | null, dateLeftFarm?: any | null, deadAt?: any | null, updatedAt: any, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null, newClassification?: AnimalBreedNewClassification | null }>, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, group?: { __typename?: 'Group', id: string, name: string } | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', unitName?: string | null } | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, linkToMySire?: { __typename?: 'Sire', id?: any | null, name: string, pedigree: boolean, passportNumber: string } | null, birthInformation?: { __typename?: 'BirthInformation', birthWeight?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string } | null, tags: Array<{ __typename?: 'AnimalTagType', color?: string | null, name: string, tagId: string, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }>, previousKeeper?: { __typename?: 'AnimalPreviousKeeperType', name: string } | null } | null } | null> } | null };

export type CreateLotMutationVariables = Exact<{
  input: CreateLotInput;
}>;


export type CreateLotMutation = { __typename?: 'Mutation', createLot?: { __typename?: 'CreateLotPayload', lot?: { __typename?: 'OwnLot', id: number } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UpdateLotMutationVariables = Exact<{
  input: UpdateLotInput;
}>;


export type UpdateLotMutation = { __typename?: 'Mutation', updateLot?: { __typename?: 'UpdateLotPayload', lot?: { __typename?: 'OwnLot', id: number, images?: Array<{ __typename?: 'LotImage', id: string, position?: number | null } | null> | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type CreateOfferForLotMutationVariables = Exact<{
  input: CreateOfferForLotInput;
}>;


export type CreateOfferForLotMutation = { __typename?: 'Mutation', createOfferForLot?: { __typename?: 'CreateOfferForLotPayload', offer?: { __typename?: 'Offer', id: string, status: OfferStatus, offeredNumber: number, actualStatus?: string | null, invoice?: { __typename?: 'Invoice', id: string, finalPrice?: number | null, priceUnit: InvoicePriceUnit, currency?: { __typename?: 'Currency', id: string, code: string } | null } | null, createdBy?: { __typename?: 'User', id: string, email: string, phone?: string | null, firstName: string, lastName: string } | null, businessUnit?: { __typename?: 'BusinessUnit', id: string, name: string, locationData?: any | null, city?: string | null, primaryLocation?: { __typename?: 'DeliveryAddressType', id: string, postcode?: string | null } | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type ResponseToLotOfferMutationVariables = Exact<{
  input: ResponseToLotOfferInput;
}>;


export type ResponseToLotOfferMutation = { __typename?: 'Mutation', responseToLotOffer?: { __typename?: 'ResponseToLotOfferPayload', offer?: { __typename?: 'Offer', id: string, status: OfferStatus, offeredNumber: number, actualStatus?: string | null, invoice?: { __typename?: 'Invoice', id: string, finalPrice?: number | null, priceUnit: InvoicePriceUnit, currency?: { __typename?: 'Currency', id: string, code: string } | null } | null, createdBy?: { __typename?: 'User', id: string, email: string, phone?: string | null, firstName: string, lastName: string } | null, businessUnit?: { __typename?: 'BusinessUnit', id: string, name: string, locationData?: any | null, city?: string | null, primaryLocation?: { __typename?: 'DeliveryAddressType', id: string, postcode?: string | null } | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type MarkAsPaidLotOfferMutationVariables = Exact<{
  input: MarkAsPaidLotOfferInput;
}>;


export type MarkAsPaidLotOfferMutation = { __typename?: 'Mutation', markAsPaidLotOffer?: { __typename?: 'MarkAsPaidLotOfferPayload', offer?: { __typename?: 'Offer', id: string, status: OfferStatus, offeredNumber: number, actualStatus?: string | null, invoice?: { __typename?: 'Invoice', id: string, finalPrice?: number | null, priceUnit: InvoicePriceUnit, currency?: { __typename?: 'Currency', id: string, code: string } | null } | null, createdBy?: { __typename?: 'User', id: string, email: string, phone?: string | null, firstName: string, lastName: string } | null, businessUnit?: { __typename?: 'BusinessUnit', id: string, name: string, locationData?: any | null, city?: string | null, primaryLocation?: { __typename?: 'DeliveryAddressType', id: string, postcode?: string | null } | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type LotSellerSentAnimalsMutationVariables = Exact<{
  input: LotSellerSentAnimalsInput;
}>;


export type LotSellerSentAnimalsMutation = { __typename?: 'Mutation', lotSellerSentAnimals?: { __typename?: 'LotSellerSentAnimalsPayload', lot?: { __typename?: 'OwnLot', id: number, status?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type LotBuyerReceivedAnimalsMutationVariables = Exact<{
  input: LotBuyerReceivedAnimalsInput;
}>;


export type LotBuyerReceivedAnimalsMutation = { __typename?: 'Mutation', lotBuyerReceivedAnimals?: { __typename?: 'LotBuyerReceivedAnimalsPayload', lot?: { __typename?: 'OwnLot', id: number, status?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type BuyingLotsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessUnit: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  showExpired?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  distance?: InputMaybe<Scalars['Float']>;
  categoryOfSale?: InputMaybe<Scalars['Float']>;
  animalType?: InputMaybe<Scalars['Float']>;
}>;


export type BuyingLotsQuery = { __typename?: 'Query', buyingLots?: { __typename?: 'PublicLotConnection', edges: Array<{ __typename?: 'PublicLotEdge', node?: { __typename?: 'PublicLot', id: number, description?: string | null, distance?: number | null, name?: string | null, price?: number | null, priceUnit?: string | null, totalPrice?: number | null, expiresAt?: any | null, status?: string | null, offersPendingCount?: number | null, animalsAverageAge?: number | null, animalsAverageGrowthRate?: any | null, animalsAverageTimesWeighed?: number | null, animalsAverageCurrentWeight?: number | null, animalsMaxNumberMoves?: number | null, animalsNumberSires?: number | null, animalsNumberWithdrawals?: number | null, isPublic: boolean, startDate?: any | null, animalsCount?: number | null, isExpired?: boolean | null, businessUnit?: { __typename?: 'BusinessUnitInfo', id?: number | null, name?: string | null, county?: string | null, country?: { __typename?: 'Country', id: string, code: string } | null, unitsOfMeasurement?: Array<{ __typename?: 'UnitOfMeasurement', id: string, code: string, measurementType: UnitOfMeasurementBusinessUnitMeasurementType } | null> | null } | null, currency?: { __typename?: 'Currency', id: string, code: string } | null, images?: Array<{ __typename?: 'LotImage', id: string, photo: string, thumbnailSmall?: string | null, position?: number | null } | null> | null, deliveryAddress?: { __typename?: 'DeliveryAddressType', id: string, postcode?: string | null, country?: { __typename?: 'Country', id: string, name: string } | null } | null, animalsCountBreedAndGender?: Array<{ __typename?: 'AnimalBreedGender', breedName?: string | null, isMale?: boolean | null, count?: number | null } | null> | null, animalType?: { __typename?: 'AnimalType', id: string, name: string } | null, categoryOfSale?: { __typename?: 'CategoryOfSale', id: number, category: string } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type BuyingLotQueryVariables = Exact<{
  id: Scalars['Int'];
  businessUnitId: Scalars['Int'];
}>;


export type BuyingLotQuery = { __typename?: 'Query', buyingLot?: { __typename?: 'PublicLot', id: number, description?: string | null, name?: string | null, price?: number | null, status?: string | null, totalPrice?: number | null, pricePerKgOnCreation?: number | null, priceUnit?: string | null, expiresAt?: any | null, startDate?: any | null, tbRequirements?: string | null, preMovementTestDate?: any | null, referenceCode?: string | null, isAcceptedMyOffer?: boolean | null, isPublic: boolean, isExpired?: boolean | null, categoryOfSale?: { __typename?: 'CategoryOfSale', id: number, category: string } | null, currency?: { __typename?: 'Currency', id: string, code: string } | null, animals?: Array<{ __typename?: 'PublicAnimal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, visualId?: string | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, sirePassportNumber?: string | null, dateMovedToFarm?: any | null, growthRate?: number | null, cphCount?: number | null, targetDailyLiveWeightGain?: number | null, withdrawalEnd?: any | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string, breedrCode?: string | null }>, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null } | null> | null, offers?: Array<{ __typename?: 'Offer', id: string, status: OfferStatus, price?: number | null, totalPriceOnCreation?: number | null, businessUnit?: { __typename?: 'BusinessUnit', id: string } | null, currency?: { __typename?: 'Currency', id: string, name: string, code: string } | null } | null> | null, images?: Array<{ __typename?: 'LotImage', id: string, photo: string, position?: number | null } | null> | null, deliveryAddress?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, postcode?: string | null, primary: boolean, locationType?: DeliveryAddressLocationType | null, locationId?: string | null, country?: { __typename?: 'Country', id: string, code: string, name: string } | null } | null, businessUnit?: { __typename?: 'BusinessUnitInfo', id?: number | null, name?: string | null, postcode?: string | null } | null, animalType?: { __typename?: 'AnimalType', id: string, name: string } | null } | null };

export type MyLotsQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type MyLotsQuery = { __typename?: 'Query', myLots?: { __typename?: 'OwnLotConnection', edges: Array<{ __typename?: 'OwnLotEdge', node?: { __typename?: 'OwnLot', id: number, description?: string | null, name?: string | null, price?: number | null, priceUnit?: string | null, totalPrice?: number | null, createdAt: any, expiresAt?: any | null, status?: string | null, offersPendingCount?: number | null, animalsAverageAge?: number | null, animalsAverageGrowthRate?: any | null, animalsAverageTimesWeighed?: number | null, animalsAverageCurrentWeight?: number | null, animalsMaxNumberMoves?: number | null, animalsNumberSires?: number | null, animalsNumberWithdrawals?: number | null, isPublic: boolean, startDate?: any | null, animalsCount?: number | null, isExpired?: boolean | null, currency?: { __typename?: 'Currency', id: string, code: string } | null, categoryOfSale?: { __typename?: 'CategoryOfSale', category: string, id: number } | null, lotOffers: Array<{ __typename?: 'Offer', id: string, price?: number | null }>, images?: Array<{ __typename?: 'LotImage', id: string, photo: string, thumbnailSmall?: string | null, position?: number | null } | null> | null, deliveryAddress?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, unitName?: string | null } | null, animalsCountBreedAndGender?: Array<{ __typename?: 'AnimalBreedGender', breedName?: string | null, isMale?: boolean | null, count?: number | null } | null> | null, distributionLists: Array<{ __typename?: 'DistributionListObjectType', id: string, name: string }>, animalType?: { __typename?: 'AnimalType', id: string, name: string } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type MyLotQueryVariables = Exact<{
  id: Scalars['Int'];
  businessUnit: Scalars['Int'];
}>;


export type MyLotQuery = { __typename?: 'Query', myLot?: { __typename?: 'OwnLot', id: number, description?: string | null, name?: string | null, price?: number | null, status?: string | null, priceUnit?: string | null, pricePerKgOnCreation?: number | null, referenceCode?: string | null, createdAt: any, startDate?: any | null, expiresAt?: any | null, isExpired?: boolean | null, lotConfigurableSellerMessage?: string | null, tbRequirements?: string | null, preMovementTestDate?: any | null, isPublic: boolean, categoryOfSale?: { __typename?: 'CategoryOfSale', id: number, category: string } | null, animalType?: { __typename?: 'AnimalType', id: string } | null, animals?: Array<{ __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, isCastrated: boolean, dob?: any | null, currentWeight?: number | null, rflId?: string | null, dateMovedToFarm?: any | null, eId?: string | null, visualId?: string | null, brucellosisId?: string | null, trichId?: string | null, tsuBarcode?: string | null, herdDoggId?: string | null, pedigreeId?: string | null, tattoo?: string | null, deliveryDate?: any | null, buyerName?: string | null, withdrawalEnd?: any | null, growthRate?: number | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, deadAt?: any | null, dateLeftFarm?: any | null, killWeight?: number | null, killQuality: string, killFatScore: string, targetDailyLiveWeightGain?: number | null, performanceCategory?: string | null, hasPreviousKeeperInfo?: boolean | null, sirePassportNumber?: string | null, cphCount?: number | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, group?: { __typename?: 'Group', id: string, name: string, daysTillTarget?: number | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }> } | null> | null, images?: Array<{ __typename?: 'LotImage', id: string, photo: string, position?: number | null, thumbnailSmall?: string | null } | null> | null, lotOffers: Array<{ __typename?: 'Offer', id: string, price?: number | null, offeredNumber: number, status: OfferStatus, createdAt: any, priceUnit?: OfferPriceUnit | null, collectionDate?: any | null, totalPriceOnCreation?: number | null, currency?: { __typename?: 'Currency', id: string, code: string } | null, businessUnit?: { __typename?: 'BusinessUnit', id: string, name: string } | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }>, deliveryAddress?: { __typename?: 'DeliveryAddressType', id: string, locationId?: string | null, unitName?: string | null } | null, tradingType?: { __typename?: 'TradingType', id: string, slug: string } | null, distributionLists: Array<{ __typename?: 'DistributionListObjectType', id: string, name: string }> } | null };

export type TermsAndConditionsQueryVariables = Exact<{
  tacType: Scalars['String'];
}>;


export type TermsAndConditionsQuery = { __typename?: 'Query', termsAndConditions?: { __typename?: 'TermsAndConditionsObjectType', title: string, description: string, type?: string | null } | null };

export type CategoriesOfSaleQueryVariables = Exact<{
  animalType: Scalars['Int'];
}>;


export type CategoriesOfSaleQuery = { __typename?: 'Query', categoriesOfSale?: { __typename?: 'CategoryOfSaleConnection', edges: Array<{ __typename?: 'CategoryOfSaleEdge', node?: { __typename?: 'CategoryOfSale', id: number, category: string } | null } | null> } | null };

export type PageInfoFragmentFragment = { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null };

export type OfferedAnimalWantFragmentFragment = { __typename?: 'PublicAnimal', id?: any | null, eId?: string | null, visualId?: string | null, passportNumber?: string | null, isMale: boolean, dob?: any | null, currentWeight?: number | null, lastWeight?: { __typename?: 'WeightActivityLog', value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null };

export type OfferedAnimalFragmentFragment = { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, withdrawalEnd?: any | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, dob?: any | null, eId?: string | null, visualId?: string | null, dateMovedToFarm?: any | null, currentWeight?: number | null, lastWeight?: { __typename?: 'WeightActivityLog', value?: number | null } | null, group?: { __typename?: 'Group', id: string, name: string } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null };

export type OfferedAnimalGroupFragmentFragment = { __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, withdrawalEnd?: any | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, dob?: any | null, isCastrated: boolean, rflId?: string | null, eId?: string | null, visualId?: string | null, isPregnant?: boolean | null, pregnancyDueDate?: any | null, deliveryDate?: any | null, buyerName?: string | null, currentWeight?: number | null, growthRate?: number | null, dateMovedToFarm?: any | null, tags: Array<{ __typename?: 'AnimalTagType', tagId: string, name: string, color?: string | null, schema: { __typename?: 'AnimalTagSchemaType', ownership: AnimalTagOwnership } }>, lot?: { __typename?: 'LotInfo', id?: number | null, status?: string | null, isExpired?: boolean | null } | null, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, locationId?: string | null } | null, lastWeight?: { __typename?: 'WeightActivityLog', date?: any | null, value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null };

export type OfferFragmentFragment = { __typename?: 'Offer', id: string, status: OfferStatus, offeredNumber: number, actualStatus?: string | null, invoice?: { __typename?: 'Invoice', id: string, finalPrice?: number | null, priceUnit: InvoicePriceUnit, currency?: { __typename?: 'Currency', id: string, code: string } | null } | null, createdBy?: { __typename?: 'User', id: string, email: string, phone?: string | null, firstName: string, lastName: string } | null, businessUnit?: { __typename?: 'BusinessUnit', id: string, name: string, locationData?: any | null, city?: string | null, primaryLocation?: { __typename?: 'DeliveryAddressType', id: string, postcode?: string | null } | null } | null };

export type WantOfferDetailsDataFragmentFragment = { __typename?: 'Offer', id: string, actualStatus?: string | null, offeredNumber: number, createdBy?: { __typename?: 'User', id: string, email: string, phone?: string | null, firstName: string, lastName: string } | null, businessUnit?: { __typename?: 'BusinessUnit', id: string, name: string, locationData?: any | null, city?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, price?: number | null, totalPrice?: number | null, finalPrice?: number | null, priceUnit: InvoicePriceUnit, currency?: { __typename?: 'Currency', id: string, code: string } | null } | null, producedLot?: { __typename?: 'PublicLot', gradingFile?: string | null, animalsCount?: number | null, id: number, animals?: Array<{ __typename?: 'PublicAnimal', id?: any | null, eId?: string | null, visualId?: string | null, passportNumber?: string | null, isMale: boolean, dob?: any | null, currentWeight?: number | null, lastWeight?: { __typename?: 'WeightActivityLog', value?: number | null } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null } | null> | null } | null, producedLotInterface?: { __typename?: 'OwnLot', id: number, animalsCount?: number | null, gradingFile?: string | null, deliveredAnimals?: Array<{ __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, withdrawalEnd?: any | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, dob?: any | null, eId?: string | null, visualId?: string | null, dateMovedToFarm?: any | null, currentWeight?: number | null, lastWeight?: { __typename?: 'WeightActivityLog', value?: number | null } | null, group?: { __typename?: 'Group', id: string, name: string } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null } | null> | null, animals?: Array<{ __typename?: 'Animal', id?: any | null, passportNumber?: string | null, isMale: boolean, withdrawalEnd?: any | null, isRegulatorySynced?: boolean | null, lastRegulatorySyncedDate?: any | null, dob?: any | null, eId?: string | null, visualId?: string | null, dateMovedToFarm?: any | null, currentWeight?: number | null, lastWeight?: { __typename?: 'WeightActivityLog', value?: number | null } | null, group?: { __typename?: 'Group', id: string, name: string } | null, animalType?: { __typename?: 'AnimalType', id: string, slug?: string | null } | null, animalBreeds: Array<{ __typename?: 'AnimalBreed', id: any, name: string }>, field?: { __typename?: 'Field', id: any, name: string, location?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null } | null, sexClassification?: { __typename?: 'SexClassification', slug: string, title: string } | null } | null> | null } | { __typename?: 'PublicLot' } | null };

export type DeliveryAddressFragmentFragment = { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, postcode?: string | null, primary: boolean, locationType?: DeliveryAddressLocationType | null, locationId?: string | null, country?: { __typename?: 'Country', id: string, code: string, name: string } | null };

export type AddDeliveryAddressMutationVariables = Exact<{
  input: AddDeliveryAddressInput;
}>;


export type AddDeliveryAddressMutation = { __typename?: 'Mutation', addDeliveryAddress?: { __typename?: 'AddDeliveryAddressPayload', deliveryAddress?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type EditDeliveryAddressMutationVariables = Exact<{
  input: EditDeliveryAddressInput;
}>;


export type EditDeliveryAddressMutation = { __typename?: 'Mutation', editDeliveryAddress?: { __typename?: 'EditDeliveryAddressPayload', deliveryAddress?: { __typename?: 'DeliveryAddressType', id: string, unitName?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type DeleteDeliveryAddressMutationVariables = Exact<{
  input: DeleteDeliveryAddressInput;
}>;


export type DeleteDeliveryAddressMutation = { __typename?: 'Mutation', deleteDeliveryAddress?: { __typename?: 'DeleteDeliveryAddressPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UploadDiscountGridMutationVariables = Exact<{
  input: UploadDiscountGridInput;
}>;


export type UploadDiscountGridMutation = { __typename?: 'Mutation', uploadDiscountGrid?: { __typename?: 'UploadDiscountGridPayload', discountGrid?: { __typename?: 'DiscountGrid', id: string, name: string } | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type CreateDistributionListMutationVariables = Exact<{
  input: CreateDistributionListInput;
}>;


export type CreateDistributionListMutation = { __typename?: 'Mutation', createDistributionList?: { __typename?: 'CreateDistributionListPayload', errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type DeleteDistributionListMutationVariables = Exact<{
  input: DeleteDistributionListInput;
}>;


export type DeleteDistributionListMutation = { __typename?: 'Mutation', deleteDistributionList?: { __typename?: 'DeleteDistributionListPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type UpdateDistributionListMutationVariables = Exact<{
  input: UpdateDistributionListInput;
}>;


export type UpdateDistributionListMutation = { __typename?: 'Mutation', updateDistributionList?: { __typename?: 'UpdateDistributionListPayload', errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type MarkOffersAsReadMutationVariables = Exact<{
  input: OfferMarkAsReadInput;
}>;


export type MarkOffersAsReadMutation = { __typename?: 'Mutation', offerMarkAsRead?: { __typename?: 'OfferMarkAsReadPayload', success?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', field: string, message: string } | null> | null } | null };

export type DeliveryAddressesQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
}>;


export type DeliveryAddressesQuery = { __typename?: 'Query', deliveryAddresses?: Array<{ __typename?: 'DeliveryAddressType', id: string, unitName?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, postcode?: string | null, primary: boolean, locationType?: DeliveryAddressLocationType | null, locationId?: string | null, country?: { __typename?: 'Country', id: string, code: string, name: string } | null } | null> | null };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries?: Array<{ __typename?: 'Country', id: string, code: string, name: string, isoAlpha2?: string | null } | null> | null };

export type HowDidYouHearAboutBreedrChoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type HowDidYouHearAboutBreedrChoicesQuery = { __typename?: 'Query', howDidYouHearAboutBreedrChoices?: Array<{ __typename?: 'HowDidYouHearAboutBreedrChoices', id?: number | null, choice?: string | null, slug?: string | null } | null> | null };

export type GetDiscountGridsQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
}>;


export type GetDiscountGridsQuery = { __typename?: 'Query', discountGrids?: Array<{ __typename?: 'DiscountGrid', id: string, name: string } | null> | null };

export type GetDistributionListsCountQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
}>;


export type GetDistributionListsCountQuery = { __typename?: 'Query', distributionLists?: { __typename?: 'DistributionListConnection', count?: number | null } | null };

export type GetDistributionListsQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
}>;


export type GetDistributionListsQuery = { __typename?: 'Query', distributionLists?: { __typename?: 'DistributionListConnection', edges: Array<{ __typename?: 'DistributionListEdge', node?: { __typename?: 'DistributionListObjectType', id: string, name: string, suppliers?: Array<{ __typename?: 'SearchBusinessUnit', id?: number | null, name?: string | null } | null> | null } | null } | null> } | null };

export type GetDistributionListByIdQueryVariables = Exact<{
  businessUnit: Scalars['Int'];
  id: Scalars['Int'];
}>;


export type GetDistributionListByIdQuery = { __typename?: 'Query', distributionList?: { __typename?: 'DistributionListObjectType', id: string, name: string, suppliers?: Array<{ __typename?: 'SearchBusinessUnit', id?: number | null, name?: string | null, location?: { __typename?: 'LocationSearchBusinessUnit', city?: string | null, unitName?: string | null } | null } | null> | null } | null };

export type GetTradingTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTradingTypesQuery = { __typename?: 'Query', tradingTypes?: Array<{ __typename?: 'TradingType', id: string, slug: string } | null> | null };

export type GetCountBusinessUnitsQueryVariables = Exact<{
  postcode: Scalars['String'];
  radius: Scalars['Int'];
  includePreferredSuppliers?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCountBusinessUnitsQuery = { __typename?: 'Query', countBusinessUnits?: { __typename?: 'BusinessUnitCountType', count?: number | null, errors?: Array<{ __typename?: 'ValidationErrorType', message: string } | null> | null } | null };

export type GetCurrenciesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrenciesListQuery = { __typename?: 'Query', currencies?: Array<{ __typename?: 'Currency', id: string, name: string, code: string } | null> | null };

export type GetEstimatedFuturePriceBasedOnWeightQueryVariables = Exact<{
  offerPricePerWeightUnit: Scalars['Float'];
  collectionDate: Scalars['Date'];
  lot: Scalars['Int'];
}>;


export type GetEstimatedFuturePriceBasedOnWeightQuery = { __typename?: 'Query', estimatedFuturePriceBasedOnWeight?: { __typename?: 'EstimatedFuturePriceType', futurePrice?: any | null, errors?: Array<{ __typename?: 'ValidationError', field: string, code: string, message: string } | null> | null } | null };

export const AnimalFragmentDoc = gql`
    fragment animal on Animal {
  id
  animalBreeds {
    id
    name
    breedrCode
    newClassification
  }
  breedPercentages {
    breed {
      id
      name
      breedrCode
    }
    percentage
  }
  currentWeight
  dateMovedToFarm
  dob
  eId
  brucellosisId
  tattoo
  tsuBarcode
  pedigreeId
  trichId
  herdDoggId
  name
  breedrId
  uhfId
  alternativeId
  growthRate
  isCastrated
  latestPurchasePrice
  isMale
  isPregnant
  lastWeight {
    date
    value
  }
  lastRegulatorySyncedDate
  group {
    id
    name
  }
  field {
    id
    name
    location {
      unitName
    }
  }
  passportNumber
  performanceCategory
  pregnancyDueDate
  sexClassification {
    slug
    title
  }
  targetLiveWeight
  visualId
  isRegulatorySynced
  deliveryDate
  sirePassportNumber
  damPassportNumber
  damId
  linkToMySire {
    id
    name
    pedigree
    passportNumber
  }
  birthInformation {
    birthWeight
  }
  animalType {
    id
  }
  withdrawalEnd
  dateLeftFarm
  deadAt
  tags {
    color
    name
    tagId
    schema {
      ownership
    }
  }
  previousKeeper {
    name
  }
  updatedAt
}
    `;
export const BlockchainAnimalFragmentFragmentDoc = gql`
    fragment blockchainAnimalFragment on BlockchainAnimalData {
  movements {
    createdBy
    fromFarmName
    fromHoldingId
    toOwnerId
    toOwnerName
    toHoldingId
    date
  }
  weights {
    date
    value
    unit
    holdingId
    createdBy
  }
  medication {
    date
    medicineName
    batchNumber
    dosage
    dosageUnits
    activeIngredient
    withdrawalDays
    holdingId
    createdBy
  }
  carcassGrading {
    date
    hotWeight
    coldWeight
    grading
    fatScore
    conformation
    condemnedWeight
    value
    killNumber
    lotNumber
    createdBy
    holdingId
  }
  breed
  dob
  isMale
  name
  ownerId
  ownerName
  ownerHoldingId
  passportNumber
  isDead
  deathDate
  deathCreatedBy
  error
}
    `;
export const BuFragmentFragmentDoc = gql`
    fragment BUFragment on BusinessUnit {
  id
  name
  profilePhoto
  warnings
  tbStatus
  postcode
  organisation {
    id
  }
  canCreateRfl
  tradingTypes {
    id
    slug
    name
  }
  businessType {
    id
    slug
  }
  locationsCount
  foggles
  regulatorySystem {
    id
    slug
    name
  }
  deliveryAddress {
    id
    unitName
    locationId
    postcode
    addressLine1
  }
  primaryLocation {
    id
    locationId
    addressLine1
    addressLine2
    city
    postcode
  }
  currency {
    id
    name
    code
  }
  unitsOfMeasurement {
    id
    code
    measurementType
  }
  country {
    id
    code
    name
    isoAlpha2
    isoNumber
    visualIdPrefix
    region {
      code
      name
    }
  }
  farmAnimalTypes {
    colour
    enabled
    id
    image
    name
    position
    slug
  }
  effectiveSubscriptionPlan {
    name
  }
  identifierPreferencesActiveIds {
    alternativeId
    passportNumber
    visualId
    eId
    name
    trichId
    tsuBarcode
    pedigreeId
    tattoo
    herdDoggId
    breedrId
    uhfId
    brucellosisId
    alternativeId
  }
  identifierPreferencesPrimaryId
  identifierPreferencesSecondaryId
  herdDoggIntegration {
    isConnected
  }
}
    `;
export const BusinessUnitTargetFragmentDoc = gql`
    fragment businessUnitTarget on BusinessUnitTarget {
  id
  name
  details
  animalType {
    id
  }
}
    `;
export const BuStrippedFragmentDoc = gql`
    fragment BUStripped on BusinessUnit {
  id
  name
}
    `;
export const AnimalFragmentFragmentDoc = gql`
    fragment animalFragment on Animal {
  id
  passportNumber
  isMale
  isCastrated
  dob
  currentWeight
  rflId
  dateMovedToFarm
  eId
  visualId
  brucellosisId
  trichId
  tsuBarcode
  herdDoggId
  pedigreeId
  tattoo
  deliveryDate
  buyerName
  field {
    id
    name
    location {
      id
      unitName
    }
  }
  lastWeight {
    date
    value
  }
  animalType {
    id
    slug
  }
  animalBreeds {
    id
    name
  }
  lot {
    id
    status
    isExpired
  }
  group {
    id
    name
    daysTillTarget
  }
  location {
    id
    unitName
    locationId
  }
  sexClassification {
    slug
    title
  }
  withdrawalEnd
  growthRate
  isRegulatorySynced
  lastRegulatorySyncedDate
  deadAt
  dateLeftFarm
  killWeight
  killQuality
  killFatScore
  targetDailyLiveWeightGain
  performanceCategory
  hasPreviousKeeperInfo
  sirePassportNumber
  cphCount
  isPregnant
  pregnancyDueDate
  tags {
    tagId
    name
    color
    schema {
      ownership
    }
  }
}
    `;
export const ImportActivityFragmentFragmentDoc = gql`
    fragment importActivityFragment on ActivityLog {
  animal {
    passportNumber
  }
  date
  payload {
    description
    data {
      name
      value
      unitName
    }
  }
}
    `;
export const UnprocessedAnimalFragmentFragmentDoc = gql`
    fragment unprocessedAnimalFragment on UnprocessedAnimal {
  id
  passportNumber
  date
  weight
  breed
  eId
  dob
  sex
}
    `;
export const TaskDetailsFragmentFragmentDoc = gql`
    fragment taskDetailsFragment on FarmSystemTaskType {
  id
  action
  status
  totalNumberItems
  updatedNumberItems
  producedTask {
    id
    newNumberItems
  }
  producedFromTask {
    createdItems {
      ... on Animal {
        ...animalFragment
      }
      ... on ActivityLog {
        ...importActivityFragment
      }
    }
  }
  processedNumberItems
  newNumberItems
  createdItems {
    ... on Animal {
      ...animalFragment
    }
    ... on ActivityLog {
      ...importActivityFragment
    }
  }
  updatedItems {
    ... on Animal {
      ...animalFragment
    }
  }
  uncreatedItems {
    ... on UnprocessedAnimal {
      ...unprocessedAnimalFragment
    }
  }
}
    ${AnimalFragmentFragmentDoc}
${ImportActivityFragmentFragmentDoc}
${UnprocessedAnimalFragmentFragmentDoc}`;
export const LineItemFragmentFragmentDoc = gql`
    fragment lineItemFragment on LineItemType {
  id
  name
  sku
  batchNumber
  quantity
  totalVolume
  originalVolume
  expiryDate
  bottleNumber
  cost
  purchaseDate
  supplierName
  volumeUnits
}
    `;
export const StockItemFragmentFragmentDoc = gql`
    fragment stockItemFragment on StockItemListType {
  id
  name
  totalQuantity
  totalVolume
  species {
    id
    name
  }
  manufacturer
  manufacturerName
  applicationMethod
  activeIngredient
  withdrawal {
    id
    animalType {
      id
      name
      slug
    }
    withdrawalPeriodDays
    withdrawalType
  }
  lineItems {
    ...lineItemFragment
  }
}
    ${LineItemFragmentFragmentDoc}`;
export const ActivityTypeFragmentFragmentDoc = gql`
    fragment activityTypeFragment on ActivityType {
  id
  image
  imageSvg
  slug
  name
  isPublic
  isSystem
  activityTemplatesCount
}
    `;
export const ActivityTemplateFragmentFragmentDoc = gql`
    fragment activityTemplateFragment on ActivityTemplate {
  id
  name
  slug
  description
  businessUnit {
    id
    name
  }
  fields {
    id
    name
    slug
    units
    fieldType
    position
    initialValue
    isRequired
    options {
      id
      title
      value
    }
  }
  activityType {
    id
    image
    imageSvg
    slug
    name
    isPublic
    isSystem
    position
    activityTemplatesCount
  }
}
    `;
export const ActivityTypeShortFragmentFragmentDoc = gql`
    fragment activityTypeShortFragment on ActivityType {
  id
  slug
  image
}
    `;
export const ActivityLogFragmentFragmentDoc = gql`
    fragment activityLogFragment on ActivityLog {
  id
  date
  dontShow
  isDeletable
  payload {
    valueDescription
    shortDescription
    longDescription
    data {
      fieldSlug
    }
  }
  activityType {
    ...activityTypeShortFragment
  }
  activityTemplate {
    id
    activityType {
      ...activityTypeShortFragment
    }
  }
}
    ${ActivityTypeShortFragmentFragmentDoc}`;
export const HistoryAnimalFragmentFragmentDoc = gql`
    fragment historyAnimalFragment on ActivityLog {
  id
  date
  dontShow
  isDeletable
  payload {
    name
    description
    data {
      value
      unitName
      fieldSlug
    }
  }
  activityType {
    ...activityTypeShortFragment
  }
  activityTemplate {
    id
    activityType {
      ...activityTypeShortFragment
    }
  }
}
    ${ActivityTypeShortFragmentFragmentDoc}`;
export const AnimalTypeFragmentFragmentDoc = gql`
    fragment animalTypeFragment on AnimalType {
  id
  name
  slug
}
    `;
export const AnimalBreedsFragmentFragmentDoc = gql`
    fragment animalBreedsFragment on AnimalBreed {
  id
  name
  breedrCode
  regName
  regBreedCode
  animalType {
    ...animalTypeFragment
  }
}
    ${AnimalTypeFragmentFragmentDoc}`;
export const PublicAnimalFragmentFragmentDoc = gql`
    fragment publicAnimalFragment on PublicAnimal {
  id
  passportNumber
  isMale
  isCastrated
  dob
  currentWeight
  visualId
  lastWeight {
    date
    value
  }
  animalType {
    id
    slug
  }
  animalBreeds {
    id
    name
    breedrCode
  }
  isRegulatorySynced
  lastRegulatorySyncedDate
  sexClassification {
    slug
    title
  }
  sirePassportNumber
  dateMovedToFarm
  growthRate
  cphCount
  targetDailyLiveWeightGain
  withdrawalEnd
  isPregnant
  pregnancyDueDate
}
    `;
export const SingleAnimalFragmentFragmentDoc = gql`
    fragment singleAnimalFragment on Animal {
  id
  passportNumber
  isMale
  isCastrated
  dob
  offerId
  currentWeight
  lastWeight {
    value
  }
  animalBreeds {
    id
    name
  }
  breedPercentages {
    breed {
      id
      name
      breedrCode
    }
    percentage
  }
  field {
    id
    name
    location {
      id
      unitName
    }
  }
  visualId
  eId
  growthRate
  performanceCategory
  sirePassportNumber
  damPassportNumber
  group {
    id
    name
    daysTillTarget
  }
  lot {
    id
    status
  }
  rflId
  deliveryDate
  buyerName
  dateMovedToFarm
  daysToTargetWeight
  withdrawalEnd
  isRegulatorySynced
  targetDailyLiveWeightGain
  lastRegulatorySyncedDate
  deadAt
  dateLeftFarm
  killWeight
  killQuality
  killFatScore
  animalColour {
    id
    code
    name
  }
  sexClassification {
    slug
    title
  }
  isPregnant
  pregnancyDueDate
  animalType {
    id
  }
  tags {
    tagId
    color
    name
    schema {
      ownership
    }
  }
  brucellosisId
  tattoo
  tsuBarcode
  pedigreeId
  trichId
  breedrId
  uhfId
  name
  herdDoggId
  alternativeId
}
    `;
export const AnimalFiltersFragmentFragmentDoc = gql`
    fragment animalFiltersFragment on AnimalFilterObjectType {
  id
  animalType {
    id
    image
    colour
  }
  name
  breeds {
    id
  }
  isMale
  sexClassifications {
    slug
    title
  }
  ageFrom
  ageTo
  currentWeightFrom
  currentWeightTo
  lastWeightFrom
  lastWeightTo
  daysSinceLastWeightFrom
  daysSinceLastWeightTo
  dobFrom
  dobTo
  dofFrom
  dofTo
  growthRateFrom
  growthRateTo
  deliveryFrom
  deliveryTo
  fields {
    id
  }
  groups {
    id
  }
  lastRegulatorySyncedDateFrom
  lastRegulatorySyncedDateTo
  isRegulatorySynced
  inWithdrawal
  color
  isAlert
  isPregnant
  pregnancyDueDateFrom
  pregnancyDueDateTo
}
    `;
export const AnimalOffspringFragmentFragmentDoc = gql`
    fragment animalOffspringFragment on PublicAnimal {
  id
  birthInformation {
    birthAbnormalities
    birthingDifficulty
    birthPresentation
    birthSize
    birthVigor
    birthWeight
  }
  dob
  isArchived
  isMale
  ownerId
  passportNumber
  sirePassportNumber
  visualId
}
    `;
export const PastureTypeFragmentFragmentDoc = gql`
    fragment pastureTypeFragment on PastureType {
  id
  name
}
    `;
export const FieldFragmentFragmentDoc = gql`
    fragment fieldFragment on Field {
  id
  name
  description
  size
  sizeUnit
  isOrganic
  isYard
  isHoldingPen
  animals {
    id
  }
  location {
    country {
      id
      code
      name
    }
    id
    locationId
    unitName
  }
  pastureTypes {
    ...pastureTypeFragment
  }
  fieldDensity
  avgDlwg
  avgEstimatedWeight
  avgRecordedWeight
  avgAge
  summaryMetrics {
    breedrCode
    regBreedCode
    animalsCount
    maleCount
    femaleCount
    animalTypeId
  }
}
    ${PastureTypeFragmentFragmentDoc}`;
export const GroupFragmentFragmentDoc = gql`
    fragment groupFragment on Group {
  id
  name
  animalsNumberCache
  targetWeight
  animalsToSaleCount
  animalAlertsCount
  businessUnitTarget {
    id
    details
  }
  category
  avgEstimatedWeight
  avgRecordedWeight
  avgDlwg
  targetDate
  daysTillTarget
  summaryMetrics {
    breedrCode
    regBreedCode
    animalsCount
    maleCount
    femaleCount
  }
  animalType {
    id
    image
    colour
    name
  }
}
    `;
export const OfferedAnimalGroupFragmentFragmentDoc = gql`
    fragment offeredAnimalGroupFragment on Animal {
  id
  passportNumber
  isMale
  withdrawalEnd
  isRegulatorySynced
  lastRegulatorySyncedDate
  dob
  isCastrated
  rflId
  eId
  visualId
  isPregnant
  pregnancyDueDate
  deliveryDate
  buyerName
  currentWeight
  growthRate
  dateMovedToFarm
  tags {
    tagId
    name
    color
    schema {
      ownership
    }
  }
  lot {
    id
    status
    isExpired
  }
  location {
    id
    unitName
    locationId
  }
  lastWeight {
    date
    value
  }
  animalType {
    id
    slug
  }
  animalBreeds {
    id
    name
  }
  field {
    id
    name
    location {
      id
      unitName
    }
  }
  sexClassification {
    slug
    title
  }
}
    `;
export const SingleGroupFragmentFragmentDoc = gql`
    fragment singleGroupFragment on Group {
  id
  name
  animalsNumberCache
  targetWeight
  animals {
    ...offeredAnimalGroupFragment
  }
  weightInfo {
    minWeight
    maxWeight
  }
  minAge
  maxAge
  timeOnFarm
  growthRate
  category
  minDaysOnFarm
  maxDaysOnFarm
  avgEstimatedWeight
  avgRecordedWeight
  avgDlwg
  targetDate
  daysTillTarget
  summaryMetrics {
    breedrCode
    regBreedCode
    animalsCount
    maleCount
    femaleCount
  }
  animalType {
    id
    image
    colour
    name
  }
}
    ${OfferedAnimalGroupFragmentFragmentDoc}`;
export const BatchPropertiesFragmentDoc = gql`
    fragment batchProperties on Group {
  id
  name
  targetWeight
  category
  targetDate
  numberOfUnidentifiedAnimalsInBatch
  batchDateOnFarm
  animalBreeds {
    id
    name
    breedrCode
  }
  averageDobInBatch
  isBatch
  gendersInBatch
}
    `;
export const OrganisationFragmentDoc = gql`
    fragment Organisation on Organisation {
  id
  name
}
    `;
export const ProducerGroupFragmentFragmentDoc = gql`
    fragment producerGroupFragment on ProducerGroupType {
  id
  name
  description
  profilePhoto
  backgroundPhoto
  members {
    id
    profilePhoto
    firstName
    lastName
    isAdmin
    status
  }
  isMyGroup
  status
}
    `;
export const RegulatoryTransactionApprovalFragmentFragmentDoc = gql`
    fragment regulatoryTransactionApprovalFragment on RegulatoryTransactionApprovalType {
  id
  reasonOfFailure
  createdAt
  actualStatus
  approvalStatus
  destination {
    regulatoryId
    description
  }
  source {
    regulatoryId
    description
  }
  destinationLocation {
    id
    unitName
    locationId
  }
  sourceActivity {
    date
    animal {
      id
      dob
      visualId
      damPassportNumber
      animalBreeds {
        id
        name
      }
      passportNumber
      isMale
      isCastrated
      sexClassification {
        slug
        title
      }
    }
  }
}
    `;
export const ReportsFragmentFragmentDoc = gql`
    fragment reportsFragment on ReportType {
  id
  businessUnit {
    id
  }
  title
  slug
  applyProducerGroup
  url
  position
  needUpgrade
  group {
    id
    title
    position
  }
  subscriptionPlans {
    id
    name
    price
    description
  }
  species {
    id
  }
  reportType
}
    `;
export const IntegrationSystemFragmentFragmentDoc = gql`
    fragment integrationSystemFragment on IntegrationSystemType {
  id
  name
  logo
  helpLink
  fields {
    id
    fieldLabel
    fieldName
    fieldType
    inputMask
    minLength
    maxLength
    placeholder
  }
  slug
}
    `;
export const FarmSystemFragmentFragmentDoc = gql`
    fragment farmSystemFragment on FarmSystemType {
  id
  errorMessage
  credentials
  status
  integrationSystem {
    ...integrationSystemFragment
  }
  ... on BcmsConnectionType {
    location {
      id
      locationId
      unitName
    }
  }
}
    ${IntegrationSystemFragmentFragmentDoc}`;
export const SireFragmentFragmentDoc = gql`
    fragment sireFragment on Sire {
  id
  name
  passportNumber
  registrationNumber
  pedigree
  sire
}
    `;
export const ErrorFragmentFragmentDoc = gql`
    fragment errorFragment on ValidationError {
  field
  message
}
    `;
export const OwnerFragmentFragmentDoc = gql`
    fragment ownerFragment on UserPublicInfo {
  id
  email
  image
  firstName
  lastName
  businessUnitUserId
}
    `;
export const UserInfoFragmentFragmentDoc = gql`
    fragment UserInfoFragment on User {
  id
  email
  firstName
  lastName
  image
  phone
  lastLogin
  jobTitle
  intercomUserHash
}
    `;
export const BusinessUnitUserFragmentDoc = gql`
    fragment businessUnitUser on BusinessUnitUser {
  id
  role {
    id
    name
  }
  status
  businessUnit {
    id
    name
  }
  user {
    ...UserInfoFragment
  }
  isOwner
}
    ${UserInfoFragmentFragmentDoc}`;
export const PageInfoFragmentDoc = gql`
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
export const DeliveryLocationFragmentDoc = gql`
    fragment DeliveryLocation on DeliveryLocationType {
  details {
    name
    address
    email
    postcode
  }
  address {
    id
    name
  }
  contact {
    id
  }
  partner {
    id
    addresses {
      id
      name
    }
  }
}
    `;
export const DeliveryFragmentDoc = gql`
    fragment Delivery on DeliveryType {
  id
  name
  status
  animalCount
  direction
  sentAt
  arrivedAt
  createdAt
  updatedAt
  animalTypes {
    id
    name
  }
  reason {
    id
    title
  }
  destinationSummary {
    locations {
      ...DeliveryLocation
    }
  }
  sourceSummary {
    locations {
      ...DeliveryLocation
    }
  }
  defaultDestination {
    ...DeliveryLocation
  }
  defaultSource {
    ...DeliveryLocation
  }
}
    ${DeliveryLocationFragmentDoc}`;
export const ConsignmentAnimalFragmentDoc = gql`
    fragment ConsignmentAnimal on Animal {
  id
  passportNumber
  eId
  visualId
  dob
  dateMovedToFarm
  animalBreeds {
    id
    name
  }
  isMale
  sexClassification {
    slug
    title
  }
  lastWeight {
    value
    date
  }
}
    `;
export const ActivityTypeFieldsFragmentDoc = gql`
    fragment ActivityTypeFields on ActivityType {
  id
  image
  imageSvg
  slug
  name
  isPublic
  isSystem
  position
  activityTemplatesCount
}
    `;
export const ContactFragmentFragmentDoc = gql`
    fragment ContactFragment on ContactObjectType {
  id
  contactType
  organisationName
  farmId
  name
  addressLine1
  addressLine2
  postcode
  city
  state
  email
  phoneNumber
  country {
    id
    name
    isoAlpha2
    code
  }
}
    `;
export const PageInfoFragmentFragmentDoc = gql`
    fragment pageInfoFragment on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
export const OfferFragmentFragmentDoc = gql`
    fragment offerFragment on Offer {
  id
  status
  offeredNumber
  actualStatus
  invoice {
    id
    finalPrice
    priceUnit
    currency {
      id
      code
    }
  }
  createdBy {
    id
    email
    phone
    firstName
    lastName
  }
  businessUnit {
    id
    name
    locationData
    city
    primaryLocation {
      id
      postcode
    }
  }
}
    `;
export const OfferedAnimalWantFragmentFragmentDoc = gql`
    fragment offeredAnimalWantFragment on PublicAnimal {
  id
  eId
  visualId
  passportNumber
  isMale
  dob
  currentWeight
  lastWeight {
    value
  }
  animalType {
    id
    slug
  }
  animalBreeds {
    id
    name
  }
  sexClassification {
    slug
    title
  }
}
    `;
export const OfferedAnimalFragmentFragmentDoc = gql`
    fragment offeredAnimalFragment on Animal {
  id
  passportNumber
  isMale
  withdrawalEnd
  isRegulatorySynced
  lastRegulatorySyncedDate
  dob
  eId
  visualId
  dateMovedToFarm
  currentWeight
  lastWeight {
    value
  }
  group {
    id
    name
  }
  animalType {
    id
    slug
  }
  animalBreeds {
    id
    name
  }
  field {
    id
    name
    location {
      id
      unitName
    }
  }
  sexClassification {
    slug
    title
  }
}
    `;
export const WantOfferDetailsDataFragmentFragmentDoc = gql`
    fragment wantOfferDetailsDataFragment on Offer {
  id
  actualStatus
  offeredNumber
  createdBy {
    id
    email
    phone
    firstName
    lastName
  }
  businessUnit {
    id
    name
    locationData
    city
  }
  invoice {
    id
    price
    totalPrice
    finalPrice
    priceUnit
    currency {
      id
      code
    }
  }
  producedLot {
    id
    ... on PublicLot {
      gradingFile
      animalsCount
      animals {
        ...offeredAnimalWantFragment
      }
    }
  }
  producedLotInterface {
    ... on OwnLot {
      id
      deliveredAnimals {
        ...offeredAnimalFragment
      }
      animals {
        ...offeredAnimalFragment
      }
      animalsCount
      gradingFile
    }
  }
}
    ${OfferedAnimalWantFragmentFragmentDoc}
${OfferedAnimalFragmentFragmentDoc}`;
export const DeliveryAddressFragmentFragmentDoc = gql`
    fragment deliveryAddressFragment on DeliveryAddressType {
  id
  unitName
  addressLine1
  addressLine2
  city
  country {
    id
    code
    name
  }
  postcode
  primary
  locationType
  locationId
}
    `;
export const MarkAnimalsAsDeadDocument = gql`
    mutation MarkAnimalsAsDead($input: MarkAnimalsAsDeadInput!) {
  markAnimalsAsDead(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type MarkAnimalsAsDeadMutationFn = Apollo.MutationFunction<MarkAnimalsAsDeadMutation, MarkAnimalsAsDeadMutationVariables>;

/**
 * __useMarkAnimalsAsDeadMutation__
 *
 * To run a mutation, you first call `useMarkAnimalsAsDeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAnimalsAsDeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAnimalsAsDeadMutation, { data, loading, error }] = useMarkAnimalsAsDeadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkAnimalsAsDeadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAnimalsAsDeadMutation, MarkAnimalsAsDeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAnimalsAsDeadMutation, MarkAnimalsAsDeadMutationVariables>(MarkAnimalsAsDeadDocument, options);
      }
export type MarkAnimalsAsDeadMutationHookResult = ReturnType<typeof useMarkAnimalsAsDeadMutation>;
export type MarkAnimalsAsDeadMutationResult = Apollo.MutationResult<MarkAnimalsAsDeadMutation>;
export type MarkAnimalsAsDeadMutationOptions = Apollo.BaseMutationOptions<MarkAnimalsAsDeadMutation, MarkAnimalsAsDeadMutationVariables>;
export const GetAnimalDocument = gql`
    query GetAnimal($id: UUID!) {
  animal(id: $id) {
    id
    passportNumber
    dob
  }
}
    `;

/**
 * __useGetAnimalQuery__
 *
 * To run a query within a React component, call `useGetAnimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAnimalQuery(baseOptions: Apollo.QueryHookOptions<GetAnimalQuery, GetAnimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnimalQuery, GetAnimalQueryVariables>(GetAnimalDocument, options);
      }
export function useGetAnimalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnimalQuery, GetAnimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnimalQuery, GetAnimalQueryVariables>(GetAnimalDocument, options);
        }
export type GetAnimalQueryHookResult = ReturnType<typeof useGetAnimalQuery>;
export type GetAnimalLazyQueryHookResult = ReturnType<typeof useGetAnimalLazyQuery>;
export type GetAnimalQueryResult = Apollo.QueryResult<GetAnimalQuery, GetAnimalQueryVariables>;
export const BreedseekDataDocument = gql`
    query BreedseekData($id: UUID!) {
  breedseek(animal: $id) {
    barcode
    testRef
    orderRef
    akaushi
    angus
    beefmasters
    brangus
    hereford
    holstein
    jersey
    redAngus
    santaGertrudis
    wagyu
    animal {
      id
    }
  }
}
    `;

/**
 * __useBreedseekDataQuery__
 *
 * To run a query within a React component, call `useBreedseekDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBreedseekDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBreedseekDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBreedseekDataQuery(baseOptions: Apollo.QueryHookOptions<BreedseekDataQuery, BreedseekDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BreedseekDataQuery, BreedseekDataQueryVariables>(BreedseekDataDocument, options);
      }
export function useBreedseekDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BreedseekDataQuery, BreedseekDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BreedseekDataQuery, BreedseekDataQueryVariables>(BreedseekDataDocument, options);
        }
export type BreedseekDataQueryHookResult = ReturnType<typeof useBreedseekDataQuery>;
export type BreedseekDataLazyQueryHookResult = ReturnType<typeof useBreedseekDataLazyQuery>;
export type BreedseekDataQueryResult = Apollo.QueryResult<BreedseekDataQuery, BreedseekDataQueryVariables>;
export const AmericanAngusEpdDocument = gql`
    query AmericanAngusEpd($id: UUID!) {
  americanAngusEpd(animal: $id) {
    angusOnHolsteinValue
    angusOnHolsteinValueRank
    angusOnJerseyValue
    angusOnJerseyValueRank
    beefValue
    beefValueRank
    birthWeightAcc
    birthWeightEpd
    birthWeightPct
    calvingEaseAcc
    calvingEaseEpd
    calvingEasePct
    carcassWeightAcc
    carcassWeightEpd
    carcassWeightPct
    clawAcc
    clawEpd
    clawPct
    combinedValue
    combinedValueRank
    cowEnergyValue
    cowEnergyValueRank
    docilityAcc
    docilityEpd
    docilityPct
    dryMatterIntakeAcc
    dryMatterIntakeEpd
    dryMatterIntakePct
    fatAcc
    fatEpd
    fatPct
    feedlotValue
    feedlotValueRank
    gridValue
    gridValueRank
    hairShedAcc
    hairShedEpd
    hairShedPct
    heiferPregnancyAcc
    heiferPregnancyEpd
    heiferPregnancyPct
    hoofAngleAcc
    hoofAngleEpd
    hoofAnglePct
    marblingAcc
    marblingEpd
    marblingPct
    maternalCalfValue
    maternalCalfValueRank
    matureHeightAcc
    matureHeightEpd
    matureHeightPct
    matureWeightAcc
    matureWeightEpd
    matureWeightPct
    milkAcc
    milkEpd
    milkPct
    papAcc
    papEpd
    papPct
    residualAdgAcc
    residualAdgEpd
    residualAdgPct
    ribeyeAreaAcc
    ribeyeAreaEpd
    ribeyeAreaPct
    scrotalCircumferenceAcc
    scrotalCircumferenceEpd
    scrotalCircumferencePct
    weanedCalfValue
    weanedCalfValueRank
    weaningWeightAcc
    weaningWeightEpd
    weaningWeightPct
    yearlingHeightAcc
    yearlingHeightEpd
    yearlingHeightPct
    yearlingWeightAcc
    yearlingWeightEpd
    yearlingWeightPct
  }
}
    `;

/**
 * __useAmericanAngusEpdQuery__
 *
 * To run a query within a React component, call `useAmericanAngusEpdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmericanAngusEpdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmericanAngusEpdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAmericanAngusEpdQuery(baseOptions: Apollo.QueryHookOptions<AmericanAngusEpdQuery, AmericanAngusEpdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmericanAngusEpdQuery, AmericanAngusEpdQueryVariables>(AmericanAngusEpdDocument, options);
      }
export function useAmericanAngusEpdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmericanAngusEpdQuery, AmericanAngusEpdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmericanAngusEpdQuery, AmericanAngusEpdQueryVariables>(AmericanAngusEpdDocument, options);
        }
export type AmericanAngusEpdQueryHookResult = ReturnType<typeof useAmericanAngusEpdQuery>;
export type AmericanAngusEpdLazyQueryHookResult = ReturnType<typeof useAmericanAngusEpdLazyQuery>;
export type AmericanAngusEpdQueryResult = Apollo.QueryResult<AmericanAngusEpdQuery, AmericanAngusEpdQueryVariables>;
export const NeogenEpdDocument = gql`
    query NeogenEpd($id: UUID!) {
  neogenEpd(animal: $id) {
    averageDailyGainAcc
    averageDailyGainEpd
    averageDailyGainPct
    birthWeightAcc
    birthWeightEpd
    birthWeightPct
    fatAcc
    fatEpd
    fatPct
    fx
    hotCarcassWeightAcc
    hotCarcassWeightEpd
    hotCarcassWeightPct
    marblingAcc
    marblingEpd
    marblingPct
    milkAcc
    milkEpd
    milkPct
    residualFeedIntakeAcc
    residualFeedIntakeEpd
    residualFeedIntakePct
    ribeyeAreaAcc
    ribeyeAreaEpd
    ribeyeAreaPct
    totalIndex
    weaningWeightAcc
    weaningWeightEpd
    weaningWeightPct
  }
}
    `;

/**
 * __useNeogenEpdQuery__
 *
 * To run a query within a React component, call `useNeogenEpdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNeogenEpdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNeogenEpdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNeogenEpdQuery(baseOptions: Apollo.QueryHookOptions<NeogenEpdQuery, NeogenEpdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NeogenEpdQuery, NeogenEpdQueryVariables>(NeogenEpdDocument, options);
      }
export function useNeogenEpdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NeogenEpdQuery, NeogenEpdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NeogenEpdQuery, NeogenEpdQueryVariables>(NeogenEpdDocument, options);
        }
export type NeogenEpdQueryHookResult = ReturnType<typeof useNeogenEpdQuery>;
export type NeogenEpdLazyQueryHookResult = ReturnType<typeof useNeogenEpdLazyQuery>;
export type NeogenEpdQueryResult = Apollo.QueryResult<NeogenEpdQuery, NeogenEpdQueryVariables>;
export const GetAnimalsDocument = gql`
    query GetAnimals($businessUnitId: Int!, $animalIds: [ID!]) {
  animals(businessUnitId: $businessUnitId, animalIds: $animalIds) {
    count
    edges {
      node {
        id
        passportNumber
        dob
        isDead
        lot {
          id
          isExpired
        }
      }
    }
  }
}
    `;

/**
 * __useGetAnimalsQuery__
 *
 * To run a query within a React component, call `useGetAnimalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalsQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *      animalIds: // value for 'animalIds'
 *   },
 * });
 */
export function useGetAnimalsQuery(baseOptions: Apollo.QueryHookOptions<GetAnimalsQuery, GetAnimalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnimalsQuery, GetAnimalsQueryVariables>(GetAnimalsDocument, options);
      }
export function useGetAnimalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnimalsQuery, GetAnimalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnimalsQuery, GetAnimalsQueryVariables>(GetAnimalsDocument, options);
        }
export type GetAnimalsQueryHookResult = ReturnType<typeof useGetAnimalsQuery>;
export type GetAnimalsLazyQueryHookResult = ReturnType<typeof useGetAnimalsLazyQuery>;
export type GetAnimalsQueryResult = Apollo.QueryResult<GetAnimalsQuery, GetAnimalsQueryVariables>;
export const GetAnimalsPageDocument = gql`
    query GetAnimalsPage($businessUnitId: Int!, $animalIds: [ID!], $animalTypeIds: [Int!], $animalTags: [ID!], $search: String, $searchIds: [IdentifierType!], $group: UUID, $field: UUID, $isMale: Boolean, $isPregnant: Boolean, $minUpdated: DateTime, $minDob: DateTime, $maxDob: DateTime, $minDof: DateTime, $maxDof: DateTime, $orderBy: [AnimalSorting!], $status: AnimalStatus, $before: String, $after: String, $first: Int, $last: Int, $breed: ID) {
  animals(
    businessUnitId: $businessUnitId
    status: $status
    minUpdated: $minUpdated
    orderBy: $orderBy
    search: $search
    searchIds: $searchIds
    animalTypeIds: $animalTypeIds
    animalIds: $animalIds
    animalTags: $animalTags
    field: $field
    group: $group
    isMale: $isMale
    isPregnant: $isPregnant
    breed: $breed
    minDob: $minDob
    maxDob: $maxDob
    minDof: $minDof
    maxDof: $maxDof
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    count
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        ...animal
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${AnimalFragmentDoc}`;

/**
 * __useGetAnimalsPageQuery__
 *
 * To run a query within a React component, call `useGetAnimalsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalsPageQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *      animalIds: // value for 'animalIds'
 *      animalTypeIds: // value for 'animalTypeIds'
 *      animalTags: // value for 'animalTags'
 *      search: // value for 'search'
 *      searchIds: // value for 'searchIds'
 *      group: // value for 'group'
 *      field: // value for 'field'
 *      isMale: // value for 'isMale'
 *      isPregnant: // value for 'isPregnant'
 *      minUpdated: // value for 'minUpdated'
 *      minDob: // value for 'minDob'
 *      maxDob: // value for 'maxDob'
 *      minDof: // value for 'minDof'
 *      maxDof: // value for 'maxDof'
 *      orderBy: // value for 'orderBy'
 *      status: // value for 'status'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      breed: // value for 'breed'
 *   },
 * });
 */
export function useGetAnimalsPageQuery(baseOptions: Apollo.QueryHookOptions<GetAnimalsPageQuery, GetAnimalsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnimalsPageQuery, GetAnimalsPageQueryVariables>(GetAnimalsPageDocument, options);
      }
export function useGetAnimalsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnimalsPageQuery, GetAnimalsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnimalsPageQuery, GetAnimalsPageQueryVariables>(GetAnimalsPageDocument, options);
        }
export type GetAnimalsPageQueryHookResult = ReturnType<typeof useGetAnimalsPageQuery>;
export type GetAnimalsPageLazyQueryHookResult = ReturnType<typeof useGetAnimalsPageLazyQuery>;
export type GetAnimalsPageQueryResult = Apollo.QueryResult<GetAnimalsPageQuery, GetAnimalsPageQueryVariables>;
export const GetExportResultDocument = gql`
    query GetExportResult($id: ID!) {
  exportResult(exportId: $id) {
    isReady
    url
  }
}
    `;

/**
 * __useGetExportResultQuery__
 *
 * To run a query within a React component, call `useGetExportResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExportResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExportResultQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExportResultQuery(baseOptions: Apollo.QueryHookOptions<GetExportResultQuery, GetExportResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExportResultQuery, GetExportResultQueryVariables>(GetExportResultDocument, options);
      }
export function useGetExportResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExportResultQuery, GetExportResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExportResultQuery, GetExportResultQueryVariables>(GetExportResultDocument, options);
        }
export type GetExportResultQueryHookResult = ReturnType<typeof useGetExportResultQuery>;
export type GetExportResultLazyQueryHookResult = ReturnType<typeof useGetExportResultLazyQuery>;
export type GetExportResultQueryResult = Apollo.QueryResult<GetExportResultQuery, GetExportResultQueryVariables>;
export const ExportAnimalsAsyncDocument = gql`
    mutation ExportAnimalsAsync($input: ExportAnimalsAsyncInput!) {
  exportAnimalsAsync(input: $input) {
    export {
      id
    }
    errors {
      code
      message
    }
  }
}
    `;
export type ExportAnimalsAsyncMutationFn = Apollo.MutationFunction<ExportAnimalsAsyncMutation, ExportAnimalsAsyncMutationVariables>;

/**
 * __useExportAnimalsAsyncMutation__
 *
 * To run a mutation, you first call `useExportAnimalsAsyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAnimalsAsyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAnimalsAsyncMutation, { data, loading, error }] = useExportAnimalsAsyncMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportAnimalsAsyncMutation(baseOptions?: Apollo.MutationHookOptions<ExportAnimalsAsyncMutation, ExportAnimalsAsyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportAnimalsAsyncMutation, ExportAnimalsAsyncMutationVariables>(ExportAnimalsAsyncDocument, options);
      }
export type ExportAnimalsAsyncMutationHookResult = ReturnType<typeof useExportAnimalsAsyncMutation>;
export type ExportAnimalsAsyncMutationResult = Apollo.MutationResult<ExportAnimalsAsyncMutation>;
export type ExportAnimalsAsyncMutationOptions = Apollo.BaseMutationOptions<ExportAnimalsAsyncMutation, ExportAnimalsAsyncMutationVariables>;
export const AnimalsExportAsyncDocument = gql`
    mutation AnimalsExportAsync($input: AnimalsExportAsyncInput!) {
  animalsExportAsync(input: $input) {
    export {
      id
      isReady
      url
    }
  }
}
    `;
export type AnimalsExportAsyncMutationFn = Apollo.MutationFunction<AnimalsExportAsyncMutation, AnimalsExportAsyncMutationVariables>;

/**
 * __useAnimalsExportAsyncMutation__
 *
 * To run a mutation, you first call `useAnimalsExportAsyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnimalsExportAsyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [animalsExportAsyncMutation, { data, loading, error }] = useAnimalsExportAsyncMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnimalsExportAsyncMutation(baseOptions?: Apollo.MutationHookOptions<AnimalsExportAsyncMutation, AnimalsExportAsyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnimalsExportAsyncMutation, AnimalsExportAsyncMutationVariables>(AnimalsExportAsyncDocument, options);
      }
export type AnimalsExportAsyncMutationHookResult = ReturnType<typeof useAnimalsExportAsyncMutation>;
export type AnimalsExportAsyncMutationResult = Apollo.MutationResult<AnimalsExportAsyncMutation>;
export type AnimalsExportAsyncMutationOptions = Apollo.BaseMutationOptions<AnimalsExportAsyncMutation, AnimalsExportAsyncMutationVariables>;
export const DamAnimalsDocument = gql`
    query DamAnimals($businessUnit: Int!, $animalIds: [ID!], $isMale: Boolean, $orderBy: [AnimalSorting!], $animalTypeIds: [Int!], $search: String, $first: Int) {
  animals(
    businessUnitId: $businessUnit
    animalIds: $animalIds
    isMale: $isMale
    orderBy: $orderBy
    animalTypeIds: $animalTypeIds
    search: $search
    first: $first
  ) {
    edges {
      node {
        id
        passportNumber
        eId
      }
    }
  }
}
    `;

/**
 * __useDamAnimalsQuery__
 *
 * To run a query within a React component, call `useDamAnimalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDamAnimalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDamAnimalsQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *      animalIds: // value for 'animalIds'
 *      isMale: // value for 'isMale'
 *      orderBy: // value for 'orderBy'
 *      animalTypeIds: // value for 'animalTypeIds'
 *      search: // value for 'search'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useDamAnimalsQuery(baseOptions: Apollo.QueryHookOptions<DamAnimalsQuery, DamAnimalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DamAnimalsQuery, DamAnimalsQueryVariables>(DamAnimalsDocument, options);
      }
export function useDamAnimalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DamAnimalsQuery, DamAnimalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DamAnimalsQuery, DamAnimalsQueryVariables>(DamAnimalsDocument, options);
        }
export type DamAnimalsQueryHookResult = ReturnType<typeof useDamAnimalsQuery>;
export type DamAnimalsLazyQueryHookResult = ReturnType<typeof useDamAnimalsLazyQuery>;
export type DamAnimalsQueryResult = Apollo.QueryResult<DamAnimalsQuery, DamAnimalsQueryVariables>;
export const SiresDocument = gql`
    query Sires($businessUnitId: Int!) {
  sires(businessUnitId: $businessUnitId) {
    id
    name
    passportNumber
  }
}
    `;

/**
 * __useSiresQuery__
 *
 * To run a query within a React component, call `useSiresQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiresQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useSiresQuery(baseOptions: Apollo.QueryHookOptions<SiresQuery, SiresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiresQuery, SiresQueryVariables>(SiresDocument, options);
      }
export function useSiresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiresQuery, SiresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiresQuery, SiresQueryVariables>(SiresDocument, options);
        }
export type SiresQueryHookResult = ReturnType<typeof useSiresQuery>;
export type SiresLazyQueryHookResult = ReturnType<typeof useSiresLazyQuery>;
export type SiresQueryResult = Apollo.QueryResult<SiresQuery, SiresQueryVariables>;
export const AnimalConditionsDocument = gql`
    query AnimalConditions($businessUnit: Int!) {
  animalConditions(businessUnit: $businessUnit) {
    id
    slug
    title
  }
}
    `;

/**
 * __useAnimalConditionsQuery__
 *
 * To run a query within a React component, call `useAnimalConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnimalConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnimalConditionsQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useAnimalConditionsQuery(baseOptions: Apollo.QueryHookOptions<AnimalConditionsQuery, AnimalConditionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnimalConditionsQuery, AnimalConditionsQueryVariables>(AnimalConditionsDocument, options);
      }
export function useAnimalConditionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnimalConditionsQuery, AnimalConditionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnimalConditionsQuery, AnimalConditionsQueryVariables>(AnimalConditionsDocument, options);
        }
export type AnimalConditionsQueryHookResult = ReturnType<typeof useAnimalConditionsQuery>;
export type AnimalConditionsLazyQueryHookResult = ReturnType<typeof useAnimalConditionsLazyQuery>;
export type AnimalConditionsQueryResult = Apollo.QueryResult<AnimalConditionsQuery, AnimalConditionsQueryVariables>;
export const GetFamilyTreeDocument = gql`
    query GetFamilyTree($animalID: UUID!, $depth: Int!) {
  ancestorTree(animalId: $animalID, depth: $depth) {
    ancestorIdentifier
    depth
    animalData {
      id
      isMale
      isDead
      dateLeftFarm
      deadAt
      passportNumber
      pedigreeId
      eId
      visualId
      brucellosisId
      tattoo
      tsuBarcode
      pedigreeId
      trichId
      herdDoggId
      name
      breedrId
      uhfId
      alternativeId
      sirePassportNumber
      damPassportNumber
    }
  }
}
    `;

/**
 * __useGetFamilyTreeQuery__
 *
 * To run a query within a React component, call `useGetFamilyTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFamilyTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFamilyTreeQuery({
 *   variables: {
 *      animalID: // value for 'animalID'
 *      depth: // value for 'depth'
 *   },
 * });
 */
export function useGetFamilyTreeQuery(baseOptions: Apollo.QueryHookOptions<GetFamilyTreeQuery, GetFamilyTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFamilyTreeQuery, GetFamilyTreeQueryVariables>(GetFamilyTreeDocument, options);
      }
export function useGetFamilyTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFamilyTreeQuery, GetFamilyTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFamilyTreeQuery, GetFamilyTreeQueryVariables>(GetFamilyTreeDocument, options);
        }
export type GetFamilyTreeQueryHookResult = ReturnType<typeof useGetFamilyTreeQuery>;
export type GetFamilyTreeLazyQueryHookResult = ReturnType<typeof useGetFamilyTreeLazyQuery>;
export type GetFamilyTreeQueryResult = Apollo.QueryResult<GetFamilyTreeQuery, GetFamilyTreeQueryVariables>;
export const SignUpDocument = gql`
    mutation SignUp($input: SignUpInput!) {
  signUp(input: $input) {
    success
    clientMutationId
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const UserExistsDocument = gql`
    query UserExists($email: String!) {
  userExists(email: $email)
}
    `;

/**
 * __useUserExistsQuery__
 *
 * To run a query within a React component, call `useUserExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserExistsQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserExistsQuery(baseOptions: Apollo.QueryHookOptions<UserExistsQuery, UserExistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserExistsQuery, UserExistsQueryVariables>(UserExistsDocument, options);
      }
export function useUserExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserExistsQuery, UserExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserExistsQuery, UserExistsQueryVariables>(UserExistsDocument, options);
        }
export type UserExistsQueryHookResult = ReturnType<typeof useUserExistsQuery>;
export type UserExistsLazyQueryHookResult = ReturnType<typeof useUserExistsLazyQuery>;
export type UserExistsQueryResult = Apollo.QueryResult<UserExistsQuery, UserExistsQueryVariables>;
export const GetBlockchainAnimalDataByPassportDocument = gql`
    query GetBlockchainAnimalDataByPassport($passportNumber: String!) {
  blockchainAnimalDataByPassport(passportNumber: $passportNumber) {
    ...blockchainAnimalFragment
  }
}
    ${BlockchainAnimalFragmentFragmentDoc}`;

/**
 * __useGetBlockchainAnimalDataByPassportQuery__
 *
 * To run a query within a React component, call `useGetBlockchainAnimalDataByPassportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockchainAnimalDataByPassportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockchainAnimalDataByPassportQuery({
 *   variables: {
 *      passportNumber: // value for 'passportNumber'
 *   },
 * });
 */
export function useGetBlockchainAnimalDataByPassportQuery(baseOptions: Apollo.QueryHookOptions<GetBlockchainAnimalDataByPassportQuery, GetBlockchainAnimalDataByPassportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlockchainAnimalDataByPassportQuery, GetBlockchainAnimalDataByPassportQueryVariables>(GetBlockchainAnimalDataByPassportDocument, options);
      }
export function useGetBlockchainAnimalDataByPassportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlockchainAnimalDataByPassportQuery, GetBlockchainAnimalDataByPassportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlockchainAnimalDataByPassportQuery, GetBlockchainAnimalDataByPassportQueryVariables>(GetBlockchainAnimalDataByPassportDocument, options);
        }
export type GetBlockchainAnimalDataByPassportQueryHookResult = ReturnType<typeof useGetBlockchainAnimalDataByPassportQuery>;
export type GetBlockchainAnimalDataByPassportLazyQueryHookResult = ReturnType<typeof useGetBlockchainAnimalDataByPassportLazyQuery>;
export type GetBlockchainAnimalDataByPassportQueryResult = Apollo.QueryResult<GetBlockchainAnimalDataByPassportQuery, GetBlockchainAnimalDataByPassportQueryVariables>;
export const GetBlockchainAnimalDataByKillNumberDocument = gql`
    query GetBlockchainAnimalDataByKillNumber($killNumber: String!, $date: Date!) {
  blockchainAnimalDataByKillNumber(killNumber: $killNumber, date: $date) {
    ...blockchainAnimalFragment
  }
}
    ${BlockchainAnimalFragmentFragmentDoc}`;

/**
 * __useGetBlockchainAnimalDataByKillNumberQuery__
 *
 * To run a query within a React component, call `useGetBlockchainAnimalDataByKillNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockchainAnimalDataByKillNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockchainAnimalDataByKillNumberQuery({
 *   variables: {
 *      killNumber: // value for 'killNumber'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetBlockchainAnimalDataByKillNumberQuery(baseOptions: Apollo.QueryHookOptions<GetBlockchainAnimalDataByKillNumberQuery, GetBlockchainAnimalDataByKillNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlockchainAnimalDataByKillNumberQuery, GetBlockchainAnimalDataByKillNumberQueryVariables>(GetBlockchainAnimalDataByKillNumberDocument, options);
      }
export function useGetBlockchainAnimalDataByKillNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlockchainAnimalDataByKillNumberQuery, GetBlockchainAnimalDataByKillNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlockchainAnimalDataByKillNumberQuery, GetBlockchainAnimalDataByKillNumberQueryVariables>(GetBlockchainAnimalDataByKillNumberDocument, options);
        }
export type GetBlockchainAnimalDataByKillNumberQueryHookResult = ReturnType<typeof useGetBlockchainAnimalDataByKillNumberQuery>;
export type GetBlockchainAnimalDataByKillNumberLazyQueryHookResult = ReturnType<typeof useGetBlockchainAnimalDataByKillNumberLazyQuery>;
export type GetBlockchainAnimalDataByKillNumberQueryResult = Apollo.QueryResult<GetBlockchainAnimalDataByKillNumberQuery, GetBlockchainAnimalDataByKillNumberQueryVariables>;
export const GetBreedrBankDetailsDocument = gql`
    query GetBreedrBankDetails {
  breedrBankDetails {
    accountNo
    accountName
    sortCode
  }
}
    `;

/**
 * __useGetBreedrBankDetailsQuery__
 *
 * To run a query within a React component, call `useGetBreedrBankDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBreedrBankDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBreedrBankDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBreedrBankDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetBreedrBankDetailsQuery, GetBreedrBankDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBreedrBankDetailsQuery, GetBreedrBankDetailsQueryVariables>(GetBreedrBankDetailsDocument, options);
      }
export function useGetBreedrBankDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBreedrBankDetailsQuery, GetBreedrBankDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBreedrBankDetailsQuery, GetBreedrBankDetailsQueryVariables>(GetBreedrBankDetailsDocument, options);
        }
export type GetBreedrBankDetailsQueryHookResult = ReturnType<typeof useGetBreedrBankDetailsQuery>;
export type GetBreedrBankDetailsLazyQueryHookResult = ReturnType<typeof useGetBreedrBankDetailsLazyQuery>;
export type GetBreedrBankDetailsQueryResult = Apollo.QueryResult<GetBreedrBankDetailsQuery, GetBreedrBankDetailsQueryVariables>;
export const CreatePreferredSuppliersDocument = gql`
    mutation CreatePreferredSuppliers($input: CreatePreferredSuppliersInput!) {
  createPreferredSuppliers(input: $input) {
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type CreatePreferredSuppliersMutationFn = Apollo.MutationFunction<CreatePreferredSuppliersMutation, CreatePreferredSuppliersMutationVariables>;

/**
 * __useCreatePreferredSuppliersMutation__
 *
 * To run a mutation, you first call `useCreatePreferredSuppliersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePreferredSuppliersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPreferredSuppliersMutation, { data, loading, error }] = useCreatePreferredSuppliersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePreferredSuppliersMutation(baseOptions?: Apollo.MutationHookOptions<CreatePreferredSuppliersMutation, CreatePreferredSuppliersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePreferredSuppliersMutation, CreatePreferredSuppliersMutationVariables>(CreatePreferredSuppliersDocument, options);
      }
export type CreatePreferredSuppliersMutationHookResult = ReturnType<typeof useCreatePreferredSuppliersMutation>;
export type CreatePreferredSuppliersMutationResult = Apollo.MutationResult<CreatePreferredSuppliersMutation>;
export type CreatePreferredSuppliersMutationOptions = Apollo.BaseMutationOptions<CreatePreferredSuppliersMutation, CreatePreferredSuppliersMutationVariables>;
export const UpdatePreferredBusinessUnitStatusDocument = gql`
    mutation UpdatePreferredBusinessUnitStatus($input: UpdatePreferredBusinessUnitStatusInput!) {
  updatePreferredBusinessUnitStatus(input: $input) {
    preferredBusinessUnit {
      id
      supplier {
        id
      }
      commonStatus
    }
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type UpdatePreferredBusinessUnitStatusMutationFn = Apollo.MutationFunction<UpdatePreferredBusinessUnitStatusMutation, UpdatePreferredBusinessUnitStatusMutationVariables>;

/**
 * __useUpdatePreferredBusinessUnitStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePreferredBusinessUnitStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreferredBusinessUnitStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreferredBusinessUnitStatusMutation, { data, loading, error }] = useUpdatePreferredBusinessUnitStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePreferredBusinessUnitStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePreferredBusinessUnitStatusMutation, UpdatePreferredBusinessUnitStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePreferredBusinessUnitStatusMutation, UpdatePreferredBusinessUnitStatusMutationVariables>(UpdatePreferredBusinessUnitStatusDocument, options);
      }
export type UpdatePreferredBusinessUnitStatusMutationHookResult = ReturnType<typeof useUpdatePreferredBusinessUnitStatusMutation>;
export type UpdatePreferredBusinessUnitStatusMutationResult = Apollo.MutationResult<UpdatePreferredBusinessUnitStatusMutation>;
export type UpdatePreferredBusinessUnitStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePreferredBusinessUnitStatusMutation, UpdatePreferredBusinessUnitStatusMutationVariables>;
export const UpdatePreferredBusinessUnitDocument = gql`
    mutation UpdatePreferredBusinessUnit($input: UpdatePreferredBusinessUnitInput!) {
  updatePreferredBusinessUnit(input: $input) {
    preferredBusinessUnit {
      id
    }
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type UpdatePreferredBusinessUnitMutationFn = Apollo.MutationFunction<UpdatePreferredBusinessUnitMutation, UpdatePreferredBusinessUnitMutationVariables>;

/**
 * __useUpdatePreferredBusinessUnitMutation__
 *
 * To run a mutation, you first call `useUpdatePreferredBusinessUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreferredBusinessUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreferredBusinessUnitMutation, { data, loading, error }] = useUpdatePreferredBusinessUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePreferredBusinessUnitMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePreferredBusinessUnitMutation, UpdatePreferredBusinessUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePreferredBusinessUnitMutation, UpdatePreferredBusinessUnitMutationVariables>(UpdatePreferredBusinessUnitDocument, options);
      }
export type UpdatePreferredBusinessUnitMutationHookResult = ReturnType<typeof useUpdatePreferredBusinessUnitMutation>;
export type UpdatePreferredBusinessUnitMutationResult = Apollo.MutationResult<UpdatePreferredBusinessUnitMutation>;
export type UpdatePreferredBusinessUnitMutationOptions = Apollo.BaseMutationOptions<UpdatePreferredBusinessUnitMutation, UpdatePreferredBusinessUnitMutationVariables>;
export const UpdateBusinessUnitSettingsDocument = gql`
    mutation UpdateBusinessUnitSettings($input: UpdateBusinessUnitSettingsInput!) {
  updateBusinessUnitSettings(input: $input) {
    enableBcmsPushTransactions
    killOut
    tbStatus
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type UpdateBusinessUnitSettingsMutationFn = Apollo.MutationFunction<UpdateBusinessUnitSettingsMutation, UpdateBusinessUnitSettingsMutationVariables>;

/**
 * __useUpdateBusinessUnitSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessUnitSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessUnitSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessUnitSettingsMutation, { data, loading, error }] = useUpdateBusinessUnitSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBusinessUnitSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessUnitSettingsMutation, UpdateBusinessUnitSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessUnitSettingsMutation, UpdateBusinessUnitSettingsMutationVariables>(UpdateBusinessUnitSettingsDocument, options);
      }
export type UpdateBusinessUnitSettingsMutationHookResult = ReturnType<typeof useUpdateBusinessUnitSettingsMutation>;
export type UpdateBusinessUnitSettingsMutationResult = Apollo.MutationResult<UpdateBusinessUnitSettingsMutation>;
export type UpdateBusinessUnitSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessUnitSettingsMutation, UpdateBusinessUnitSettingsMutationVariables>;
export const TermsAndConditionsAcceptDocument = gql`
    mutation TermsAndConditionsAccept($input: TermsAndConditionsAcceptInput!) {
  termsAndConditionsAccept(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type TermsAndConditionsAcceptMutationFn = Apollo.MutationFunction<TermsAndConditionsAcceptMutation, TermsAndConditionsAcceptMutationVariables>;

/**
 * __useTermsAndConditionsAcceptMutation__
 *
 * To run a mutation, you first call `useTermsAndConditionsAcceptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTermsAndConditionsAcceptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [termsAndConditionsAcceptMutation, { data, loading, error }] = useTermsAndConditionsAcceptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTermsAndConditionsAcceptMutation(baseOptions?: Apollo.MutationHookOptions<TermsAndConditionsAcceptMutation, TermsAndConditionsAcceptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TermsAndConditionsAcceptMutation, TermsAndConditionsAcceptMutationVariables>(TermsAndConditionsAcceptDocument, options);
      }
export type TermsAndConditionsAcceptMutationHookResult = ReturnType<typeof useTermsAndConditionsAcceptMutation>;
export type TermsAndConditionsAcceptMutationResult = Apollo.MutationResult<TermsAndConditionsAcceptMutation>;
export type TermsAndConditionsAcceptMutationOptions = Apollo.BaseMutationOptions<TermsAndConditionsAcceptMutation, TermsAndConditionsAcceptMutationVariables>;
export const GetBusinessUnitsDocument = gql`
    query GetBusinessUnits {
  businessUnits {
    ...BUFragment
  }
}
    ${BuFragmentFragmentDoc}`;

/**
 * __useGetBusinessUnitsQuery__
 *
 * To run a query within a React component, call `useGetBusinessUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBusinessUnitsQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessUnitsQuery, GetBusinessUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessUnitsQuery, GetBusinessUnitsQueryVariables>(GetBusinessUnitsDocument, options);
      }
export function useGetBusinessUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessUnitsQuery, GetBusinessUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessUnitsQuery, GetBusinessUnitsQueryVariables>(GetBusinessUnitsDocument, options);
        }
export type GetBusinessUnitsQueryHookResult = ReturnType<typeof useGetBusinessUnitsQuery>;
export type GetBusinessUnitsLazyQueryHookResult = ReturnType<typeof useGetBusinessUnitsLazyQuery>;
export type GetBusinessUnitsQueryResult = Apollo.QueryResult<GetBusinessUnitsQuery, GetBusinessUnitsQueryVariables>;
export const GetStrippedBusinessUnitsDocument = gql`
    query GetStrippedBusinessUnits {
  businessUnits {
    ...BUStripped
  }
}
    ${BuStrippedFragmentDoc}`;

/**
 * __useGetStrippedBusinessUnitsQuery__
 *
 * To run a query within a React component, call `useGetStrippedBusinessUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStrippedBusinessUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStrippedBusinessUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStrippedBusinessUnitsQuery(baseOptions?: Apollo.QueryHookOptions<GetStrippedBusinessUnitsQuery, GetStrippedBusinessUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStrippedBusinessUnitsQuery, GetStrippedBusinessUnitsQueryVariables>(GetStrippedBusinessUnitsDocument, options);
      }
export function useGetStrippedBusinessUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStrippedBusinessUnitsQuery, GetStrippedBusinessUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStrippedBusinessUnitsQuery, GetStrippedBusinessUnitsQueryVariables>(GetStrippedBusinessUnitsDocument, options);
        }
export type GetStrippedBusinessUnitsQueryHookResult = ReturnType<typeof useGetStrippedBusinessUnitsQuery>;
export type GetStrippedBusinessUnitsLazyQueryHookResult = ReturnType<typeof useGetStrippedBusinessUnitsLazyQuery>;
export type GetStrippedBusinessUnitsQueryResult = Apollo.QueryResult<GetStrippedBusinessUnitsQuery, GetStrippedBusinessUnitsQueryVariables>;
export const GetBusinessUnitDocument = gql`
    query GetBusinessUnit($businessUnit: Int!) {
  businessUnit(businessUnit: $businessUnit) {
    ...BUFragment
  }
}
    ${BuFragmentFragmentDoc}`;

/**
 * __useGetBusinessUnitQuery__
 *
 * To run a query within a React component, call `useGetBusinessUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessUnitQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useGetBusinessUnitQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessUnitQuery, GetBusinessUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessUnitQuery, GetBusinessUnitQueryVariables>(GetBusinessUnitDocument, options);
      }
export function useGetBusinessUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessUnitQuery, GetBusinessUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessUnitQuery, GetBusinessUnitQueryVariables>(GetBusinessUnitDocument, options);
        }
export type GetBusinessUnitQueryHookResult = ReturnType<typeof useGetBusinessUnitQuery>;
export type GetBusinessUnitLazyQueryHookResult = ReturnType<typeof useGetBusinessUnitLazyQuery>;
export type GetBusinessUnitQueryResult = Apollo.QueryResult<GetBusinessUnitQuery, GetBusinessUnitQueryVariables>;
export const GetBusinessUnitUsersDocument = gql`
    query GetBusinessUnitUsers($businessUnitId: Int) {
  businessUnitUsers(businessUnitId: $businessUnitId) {
    ...businessUnitUser
  }
}
    ${BusinessUnitUserFragmentDoc}`;

/**
 * __useGetBusinessUnitUsersQuery__
 *
 * To run a query within a React component, call `useGetBusinessUnitUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessUnitUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessUnitUsersQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useGetBusinessUnitUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessUnitUsersQuery, GetBusinessUnitUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessUnitUsersQuery, GetBusinessUnitUsersQueryVariables>(GetBusinessUnitUsersDocument, options);
      }
export function useGetBusinessUnitUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessUnitUsersQuery, GetBusinessUnitUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessUnitUsersQuery, GetBusinessUnitUsersQueryVariables>(GetBusinessUnitUsersDocument, options);
        }
export type GetBusinessUnitUsersQueryHookResult = ReturnType<typeof useGetBusinessUnitUsersQuery>;
export type GetBusinessUnitUsersLazyQueryHookResult = ReturnType<typeof useGetBusinessUnitUsersLazyQuery>;
export type GetBusinessUnitUsersQueryResult = Apollo.QueryResult<GetBusinessUnitUsersQuery, GetBusinessUnitUsersQueryVariables>;
export const GetBusinessUnitSettingsDocument = gql`
    query GetBusinessUnitSettings($businessUnit: Int!) {
  businessUnit(businessUnit: $businessUnit) {
    id
    killOut
    enableBcmsPushTransactions
    tbStatus
    dateJoined
  }
}
    `;

/**
 * __useGetBusinessUnitSettingsQuery__
 *
 * To run a query within a React component, call `useGetBusinessUnitSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessUnitSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessUnitSettingsQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useGetBusinessUnitSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessUnitSettingsQuery, GetBusinessUnitSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessUnitSettingsQuery, GetBusinessUnitSettingsQueryVariables>(GetBusinessUnitSettingsDocument, options);
      }
export function useGetBusinessUnitSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessUnitSettingsQuery, GetBusinessUnitSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessUnitSettingsQuery, GetBusinessUnitSettingsQueryVariables>(GetBusinessUnitSettingsDocument, options);
        }
export type GetBusinessUnitSettingsQueryHookResult = ReturnType<typeof useGetBusinessUnitSettingsQuery>;
export type GetBusinessUnitSettingsLazyQueryHookResult = ReturnType<typeof useGetBusinessUnitSettingsLazyQuery>;
export type GetBusinessUnitSettingsQueryResult = Apollo.QueryResult<GetBusinessUnitSettingsQuery, GetBusinessUnitSettingsQueryVariables>;
export const GetBusinessUnitSizeUnitDocument = gql`
    query GetBusinessUnitSizeUnit($businessUnit: Int!) {
  businessUnit(businessUnit: $businessUnit) {
    id
    settings {
      sizeUnit
    }
  }
}
    `;

/**
 * __useGetBusinessUnitSizeUnitQuery__
 *
 * To run a query within a React component, call `useGetBusinessUnitSizeUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessUnitSizeUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessUnitSizeUnitQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useGetBusinessUnitSizeUnitQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessUnitSizeUnitQuery, GetBusinessUnitSizeUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessUnitSizeUnitQuery, GetBusinessUnitSizeUnitQueryVariables>(GetBusinessUnitSizeUnitDocument, options);
      }
export function useGetBusinessUnitSizeUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessUnitSizeUnitQuery, GetBusinessUnitSizeUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessUnitSizeUnitQuery, GetBusinessUnitSizeUnitQueryVariables>(GetBusinessUnitSizeUnitDocument, options);
        }
export type GetBusinessUnitSizeUnitQueryHookResult = ReturnType<typeof useGetBusinessUnitSizeUnitQuery>;
export type GetBusinessUnitSizeUnitLazyQueryHookResult = ReturnType<typeof useGetBusinessUnitSizeUnitLazyQuery>;
export type GetBusinessUnitSizeUnitQueryResult = Apollo.QueryResult<GetBusinessUnitSizeUnitQuery, GetBusinessUnitSizeUnitQueryVariables>;
export const SearchBusinessUnitsDocument = gql`
    query SearchBusinessUnits($query: String, $roles: [String], $excludeBusinessUnitId: Int, $preferredSuppliersBuyerId: Int) {
  searchBusinessUnits(
    query: $query
    roles: $roles
    excludeBusinessUnitId: $excludeBusinessUnitId
    preferredSuppliersBuyerId: $preferredSuppliersBuyerId
  ) {
    id
    name
    location {
      city
      unitName
    }
  }
}
    `;

/**
 * __useSearchBusinessUnitsQuery__
 *
 * To run a query within a React component, call `useSearchBusinessUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBusinessUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBusinessUnitsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      roles: // value for 'roles'
 *      excludeBusinessUnitId: // value for 'excludeBusinessUnitId'
 *      preferredSuppliersBuyerId: // value for 'preferredSuppliersBuyerId'
 *   },
 * });
 */
export function useSearchBusinessUnitsQuery(baseOptions?: Apollo.QueryHookOptions<SearchBusinessUnitsQuery, SearchBusinessUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchBusinessUnitsQuery, SearchBusinessUnitsQueryVariables>(SearchBusinessUnitsDocument, options);
      }
export function useSearchBusinessUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchBusinessUnitsQuery, SearchBusinessUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchBusinessUnitsQuery, SearchBusinessUnitsQueryVariables>(SearchBusinessUnitsDocument, options);
        }
export type SearchBusinessUnitsQueryHookResult = ReturnType<typeof useSearchBusinessUnitsQuery>;
export type SearchBusinessUnitsLazyQueryHookResult = ReturnType<typeof useSearchBusinessUnitsLazyQuery>;
export type SearchBusinessUnitsQueryResult = Apollo.QueryResult<SearchBusinessUnitsQuery, SearchBusinessUnitsQueryVariables>;
export const SearchPreferredBusinessUnitsDocument = gql`
    query SearchPreferredBusinessUnits($query: String, $roles: [String], $excludeBusinessUnitIds: [Int!], $preferredSuppliersBuyerId: Int) {
  searchBusinessUnits(
    query: $query
    roles: $roles
    excludeBusinessUnitIds: $excludeBusinessUnitIds
    preferredSuppliersBuyerId: $preferredSuppliersBuyerId
  ) {
    id
    name
    location {
      city
      unitName
    }
  }
}
    `;

/**
 * __useSearchPreferredBusinessUnitsQuery__
 *
 * To run a query within a React component, call `useSearchPreferredBusinessUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPreferredBusinessUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPreferredBusinessUnitsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      roles: // value for 'roles'
 *      excludeBusinessUnitIds: // value for 'excludeBusinessUnitIds'
 *      preferredSuppliersBuyerId: // value for 'preferredSuppliersBuyerId'
 *   },
 * });
 */
export function useSearchPreferredBusinessUnitsQuery(baseOptions?: Apollo.QueryHookOptions<SearchPreferredBusinessUnitsQuery, SearchPreferredBusinessUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPreferredBusinessUnitsQuery, SearchPreferredBusinessUnitsQueryVariables>(SearchPreferredBusinessUnitsDocument, options);
      }
export function useSearchPreferredBusinessUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPreferredBusinessUnitsQuery, SearchPreferredBusinessUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPreferredBusinessUnitsQuery, SearchPreferredBusinessUnitsQueryVariables>(SearchPreferredBusinessUnitsDocument, options);
        }
export type SearchPreferredBusinessUnitsQueryHookResult = ReturnType<typeof useSearchPreferredBusinessUnitsQuery>;
export type SearchPreferredBusinessUnitsLazyQueryHookResult = ReturnType<typeof useSearchPreferredBusinessUnitsLazyQuery>;
export type SearchPreferredBusinessUnitsQueryResult = Apollo.QueryResult<SearchPreferredBusinessUnitsQuery, SearchPreferredBusinessUnitsQueryVariables>;
export const GetPreferredBusinessUnitsDocument = gql`
    query GetPreferredBusinessUnits($businessUnit: Int!) {
  preferredBusinessUnits(businessUnit: $businessUnit) {
    id
    supplier {
      id
      name
      primaryLocation {
        id
        city
        unitName
      }
    }
    buyer {
      id
      name
      primaryLocation {
        id
        city
        unitName
      }
    }
    fieldsman {
      id
      firstName
      lastName
    }
    priceAdjustment
    commonStatus
    tacTitle
    tacDescription
  }
}
    `;

/**
 * __useGetPreferredBusinessUnitsQuery__
 *
 * To run a query within a React component, call `useGetPreferredBusinessUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferredBusinessUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferredBusinessUnitsQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useGetPreferredBusinessUnitsQuery(baseOptions: Apollo.QueryHookOptions<GetPreferredBusinessUnitsQuery, GetPreferredBusinessUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreferredBusinessUnitsQuery, GetPreferredBusinessUnitsQueryVariables>(GetPreferredBusinessUnitsDocument, options);
      }
export function useGetPreferredBusinessUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreferredBusinessUnitsQuery, GetPreferredBusinessUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreferredBusinessUnitsQuery, GetPreferredBusinessUnitsQueryVariables>(GetPreferredBusinessUnitsDocument, options);
        }
export type GetPreferredBusinessUnitsQueryHookResult = ReturnType<typeof useGetPreferredBusinessUnitsQuery>;
export type GetPreferredBusinessUnitsLazyQueryHookResult = ReturnType<typeof useGetPreferredBusinessUnitsLazyQuery>;
export type GetPreferredBusinessUnitsQueryResult = Apollo.QueryResult<GetPreferredBusinessUnitsQuery, GetPreferredBusinessUnitsQueryVariables>;
export const GetPreferredBusinessUnitDocument = gql`
    query GetPreferredBusinessUnit($businessUnit: Int!, $id: Int!) {
  preferredBusinessUnit(businessUnit: $businessUnit, id: $id) {
    id
    supplier {
      id
      name
    }
    fieldsman {
      id
    }
    priceAdjustment
  }
}
    `;

/**
 * __useGetPreferredBusinessUnitQuery__
 *
 * To run a query within a React component, call `useGetPreferredBusinessUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferredBusinessUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferredBusinessUnitQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPreferredBusinessUnitQuery(baseOptions: Apollo.QueryHookOptions<GetPreferredBusinessUnitQuery, GetPreferredBusinessUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreferredBusinessUnitQuery, GetPreferredBusinessUnitQueryVariables>(GetPreferredBusinessUnitDocument, options);
      }
export function useGetPreferredBusinessUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreferredBusinessUnitQuery, GetPreferredBusinessUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreferredBusinessUnitQuery, GetPreferredBusinessUnitQueryVariables>(GetPreferredBusinessUnitDocument, options);
        }
export type GetPreferredBusinessUnitQueryHookResult = ReturnType<typeof useGetPreferredBusinessUnitQuery>;
export type GetPreferredBusinessUnitLazyQueryHookResult = ReturnType<typeof useGetPreferredBusinessUnitLazyQuery>;
export type GetPreferredBusinessUnitQueryResult = Apollo.QueryResult<GetPreferredBusinessUnitQuery, GetPreferredBusinessUnitQueryVariables>;
export const EmptyStateDocument = gql`
    query EmptyState($businessUnitId: Int!, $page: String!, $platform: String!, $animalType: Int!) {
  emptyState(
    businessUnitId: $businessUnitId
    page: $page
    platform: $platform
    animalType: $animalType
  ) {
    id
    text
    image
    page
    showButton
    button
    buttonLink
    buttonLabel
  }
}
    `;

/**
 * __useEmptyStateQuery__
 *
 * To run a query within a React component, call `useEmptyStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmptyStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmptyStateQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *      page: // value for 'page'
 *      platform: // value for 'platform'
 *      animalType: // value for 'animalType'
 *   },
 * });
 */
export function useEmptyStateQuery(baseOptions: Apollo.QueryHookOptions<EmptyStateQuery, EmptyStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmptyStateQuery, EmptyStateQueryVariables>(EmptyStateDocument, options);
      }
export function useEmptyStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmptyStateQuery, EmptyStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmptyStateQuery, EmptyStateQueryVariables>(EmptyStateDocument, options);
        }
export type EmptyStateQueryHookResult = ReturnType<typeof useEmptyStateQuery>;
export type EmptyStateLazyQueryHookResult = ReturnType<typeof useEmptyStateLazyQuery>;
export type EmptyStateQueryResult = Apollo.QueryResult<EmptyStateQuery, EmptyStateQueryVariables>;
export const GetSupportedSystemsCustomImportDocument = gql`
    query GetSupportedSystemsCustomImport($farm: Int!, $systemType: String, $isAutomatedSystem: Boolean) {
  integrationSystems(
    farm: $farm
    systemType: $systemType
    isAutomatedSystem: $isAutomatedSystem
  ) {
    id
    name
    logo
  }
}
    `;

/**
 * __useGetSupportedSystemsCustomImportQuery__
 *
 * To run a query within a React component, call `useGetSupportedSystemsCustomImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportedSystemsCustomImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportedSystemsCustomImportQuery({
 *   variables: {
 *      farm: // value for 'farm'
 *      systemType: // value for 'systemType'
 *      isAutomatedSystem: // value for 'isAutomatedSystem'
 *   },
 * });
 */
export function useGetSupportedSystemsCustomImportQuery(baseOptions: Apollo.QueryHookOptions<GetSupportedSystemsCustomImportQuery, GetSupportedSystemsCustomImportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupportedSystemsCustomImportQuery, GetSupportedSystemsCustomImportQueryVariables>(GetSupportedSystemsCustomImportDocument, options);
      }
export function useGetSupportedSystemsCustomImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupportedSystemsCustomImportQuery, GetSupportedSystemsCustomImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupportedSystemsCustomImportQuery, GetSupportedSystemsCustomImportQueryVariables>(GetSupportedSystemsCustomImportDocument, options);
        }
export type GetSupportedSystemsCustomImportQueryHookResult = ReturnType<typeof useGetSupportedSystemsCustomImportQuery>;
export type GetSupportedSystemsCustomImportLazyQueryHookResult = ReturnType<typeof useGetSupportedSystemsCustomImportLazyQuery>;
export type GetSupportedSystemsCustomImportQueryResult = Apollo.QueryResult<GetSupportedSystemsCustomImportQuery, GetSupportedSystemsCustomImportQueryVariables>;
export const ImportResultDocument = gql`
    query ImportResult($task: String!) {
  importResult(task: $task) {
    isDone
    processedRows
    errorRows
    failedAnimalsUrl
    failedActivitiesUrl
    importedAnimalsCount
    createdGroupsCount
    updatedAnimals
    animals {
      ...animalFragment
    }
    importedActivitiesCount
  }
}
    ${AnimalFragmentFragmentDoc}`;

/**
 * __useImportResultQuery__
 *
 * To run a query within a React component, call `useImportResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportResultQuery({
 *   variables: {
 *      task: // value for 'task'
 *   },
 * });
 */
export function useImportResultQuery(baseOptions: Apollo.QueryHookOptions<ImportResultQuery, ImportResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportResultQuery, ImportResultQueryVariables>(ImportResultDocument, options);
      }
export function useImportResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportResultQuery, ImportResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportResultQuery, ImportResultQueryVariables>(ImportResultDocument, options);
        }
export type ImportResultQueryHookResult = ReturnType<typeof useImportResultQuery>;
export type ImportResultLazyQueryHookResult = ReturnType<typeof useImportResultLazyQuery>;
export type ImportResultQueryResult = Apollo.QueryResult<ImportResultQuery, ImportResultQueryVariables>;
export const BcmsImportCsvDocument = gql`
    mutation BcmsImportCsv($input: BcmsImportCsvInput!) {
  bcmsImportCsv(input: $input) {
    task {
      ...taskDetailsFragment
    }
    errors {
      ...errorFragment
    }
  }
}
    ${TaskDetailsFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type BcmsImportCsvMutationFn = Apollo.MutationFunction<BcmsImportCsvMutation, BcmsImportCsvMutationVariables>;

/**
 * __useBcmsImportCsvMutation__
 *
 * To run a mutation, you first call `useBcmsImportCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBcmsImportCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bcmsImportCsvMutation, { data, loading, error }] = useBcmsImportCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBcmsImportCsvMutation(baseOptions?: Apollo.MutationHookOptions<BcmsImportCsvMutation, BcmsImportCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BcmsImportCsvMutation, BcmsImportCsvMutationVariables>(BcmsImportCsvDocument, options);
      }
export type BcmsImportCsvMutationHookResult = ReturnType<typeof useBcmsImportCsvMutation>;
export type BcmsImportCsvMutationResult = Apollo.MutationResult<BcmsImportCsvMutation>;
export type BcmsImportCsvMutationOptions = Apollo.BaseMutationOptions<BcmsImportCsvMutation, BcmsImportCsvMutationVariables>;
export const TruTestImportXlsDocument = gql`
    mutation TruTestImportXls($input: TruTestImportXlsInput!) {
  truTestImportXls(input: $input) {
    task {
      ...taskDetailsFragment
    }
    errors {
      ...errorFragment
    }
  }
}
    ${TaskDetailsFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type TruTestImportXlsMutationFn = Apollo.MutationFunction<TruTestImportXlsMutation, TruTestImportXlsMutationVariables>;

/**
 * __useTruTestImportXlsMutation__
 *
 * To run a mutation, you first call `useTruTestImportXlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTruTestImportXlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [truTestImportXlsMutation, { data, loading, error }] = useTruTestImportXlsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTruTestImportXlsMutation(baseOptions?: Apollo.MutationHookOptions<TruTestImportXlsMutation, TruTestImportXlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TruTestImportXlsMutation, TruTestImportXlsMutationVariables>(TruTestImportXlsDocument, options);
      }
export type TruTestImportXlsMutationHookResult = ReturnType<typeof useTruTestImportXlsMutation>;
export type TruTestImportXlsMutationResult = Apollo.MutationResult<TruTestImportXlsMutation>;
export type TruTestImportXlsMutationOptions = Apollo.BaseMutationOptions<TruTestImportXlsMutation, TruTestImportXlsMutationVariables>;
export const FarmPlanImportXlsDocument = gql`
    mutation FarmPlanImportXls($input: FarmPlanImportXLSInput!) {
  farmPlanImportXls(input: $input) {
    task {
      ...taskDetailsFragment
    }
    errors {
      ...errorFragment
    }
  }
}
    ${TaskDetailsFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type FarmPlanImportXlsMutationFn = Apollo.MutationFunction<FarmPlanImportXlsMutation, FarmPlanImportXlsMutationVariables>;

/**
 * __useFarmPlanImportXlsMutation__
 *
 * To run a mutation, you first call `useFarmPlanImportXlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFarmPlanImportXlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [farmPlanImportXlsMutation, { data, loading, error }] = useFarmPlanImportXlsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFarmPlanImportXlsMutation(baseOptions?: Apollo.MutationHookOptions<FarmPlanImportXlsMutation, FarmPlanImportXlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FarmPlanImportXlsMutation, FarmPlanImportXlsMutationVariables>(FarmPlanImportXlsDocument, options);
      }
export type FarmPlanImportXlsMutationHookResult = ReturnType<typeof useFarmPlanImportXlsMutation>;
export type FarmPlanImportXlsMutationResult = Apollo.MutationResult<FarmPlanImportXlsMutation>;
export type FarmPlanImportXlsMutationOptions = Apollo.BaseMutationOptions<FarmPlanImportXlsMutation, FarmPlanImportXlsMutationVariables>;
export const AphisImportCsvDocument = gql`
    mutation AphisImportCsv($input: AphisImportCsvInput!) {
  aphisImportCsv(input: $input) {
    task {
      ...taskDetailsFragment
    }
    errors {
      ...errorFragment
    }
  }
}
    ${TaskDetailsFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type AphisImportCsvMutationFn = Apollo.MutationFunction<AphisImportCsvMutation, AphisImportCsvMutationVariables>;

/**
 * __useAphisImportCsvMutation__
 *
 * To run a mutation, you first call `useAphisImportCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAphisImportCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aphisImportCsvMutation, { data, loading, error }] = useAphisImportCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAphisImportCsvMutation(baseOptions?: Apollo.MutationHookOptions<AphisImportCsvMutation, AphisImportCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AphisImportCsvMutation, AphisImportCsvMutationVariables>(AphisImportCsvDocument, options);
      }
export type AphisImportCsvMutationHookResult = ReturnType<typeof useAphisImportCsvMutation>;
export type AphisImportCsvMutationResult = Apollo.MutationResult<AphisImportCsvMutation>;
export type AphisImportCsvMutationOptions = Apollo.BaseMutationOptions<AphisImportCsvMutation, AphisImportCsvMutationVariables>;
export const StartFarmSystemTaskDocument = gql`
    mutation StartFarmSystemTask($input: StartFarmSystemTaskInput!) {
  startFarmSystemTask(input: $input) {
    id
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type StartFarmSystemTaskMutationFn = Apollo.MutationFunction<StartFarmSystemTaskMutation, StartFarmSystemTaskMutationVariables>;

/**
 * __useStartFarmSystemTaskMutation__
 *
 * To run a mutation, you first call `useStartFarmSystemTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartFarmSystemTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startFarmSystemTaskMutation, { data, loading, error }] = useStartFarmSystemTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartFarmSystemTaskMutation(baseOptions?: Apollo.MutationHookOptions<StartFarmSystemTaskMutation, StartFarmSystemTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartFarmSystemTaskMutation, StartFarmSystemTaskMutationVariables>(StartFarmSystemTaskDocument, options);
      }
export type StartFarmSystemTaskMutationHookResult = ReturnType<typeof useStartFarmSystemTaskMutation>;
export type StartFarmSystemTaskMutationResult = Apollo.MutationResult<StartFarmSystemTaskMutation>;
export type StartFarmSystemTaskMutationOptions = Apollo.BaseMutationOptions<StartFarmSystemTaskMutation, StartFarmSystemTaskMutationVariables>;
export const CancelFarmSystemTaskDocument = gql`
    mutation CancelFarmSystemTask($input: CancelFarmSystemTaskInput!) {
  cancelFarmSystemTask(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type CancelFarmSystemTaskMutationFn = Apollo.MutationFunction<CancelFarmSystemTaskMutation, CancelFarmSystemTaskMutationVariables>;

/**
 * __useCancelFarmSystemTaskMutation__
 *
 * To run a mutation, you first call `useCancelFarmSystemTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelFarmSystemTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelFarmSystemTaskMutation, { data, loading, error }] = useCancelFarmSystemTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelFarmSystemTaskMutation(baseOptions?: Apollo.MutationHookOptions<CancelFarmSystemTaskMutation, CancelFarmSystemTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelFarmSystemTaskMutation, CancelFarmSystemTaskMutationVariables>(CancelFarmSystemTaskDocument, options);
      }
export type CancelFarmSystemTaskMutationHookResult = ReturnType<typeof useCancelFarmSystemTaskMutation>;
export type CancelFarmSystemTaskMutationResult = Apollo.MutationResult<CancelFarmSystemTaskMutation>;
export type CancelFarmSystemTaskMutationOptions = Apollo.BaseMutationOptions<CancelFarmSystemTaskMutation, CancelFarmSystemTaskMutationVariables>;
export const GetSupportedSystemsDocument = gql`
    query GetSupportedSystems($farm: Int!, $systemType: String, $isAutomatedSystem: Boolean) {
  integrationSystems(
    farm: $farm
    systemType: $systemType
    isAutomatedSystem: $isAutomatedSystem
  ) {
    ...integrationSystemFragment
  }
}
    ${IntegrationSystemFragmentFragmentDoc}`;

/**
 * __useGetSupportedSystemsQuery__
 *
 * To run a query within a React component, call `useGetSupportedSystemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportedSystemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportedSystemsQuery({
 *   variables: {
 *      farm: // value for 'farm'
 *      systemType: // value for 'systemType'
 *      isAutomatedSystem: // value for 'isAutomatedSystem'
 *   },
 * });
 */
export function useGetSupportedSystemsQuery(baseOptions: Apollo.QueryHookOptions<GetSupportedSystemsQuery, GetSupportedSystemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupportedSystemsQuery, GetSupportedSystemsQueryVariables>(GetSupportedSystemsDocument, options);
      }
export function useGetSupportedSystemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupportedSystemsQuery, GetSupportedSystemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupportedSystemsQuery, GetSupportedSystemsQueryVariables>(GetSupportedSystemsDocument, options);
        }
export type GetSupportedSystemsQueryHookResult = ReturnType<typeof useGetSupportedSystemsQuery>;
export type GetSupportedSystemsLazyQueryHookResult = ReturnType<typeof useGetSupportedSystemsLazyQuery>;
export type GetSupportedSystemsQueryResult = Apollo.QueryResult<GetSupportedSystemsQuery, GetSupportedSystemsQueryVariables>;
export const GetTaskInfoDocument = gql`
    query GetTaskInfo($taskId: Int!) {
  farmSystemTask(taskId: $taskId) {
    ...taskDetailsFragment
  }
}
    ${TaskDetailsFragmentFragmentDoc}`;

/**
 * __useGetTaskInfoQuery__
 *
 * To run a query within a React component, call `useGetTaskInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskInfoQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskInfoQuery(baseOptions: Apollo.QueryHookOptions<GetTaskInfoQuery, GetTaskInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskInfoQuery, GetTaskInfoQueryVariables>(GetTaskInfoDocument, options);
      }
export function useGetTaskInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskInfoQuery, GetTaskInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskInfoQuery, GetTaskInfoQueryVariables>(GetTaskInfoDocument, options);
        }
export type GetTaskInfoQueryHookResult = ReturnType<typeof useGetTaskInfoQuery>;
export type GetTaskInfoLazyQueryHookResult = ReturnType<typeof useGetTaskInfoLazyQuery>;
export type GetTaskInfoQueryResult = Apollo.QueryResult<GetTaskInfoQuery, GetTaskInfoQueryVariables>;
export const LinkHerdDoggAccountDocument = gql`
    mutation linkHerdDoggAccount($input: LinkHerdDoggAccountInput!) {
  linkHerdDoggAccount(input: $input) {
    success
  }
}
    `;
export type LinkHerdDoggAccountMutationFn = Apollo.MutationFunction<LinkHerdDoggAccountMutation, LinkHerdDoggAccountMutationVariables>;

/**
 * __useLinkHerdDoggAccountMutation__
 *
 * To run a mutation, you first call `useLinkHerdDoggAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkHerdDoggAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkHerdDoggAccountMutation, { data, loading, error }] = useLinkHerdDoggAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkHerdDoggAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkHerdDoggAccountMutation, LinkHerdDoggAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkHerdDoggAccountMutation, LinkHerdDoggAccountMutationVariables>(LinkHerdDoggAccountDocument, options);
      }
export type LinkHerdDoggAccountMutationHookResult = ReturnType<typeof useLinkHerdDoggAccountMutation>;
export type LinkHerdDoggAccountMutationResult = Apollo.MutationResult<LinkHerdDoggAccountMutation>;
export type LinkHerdDoggAccountMutationOptions = Apollo.BaseMutationOptions<LinkHerdDoggAccountMutation, LinkHerdDoggAccountMutationVariables>;
export const UnlinkHerdDoggAccountDocument = gql`
    mutation unlinkHerdDoggAccount($input: UnlinkHerdDoggAccountInput!) {
  unlinkHerdDoggAccount(input: $input) {
    success
  }
}
    `;
export type UnlinkHerdDoggAccountMutationFn = Apollo.MutationFunction<UnlinkHerdDoggAccountMutation, UnlinkHerdDoggAccountMutationVariables>;

/**
 * __useUnlinkHerdDoggAccountMutation__
 *
 * To run a mutation, you first call `useUnlinkHerdDoggAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkHerdDoggAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkHerdDoggAccountMutation, { data, loading, error }] = useUnlinkHerdDoggAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkHerdDoggAccountMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkHerdDoggAccountMutation, UnlinkHerdDoggAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkHerdDoggAccountMutation, UnlinkHerdDoggAccountMutationVariables>(UnlinkHerdDoggAccountDocument, options);
      }
export type UnlinkHerdDoggAccountMutationHookResult = ReturnType<typeof useUnlinkHerdDoggAccountMutation>;
export type UnlinkHerdDoggAccountMutationResult = Apollo.MutationResult<UnlinkHerdDoggAccountMutation>;
export type UnlinkHerdDoggAccountMutationOptions = Apollo.BaseMutationOptions<UnlinkHerdDoggAccountMutation, UnlinkHerdDoggAccountMutationVariables>;
export const GetStockItemDocument = gql`
    query GetStockItem($id: UUID!, $businessUnitId: Int!) {
  stockItem(id: $id, businessUnitId: $businessUnitId) {
    ...stockItemFragment
  }
}
    ${StockItemFragmentFragmentDoc}`;

/**
 * __useGetStockItemQuery__
 *
 * To run a query within a React component, call `useGetStockItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useGetStockItemQuery(baseOptions: Apollo.QueryHookOptions<GetStockItemQuery, GetStockItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockItemQuery, GetStockItemQueryVariables>(GetStockItemDocument, options);
      }
export function useGetStockItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockItemQuery, GetStockItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockItemQuery, GetStockItemQueryVariables>(GetStockItemDocument, options);
        }
export type GetStockItemQueryHookResult = ReturnType<typeof useGetStockItemQuery>;
export type GetStockItemLazyQueryHookResult = ReturnType<typeof useGetStockItemLazyQuery>;
export type GetStockItemQueryResult = Apollo.QueryResult<GetStockItemQuery, GetStockItemQueryVariables>;
export const LineItemsDocument = gql`
    query LineItems($businessUnitId: Int!) {
  lineItems(businessUnitId: $businessUnitId) {
    id
    name
    sku
    purchaseDate
    expiryDate
    batchNumber
    quantity
    totalVolume
    originalVolume
    quantityUnits
    stockItem {
      id
      name
    }
  }
}
    `;

/**
 * __useLineItemsQuery__
 *
 * To run a query within a React component, call `useLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLineItemsQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useLineItemsQuery(baseOptions: Apollo.QueryHookOptions<LineItemsQuery, LineItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LineItemsQuery, LineItemsQueryVariables>(LineItemsDocument, options);
      }
export function useLineItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LineItemsQuery, LineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LineItemsQuery, LineItemsQueryVariables>(LineItemsDocument, options);
        }
export type LineItemsQueryHookResult = ReturnType<typeof useLineItemsQuery>;
export type LineItemsLazyQueryHookResult = ReturnType<typeof useLineItemsLazyQuery>;
export type LineItemsQueryResult = Apollo.QueryResult<LineItemsQuery, LineItemsQueryVariables>;
export const GetMedicineActivitiesDocument = gql`
    query GetMedicineActivities($businessUnitId: Int!, $stockItemId: UUID!, $batchNumber: String, $first: Int, $after: String) {
  itemTransactions(
    businessUnitId: $businessUnitId
    stockItemId: $stockItemId
    batchNumber: $batchNumber
    first: $first
    after: $after
  ) {
    edges {
      node {
        id
        date
        batchNumber
        valueDescription
        shortDescription
        longDescription
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetMedicineActivitiesQuery__
 *
 * To run a query within a React component, call `useGetMedicineActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMedicineActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMedicineActivitiesQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *      stockItemId: // value for 'stockItemId'
 *      batchNumber: // value for 'batchNumber'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetMedicineActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetMedicineActivitiesQuery, GetMedicineActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMedicineActivitiesQuery, GetMedicineActivitiesQueryVariables>(GetMedicineActivitiesDocument, options);
      }
export function useGetMedicineActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMedicineActivitiesQuery, GetMedicineActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMedicineActivitiesQuery, GetMedicineActivitiesQueryVariables>(GetMedicineActivitiesDocument, options);
        }
export type GetMedicineActivitiesQueryHookResult = ReturnType<typeof useGetMedicineActivitiesQuery>;
export type GetMedicineActivitiesLazyQueryHookResult = ReturnType<typeof useGetMedicineActivitiesLazyQuery>;
export type GetMedicineActivitiesQueryResult = Apollo.QueryResult<GetMedicineActivitiesQuery, GetMedicineActivitiesQueryVariables>;
export const GetInventoryInfoDocument = gql`
    query GetInventoryInfo($businessUnitId: Int!) {
  inventoryInfo(businessUnitId: $businessUnitId) {
    id
    activeIngredients
    batchNumber
    name
    stockItemId
    totalOriginalVolume
    totalRemainingVolume
    volumeUnits
    withdrawalNotes
  }
}
    `;

/**
 * __useGetInventoryInfoQuery__
 *
 * To run a query within a React component, call `useGetInventoryInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInventoryInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInventoryInfoQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useGetInventoryInfoQuery(baseOptions: Apollo.QueryHookOptions<GetInventoryInfoQuery, GetInventoryInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInventoryInfoQuery, GetInventoryInfoQueryVariables>(GetInventoryInfoDocument, options);
      }
export function useGetInventoryInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInventoryInfoQuery, GetInventoryInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInventoryInfoQuery, GetInventoryInfoQueryVariables>(GetInventoryInfoDocument, options);
        }
export type GetInventoryInfoQueryHookResult = ReturnType<typeof useGetInventoryInfoQuery>;
export type GetInventoryInfoLazyQueryHookResult = ReturnType<typeof useGetInventoryInfoLazyQuery>;
export type GetInventoryInfoQueryResult = Apollo.QueryResult<GetInventoryInfoQuery, GetInventoryInfoQueryVariables>;
export const LogActivityBulkMutationDocument = gql`
    mutation LogActivityBulkMutation($input: LogActivityBulkInput!) {
  logActivityBulk(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type LogActivityBulkMutationMutationFn = Apollo.MutationFunction<LogActivityBulkMutationMutation, LogActivityBulkMutationMutationVariables>;

/**
 * __useLogActivityBulkMutationMutation__
 *
 * To run a mutation, you first call `useLogActivityBulkMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogActivityBulkMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logActivityBulkMutationMutation, { data, loading, error }] = useLogActivityBulkMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogActivityBulkMutationMutation(baseOptions?: Apollo.MutationHookOptions<LogActivityBulkMutationMutation, LogActivityBulkMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogActivityBulkMutationMutation, LogActivityBulkMutationMutationVariables>(LogActivityBulkMutationDocument, options);
      }
export type LogActivityBulkMutationMutationHookResult = ReturnType<typeof useLogActivityBulkMutationMutation>;
export type LogActivityBulkMutationMutationResult = Apollo.MutationResult<LogActivityBulkMutationMutation>;
export type LogActivityBulkMutationMutationOptions = Apollo.BaseMutationOptions<LogActivityBulkMutationMutation, LogActivityBulkMutationMutationVariables>;
export const DeleteActivityBulkMutationDocument = gql`
    mutation DeleteActivityBulkMutation($input: DeleteActivityBulkInput!) {
  deleteActivityBulk(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type DeleteActivityBulkMutationMutationFn = Apollo.MutationFunction<DeleteActivityBulkMutationMutation, DeleteActivityBulkMutationMutationVariables>;

/**
 * __useDeleteActivityBulkMutationMutation__
 *
 * To run a mutation, you first call `useDeleteActivityBulkMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActivityBulkMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActivityBulkMutationMutation, { data, loading, error }] = useDeleteActivityBulkMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteActivityBulkMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActivityBulkMutationMutation, DeleteActivityBulkMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActivityBulkMutationMutation, DeleteActivityBulkMutationMutationVariables>(DeleteActivityBulkMutationDocument, options);
      }
export type DeleteActivityBulkMutationMutationHookResult = ReturnType<typeof useDeleteActivityBulkMutationMutation>;
export type DeleteActivityBulkMutationMutationResult = Apollo.MutationResult<DeleteActivityBulkMutationMutation>;
export type DeleteActivityBulkMutationMutationOptions = Apollo.BaseMutationOptions<DeleteActivityBulkMutationMutation, DeleteActivityBulkMutationMutationVariables>;
export const GetActivityTypesDocument = gql`
    query GetActivityTypes($businessUnit: Int!) {
  activityTypes(businessUnit: $businessUnit) {
    ...activityTypeFragment
  }
}
    ${ActivityTypeFragmentFragmentDoc}`;

/**
 * __useGetActivityTypesQuery__
 *
 * To run a query within a React component, call `useGetActivityTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityTypesQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useGetActivityTypesQuery(baseOptions: Apollo.QueryHookOptions<GetActivityTypesQuery, GetActivityTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityTypesQuery, GetActivityTypesQueryVariables>(GetActivityTypesDocument, options);
      }
export function useGetActivityTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityTypesQuery, GetActivityTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityTypesQuery, GetActivityTypesQueryVariables>(GetActivityTypesDocument, options);
        }
export type GetActivityTypesQueryHookResult = ReturnType<typeof useGetActivityTypesQuery>;
export type GetActivityTypesLazyQueryHookResult = ReturnType<typeof useGetActivityTypesLazyQuery>;
export type GetActivityTypesQueryResult = Apollo.QueryResult<GetActivityTypesQuery, GetActivityTypesQueryVariables>;
export const GetActivityTemplatesDocument = gql`
    query GetActivityTemplates($businessUnit: Int, $species: Int) {
  activityTemplates(businessUnit: $businessUnit, species: $species) {
    ...activityTemplateFragment
  }
}
    ${ActivityTemplateFragmentFragmentDoc}`;

/**
 * __useGetActivityTemplatesQuery__
 *
 * To run a query within a React component, call `useGetActivityTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityTemplatesQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *      species: // value for 'species'
 *   },
 * });
 */
export function useGetActivityTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetActivityTemplatesQuery, GetActivityTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityTemplatesQuery, GetActivityTemplatesQueryVariables>(GetActivityTemplatesDocument, options);
      }
export function useGetActivityTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityTemplatesQuery, GetActivityTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityTemplatesQuery, GetActivityTemplatesQueryVariables>(GetActivityTemplatesDocument, options);
        }
export type GetActivityTemplatesQueryHookResult = ReturnType<typeof useGetActivityTemplatesQuery>;
export type GetActivityTemplatesLazyQueryHookResult = ReturnType<typeof useGetActivityTemplatesLazyQuery>;
export type GetActivityTemplatesQueryResult = Apollo.QueryResult<GetActivityTemplatesQuery, GetActivityTemplatesQueryVariables>;
export const GetActivityLogDocument = gql`
    query GetActivityLog($animal: UUID, $first: Int, $after: String, $activityTemplateSlugs: [String], $activityTypeSlugs: [String]) {
  activities(
    animal: $animal
    first: $first
    after: $after
    activityTemplateSlugs: $activityTemplateSlugs
    activityTypeSlugs: $activityTypeSlugs
  ) {
    edges {
      node {
        ...activityLogFragment
      }
    }
    pageInfo {
      ...pageInfoFragment
    }
  }
}
    ${ActivityLogFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetActivityLogQuery__
 *
 * To run a query within a React component, call `useGetActivityLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityLogQuery({
 *   variables: {
 *      animal: // value for 'animal'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      activityTemplateSlugs: // value for 'activityTemplateSlugs'
 *      activityTypeSlugs: // value for 'activityTypeSlugs'
 *   },
 * });
 */
export function useGetActivityLogQuery(baseOptions?: Apollo.QueryHookOptions<GetActivityLogQuery, GetActivityLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityLogQuery, GetActivityLogQueryVariables>(GetActivityLogDocument, options);
      }
export function useGetActivityLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityLogQuery, GetActivityLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityLogQuery, GetActivityLogQueryVariables>(GetActivityLogDocument, options);
        }
export type GetActivityLogQueryHookResult = ReturnType<typeof useGetActivityLogQuery>;
export type GetActivityLogLazyQueryHookResult = ReturnType<typeof useGetActivityLogLazyQuery>;
export type GetActivityLogQueryResult = Apollo.QueryResult<GetActivityLogQuery, GetActivityLogQueryVariables>;
export const GetActivityLogOldDocument = gql`
    query GetActivityLogOld($animal: UUID, $first: Int, $after: String, $activityTemplateSlugs: [String], $activityTypeSlugs: [String]) {
  activities(
    animal: $animal
    first: $first
    after: $after
    activityTemplateSlugs: $activityTemplateSlugs
    activityTypeSlugs: $activityTypeSlugs
  ) {
    edges {
      node {
        ...historyAnimalFragment
      }
    }
    pageInfo {
      ...pageInfoFragment
    }
  }
}
    ${HistoryAnimalFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetActivityLogOldQuery__
 *
 * To run a query within a React component, call `useGetActivityLogOldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityLogOldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityLogOldQuery({
 *   variables: {
 *      animal: // value for 'animal'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      activityTemplateSlugs: // value for 'activityTemplateSlugs'
 *      activityTypeSlugs: // value for 'activityTypeSlugs'
 *   },
 * });
 */
export function useGetActivityLogOldQuery(baseOptions?: Apollo.QueryHookOptions<GetActivityLogOldQuery, GetActivityLogOldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityLogOldQuery, GetActivityLogOldQueryVariables>(GetActivityLogOldDocument, options);
      }
export function useGetActivityLogOldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityLogOldQuery, GetActivityLogOldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityLogOldQuery, GetActivityLogOldQueryVariables>(GetActivityLogOldDocument, options);
        }
export type GetActivityLogOldQueryHookResult = ReturnType<typeof useGetActivityLogOldQuery>;
export type GetActivityLogOldLazyQueryHookResult = ReturnType<typeof useGetActivityLogOldLazyQuery>;
export type GetActivityLogOldQueryResult = Apollo.QueryResult<GetActivityLogOldQuery, GetActivityLogOldQueryVariables>;
export const GetActivityLogNewDocument = gql`
    query GetActivityLogNew($animal: UUID, $first: Int, $after: String, $activityTemplateSlugs: [String], $activityTypeSlugs: [String], $isChartable: Boolean) {
  activities(
    animal: $animal
    first: $first
    after: $after
    activityTemplateSlugs: $activityTemplateSlugs
    activityTypeSlugs: $activityTypeSlugs
    isChartable: $isChartable
  ) {
    edges {
      node {
        ...activityLogFragment
      }
    }
    pageInfo {
      ...pageInfoFragment
    }
  }
}
    ${ActivityLogFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetActivityLogNewQuery__
 *
 * To run a query within a React component, call `useGetActivityLogNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityLogNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityLogNewQuery({
 *   variables: {
 *      animal: // value for 'animal'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      activityTemplateSlugs: // value for 'activityTemplateSlugs'
 *      activityTypeSlugs: // value for 'activityTypeSlugs'
 *      isChartable: // value for 'isChartable'
 *   },
 * });
 */
export function useGetActivityLogNewQuery(baseOptions?: Apollo.QueryHookOptions<GetActivityLogNewQuery, GetActivityLogNewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityLogNewQuery, GetActivityLogNewQueryVariables>(GetActivityLogNewDocument, options);
      }
export function useGetActivityLogNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityLogNewQuery, GetActivityLogNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityLogNewQuery, GetActivityLogNewQueryVariables>(GetActivityLogNewDocument, options);
        }
export type GetActivityLogNewQueryHookResult = ReturnType<typeof useGetActivityLogNewQuery>;
export type GetActivityLogNewLazyQueryHookResult = ReturnType<typeof useGetActivityLogNewLazyQuery>;
export type GetActivityLogNewQueryResult = Apollo.QueryResult<GetActivityLogNewQuery, GetActivityLogNewQueryVariables>;
export const CreateAnimalFilterDocument = gql`
    mutation CreateAnimalFilter($input: CreateAnimalFilterInput!) {
  createAnimalFilter(input: $input) {
    animalFilter {
      ...animalFiltersFragment
    }
    errors {
      ...errorFragment
    }
  }
}
    ${AnimalFiltersFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type CreateAnimalFilterMutationFn = Apollo.MutationFunction<CreateAnimalFilterMutation, CreateAnimalFilterMutationVariables>;

/**
 * __useCreateAnimalFilterMutation__
 *
 * To run a mutation, you first call `useCreateAnimalFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnimalFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnimalFilterMutation, { data, loading, error }] = useCreateAnimalFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnimalFilterMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnimalFilterMutation, CreateAnimalFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnimalFilterMutation, CreateAnimalFilterMutationVariables>(CreateAnimalFilterDocument, options);
      }
export type CreateAnimalFilterMutationHookResult = ReturnType<typeof useCreateAnimalFilterMutation>;
export type CreateAnimalFilterMutationResult = Apollo.MutationResult<CreateAnimalFilterMutation>;
export type CreateAnimalFilterMutationOptions = Apollo.BaseMutationOptions<CreateAnimalFilterMutation, CreateAnimalFilterMutationVariables>;
export const UpdateAnimalFilterDocument = gql`
    mutation UpdateAnimalFilter($input: UpdateAnimalFilterInput!) {
  updateAnimalFilter(input: $input) {
    animalFilter {
      id
    }
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type UpdateAnimalFilterMutationFn = Apollo.MutationFunction<UpdateAnimalFilterMutation, UpdateAnimalFilterMutationVariables>;

/**
 * __useUpdateAnimalFilterMutation__
 *
 * To run a mutation, you first call `useUpdateAnimalFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnimalFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnimalFilterMutation, { data, loading, error }] = useUpdateAnimalFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnimalFilterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnimalFilterMutation, UpdateAnimalFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnimalFilterMutation, UpdateAnimalFilterMutationVariables>(UpdateAnimalFilterDocument, options);
      }
export type UpdateAnimalFilterMutationHookResult = ReturnType<typeof useUpdateAnimalFilterMutation>;
export type UpdateAnimalFilterMutationResult = Apollo.MutationResult<UpdateAnimalFilterMutation>;
export type UpdateAnimalFilterMutationOptions = Apollo.BaseMutationOptions<UpdateAnimalFilterMutation, UpdateAnimalFilterMutationVariables>;
export const DeleteAnimalFilterDocument = gql`
    mutation DeleteAnimalFilter($input: DeleteAnimalFilterInput!) {
  deleteAnimalFilter(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type DeleteAnimalFilterMutationFn = Apollo.MutationFunction<DeleteAnimalFilterMutation, DeleteAnimalFilterMutationVariables>;

/**
 * __useDeleteAnimalFilterMutation__
 *
 * To run a mutation, you first call `useDeleteAnimalFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnimalFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnimalFilterMutation, { data, loading, error }] = useDeleteAnimalFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAnimalFilterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnimalFilterMutation, DeleteAnimalFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnimalFilterMutation, DeleteAnimalFilterMutationVariables>(DeleteAnimalFilterDocument, options);
      }
export type DeleteAnimalFilterMutationHookResult = ReturnType<typeof useDeleteAnimalFilterMutation>;
export type DeleteAnimalFilterMutationResult = Apollo.MutationResult<DeleteAnimalFilterMutation>;
export type DeleteAnimalFilterMutationOptions = Apollo.BaseMutationOptions<DeleteAnimalFilterMutation, DeleteAnimalFilterMutationVariables>;
export const GetAnimalBreedsDocument = gql`
    query GetAnimalBreeds {
  animalBreeds {
    ...animalBreedsFragment
  }
}
    ${AnimalBreedsFragmentFragmentDoc}`;

/**
 * __useGetAnimalBreedsQuery__
 *
 * To run a query within a React component, call `useGetAnimalBreedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalBreedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalBreedsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnimalBreedsQuery(baseOptions?: Apollo.QueryHookOptions<GetAnimalBreedsQuery, GetAnimalBreedsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnimalBreedsQuery, GetAnimalBreedsQueryVariables>(GetAnimalBreedsDocument, options);
      }
export function useGetAnimalBreedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnimalBreedsQuery, GetAnimalBreedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnimalBreedsQuery, GetAnimalBreedsQueryVariables>(GetAnimalBreedsDocument, options);
        }
export type GetAnimalBreedsQueryHookResult = ReturnType<typeof useGetAnimalBreedsQuery>;
export type GetAnimalBreedsLazyQueryHookResult = ReturnType<typeof useGetAnimalBreedsLazyQuery>;
export type GetAnimalBreedsQueryResult = Apollo.QueryResult<GetAnimalBreedsQuery, GetAnimalBreedsQueryVariables>;
export const GetBusinessUnitBreedsDocument = gql`
    query GetBusinessUnitBreeds($businessUnitId: Int!, $animalTypeIds: [Int]) {
  businessUnitBreeds(
    businessUnitId: $businessUnitId
    animalTypeIds: $animalTypeIds
  ) {
    ...animalBreedsFragment
  }
}
    ${AnimalBreedsFragmentFragmentDoc}`;

/**
 * __useGetBusinessUnitBreedsQuery__
 *
 * To run a query within a React component, call `useGetBusinessUnitBreedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessUnitBreedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessUnitBreedsQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *      animalTypeIds: // value for 'animalTypeIds'
 *   },
 * });
 */
export function useGetBusinessUnitBreedsQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessUnitBreedsQuery, GetBusinessUnitBreedsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessUnitBreedsQuery, GetBusinessUnitBreedsQueryVariables>(GetBusinessUnitBreedsDocument, options);
      }
export function useGetBusinessUnitBreedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessUnitBreedsQuery, GetBusinessUnitBreedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessUnitBreedsQuery, GetBusinessUnitBreedsQueryVariables>(GetBusinessUnitBreedsDocument, options);
        }
export type GetBusinessUnitBreedsQueryHookResult = ReturnType<typeof useGetBusinessUnitBreedsQuery>;
export type GetBusinessUnitBreedsLazyQueryHookResult = ReturnType<typeof useGetBusinessUnitBreedsLazyQuery>;
export type GetBusinessUnitBreedsQueryResult = Apollo.QueryResult<GetBusinessUnitBreedsQuery, GetBusinessUnitBreedsQueryVariables>;
export const GetAnimalTypesDocument = gql`
    query GetAnimalTypes {
  animalTypes {
    ...animalTypeFragment
  }
}
    ${AnimalTypeFragmentFragmentDoc}`;

/**
 * __useGetAnimalTypesQuery__
 *
 * To run a query within a React component, call `useGetAnimalTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnimalTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAnimalTypesQuery, GetAnimalTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnimalTypesQuery, GetAnimalTypesQueryVariables>(GetAnimalTypesDocument, options);
      }
export function useGetAnimalTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnimalTypesQuery, GetAnimalTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnimalTypesQuery, GetAnimalTypesQueryVariables>(GetAnimalTypesDocument, options);
        }
export type GetAnimalTypesQueryHookResult = ReturnType<typeof useGetAnimalTypesQuery>;
export type GetAnimalTypesLazyQueryHookResult = ReturnType<typeof useGetAnimalTypesLazyQuery>;
export type GetAnimalTypesQueryResult = Apollo.QueryResult<GetAnimalTypesQuery, GetAnimalTypesQueryVariables>;
export const GetAnimalCategoriesDocument = gql`
    query GetAnimalCategories {
  animalTypes {
    id
    name
    categoriesOfSale {
      id
      category
      position
    }
  }
}
    `;

/**
 * __useGetAnimalCategoriesQuery__
 *
 * To run a query within a React component, call `useGetAnimalCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnimalCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAnimalCategoriesQuery, GetAnimalCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnimalCategoriesQuery, GetAnimalCategoriesQueryVariables>(GetAnimalCategoriesDocument, options);
      }
export function useGetAnimalCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnimalCategoriesQuery, GetAnimalCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnimalCategoriesQuery, GetAnimalCategoriesQueryVariables>(GetAnimalCategoriesDocument, options);
        }
export type GetAnimalCategoriesQueryHookResult = ReturnType<typeof useGetAnimalCategoriesQuery>;
export type GetAnimalCategoriesLazyQueryHookResult = ReturnType<typeof useGetAnimalCategoriesLazyQuery>;
export type GetAnimalCategoriesQueryResult = Apollo.QueryResult<GetAnimalCategoriesQuery, GetAnimalCategoriesQueryVariables>;
export const GetAnimalsListDocument = gql`
    query GetAnimalsList($animalTypeIds: [Int], $search: String, $businessUnitId: Int, $isDead: Boolean, $isWasOwned: Boolean, $group: UUID, $updatedFrom: DateTime, $isOnFarm: Boolean) {
  animalsExtended(
    animalTypeIds: $animalTypeIds
    search: $search
    businessUnitId: $businessUnitId
    isDead: $isDead
    isWasOwned: $isWasOwned
    group: $group
    updatedFrom: $updatedFrom
    isOnFarm: $isOnFarm
  ) {
    animals {
      ...animalFragment
    }
    animalsCount
  }
}
    ${AnimalFragmentFragmentDoc}`;

/**
 * __useGetAnimalsListQuery__
 *
 * To run a query within a React component, call `useGetAnimalsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalsListQuery({
 *   variables: {
 *      animalTypeIds: // value for 'animalTypeIds'
 *      search: // value for 'search'
 *      businessUnitId: // value for 'businessUnitId'
 *      isDead: // value for 'isDead'
 *      isWasOwned: // value for 'isWasOwned'
 *      group: // value for 'group'
 *      updatedFrom: // value for 'updatedFrom'
 *      isOnFarm: // value for 'isOnFarm'
 *   },
 * });
 */
export function useGetAnimalsListQuery(baseOptions?: Apollo.QueryHookOptions<GetAnimalsListQuery, GetAnimalsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnimalsListQuery, GetAnimalsListQueryVariables>(GetAnimalsListDocument, options);
      }
export function useGetAnimalsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnimalsListQuery, GetAnimalsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnimalsListQuery, GetAnimalsListQueryVariables>(GetAnimalsListDocument, options);
        }
export type GetAnimalsListQueryHookResult = ReturnType<typeof useGetAnimalsListQuery>;
export type GetAnimalsListLazyQueryHookResult = ReturnType<typeof useGetAnimalsListLazyQuery>;
export type GetAnimalsListQueryResult = Apollo.QueryResult<GetAnimalsListQuery, GetAnimalsListQueryVariables>;
export const GetAnimalsListWithPredictedDataDocument = gql`
    query GetAnimalsListWithPredictedData($search: String, $businessUnitId: Int, $isDead: Boolean, $isWasOwned: Boolean, $group: UUID, $updatedFrom: DateTime, $date: Date!) {
  animalsExtended(
    search: $search
    businessUnitId: $businessUnitId
    isDead: $isDead
    isWasOwned: $isWasOwned
    group: $group
    updatedFrom: $updatedFrom
  ) {
    animals {
      ...animalFragment
      estimatedAgeOn(date: $date)
      estimatedWeightOn(date: $date)
    }
    animalsCount
  }
}
    ${AnimalFragmentFragmentDoc}`;

/**
 * __useGetAnimalsListWithPredictedDataQuery__
 *
 * To run a query within a React component, call `useGetAnimalsListWithPredictedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalsListWithPredictedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalsListWithPredictedDataQuery({
 *   variables: {
 *      search: // value for 'search'
 *      businessUnitId: // value for 'businessUnitId'
 *      isDead: // value for 'isDead'
 *      isWasOwned: // value for 'isWasOwned'
 *      group: // value for 'group'
 *      updatedFrom: // value for 'updatedFrom'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetAnimalsListWithPredictedDataQuery(baseOptions: Apollo.QueryHookOptions<GetAnimalsListWithPredictedDataQuery, GetAnimalsListWithPredictedDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnimalsListWithPredictedDataQuery, GetAnimalsListWithPredictedDataQueryVariables>(GetAnimalsListWithPredictedDataDocument, options);
      }
export function useGetAnimalsListWithPredictedDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnimalsListWithPredictedDataQuery, GetAnimalsListWithPredictedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnimalsListWithPredictedDataQuery, GetAnimalsListWithPredictedDataQueryVariables>(GetAnimalsListWithPredictedDataDocument, options);
        }
export type GetAnimalsListWithPredictedDataQueryHookResult = ReturnType<typeof useGetAnimalsListWithPredictedDataQuery>;
export type GetAnimalsListWithPredictedDataLazyQueryHookResult = ReturnType<typeof useGetAnimalsListWithPredictedDataLazyQuery>;
export type GetAnimalsListWithPredictedDataQueryResult = Apollo.QueryResult<GetAnimalsListWithPredictedDataQuery, GetAnimalsListWithPredictedDataQueryVariables>;
export const GetAnimalByIdDocument = gql`
    query GetAnimalById($id: UUID!) {
  animal(id: $id) {
    ...singleAnimalFragment
  }
}
    ${SingleAnimalFragmentFragmentDoc}`;

/**
 * __useGetAnimalByIdQuery__
 *
 * To run a query within a React component, call `useGetAnimalByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAnimalByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAnimalByIdQuery, GetAnimalByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnimalByIdQuery, GetAnimalByIdQueryVariables>(GetAnimalByIdDocument, options);
      }
export function useGetAnimalByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnimalByIdQuery, GetAnimalByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnimalByIdQuery, GetAnimalByIdQueryVariables>(GetAnimalByIdDocument, options);
        }
export type GetAnimalByIdQueryHookResult = ReturnType<typeof useGetAnimalByIdQuery>;
export type GetAnimalByIdLazyQueryHookResult = ReturnType<typeof useGetAnimalByIdLazyQuery>;
export type GetAnimalByIdQueryResult = Apollo.QueryResult<GetAnimalByIdQuery, GetAnimalByIdQueryVariables>;
export const GetPerformanceChartDataDocument = gql`
    query GetPerformanceChartData($animal: UUID!) {
  performanceChartData(animal: $animal) {
    dates {
      timestamp
    }
    measurements {
      timestamp
      value
      high
      avg
      low
      age
      onTargetWeight
      dailyLiveWeightGain
      targetDailyLiveWeightGain
      diffTargetDailyLiveWeightGain
      daysToTarget
      daysToTargetWeight
    }
    predictions {
      timestamp
      value
    }
    low {
      timestamp
      value
    }
    avg {
      timestamp
      value
    }
    high {
      timestamp
      value
    }
    references {
      timestamp
      value
      label
      rfl
      context
    }
    targetWeights {
      timestamp
      value
    }
    contexts
  }
}
    `;

/**
 * __useGetPerformanceChartDataQuery__
 *
 * To run a query within a React component, call `useGetPerformanceChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPerformanceChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPerformanceChartDataQuery({
 *   variables: {
 *      animal: // value for 'animal'
 *   },
 * });
 */
export function useGetPerformanceChartDataQuery(baseOptions: Apollo.QueryHookOptions<GetPerformanceChartDataQuery, GetPerformanceChartDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPerformanceChartDataQuery, GetPerformanceChartDataQueryVariables>(GetPerformanceChartDataDocument, options);
      }
export function useGetPerformanceChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPerformanceChartDataQuery, GetPerformanceChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPerformanceChartDataQuery, GetPerformanceChartDataQueryVariables>(GetPerformanceChartDataDocument, options);
        }
export type GetPerformanceChartDataQueryHookResult = ReturnType<typeof useGetPerformanceChartDataQuery>;
export type GetPerformanceChartDataLazyQueryHookResult = ReturnType<typeof useGetPerformanceChartDataLazyQuery>;
export type GetPerformanceChartDataQueryResult = Apollo.QueryResult<GetPerformanceChartDataQuery, GetPerformanceChartDataQueryVariables>;
export const HasUnsyncedAnimalsDocument = gql`
    query HasUnsyncedAnimals($businessUnitId: Int!) {
  hasUnsyncedAnimals(businessUnitId: $businessUnitId)
}
    `;

/**
 * __useHasUnsyncedAnimalsQuery__
 *
 * To run a query within a React component, call `useHasUnsyncedAnimalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasUnsyncedAnimalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasUnsyncedAnimalsQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useHasUnsyncedAnimalsQuery(baseOptions: Apollo.QueryHookOptions<HasUnsyncedAnimalsQuery, HasUnsyncedAnimalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasUnsyncedAnimalsQuery, HasUnsyncedAnimalsQueryVariables>(HasUnsyncedAnimalsDocument, options);
      }
export function useHasUnsyncedAnimalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasUnsyncedAnimalsQuery, HasUnsyncedAnimalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasUnsyncedAnimalsQuery, HasUnsyncedAnimalsQueryVariables>(HasUnsyncedAnimalsDocument, options);
        }
export type HasUnsyncedAnimalsQueryHookResult = ReturnType<typeof useHasUnsyncedAnimalsQuery>;
export type HasUnsyncedAnimalsLazyQueryHookResult = ReturnType<typeof useHasUnsyncedAnimalsLazyQuery>;
export type HasUnsyncedAnimalsQueryResult = Apollo.QueryResult<HasUnsyncedAnimalsQuery, HasUnsyncedAnimalsQueryVariables>;
export const AnimalFiltersDocument = gql`
    query AnimalFilters($businessUnitId: Int!) {
  animalFilters(businessUnitId: $businessUnitId) {
    ...animalFiltersFragment
  }
}
    ${AnimalFiltersFragmentFragmentDoc}`;

/**
 * __useAnimalFiltersQuery__
 *
 * To run a query within a React component, call `useAnimalFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnimalFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnimalFiltersQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useAnimalFiltersQuery(baseOptions: Apollo.QueryHookOptions<AnimalFiltersQuery, AnimalFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnimalFiltersQuery, AnimalFiltersQueryVariables>(AnimalFiltersDocument, options);
      }
export function useAnimalFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnimalFiltersQuery, AnimalFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnimalFiltersQuery, AnimalFiltersQueryVariables>(AnimalFiltersDocument, options);
        }
export type AnimalFiltersQueryHookResult = ReturnType<typeof useAnimalFiltersQuery>;
export type AnimalFiltersLazyQueryHookResult = ReturnType<typeof useAnimalFiltersLazyQuery>;
export type AnimalFiltersQueryResult = Apollo.QueryResult<AnimalFiltersQuery, AnimalFiltersQueryVariables>;
export const AnimalFilterAlertsDocument = gql`
    query AnimalFilterAlerts($businessUnitId: Int!) {
  animalFilterAlerts(businessUnitId: $businessUnitId) {
    count
    animalFilter {
      id
      name
      color
      animalType {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAnimalFilterAlertsQuery__
 *
 * To run a query within a React component, call `useAnimalFilterAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnimalFilterAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnimalFilterAlertsQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useAnimalFilterAlertsQuery(baseOptions: Apollo.QueryHookOptions<AnimalFilterAlertsQuery, AnimalFilterAlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnimalFilterAlertsQuery, AnimalFilterAlertsQueryVariables>(AnimalFilterAlertsDocument, options);
      }
export function useAnimalFilterAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnimalFilterAlertsQuery, AnimalFilterAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnimalFilterAlertsQuery, AnimalFilterAlertsQueryVariables>(AnimalFilterAlertsDocument, options);
        }
export type AnimalFilterAlertsQueryHookResult = ReturnType<typeof useAnimalFilterAlertsQuery>;
export type AnimalFilterAlertsLazyQueryHookResult = ReturnType<typeof useAnimalFilterAlertsLazyQuery>;
export type AnimalFilterAlertsQueryResult = Apollo.QueryResult<AnimalFilterAlertsQuery, AnimalFilterAlertsQueryVariables>;
export const AnimalSexClassificationsDocument = gql`
    query AnimalSexClassifications($businessUnitId: Int!, $animalTypeIds: [Int]) {
  sexClassifications(
    businessUnitId: $businessUnitId
    animalTypeIds: $animalTypeIds
  ) {
    slug
    title
    animalType {
      id
    }
  }
}
    `;

/**
 * __useAnimalSexClassificationsQuery__
 *
 * To run a query within a React component, call `useAnimalSexClassificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnimalSexClassificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnimalSexClassificationsQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *      animalTypeIds: // value for 'animalTypeIds'
 *   },
 * });
 */
export function useAnimalSexClassificationsQuery(baseOptions: Apollo.QueryHookOptions<AnimalSexClassificationsQuery, AnimalSexClassificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnimalSexClassificationsQuery, AnimalSexClassificationsQueryVariables>(AnimalSexClassificationsDocument, options);
      }
export function useAnimalSexClassificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnimalSexClassificationsQuery, AnimalSexClassificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnimalSexClassificationsQuery, AnimalSexClassificationsQueryVariables>(AnimalSexClassificationsDocument, options);
        }
export type AnimalSexClassificationsQueryHookResult = ReturnType<typeof useAnimalSexClassificationsQuery>;
export type AnimalSexClassificationsLazyQueryHookResult = ReturnType<typeof useAnimalSexClassificationsLazyQuery>;
export type AnimalSexClassificationsQueryResult = Apollo.QueryResult<AnimalSexClassificationsQuery, AnimalSexClassificationsQueryVariables>;
export const GetAnimalOffspringDocument = gql`
    query GetAnimalOffspring($businessUnitId: Int!, $animalId: String!) {
  animalOffspring(businessUnitId: $businessUnitId, animalId: $animalId) {
    summary {
      animalsCount
      maleCount
      femaleCount
    }
    animals {
      ...animalOffspringFragment
    }
  }
}
    ${AnimalOffspringFragmentFragmentDoc}`;

/**
 * __useGetAnimalOffspringQuery__
 *
 * To run a query within a React component, call `useGetAnimalOffspringQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalOffspringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalOffspringQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *      animalId: // value for 'animalId'
 *   },
 * });
 */
export function useGetAnimalOffspringQuery(baseOptions: Apollo.QueryHookOptions<GetAnimalOffspringQuery, GetAnimalOffspringQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnimalOffspringQuery, GetAnimalOffspringQueryVariables>(GetAnimalOffspringDocument, options);
      }
export function useGetAnimalOffspringLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnimalOffspringQuery, GetAnimalOffspringQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnimalOffspringQuery, GetAnimalOffspringQueryVariables>(GetAnimalOffspringDocument, options);
        }
export type GetAnimalOffspringQueryHookResult = ReturnType<typeof useGetAnimalOffspringQuery>;
export type GetAnimalOffspringLazyQueryHookResult = ReturnType<typeof useGetAnimalOffspringLazyQuery>;
export type GetAnimalOffspringQueryResult = Apollo.QueryResult<GetAnimalOffspringQuery, GetAnimalOffspringQueryVariables>;
export const GetAnimalCountDocument = gql`
    query GetAnimalCount($businessUnit: Int!) {
  animalsCount(businessUnit: $businessUnit) {
    totalAnimals
  }
}
    `;

/**
 * __useGetAnimalCountQuery__
 *
 * To run a query within a React component, call `useGetAnimalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalCountQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useGetAnimalCountQuery(baseOptions: Apollo.QueryHookOptions<GetAnimalCountQuery, GetAnimalCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnimalCountQuery, GetAnimalCountQueryVariables>(GetAnimalCountDocument, options);
      }
export function useGetAnimalCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnimalCountQuery, GetAnimalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnimalCountQuery, GetAnimalCountQueryVariables>(GetAnimalCountDocument, options);
        }
export type GetAnimalCountQueryHookResult = ReturnType<typeof useGetAnimalCountQuery>;
export type GetAnimalCountLazyQueryHookResult = ReturnType<typeof useGetAnimalCountLazyQuery>;
export type GetAnimalCountQueryResult = Apollo.QueryResult<GetAnimalCountQuery, GetAnimalCountQueryVariables>;
export const CreateFieldDocument = gql`
    mutation CreateField($input: CreateFieldInput!) {
  createField(input: $input) {
    errors {
      ...errorFragment
    }
    field {
      ...fieldFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}
${FieldFragmentFragmentDoc}`;
export type CreateFieldMutationFn = Apollo.MutationFunction<CreateFieldMutation, CreateFieldMutationVariables>;

/**
 * __useCreateFieldMutation__
 *
 * To run a mutation, you first call `useCreateFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFieldMutation, { data, loading, error }] = useCreateFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFieldMutation(baseOptions?: Apollo.MutationHookOptions<CreateFieldMutation, CreateFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFieldMutation, CreateFieldMutationVariables>(CreateFieldDocument, options);
      }
export type CreateFieldMutationHookResult = ReturnType<typeof useCreateFieldMutation>;
export type CreateFieldMutationResult = Apollo.MutationResult<CreateFieldMutation>;
export type CreateFieldMutationOptions = Apollo.BaseMutationOptions<CreateFieldMutation, CreateFieldMutationVariables>;
export const UpdateFieldOldDocument = gql`
    mutation UpdateFieldOld($input: UpdateFieldInput!) {
  updateField(input: $input) {
    errors {
      ...errorFragment
    }
    field {
      ...fieldFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}
${FieldFragmentFragmentDoc}`;
export type UpdateFieldOldMutationFn = Apollo.MutationFunction<UpdateFieldOldMutation, UpdateFieldOldMutationVariables>;

/**
 * __useUpdateFieldOldMutation__
 *
 * To run a mutation, you first call `useUpdateFieldOldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFieldOldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFieldOldMutation, { data, loading, error }] = useUpdateFieldOldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFieldOldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFieldOldMutation, UpdateFieldOldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFieldOldMutation, UpdateFieldOldMutationVariables>(UpdateFieldOldDocument, options);
      }
export type UpdateFieldOldMutationHookResult = ReturnType<typeof useUpdateFieldOldMutation>;
export type UpdateFieldOldMutationResult = Apollo.MutationResult<UpdateFieldOldMutation>;
export type UpdateFieldOldMutationOptions = Apollo.BaseMutationOptions<UpdateFieldOldMutation, UpdateFieldOldMutationVariables>;
export const DeleteFieldDocument = gql`
    mutation DeleteField($input: DeleteFieldInput!) {
  deleteField(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type DeleteFieldMutationFn = Apollo.MutationFunction<DeleteFieldMutation, DeleteFieldMutationVariables>;

/**
 * __useDeleteFieldMutation__
 *
 * To run a mutation, you first call `useDeleteFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFieldMutation, { data, loading, error }] = useDeleteFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFieldMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFieldMutation, DeleteFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFieldMutation, DeleteFieldMutationVariables>(DeleteFieldDocument, options);
      }
export type DeleteFieldMutationHookResult = ReturnType<typeof useDeleteFieldMutation>;
export type DeleteFieldMutationResult = Apollo.MutationResult<DeleteFieldMutation>;
export type DeleteFieldMutationOptions = Apollo.BaseMutationOptions<DeleteFieldMutation, DeleteFieldMutationVariables>;
export const MoveAnimalsToFieldDocument = gql`
    mutation MoveAnimalsToField($input: MoveAnimalsToFieldInput!) {
  moveAnimalsToField(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type MoveAnimalsToFieldMutationFn = Apollo.MutationFunction<MoveAnimalsToFieldMutation, MoveAnimalsToFieldMutationVariables>;

/**
 * __useMoveAnimalsToFieldMutation__
 *
 * To run a mutation, you first call `useMoveAnimalsToFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveAnimalsToFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveAnimalsToFieldMutation, { data, loading, error }] = useMoveAnimalsToFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveAnimalsToFieldMutation(baseOptions?: Apollo.MutationHookOptions<MoveAnimalsToFieldMutation, MoveAnimalsToFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveAnimalsToFieldMutation, MoveAnimalsToFieldMutationVariables>(MoveAnimalsToFieldDocument, options);
      }
export type MoveAnimalsToFieldMutationHookResult = ReturnType<typeof useMoveAnimalsToFieldMutation>;
export type MoveAnimalsToFieldMutationResult = Apollo.MutationResult<MoveAnimalsToFieldMutation>;
export type MoveAnimalsToFieldMutationOptions = Apollo.BaseMutationOptions<MoveAnimalsToFieldMutation, MoveAnimalsToFieldMutationVariables>;
export const GetFieldsListDocument = gql`
    query GetFieldsList($businessUnitId: Int) {
  fields(businessUnitId: $businessUnitId) {
    ...fieldFragment
  }
}
    ${FieldFragmentFragmentDoc}`;

/**
 * __useGetFieldsListQuery__
 *
 * To run a query within a React component, call `useGetFieldsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFieldsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFieldsListQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useGetFieldsListQuery(baseOptions?: Apollo.QueryHookOptions<GetFieldsListQuery, GetFieldsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFieldsListQuery, GetFieldsListQueryVariables>(GetFieldsListDocument, options);
      }
export function useGetFieldsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFieldsListQuery, GetFieldsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFieldsListQuery, GetFieldsListQueryVariables>(GetFieldsListDocument, options);
        }
export type GetFieldsListQueryHookResult = ReturnType<typeof useGetFieldsListQuery>;
export type GetFieldsListLazyQueryHookResult = ReturnType<typeof useGetFieldsListLazyQuery>;
export type GetFieldsListQueryResult = Apollo.QueryResult<GetFieldsListQuery, GetFieldsListQueryVariables>;
export const GetPastureTypesDocument = gql`
    query GetPastureTypes {
  pastureTypes {
    ...pastureTypeFragment
  }
}
    ${PastureTypeFragmentFragmentDoc}`;

/**
 * __useGetPastureTypesQuery__
 *
 * To run a query within a React component, call `useGetPastureTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPastureTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPastureTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPastureTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetPastureTypesQuery, GetPastureTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPastureTypesQuery, GetPastureTypesQueryVariables>(GetPastureTypesDocument, options);
      }
export function useGetPastureTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPastureTypesQuery, GetPastureTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPastureTypesQuery, GetPastureTypesQueryVariables>(GetPastureTypesDocument, options);
        }
export type GetPastureTypesQueryHookResult = ReturnType<typeof useGetPastureTypesQuery>;
export type GetPastureTypesLazyQueryHookResult = ReturnType<typeof useGetPastureTypesLazyQuery>;
export type GetPastureTypesQueryResult = Apollo.QueryResult<GetPastureTypesQuery, GetPastureTypesQueryVariables>;
export const GetFieldDocument = gql`
    query GetField($id: UUID!) {
  field(id: $id) {
    ...fieldFragment
  }
}
    ${FieldFragmentFragmentDoc}`;

/**
 * __useGetFieldQuery__
 *
 * To run a query within a React component, call `useGetFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFieldQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFieldQuery(baseOptions: Apollo.QueryHookOptions<GetFieldQuery, GetFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFieldQuery, GetFieldQueryVariables>(GetFieldDocument, options);
      }
export function useGetFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFieldQuery, GetFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFieldQuery, GetFieldQueryVariables>(GetFieldDocument, options);
        }
export type GetFieldQueryHookResult = ReturnType<typeof useGetFieldQuery>;
export type GetFieldLazyQueryHookResult = ReturnType<typeof useGetFieldLazyQuery>;
export type GetFieldQueryResult = Apollo.QueryResult<GetFieldQuery, GetFieldQueryVariables>;
export const GetAnimalsFromFieldDocument = gql`
    query GetAnimalsFromField($id: UUID!) {
  field(id: $id) {
    id
    animals {
      id
      visualId
      eId
      animalBreeds {
        id
        name
      }
      passportNumber
      sexClassification {
        slug
        title
      }
      dob
      dateMovedToFarm
      currentWeight
      lastWeight {
        date
        value
      }
      targetDailyLiveWeightGain
      isPregnant
      pregnancyDueDate
      rflId
      deliveryDate
      tags {
        tagId
        name
        color
        schema {
          ownership
        }
      }
      group {
        id
        name
        daysTillTarget
      }
      field {
        id
        name
        location {
          id
          unitName
        }
      }
      isRegulatorySynced
      lastRegulatorySyncedDate
      isMale
      isCastrated
    }
  }
}
    `;

/**
 * __useGetAnimalsFromFieldQuery__
 *
 * To run a query within a React component, call `useGetAnimalsFromFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalsFromFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalsFromFieldQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAnimalsFromFieldQuery(baseOptions: Apollo.QueryHookOptions<GetAnimalsFromFieldQuery, GetAnimalsFromFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnimalsFromFieldQuery, GetAnimalsFromFieldQueryVariables>(GetAnimalsFromFieldDocument, options);
      }
export function useGetAnimalsFromFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnimalsFromFieldQuery, GetAnimalsFromFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnimalsFromFieldQuery, GetAnimalsFromFieldQueryVariables>(GetAnimalsFromFieldDocument, options);
        }
export type GetAnimalsFromFieldQueryHookResult = ReturnType<typeof useGetAnimalsFromFieldQuery>;
export type GetAnimalsFromFieldLazyQueryHookResult = ReturnType<typeof useGetAnimalsFromFieldLazyQuery>;
export type GetAnimalsFromFieldQueryResult = Apollo.QueryResult<GetAnimalsFromFieldQuery, GetAnimalsFromFieldQueryVariables>;
export const CreateGroupDocument = gql`
    mutation CreateGroup($input: CreateGroupInput!) {
  createGroup(input: $input) {
    group {
      ...groupFragment
    }
    errors {
      ...errorFragment
    }
  }
}
    ${GroupFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation UpdateGroup($input: UpdateGroupInput!) {
  updateGroup(input: $input) {
    group {
      ...groupFragment
    }
    errors {
      ...errorFragment
    }
  }
}
    ${GroupFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const DeleteGroupWithAnimalsDocument = gql`
    mutation DeleteGroupWithAnimals($input: DeleteGroupWithAnimalsInput!) {
  deleteGroupWithAnimals(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type DeleteGroupWithAnimalsMutationFn = Apollo.MutationFunction<DeleteGroupWithAnimalsMutation, DeleteGroupWithAnimalsMutationVariables>;

/**
 * __useDeleteGroupWithAnimalsMutation__
 *
 * To run a mutation, you first call `useDeleteGroupWithAnimalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupWithAnimalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupWithAnimalsMutation, { data, loading, error }] = useDeleteGroupWithAnimalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteGroupWithAnimalsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupWithAnimalsMutation, DeleteGroupWithAnimalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupWithAnimalsMutation, DeleteGroupWithAnimalsMutationVariables>(DeleteGroupWithAnimalsDocument, options);
      }
export type DeleteGroupWithAnimalsMutationHookResult = ReturnType<typeof useDeleteGroupWithAnimalsMutation>;
export type DeleteGroupWithAnimalsMutationResult = Apollo.MutationResult<DeleteGroupWithAnimalsMutation>;
export type DeleteGroupWithAnimalsMutationOptions = Apollo.BaseMutationOptions<DeleteGroupWithAnimalsMutation, DeleteGroupWithAnimalsMutationVariables>;
export const AssignAnimalsToGroupDocument = gql`
    mutation AssignAnimalsToGroup($input: MoveAnimalsToGroupInput!) {
  moveAnimalsToGroup(input: $input) {
    success
    groups {
      id
      name
    }
    animals {
      ...singleAnimalFragment
    }
    errors {
      ...errorFragment
    }
  }
}
    ${SingleAnimalFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type AssignAnimalsToGroupMutationFn = Apollo.MutationFunction<AssignAnimalsToGroupMutation, AssignAnimalsToGroupMutationVariables>;

/**
 * __useAssignAnimalsToGroupMutation__
 *
 * To run a mutation, you first call `useAssignAnimalsToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAnimalsToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAnimalsToGroupMutation, { data, loading, error }] = useAssignAnimalsToGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignAnimalsToGroupMutation(baseOptions?: Apollo.MutationHookOptions<AssignAnimalsToGroupMutation, AssignAnimalsToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignAnimalsToGroupMutation, AssignAnimalsToGroupMutationVariables>(AssignAnimalsToGroupDocument, options);
      }
export type AssignAnimalsToGroupMutationHookResult = ReturnType<typeof useAssignAnimalsToGroupMutation>;
export type AssignAnimalsToGroupMutationResult = Apollo.MutationResult<AssignAnimalsToGroupMutation>;
export type AssignAnimalsToGroupMutationOptions = Apollo.BaseMutationOptions<AssignAnimalsToGroupMutation, AssignAnimalsToGroupMutationVariables>;
export const MoveGroupsToFieldDocument = gql`
    mutation moveGroupsToField($input: MoveGroupsToFieldInput!) {
  moveGroupsToField(input: $input) {
    success
    groups {
      id
      name
    }
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type MoveGroupsToFieldMutationFn = Apollo.MutationFunction<MoveGroupsToFieldMutation, MoveGroupsToFieldMutationVariables>;

/**
 * __useMoveGroupsToFieldMutation__
 *
 * To run a mutation, you first call `useMoveGroupsToFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveGroupsToFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveGroupsToFieldMutation, { data, loading, error }] = useMoveGroupsToFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveGroupsToFieldMutation(baseOptions?: Apollo.MutationHookOptions<MoveGroupsToFieldMutation, MoveGroupsToFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveGroupsToFieldMutation, MoveGroupsToFieldMutationVariables>(MoveGroupsToFieldDocument, options);
      }
export type MoveGroupsToFieldMutationHookResult = ReturnType<typeof useMoveGroupsToFieldMutation>;
export type MoveGroupsToFieldMutationResult = Apollo.MutationResult<MoveGroupsToFieldMutation>;
export type MoveGroupsToFieldMutationOptions = Apollo.BaseMutationOptions<MoveGroupsToFieldMutation, MoveGroupsToFieldMutationVariables>;
export const CreateBatchDocument = gql`
    mutation createBatch($input: CreateBatchInput!) {
  createBatch(input: $input) {
    group {
      id
      name
    }
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type CreateBatchMutationFn = Apollo.MutationFunction<CreateBatchMutation, CreateBatchMutationVariables>;

/**
 * __useCreateBatchMutation__
 *
 * To run a mutation, you first call `useCreateBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBatchMutation, { data, loading, error }] = useCreateBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBatchMutation(baseOptions?: Apollo.MutationHookOptions<CreateBatchMutation, CreateBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBatchMutation, CreateBatchMutationVariables>(CreateBatchDocument, options);
      }
export type CreateBatchMutationHookResult = ReturnType<typeof useCreateBatchMutation>;
export type CreateBatchMutationResult = Apollo.MutationResult<CreateBatchMutation>;
export type CreateBatchMutationOptions = Apollo.BaseMutationOptions<CreateBatchMutation, CreateBatchMutationVariables>;
export const UpdateBatchDocument = gql`
    mutation updateBatch($input: UpdateBatchInput!) {
  updateBatch(input: $input) {
    group {
      id
      name
    }
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type UpdateBatchMutationFn = Apollo.MutationFunction<UpdateBatchMutation, UpdateBatchMutationVariables>;

/**
 * __useUpdateBatchMutation__
 *
 * To run a mutation, you first call `useUpdateBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBatchMutation, { data, loading, error }] = useUpdateBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBatchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBatchMutation, UpdateBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBatchMutation, UpdateBatchMutationVariables>(UpdateBatchDocument, options);
      }
export type UpdateBatchMutationHookResult = ReturnType<typeof useUpdateBatchMutation>;
export type UpdateBatchMutationResult = Apollo.MutationResult<UpdateBatchMutation>;
export type UpdateBatchMutationOptions = Apollo.BaseMutationOptions<UpdateBatchMutation, UpdateBatchMutationVariables>;
export const GetGroupsListDocument = gql`
    query GetGroupsList($businessUnitId: Int, $animalTypeIds: [Int]) {
  groupsExtended(businessUnitId: $businessUnitId, animalTypeIds: $animalTypeIds) {
    groups {
      ...batchProperties
      ...groupFragment
    }
  }
}
    ${BatchPropertiesFragmentDoc}
${GroupFragmentFragmentDoc}`;

/**
 * __useGetGroupsListQuery__
 *
 * To run a query within a React component, call `useGetGroupsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsListQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *      animalTypeIds: // value for 'animalTypeIds'
 *   },
 * });
 */
export function useGetGroupsListQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupsListQuery, GetGroupsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsListQuery, GetGroupsListQueryVariables>(GetGroupsListDocument, options);
      }
export function useGetGroupsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsListQuery, GetGroupsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsListQuery, GetGroupsListQueryVariables>(GetGroupsListDocument, options);
        }
export type GetGroupsListQueryHookResult = ReturnType<typeof useGetGroupsListQuery>;
export type GetGroupsListLazyQueryHookResult = ReturnType<typeof useGetGroupsListLazyQuery>;
export type GetGroupsListQueryResult = Apollo.QueryResult<GetGroupsListQuery, GetGroupsListQueryVariables>;
export const GetGroupDocument = gql`
    query GetGroup($group: UUID!, $businessUnit: Int!) {
  group(group: $group, businessUnit: $businessUnit) {
    ...batchProperties
    ...singleGroupFragment
  }
}
    ${BatchPropertiesFragmentDoc}
${SingleGroupFragmentFragmentDoc}`;

/**
 * __useGetGroupQuery__
 *
 * To run a query within a React component, call `useGetGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupQuery({
 *   variables: {
 *      group: // value for 'group'
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useGetGroupQuery(baseOptions: Apollo.QueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
      }
export function useGetGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
        }
export type GetGroupQueryHookResult = ReturnType<typeof useGetGroupQuery>;
export type GetGroupLazyQueryHookResult = ReturnType<typeof useGetGroupLazyQuery>;
export type GetGroupQueryResult = Apollo.QueryResult<GetGroupQuery, GetGroupQueryVariables>;
export const GetBatchTermsDocument = gql`
    query GetBatchTerms {
  animalTypes {
    id
    name
    batchName {
      name
      plural
    }
  }
}
    `;

/**
 * __useGetBatchTermsQuery__
 *
 * To run a query within a React component, call `useGetBatchTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBatchTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBatchTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBatchTermsQuery(baseOptions?: Apollo.QueryHookOptions<GetBatchTermsQuery, GetBatchTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBatchTermsQuery, GetBatchTermsQueryVariables>(GetBatchTermsDocument, options);
      }
export function useGetBatchTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBatchTermsQuery, GetBatchTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBatchTermsQuery, GetBatchTermsQueryVariables>(GetBatchTermsDocument, options);
        }
export type GetBatchTermsQueryHookResult = ReturnType<typeof useGetBatchTermsQuery>;
export type GetBatchTermsLazyQueryHookResult = ReturnType<typeof useGetBatchTermsLazyQuery>;
export type GetBatchTermsQueryResult = Apollo.QueryResult<GetBatchTermsQuery, GetBatchTermsQueryVariables>;
export const GetBatchByIdDocument = gql`
    query GetBatchById($group: UUID!, $businessUnit: Int!) {
  group(group: $group, businessUnit: $businessUnit) {
    ...batchProperties
    ...singleGroupFragment
  }
}
    ${BatchPropertiesFragmentDoc}
${SingleGroupFragmentFragmentDoc}`;

/**
 * __useGetBatchByIdQuery__
 *
 * To run a query within a React component, call `useGetBatchByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBatchByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBatchByIdQuery({
 *   variables: {
 *      group: // value for 'group'
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useGetBatchByIdQuery(baseOptions: Apollo.QueryHookOptions<GetBatchByIdQuery, GetBatchByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBatchByIdQuery, GetBatchByIdQueryVariables>(GetBatchByIdDocument, options);
      }
export function useGetBatchByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBatchByIdQuery, GetBatchByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBatchByIdQuery, GetBatchByIdQueryVariables>(GetBatchByIdDocument, options);
        }
export type GetBatchByIdQueryHookResult = ReturnType<typeof useGetBatchByIdQuery>;
export type GetBatchByIdLazyQueryHookResult = ReturnType<typeof useGetBatchByIdLazyQuery>;
export type GetBatchByIdQueryResult = Apollo.QueryResult<GetBatchByIdQuery, GetBatchByIdQueryVariables>;
export const GetOrganizationsDocument = gql`
    query GetOrganizations {
  organisations {
    organisation {
      ...Organisation
    }
    businessUnits {
      ...BUFragment
    }
  }
}
    ${OrganisationFragmentDoc}
${BuFragmentFragmentDoc}`;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetOrganisationBusinessUnitsDocument = gql`
    query GetOrganisationBusinessUnits($businessUnitId: Int!) {
  organisationBusinessUnits(businessUnit: $businessUnitId) {
    organisation {
      ...Organisation
    }
    ...BUFragment
  }
}
    ${OrganisationFragmentDoc}
${BuFragmentFragmentDoc}`;

/**
 * __useGetOrganisationBusinessUnitsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationBusinessUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationBusinessUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationBusinessUnitsQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useGetOrganisationBusinessUnitsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationBusinessUnitsQuery, GetOrganisationBusinessUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationBusinessUnitsQuery, GetOrganisationBusinessUnitsQueryVariables>(GetOrganisationBusinessUnitsDocument, options);
      }
export function useGetOrganisationBusinessUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationBusinessUnitsQuery, GetOrganisationBusinessUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationBusinessUnitsQuery, GetOrganisationBusinessUnitsQueryVariables>(GetOrganisationBusinessUnitsDocument, options);
        }
export type GetOrganisationBusinessUnitsQueryHookResult = ReturnType<typeof useGetOrganisationBusinessUnitsQuery>;
export type GetOrganisationBusinessUnitsLazyQueryHookResult = ReturnType<typeof useGetOrganisationBusinessUnitsLazyQuery>;
export type GetOrganisationBusinessUnitsQueryResult = Apollo.QueryResult<GetOrganisationBusinessUnitsQuery, GetOrganisationBusinessUnitsQueryVariables>;
export const GetProducerGroupsDocument = gql`
    query GetProducerGroups($businessUnit: Int!) {
  producerGroups(businessUnit: $businessUnit) {
    ...producerGroupFragment
  }
}
    ${ProducerGroupFragmentFragmentDoc}`;

/**
 * __useGetProducerGroupsQuery__
 *
 * To run a query within a React component, call `useGetProducerGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProducerGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProducerGroupsQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useGetProducerGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetProducerGroupsQuery, GetProducerGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProducerGroupsQuery, GetProducerGroupsQueryVariables>(GetProducerGroupsDocument, options);
      }
export function useGetProducerGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProducerGroupsQuery, GetProducerGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProducerGroupsQuery, GetProducerGroupsQueryVariables>(GetProducerGroupsDocument, options);
        }
export type GetProducerGroupsQueryHookResult = ReturnType<typeof useGetProducerGroupsQuery>;
export type GetProducerGroupsLazyQueryHookResult = ReturnType<typeof useGetProducerGroupsLazyQuery>;
export type GetProducerGroupsQueryResult = Apollo.QueryResult<GetProducerGroupsQuery, GetProducerGroupsQueryVariables>;
export const RegulatoryTransactionApprovalsResponseDocument = gql`
    mutation RegulatoryTransactionApprovalsResponse($input: RegulatoryTransactionApprovalsResponseInput!) {
  regulatoryTransactionApprovalsResponse(input: $input) {
    regulatoryTransactionApprovals {
      id
      actualStatus
    }
    errors {
      field
      code
    }
  }
}
    `;
export type RegulatoryTransactionApprovalsResponseMutationFn = Apollo.MutationFunction<RegulatoryTransactionApprovalsResponseMutation, RegulatoryTransactionApprovalsResponseMutationVariables>;

/**
 * __useRegulatoryTransactionApprovalsResponseMutation__
 *
 * To run a mutation, you first call `useRegulatoryTransactionApprovalsResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegulatoryTransactionApprovalsResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regulatoryTransactionApprovalsResponseMutation, { data, loading, error }] = useRegulatoryTransactionApprovalsResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegulatoryTransactionApprovalsResponseMutation(baseOptions?: Apollo.MutationHookOptions<RegulatoryTransactionApprovalsResponseMutation, RegulatoryTransactionApprovalsResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegulatoryTransactionApprovalsResponseMutation, RegulatoryTransactionApprovalsResponseMutationVariables>(RegulatoryTransactionApprovalsResponseDocument, options);
      }
export type RegulatoryTransactionApprovalsResponseMutationHookResult = ReturnType<typeof useRegulatoryTransactionApprovalsResponseMutation>;
export type RegulatoryTransactionApprovalsResponseMutationResult = Apollo.MutationResult<RegulatoryTransactionApprovalsResponseMutation>;
export type RegulatoryTransactionApprovalsResponseMutationOptions = Apollo.BaseMutationOptions<RegulatoryTransactionApprovalsResponseMutation, RegulatoryTransactionApprovalsResponseMutationVariables>;
export const RegulatoryTransactionApprovalsRetryDocument = gql`
    mutation RegulatoryTransactionApprovalsRetry($input: RegulatoryTransactionApprovalsRetryInput!) {
  regulatoryTransactionApprovalsRetry(input: $input) {
    regulatoryTransactionApprovals {
      id
      actualStatus
    }
    errors {
      field
      code
    }
  }
}
    `;
export type RegulatoryTransactionApprovalsRetryMutationFn = Apollo.MutationFunction<RegulatoryTransactionApprovalsRetryMutation, RegulatoryTransactionApprovalsRetryMutationVariables>;

/**
 * __useRegulatoryTransactionApprovalsRetryMutation__
 *
 * To run a mutation, you first call `useRegulatoryTransactionApprovalsRetryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegulatoryTransactionApprovalsRetryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regulatoryTransactionApprovalsRetryMutation, { data, loading, error }] = useRegulatoryTransactionApprovalsRetryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegulatoryTransactionApprovalsRetryMutation(baseOptions?: Apollo.MutationHookOptions<RegulatoryTransactionApprovalsRetryMutation, RegulatoryTransactionApprovalsRetryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegulatoryTransactionApprovalsRetryMutation, RegulatoryTransactionApprovalsRetryMutationVariables>(RegulatoryTransactionApprovalsRetryDocument, options);
      }
export type RegulatoryTransactionApprovalsRetryMutationHookResult = ReturnType<typeof useRegulatoryTransactionApprovalsRetryMutation>;
export type RegulatoryTransactionApprovalsRetryMutationResult = Apollo.MutationResult<RegulatoryTransactionApprovalsRetryMutation>;
export type RegulatoryTransactionApprovalsRetryMutationOptions = Apollo.BaseMutationOptions<RegulatoryTransactionApprovalsRetryMutation, RegulatoryTransactionApprovalsRetryMutationVariables>;
export const RegulatoryTransactionApprovalsChangeDateDocument = gql`
    mutation RegulatoryTransactionApprovalsChangeDate($input: RegulatoryTransactionApprovalsChangeDateInput!) {
  regulatoryTransactionApprovalsChangeDate(input: $input) {
    regulatoryTransactionApprovals {
      id
      actualStatus
      sourceActivity {
        date
      }
    }
    errors {
      field
      code
    }
  }
}
    `;
export type RegulatoryTransactionApprovalsChangeDateMutationFn = Apollo.MutationFunction<RegulatoryTransactionApprovalsChangeDateMutation, RegulatoryTransactionApprovalsChangeDateMutationVariables>;

/**
 * __useRegulatoryTransactionApprovalsChangeDateMutation__
 *
 * To run a mutation, you first call `useRegulatoryTransactionApprovalsChangeDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegulatoryTransactionApprovalsChangeDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regulatoryTransactionApprovalsChangeDateMutation, { data, loading, error }] = useRegulatoryTransactionApprovalsChangeDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegulatoryTransactionApprovalsChangeDateMutation(baseOptions?: Apollo.MutationHookOptions<RegulatoryTransactionApprovalsChangeDateMutation, RegulatoryTransactionApprovalsChangeDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegulatoryTransactionApprovalsChangeDateMutation, RegulatoryTransactionApprovalsChangeDateMutationVariables>(RegulatoryTransactionApprovalsChangeDateDocument, options);
      }
export type RegulatoryTransactionApprovalsChangeDateMutationHookResult = ReturnType<typeof useRegulatoryTransactionApprovalsChangeDateMutation>;
export type RegulatoryTransactionApprovalsChangeDateMutationResult = Apollo.MutationResult<RegulatoryTransactionApprovalsChangeDateMutation>;
export type RegulatoryTransactionApprovalsChangeDateMutationOptions = Apollo.BaseMutationOptions<RegulatoryTransactionApprovalsChangeDateMutation, RegulatoryTransactionApprovalsChangeDateMutationVariables>;
export const RegulatoryTransactionApprovalsAbortDocument = gql`
    mutation RegulatoryTransactionApprovalsAbort($input: RegulatoryTransactionApprovalsAbortInput!) {
  regulatoryTransactionApprovalsAbort(input: $input) {
    regulatoryTransactionApprovals {
      id
      actualStatus
      reasonOfFailure
    }
    errors {
      field
      code
    }
  }
}
    `;
export type RegulatoryTransactionApprovalsAbortMutationFn = Apollo.MutationFunction<RegulatoryTransactionApprovalsAbortMutation, RegulatoryTransactionApprovalsAbortMutationVariables>;

/**
 * __useRegulatoryTransactionApprovalsAbortMutation__
 *
 * To run a mutation, you first call `useRegulatoryTransactionApprovalsAbortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegulatoryTransactionApprovalsAbortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regulatoryTransactionApprovalsAbortMutation, { data, loading, error }] = useRegulatoryTransactionApprovalsAbortMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegulatoryTransactionApprovalsAbortMutation(baseOptions?: Apollo.MutationHookOptions<RegulatoryTransactionApprovalsAbortMutation, RegulatoryTransactionApprovalsAbortMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegulatoryTransactionApprovalsAbortMutation, RegulatoryTransactionApprovalsAbortMutationVariables>(RegulatoryTransactionApprovalsAbortDocument, options);
      }
export type RegulatoryTransactionApprovalsAbortMutationHookResult = ReturnType<typeof useRegulatoryTransactionApprovalsAbortMutation>;
export type RegulatoryTransactionApprovalsAbortMutationResult = Apollo.MutationResult<RegulatoryTransactionApprovalsAbortMutation>;
export type RegulatoryTransactionApprovalsAbortMutationOptions = Apollo.BaseMutationOptions<RegulatoryTransactionApprovalsAbortMutation, RegulatoryTransactionApprovalsAbortMutationVariables>;
export const RegulatoryTransactionApprovalSummaryDocument = gql`
    query RegulatoryTransactionApprovalSummary($businessUnitId: Int!) {
  regulatoryTransactionApprovalSummary(businessUnitId: $businessUnitId) {
    id
    type
    pending
    inProgress
    failed
    successful
  }
}
    `;

/**
 * __useRegulatoryTransactionApprovalSummaryQuery__
 *
 * To run a query within a React component, call `useRegulatoryTransactionApprovalSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulatoryTransactionApprovalSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulatoryTransactionApprovalSummaryQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useRegulatoryTransactionApprovalSummaryQuery(baseOptions: Apollo.QueryHookOptions<RegulatoryTransactionApprovalSummaryQuery, RegulatoryTransactionApprovalSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegulatoryTransactionApprovalSummaryQuery, RegulatoryTransactionApprovalSummaryQueryVariables>(RegulatoryTransactionApprovalSummaryDocument, options);
      }
export function useRegulatoryTransactionApprovalSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegulatoryTransactionApprovalSummaryQuery, RegulatoryTransactionApprovalSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegulatoryTransactionApprovalSummaryQuery, RegulatoryTransactionApprovalSummaryQueryVariables>(RegulatoryTransactionApprovalSummaryDocument, options);
        }
export type RegulatoryTransactionApprovalSummaryQueryHookResult = ReturnType<typeof useRegulatoryTransactionApprovalSummaryQuery>;
export type RegulatoryTransactionApprovalSummaryLazyQueryHookResult = ReturnType<typeof useRegulatoryTransactionApprovalSummaryLazyQuery>;
export type RegulatoryTransactionApprovalSummaryQueryResult = Apollo.QueryResult<RegulatoryTransactionApprovalSummaryQuery, RegulatoryTransactionApprovalSummaryQueryVariables>;
export const RegulatoryTransactionApprovalsDocument = gql`
    query RegulatoryTransactionApprovals($businessUnitId: Int!, $transactionType: String!, $statuses: [String!]) {
  regulatoryTransactionApprovals(
    businessUnitId: $businessUnitId
    transactionType: $transactionType
    statuses: $statuses
  ) {
    ...regulatoryTransactionApprovalFragment
  }
}
    ${RegulatoryTransactionApprovalFragmentFragmentDoc}`;

/**
 * __useRegulatoryTransactionApprovalsQuery__
 *
 * To run a query within a React component, call `useRegulatoryTransactionApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulatoryTransactionApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulatoryTransactionApprovalsQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *      transactionType: // value for 'transactionType'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useRegulatoryTransactionApprovalsQuery(baseOptions: Apollo.QueryHookOptions<RegulatoryTransactionApprovalsQuery, RegulatoryTransactionApprovalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegulatoryTransactionApprovalsQuery, RegulatoryTransactionApprovalsQueryVariables>(RegulatoryTransactionApprovalsDocument, options);
      }
export function useRegulatoryTransactionApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegulatoryTransactionApprovalsQuery, RegulatoryTransactionApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegulatoryTransactionApprovalsQuery, RegulatoryTransactionApprovalsQueryVariables>(RegulatoryTransactionApprovalsDocument, options);
        }
export type RegulatoryTransactionApprovalsQueryHookResult = ReturnType<typeof useRegulatoryTransactionApprovalsQuery>;
export type RegulatoryTransactionApprovalsLazyQueryHookResult = ReturnType<typeof useRegulatoryTransactionApprovalsLazyQuery>;
export type RegulatoryTransactionApprovalsQueryResult = Apollo.QueryResult<RegulatoryTransactionApprovalsQuery, RegulatoryTransactionApprovalsQueryVariables>;
export const RegulatoryTransactionApprovalsWithWarningDocument = gql`
    query RegulatoryTransactionApprovalsWithWarning($businessUnitId: Int!, $transactionType: String!) {
  regulatoryTransactionApprovalsWithWarning(
    businessUnitId: $businessUnitId
    transactionType: $transactionType
  ) {
    ...regulatoryTransactionApprovalFragment
  }
}
    ${RegulatoryTransactionApprovalFragmentFragmentDoc}`;

/**
 * __useRegulatoryTransactionApprovalsWithWarningQuery__
 *
 * To run a query within a React component, call `useRegulatoryTransactionApprovalsWithWarningQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulatoryTransactionApprovalsWithWarningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulatoryTransactionApprovalsWithWarningQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *      transactionType: // value for 'transactionType'
 *   },
 * });
 */
export function useRegulatoryTransactionApprovalsWithWarningQuery(baseOptions: Apollo.QueryHookOptions<RegulatoryTransactionApprovalsWithWarningQuery, RegulatoryTransactionApprovalsWithWarningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegulatoryTransactionApprovalsWithWarningQuery, RegulatoryTransactionApprovalsWithWarningQueryVariables>(RegulatoryTransactionApprovalsWithWarningDocument, options);
      }
export function useRegulatoryTransactionApprovalsWithWarningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegulatoryTransactionApprovalsWithWarningQuery, RegulatoryTransactionApprovalsWithWarningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegulatoryTransactionApprovalsWithWarningQuery, RegulatoryTransactionApprovalsWithWarningQueryVariables>(RegulatoryTransactionApprovalsWithWarningDocument, options);
        }
export type RegulatoryTransactionApprovalsWithWarningQueryHookResult = ReturnType<typeof useRegulatoryTransactionApprovalsWithWarningQuery>;
export type RegulatoryTransactionApprovalsWithWarningLazyQueryHookResult = ReturnType<typeof useRegulatoryTransactionApprovalsWithWarningLazyQuery>;
export type RegulatoryTransactionApprovalsWithWarningQueryResult = Apollo.QueryResult<RegulatoryTransactionApprovalsWithWarningQuery, RegulatoryTransactionApprovalsWithWarningQueryVariables>;
export const RegulatoryTransactionWarningsDocument = gql`
    query RegulatoryTransactionWarnings($businessUnitId: Int!) {
  regulatoryTransactionWarnings(businessUnitId: $businessUnitId) {
    type
    count
    lapseOfTime
  }
}
    `;

/**
 * __useRegulatoryTransactionWarningsQuery__
 *
 * To run a query within a React component, call `useRegulatoryTransactionWarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulatoryTransactionWarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulatoryTransactionWarningsQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useRegulatoryTransactionWarningsQuery(baseOptions: Apollo.QueryHookOptions<RegulatoryTransactionWarningsQuery, RegulatoryTransactionWarningsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegulatoryTransactionWarningsQuery, RegulatoryTransactionWarningsQueryVariables>(RegulatoryTransactionWarningsDocument, options);
      }
export function useRegulatoryTransactionWarningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegulatoryTransactionWarningsQuery, RegulatoryTransactionWarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegulatoryTransactionWarningsQuery, RegulatoryTransactionWarningsQueryVariables>(RegulatoryTransactionWarningsDocument, options);
        }
export type RegulatoryTransactionWarningsQueryHookResult = ReturnType<typeof useRegulatoryTransactionWarningsQuery>;
export type RegulatoryTransactionWarningsLazyQueryHookResult = ReturnType<typeof useRegulatoryTransactionWarningsLazyQuery>;
export type RegulatoryTransactionWarningsQueryResult = Apollo.QueryResult<RegulatoryTransactionWarningsQuery, RegulatoryTransactionWarningsQueryVariables>;
export const GetReportsListDocument = gql`
    query GetReportsList($businessUnit: Int, $species: Int) {
  reports(businessUnit: $businessUnit, species: $species) {
    ...reportsFragment
  }
}
    ${ReportsFragmentFragmentDoc}`;

/**
 * __useGetReportsListQuery__
 *
 * To run a query within a React component, call `useGetReportsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsListQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *      species: // value for 'species'
 *   },
 * });
 */
export function useGetReportsListQuery(baseOptions?: Apollo.QueryHookOptions<GetReportsListQuery, GetReportsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsListQuery, GetReportsListQueryVariables>(GetReportsListDocument, options);
      }
export function useGetReportsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsListQuery, GetReportsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsListQuery, GetReportsListQueryVariables>(GetReportsListDocument, options);
        }
export type GetReportsListQueryHookResult = ReturnType<typeof useGetReportsListQuery>;
export type GetReportsListLazyQueryHookResult = ReturnType<typeof useGetReportsListLazyQuery>;
export type GetReportsListQueryResult = Apollo.QueryResult<GetReportsListQuery, GetReportsListQueryVariables>;
export const GetReportUrlDocument = gql`
    query GetReportUrl($embedUrl: String!) {
  sisenseEmbedUrl(embedUrl: $embedUrl) {
    url
  }
}
    `;

/**
 * __useGetReportUrlQuery__
 *
 * To run a query within a React component, call `useGetReportUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportUrlQuery({
 *   variables: {
 *      embedUrl: // value for 'embedUrl'
 *   },
 * });
 */
export function useGetReportUrlQuery(baseOptions: Apollo.QueryHookOptions<GetReportUrlQuery, GetReportUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportUrlQuery, GetReportUrlQueryVariables>(GetReportUrlDocument, options);
      }
export function useGetReportUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportUrlQuery, GetReportUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportUrlQuery, GetReportUrlQueryVariables>(GetReportUrlDocument, options);
        }
export type GetReportUrlQueryHookResult = ReturnType<typeof useGetReportUrlQuery>;
export type GetReportUrlLazyQueryHookResult = ReturnType<typeof useGetReportUrlLazyQuery>;
export type GetReportUrlQueryResult = Apollo.QueryResult<GetReportUrlQuery, GetReportUrlQueryVariables>;
export const GetMainReportDocument = gql`
    query GetMainReport($businessUnit: Int!) {
  mainReport(businessUnit: $businessUnit) {
    id
    title
    url
  }
}
    `;

/**
 * __useGetMainReportQuery__
 *
 * To run a query within a React component, call `useGetMainReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMainReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMainReportQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useGetMainReportQuery(baseOptions: Apollo.QueryHookOptions<GetMainReportQuery, GetMainReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMainReportQuery, GetMainReportQueryVariables>(GetMainReportDocument, options);
      }
export function useGetMainReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMainReportQuery, GetMainReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMainReportQuery, GetMainReportQueryVariables>(GetMainReportDocument, options);
        }
export type GetMainReportQueryHookResult = ReturnType<typeof useGetMainReportQuery>;
export type GetMainReportLazyQueryHookResult = ReturnType<typeof useGetMainReportLazyQuery>;
export type GetMainReportQueryResult = Apollo.QueryResult<GetMainReportQuery, GetMainReportQueryVariables>;
export const GetQuicksightEmbedUrlDocument = gql`
    query getQuicksightEmbedUrl($businessUnit: Int!, $embedUrl: String!) {
  quicksightEmbedUrl(businessUnit: $businessUnit, embedUrl: $embedUrl) {
    url
    parameters {
      code
      value
    }
  }
}
    `;

/**
 * __useGetQuicksightEmbedUrlQuery__
 *
 * To run a query within a React component, call `useGetQuicksightEmbedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuicksightEmbedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuicksightEmbedUrlQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *      embedUrl: // value for 'embedUrl'
 *   },
 * });
 */
export function useGetQuicksightEmbedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetQuicksightEmbedUrlQuery, GetQuicksightEmbedUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuicksightEmbedUrlQuery, GetQuicksightEmbedUrlQueryVariables>(GetQuicksightEmbedUrlDocument, options);
      }
export function useGetQuicksightEmbedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuicksightEmbedUrlQuery, GetQuicksightEmbedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuicksightEmbedUrlQuery, GetQuicksightEmbedUrlQueryVariables>(GetQuicksightEmbedUrlDocument, options);
        }
export type GetQuicksightEmbedUrlQueryHookResult = ReturnType<typeof useGetQuicksightEmbedUrlQuery>;
export type GetQuicksightEmbedUrlLazyQueryHookResult = ReturnType<typeof useGetQuicksightEmbedUrlLazyQuery>;
export type GetQuicksightEmbedUrlQueryResult = Apollo.QueryResult<GetQuicksightEmbedUrlQuery, GetQuicksightEmbedUrlQueryVariables>;
export const CreateFarmSystemDocument = gql`
    mutation CreateFarmSystem($input: CreateFarmSystemInput!) {
  createFarmSystem(input: $input) {
    farmSystem {
      ...farmSystemFragment
    }
    errors {
      ...errorFragment
    }
  }
}
    ${FarmSystemFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type CreateFarmSystemMutationFn = Apollo.MutationFunction<CreateFarmSystemMutation, CreateFarmSystemMutationVariables>;

/**
 * __useCreateFarmSystemMutation__
 *
 * To run a mutation, you first call `useCreateFarmSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFarmSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFarmSystemMutation, { data, loading, error }] = useCreateFarmSystemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFarmSystemMutation(baseOptions?: Apollo.MutationHookOptions<CreateFarmSystemMutation, CreateFarmSystemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFarmSystemMutation, CreateFarmSystemMutationVariables>(CreateFarmSystemDocument, options);
      }
export type CreateFarmSystemMutationHookResult = ReturnType<typeof useCreateFarmSystemMutation>;
export type CreateFarmSystemMutationResult = Apollo.MutationResult<CreateFarmSystemMutation>;
export type CreateFarmSystemMutationOptions = Apollo.BaseMutationOptions<CreateFarmSystemMutation, CreateFarmSystemMutationVariables>;
export const UpdateFarmSystemDocument = gql`
    mutation UpdateFarmSystem($input: UpdateFarmSystemInput!) {
  updateFarmSystem(input: $input) {
    farmSystem {
      ...farmSystemFragment
    }
    errors {
      ...errorFragment
    }
  }
}
    ${FarmSystemFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type UpdateFarmSystemMutationFn = Apollo.MutationFunction<UpdateFarmSystemMutation, UpdateFarmSystemMutationVariables>;

/**
 * __useUpdateFarmSystemMutation__
 *
 * To run a mutation, you first call `useUpdateFarmSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFarmSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFarmSystemMutation, { data, loading, error }] = useUpdateFarmSystemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFarmSystemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFarmSystemMutation, UpdateFarmSystemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFarmSystemMutation, UpdateFarmSystemMutationVariables>(UpdateFarmSystemDocument, options);
      }
export type UpdateFarmSystemMutationHookResult = ReturnType<typeof useUpdateFarmSystemMutation>;
export type UpdateFarmSystemMutationResult = Apollo.MutationResult<UpdateFarmSystemMutation>;
export type UpdateFarmSystemMutationOptions = Apollo.BaseMutationOptions<UpdateFarmSystemMutation, UpdateFarmSystemMutationVariables>;
export const DeleteFarmSystemDocument = gql`
    mutation DeleteFarmSystem($input: DeleteFarmSystemInput!) {
  deleteFarmSystem(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type DeleteFarmSystemMutationFn = Apollo.MutationFunction<DeleteFarmSystemMutation, DeleteFarmSystemMutationVariables>;

/**
 * __useDeleteFarmSystemMutation__
 *
 * To run a mutation, you first call `useDeleteFarmSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFarmSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFarmSystemMutation, { data, loading, error }] = useDeleteFarmSystemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFarmSystemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFarmSystemMutation, DeleteFarmSystemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFarmSystemMutation, DeleteFarmSystemMutationVariables>(DeleteFarmSystemDocument, options);
      }
export type DeleteFarmSystemMutationHookResult = ReturnType<typeof useDeleteFarmSystemMutation>;
export type DeleteFarmSystemMutationResult = Apollo.MutationResult<DeleteFarmSystemMutation>;
export type DeleteFarmSystemMutationOptions = Apollo.BaseMutationOptions<DeleteFarmSystemMutation, DeleteFarmSystemMutationVariables>;
export const BcmsServiceRequestGeneratePdfDocument = gql`
    mutation BcmsServiceRequestGeneratePdf($input: BcmsServiceRequestGeneratePdfInput!) {
  bcmsServiceRequestGeneratePdf(input: $input) {
    url
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type BcmsServiceRequestGeneratePdfMutationFn = Apollo.MutationFunction<BcmsServiceRequestGeneratePdfMutation, BcmsServiceRequestGeneratePdfMutationVariables>;

/**
 * __useBcmsServiceRequestGeneratePdfMutation__
 *
 * To run a mutation, you first call `useBcmsServiceRequestGeneratePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBcmsServiceRequestGeneratePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bcmsServiceRequestGeneratePdfMutation, { data, loading, error }] = useBcmsServiceRequestGeneratePdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBcmsServiceRequestGeneratePdfMutation(baseOptions?: Apollo.MutationHookOptions<BcmsServiceRequestGeneratePdfMutation, BcmsServiceRequestGeneratePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BcmsServiceRequestGeneratePdfMutation, BcmsServiceRequestGeneratePdfMutationVariables>(BcmsServiceRequestGeneratePdfDocument, options);
      }
export type BcmsServiceRequestGeneratePdfMutationHookResult = ReturnType<typeof useBcmsServiceRequestGeneratePdfMutation>;
export type BcmsServiceRequestGeneratePdfMutationResult = Apollo.MutationResult<BcmsServiceRequestGeneratePdfMutation>;
export type BcmsServiceRequestGeneratePdfMutationOptions = Apollo.BaseMutationOptions<BcmsServiceRequestGeneratePdfMutation, BcmsServiceRequestGeneratePdfMutationVariables>;
export const CreateBankDetailsDocument = gql`
    mutation CreateBankDetails($input: CreateBankDetailsInput!) {
  createBankDetails(input: $input) {
    bankDetails {
      id
    }
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type CreateBankDetailsMutationFn = Apollo.MutationFunction<CreateBankDetailsMutation, CreateBankDetailsMutationVariables>;

/**
 * __useCreateBankDetailsMutation__
 *
 * To run a mutation, you first call `useCreateBankDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBankDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBankDetailsMutation, { data, loading, error }] = useCreateBankDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBankDetailsMutation(baseOptions?: Apollo.MutationHookOptions<CreateBankDetailsMutation, CreateBankDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBankDetailsMutation, CreateBankDetailsMutationVariables>(CreateBankDetailsDocument, options);
      }
export type CreateBankDetailsMutationHookResult = ReturnType<typeof useCreateBankDetailsMutation>;
export type CreateBankDetailsMutationResult = Apollo.MutationResult<CreateBankDetailsMutation>;
export type CreateBankDetailsMutationOptions = Apollo.BaseMutationOptions<CreateBankDetailsMutation, CreateBankDetailsMutationVariables>;
export const UpdateBankDetailsDocument = gql`
    mutation UpdateBankDetails($input: UpdateBankDetailsInput!) {
  updateBankDetails(input: $input) {
    bankDetails {
      id
    }
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type UpdateBankDetailsMutationFn = Apollo.MutationFunction<UpdateBankDetailsMutation, UpdateBankDetailsMutationVariables>;

/**
 * __useUpdateBankDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateBankDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBankDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBankDetailsMutation, { data, loading, error }] = useUpdateBankDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBankDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBankDetailsMutation, UpdateBankDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBankDetailsMutation, UpdateBankDetailsMutationVariables>(UpdateBankDetailsDocument, options);
      }
export type UpdateBankDetailsMutationHookResult = ReturnType<typeof useUpdateBankDetailsMutation>;
export type UpdateBankDetailsMutationResult = Apollo.MutationResult<UpdateBankDetailsMutation>;
export type UpdateBankDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateBankDetailsMutation, UpdateBankDetailsMutationVariables>;
export const UpdateIdentifierPreferencesDocument = gql`
    mutation UpdateIdentifierPreferences($input: UpdateIdentifierPreferencesInput!) {
  updateIdentifierPreferences(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type UpdateIdentifierPreferencesMutationFn = Apollo.MutationFunction<UpdateIdentifierPreferencesMutation, UpdateIdentifierPreferencesMutationVariables>;

/**
 * __useUpdateIdentifierPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateIdentifierPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIdentifierPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIdentifierPreferencesMutation, { data, loading, error }] = useUpdateIdentifierPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIdentifierPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIdentifierPreferencesMutation, UpdateIdentifierPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIdentifierPreferencesMutation, UpdateIdentifierPreferencesMutationVariables>(UpdateIdentifierPreferencesDocument, options);
      }
export type UpdateIdentifierPreferencesMutationHookResult = ReturnType<typeof useUpdateIdentifierPreferencesMutation>;
export type UpdateIdentifierPreferencesMutationResult = Apollo.MutationResult<UpdateIdentifierPreferencesMutation>;
export type UpdateIdentifierPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateIdentifierPreferencesMutation, UpdateIdentifierPreferencesMutationVariables>;
export const GetFarmSystemsDocument = gql`
    query GetFarmSystems($farm: Int!) {
  farmSystems(farm: $farm) {
    ...farmSystemFragment
  }
}
    ${FarmSystemFragmentFragmentDoc}`;

/**
 * __useGetFarmSystemsQuery__
 *
 * To run a query within a React component, call `useGetFarmSystemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFarmSystemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFarmSystemsQuery({
 *   variables: {
 *      farm: // value for 'farm'
 *   },
 * });
 */
export function useGetFarmSystemsQuery(baseOptions: Apollo.QueryHookOptions<GetFarmSystemsQuery, GetFarmSystemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFarmSystemsQuery, GetFarmSystemsQueryVariables>(GetFarmSystemsDocument, options);
      }
export function useGetFarmSystemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFarmSystemsQuery, GetFarmSystemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFarmSystemsQuery, GetFarmSystemsQueryVariables>(GetFarmSystemsDocument, options);
        }
export type GetFarmSystemsQueryHookResult = ReturnType<typeof useGetFarmSystemsQuery>;
export type GetFarmSystemsLazyQueryHookResult = ReturnType<typeof useGetFarmSystemsLazyQuery>;
export type GetFarmSystemsQueryResult = Apollo.QueryResult<GetFarmSystemsQuery, GetFarmSystemsQueryVariables>;
export const GetSettingsFaqDocument = gql`
    query GetSettingsFaq($businessUnitId: Int!) {
  settingsFaq(businessUnitId: $businessUnitId) {
    id
    title
    description
  }
}
    `;

/**
 * __useGetSettingsFaqQuery__
 *
 * To run a query within a React component, call `useGetSettingsFaqQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsFaqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsFaqQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useGetSettingsFaqQuery(baseOptions: Apollo.QueryHookOptions<GetSettingsFaqQuery, GetSettingsFaqQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettingsFaqQuery, GetSettingsFaqQueryVariables>(GetSettingsFaqDocument, options);
      }
export function useGetSettingsFaqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettingsFaqQuery, GetSettingsFaqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettingsFaqQuery, GetSettingsFaqQueryVariables>(GetSettingsFaqDocument, options);
        }
export type GetSettingsFaqQueryHookResult = ReturnType<typeof useGetSettingsFaqQuery>;
export type GetSettingsFaqLazyQueryHookResult = ReturnType<typeof useGetSettingsFaqLazyQuery>;
export type GetSettingsFaqQueryResult = Apollo.QueryResult<GetSettingsFaqQuery, GetSettingsFaqQueryVariables>;
export const GetTermsDocument = gql`
    query GetTerms($tacType: String!) {
  termsAndConditions(tacType: $tacType) {
    id
    title
    description
    type
  }
}
    `;

/**
 * __useGetTermsQuery__
 *
 * To run a query within a React component, call `useGetTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsQuery({
 *   variables: {
 *      tacType: // value for 'tacType'
 *   },
 * });
 */
export function useGetTermsQuery(baseOptions: Apollo.QueryHookOptions<GetTermsQuery, GetTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTermsQuery, GetTermsQueryVariables>(GetTermsDocument, options);
      }
export function useGetTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTermsQuery, GetTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTermsQuery, GetTermsQueryVariables>(GetTermsDocument, options);
        }
export type GetTermsQueryHookResult = ReturnType<typeof useGetTermsQuery>;
export type GetTermsLazyQueryHookResult = ReturnType<typeof useGetTermsLazyQuery>;
export type GetTermsQueryResult = Apollo.QueryResult<GetTermsQuery, GetTermsQueryVariables>;
export const GetBankDetailsDocument = gql`
    query GetBankDetails($businessUnitId: Int) {
  bankDetails(businessUnitId: $businessUnitId) {
    id
    accountNo
    accountName
    sortCode
    isBusinessAccount
  }
}
    `;

/**
 * __useGetBankDetailsQuery__
 *
 * To run a query within a React component, call `useGetBankDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankDetailsQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useGetBankDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetBankDetailsQuery, GetBankDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankDetailsQuery, GetBankDetailsQueryVariables>(GetBankDetailsDocument, options);
      }
export function useGetBankDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankDetailsQuery, GetBankDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankDetailsQuery, GetBankDetailsQueryVariables>(GetBankDetailsDocument, options);
        }
export type GetBankDetailsQueryHookResult = ReturnType<typeof useGetBankDetailsQuery>;
export type GetBankDetailsLazyQueryHookResult = ReturnType<typeof useGetBankDetailsLazyQuery>;
export type GetBankDetailsQueryResult = Apollo.QueryResult<GetBankDetailsQuery, GetBankDetailsQueryVariables>;
export const GetIdentifierPreferencesDocument = gql`
    query GetIdentifierPreferences($businessUnit: Int!) {
  businessUnit(businessUnit: $businessUnit) {
    guid
    identifierPreferencesActiveIds {
      passportNumber
      visualId
      eId
      name
      trichId
      tsuBarcode
      pedigreeId
      tattoo
      herdDoggId
      breedrId
      uhfId
      brucellosisId
      alternativeId
    }
    identifierPreferencesPrimaryId
    identifierPreferencesSecondaryId
  }
}
    `;

/**
 * __useGetIdentifierPreferencesQuery__
 *
 * To run a query within a React component, call `useGetIdentifierPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdentifierPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdentifierPreferencesQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useGetIdentifierPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetIdentifierPreferencesQuery, GetIdentifierPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIdentifierPreferencesQuery, GetIdentifierPreferencesQueryVariables>(GetIdentifierPreferencesDocument, options);
      }
export function useGetIdentifierPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIdentifierPreferencesQuery, GetIdentifierPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIdentifierPreferencesQuery, GetIdentifierPreferencesQueryVariables>(GetIdentifierPreferencesDocument, options);
        }
export type GetIdentifierPreferencesQueryHookResult = ReturnType<typeof useGetIdentifierPreferencesQuery>;
export type GetIdentifierPreferencesLazyQueryHookResult = ReturnType<typeof useGetIdentifierPreferencesLazyQuery>;
export type GetIdentifierPreferencesQueryResult = Apollo.QueryResult<GetIdentifierPreferencesQuery, GetIdentifierPreferencesQueryVariables>;
export const DeleteSireDocument = gql`
    mutation DeleteSire($input: DeleteSireInput!) {
  deleteSire(input: $input) {
    success
  }
}
    `;
export type DeleteSireMutationFn = Apollo.MutationFunction<DeleteSireMutation, DeleteSireMutationVariables>;

/**
 * __useDeleteSireMutation__
 *
 * To run a mutation, you first call `useDeleteSireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSireMutation, { data, loading, error }] = useDeleteSireMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSireMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSireMutation, DeleteSireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSireMutation, DeleteSireMutationVariables>(DeleteSireDocument, options);
      }
export type DeleteSireMutationHookResult = ReturnType<typeof useDeleteSireMutation>;
export type DeleteSireMutationResult = Apollo.MutationResult<DeleteSireMutation>;
export type DeleteSireMutationOptions = Apollo.BaseMutationOptions<DeleteSireMutation, DeleteSireMutationVariables>;
export const CreateSireDocument = gql`
    mutation CreateSire($input: CreateSireInput!) {
  createSire(input: $input) {
    sire {
      ...sireFragment
    }
    success
    errors {
      ...errorFragment
    }
  }
}
    ${SireFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type CreateSireMutationFn = Apollo.MutationFunction<CreateSireMutation, CreateSireMutationVariables>;

/**
 * __useCreateSireMutation__
 *
 * To run a mutation, you first call `useCreateSireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSireMutation, { data, loading, error }] = useCreateSireMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSireMutation(baseOptions?: Apollo.MutationHookOptions<CreateSireMutation, CreateSireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSireMutation, CreateSireMutationVariables>(CreateSireDocument, options);
      }
export type CreateSireMutationHookResult = ReturnType<typeof useCreateSireMutation>;
export type CreateSireMutationResult = Apollo.MutationResult<CreateSireMutation>;
export type CreateSireMutationOptions = Apollo.BaseMutationOptions<CreateSireMutation, CreateSireMutationVariables>;
export const UpdateSireDocument = gql`
    mutation UpdateSire($input: UpdateSireInput!) {
  updateSire(input: $input) {
    sire {
      ...sireFragment
    }
    success
    errors {
      ...errorFragment
    }
  }
}
    ${SireFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type UpdateSireMutationFn = Apollo.MutationFunction<UpdateSireMutation, UpdateSireMutationVariables>;

/**
 * __useUpdateSireMutation__
 *
 * To run a mutation, you first call `useUpdateSireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSireMutation, { data, loading, error }] = useUpdateSireMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSireMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSireMutation, UpdateSireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSireMutation, UpdateSireMutationVariables>(UpdateSireDocument, options);
      }
export type UpdateSireMutationHookResult = ReturnType<typeof useUpdateSireMutation>;
export type UpdateSireMutationResult = Apollo.MutationResult<UpdateSireMutation>;
export type UpdateSireMutationOptions = Apollo.BaseMutationOptions<UpdateSireMutation, UpdateSireMutationVariables>;
export const GetSiresListDocument = gql`
    query GetSiresList($businessUnitId: Int!) {
  sires(businessUnitId: $businessUnitId) {
    ...sireFragment
  }
}
    ${SireFragmentFragmentDoc}`;

/**
 * __useGetSiresListQuery__
 *
 * To run a query within a React component, call `useGetSiresListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiresListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiresListQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useGetSiresListQuery(baseOptions: Apollo.QueryHookOptions<GetSiresListQuery, GetSiresListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiresListQuery, GetSiresListQueryVariables>(GetSiresListDocument, options);
      }
export function useGetSiresListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiresListQuery, GetSiresListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiresListQuery, GetSiresListQueryVariables>(GetSiresListDocument, options);
        }
export type GetSiresListQueryHookResult = ReturnType<typeof useGetSiresListQuery>;
export type GetSiresListLazyQueryHookResult = ReturnType<typeof useGetSiresListLazyQuery>;
export type GetSiresListQueryResult = Apollo.QueryResult<GetSiresListQuery, GetSiresListQueryVariables>;
export const GetSireByIdDocument = gql`
    query GetSireById($id: UUID!, $businessUnitId: Int!) {
  sire(id: $id, businessUnitId: $businessUnitId) {
    ...sireFragment
  }
}
    ${SireFragmentFragmentDoc}`;

/**
 * __useGetSireByIdQuery__
 *
 * To run a query within a React component, call `useGetSireByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSireByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSireByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useGetSireByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSireByIdQuery, GetSireByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSireByIdQuery, GetSireByIdQueryVariables>(GetSireByIdDocument, options);
      }
export function useGetSireByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSireByIdQuery, GetSireByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSireByIdQuery, GetSireByIdQueryVariables>(GetSireByIdDocument, options);
        }
export type GetSireByIdQueryHookResult = ReturnType<typeof useGetSireByIdQuery>;
export type GetSireByIdLazyQueryHookResult = ReturnType<typeof useGetSireByIdLazyQuery>;
export type GetSireByIdQueryResult = Apollo.QueryResult<GetSireByIdQuery, GetSireByIdQueryVariables>;
export const UpdateEmailDocument = gql`
    mutation updateEmail($input: UpdateEmailInput!) {
  updateEmail(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type UpdateEmailMutationFn = Apollo.MutationFunction<UpdateEmailMutation, UpdateEmailMutationVariables>;

/**
 * __useUpdateEmailMutation__
 *
 * To run a mutation, you first call `useUpdateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailMutation, { data, loading, error }] = useUpdateEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailMutation, UpdateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailMutation, UpdateEmailMutationVariables>(UpdateEmailDocument, options);
      }
export type UpdateEmailMutationHookResult = ReturnType<typeof useUpdateEmailMutation>;
export type UpdateEmailMutationResult = Apollo.MutationResult<UpdateEmailMutation>;
export type UpdateEmailMutationOptions = Apollo.BaseMutationOptions<UpdateEmailMutation, UpdateEmailMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation updatePassword($input: UpdatePasswordInput!) {
  updatePassword(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const UpdateUserDataDocument = gql`
    mutation UpdateUserData($input: UpdateUserInput!) {
  updateUserInfo(input: $input) {
    user {
      ...UserInfoFragment
    }
    errors {
      ...errorFragment
    }
  }
}
    ${UserInfoFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type UpdateUserDataMutationFn = Apollo.MutationFunction<UpdateUserDataMutation, UpdateUserDataMutationVariables>;

/**
 * __useUpdateUserDataMutation__
 *
 * To run a mutation, you first call `useUpdateUserDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDataMutation, { data, loading, error }] = useUpdateUserDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDataMutation, UpdateUserDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDataMutation, UpdateUserDataMutationVariables>(UpdateUserDataDocument, options);
      }
export type UpdateUserDataMutationHookResult = ReturnType<typeof useUpdateUserDataMutation>;
export type UpdateUserDataMutationResult = Apollo.MutationResult<UpdateUserDataMutation>;
export type UpdateUserDataMutationOptions = Apollo.BaseMutationOptions<UpdateUserDataMutation, UpdateUserDataMutationVariables>;
export const InviteUserDocument = gql`
    mutation InviteUser($input: InviteUserInput!) {
  inviteUser(input: $input) {
    businessUnitUser {
      ...businessUnitUser
    }
    errors {
      ...errorFragment
    }
  }
}
    ${BusinessUnitUserFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const TransferUserOwnershipDocument = gql`
    mutation TransferUserOwnership($input: TransferOwnershipInput!) {
  transferOwnership(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type TransferUserOwnershipMutationFn = Apollo.MutationFunction<TransferUserOwnershipMutation, TransferUserOwnershipMutationVariables>;

/**
 * __useTransferUserOwnershipMutation__
 *
 * To run a mutation, you first call `useTransferUserOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferUserOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferUserOwnershipMutation, { data, loading, error }] = useTransferUserOwnershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferUserOwnershipMutation(baseOptions?: Apollo.MutationHookOptions<TransferUserOwnershipMutation, TransferUserOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferUserOwnershipMutation, TransferUserOwnershipMutationVariables>(TransferUserOwnershipDocument, options);
      }
export type TransferUserOwnershipMutationHookResult = ReturnType<typeof useTransferUserOwnershipMutation>;
export type TransferUserOwnershipMutationResult = Apollo.MutationResult<TransferUserOwnershipMutation>;
export type TransferUserOwnershipMutationOptions = Apollo.BaseMutationOptions<TransferUserOwnershipMutation, TransferUserOwnershipMutationVariables>;
export const SentResetPasswordEmailDocument = gql`
    mutation SentResetPasswordEmail($input: SendResetPasswordEmailInput!) {
  sendResetPasswordEmail(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type SentResetPasswordEmailMutationFn = Apollo.MutationFunction<SentResetPasswordEmailMutation, SentResetPasswordEmailMutationVariables>;

/**
 * __useSentResetPasswordEmailMutation__
 *
 * To run a mutation, you first call `useSentResetPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSentResetPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sentResetPasswordEmailMutation, { data, loading, error }] = useSentResetPasswordEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSentResetPasswordEmailMutation(baseOptions?: Apollo.MutationHookOptions<SentResetPasswordEmailMutation, SentResetPasswordEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SentResetPasswordEmailMutation, SentResetPasswordEmailMutationVariables>(SentResetPasswordEmailDocument, options);
      }
export type SentResetPasswordEmailMutationHookResult = ReturnType<typeof useSentResetPasswordEmailMutation>;
export type SentResetPasswordEmailMutationResult = Apollo.MutationResult<SentResetPasswordEmailMutation>;
export type SentResetPasswordEmailMutationOptions = Apollo.BaseMutationOptions<SentResetPasswordEmailMutation, SentResetPasswordEmailMutationVariables>;
export const CompleteInviteDocument = gql`
    mutation CompleteInvite($input: CompleteInvitationInput!) {
  completeInvite(input: $input) {
    token
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type CompleteInviteMutationFn = Apollo.MutationFunction<CompleteInviteMutation, CompleteInviteMutationVariables>;

/**
 * __useCompleteInviteMutation__
 *
 * To run a mutation, you first call `useCompleteInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeInviteMutation, { data, loading, error }] = useCompleteInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteInviteMutation(baseOptions?: Apollo.MutationHookOptions<CompleteInviteMutation, CompleteInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteInviteMutation, CompleteInviteMutationVariables>(CompleteInviteDocument, options);
      }
export type CompleteInviteMutationHookResult = ReturnType<typeof useCompleteInviteMutation>;
export type CompleteInviteMutationResult = Apollo.MutationResult<CompleteInviteMutation>;
export type CompleteInviteMutationOptions = Apollo.BaseMutationOptions<CompleteInviteMutation, CompleteInviteMutationVariables>;
export const ResentInviteDocument = gql`
    mutation ResentInvite($input: ReInviteUserInput!) {
  reInviteUser(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type ResentInviteMutationFn = Apollo.MutationFunction<ResentInviteMutation, ResentInviteMutationVariables>;

/**
 * __useResentInviteMutation__
 *
 * To run a mutation, you first call `useResentInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResentInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resentInviteMutation, { data, loading, error }] = useResentInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResentInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResentInviteMutation, ResentInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResentInviteMutation, ResentInviteMutationVariables>(ResentInviteDocument, options);
      }
export type ResentInviteMutationHookResult = ReturnType<typeof useResentInviteMutation>;
export type ResentInviteMutationResult = Apollo.MutationResult<ResentInviteMutation>;
export type ResentInviteMutationOptions = Apollo.BaseMutationOptions<ResentInviteMutation, ResentInviteMutationVariables>;
export const DeleteUserFromFarmDocument = gql`
    mutation DeleteUserFromFarm($input: DeleteUserFromFarmInput!) {
  deleteUserFromFarm(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type DeleteUserFromFarmMutationFn = Apollo.MutationFunction<DeleteUserFromFarmMutation, DeleteUserFromFarmMutationVariables>;

/**
 * __useDeleteUserFromFarmMutation__
 *
 * To run a mutation, you first call `useDeleteUserFromFarmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserFromFarmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserFromFarmMutation, { data, loading, error }] = useDeleteUserFromFarmMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserFromFarmMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserFromFarmMutation, DeleteUserFromFarmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserFromFarmMutation, DeleteUserFromFarmMutationVariables>(DeleteUserFromFarmDocument, options);
      }
export type DeleteUserFromFarmMutationHookResult = ReturnType<typeof useDeleteUserFromFarmMutation>;
export type DeleteUserFromFarmMutationResult = Apollo.MutationResult<DeleteUserFromFarmMutation>;
export type DeleteUserFromFarmMutationOptions = Apollo.BaseMutationOptions<DeleteUserFromFarmMutation, DeleteUserFromFarmMutationVariables>;
export const UpdateBusinessUnitUserDocument = gql`
    mutation UpdateBusinessUnitUser($input: UpdateBusinessUnitUserInput!) {
  updateBusinessUnitUser(input: $input) {
    businessUnitUser {
      ...businessUnitUser
    }
    errors {
      ...errorFragment
    }
  }
}
    ${BusinessUnitUserFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type UpdateBusinessUnitUserMutationFn = Apollo.MutationFunction<UpdateBusinessUnitUserMutation, UpdateBusinessUnitUserMutationVariables>;

/**
 * __useUpdateBusinessUnitUserMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessUnitUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessUnitUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessUnitUserMutation, { data, loading, error }] = useUpdateBusinessUnitUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBusinessUnitUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessUnitUserMutation, UpdateBusinessUnitUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessUnitUserMutation, UpdateBusinessUnitUserMutationVariables>(UpdateBusinessUnitUserDocument, options);
      }
export type UpdateBusinessUnitUserMutationHookResult = ReturnType<typeof useUpdateBusinessUnitUserMutation>;
export type UpdateBusinessUnitUserMutationResult = Apollo.MutationResult<UpdateBusinessUnitUserMutation>;
export type UpdateBusinessUnitUserMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessUnitUserMutation, UpdateBusinessUnitUserMutationVariables>;
export const GetUserDocument = gql`
    query GetUser {
  userInfo {
    ...UserInfoFragment
  }
}
    ${UserInfoFragmentFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const SearchUserDocument = gql`
    query SearchUser($search: String) {
  searchUser(search: $search) {
    ...ownerFragment
  }
}
    ${OwnerFragmentFragmentDoc}`;

/**
 * __useSearchUserQuery__
 *
 * To run a query within a React component, call `useSearchUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchUserQuery(baseOptions?: Apollo.QueryHookOptions<SearchUserQuery, SearchUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
      }
export function useSearchUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUserQuery, SearchUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
        }
export type SearchUserQueryHookResult = ReturnType<typeof useSearchUserQuery>;
export type SearchUserLazyQueryHookResult = ReturnType<typeof useSearchUserLazyQuery>;
export type SearchUserQueryResult = Apollo.QueryResult<SearchUserQuery, SearchUserQueryVariables>;
export const RolesListDocument = gql`
    query RolesList {
  roles {
    id
    name
  }
}
    `;

/**
 * __useRolesListQuery__
 *
 * To run a query within a React component, call `useRolesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolesListQuery(baseOptions?: Apollo.QueryHookOptions<RolesListQuery, RolesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesListQuery, RolesListQueryVariables>(RolesListDocument, options);
      }
export function useRolesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesListQuery, RolesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesListQuery, RolesListQueryVariables>(RolesListDocument, options);
        }
export type RolesListQueryHookResult = ReturnType<typeof useRolesListQuery>;
export type RolesListLazyQueryHookResult = ReturnType<typeof useRolesListLazyQuery>;
export type RolesListQueryResult = Apollo.QueryResult<RolesListQuery, RolesListQueryVariables>;
export const CommitDeliveryDocument = gql`
    mutation CommitDelivery($input: CommitDeliveryInput!) {
  commitDelivery(input: $input) {
    clientMutationId
    success
    errors {
      field
      message
    }
    delivery {
      ...Delivery
    }
  }
}
    ${DeliveryFragmentDoc}`;
export type CommitDeliveryMutationFn = Apollo.MutationFunction<CommitDeliveryMutation, CommitDeliveryMutationVariables>;

/**
 * __useCommitDeliveryMutation__
 *
 * To run a mutation, you first call `useCommitDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitDeliveryMutation, { data, loading, error }] = useCommitDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommitDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<CommitDeliveryMutation, CommitDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommitDeliveryMutation, CommitDeliveryMutationVariables>(CommitDeliveryDocument, options);
      }
export type CommitDeliveryMutationHookResult = ReturnType<typeof useCommitDeliveryMutation>;
export type CommitDeliveryMutationResult = Apollo.MutationResult<CommitDeliveryMutation>;
export type CommitDeliveryMutationOptions = Apollo.BaseMutationOptions<CommitDeliveryMutation, CommitDeliveryMutationVariables>;
export const CreateDeliveryDocument = gql`
    mutation CreateDelivery($input: CreateDeliveryInput!) {
  createDelivery(input: $input) {
    clientMutationId
    success
    errors {
      field
      message
    }
    delivery {
      ...Delivery
    }
  }
}
    ${DeliveryFragmentDoc}`;
export type CreateDeliveryMutationFn = Apollo.MutationFunction<CreateDeliveryMutation, CreateDeliveryMutationVariables>;

/**
 * __useCreateDeliveryMutation__
 *
 * To run a mutation, you first call `useCreateDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliveryMutation, { data, loading, error }] = useCreateDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeliveryMutation, CreateDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeliveryMutation, CreateDeliveryMutationVariables>(CreateDeliveryDocument, options);
      }
export type CreateDeliveryMutationHookResult = ReturnType<typeof useCreateDeliveryMutation>;
export type CreateDeliveryMutationResult = Apollo.MutationResult<CreateDeliveryMutation>;
export type CreateDeliveryMutationOptions = Apollo.BaseMutationOptions<CreateDeliveryMutation, CreateDeliveryMutationVariables>;
export const UpdateDeliveryDocument = gql`
    mutation UpdateDelivery($input: UpdateDeliveryInput!) {
  updateDelivery(input: $input) {
    clientMutationId
    success
    errors {
      field
      message
    }
    delivery {
      ...Delivery
    }
  }
}
    ${DeliveryFragmentDoc}`;
export type UpdateDeliveryMutationFn = Apollo.MutationFunction<UpdateDeliveryMutation, UpdateDeliveryMutationVariables>;

/**
 * __useUpdateDeliveryMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryMutation, { data, loading, error }] = useUpdateDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryMutation, UpdateDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryMutation, UpdateDeliveryMutationVariables>(UpdateDeliveryDocument, options);
      }
export type UpdateDeliveryMutationHookResult = ReturnType<typeof useUpdateDeliveryMutation>;
export type UpdateDeliveryMutationResult = Apollo.MutationResult<UpdateDeliveryMutation>;
export type UpdateDeliveryMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryMutation, UpdateDeliveryMutationVariables>;
export const DeleteDeliveryDocument = gql`
    mutation DeleteDelivery($input: DeleteDeliveryInput!) {
  deleteDelivery(input: $input) {
    clientMutationId
    success
    errors {
      field
      message
    }
  }
}
    `;
export type DeleteDeliveryMutationFn = Apollo.MutationFunction<DeleteDeliveryMutation, DeleteDeliveryMutationVariables>;

/**
 * __useDeleteDeliveryMutation__
 *
 * To run a mutation, you first call `useDeleteDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeliveryMutation, { data, loading, error }] = useDeleteDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeliveryMutation, DeleteDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeliveryMutation, DeleteDeliveryMutationVariables>(DeleteDeliveryDocument, options);
      }
export type DeleteDeliveryMutationHookResult = ReturnType<typeof useDeleteDeliveryMutation>;
export type DeleteDeliveryMutationResult = Apollo.MutationResult<DeleteDeliveryMutation>;
export type DeleteDeliveryMutationOptions = Apollo.BaseMutationOptions<DeleteDeliveryMutation, DeleteDeliveryMutationVariables>;
export const AddAnimalsToDeliveryDocument = gql`
    mutation AddAnimalsToDelivery($input: DeliverAnimalsOutInput!) {
  deliverAnimalsOut(input: $input) {
    errors {
      field
      message
    }
    delivery {
      id
    }
  }
}
    `;
export type AddAnimalsToDeliveryMutationFn = Apollo.MutationFunction<AddAnimalsToDeliveryMutation, AddAnimalsToDeliveryMutationVariables>;

/**
 * __useAddAnimalsToDeliveryMutation__
 *
 * To run a mutation, you first call `useAddAnimalsToDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAnimalsToDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAnimalsToDeliveryMutation, { data, loading, error }] = useAddAnimalsToDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAnimalsToDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<AddAnimalsToDeliveryMutation, AddAnimalsToDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAnimalsToDeliveryMutation, AddAnimalsToDeliveryMutationVariables>(AddAnimalsToDeliveryDocument, options);
      }
export type AddAnimalsToDeliveryMutationHookResult = ReturnType<typeof useAddAnimalsToDeliveryMutation>;
export type AddAnimalsToDeliveryMutationResult = Apollo.MutationResult<AddAnimalsToDeliveryMutation>;
export type AddAnimalsToDeliveryMutationOptions = Apollo.BaseMutationOptions<AddAnimalsToDeliveryMutation, AddAnimalsToDeliveryMutationVariables>;
export const RemoveAnimalsFromDeliveryDocument = gql`
    mutation RemoveAnimalsFromDelivery($input: DeleteDeliveryAnimalsInput!) {
  deleteDeliveryAnimals(input: $input) {
    errors {
      field
      message
    }
    delivery {
      id
    }
  }
}
    `;
export type RemoveAnimalsFromDeliveryMutationFn = Apollo.MutationFunction<RemoveAnimalsFromDeliveryMutation, RemoveAnimalsFromDeliveryMutationVariables>;

/**
 * __useRemoveAnimalsFromDeliveryMutation__
 *
 * To run a mutation, you first call `useRemoveAnimalsFromDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAnimalsFromDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAnimalsFromDeliveryMutation, { data, loading, error }] = useRemoveAnimalsFromDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAnimalsFromDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAnimalsFromDeliveryMutation, RemoveAnimalsFromDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAnimalsFromDeliveryMutation, RemoveAnimalsFromDeliveryMutationVariables>(RemoveAnimalsFromDeliveryDocument, options);
      }
export type RemoveAnimalsFromDeliveryMutationHookResult = ReturnType<typeof useRemoveAnimalsFromDeliveryMutation>;
export type RemoveAnimalsFromDeliveryMutationResult = Apollo.MutationResult<RemoveAnimalsFromDeliveryMutation>;
export type RemoveAnimalsFromDeliveryMutationOptions = Apollo.BaseMutationOptions<RemoveAnimalsFromDeliveryMutation, RemoveAnimalsFromDeliveryMutationVariables>;
export const CreateAndAddAnimalToDeliveryDocument = gql`
    mutation CreateAndAddAnimalToDelivery($input: DeliverNewAnimalInput!) {
  deliverNewAnimal(input: $input) {
    delivery {
      id
    }
    animal {
      ...animal
    }
    errors {
      field
      message
    }
  }
}
    ${AnimalFragmentDoc}`;
export type CreateAndAddAnimalToDeliveryMutationFn = Apollo.MutationFunction<CreateAndAddAnimalToDeliveryMutation, CreateAndAddAnimalToDeliveryMutationVariables>;

/**
 * __useCreateAndAddAnimalToDeliveryMutation__
 *
 * To run a mutation, you first call `useCreateAndAddAnimalToDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndAddAnimalToDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndAddAnimalToDeliveryMutation, { data, loading, error }] = useCreateAndAddAnimalToDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAndAddAnimalToDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<CreateAndAddAnimalToDeliveryMutation, CreateAndAddAnimalToDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAndAddAnimalToDeliveryMutation, CreateAndAddAnimalToDeliveryMutationVariables>(CreateAndAddAnimalToDeliveryDocument, options);
      }
export type CreateAndAddAnimalToDeliveryMutationHookResult = ReturnType<typeof useCreateAndAddAnimalToDeliveryMutation>;
export type CreateAndAddAnimalToDeliveryMutationResult = Apollo.MutationResult<CreateAndAddAnimalToDeliveryMutation>;
export type CreateAndAddAnimalToDeliveryMutationOptions = Apollo.BaseMutationOptions<CreateAndAddAnimalToDeliveryMutation, CreateAndAddAnimalToDeliveryMutationVariables>;
export const UpdateAnimalDocument = gql`
    mutation UpdateAnimal($input: UpdateAnimalInput!) {
  updateAnimal(input: $input) {
    animal {
      ...animal
    }
    errors {
      field
      message
    }
  }
}
    ${AnimalFragmentDoc}`;
export type UpdateAnimalMutationFn = Apollo.MutationFunction<UpdateAnimalMutation, UpdateAnimalMutationVariables>;

/**
 * __useUpdateAnimalMutation__
 *
 * To run a mutation, you first call `useUpdateAnimalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnimalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnimalMutation, { data, loading, error }] = useUpdateAnimalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnimalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnimalMutation, UpdateAnimalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnimalMutation, UpdateAnimalMutationVariables>(UpdateAnimalDocument, options);
      }
export type UpdateAnimalMutationHookResult = ReturnType<typeof useUpdateAnimalMutation>;
export type UpdateAnimalMutationResult = Apollo.MutationResult<UpdateAnimalMutation>;
export type UpdateAnimalMutationOptions = Apollo.BaseMutationOptions<UpdateAnimalMutation, UpdateAnimalMutationVariables>;
export const UndoDeliveryDocument = gql`
    mutation UndoDelivery($input: UndoDeliveryInput!) {
  undoDelivery(input: $input) {
    delivery {
      id
    }
    success
    errors {
      field
      code
      message
    }
  }
}
    `;
export type UndoDeliveryMutationFn = Apollo.MutationFunction<UndoDeliveryMutation, UndoDeliveryMutationVariables>;

/**
 * __useUndoDeliveryMutation__
 *
 * To run a mutation, you first call `useUndoDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoDeliveryMutation, { data, loading, error }] = useUndoDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUndoDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<UndoDeliveryMutation, UndoDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UndoDeliveryMutation, UndoDeliveryMutationVariables>(UndoDeliveryDocument, options);
      }
export type UndoDeliveryMutationHookResult = ReturnType<typeof useUndoDeliveryMutation>;
export type UndoDeliveryMutationResult = Apollo.MutationResult<UndoDeliveryMutation>;
export type UndoDeliveryMutationOptions = Apollo.BaseMutationOptions<UndoDeliveryMutation, UndoDeliveryMutationVariables>;
export const DeliveryPartnerAddressesDocument = gql`
    query DeliveryPartnerAddresses($businessUnit: ID!, $orderBy: [DeliveryPartnerAddressSortingEnum!]) {
  deliveryPartnerAddresses(businessUnit: $businessUnit, orderBy: $orderBy) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useDeliveryPartnerAddressesQuery__
 *
 * To run a query within a React component, call `useDeliveryPartnerAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryPartnerAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryPartnerAddressesQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useDeliveryPartnerAddressesQuery(baseOptions: Apollo.QueryHookOptions<DeliveryPartnerAddressesQuery, DeliveryPartnerAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryPartnerAddressesQuery, DeliveryPartnerAddressesQueryVariables>(DeliveryPartnerAddressesDocument, options);
      }
export function useDeliveryPartnerAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryPartnerAddressesQuery, DeliveryPartnerAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryPartnerAddressesQuery, DeliveryPartnerAddressesQueryVariables>(DeliveryPartnerAddressesDocument, options);
        }
export type DeliveryPartnerAddressesQueryHookResult = ReturnType<typeof useDeliveryPartnerAddressesQuery>;
export type DeliveryPartnerAddressesLazyQueryHookResult = ReturnType<typeof useDeliveryPartnerAddressesLazyQuery>;
export type DeliveryPartnerAddressesQueryResult = Apollo.QueryResult<DeliveryPartnerAddressesQuery, DeliveryPartnerAddressesQueryVariables>;
export const DeliveriesDocument = gql`
    query Deliveries($businessUnit: ID!, $status: DeliveryStatusEnum, $direction: DeliveryDirectionEnum, $orderBy: [DeliverySortingEnum], $before: String, $after: String, $first: Int, $last: Int) {
  deliveries(
    businessUnit: $businessUnit
    status: $status
    direction: $direction
    orderBy: $orderBy
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    pageInfo {
      ...PageInfo
    }
    count
    edges {
      node {
        ...Delivery
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${DeliveryFragmentDoc}`;

/**
 * __useDeliveriesQuery__
 *
 * To run a query within a React component, call `useDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveriesQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *      status: // value for 'status'
 *      direction: // value for 'direction'
 *      orderBy: // value for 'orderBy'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useDeliveriesQuery(baseOptions: Apollo.QueryHookOptions<DeliveriesQuery, DeliveriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveriesQuery, DeliveriesQueryVariables>(DeliveriesDocument, options);
      }
export function useDeliveriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveriesQuery, DeliveriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveriesQuery, DeliveriesQueryVariables>(DeliveriesDocument, options);
        }
export type DeliveriesQueryHookResult = ReturnType<typeof useDeliveriesQuery>;
export type DeliveriesLazyQueryHookResult = ReturnType<typeof useDeliveriesLazyQuery>;
export type DeliveriesQueryResult = Apollo.QueryResult<DeliveriesQuery, DeliveriesQueryVariables>;
export const DeliveryDocument = gql`
    query Delivery($businessUnit: ID!, $delivery: ID!) {
  delivery(businessUnit: $businessUnit, delivery: $delivery) {
    delivery {
      ...Delivery
    }
    consignments {
      edges {
        node {
          animalCount
          animals {
            edges {
              node {
                ...ConsignmentAnimal
              }
            }
          }
          destination {
            details {
              name
              address
              email
              postcode
            }
          }
        }
      }
    }
  }
}
    ${DeliveryFragmentDoc}
${ConsignmentAnimalFragmentDoc}`;

/**
 * __useDeliveryQuery__
 *
 * To run a query within a React component, call `useDeliveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *      delivery: // value for 'delivery'
 *   },
 * });
 */
export function useDeliveryQuery(baseOptions: Apollo.QueryHookOptions<DeliveryQuery, DeliveryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryQuery, DeliveryQueryVariables>(DeliveryDocument, options);
      }
export function useDeliveryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryQuery, DeliveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryQuery, DeliveryQueryVariables>(DeliveryDocument, options);
        }
export type DeliveryQueryHookResult = ReturnType<typeof useDeliveryQuery>;
export type DeliveryLazyQueryHookResult = ReturnType<typeof useDeliveryLazyQuery>;
export type DeliveryQueryResult = Apollo.QueryResult<DeliveryQuery, DeliveryQueryVariables>;
export const DeliveryReasonsDocument = gql`
    query DeliveryReasons($businessUnit: ID!, $isActive: Boolean, $directions: [DeliveryDirectionEnum!]) {
  deliveryReasons(
    businessUnit: $businessUnit
    isActive: $isActive
    directions: $directions
  ) {
    edges {
      node {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useDeliveryReasonsQuery__
 *
 * To run a query within a React component, call `useDeliveryReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryReasonsQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *      isActive: // value for 'isActive'
 *      directions: // value for 'directions'
 *   },
 * });
 */
export function useDeliveryReasonsQuery(baseOptions: Apollo.QueryHookOptions<DeliveryReasonsQuery, DeliveryReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryReasonsQuery, DeliveryReasonsQueryVariables>(DeliveryReasonsDocument, options);
      }
export function useDeliveryReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryReasonsQuery, DeliveryReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryReasonsQuery, DeliveryReasonsQueryVariables>(DeliveryReasonsDocument, options);
        }
export type DeliveryReasonsQueryHookResult = ReturnType<typeof useDeliveryReasonsQuery>;
export type DeliveryReasonsLazyQueryHookResult = ReturnType<typeof useDeliveryReasonsLazyQuery>;
export type DeliveryReasonsQueryResult = Apollo.QueryResult<DeliveryReasonsQuery, DeliveryReasonsQueryVariables>;
export const DraftDeliveryDocument = gql`
    query DraftDelivery($businessUnit: ID!, $delivery: ID!) {
  delivery(businessUnit: $businessUnit, delivery: $delivery) {
    delivery {
      ...Delivery
    }
  }
}
    ${DeliveryFragmentDoc}`;

/**
 * __useDraftDeliveryQuery__
 *
 * To run a query within a React component, call `useDraftDeliveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftDeliveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftDeliveryQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *      delivery: // value for 'delivery'
 *   },
 * });
 */
export function useDraftDeliveryQuery(baseOptions: Apollo.QueryHookOptions<DraftDeliveryQuery, DraftDeliveryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DraftDeliveryQuery, DraftDeliveryQueryVariables>(DraftDeliveryDocument, options);
      }
export function useDraftDeliveryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DraftDeliveryQuery, DraftDeliveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DraftDeliveryQuery, DraftDeliveryQueryVariables>(DraftDeliveryDocument, options);
        }
export type DraftDeliveryQueryHookResult = ReturnType<typeof useDraftDeliveryQuery>;
export type DraftDeliveryLazyQueryHookResult = ReturnType<typeof useDraftDeliveryLazyQuery>;
export type DraftDeliveryQueryResult = Apollo.QueryResult<DraftDeliveryQuery, DraftDeliveryQueryVariables>;
export const DraftDeliveryAnimalsDocument = gql`
    query DraftDeliveryAnimals($businessUnit: ID!, $delivery: ID!) {
  delivery(businessUnit: $businessUnit, delivery: $delivery) {
    delivery {
      id
    }
    animals {
      edges {
        cursor
        node {
          ...animal
        }
      }
    }
  }
}
    ${AnimalFragmentDoc}`;

/**
 * __useDraftDeliveryAnimalsQuery__
 *
 * To run a query within a React component, call `useDraftDeliveryAnimalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftDeliveryAnimalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftDeliveryAnimalsQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *      delivery: // value for 'delivery'
 *   },
 * });
 */
export function useDraftDeliveryAnimalsQuery(baseOptions: Apollo.QueryHookOptions<DraftDeliveryAnimalsQuery, DraftDeliveryAnimalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DraftDeliveryAnimalsQuery, DraftDeliveryAnimalsQueryVariables>(DraftDeliveryAnimalsDocument, options);
      }
export function useDraftDeliveryAnimalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DraftDeliveryAnimalsQuery, DraftDeliveryAnimalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DraftDeliveryAnimalsQuery, DraftDeliveryAnimalsQueryVariables>(DraftDeliveryAnimalsDocument, options);
        }
export type DraftDeliveryAnimalsQueryHookResult = ReturnType<typeof useDraftDeliveryAnimalsQuery>;
export type DraftDeliveryAnimalsLazyQueryHookResult = ReturnType<typeof useDraftDeliveryAnimalsLazyQuery>;
export type DraftDeliveryAnimalsQueryResult = Apollo.QueryResult<DraftDeliveryAnimalsQuery, DraftDeliveryAnimalsQueryVariables>;
export const CheckIfAnimalExistsDocument = gql`
    query CheckIfAnimalExists($businessUnit: Int!, $visualId: String, $eId: String, $passportNumber: String, $first: Int, $search: String, $searchIds: [IdentifierType!]) {
  animals(
    businessUnitId: $businessUnit
    visualId: $visualId
    eId: $eId
    passportNumber: $passportNumber
    first: $first
    search: $search
    searchIds: $searchIds
  ) {
    edges {
      node {
        id
        brucellosisId
        eId
        herdDoggId
        pedigreeId
        tattoo
        trichId
        tsuBarcode
        uhfId
        visualId
      }
    }
  }
}
    `;

/**
 * __useCheckIfAnimalExistsQuery__
 *
 * To run a query within a React component, call `useCheckIfAnimalExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfAnimalExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfAnimalExistsQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *      visualId: // value for 'visualId'
 *      eId: // value for 'eId'
 *      passportNumber: // value for 'passportNumber'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      searchIds: // value for 'searchIds'
 *   },
 * });
 */
export function useCheckIfAnimalExistsQuery(baseOptions: Apollo.QueryHookOptions<CheckIfAnimalExistsQuery, CheckIfAnimalExistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIfAnimalExistsQuery, CheckIfAnimalExistsQueryVariables>(CheckIfAnimalExistsDocument, options);
      }
export function useCheckIfAnimalExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIfAnimalExistsQuery, CheckIfAnimalExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIfAnimalExistsQuery, CheckIfAnimalExistsQueryVariables>(CheckIfAnimalExistsDocument, options);
        }
export type CheckIfAnimalExistsQueryHookResult = ReturnType<typeof useCheckIfAnimalExistsQuery>;
export type CheckIfAnimalExistsLazyQueryHookResult = ReturnType<typeof useCheckIfAnimalExistsLazyQuery>;
export type CheckIfAnimalExistsQueryResult = Apollo.QueryResult<CheckIfAnimalExistsQuery, CheckIfAnimalExistsQueryVariables>;
export const CreateStripePortalSessionDocument = gql`
    mutation CreateStripePortalSession($input: CreateStripePortalSessionInput!) {
  createStripePortalSession(input: $input) {
    clientMutationId
    sessionUrl
  }
}
    `;
export type CreateStripePortalSessionMutationFn = Apollo.MutationFunction<CreateStripePortalSessionMutation, CreateStripePortalSessionMutationVariables>;

/**
 * __useCreateStripePortalSessionMutation__
 *
 * To run a mutation, you first call `useCreateStripePortalSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripePortalSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripePortalSessionMutation, { data, loading, error }] = useCreateStripePortalSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStripePortalSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripePortalSessionMutation, CreateStripePortalSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripePortalSessionMutation, CreateStripePortalSessionMutationVariables>(CreateStripePortalSessionDocument, options);
      }
export type CreateStripePortalSessionMutationHookResult = ReturnType<typeof useCreateStripePortalSessionMutation>;
export type CreateStripePortalSessionMutationResult = Apollo.MutationResult<CreateStripePortalSessionMutation>;
export type CreateStripePortalSessionMutationOptions = Apollo.BaseMutationOptions<CreateStripePortalSessionMutation, CreateStripePortalSessionMutationVariables>;
export const CreateStripeCheckoutSessionDocument = gql`
    mutation CreateStripeCheckoutSession($input: CreateStripeCheckoutSessionInput!) {
  createStripeCheckoutSession(input: $input) {
    clientMutationId
    sessionUrl
  }
}
    `;
export type CreateStripeCheckoutSessionMutationFn = Apollo.MutationFunction<CreateStripeCheckoutSessionMutation, CreateStripeCheckoutSessionMutationVariables>;

/**
 * __useCreateStripeCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateStripeCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeCheckoutSessionMutation, { data, loading, error }] = useCreateStripeCheckoutSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStripeCheckoutSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripeCheckoutSessionMutation, CreateStripeCheckoutSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripeCheckoutSessionMutation, CreateStripeCheckoutSessionMutationVariables>(CreateStripeCheckoutSessionDocument, options);
      }
export type CreateStripeCheckoutSessionMutationHookResult = ReturnType<typeof useCreateStripeCheckoutSessionMutation>;
export type CreateStripeCheckoutSessionMutationResult = Apollo.MutationResult<CreateStripeCheckoutSessionMutation>;
export type CreateStripeCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<CreateStripeCheckoutSessionMutation, CreateStripeCheckoutSessionMutationVariables>;
export const GetSubscriptionFeaturesDocument = gql`
    query GetSubscriptionFeatures($businessUnit: Int!) {
  businessUnit(businessUnit: $businessUnit) {
    id
    subscriptionPlanFeatures {
      slug
      isActive
    }
  }
}
    `;

/**
 * __useGetSubscriptionFeaturesQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionFeaturesQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useGetSubscriptionFeaturesQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionFeaturesQuery, GetSubscriptionFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionFeaturesQuery, GetSubscriptionFeaturesQueryVariables>(GetSubscriptionFeaturesDocument, options);
      }
export function useGetSubscriptionFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionFeaturesQuery, GetSubscriptionFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionFeaturesQuery, GetSubscriptionFeaturesQueryVariables>(GetSubscriptionFeaturesDocument, options);
        }
export type GetSubscriptionFeaturesQueryHookResult = ReturnType<typeof useGetSubscriptionFeaturesQuery>;
export type GetSubscriptionFeaturesLazyQueryHookResult = ReturnType<typeof useGetSubscriptionFeaturesLazyQuery>;
export type GetSubscriptionFeaturesQueryResult = Apollo.QueryResult<GetSubscriptionFeaturesQuery, GetSubscriptionFeaturesQueryVariables>;
export const SubscriptionStatusDocument = gql`
    query SubscriptionStatus($businessUnitId: Int!) {
  subscriptionStatus(businessUnitId: $businessUnitId) {
    activationTokens {
      id
      behaviour
    }
    hasStripeState
    hasStripeSubscriptions
    isSubscribed
  }
}
    `;

/**
 * __useSubscriptionStatusQuery__
 *
 * To run a query within a React component, call `useSubscriptionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionStatusQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useSubscriptionStatusQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>(SubscriptionStatusDocument, options);
      }
export function useSubscriptionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>(SubscriptionStatusDocument, options);
        }
export type SubscriptionStatusQueryHookResult = ReturnType<typeof useSubscriptionStatusQuery>;
export type SubscriptionStatusLazyQueryHookResult = ReturnType<typeof useSubscriptionStatusLazyQuery>;
export type SubscriptionStatusQueryResult = Apollo.QueryResult<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>;
export const UpdateFieldDocument = gql`
    mutation UpdateField($input: UpdateFieldInput!) {
  updateField(input: $input) {
    errors {
      ...errorFragment
    }
    field {
      id
      name
      description
      isOrganic
      isYard
      location {
        id
        country {
          name
        }
        locationId
        unitName
      }
      pastureTypes {
        id
        name
      }
      isHoldingPen
      size
      sizeUnit
      fieldDensity
      avgDlwg
      avgEstimatedWeight
      avgRecordedWeight
      avgAge
      summaryMetrics {
        breedrCode
        animalsCount
        femaleCount
        maleCount
        animalTypeId
      }
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type UpdateFieldMutationFn = Apollo.MutationFunction<UpdateFieldMutation, UpdateFieldMutationVariables>;

/**
 * __useUpdateFieldMutation__
 *
 * To run a mutation, you first call `useUpdateFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFieldMutation, { data, loading, error }] = useUpdateFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFieldMutation, UpdateFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFieldMutation, UpdateFieldMutationVariables>(UpdateFieldDocument, options);
      }
export type UpdateFieldMutationHookResult = ReturnType<typeof useUpdateFieldMutation>;
export type UpdateFieldMutationResult = Apollo.MutationResult<UpdateFieldMutation>;
export type UpdateFieldMutationOptions = Apollo.BaseMutationOptions<UpdateFieldMutation, UpdateFieldMutationVariables>;
export const FieldNamesDocument = gql`
    query FieldNames($businessUnitId: Int) {
  fields(businessUnitId: $businessUnitId) {
    id
    name
    location {
      id
      unitName
    }
  }
}
    `;

/**
 * __useFieldNamesQuery__
 *
 * To run a query within a React component, call `useFieldNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldNamesQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useFieldNamesQuery(baseOptions?: Apollo.QueryHookOptions<FieldNamesQuery, FieldNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FieldNamesQuery, FieldNamesQueryVariables>(FieldNamesDocument, options);
      }
export function useFieldNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldNamesQuery, FieldNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FieldNamesQuery, FieldNamesQueryVariables>(FieldNamesDocument, options);
        }
export type FieldNamesQueryHookResult = ReturnType<typeof useFieldNamesQuery>;
export type FieldNamesLazyQueryHookResult = ReturnType<typeof useFieldNamesLazyQuery>;
export type FieldNamesQueryResult = Apollo.QueryResult<FieldNamesQuery, FieldNamesQueryVariables>;
export const FieldsDocument = gql`
    query Fields($businessUnitId: Int) {
  fields(businessUnitId: $businessUnitId) {
    id
    name
    isOrganic
    isYard
    location {
      country {
        id
        code
        name
      }
      id
      locationId
      unitName
    }
    name
    sizeUnit
    fieldDensity
    avgAge
    avgDlwg
    avgEstimatedWeight
    summaryMetrics {
      breedrCode
      regBreedCode
      animalsCount
      maleCount
      femaleCount
      animalTypeId
    }
    description
    animalAlertsCount
  }
}
    `;

/**
 * __useFieldsQuery__
 *
 * To run a query within a React component, call `useFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldsQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useFieldsQuery(baseOptions?: Apollo.QueryHookOptions<FieldsQuery, FieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FieldsQuery, FieldsQueryVariables>(FieldsDocument, options);
      }
export function useFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldsQuery, FieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FieldsQuery, FieldsQueryVariables>(FieldsDocument, options);
        }
export type FieldsQueryHookResult = ReturnType<typeof useFieldsQuery>;
export type FieldsLazyQueryHookResult = ReturnType<typeof useFieldsLazyQuery>;
export type FieldsQueryResult = Apollo.QueryResult<FieldsQuery, FieldsQueryVariables>;
export const FieldDocument = gql`
    query Field($id: UUID!) {
  field(id: $id) {
    id
    name
    description
    isOrganic
    isYard
    location {
      id
      country {
        name
      }
      locationId
      unitName
    }
    pastureTypes {
      id
      name
    }
    isHoldingPen
    size
    sizeUnit
    fieldDensity
    avgDlwg
    avgEstimatedWeight
    avgRecordedWeight
    avgAge
    summaryMetrics {
      breedrCode
      animalsCount
      femaleCount
      maleCount
      animalTypeId
    }
  }
}
    `;

/**
 * __useFieldQuery__
 *
 * To run a query within a React component, call `useFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFieldQuery(baseOptions: Apollo.QueryHookOptions<FieldQuery, FieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FieldQuery, FieldQueryVariables>(FieldDocument, options);
      }
export function useFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldQuery, FieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FieldQuery, FieldQueryVariables>(FieldDocument, options);
        }
export type FieldQueryHookResult = ReturnType<typeof useFieldQuery>;
export type FieldLazyQueryHookResult = ReturnType<typeof useFieldLazyQuery>;
export type FieldQueryResult = Apollo.QueryResult<FieldQuery, FieldQueryVariables>;
export const FinancialTransactionsDocument = gql`
    query FinancialTransactions($businessUnit: ID!, $first: Int, $last: Int, $before: String, $after: String, $orderBy: FinancialTransactionsSortByEnumType, $desc: Boolean) {
  financialTransactions(
    businessUnit: $businessUnit
    first: $first
    last: $last
    before: $before
    after: $after
    orderBy: $orderBy
    desc: $desc
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    count
    edges {
      node {
        id
        label
        animalsCount
        amount
        date
        recordType
      }
    }
  }
}
    `;

/**
 * __useFinancialTransactionsQuery__
 *
 * To run a query within a React component, call `useFinancialTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialTransactionsQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      desc: // value for 'desc'
 *   },
 * });
 */
export function useFinancialTransactionsQuery(baseOptions: Apollo.QueryHookOptions<FinancialTransactionsQuery, FinancialTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancialTransactionsQuery, FinancialTransactionsQueryVariables>(FinancialTransactionsDocument, options);
      }
export function useFinancialTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancialTransactionsQuery, FinancialTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancialTransactionsQuery, FinancialTransactionsQueryVariables>(FinancialTransactionsDocument, options);
        }
export type FinancialTransactionsQueryHookResult = ReturnType<typeof useFinancialTransactionsQuery>;
export type FinancialTransactionsLazyQueryHookResult = ReturnType<typeof useFinancialTransactionsLazyQuery>;
export type FinancialTransactionsQueryResult = Apollo.QueryResult<FinancialTransactionsQuery, FinancialTransactionsQueryVariables>;
export const BatchDocument = gql`
    query Batch($group: UUID!, $businessUnit: Int!) {
  group(group: $group, businessUnit: $businessUnit) {
    id
    animalsNumberCache
    averageDobInBatch
    category
    gendersInBatch
    numberOfUnidentifiedAnimalsInBatch
    isBatch
    targetWeight
    targetDate
    daysTillTarget
    avgDlwg
    timeOnFarm
    name
    animalType {
      id
      name
    }
    animalBreeds {
      id
    }
    summaryMetrics {
      femaleCount
      maleCount
      breedrCode
    }
  }
}
    `;

/**
 * __useBatchQuery__
 *
 * To run a query within a React component, call `useBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBatchQuery({
 *   variables: {
 *      group: // value for 'group'
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useBatchQuery(baseOptions: Apollo.QueryHookOptions<BatchQuery, BatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BatchQuery, BatchQueryVariables>(BatchDocument, options);
      }
export function useBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BatchQuery, BatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BatchQuery, BatchQueryVariables>(BatchDocument, options);
        }
export type BatchQueryHookResult = ReturnType<typeof useBatchQuery>;
export type BatchLazyQueryHookResult = ReturnType<typeof useBatchLazyQuery>;
export type BatchQueryResult = Apollo.QueryResult<BatchQuery, BatchQueryVariables>;
export const GroupDocument = gql`
    query Group($group: UUID!, $businessUnit: Int!) {
  group(group: $group, businessUnit: $businessUnit) {
    id
    name
    targetWeight
    category
    animalType {
      id
      colour
      image
    }
    targetDate
    timeOnFarm
    minAge
    maxAge
    weightInfo {
      minWeight
      maxWeight
    }
    category
    minDaysOnFarm
    maxDaysOnFarm
    avgEstimatedWeight
    avgRecordedWeight
    avgDlwg
    daysTillTarget
    isBatch
    summaryMetrics {
      breedrCode
      animalsCount
      femaleCount
      maleCount
    }
    animals {
      id
    }
  }
}
    `;

/**
 * __useGroupQuery__
 *
 * To run a query within a React component, call `useGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupQuery({
 *   variables: {
 *      group: // value for 'group'
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useGroupQuery(baseOptions: Apollo.QueryHookOptions<GroupQuery, GroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
      }
export function useGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupQuery, GroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
        }
export type GroupQueryHookResult = ReturnType<typeof useGroupQuery>;
export type GroupLazyQueryHookResult = ReturnType<typeof useGroupLazyQuery>;
export type GroupQueryResult = Apollo.QueryResult<GroupQuery, GroupQueryVariables>;
export const GroupsInfoDocument = gql`
    query GroupsInfo($businessUnitId: Int, $animalTypeIds: [Int]) {
  groupsExtended(businessUnitId: $businessUnitId, animalTypeIds: $animalTypeIds) {
    groupsCount
    groups {
      id
      name
      isBatch
    }
  }
}
    `;

/**
 * __useGroupsInfoQuery__
 *
 * To run a query within a React component, call `useGroupsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsInfoQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *      animalTypeIds: // value for 'animalTypeIds'
 *   },
 * });
 */
export function useGroupsInfoQuery(baseOptions?: Apollo.QueryHookOptions<GroupsInfoQuery, GroupsInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupsInfoQuery, GroupsInfoQueryVariables>(GroupsInfoDocument, options);
      }
export function useGroupsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupsInfoQuery, GroupsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupsInfoQuery, GroupsInfoQueryVariables>(GroupsInfoDocument, options);
        }
export type GroupsInfoQueryHookResult = ReturnType<typeof useGroupsInfoQuery>;
export type GroupsInfoLazyQueryHookResult = ReturnType<typeof useGroupsInfoLazyQuery>;
export type GroupsInfoQueryResult = Apollo.QueryResult<GroupsInfoQuery, GroupsInfoQueryVariables>;
export const GetGroupsCountDocument = gql`
    query GetGroupsCount($businessUnitId: Int) {
  groupsExtended(businessUnitId: $businessUnitId) {
    groupsCount
  }
}
    `;

/**
 * __useGetGroupsCountQuery__
 *
 * To run a query within a React component, call `useGetGroupsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsCountQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useGetGroupsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupsCountQuery, GetGroupsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsCountQuery, GetGroupsCountQueryVariables>(GetGroupsCountDocument, options);
      }
export function useGetGroupsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsCountQuery, GetGroupsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsCountQuery, GetGroupsCountQueryVariables>(GetGroupsCountDocument, options);
        }
export type GetGroupsCountQueryHookResult = ReturnType<typeof useGetGroupsCountQuery>;
export type GetGroupsCountLazyQueryHookResult = ReturnType<typeof useGetGroupsCountLazyQuery>;
export type GetGroupsCountQueryResult = Apollo.QueryResult<GetGroupsCountQuery, GetGroupsCountQueryVariables>;
export const UploadCsvDocument = gql`
    mutation UploadCsv($input: UploadCsvInput!) {
  uploadCsv(input: $input) {
    id
    rows
    fields
    totalColumns
    totalRows
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type UploadCsvMutationFn = Apollo.MutationFunction<UploadCsvMutation, UploadCsvMutationVariables>;

/**
 * __useUploadCsvMutation__
 *
 * To run a mutation, you first call `useUploadCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCsvMutation, { data, loading, error }] = useUploadCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadCsvMutation(baseOptions?: Apollo.MutationHookOptions<UploadCsvMutation, UploadCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCsvMutation, UploadCsvMutationVariables>(UploadCsvDocument, options);
      }
export type UploadCsvMutationHookResult = ReturnType<typeof useUploadCsvMutation>;
export type UploadCsvMutationResult = Apollo.MutationResult<UploadCsvMutation>;
export type UploadCsvMutationOptions = Apollo.BaseMutationOptions<UploadCsvMutation, UploadCsvMutationVariables>;
export const ImportCsvDocument = gql`
    mutation ImportCsv($input: ImportCsvInput!) {
  importCsv(input: $input) {
    taskId
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type ImportCsvMutationFn = Apollo.MutationFunction<ImportCsvMutation, ImportCsvMutationVariables>;

/**
 * __useImportCsvMutation__
 *
 * To run a mutation, you first call `useImportCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importCsvMutation, { data, loading, error }] = useImportCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportCsvMutation(baseOptions?: Apollo.MutationHookOptions<ImportCsvMutation, ImportCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportCsvMutation, ImportCsvMutationVariables>(ImportCsvDocument, options);
      }
export type ImportCsvMutationHookResult = ReturnType<typeof useImportCsvMutation>;
export type ImportCsvMutationResult = Apollo.MutationResult<ImportCsvMutation>;
export type ImportCsvMutationOptions = Apollo.BaseMutationOptions<ImportCsvMutation, ImportCsvMutationVariables>;
export const GetBatchUploadFormatsDocument = gql`
    query GetBatchUploadFormats($businessUnitId: Int!) {
  batchUploadFormats(businessUnitId: $businessUnitId) {
    animalTypes {
      id
    }
    activityTemplateId
    categorySlug
    name
    slug
    columns {
      isRequired
      label
      name
    }
    activityType {
      ...ActivityTypeFields
    }
  }
}
    ${ActivityTypeFieldsFragmentDoc}`;

/**
 * __useGetBatchUploadFormatsQuery__
 *
 * To run a query within a React component, call `useGetBatchUploadFormatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBatchUploadFormatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBatchUploadFormatsQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useGetBatchUploadFormatsQuery(baseOptions: Apollo.QueryHookOptions<GetBatchUploadFormatsQuery, GetBatchUploadFormatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBatchUploadFormatsQuery, GetBatchUploadFormatsQueryVariables>(GetBatchUploadFormatsDocument, options);
      }
export function useGetBatchUploadFormatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBatchUploadFormatsQuery, GetBatchUploadFormatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBatchUploadFormatsQuery, GetBatchUploadFormatsQueryVariables>(GetBatchUploadFormatsDocument, options);
        }
export type GetBatchUploadFormatsQueryHookResult = ReturnType<typeof useGetBatchUploadFormatsQuery>;
export type GetBatchUploadFormatsLazyQueryHookResult = ReturnType<typeof useGetBatchUploadFormatsLazyQuery>;
export type GetBatchUploadFormatsQueryResult = Apollo.QueryResult<GetBatchUploadFormatsQuery, GetBatchUploadFormatsQueryVariables>;
export const GetBatchUploadFormatDocument = gql`
    query GetBatchUploadFormat($businessUnitId: ID!, $slug: String!) {
  batchUploadFormat(businessUnit: $businessUnitId, slug: $slug) {
    animalTypes {
      id
    }
    activityTemplateId
    name
    slug
    columns {
      isRequired
      label
      name
    }
    activityType {
      ...ActivityTypeFields
    }
  }
}
    ${ActivityTypeFieldsFragmentDoc}`;

/**
 * __useGetBatchUploadFormatQuery__
 *
 * To run a query within a React component, call `useGetBatchUploadFormatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBatchUploadFormatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBatchUploadFormatQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetBatchUploadFormatQuery(baseOptions: Apollo.QueryHookOptions<GetBatchUploadFormatQuery, GetBatchUploadFormatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBatchUploadFormatQuery, GetBatchUploadFormatQueryVariables>(GetBatchUploadFormatDocument, options);
      }
export function useGetBatchUploadFormatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBatchUploadFormatQuery, GetBatchUploadFormatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBatchUploadFormatQuery, GetBatchUploadFormatQueryVariables>(GetBatchUploadFormatDocument, options);
        }
export type GetBatchUploadFormatQueryHookResult = ReturnType<typeof useGetBatchUploadFormatQuery>;
export type GetBatchUploadFormatLazyQueryHookResult = ReturnType<typeof useGetBatchUploadFormatLazyQuery>;
export type GetBatchUploadFormatQueryResult = Apollo.QueryResult<GetBatchUploadFormatQuery, GetBatchUploadFormatQueryVariables>;
export const GetActivityTypesNewDocument = gql`
    query GetActivityTypesNew($businessUnit: Int!) {
  activityTypes(businessUnit: $businessUnit) {
    ...ActivityTypeFields
  }
}
    ${ActivityTypeFieldsFragmentDoc}`;

/**
 * __useGetActivityTypesNewQuery__
 *
 * To run a query within a React component, call `useGetActivityTypesNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityTypesNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityTypesNewQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useGetActivityTypesNewQuery(baseOptions: Apollo.QueryHookOptions<GetActivityTypesNewQuery, GetActivityTypesNewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityTypesNewQuery, GetActivityTypesNewQueryVariables>(GetActivityTypesNewDocument, options);
      }
export function useGetActivityTypesNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityTypesNewQuery, GetActivityTypesNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityTypesNewQuery, GetActivityTypesNewQueryVariables>(GetActivityTypesNewDocument, options);
        }
export type GetActivityTypesNewQueryHookResult = ReturnType<typeof useGetActivityTypesNewQuery>;
export type GetActivityTypesNewLazyQueryHookResult = ReturnType<typeof useGetActivityTypesNewLazyQuery>;
export type GetActivityTypesNewQueryResult = Apollo.QueryResult<GetActivityTypesNewQuery, GetActivityTypesNewQueryVariables>;
export const GetLandingReportDocument = gql`
    query GetLandingReport($businessUnit: Int!) {
  mainReport(businessUnit: $businessUnit) {
    id
    title
    url
    reportType
  }
}
    `;

/**
 * __useGetLandingReportQuery__
 *
 * To run a query within a React component, call `useGetLandingReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLandingReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLandingReportQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useGetLandingReportQuery(baseOptions: Apollo.QueryHookOptions<GetLandingReportQuery, GetLandingReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLandingReportQuery, GetLandingReportQueryVariables>(GetLandingReportDocument, options);
      }
export function useGetLandingReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLandingReportQuery, GetLandingReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLandingReportQuery, GetLandingReportQueryVariables>(GetLandingReportDocument, options);
        }
export type GetLandingReportQueryHookResult = ReturnType<typeof useGetLandingReportQuery>;
export type GetLandingReportLazyQueryHookResult = ReturnType<typeof useGetLandingReportLazyQuery>;
export type GetLandingReportQueryResult = Apollo.QueryResult<GetLandingReportQuery, GetLandingReportQueryVariables>;
export const DashboardsDocument = gql`
    query dashboards {
  dashboards {
    title
    slug
    filters {
      filterType
      filterName
    }
  }
}
    `;

/**
 * __useDashboardsQuery__
 *
 * To run a query within a React component, call `useDashboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardsQuery(baseOptions?: Apollo.QueryHookOptions<DashboardsQuery, DashboardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardsQuery, DashboardsQueryVariables>(DashboardsDocument, options);
      }
export function useDashboardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardsQuery, DashboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardsQuery, DashboardsQueryVariables>(DashboardsDocument, options);
        }
export type DashboardsQueryHookResult = ReturnType<typeof useDashboardsQuery>;
export type DashboardsLazyQueryHookResult = ReturnType<typeof useDashboardsLazyQuery>;
export type DashboardsQueryResult = Apollo.QueryResult<DashboardsQuery, DashboardsQueryVariables>;
export const DashboardDocument = gql`
    query Dashboard($dashboardSlug: String!) {
  dashboard(dashboardSlug: $dashboardSlug) {
    title
    slug
    charts {
      reportType
      dataParam
      layoutSize
    }
    filters {
      filterType
      filterName
    }
  }
}
    `;

/**
 * __useDashboardQuery__
 *
 * To run a query within a React component, call `useDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardQuery({
 *   variables: {
 *      dashboardSlug: // value for 'dashboardSlug'
 *   },
 * });
 */
export function useDashboardQuery(baseOptions: Apollo.QueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
      }
export function useDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
        }
export type DashboardQueryHookResult = ReturnType<typeof useDashboardQuery>;
export type DashboardLazyQueryHookResult = ReturnType<typeof useDashboardLazyQuery>;
export type DashboardQueryResult = Apollo.QueryResult<DashboardQuery, DashboardQueryVariables>;
export const CreateDownloadDocument = gql`
    mutation createDownload($input: CreateDownloadInput!) {
  createDownload(input: $input) {
    downloadId
    success
  }
}
    `;
export type CreateDownloadMutationFn = Apollo.MutationFunction<CreateDownloadMutation, CreateDownloadMutationVariables>;

/**
 * __useCreateDownloadMutation__
 *
 * To run a mutation, you first call `useCreateDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDownloadMutation, { data, loading, error }] = useCreateDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDownloadMutation(baseOptions?: Apollo.MutationHookOptions<CreateDownloadMutation, CreateDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDownloadMutation, CreateDownloadMutationVariables>(CreateDownloadDocument, options);
      }
export type CreateDownloadMutationHookResult = ReturnType<typeof useCreateDownloadMutation>;
export type CreateDownloadMutationResult = Apollo.MutationResult<CreateDownloadMutation>;
export type CreateDownloadMutationOptions = Apollo.BaseMutationOptions<CreateDownloadMutation, CreateDownloadMutationVariables>;
export const TableDataDocument = gql`
    query tableData($chartSlug: String!, $dashboardSlug: String!, $businessUnitId: Int!, $orderBy: String, $pagination: PaginationObjectType, $filters: GenericScalar) {
  tableData(
    chartSlug: $chartSlug
    dashboardSlug: $dashboardSlug
    businessUnitId: $businessUnitId
    pagination: $pagination
    orderBy: $orderBy
    filters: $filters
  ) {
    title
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    download {
      slug
      variables
    }
    columns {
      displayName
      accessor
      sortable
    }
    searchableField {
      field
      label
    }
    data
  }
}
    `;

/**
 * __useTableDataQuery__
 *
 * To run a query within a React component, call `useTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableDataQuery({
 *   variables: {
 *      chartSlug: // value for 'chartSlug'
 *      dashboardSlug: // value for 'dashboardSlug'
 *      businessUnitId: // value for 'businessUnitId'
 *      orderBy: // value for 'orderBy'
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTableDataQuery(baseOptions: Apollo.QueryHookOptions<TableDataQuery, TableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TableDataQuery, TableDataQueryVariables>(TableDataDocument, options);
      }
export function useTableDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TableDataQuery, TableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TableDataQuery, TableDataQueryVariables>(TableDataDocument, options);
        }
export type TableDataQueryHookResult = ReturnType<typeof useTableDataQuery>;
export type TableDataLazyQueryHookResult = ReturnType<typeof useTableDataLazyQuery>;
export type TableDataQueryResult = Apollo.QueryResult<TableDataQuery, TableDataQueryVariables>;
export const ChartDataDocument = gql`
    query chartData($chartSlug: String!, $dashboardSlug: String!, $businessUnitId: Int!, $filters: GenericScalar) {
  chartData(
    chartSlug: $chartSlug
    dashboardSlug: $dashboardSlug
    businessUnitId: $businessUnitId
    filters: $filters
  ) {
    title
    value
  }
}
    `;

/**
 * __useChartDataQuery__
 *
 * To run a query within a React component, call `useChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChartDataQuery({
 *   variables: {
 *      chartSlug: // value for 'chartSlug'
 *      dashboardSlug: // value for 'dashboardSlug'
 *      businessUnitId: // value for 'businessUnitId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useChartDataQuery(baseOptions: Apollo.QueryHookOptions<ChartDataQuery, ChartDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChartDataQuery, ChartDataQueryVariables>(ChartDataDocument, options);
      }
export function useChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChartDataQuery, ChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChartDataQuery, ChartDataQueryVariables>(ChartDataDocument, options);
        }
export type ChartDataQueryHookResult = ReturnType<typeof useChartDataQuery>;
export type ChartDataLazyQueryHookResult = ReturnType<typeof useChartDataLazyQuery>;
export type ChartDataQueryResult = Apollo.QueryResult<ChartDataQuery, ChartDataQueryVariables>;
export const PieChartDataDocument = gql`
    query pieChartData($chartSlug: String!, $dashboardSlug: String!, $businessUnitId: Int!, $filters: GenericScalar) {
  pieChartData(
    chartSlug: $chartSlug
    dashboardSlug: $dashboardSlug
    businessUnitId: $businessUnitId
    filters: $filters
  ) {
    title
    data {
      ... on LabelNumberObjectType {
        x
        y
      }
    }
  }
}
    `;

/**
 * __usePieChartDataQuery__
 *
 * To run a query within a React component, call `usePieChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePieChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePieChartDataQuery({
 *   variables: {
 *      chartSlug: // value for 'chartSlug'
 *      dashboardSlug: // value for 'dashboardSlug'
 *      businessUnitId: // value for 'businessUnitId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePieChartDataQuery(baseOptions: Apollo.QueryHookOptions<PieChartDataQuery, PieChartDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PieChartDataQuery, PieChartDataQueryVariables>(PieChartDataDocument, options);
      }
export function usePieChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PieChartDataQuery, PieChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PieChartDataQuery, PieChartDataQueryVariables>(PieChartDataDocument, options);
        }
export type PieChartDataQueryHookResult = ReturnType<typeof usePieChartDataQuery>;
export type PieChartDataLazyQueryHookResult = ReturnType<typeof usePieChartDataLazyQuery>;
export type PieChartDataQueryResult = Apollo.QueryResult<PieChartDataQuery, PieChartDataQueryVariables>;
export const BarChartDataDocument = gql`
    query barChartData($chartSlug: String!, $dashboardSlug: String!, $businessUnitId: Int!, $filters: GenericScalar) {
  barChartData(
    chartSlug: $chartSlug
    dashboardSlug: $dashboardSlug
    businessUnitId: $businessUnitId
    filters: $filters
  ) {
    title
    bars {
      ... on SeriesObjectType {
        label
        data {
          ... on LabelNumberObjectType {
            x
            y
          }
        }
      }
    }
  }
}
    `;

/**
 * __useBarChartDataQuery__
 *
 * To run a query within a React component, call `useBarChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBarChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBarChartDataQuery({
 *   variables: {
 *      chartSlug: // value for 'chartSlug'
 *      dashboardSlug: // value for 'dashboardSlug'
 *      businessUnitId: // value for 'businessUnitId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useBarChartDataQuery(baseOptions: Apollo.QueryHookOptions<BarChartDataQuery, BarChartDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BarChartDataQuery, BarChartDataQueryVariables>(BarChartDataDocument, options);
      }
export function useBarChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BarChartDataQuery, BarChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BarChartDataQuery, BarChartDataQueryVariables>(BarChartDataDocument, options);
        }
export type BarChartDataQueryHookResult = ReturnType<typeof useBarChartDataQuery>;
export type BarChartDataLazyQueryHookResult = ReturnType<typeof useBarChartDataLazyQuery>;
export type BarChartDataQueryResult = Apollo.QueryResult<BarChartDataQuery, BarChartDataQueryVariables>;
export const DownloadsDocument = gql`
    query downloads($businessUnitId: Int!) {
  downloads(businessUnitId: $businessUnitId) {
    edges {
      node {
        id
        name
        status
        downloadedFile
      }
    }
  }
}
    `;

/**
 * __useDownloadsQuery__
 *
 * To run a query within a React component, call `useDownloadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadsQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useDownloadsQuery(baseOptions: Apollo.QueryHookOptions<DownloadsQuery, DownloadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadsQuery, DownloadsQueryVariables>(DownloadsDocument, options);
      }
export function useDownloadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadsQuery, DownloadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadsQuery, DownloadsQueryVariables>(DownloadsDocument, options);
        }
export type DownloadsQueryHookResult = ReturnType<typeof useDownloadsQuery>;
export type DownloadsLazyQueryHookResult = ReturnType<typeof useDownloadsLazyQuery>;
export type DownloadsQueryResult = Apollo.QueryResult<DownloadsQuery, DownloadsQueryVariables>;
export const CreateContactDocument = gql`
    mutation CreateContact($input: CreateContactInput!) {
  createContact(input: $input) {
    contact {
      ...ContactFragment
    }
    errors {
      ...errorFragment
    }
  }
}
    ${ContactFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const UpdateContactDocument = gql`
    mutation UpdateContact($input: UpdateContactInput!) {
  updateContact(input: $input) {
    contact {
      ...ContactFragment
    }
    errors {
      ...errorFragment
    }
  }
}
    ${ContactFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type UpdateContactMutationFn = Apollo.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactMutation, UpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, options);
      }
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = Apollo.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = Apollo.BaseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>;
export const ContactsDocument = gql`
    query Contacts($businessUnit: Int!, $contactType: String) {
  contacts(businessUnit: $businessUnit, contactType: $contactType) {
    ...ContactFragment
  }
}
    ${ContactFragmentFragmentDoc}`;

/**
 * __useContactsQuery__
 *
 * To run a query within a React component, call `useContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *      contactType: // value for 'contactType'
 *   },
 * });
 */
export function useContactsQuery(baseOptions: Apollo.QueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
      }
export function useContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
        }
export type ContactsQueryHookResult = ReturnType<typeof useContactsQuery>;
export type ContactsLazyQueryHookResult = ReturnType<typeof useContactsLazyQuery>;
export type ContactsQueryResult = Apollo.QueryResult<ContactsQuery, ContactsQueryVariables>;
export const ContactDocument = gql`
    query Contact($id: Int!, $businessUnitId: Int!) {
  contact(id: $id, businessUnitId: $businessUnitId) {
    ...ContactFragment
  }
}
    ${ContactFragmentFragmentDoc}`;

/**
 * __useContactQuery__
 *
 * To run a query within a React component, call `useContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useContactQuery(baseOptions: Apollo.QueryHookOptions<ContactQuery, ContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
      }
export function useContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactQuery, ContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
        }
export type ContactQueryHookResult = ReturnType<typeof useContactQuery>;
export type ContactLazyQueryHookResult = ReturnType<typeof useContactLazyQuery>;
export type ContactQueryResult = Apollo.QueryResult<ContactQuery, ContactQueryVariables>;
export const SupplyChainsDocument = gql`
    query SupplyChains($buId: Int!) {
  supplyChainPages(businessUnit: $buId) {
    id
    title
    banner
    accreditation
    subregion
    text
    bullets {
      id
      text
      order
    }
  }
}
    `;

/**
 * __useSupplyChainsQuery__
 *
 * To run a query within a React component, call `useSupplyChainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplyChainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplyChainsQuery({
 *   variables: {
 *      buId: // value for 'buId'
 *   },
 * });
 */
export function useSupplyChainsQuery(baseOptions: Apollo.QueryHookOptions<SupplyChainsQuery, SupplyChainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplyChainsQuery, SupplyChainsQueryVariables>(SupplyChainsDocument, options);
      }
export function useSupplyChainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplyChainsQuery, SupplyChainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplyChainsQuery, SupplyChainsQueryVariables>(SupplyChainsDocument, options);
        }
export type SupplyChainsQueryHookResult = ReturnType<typeof useSupplyChainsQuery>;
export type SupplyChainsLazyQueryHookResult = ReturnType<typeof useSupplyChainsLazyQuery>;
export type SupplyChainsQueryResult = Apollo.QueryResult<SupplyChainsQuery, SupplyChainsQueryVariables>;
export const MergeAnimalTagsDocument = gql`
    mutation mergeAnimalTags($input: MergeAnimalTagsInput!) {
  mergeAnimalTags(input: $input) {
    animals {
      ...singleAnimalFragment
    }
    errors {
      field
      message
    }
  }
}
    ${SingleAnimalFragmentFragmentDoc}`;
export type MergeAnimalTagsMutationFn = Apollo.MutationFunction<MergeAnimalTagsMutation, MergeAnimalTagsMutationVariables>;

/**
 * __useMergeAnimalTagsMutation__
 *
 * To run a mutation, you first call `useMergeAnimalTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeAnimalTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeAnimalTagsMutation, { data, loading, error }] = useMergeAnimalTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeAnimalTagsMutation(baseOptions?: Apollo.MutationHookOptions<MergeAnimalTagsMutation, MergeAnimalTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeAnimalTagsMutation, MergeAnimalTagsMutationVariables>(MergeAnimalTagsDocument, options);
      }
export type MergeAnimalTagsMutationHookResult = ReturnType<typeof useMergeAnimalTagsMutation>;
export type MergeAnimalTagsMutationResult = Apollo.MutationResult<MergeAnimalTagsMutation>;
export type MergeAnimalTagsMutationOptions = Apollo.BaseMutationOptions<MergeAnimalTagsMutation, MergeAnimalTagsMutationVariables>;
export const CreateTagDocument = gql`
    mutation createTag($input: CreateTagInput!) {
  createTag(input: $input) {
    animalTag {
      id
      slug
      name
      color
      ownership
      animalTypes {
        id
      }
    }
    errors {
      field
      message
    }
  }
}
    `;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const UpdateTagDocument = gql`
    mutation updateTag($input: UpdateTagInput!) {
  updateTag(input: $input) {
    animalTag {
      id
      slug
      name
      color
      ownership
      animalTypes {
        id
      }
    }
    errors {
      field
      message
    }
  }
}
    `;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const DeleteTagDocument = gql`
    mutation deleteTag($input: DeleteTagInput!) {
  deleteTag(input: $input) {
    success
    errors {
      field
      message
    }
  }
}
    `;
export type DeleteTagMutationFn = Apollo.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const AnimalTagsDocument = gql`
    query AnimalTags($buId: Int!, $tagIds: [ID!]) {
  animalTags(businessUnitId: $buId, tagIds: $tagIds, first: 100) {
    edges {
      node {
        id
        name
        color
        numAliveAnimals
        ownership
        schema {
          id
          isRemovable
        }
      }
    }
  }
}
    `;

/**
 * __useAnimalTagsQuery__
 *
 * To run a query within a React component, call `useAnimalTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnimalTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnimalTagsQuery({
 *   variables: {
 *      buId: // value for 'buId'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useAnimalTagsQuery(baseOptions: Apollo.QueryHookOptions<AnimalTagsQuery, AnimalTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnimalTagsQuery, AnimalTagsQueryVariables>(AnimalTagsDocument, options);
      }
export function useAnimalTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnimalTagsQuery, AnimalTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnimalTagsQuery, AnimalTagsQueryVariables>(AnimalTagsDocument, options);
        }
export type AnimalTagsQueryHookResult = ReturnType<typeof useAnimalTagsQuery>;
export type AnimalTagsLazyQueryHookResult = ReturnType<typeof useAnimalTagsLazyQuery>;
export type AnimalTagsQueryResult = Apollo.QueryResult<AnimalTagsQuery, AnimalTagsQueryVariables>;
export const AnimalTagDocument = gql`
    query AnimalTag($buId: Int!, $tagIds: [ID!]) {
  animalTags(businessUnitId: $buId, tagIds: $tagIds, first: 100) {
    edges {
      node {
        id
        name
        color
        numAliveAnimals
        ownership
        averageAge
        averageDaysOnFarm
        averageRecordedWeight
        averageEstimatedWeight
      }
    }
  }
}
    `;

/**
 * __useAnimalTagQuery__
 *
 * To run a query within a React component, call `useAnimalTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnimalTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnimalTagQuery({
 *   variables: {
 *      buId: // value for 'buId'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useAnimalTagQuery(baseOptions: Apollo.QueryHookOptions<AnimalTagQuery, AnimalTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnimalTagQuery, AnimalTagQueryVariables>(AnimalTagDocument, options);
      }
export function useAnimalTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnimalTagQuery, AnimalTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnimalTagQuery, AnimalTagQueryVariables>(AnimalTagDocument, options);
        }
export type AnimalTagQueryHookResult = ReturnType<typeof useAnimalTagQuery>;
export type AnimalTagLazyQueryHookResult = ReturnType<typeof useAnimalTagLazyQuery>;
export type AnimalTagQueryResult = Apollo.QueryResult<AnimalTagQuery, AnimalTagQueryVariables>;
export const GetAnimalsWithTagsDocument = gql`
    query GetAnimalsWithTags($businessUnitId: Int!, $first: Int, $last: Int, $before: String, $after: String, $isMale: Boolean, $search: String, $searchIds: [IdentifierType!], $isPregnant: Boolean, $minDob: DateTime, $maxDob: DateTime, $minDof: DateTime, $maxDof: DateTime, $animalTags: [ID!], $animalIds: [ID!], $orderBy: [AnimalSorting!], $field: UUID, $group: UUID) {
  animals(
    businessUnitId: $businessUnitId
    search: $search
    searchIds: $searchIds
    first: $first
    last: $last
    before: $before
    after: $after
    animalTags: $animalTags
    isMale: $isMale
    isPregnant: $isPregnant
    minDob: $minDob
    maxDob: $maxDob
    minDof: $minDof
    maxDof: $maxDof
    animalIds: $animalIds
    orderBy: $orderBy
    field: $field
    group: $group
  ) {
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges {
      node {
        ...animal
      }
    }
  }
}
    ${AnimalFragmentDoc}`;

/**
 * __useGetAnimalsWithTagsQuery__
 *
 * To run a query within a React component, call `useGetAnimalsWithTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalsWithTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalsWithTagsQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      isMale: // value for 'isMale'
 *      search: // value for 'search'
 *      searchIds: // value for 'searchIds'
 *      isPregnant: // value for 'isPregnant'
 *      minDob: // value for 'minDob'
 *      maxDob: // value for 'maxDob'
 *      minDof: // value for 'minDof'
 *      maxDof: // value for 'maxDof'
 *      animalTags: // value for 'animalTags'
 *      animalIds: // value for 'animalIds'
 *      orderBy: // value for 'orderBy'
 *      field: // value for 'field'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useGetAnimalsWithTagsQuery(baseOptions: Apollo.QueryHookOptions<GetAnimalsWithTagsQuery, GetAnimalsWithTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnimalsWithTagsQuery, GetAnimalsWithTagsQueryVariables>(GetAnimalsWithTagsDocument, options);
      }
export function useGetAnimalsWithTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnimalsWithTagsQuery, GetAnimalsWithTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnimalsWithTagsQuery, GetAnimalsWithTagsQueryVariables>(GetAnimalsWithTagsDocument, options);
        }
export type GetAnimalsWithTagsQueryHookResult = ReturnType<typeof useGetAnimalsWithTagsQuery>;
export type GetAnimalsWithTagsLazyQueryHookResult = ReturnType<typeof useGetAnimalsWithTagsLazyQuery>;
export type GetAnimalsWithTagsQueryResult = Apollo.QueryResult<GetAnimalsWithTagsQuery, GetAnimalsWithTagsQueryVariables>;
export const CreateLotDocument = gql`
    mutation CreateLot($input: CreateLotInput!) {
  createLot(input: $input) {
    lot {
      id
    }
    errors {
      field
      message
    }
  }
}
    `;
export type CreateLotMutationFn = Apollo.MutationFunction<CreateLotMutation, CreateLotMutationVariables>;

/**
 * __useCreateLotMutation__
 *
 * To run a mutation, you first call `useCreateLotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLotMutation, { data, loading, error }] = useCreateLotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLotMutation(baseOptions?: Apollo.MutationHookOptions<CreateLotMutation, CreateLotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLotMutation, CreateLotMutationVariables>(CreateLotDocument, options);
      }
export type CreateLotMutationHookResult = ReturnType<typeof useCreateLotMutation>;
export type CreateLotMutationResult = Apollo.MutationResult<CreateLotMutation>;
export type CreateLotMutationOptions = Apollo.BaseMutationOptions<CreateLotMutation, CreateLotMutationVariables>;
export const UpdateLotDocument = gql`
    mutation UpdateLot($input: UpdateLotInput!) {
  updateLot(input: $input) {
    lot {
      id
      images {
        id
        position
      }
    }
    errors {
      field
      message
    }
  }
}
    `;
export type UpdateLotMutationFn = Apollo.MutationFunction<UpdateLotMutation, UpdateLotMutationVariables>;

/**
 * __useUpdateLotMutation__
 *
 * To run a mutation, you first call `useUpdateLotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLotMutation, { data, loading, error }] = useUpdateLotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLotMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLotMutation, UpdateLotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLotMutation, UpdateLotMutationVariables>(UpdateLotDocument, options);
      }
export type UpdateLotMutationHookResult = ReturnType<typeof useUpdateLotMutation>;
export type UpdateLotMutationResult = Apollo.MutationResult<UpdateLotMutation>;
export type UpdateLotMutationOptions = Apollo.BaseMutationOptions<UpdateLotMutation, UpdateLotMutationVariables>;
export const CreateOfferForLotDocument = gql`
    mutation CreateOfferForLot($input: CreateOfferForLotInput!) {
  createOfferForLot(input: $input) {
    offer {
      ...offerFragment
    }
    errors {
      ...errorFragment
    }
  }
}
    ${OfferFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type CreateOfferForLotMutationFn = Apollo.MutationFunction<CreateOfferForLotMutation, CreateOfferForLotMutationVariables>;

/**
 * __useCreateOfferForLotMutation__
 *
 * To run a mutation, you first call `useCreateOfferForLotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfferForLotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOfferForLotMutation, { data, loading, error }] = useCreateOfferForLotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOfferForLotMutation(baseOptions?: Apollo.MutationHookOptions<CreateOfferForLotMutation, CreateOfferForLotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOfferForLotMutation, CreateOfferForLotMutationVariables>(CreateOfferForLotDocument, options);
      }
export type CreateOfferForLotMutationHookResult = ReturnType<typeof useCreateOfferForLotMutation>;
export type CreateOfferForLotMutationResult = Apollo.MutationResult<CreateOfferForLotMutation>;
export type CreateOfferForLotMutationOptions = Apollo.BaseMutationOptions<CreateOfferForLotMutation, CreateOfferForLotMutationVariables>;
export const ResponseToLotOfferDocument = gql`
    mutation ResponseToLotOffer($input: ResponseToLotOfferInput!) {
  responseToLotOffer(input: $input) {
    offer {
      ...offerFragment
    }
    errors {
      ...errorFragment
    }
  }
}
    ${OfferFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type ResponseToLotOfferMutationFn = Apollo.MutationFunction<ResponseToLotOfferMutation, ResponseToLotOfferMutationVariables>;

/**
 * __useResponseToLotOfferMutation__
 *
 * To run a mutation, you first call `useResponseToLotOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResponseToLotOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [responseToLotOfferMutation, { data, loading, error }] = useResponseToLotOfferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResponseToLotOfferMutation(baseOptions?: Apollo.MutationHookOptions<ResponseToLotOfferMutation, ResponseToLotOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResponseToLotOfferMutation, ResponseToLotOfferMutationVariables>(ResponseToLotOfferDocument, options);
      }
export type ResponseToLotOfferMutationHookResult = ReturnType<typeof useResponseToLotOfferMutation>;
export type ResponseToLotOfferMutationResult = Apollo.MutationResult<ResponseToLotOfferMutation>;
export type ResponseToLotOfferMutationOptions = Apollo.BaseMutationOptions<ResponseToLotOfferMutation, ResponseToLotOfferMutationVariables>;
export const MarkAsPaidLotOfferDocument = gql`
    mutation MarkAsPaidLotOffer($input: MarkAsPaidLotOfferInput!) {
  markAsPaidLotOffer(input: $input) {
    offer {
      ...offerFragment
    }
    errors {
      ...errorFragment
    }
  }
}
    ${OfferFragmentFragmentDoc}
${ErrorFragmentFragmentDoc}`;
export type MarkAsPaidLotOfferMutationFn = Apollo.MutationFunction<MarkAsPaidLotOfferMutation, MarkAsPaidLotOfferMutationVariables>;

/**
 * __useMarkAsPaidLotOfferMutation__
 *
 * To run a mutation, you first call `useMarkAsPaidLotOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsPaidLotOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAsPaidLotOfferMutation, { data, loading, error }] = useMarkAsPaidLotOfferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkAsPaidLotOfferMutation(baseOptions?: Apollo.MutationHookOptions<MarkAsPaidLotOfferMutation, MarkAsPaidLotOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAsPaidLotOfferMutation, MarkAsPaidLotOfferMutationVariables>(MarkAsPaidLotOfferDocument, options);
      }
export type MarkAsPaidLotOfferMutationHookResult = ReturnType<typeof useMarkAsPaidLotOfferMutation>;
export type MarkAsPaidLotOfferMutationResult = Apollo.MutationResult<MarkAsPaidLotOfferMutation>;
export type MarkAsPaidLotOfferMutationOptions = Apollo.BaseMutationOptions<MarkAsPaidLotOfferMutation, MarkAsPaidLotOfferMutationVariables>;
export const LotSellerSentAnimalsDocument = gql`
    mutation LotSellerSentAnimals($input: LotSellerSentAnimalsInput!) {
  lotSellerSentAnimals(input: $input) {
    lot {
      id
      status
    }
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type LotSellerSentAnimalsMutationFn = Apollo.MutationFunction<LotSellerSentAnimalsMutation, LotSellerSentAnimalsMutationVariables>;

/**
 * __useLotSellerSentAnimalsMutation__
 *
 * To run a mutation, you first call `useLotSellerSentAnimalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLotSellerSentAnimalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lotSellerSentAnimalsMutation, { data, loading, error }] = useLotSellerSentAnimalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLotSellerSentAnimalsMutation(baseOptions?: Apollo.MutationHookOptions<LotSellerSentAnimalsMutation, LotSellerSentAnimalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LotSellerSentAnimalsMutation, LotSellerSentAnimalsMutationVariables>(LotSellerSentAnimalsDocument, options);
      }
export type LotSellerSentAnimalsMutationHookResult = ReturnType<typeof useLotSellerSentAnimalsMutation>;
export type LotSellerSentAnimalsMutationResult = Apollo.MutationResult<LotSellerSentAnimalsMutation>;
export type LotSellerSentAnimalsMutationOptions = Apollo.BaseMutationOptions<LotSellerSentAnimalsMutation, LotSellerSentAnimalsMutationVariables>;
export const LotBuyerReceivedAnimalsDocument = gql`
    mutation LotBuyerReceivedAnimals($input: LotBuyerReceivedAnimalsInput!) {
  lotBuyerReceivedAnimals(input: $input) {
    lot {
      id
      status
    }
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type LotBuyerReceivedAnimalsMutationFn = Apollo.MutationFunction<LotBuyerReceivedAnimalsMutation, LotBuyerReceivedAnimalsMutationVariables>;

/**
 * __useLotBuyerReceivedAnimalsMutation__
 *
 * To run a mutation, you first call `useLotBuyerReceivedAnimalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLotBuyerReceivedAnimalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lotBuyerReceivedAnimalsMutation, { data, loading, error }] = useLotBuyerReceivedAnimalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLotBuyerReceivedAnimalsMutation(baseOptions?: Apollo.MutationHookOptions<LotBuyerReceivedAnimalsMutation, LotBuyerReceivedAnimalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LotBuyerReceivedAnimalsMutation, LotBuyerReceivedAnimalsMutationVariables>(LotBuyerReceivedAnimalsDocument, options);
      }
export type LotBuyerReceivedAnimalsMutationHookResult = ReturnType<typeof useLotBuyerReceivedAnimalsMutation>;
export type LotBuyerReceivedAnimalsMutationResult = Apollo.MutationResult<LotBuyerReceivedAnimalsMutation>;
export type LotBuyerReceivedAnimalsMutationOptions = Apollo.BaseMutationOptions<LotBuyerReceivedAnimalsMutation, LotBuyerReceivedAnimalsMutationVariables>;
export const BuyingLotsDocument = gql`
    query BuyingLots($after: String, $before: String, $businessUnit: Int!, $first: Int, $last: Int, $orderBy: String, $showExpired: Boolean, $status: [String], $distance: Float, $categoryOfSale: Float, $animalType: Float) {
  buyingLots(
    after: $after
    before: $before
    businessUnit: $businessUnit
    first: $first
    last: $last
    orderBy: $orderBy
    showExpired: $showExpired
    status: $status
    distance: $distance
    categoryOfSale: $categoryOfSale
    animalType: $animalType
  ) {
    edges {
      node {
        businessUnit {
          id
          name
          country {
            id
            code
          }
          unitsOfMeasurement {
            id
            code
            measurementType
          }
          county
        }
        id
        currency {
          id
          code
        }
        description
        distance(businessUnitId: $businessUnit)
        name
        price
        priceUnit
        totalPrice
        expiresAt
        status
        images {
          id
          photo
          thumbnailSmall
          position
        }
        offersPendingCount
        deliveryAddress {
          id
          country {
            id
            name
          }
          postcode
        }
        animalsAverageAge
        animalsAverageGrowthRate
        animalsAverageTimesWeighed
        animalsAverageCurrentWeight
        animalsMaxNumberMoves
        animalsNumberSires
        animalsNumberWithdrawals
        animalsCountBreedAndGender {
          breedName
          isMale
          count
        }
        isPublic
        startDate
        animalsCount
        isExpired
        animalType {
          id
          name
        }
        categoryOfSale {
          id
          category
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useBuyingLotsQuery__
 *
 * To run a query within a React component, call `useBuyingLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyingLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyingLotsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      businessUnit: // value for 'businessUnit'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *      showExpired: // value for 'showExpired'
 *      status: // value for 'status'
 *      distance: // value for 'distance'
 *      categoryOfSale: // value for 'categoryOfSale'
 *      animalType: // value for 'animalType'
 *   },
 * });
 */
export function useBuyingLotsQuery(baseOptions: Apollo.QueryHookOptions<BuyingLotsQuery, BuyingLotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuyingLotsQuery, BuyingLotsQueryVariables>(BuyingLotsDocument, options);
      }
export function useBuyingLotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyingLotsQuery, BuyingLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuyingLotsQuery, BuyingLotsQueryVariables>(BuyingLotsDocument, options);
        }
export type BuyingLotsQueryHookResult = ReturnType<typeof useBuyingLotsQuery>;
export type BuyingLotsLazyQueryHookResult = ReturnType<typeof useBuyingLotsLazyQuery>;
export type BuyingLotsQueryResult = Apollo.QueryResult<BuyingLotsQuery, BuyingLotsQueryVariables>;
export const BuyingLotDocument = gql`
    query BuyingLot($id: Int!, $businessUnitId: Int!) {
  buyingLot(id: $id, businessUnit: $businessUnitId) {
    id
    description
    name
    categoryOfSale {
      id
      category
    }
    price
    status
    totalPrice
    pricePerKgOnCreation
    priceUnit
    currency {
      id
      code
    }
    expiresAt
    startDate
    animals {
      ...publicAnimalFragment
    }
    offers(businessUnitId: $businessUnitId) {
      id
      status
      businessUnit {
        id
      }
      price
      totalPriceOnCreation
      currency {
        id
        name
        code
      }
    }
    images {
      id
      photo
      position
    }
    deliveryAddress {
      id
      unitName
      addressLine1
      addressLine2
      city
      country {
        id
        code
        name
      }
      postcode
      primary
      locationType
      locationId
    }
    businessUnit {
      id
      name
      postcode
    }
    animalType {
      id
      name
    }
    tbRequirements
    preMovementTestDate
    referenceCode
    isAcceptedMyOffer(businessUnitId: $businessUnitId)
    isPublic
    isExpired
  }
}
    ${PublicAnimalFragmentFragmentDoc}`;

/**
 * __useBuyingLotQuery__
 *
 * To run a query within a React component, call `useBuyingLotQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyingLotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyingLotQuery({
 *   variables: {
 *      id: // value for 'id'
 *      businessUnitId: // value for 'businessUnitId'
 *   },
 * });
 */
export function useBuyingLotQuery(baseOptions: Apollo.QueryHookOptions<BuyingLotQuery, BuyingLotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuyingLotQuery, BuyingLotQueryVariables>(BuyingLotDocument, options);
      }
export function useBuyingLotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyingLotQuery, BuyingLotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuyingLotQuery, BuyingLotQueryVariables>(BuyingLotDocument, options);
        }
export type BuyingLotQueryHookResult = ReturnType<typeof useBuyingLotQuery>;
export type BuyingLotLazyQueryHookResult = ReturnType<typeof useBuyingLotLazyQuery>;
export type BuyingLotQueryResult = Apollo.QueryResult<BuyingLotQuery, BuyingLotQueryVariables>;
export const MyLotsDocument = gql`
    query MyLots($businessUnit: Int!, $isActive: Boolean, $after: String, $first: Int) {
  myLots(
    businessUnit: $businessUnit
    isActive: $isActive
    after: $after
    first: $first
  ) {
    edges {
      node {
        id
        description
        name
        price
        priceUnit
        totalPrice
        createdAt
        expiresAt
        currency {
          id
          code
        }
        categoryOfSale {
          category
          id
        }
        status
        lotOffers {
          id
          price
        }
        images {
          id
          photo
          thumbnailSmall
          position
        }
        offersPendingCount
        deliveryAddress {
          id
          locationId
          unitName
        }
        animalsAverageAge
        animalsAverageGrowthRate
        animalsAverageTimesWeighed
        animalsAverageCurrentWeight
        animalsMaxNumberMoves
        animalsNumberSires
        animalsNumberWithdrawals
        animalsCountBreedAndGender {
          breedName
          isMale
          count
        }
        distributionLists {
          id
          name
        }
        isPublic
        startDate
        animalsCount
        isExpired
        animalType {
          id
          name
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useMyLotsQuery__
 *
 * To run a query within a React component, call `useMyLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLotsQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *      isActive: // value for 'isActive'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useMyLotsQuery(baseOptions: Apollo.QueryHookOptions<MyLotsQuery, MyLotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLotsQuery, MyLotsQueryVariables>(MyLotsDocument, options);
      }
export function useMyLotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLotsQuery, MyLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLotsQuery, MyLotsQueryVariables>(MyLotsDocument, options);
        }
export type MyLotsQueryHookResult = ReturnType<typeof useMyLotsQuery>;
export type MyLotsLazyQueryHookResult = ReturnType<typeof useMyLotsLazyQuery>;
export type MyLotsQueryResult = Apollo.QueryResult<MyLotsQuery, MyLotsQueryVariables>;
export const MyLotDocument = gql`
    query MyLot($id: Int!, $businessUnit: Int!) {
  myLot(id: $id, businessUnit: $businessUnit) {
    id
    categoryOfSale {
      id
      category
    }
    animalType {
      id
    }
    description
    name
    price
    status
    priceUnit
    pricePerKgOnCreation
    referenceCode
    createdAt
    startDate
    expiresAt
    isExpired
    animals {
      ...animalFragment
    }
    lotConfigurableSellerMessage
    tbRequirements
    preMovementTestDate
    images {
      id
      photo
      position
      thumbnailSmall
    }
    lotOffers {
      id
      price
      offeredNumber
      status
      createdAt
      priceUnit
      collectionDate
      totalPriceOnCreation
      currency {
        id
        code
      }
      businessUnit {
        id
        name
      }
      createdBy {
        id
        firstName
        lastName
      }
    }
    deliveryAddress {
      id
      locationId
      unitName
    }
    tradingType {
      id
      slug
    }
    distributionLists {
      id
      name
    }
    isPublic
  }
}
    ${AnimalFragmentFragmentDoc}`;

/**
 * __useMyLotQuery__
 *
 * To run a query within a React component, call `useMyLotQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLotQuery({
 *   variables: {
 *      id: // value for 'id'
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useMyLotQuery(baseOptions: Apollo.QueryHookOptions<MyLotQuery, MyLotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLotQuery, MyLotQueryVariables>(MyLotDocument, options);
      }
export function useMyLotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLotQuery, MyLotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLotQuery, MyLotQueryVariables>(MyLotDocument, options);
        }
export type MyLotQueryHookResult = ReturnType<typeof useMyLotQuery>;
export type MyLotLazyQueryHookResult = ReturnType<typeof useMyLotLazyQuery>;
export type MyLotQueryResult = Apollo.QueryResult<MyLotQuery, MyLotQueryVariables>;
export const TermsAndConditionsDocument = gql`
    query TermsAndConditions($tacType: String!) {
  termsAndConditions(tacType: $tacType) {
    title
    description
    type
  }
}
    `;

/**
 * __useTermsAndConditionsQuery__
 *
 * To run a query within a React component, call `useTermsAndConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTermsAndConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTermsAndConditionsQuery({
 *   variables: {
 *      tacType: // value for 'tacType'
 *   },
 * });
 */
export function useTermsAndConditionsQuery(baseOptions: Apollo.QueryHookOptions<TermsAndConditionsQuery, TermsAndConditionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TermsAndConditionsQuery, TermsAndConditionsQueryVariables>(TermsAndConditionsDocument, options);
      }
export function useTermsAndConditionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TermsAndConditionsQuery, TermsAndConditionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TermsAndConditionsQuery, TermsAndConditionsQueryVariables>(TermsAndConditionsDocument, options);
        }
export type TermsAndConditionsQueryHookResult = ReturnType<typeof useTermsAndConditionsQuery>;
export type TermsAndConditionsLazyQueryHookResult = ReturnType<typeof useTermsAndConditionsLazyQuery>;
export type TermsAndConditionsQueryResult = Apollo.QueryResult<TermsAndConditionsQuery, TermsAndConditionsQueryVariables>;
export const CategoriesOfSaleDocument = gql`
    query CategoriesOfSale($animalType: Int!) {
  categoriesOfSale(animalType: $animalType) {
    edges {
      node {
        id
        category
      }
    }
  }
}
    `;

/**
 * __useCategoriesOfSaleQuery__
 *
 * To run a query within a React component, call `useCategoriesOfSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesOfSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesOfSaleQuery({
 *   variables: {
 *      animalType: // value for 'animalType'
 *   },
 * });
 */
export function useCategoriesOfSaleQuery(baseOptions: Apollo.QueryHookOptions<CategoriesOfSaleQuery, CategoriesOfSaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriesOfSaleQuery, CategoriesOfSaleQueryVariables>(CategoriesOfSaleDocument, options);
      }
export function useCategoriesOfSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriesOfSaleQuery, CategoriesOfSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriesOfSaleQuery, CategoriesOfSaleQueryVariables>(CategoriesOfSaleDocument, options);
        }
export type CategoriesOfSaleQueryHookResult = ReturnType<typeof useCategoriesOfSaleQuery>;
export type CategoriesOfSaleLazyQueryHookResult = ReturnType<typeof useCategoriesOfSaleLazyQuery>;
export type CategoriesOfSaleQueryResult = Apollo.QueryResult<CategoriesOfSaleQuery, CategoriesOfSaleQueryVariables>;
export const AddDeliveryAddressDocument = gql`
    mutation addDeliveryAddress($input: AddDeliveryAddressInput!) {
  addDeliveryAddress(input: $input) {
    deliveryAddress {
      id
      unitName
    }
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type AddDeliveryAddressMutationFn = Apollo.MutationFunction<AddDeliveryAddressMutation, AddDeliveryAddressMutationVariables>;

/**
 * __useAddDeliveryAddressMutation__
 *
 * To run a mutation, you first call `useAddDeliveryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDeliveryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDeliveryAddressMutation, { data, loading, error }] = useAddDeliveryAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDeliveryAddressMutation(baseOptions?: Apollo.MutationHookOptions<AddDeliveryAddressMutation, AddDeliveryAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDeliveryAddressMutation, AddDeliveryAddressMutationVariables>(AddDeliveryAddressDocument, options);
      }
export type AddDeliveryAddressMutationHookResult = ReturnType<typeof useAddDeliveryAddressMutation>;
export type AddDeliveryAddressMutationResult = Apollo.MutationResult<AddDeliveryAddressMutation>;
export type AddDeliveryAddressMutationOptions = Apollo.BaseMutationOptions<AddDeliveryAddressMutation, AddDeliveryAddressMutationVariables>;
export const EditDeliveryAddressDocument = gql`
    mutation editDeliveryAddress($input: EditDeliveryAddressInput!) {
  editDeliveryAddress(input: $input) {
    deliveryAddress {
      id
      unitName
    }
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type EditDeliveryAddressMutationFn = Apollo.MutationFunction<EditDeliveryAddressMutation, EditDeliveryAddressMutationVariables>;

/**
 * __useEditDeliveryAddressMutation__
 *
 * To run a mutation, you first call `useEditDeliveryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDeliveryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDeliveryAddressMutation, { data, loading, error }] = useEditDeliveryAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDeliveryAddressMutation(baseOptions?: Apollo.MutationHookOptions<EditDeliveryAddressMutation, EditDeliveryAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDeliveryAddressMutation, EditDeliveryAddressMutationVariables>(EditDeliveryAddressDocument, options);
      }
export type EditDeliveryAddressMutationHookResult = ReturnType<typeof useEditDeliveryAddressMutation>;
export type EditDeliveryAddressMutationResult = Apollo.MutationResult<EditDeliveryAddressMutation>;
export type EditDeliveryAddressMutationOptions = Apollo.BaseMutationOptions<EditDeliveryAddressMutation, EditDeliveryAddressMutationVariables>;
export const DeleteDeliveryAddressDocument = gql`
    mutation deleteDeliveryAddress($input: DeleteDeliveryAddressInput!) {
  deleteDeliveryAddress(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type DeleteDeliveryAddressMutationFn = Apollo.MutationFunction<DeleteDeliveryAddressMutation, DeleteDeliveryAddressMutationVariables>;

/**
 * __useDeleteDeliveryAddressMutation__
 *
 * To run a mutation, you first call `useDeleteDeliveryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeliveryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeliveryAddressMutation, { data, loading, error }] = useDeleteDeliveryAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDeliveryAddressMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeliveryAddressMutation, DeleteDeliveryAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeliveryAddressMutation, DeleteDeliveryAddressMutationVariables>(DeleteDeliveryAddressDocument, options);
      }
export type DeleteDeliveryAddressMutationHookResult = ReturnType<typeof useDeleteDeliveryAddressMutation>;
export type DeleteDeliveryAddressMutationResult = Apollo.MutationResult<DeleteDeliveryAddressMutation>;
export type DeleteDeliveryAddressMutationOptions = Apollo.BaseMutationOptions<DeleteDeliveryAddressMutation, DeleteDeliveryAddressMutationVariables>;
export const UploadDiscountGridDocument = gql`
    mutation UploadDiscountGrid($input: UploadDiscountGridInput!) {
  uploadDiscountGrid(input: $input) {
    discountGrid {
      id
      name
    }
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type UploadDiscountGridMutationFn = Apollo.MutationFunction<UploadDiscountGridMutation, UploadDiscountGridMutationVariables>;

/**
 * __useUploadDiscountGridMutation__
 *
 * To run a mutation, you first call `useUploadDiscountGridMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDiscountGridMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDiscountGridMutation, { data, loading, error }] = useUploadDiscountGridMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadDiscountGridMutation(baseOptions?: Apollo.MutationHookOptions<UploadDiscountGridMutation, UploadDiscountGridMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDiscountGridMutation, UploadDiscountGridMutationVariables>(UploadDiscountGridDocument, options);
      }
export type UploadDiscountGridMutationHookResult = ReturnType<typeof useUploadDiscountGridMutation>;
export type UploadDiscountGridMutationResult = Apollo.MutationResult<UploadDiscountGridMutation>;
export type UploadDiscountGridMutationOptions = Apollo.BaseMutationOptions<UploadDiscountGridMutation, UploadDiscountGridMutationVariables>;
export const CreateDistributionListDocument = gql`
    mutation CreateDistributionList($input: CreateDistributionListInput!) {
  createDistributionList(input: $input) {
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type CreateDistributionListMutationFn = Apollo.MutationFunction<CreateDistributionListMutation, CreateDistributionListMutationVariables>;

/**
 * __useCreateDistributionListMutation__
 *
 * To run a mutation, you first call `useCreateDistributionListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDistributionListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDistributionListMutation, { data, loading, error }] = useCreateDistributionListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDistributionListMutation(baseOptions?: Apollo.MutationHookOptions<CreateDistributionListMutation, CreateDistributionListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDistributionListMutation, CreateDistributionListMutationVariables>(CreateDistributionListDocument, options);
      }
export type CreateDistributionListMutationHookResult = ReturnType<typeof useCreateDistributionListMutation>;
export type CreateDistributionListMutationResult = Apollo.MutationResult<CreateDistributionListMutation>;
export type CreateDistributionListMutationOptions = Apollo.BaseMutationOptions<CreateDistributionListMutation, CreateDistributionListMutationVariables>;
export const DeleteDistributionListDocument = gql`
    mutation DeleteDistributionList($input: DeleteDistributionListInput!) {
  deleteDistributionList(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type DeleteDistributionListMutationFn = Apollo.MutationFunction<DeleteDistributionListMutation, DeleteDistributionListMutationVariables>;

/**
 * __useDeleteDistributionListMutation__
 *
 * To run a mutation, you first call `useDeleteDistributionListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDistributionListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDistributionListMutation, { data, loading, error }] = useDeleteDistributionListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDistributionListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDistributionListMutation, DeleteDistributionListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDistributionListMutation, DeleteDistributionListMutationVariables>(DeleteDistributionListDocument, options);
      }
export type DeleteDistributionListMutationHookResult = ReturnType<typeof useDeleteDistributionListMutation>;
export type DeleteDistributionListMutationResult = Apollo.MutationResult<DeleteDistributionListMutation>;
export type DeleteDistributionListMutationOptions = Apollo.BaseMutationOptions<DeleteDistributionListMutation, DeleteDistributionListMutationVariables>;
export const UpdateDistributionListDocument = gql`
    mutation UpdateDistributionList($input: UpdateDistributionListInput!) {
  updateDistributionList(input: $input) {
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type UpdateDistributionListMutationFn = Apollo.MutationFunction<UpdateDistributionListMutation, UpdateDistributionListMutationVariables>;

/**
 * __useUpdateDistributionListMutation__
 *
 * To run a mutation, you first call `useUpdateDistributionListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDistributionListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDistributionListMutation, { data, loading, error }] = useUpdateDistributionListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDistributionListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDistributionListMutation, UpdateDistributionListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDistributionListMutation, UpdateDistributionListMutationVariables>(UpdateDistributionListDocument, options);
      }
export type UpdateDistributionListMutationHookResult = ReturnType<typeof useUpdateDistributionListMutation>;
export type UpdateDistributionListMutationResult = Apollo.MutationResult<UpdateDistributionListMutation>;
export type UpdateDistributionListMutationOptions = Apollo.BaseMutationOptions<UpdateDistributionListMutation, UpdateDistributionListMutationVariables>;
export const MarkOffersAsReadDocument = gql`
    mutation MarkOffersAsRead($input: OfferMarkAsReadInput!) {
  offerMarkAsRead(input: $input) {
    success
    errors {
      ...errorFragment
    }
  }
}
    ${ErrorFragmentFragmentDoc}`;
export type MarkOffersAsReadMutationFn = Apollo.MutationFunction<MarkOffersAsReadMutation, MarkOffersAsReadMutationVariables>;

/**
 * __useMarkOffersAsReadMutation__
 *
 * To run a mutation, you first call `useMarkOffersAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkOffersAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markOffersAsReadMutation, { data, loading, error }] = useMarkOffersAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkOffersAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkOffersAsReadMutation, MarkOffersAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkOffersAsReadMutation, MarkOffersAsReadMutationVariables>(MarkOffersAsReadDocument, options);
      }
export type MarkOffersAsReadMutationHookResult = ReturnType<typeof useMarkOffersAsReadMutation>;
export type MarkOffersAsReadMutationResult = Apollo.MutationResult<MarkOffersAsReadMutation>;
export type MarkOffersAsReadMutationOptions = Apollo.BaseMutationOptions<MarkOffersAsReadMutation, MarkOffersAsReadMutationVariables>;
export const DeliveryAddressesDocument = gql`
    query deliveryAddresses($businessUnit: Int!) {
  deliveryAddresses(businessUnit: $businessUnit) {
    ...deliveryAddressFragment
  }
}
    ${DeliveryAddressFragmentFragmentDoc}`;

/**
 * __useDeliveryAddressesQuery__
 *
 * To run a query within a React component, call `useDeliveryAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryAddressesQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useDeliveryAddressesQuery(baseOptions: Apollo.QueryHookOptions<DeliveryAddressesQuery, DeliveryAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryAddressesQuery, DeliveryAddressesQueryVariables>(DeliveryAddressesDocument, options);
      }
export function useDeliveryAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryAddressesQuery, DeliveryAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryAddressesQuery, DeliveryAddressesQueryVariables>(DeliveryAddressesDocument, options);
        }
export type DeliveryAddressesQueryHookResult = ReturnType<typeof useDeliveryAddressesQuery>;
export type DeliveryAddressesLazyQueryHookResult = ReturnType<typeof useDeliveryAddressesLazyQuery>;
export type DeliveryAddressesQueryResult = Apollo.QueryResult<DeliveryAddressesQuery, DeliveryAddressesQueryVariables>;
export const CountriesDocument = gql`
    query Countries {
  countries {
    id
    code
    name
    isoAlpha2
  }
}
    `;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const HowDidYouHearAboutBreedrChoicesDocument = gql`
    query HowDidYouHearAboutBreedrChoices {
  howDidYouHearAboutBreedrChoices {
    id
    choice
    slug
  }
}
    `;

/**
 * __useHowDidYouHearAboutBreedrChoicesQuery__
 *
 * To run a query within a React component, call `useHowDidYouHearAboutBreedrChoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHowDidYouHearAboutBreedrChoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHowDidYouHearAboutBreedrChoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useHowDidYouHearAboutBreedrChoicesQuery(baseOptions?: Apollo.QueryHookOptions<HowDidYouHearAboutBreedrChoicesQuery, HowDidYouHearAboutBreedrChoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HowDidYouHearAboutBreedrChoicesQuery, HowDidYouHearAboutBreedrChoicesQueryVariables>(HowDidYouHearAboutBreedrChoicesDocument, options);
      }
export function useHowDidYouHearAboutBreedrChoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HowDidYouHearAboutBreedrChoicesQuery, HowDidYouHearAboutBreedrChoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HowDidYouHearAboutBreedrChoicesQuery, HowDidYouHearAboutBreedrChoicesQueryVariables>(HowDidYouHearAboutBreedrChoicesDocument, options);
        }
export type HowDidYouHearAboutBreedrChoicesQueryHookResult = ReturnType<typeof useHowDidYouHearAboutBreedrChoicesQuery>;
export type HowDidYouHearAboutBreedrChoicesLazyQueryHookResult = ReturnType<typeof useHowDidYouHearAboutBreedrChoicesLazyQuery>;
export type HowDidYouHearAboutBreedrChoicesQueryResult = Apollo.QueryResult<HowDidYouHearAboutBreedrChoicesQuery, HowDidYouHearAboutBreedrChoicesQueryVariables>;
export const GetDiscountGridsDocument = gql`
    query GetDiscountGrids($businessUnit: Int!) {
  discountGrids(businessUnit: $businessUnit) {
    id
    name
  }
}
    `;

/**
 * __useGetDiscountGridsQuery__
 *
 * To run a query within a React component, call `useGetDiscountGridsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountGridsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountGridsQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useGetDiscountGridsQuery(baseOptions: Apollo.QueryHookOptions<GetDiscountGridsQuery, GetDiscountGridsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountGridsQuery, GetDiscountGridsQueryVariables>(GetDiscountGridsDocument, options);
      }
export function useGetDiscountGridsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountGridsQuery, GetDiscountGridsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountGridsQuery, GetDiscountGridsQueryVariables>(GetDiscountGridsDocument, options);
        }
export type GetDiscountGridsQueryHookResult = ReturnType<typeof useGetDiscountGridsQuery>;
export type GetDiscountGridsLazyQueryHookResult = ReturnType<typeof useGetDiscountGridsLazyQuery>;
export type GetDiscountGridsQueryResult = Apollo.QueryResult<GetDiscountGridsQuery, GetDiscountGridsQueryVariables>;
export const GetDistributionListsCountDocument = gql`
    query GetDistributionListsCount($businessUnit: Int!) {
  distributionLists(businessUnit: $businessUnit) {
    count
  }
}
    `;

/**
 * __useGetDistributionListsCountQuery__
 *
 * To run a query within a React component, call `useGetDistributionListsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionListsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionListsCountQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useGetDistributionListsCountQuery(baseOptions: Apollo.QueryHookOptions<GetDistributionListsCountQuery, GetDistributionListsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDistributionListsCountQuery, GetDistributionListsCountQueryVariables>(GetDistributionListsCountDocument, options);
      }
export function useGetDistributionListsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistributionListsCountQuery, GetDistributionListsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDistributionListsCountQuery, GetDistributionListsCountQueryVariables>(GetDistributionListsCountDocument, options);
        }
export type GetDistributionListsCountQueryHookResult = ReturnType<typeof useGetDistributionListsCountQuery>;
export type GetDistributionListsCountLazyQueryHookResult = ReturnType<typeof useGetDistributionListsCountLazyQuery>;
export type GetDistributionListsCountQueryResult = Apollo.QueryResult<GetDistributionListsCountQuery, GetDistributionListsCountQueryVariables>;
export const GetDistributionListsDocument = gql`
    query GetDistributionLists($businessUnit: Int!) {
  distributionLists(businessUnit: $businessUnit) {
    edges {
      node {
        id
        name
        suppliers {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetDistributionListsQuery__
 *
 * To run a query within a React component, call `useGetDistributionListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionListsQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useGetDistributionListsQuery(baseOptions: Apollo.QueryHookOptions<GetDistributionListsQuery, GetDistributionListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDistributionListsQuery, GetDistributionListsQueryVariables>(GetDistributionListsDocument, options);
      }
export function useGetDistributionListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistributionListsQuery, GetDistributionListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDistributionListsQuery, GetDistributionListsQueryVariables>(GetDistributionListsDocument, options);
        }
export type GetDistributionListsQueryHookResult = ReturnType<typeof useGetDistributionListsQuery>;
export type GetDistributionListsLazyQueryHookResult = ReturnType<typeof useGetDistributionListsLazyQuery>;
export type GetDistributionListsQueryResult = Apollo.QueryResult<GetDistributionListsQuery, GetDistributionListsQueryVariables>;
export const GetDistributionListByIdDocument = gql`
    query GetDistributionListById($businessUnit: Int!, $id: Int!) {
  distributionList(businessUnit: $businessUnit, id: $id) {
    id
    name
    suppliers {
      id
      name
      location {
        city
        unitName
      }
    }
  }
}
    `;

/**
 * __useGetDistributionListByIdQuery__
 *
 * To run a query within a React component, call `useGetDistributionListByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionListByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionListByIdQuery({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDistributionListByIdQuery(baseOptions: Apollo.QueryHookOptions<GetDistributionListByIdQuery, GetDistributionListByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDistributionListByIdQuery, GetDistributionListByIdQueryVariables>(GetDistributionListByIdDocument, options);
      }
export function useGetDistributionListByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistributionListByIdQuery, GetDistributionListByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDistributionListByIdQuery, GetDistributionListByIdQueryVariables>(GetDistributionListByIdDocument, options);
        }
export type GetDistributionListByIdQueryHookResult = ReturnType<typeof useGetDistributionListByIdQuery>;
export type GetDistributionListByIdLazyQueryHookResult = ReturnType<typeof useGetDistributionListByIdLazyQuery>;
export type GetDistributionListByIdQueryResult = Apollo.QueryResult<GetDistributionListByIdQuery, GetDistributionListByIdQueryVariables>;
export const GetTradingTypesDocument = gql`
    query GetTradingTypes {
  tradingTypes {
    id
    slug
  }
}
    `;

/**
 * __useGetTradingTypesQuery__
 *
 * To run a query within a React component, call `useGetTradingTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTradingTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTradingTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTradingTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetTradingTypesQuery, GetTradingTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTradingTypesQuery, GetTradingTypesQueryVariables>(GetTradingTypesDocument, options);
      }
export function useGetTradingTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTradingTypesQuery, GetTradingTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTradingTypesQuery, GetTradingTypesQueryVariables>(GetTradingTypesDocument, options);
        }
export type GetTradingTypesQueryHookResult = ReturnType<typeof useGetTradingTypesQuery>;
export type GetTradingTypesLazyQueryHookResult = ReturnType<typeof useGetTradingTypesLazyQuery>;
export type GetTradingTypesQueryResult = Apollo.QueryResult<GetTradingTypesQuery, GetTradingTypesQueryVariables>;
export const GetCountBusinessUnitsDocument = gql`
    query GetCountBusinessUnits($postcode: String!, $radius: Int!, $includePreferredSuppliers: Boolean) {
  countBusinessUnits(
    postcode: $postcode
    radius: $radius
    includePreferredSuppliers: $includePreferredSuppliers
  ) {
    count
    errors {
      message
    }
  }
}
    `;

/**
 * __useGetCountBusinessUnitsQuery__
 *
 * To run a query within a React component, call `useGetCountBusinessUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountBusinessUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountBusinessUnitsQuery({
 *   variables: {
 *      postcode: // value for 'postcode'
 *      radius: // value for 'radius'
 *      includePreferredSuppliers: // value for 'includePreferredSuppliers'
 *   },
 * });
 */
export function useGetCountBusinessUnitsQuery(baseOptions: Apollo.QueryHookOptions<GetCountBusinessUnitsQuery, GetCountBusinessUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountBusinessUnitsQuery, GetCountBusinessUnitsQueryVariables>(GetCountBusinessUnitsDocument, options);
      }
export function useGetCountBusinessUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountBusinessUnitsQuery, GetCountBusinessUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountBusinessUnitsQuery, GetCountBusinessUnitsQueryVariables>(GetCountBusinessUnitsDocument, options);
        }
export type GetCountBusinessUnitsQueryHookResult = ReturnType<typeof useGetCountBusinessUnitsQuery>;
export type GetCountBusinessUnitsLazyQueryHookResult = ReturnType<typeof useGetCountBusinessUnitsLazyQuery>;
export type GetCountBusinessUnitsQueryResult = Apollo.QueryResult<GetCountBusinessUnitsQuery, GetCountBusinessUnitsQueryVariables>;
export const GetCurrenciesListDocument = gql`
    query GetCurrenciesList {
  currencies {
    id
    name
    code
  }
}
    `;

/**
 * __useGetCurrenciesListQuery__
 *
 * To run a query within a React component, call `useGetCurrenciesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrenciesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrenciesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrenciesListQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrenciesListQuery, GetCurrenciesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrenciesListQuery, GetCurrenciesListQueryVariables>(GetCurrenciesListDocument, options);
      }
export function useGetCurrenciesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrenciesListQuery, GetCurrenciesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrenciesListQuery, GetCurrenciesListQueryVariables>(GetCurrenciesListDocument, options);
        }
export type GetCurrenciesListQueryHookResult = ReturnType<typeof useGetCurrenciesListQuery>;
export type GetCurrenciesListLazyQueryHookResult = ReturnType<typeof useGetCurrenciesListLazyQuery>;
export type GetCurrenciesListQueryResult = Apollo.QueryResult<GetCurrenciesListQuery, GetCurrenciesListQueryVariables>;
export const GetEstimatedFuturePriceBasedOnWeightDocument = gql`
    query GetEstimatedFuturePriceBasedOnWeight($offerPricePerWeightUnit: Float!, $collectionDate: Date!, $lot: Int!) {
  estimatedFuturePriceBasedOnWeight(
    offerPricePerWeightUnit: $offerPricePerWeightUnit
    collectionDate: $collectionDate
    lot: $lot
  ) {
    futurePrice
    errors {
      field
      code
      message
    }
  }
}
    `;

/**
 * __useGetEstimatedFuturePriceBasedOnWeightQuery__
 *
 * To run a query within a React component, call `useGetEstimatedFuturePriceBasedOnWeightQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstimatedFuturePriceBasedOnWeightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstimatedFuturePriceBasedOnWeightQuery({
 *   variables: {
 *      offerPricePerWeightUnit: // value for 'offerPricePerWeightUnit'
 *      collectionDate: // value for 'collectionDate'
 *      lot: // value for 'lot'
 *   },
 * });
 */
export function useGetEstimatedFuturePriceBasedOnWeightQuery(baseOptions: Apollo.QueryHookOptions<GetEstimatedFuturePriceBasedOnWeightQuery, GetEstimatedFuturePriceBasedOnWeightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstimatedFuturePriceBasedOnWeightQuery, GetEstimatedFuturePriceBasedOnWeightQueryVariables>(GetEstimatedFuturePriceBasedOnWeightDocument, options);
      }
export function useGetEstimatedFuturePriceBasedOnWeightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstimatedFuturePriceBasedOnWeightQuery, GetEstimatedFuturePriceBasedOnWeightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstimatedFuturePriceBasedOnWeightQuery, GetEstimatedFuturePriceBasedOnWeightQueryVariables>(GetEstimatedFuturePriceBasedOnWeightDocument, options);
        }
export type GetEstimatedFuturePriceBasedOnWeightQueryHookResult = ReturnType<typeof useGetEstimatedFuturePriceBasedOnWeightQuery>;
export type GetEstimatedFuturePriceBasedOnWeightLazyQueryHookResult = ReturnType<typeof useGetEstimatedFuturePriceBasedOnWeightLazyQuery>;
export type GetEstimatedFuturePriceBasedOnWeightQueryResult = Apollo.QueryResult<GetEstimatedFuturePriceBasedOnWeightQuery, GetEstimatedFuturePriceBasedOnWeightQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AnimalInterface": [
      "Animal",
      "PublicAnimal",
      "StocktakeObjectType"
    ],
    "BusinessUnitInterface": [
      "BusinessUnit",
      "PublicBusinessUnit"
    ],
    "DeliveryAddressInterface": [
      "DeliveryAddressType",
      "PublicDeliveryAddressType"
    ],
    "Entity": [
      "Group"
    ],
    "EntityAlertInterface": [
      "AnimalAlert"
    ],
    "FarmSystemType": [
      "BcmsConnectionType",
      "CommonFarmSystemType",
      "ScotMovesConnectionType"
    ],
    "Lot": [
      "OwnLot",
      "PublicLot"
    ],
    "ProcessedItem": [
      "ActivityLog",
      "Animal"
    ],
    "TagSchemaInterface": [
      "AnimalTagOverviewType",
      "AnimalTagSchemaType",
      "AnimalTagType"
    ],
    "UnprocessedItem": [
      "UnprocessedAnimal"
    ],
    "Want": [
      "OwnWant",
      "PublicWant"
    ]
  }
};
      export default result;
    
export type AbattoirKeySpecifier = ('abattoirParts' | 'addressInfo' | 'competentAuthority' | 'country' | 'extraData' | 'formattedAddressInfo' | 'id' | 'marks' | 'number' | 'remarks' | 'sectionParts' | 'species' | 'tradingName' | AbattoirKeySpecifier)[];
export type AbattoirFieldPolicy = {
	abattoirParts?: FieldPolicy<any> | FieldReadFunction<any>,
	addressInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	competentAuthority?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	extraData?: FieldPolicy<any> | FieldReadFunction<any>,
	formattedAddressInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	marks?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	remarks?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionParts?: FieldPolicy<any> | FieldReadFunction<any>,
	species?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AbattoirConnectionKeySpecifier = ('edges' | 'pageInfo' | AbattoirConnectionKeySpecifier)[];
export type AbattoirConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AbattoirEdgeKeySpecifier = ('cursor' | 'node' | AbattoirEdgeKeySpecifier)[];
export type AbattoirEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AbattoirEstablishmentKeySpecifier = ('additionalInfo' | 'id' | 'name' | 'slug' | AbattoirEstablishmentKeySpecifier)[];
export type AbattoirEstablishmentFieldPolicy = {
	additionalInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AbattoirPartKeySpecifier = ('abattoirSet' | 'id' | 'name' | 'part' | 'sectionNumber' | AbattoirPartKeySpecifier)[];
export type AbattoirPartFieldPolicy = {
	abattoirSet?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	part?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AcceptDeliveryPayloadKeySpecifier = ('clientMutationId' | 'delivery' | 'errors' | 'success' | AcceptDeliveryPayloadKeySpecifier)[];
export type AcceptDeliveryPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AcceptInvitationPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'producerGroupMember' | AcceptInvitationPayloadKeySpecifier)[];
export type AcceptInvitationPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	producerGroupMember?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccreditationKeySpecifier = ('animalType' | 'icon' | 'id' | 'image' | 'name' | 'position' | AccreditationKeySpecifier)[];
export type AccreditationFieldPolicy = {
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	icon?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActiveIdentifierPreferencesTypeKeySpecifier = ('alternativeId' | 'breedrId' | 'brucellosisId' | 'eId' | 'herdDoggId' | 'name' | 'passportNumber' | 'pedigreeId' | 'tattoo' | 'trichId' | 'tsuBarcode' | 'uhfId' | 'visualId' | ActiveIdentifierPreferencesTypeKeySpecifier)[];
export type ActiveIdentifierPreferencesTypeFieldPolicy = {
	alternativeId?: FieldPolicy<any> | FieldReadFunction<any>,
	breedrId?: FieldPolicy<any> | FieldReadFunction<any>,
	brucellosisId?: FieldPolicy<any> | FieldReadFunction<any>,
	eId?: FieldPolicy<any> | FieldReadFunction<any>,
	herdDoggId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	passportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	pedigreeId?: FieldPolicy<any> | FieldReadFunction<any>,
	tattoo?: FieldPolicy<any> | FieldReadFunction<any>,
	trichId?: FieldPolicy<any> | FieldReadFunction<any>,
	tsuBarcode?: FieldPolicy<any> | FieldReadFunction<any>,
	uhfId?: FieldPolicy<any> | FieldReadFunction<any>,
	visualId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityConnectionKeySpecifier = ('edges' | 'pageInfo' | ActivityConnectionKeySpecifier)[];
export type ActivityConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityEdgeKeySpecifier = ('cursor' | 'node' | ActivityEdgeKeySpecifier)[];
export type ActivityEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityLogKeySpecifier = ('activityTemplate' | 'activityTemplateId' | 'activityType' | 'activityTypeId' | 'animal' | 'animalsCount' | 'date' | 'dontShow' | 'id' | 'isDeletable' | 'meta' | 'payload' | 'subType' | 'type' | 'values' | ActivityLogKeySpecifier)[];
export type ActivityLogFieldPolicy = {
	activityTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	activityTemplateId?: FieldPolicy<any> | FieldReadFunction<any>,
	activityType?: FieldPolicy<any> | FieldReadFunction<any>,
	activityTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	dontShow?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeletable?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	payload?: FieldPolicy<any> | FieldReadFunction<any>,
	subType?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityPayloadKeySpecifier = ('data' | 'description' | 'longDescription' | 'name' | 'shortDescription' | 'valueDescription' | ActivityPayloadKeySpecifier)[];
export type ActivityPayloadFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	longDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	shortDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	valueDescription?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityPayloadDataKeySpecifier = ('fieldSlug' | 'fieldType' | 'id' | 'initialValue' | 'name' | 'position' | 'unitName' | 'units' | 'value' | ActivityPayloadDataKeySpecifier)[];
export type ActivityPayloadDataFieldPolicy = {
	fieldSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	initialValue?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	unitName?: FieldPolicy<any> | FieldReadFunction<any>,
	units?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityTemplateKeySpecifier = ('activityType' | 'allowRepeatActivity' | 'businessUnit' | 'createdBy' | 'description' | 'fields' | 'handlers' | 'id' | 'isAllowedToDelete' | 'isDisabled' | 'isFavorite' | 'isOwn' | 'isPublic' | 'isSystem' | 'longDescription' | 'name' | 'regions' | 'shortDescription' | 'slug' | 'species' | 'valueDescription' | ActivityTemplateKeySpecifier)[];
export type ActivityTemplateFieldPolicy = {
	activityType?: FieldPolicy<any> | FieldReadFunction<any>,
	allowRepeatActivity?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	handlers?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isAllowedToDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	isDisabled?: FieldPolicy<any> | FieldReadFunction<any>,
	isFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	isOwn?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	isSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	longDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	regions?: FieldPolicy<any> | FieldReadFunction<any>,
	shortDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	species?: FieldPolicy<any> | FieldReadFunction<any>,
	valueDescription?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityTemplateFieldKeySpecifier = ('activityTemplate' | 'fieldType' | 'id' | 'initialValue' | 'isRequired' | 'name' | 'options' | 'position' | 'slug' | 'units' | ActivityTemplateFieldKeySpecifier)[];
export type ActivityTemplateFieldFieldPolicy = {
	activityTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	initialValue?: FieldPolicy<any> | FieldReadFunction<any>,
	isRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	units?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityTemplateFieldOptionKeySpecifier = ('activityTemplateField' | 'id' | 'position' | 'title' | 'value' | ActivityTemplateFieldOptionKeySpecifier)[];
export type ActivityTemplateFieldOptionFieldPolicy = {
	activityTemplateField?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityTemplateFieldUnitKeySpecifier = ('fieldTypeId' | 'fieldTypeName' | 'id' | 'name' | ActivityTemplateFieldUnitKeySpecifier)[];
export type ActivityTemplateFieldUnitFieldPolicy = {
	fieldTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldTypeName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityTypeKeySpecifier = ('activityTemplatesCount' | 'businessUnitTypes' | 'id' | 'image' | 'imageSvg' | 'isCopyable' | 'isExtendable' | 'isPublic' | 'isSystem' | 'name' | 'position' | 'slug' | ActivityTypeKeySpecifier)[];
export type ActivityTypeFieldPolicy = {
	activityTemplatesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	imageSvg?: FieldPolicy<any> | FieldReadFunction<any>,
	isCopyable?: FieldPolicy<any> | FieldReadFunction<any>,
	isExtendable?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	isSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddAnimalsMedicineCoursePayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | AddAnimalsMedicineCoursePayloadKeySpecifier)[];
export type AddAnimalsMedicineCoursePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddAnimalsToFinancialTransactionPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'financialTransaction' | 'success' | AddAnimalsToFinancialTransactionPayloadKeySpecifier)[];
export type AddAnimalsToFinancialTransactionPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	financialTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddDeliveryAddressPayloadKeySpecifier = ('clientMutationId' | 'deliveryAddress' | 'errors' | AddDeliveryAddressPayloadKeySpecifier)[];
export type AddDeliveryAddressPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddMedicineCoursePayloadKeySpecifier = ('clientMutationId' | 'errors' | 'medicineCourse' | AddMedicineCoursePayloadKeySpecifier)[];
export type AddMedicineCoursePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	medicineCourse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddMedicineCourseStagePayloadKeySpecifier = ('clientMutationId' | 'errors' | 'medicineCourseStage' | 'success' | AddMedicineCourseStagePayloadKeySpecifier)[];
export type AddMedicineCourseStagePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	medicineCourseStage?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddMedicineLineItemPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'lineItem' | AddMedicineLineItemPayloadKeySpecifier)[];
export type AddMedicineLineItemPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	lineItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddRegularWithdrawalPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'regularWithdrawal' | AddRegularWithdrawalPayloadKeySpecifier)[];
export type AddRegularWithdrawalPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	regularWithdrawal?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdministerAnimalsMedicineCourseStagePayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | AdministerAnimalsMedicineCourseStagePayloadKeySpecifier)[];
export type AdministerAnimalsMedicineCourseStagePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertObjectTypeKeySpecifier = ('alertType' | 'animalAlert' | 'animalSet' | 'businessUnit' | 'completedAt' | 'completedBy' | 'createdAt' | 'createdBy' | 'id' | 'isCrushReminder' | 'notes' | 'remindAt' | 'resolutionComments' | 'updatedAt' | 'updatedBy' | 'urgency' | AlertObjectTypeKeySpecifier)[];
export type AlertObjectTypeFieldPolicy = {
	alertType?: FieldPolicy<any> | FieldReadFunction<any>,
	animalAlert?: FieldPolicy<any> | FieldReadFunction<any>,
	animalSet?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	completedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	completedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isCrushReminder?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	remindAt?: FieldPolicy<any> | FieldReadFunction<any>,
	resolutionComments?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	urgency?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertTypeKeySpecifier = ('alertSet' | 'code' | 'disabled' | 'name' | 'objectType' | AlertTypeKeySpecifier)[];
export type AlertTypeFieldPolicy = {
	alertSet?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	disabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	objectType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AmericanAngusEPDKeySpecifier = ('angusOnHolsteinValue' | 'angusOnHolsteinValueRank' | 'angusOnJerseyValue' | 'angusOnJerseyValueRank' | 'animal' | 'beefValue' | 'beefValueRank' | 'birthWeightAcc' | 'birthWeightEpd' | 'birthWeightPct' | 'calvingEaseAcc' | 'calvingEaseEpd' | 'calvingEasePct' | 'carcassWeightAcc' | 'carcassWeightEpd' | 'carcassWeightPct' | 'clawAcc' | 'clawEpd' | 'clawPct' | 'combinedValue' | 'combinedValueRank' | 'cowEnergyValue' | 'cowEnergyValueRank' | 'docilityAcc' | 'docilityEpd' | 'docilityPct' | 'dryMatterIntakeAcc' | 'dryMatterIntakeEpd' | 'dryMatterIntakePct' | 'fatAcc' | 'fatEpd' | 'fatPct' | 'feedlotValue' | 'feedlotValueRank' | 'gridValue' | 'gridValueRank' | 'hairShedAcc' | 'hairShedEpd' | 'hairShedPct' | 'heiferPregnancyAcc' | 'heiferPregnancyEpd' | 'heiferPregnancyPct' | 'hoofAngleAcc' | 'hoofAngleEpd' | 'hoofAnglePct' | 'marblingAcc' | 'marblingEpd' | 'marblingPct' | 'maternalCalfValue' | 'maternalCalfValueRank' | 'matureHeightAcc' | 'matureHeightEpd' | 'matureHeightPct' | 'matureWeightAcc' | 'matureWeightEpd' | 'matureWeightPct' | 'milkAcc' | 'milkEpd' | 'milkPct' | 'papAcc' | 'papEpd' | 'papPct' | 'residualAdgAcc' | 'residualAdgEpd' | 'residualAdgPct' | 'ribeyeAreaAcc' | 'ribeyeAreaEpd' | 'ribeyeAreaPct' | 'scrotalCircumferenceAcc' | 'scrotalCircumferenceEpd' | 'scrotalCircumferencePct' | 'weanedCalfValue' | 'weanedCalfValueRank' | 'weaningWeightAcc' | 'weaningWeightEpd' | 'weaningWeightPct' | 'yearlingHeightAcc' | 'yearlingHeightEpd' | 'yearlingHeightPct' | 'yearlingWeightAcc' | 'yearlingWeightEpd' | 'yearlingWeightPct' | AmericanAngusEPDKeySpecifier)[];
export type AmericanAngusEPDFieldPolicy = {
	angusOnHolsteinValue?: FieldPolicy<any> | FieldReadFunction<any>,
	angusOnHolsteinValueRank?: FieldPolicy<any> | FieldReadFunction<any>,
	angusOnJerseyValue?: FieldPolicy<any> | FieldReadFunction<any>,
	angusOnJerseyValueRank?: FieldPolicy<any> | FieldReadFunction<any>,
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	beefValue?: FieldPolicy<any> | FieldReadFunction<any>,
	beefValueRank?: FieldPolicy<any> | FieldReadFunction<any>,
	birthWeightAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	birthWeightEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	birthWeightPct?: FieldPolicy<any> | FieldReadFunction<any>,
	calvingEaseAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	calvingEaseEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	calvingEasePct?: FieldPolicy<any> | FieldReadFunction<any>,
	carcassWeightAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	carcassWeightEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	carcassWeightPct?: FieldPolicy<any> | FieldReadFunction<any>,
	clawAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	clawEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	clawPct?: FieldPolicy<any> | FieldReadFunction<any>,
	combinedValue?: FieldPolicy<any> | FieldReadFunction<any>,
	combinedValueRank?: FieldPolicy<any> | FieldReadFunction<any>,
	cowEnergyValue?: FieldPolicy<any> | FieldReadFunction<any>,
	cowEnergyValueRank?: FieldPolicy<any> | FieldReadFunction<any>,
	docilityAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	docilityEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	docilityPct?: FieldPolicy<any> | FieldReadFunction<any>,
	dryMatterIntakeAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	dryMatterIntakeEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	dryMatterIntakePct?: FieldPolicy<any> | FieldReadFunction<any>,
	fatAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	fatEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	fatPct?: FieldPolicy<any> | FieldReadFunction<any>,
	feedlotValue?: FieldPolicy<any> | FieldReadFunction<any>,
	feedlotValueRank?: FieldPolicy<any> | FieldReadFunction<any>,
	gridValue?: FieldPolicy<any> | FieldReadFunction<any>,
	gridValueRank?: FieldPolicy<any> | FieldReadFunction<any>,
	hairShedAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	hairShedEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	hairShedPct?: FieldPolicy<any> | FieldReadFunction<any>,
	heiferPregnancyAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	heiferPregnancyEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	heiferPregnancyPct?: FieldPolicy<any> | FieldReadFunction<any>,
	hoofAngleAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	hoofAngleEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	hoofAnglePct?: FieldPolicy<any> | FieldReadFunction<any>,
	marblingAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	marblingEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	marblingPct?: FieldPolicy<any> | FieldReadFunction<any>,
	maternalCalfValue?: FieldPolicy<any> | FieldReadFunction<any>,
	maternalCalfValueRank?: FieldPolicy<any> | FieldReadFunction<any>,
	matureHeightAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	matureHeightEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	matureHeightPct?: FieldPolicy<any> | FieldReadFunction<any>,
	matureWeightAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	matureWeightEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	matureWeightPct?: FieldPolicy<any> | FieldReadFunction<any>,
	milkAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	milkEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	milkPct?: FieldPolicy<any> | FieldReadFunction<any>,
	papAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	papEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	papPct?: FieldPolicy<any> | FieldReadFunction<any>,
	residualAdgAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	residualAdgEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	residualAdgPct?: FieldPolicy<any> | FieldReadFunction<any>,
	ribeyeAreaAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	ribeyeAreaEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	ribeyeAreaPct?: FieldPolicy<any> | FieldReadFunction<any>,
	scrotalCircumferenceAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	scrotalCircumferenceEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	scrotalCircumferencePct?: FieldPolicy<any> | FieldReadFunction<any>,
	weanedCalfValue?: FieldPolicy<any> | FieldReadFunction<any>,
	weanedCalfValueRank?: FieldPolicy<any> | FieldReadFunction<any>,
	weaningWeightAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	weaningWeightEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	weaningWeightPct?: FieldPolicy<any> | FieldReadFunction<any>,
	yearlingHeightAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	yearlingHeightEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	yearlingHeightPct?: FieldPolicy<any> | FieldReadFunction<any>,
	yearlingWeightAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	yearlingWeightEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	yearlingWeightPct?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AncestorTypeKeySpecifier = ('ancestorIdentifier' | 'animalData' | 'depth' | AncestorTypeKeySpecifier)[];
export type AncestorTypeFieldPolicy = {
	ancestorIdentifier?: FieldPolicy<any> | FieldReadFunction<any>,
	animalData?: FieldPolicy<any> | FieldReadFunction<any>,
	depth?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalKeySpecifier = ('age' | 'ageCategory' | 'alerts' | 'allAlertsCount' | 'alternativeId' | 'animalBreeds' | 'animalColour' | 'animalSubtype' | 'animalType' | 'animalTypeId' | 'birthInformation' | 'breedPercentages' | 'breedSocietyRegistration' | 'breeding' | 'breedrId' | 'brucellosisId' | 'buyerName' | 'children' | 'cphCount' | 'createdAt' | 'currentAlertsCount' | 'currentHighUrgencyAlertsCount' | 'currentWeight' | 'dam' | 'damId' | 'damPassportNumber' | 'dateLeftFarm' | 'dateMovedToFarm' | 'daysToTargetWeight' | 'deadAt' | 'deliveryDate' | 'description' | 'dob' | 'eId' | 'eIdCleaned' | 'eIdsHistory' | 'estimatedAgeOn' | 'estimatedCarcassWeight' | 'estimatedWeightOn' | 'field' | 'fieldId' | 'gender' | 'group' | 'groupId' | 'growthRate' | 'growthRateSinceConception' | 'growthRateSinceLastWeighLog' | 'hasPreviousKeeperInfo' | 'herdDoggId' | 'id' | 'images' | 'impactStatus' | 'isArchived' | 'isBcmsSynced' | 'isBirthed' | 'isCastrated' | 'isDead' | 'isMale' | 'isOnFarm' | 'isPedigree' | 'isPregnant' | 'isRegulatorySynced' | 'isSoftDeleted' | 'killFatScore' | 'killFatScoreInt' | 'killQuality' | 'killQualityInt' | 'killWeight' | 'lastRegulatorySyncedDate' | 'lastWeight' | 'latestPurchasePrice' | 'linkToMySire' | 'location' | 'lot' | 'metaData' | 'name' | 'notifications' | 'offerId' | 'owner' | 'ownerId' | 'ownersHistory' | 'parentageChecked' | 'passportNumber' | 'pedigree' | 'pedigreeId' | 'performanceCategory' | 'predicatedDateReady' | 'predictedDateReady' | 'predictedWeightAtDelivery' | 'predictedWeights' | 'pregnancyDueDate' | 'previousKeeper' | 'registrationStatus' | 'relatedMeatLabels' | 'rflId' | 'sexClassification' | 'sire' | 'sireId' | 'sireIsPedigree' | 'sirePassportNumber' | 'sireStuds' | 'softDeletedAt' | 'studSiredId' | 'tags' | 'targetDailyLiveWeightGain' | 'targetLiveWeight' | 'tattoo' | 'trichId' | 'trioVerified' | 'tsuBarcode' | 'uhfId' | 'unreadNotificationsCount' | 'updatedAt' | 'updatedBy' | 'visualId' | 'visualIdsHistory' | 'withdrawalEnd' | 'withdrawalStart' | AnimalKeySpecifier)[];
export type AnimalFieldPolicy = {
	age?: FieldPolicy<any> | FieldReadFunction<any>,
	ageCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	alerts?: FieldPolicy<any> | FieldReadFunction<any>,
	allAlertsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	alternativeId?: FieldPolicy<any> | FieldReadFunction<any>,
	animalBreeds?: FieldPolicy<any> | FieldReadFunction<any>,
	animalColour?: FieldPolicy<any> | FieldReadFunction<any>,
	animalSubtype?: FieldPolicy<any> | FieldReadFunction<any>,
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	animalTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	birthInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	breedPercentages?: FieldPolicy<any> | FieldReadFunction<any>,
	breedSocietyRegistration?: FieldPolicy<any> | FieldReadFunction<any>,
	breeding?: FieldPolicy<any> | FieldReadFunction<any>,
	breedrId?: FieldPolicy<any> | FieldReadFunction<any>,
	brucellosisId?: FieldPolicy<any> | FieldReadFunction<any>,
	buyerName?: FieldPolicy<any> | FieldReadFunction<any>,
	children?: FieldPolicy<any> | FieldReadFunction<any>,
	cphCount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currentAlertsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	currentHighUrgencyAlertsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	currentWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	dam?: FieldPolicy<any> | FieldReadFunction<any>,
	damId?: FieldPolicy<any> | FieldReadFunction<any>,
	damPassportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	dateLeftFarm?: FieldPolicy<any> | FieldReadFunction<any>,
	dateMovedToFarm?: FieldPolicy<any> | FieldReadFunction<any>,
	daysToTargetWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	deadAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	dob?: FieldPolicy<any> | FieldReadFunction<any>,
	eId?: FieldPolicy<any> | FieldReadFunction<any>,
	eIdCleaned?: FieldPolicy<any> | FieldReadFunction<any>,
	eIdsHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedAgeOn?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedCarcassWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedWeightOn?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldId?: FieldPolicy<any> | FieldReadFunction<any>,
	gender?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>,
	groupId?: FieldPolicy<any> | FieldReadFunction<any>,
	growthRate?: FieldPolicy<any> | FieldReadFunction<any>,
	growthRateSinceConception?: FieldPolicy<any> | FieldReadFunction<any>,
	growthRateSinceLastWeighLog?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousKeeperInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	herdDoggId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	impactStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	isArchived?: FieldPolicy<any> | FieldReadFunction<any>,
	isBcmsSynced?: FieldPolicy<any> | FieldReadFunction<any>,
	isBirthed?: FieldPolicy<any> | FieldReadFunction<any>,
	isCastrated?: FieldPolicy<any> | FieldReadFunction<any>,
	isDead?: FieldPolicy<any> | FieldReadFunction<any>,
	isMale?: FieldPolicy<any> | FieldReadFunction<any>,
	isOnFarm?: FieldPolicy<any> | FieldReadFunction<any>,
	isPedigree?: FieldPolicy<any> | FieldReadFunction<any>,
	isPregnant?: FieldPolicy<any> | FieldReadFunction<any>,
	isRegulatorySynced?: FieldPolicy<any> | FieldReadFunction<any>,
	isSoftDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	killFatScore?: FieldPolicy<any> | FieldReadFunction<any>,
	killFatScoreInt?: FieldPolicy<any> | FieldReadFunction<any>,
	killQuality?: FieldPolicy<any> | FieldReadFunction<any>,
	killQualityInt?: FieldPolicy<any> | FieldReadFunction<any>,
	killWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	lastRegulatorySyncedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	lastWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	latestPurchasePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	linkToMySire?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	lot?: FieldPolicy<any> | FieldReadFunction<any>,
	metaData?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	offerId?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerId?: FieldPolicy<any> | FieldReadFunction<any>,
	ownersHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	parentageChecked?: FieldPolicy<any> | FieldReadFunction<any>,
	passportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	pedigree?: FieldPolicy<any> | FieldReadFunction<any>,
	pedigreeId?: FieldPolicy<any> | FieldReadFunction<any>,
	performanceCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	predicatedDateReady?: FieldPolicy<any> | FieldReadFunction<any>,
	predictedDateReady?: FieldPolicy<any> | FieldReadFunction<any>,
	predictedWeightAtDelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	predictedWeights?: FieldPolicy<any> | FieldReadFunction<any>,
	pregnancyDueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	previousKeeper?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedMeatLabels?: FieldPolicy<any> | FieldReadFunction<any>,
	rflId?: FieldPolicy<any> | FieldReadFunction<any>,
	sexClassification?: FieldPolicy<any> | FieldReadFunction<any>,
	sire?: FieldPolicy<any> | FieldReadFunction<any>,
	sireId?: FieldPolicy<any> | FieldReadFunction<any>,
	sireIsPedigree?: FieldPolicy<any> | FieldReadFunction<any>,
	sirePassportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	sireStuds?: FieldPolicy<any> | FieldReadFunction<any>,
	softDeletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	studSiredId?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	targetDailyLiveWeightGain?: FieldPolicy<any> | FieldReadFunction<any>,
	targetLiveWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	tattoo?: FieldPolicy<any> | FieldReadFunction<any>,
	trichId?: FieldPolicy<any> | FieldReadFunction<any>,
	trioVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	tsuBarcode?: FieldPolicy<any> | FieldReadFunction<any>,
	uhfId?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadNotificationsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	visualId?: FieldPolicy<any> | FieldReadFunction<any>,
	visualIdsHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalStart?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalAlertKeySpecifier = ('alert' | 'animal' | 'entityType' | 'id' | AnimalAlertKeySpecifier)[];
export type AnimalAlertFieldPolicy = {
	alert?: FieldPolicy<any> | FieldReadFunction<any>,
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	entityType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalAlertObjectTypeKeySpecifier = ('alert' | 'animal' | 'id' | AnimalAlertObjectTypeKeySpecifier)[];
export type AnimalAlertObjectTypeFieldPolicy = {
	alert?: FieldPolicy<any> | FieldReadFunction<any>,
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalBreedKeySpecifier = ('animalType' | 'birthWeight' | 'breedrCode' | 'classification' | 'groups' | 'id' | 'name' | 'newClassification' | 'regBreedCode' | 'regName' | 'region' | 'version' | AnimalBreedKeySpecifier)[];
export type AnimalBreedFieldPolicy = {
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	birthWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	breedrCode?: FieldPolicy<any> | FieldReadFunction<any>,
	classification?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	newClassification?: FieldPolicy<any> | FieldReadFunction<any>,
	regBreedCode?: FieldPolicy<any> | FieldReadFunction<any>,
	regName?: FieldPolicy<any> | FieldReadFunction<any>,
	region?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalBreedGenderKeySpecifier = ('breedCode' | 'breedName' | 'count' | 'isMale' | AnimalBreedGenderKeySpecifier)[];
export type AnimalBreedGenderFieldPolicy = {
	breedCode?: FieldPolicy<any> | FieldReadFunction<any>,
	breedName?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	isMale?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalColourKeySpecifier = ('code' | 'id' | 'name' | AnimalColourKeySpecifier)[];
export type AnimalColourFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalConditionTypeKeySpecifier = ('id' | 'slug' | 'title' | AnimalConditionTypeKeySpecifier)[];
export type AnimalConditionTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalConnectionKeySpecifier = ('animals' | 'animalsCount' | AnimalConnectionKeySpecifier)[];
export type AnimalConnectionFieldPolicy = {
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalConnection2KeySpecifier = ('count' | 'edges' | 'pageInfo' | 'serverTime' | AnimalConnection2KeySpecifier)[];
export type AnimalConnection2FieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	serverTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalConnection2EdgeKeySpecifier = ('cursor' | 'node' | AnimalConnection2EdgeKeySpecifier)[];
export type AnimalConnection2EdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalFilterAlertObjectTypeKeySpecifier = ('animalFilter' | 'count' | AnimalFilterAlertObjectTypeKeySpecifier)[];
export type AnimalFilterAlertObjectTypeFieldPolicy = {
	animalFilter?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalFilterObjectTypeKeySpecifier = ('ageFrom' | 'ageTo' | 'animalType' | 'breeds' | 'businessUnit' | 'color' | 'createdBy' | 'currentWeightFrom' | 'currentWeightTo' | 'daysSinceLastWeightFrom' | 'daysSinceLastWeightTo' | 'deliveryFrom' | 'deliveryTo' | 'dobFrom' | 'dobTo' | 'dofFrom' | 'dofTo' | 'fields' | 'groups' | 'growthRateFrom' | 'growthRateTo' | 'id' | 'inWithdrawal' | 'isAlert' | 'isBcmsSynced' | 'isMale' | 'isPregnant' | 'isRegulatorySynced' | 'lastRegulatorySyncedDate' | 'lastRegulatorySyncedDateFrom' | 'lastRegulatorySyncedDateTo' | 'lastWeightFrom' | 'lastWeightTo' | 'name' | 'pregnancyDueDateFrom' | 'pregnancyDueDateTo' | 'sexClassifications' | AnimalFilterObjectTypeKeySpecifier)[];
export type AnimalFilterObjectTypeFieldPolicy = {
	ageFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	ageTo?: FieldPolicy<any> | FieldReadFunction<any>,
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	breeds?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	currentWeightFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	currentWeightTo?: FieldPolicy<any> | FieldReadFunction<any>,
	daysSinceLastWeightFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	daysSinceLastWeightTo?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryTo?: FieldPolicy<any> | FieldReadFunction<any>,
	dobFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	dobTo?: FieldPolicy<any> | FieldReadFunction<any>,
	dofFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	dofTo?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	growthRateFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	growthRateTo?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inWithdrawal?: FieldPolicy<any> | FieldReadFunction<any>,
	isAlert?: FieldPolicy<any> | FieldReadFunction<any>,
	isBcmsSynced?: FieldPolicy<any> | FieldReadFunction<any>,
	isMale?: FieldPolicy<any> | FieldReadFunction<any>,
	isPregnant?: FieldPolicy<any> | FieldReadFunction<any>,
	isRegulatorySynced?: FieldPolicy<any> | FieldReadFunction<any>,
	lastRegulatorySyncedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	lastRegulatorySyncedDateFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	lastRegulatorySyncedDateTo?: FieldPolicy<any> | FieldReadFunction<any>,
	lastWeightFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	lastWeightTo?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	pregnancyDueDateFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	pregnancyDueDateTo?: FieldPolicy<any> | FieldReadFunction<any>,
	sexClassifications?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalImageKeySpecifier = ('createdAt' | 'id' | 'image' | AnimalImageKeySpecifier)[];
export type AnimalImageFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalInterfaceKeySpecifier = ('ageCategory' | 'animalBreeds' | 'animalColour' | 'animalType' | 'breedPercentages' | 'breeding' | 'cphCount' | 'currentWeight' | 'damPassportNumber' | 'dateMovedToFarm' | 'daysToTargetWeight' | 'dob' | 'eId' | 'eIdCleaned' | 'estimatedAgeOn' | 'estimatedCarcassWeight' | 'estimatedWeightOn' | 'gender' | 'growthRate' | 'growthRateSinceConception' | 'growthRateSinceLastWeighLog' | 'images' | 'isArchived' | 'isBcmsSynced' | 'isCastrated' | 'isMale' | 'isPregnant' | 'isRegulatorySynced' | 'isSoftDeleted' | 'lastRegulatorySyncedDate' | 'lastWeight' | 'name' | 'ownerId' | 'passportNumber' | 'predicatedDateReady' | 'predictedDateReady' | 'predictedWeightAtDelivery' | 'pregnancyDueDate' | 'sexClassification' | 'sirePassportNumber' | 'softDeletedAt' | 'targetDailyLiveWeightGain' | 'targetLiveWeight' | 'visualId' | 'withdrawalEnd' | AnimalInterfaceKeySpecifier)[];
export type AnimalInterfaceFieldPolicy = {
	ageCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	animalBreeds?: FieldPolicy<any> | FieldReadFunction<any>,
	animalColour?: FieldPolicy<any> | FieldReadFunction<any>,
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	breedPercentages?: FieldPolicy<any> | FieldReadFunction<any>,
	breeding?: FieldPolicy<any> | FieldReadFunction<any>,
	cphCount?: FieldPolicy<any> | FieldReadFunction<any>,
	currentWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	damPassportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	dateMovedToFarm?: FieldPolicy<any> | FieldReadFunction<any>,
	daysToTargetWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	dob?: FieldPolicy<any> | FieldReadFunction<any>,
	eId?: FieldPolicy<any> | FieldReadFunction<any>,
	eIdCleaned?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedAgeOn?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedCarcassWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedWeightOn?: FieldPolicy<any> | FieldReadFunction<any>,
	gender?: FieldPolicy<any> | FieldReadFunction<any>,
	growthRate?: FieldPolicy<any> | FieldReadFunction<any>,
	growthRateSinceConception?: FieldPolicy<any> | FieldReadFunction<any>,
	growthRateSinceLastWeighLog?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	isArchived?: FieldPolicy<any> | FieldReadFunction<any>,
	isBcmsSynced?: FieldPolicy<any> | FieldReadFunction<any>,
	isCastrated?: FieldPolicy<any> | FieldReadFunction<any>,
	isMale?: FieldPolicy<any> | FieldReadFunction<any>,
	isPregnant?: FieldPolicy<any> | FieldReadFunction<any>,
	isRegulatorySynced?: FieldPolicy<any> | FieldReadFunction<any>,
	isSoftDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	lastRegulatorySyncedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	lastWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerId?: FieldPolicy<any> | FieldReadFunction<any>,
	passportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	predicatedDateReady?: FieldPolicy<any> | FieldReadFunction<any>,
	predictedDateReady?: FieldPolicy<any> | FieldReadFunction<any>,
	predictedWeightAtDelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	pregnancyDueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	sexClassification?: FieldPolicy<any> | FieldReadFunction<any>,
	sirePassportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	softDeletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	targetDailyLiveWeightGain?: FieldPolicy<any> | FieldReadFunction<any>,
	targetLiveWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	visualId?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalEnd?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalOffspringObjectTypeKeySpecifier = ('animals' | 'summary' | AnimalOffspringObjectTypeKeySpecifier)[];
export type AnimalOffspringObjectTypeFieldPolicy = {
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	summary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalPagePaginatedTypeKeySpecifier = ('animals' | 'count' | 'hasNext' | 'hasPrev' | 'lastFetchTime' | 'page' | 'pages' | AnimalPagePaginatedTypeKeySpecifier)[];
export type AnimalPagePaginatedTypeFieldPolicy = {
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNext?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPrev?: FieldPolicy<any> | FieldReadFunction<any>,
	lastFetchTime?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalPreviousKeeperTypeKeySpecifier = ('address' | 'contact' | 'name' | 'regulatoryId' | AnimalPreviousKeeperTypeKeySpecifier)[];
export type AnimalPreviousKeeperTypeFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalSnapshotTypeKeySpecifier = ('url' | AnimalSnapshotTypeKeySpecifier)[];
export type AnimalSnapshotTypeFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalTagOverviewConnectionKeySpecifier = ('edges' | 'pageInfo' | AnimalTagOverviewConnectionKeySpecifier)[];
export type AnimalTagOverviewConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalTagOverviewEdgeKeySpecifier = ('cursor' | 'node' | AnimalTagOverviewEdgeKeySpecifier)[];
export type AnimalTagOverviewEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalTagOverviewTypeKeySpecifier = ('animalTypes' | 'averageAge' | 'averageDaysOnFarm' | 'averageEstimatedWeight' | 'averageRecordedWeight' | 'breeds' | 'color' | 'genderType' | 'id' | 'isRemovable' | 'name' | 'numAliveAnimals' | 'ownership' | 'schema' | 'slug' | 'tagId' | 'textColor' | 'valueType' | AnimalTagOverviewTypeKeySpecifier)[];
export type AnimalTagOverviewTypeFieldPolicy = {
	animalTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	averageAge?: FieldPolicy<any> | FieldReadFunction<any>,
	averageDaysOnFarm?: FieldPolicy<any> | FieldReadFunction<any>,
	averageEstimatedWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	averageRecordedWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	breeds?: FieldPolicy<any> | FieldReadFunction<any>,
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	genderType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isRemovable?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	numAliveAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	ownership?: FieldPolicy<any> | FieldReadFunction<any>,
	schema?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	tagId?: FieldPolicy<any> | FieldReadFunction<any>,
	textColor?: FieldPolicy<any> | FieldReadFunction<any>,
	valueType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalTagSchemaTypeKeySpecifier = ('animalTypes' | 'color' | 'id' | 'isRemovable' | 'name' | 'ownership' | 'slug' | 'tagId' | 'textColor' | 'valueType' | AnimalTagSchemaTypeKeySpecifier)[];
export type AnimalTagSchemaTypeFieldPolicy = {
	animalTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isRemovable?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	ownership?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	tagId?: FieldPolicy<any> | FieldReadFunction<any>,
	textColor?: FieldPolicy<any> | FieldReadFunction<any>,
	valueType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalTagTypeKeySpecifier = ('animalTypes' | 'color' | 'isRemovable' | 'name' | 'ownership' | 'schema' | 'slug' | 'tagId' | 'textColor' | 'valueId' | 'valueType' | AnimalTagTypeKeySpecifier)[];
export type AnimalTagTypeFieldPolicy = {
	animalTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	isRemovable?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	ownership?: FieldPolicy<any> | FieldReadFunction<any>,
	schema?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	tagId?: FieldPolicy<any> | FieldReadFunction<any>,
	textColor?: FieldPolicy<any> | FieldReadFunction<any>,
	valueId?: FieldPolicy<any> | FieldReadFunction<any>,
	valueType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalTypeKeySpecifier = ('batchName' | 'breeds' | 'categoriesOfSale' | 'colour' | 'emptyStates' | 'enabled' | 'enabledPredictions' | 'gestationDays' | 'groups' | 'id' | 'image' | 'integrationsystemSet' | 'name' | 'position' | 'sexclassificationSet' | 'slug' | 'stockitemSet' | AnimalTypeKeySpecifier)[];
export type AnimalTypeFieldPolicy = {
	batchName?: FieldPolicy<any> | FieldReadFunction<any>,
	breeds?: FieldPolicy<any> | FieldReadFunction<any>,
	categoriesOfSale?: FieldPolicy<any> | FieldReadFunction<any>,
	colour?: FieldPolicy<any> | FieldReadFunction<any>,
	emptyStates?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	enabledPredictions?: FieldPolicy<any> | FieldReadFunction<any>,
	gestationDays?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	integrationsystemSet?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	sexclassificationSet?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	stockitemSet?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalTypePublicKeySpecifier = ('id' | 'name' | 'slug' | AnimalTypePublicKeySpecifier)[];
export type AnimalTypePublicFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalsCountKeySpecifier = ('deadAnimals' | 'liveAnimals' | 'movedOffFarmAnimals' | 'totalAnimals' | AnimalsCountKeySpecifier)[];
export type AnimalsCountFieldPolicy = {
	deadAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	liveAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	movedOffFarmAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAnimals?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalsExportAsyncPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'export' | AnimalsExportAsyncPayloadKeySpecifier)[];
export type AnimalsExportAsyncPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	export?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalsPaginatedConnectionKeySpecifier = ('edges' | 'pageInfo' | AnimalsPaginatedConnectionKeySpecifier)[];
export type AnimalsPaginatedConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnimalsPaginatedEdgeKeySpecifier = ('cursor' | 'node' | AnimalsPaginatedEdgeKeySpecifier)[];
export type AnimalsPaginatedEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AphisImportCsvPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'task' | AphisImportCsvPayloadKeySpecifier)[];
export type AphisImportCsvPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	task?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ApproveEmailPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | ApproveEmailPayloadKeySpecifier)[];
export type ApproveEmailPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttachDeliveryAffidavitPayloadKeySpecifier = ('clientMutationId' | 'delivery' | 'errors' | 'success' | AttachDeliveryAffidavitPayloadKeySpecifier)[];
export type AttachDeliveryAffidavitPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BalanceAccountTypeKeySpecifier = ('balance' | 'businessUnit' | 'createdAt' | 'currency' | 'id' | 'updatedAt' | BalanceAccountTypeKeySpecifier)[];
export type BalanceAccountTypeFieldPolicy = {
	balance?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BandChartDataKeySpecifier = ('timestamp' | 'value' | BandChartDataKeySpecifier)[];
export type BandChartDataFieldPolicy = {
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BankAccountDetailsObjectTypeKeySpecifier = ('accountName' | 'accountNo' | 'id' | 'isBusinessAccount' | 'sortCode' | BankAccountDetailsObjectTypeKeySpecifier)[];
export type BankAccountDetailsObjectTypeFieldPolicy = {
	accountName?: FieldPolicy<any> | FieldReadFunction<any>,
	accountNo?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isBusinessAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	sortCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BankAccountTypeKeySpecifier = ('accountInfo' | 'balanceAccount' | 'createdAt' | 'createdBy' | 'currency' | 'id' | 'token' | 'updatedAt' | BankAccountTypeKeySpecifier)[];
export type BankAccountTypeFieldPolicy = {
	accountInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	balanceAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BarChartDataObjectTypeKeySpecifier = ('bars' | 'title' | BarChartDataObjectTypeKeySpecifier)[];
export type BarChartDataObjectTypeFieldPolicy = {
	bars?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BatchKeySpecifier = ('animalBreeds' | 'animalType' | 'animalTypeId' | 'averageDobInBatch' | 'batchDateOnFarm' | 'businessUnit' | 'businessUnitId' | 'businessUnitTarget' | 'businessUnitTargetId' | 'createdAt' | 'description' | 'gendersInBatch' | 'id' | 'isBatch' | 'isPurchased' | 'name' | 'numberOfUnidentifiedAnimalsInBatch' | 'updatedAt' | BatchKeySpecifier)[];
export type BatchFieldPolicy = {
	animalBreeds?: FieldPolicy<any> | FieldReadFunction<any>,
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	animalTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	averageDobInBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	batchDateOnFarm?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitId?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitTargetId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	gendersInBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	isPurchased?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfUnidentifiedAnimalsInBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BatchNameObjectTypeKeySpecifier = ('name' | 'plural' | BatchNameObjectTypeKeySpecifier)[];
export type BatchNameObjectTypeFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	plural?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BatchUploadFormatKeySpecifier = ('activityTemplateId' | 'activityType' | 'animalTypes' | 'categorySlug' | 'columns' | 'entityType' | 'isMappable' | 'name' | 'options' | 'slug' | BatchUploadFormatKeySpecifier)[];
export type BatchUploadFormatFieldPolicy = {
	activityTemplateId?: FieldPolicy<any> | FieldReadFunction<any>,
	activityType?: FieldPolicy<any> | FieldReadFunction<any>,
	animalTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	categorySlug?: FieldPolicy<any> | FieldReadFunction<any>,
	columns?: FieldPolicy<any> | FieldReadFunction<any>,
	entityType?: FieldPolicy<any> | FieldReadFunction<any>,
	isMappable?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BatchUploadFormatColumnKeySpecifier = ('activityField' | 'categorySlug' | 'isRequired' | 'isRequiredConditionally' | 'label' | 'name' | 'position' | 'slug' | BatchUploadFormatColumnKeySpecifier)[];
export type BatchUploadFormatColumnFieldPolicy = {
	activityField?: FieldPolicy<any> | FieldReadFunction<any>,
	categorySlug?: FieldPolicy<any> | FieldReadFunction<any>,
	isRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	isRequiredConditionally?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BatchUploadFormatOptionKeySpecifier = ('choices' | 'dataSubtype' | 'dataType' | 'default' | 'helpText' | 'label' | 'slug' | BatchUploadFormatOptionKeySpecifier)[];
export type BatchUploadFormatOptionFieldPolicy = {
	choices?: FieldPolicy<any> | FieldReadFunction<any>,
	dataSubtype?: FieldPolicy<any> | FieldReadFunction<any>,
	dataType?: FieldPolicy<any> | FieldReadFunction<any>,
	default?: FieldPolicy<any> | FieldReadFunction<any>,
	helpText?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BcmsConnectionTypeKeySpecifier = ('credentials' | 'errorMessage' | 'farm' | 'id' | 'integrationSystem' | 'location' | 'status' | BcmsConnectionTypeKeySpecifier)[];
export type BcmsConnectionTypeFieldPolicy = {
	credentials?: FieldPolicy<any> | FieldReadFunction<any>,
	errorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	farm?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	integrationSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BcmsImportCsvPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'task' | BcmsImportCsvPayloadKeySpecifier)[];
export type BcmsImportCsvPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	task?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BcmsServiceRequestGeneratePdfPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'url' | BcmsServiceRequestGeneratePdfPayloadKeySpecifier)[];
export type BcmsServiceRequestGeneratePdfPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BirthAnimalPayloadKeySpecifier = ('animal' | 'clientMutationId' | 'errors' | 'success' | BirthAnimalPayloadKeySpecifier)[];
export type BirthAnimalPayloadFieldPolicy = {
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BirthInformationKeySpecifier = ('animal' | 'birthAbnormalities' | 'birthPresentation' | 'birthSize' | 'birthVigor' | 'birthWeight' | 'birthingDifficulty' | 'calfColour' | 'created' | 'id' | 'isStillborn' | 'litterSize' | 'updated' | BirthInformationKeySpecifier)[];
export type BirthInformationFieldPolicy = {
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	birthAbnormalities?: FieldPolicy<any> | FieldReadFunction<any>,
	birthPresentation?: FieldPolicy<any> | FieldReadFunction<any>,
	birthSize?: FieldPolicy<any> | FieldReadFunction<any>,
	birthVigor?: FieldPolicy<any> | FieldReadFunction<any>,
	birthWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	birthingDifficulty?: FieldPolicy<any> | FieldReadFunction<any>,
	calfColour?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isStillborn?: FieldPolicy<any> | FieldReadFunction<any>,
	litterSize?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BlockchainAnimalDataKeySpecifier = ('breed' | 'carcassGrading' | 'deathCreatedBy' | 'deathDate' | 'dob' | 'error' | 'isDead' | 'isMale' | 'medication' | 'movements' | 'name' | 'ownerHoldingId' | 'ownerId' | 'ownerName' | 'passportNumber' | 'weights' | BlockchainAnimalDataKeySpecifier)[];
export type BlockchainAnimalDataFieldPolicy = {
	breed?: FieldPolicy<any> | FieldReadFunction<any>,
	carcassGrading?: FieldPolicy<any> | FieldReadFunction<any>,
	deathCreatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	deathDate?: FieldPolicy<any> | FieldReadFunction<any>,
	dob?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	isDead?: FieldPolicy<any> | FieldReadFunction<any>,
	isMale?: FieldPolicy<any> | FieldReadFunction<any>,
	medication?: FieldPolicy<any> | FieldReadFunction<any>,
	movements?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerHoldingId?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerId?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerName?: FieldPolicy<any> | FieldReadFunction<any>,
	passportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	weights?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BlockchainCarcassGradingInfoKeySpecifier = ('coldWeight' | 'condemnedWeight' | 'conformation' | 'createdBy' | 'date' | 'fatScore' | 'grading' | 'holdingId' | 'hotWeight' | 'killNumber' | 'lotNumber' | 'value' | BlockchainCarcassGradingInfoKeySpecifier)[];
export type BlockchainCarcassGradingInfoFieldPolicy = {
	coldWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	condemnedWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	conformation?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	fatScore?: FieldPolicy<any> | FieldReadFunction<any>,
	grading?: FieldPolicy<any> | FieldReadFunction<any>,
	holdingId?: FieldPolicy<any> | FieldReadFunction<any>,
	hotWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	killNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	lotNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BlockchainMedicationInfoKeySpecifier = ('activeIngredient' | 'batchNumber' | 'createdBy' | 'date' | 'dosage' | 'dosageUnits' | 'holdingId' | 'medicineName' | 'withdrawalDays' | BlockchainMedicationInfoKeySpecifier)[];
export type BlockchainMedicationInfoFieldPolicy = {
	activeIngredient?: FieldPolicy<any> | FieldReadFunction<any>,
	batchNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	dosage?: FieldPolicy<any> | FieldReadFunction<any>,
	dosageUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	holdingId?: FieldPolicy<any> | FieldReadFunction<any>,
	medicineName?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalDays?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BlockchainMoveInfoKeySpecifier = ('createdBy' | 'date' | 'fromFarmName' | 'fromHoldingId' | 'toHoldingId' | 'toOwnerId' | 'toOwnerName' | BlockchainMoveInfoKeySpecifier)[];
export type BlockchainMoveInfoFieldPolicy = {
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	fromFarmName?: FieldPolicy<any> | FieldReadFunction<any>,
	fromHoldingId?: FieldPolicy<any> | FieldReadFunction<any>,
	toHoldingId?: FieldPolicy<any> | FieldReadFunction<any>,
	toOwnerId?: FieldPolicy<any> | FieldReadFunction<any>,
	toOwnerName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BlockchainWeightInfoKeySpecifier = ('createdBy' | 'date' | 'holdingId' | 'unit' | 'value' | BlockchainWeightInfoKeySpecifier)[];
export type BlockchainWeightInfoFieldPolicy = {
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	holdingId?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BreedPercentageKeySpecifier = ('breed' | 'percentage' | BreedPercentageKeySpecifier)[];
export type BreedPercentageFieldPolicy = {
	breed?: FieldPolicy<any> | FieldReadFunction<any>,
	percentage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BreedrBankAccountDetailsObjectTypeKeySpecifier = ('accountName' | 'accountNo' | 'sortCode' | BreedrBankAccountDetailsObjectTypeKeySpecifier)[];
export type BreedrBankAccountDetailsObjectTypeFieldPolicy = {
	accountName?: FieldPolicy<any> | FieldReadFunction<any>,
	accountNo?: FieldPolicy<any> | FieldReadFunction<any>,
	sortCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BreedseekDataKeySpecifier = ('akaushi' | 'angus' | 'animal' | 'barcode' | 'beefmasters' | 'brangus' | 'hereford' | 'holstein' | 'jersey' | 'orderRef' | 'redAngus' | 'santaGertrudis' | 'testRef' | 'wagyu' | BreedseekDataKeySpecifier)[];
export type BreedseekDataFieldPolicy = {
	akaushi?: FieldPolicy<any> | FieldReadFunction<any>,
	angus?: FieldPolicy<any> | FieldReadFunction<any>,
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	barcode?: FieldPolicy<any> | FieldReadFunction<any>,
	beefmasters?: FieldPolicy<any> | FieldReadFunction<any>,
	brangus?: FieldPolicy<any> | FieldReadFunction<any>,
	hereford?: FieldPolicy<any> | FieldReadFunction<any>,
	holstein?: FieldPolicy<any> | FieldReadFunction<any>,
	jersey?: FieldPolicy<any> | FieldReadFunction<any>,
	orderRef?: FieldPolicy<any> | FieldReadFunction<any>,
	redAngus?: FieldPolicy<any> | FieldReadFunction<any>,
	santaGertrudis?: FieldPolicy<any> | FieldReadFunction<any>,
	testRef?: FieldPolicy<any> | FieldReadFunction<any>,
	wagyu?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BulletObjectTypeKeySpecifier = ('id' | 'order' | 'text' | BulletObjectTypeKeySpecifier)[];
export type BulletObjectTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessTypeKeySpecifier = ('activityTypes' | 'id' | 'mainReport' | 'name' | 'slug' | BusinessTypeKeySpecifier)[];
export type BusinessTypeFieldPolicy = {
	activityTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mainReport?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessUnitKeySpecifier = ('accreditations' | 'activityTemplates' | 'address' | 'addressExtra' | 'animalDetails' | 'animalFilters' | 'animalMatchingColumns' | 'animalTypes' | 'backgroundPhoto' | 'balance' | 'birthDataForm' | 'businessType' | 'businessUnitAccreditations' | 'businessUnitTargets' | 'canCreateRfl' | 'carcassGradingExtractor' | 'city' | 'country' | 'county' | 'currency' | 'dateJoined' | 'deliveryAddress' | 'description' | 'effectiveSubscriptionPlan' | 'employeeCnt' | 'enableBcmsPushTransactions' | 'farmAnimalTypes' | 'farmId' | 'financialTransactions' | 'foggles' | 'growthStage' | 'guid' | 'herdDoggIntegration' | 'holdingId' | 'houseNumber' | 'id' | 'identifierPreferencesActiveIds' | 'identifierPreferencesPrimaryId' | 'identifierPreferencesSecondaryId' | 'isOrganic' | 'killOut' | 'locationData' | 'locationsCount' | 'lotExpiryInDays' | 'marketType' | 'mobile' | 'name' | 'organisation' | 'phone' | 'postcode' | 'preferredBusinessUnits' | 'primaryLocation' | 'profilePhoto' | 'ratingAverage' | 'region' | 'regulatorySystem' | 'regulatorySystemAvailable' | 'requireBirthData' | 'settings' | 'statuses' | 'subscriptionPlan' | 'subscriptionPlanFeatures' | 'tbStatus' | 'tradingPlan' | 'tradingTypes' | 'unitsOfMeasurement' | 'userPermissions' | 'users' | 'vatRate' | 'warnings' | 'workers' | BusinessUnitKeySpecifier)[];
export type BusinessUnitFieldPolicy = {
	accreditations?: FieldPolicy<any> | FieldReadFunction<any>,
	activityTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	addressExtra?: FieldPolicy<any> | FieldReadFunction<any>,
	animalDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	animalFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	animalMatchingColumns?: FieldPolicy<any> | FieldReadFunction<any>,
	animalTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	balance?: FieldPolicy<any> | FieldReadFunction<any>,
	birthDataForm?: FieldPolicy<any> | FieldReadFunction<any>,
	businessType?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitAccreditations?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitTargets?: FieldPolicy<any> | FieldReadFunction<any>,
	canCreateRfl?: FieldPolicy<any> | FieldReadFunction<any>,
	carcassGradingExtractor?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	county?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	dateJoined?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	effectiveSubscriptionPlan?: FieldPolicy<any> | FieldReadFunction<any>,
	employeeCnt?: FieldPolicy<any> | FieldReadFunction<any>,
	enableBcmsPushTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	farmAnimalTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	farmId?: FieldPolicy<any> | FieldReadFunction<any>,
	financialTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	foggles?: FieldPolicy<any> | FieldReadFunction<any>,
	growthStage?: FieldPolicy<any> | FieldReadFunction<any>,
	guid?: FieldPolicy<any> | FieldReadFunction<any>,
	herdDoggIntegration?: FieldPolicy<any> | FieldReadFunction<any>,
	holdingId?: FieldPolicy<any> | FieldReadFunction<any>,
	houseNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	identifierPreferencesActiveIds?: FieldPolicy<any> | FieldReadFunction<any>,
	identifierPreferencesPrimaryId?: FieldPolicy<any> | FieldReadFunction<any>,
	identifierPreferencesSecondaryId?: FieldPolicy<any> | FieldReadFunction<any>,
	isOrganic?: FieldPolicy<any> | FieldReadFunction<any>,
	killOut?: FieldPolicy<any> | FieldReadFunction<any>,
	locationData?: FieldPolicy<any> | FieldReadFunction<any>,
	locationsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	lotExpiryInDays?: FieldPolicy<any> | FieldReadFunction<any>,
	marketType?: FieldPolicy<any> | FieldReadFunction<any>,
	mobile?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organisation?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	postcode?: FieldPolicy<any> | FieldReadFunction<any>,
	preferredBusinessUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	ratingAverage?: FieldPolicy<any> | FieldReadFunction<any>,
	region?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatorySystem?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatorySystemAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	requireBirthData?: FieldPolicy<any> | FieldReadFunction<any>,
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	statuses?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionPlan?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionPlanFeatures?: FieldPolicy<any> | FieldReadFunction<any>,
	tbStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingPlan?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	unitsOfMeasurement?: FieldPolicy<any> | FieldReadFunction<any>,
	userPermissions?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRate?: FieldPolicy<any> | FieldReadFunction<any>,
	warnings?: FieldPolicy<any> | FieldReadFunction<any>,
	workers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessUnitAccreditationKeySpecifier = ('accreditation' | 'businessUnit' | 'dateUploaded' | 'documents' | 'expires' | 'id' | 'isApproved' | 'membershipId' | 'uploadedBy' | BusinessUnitAccreditationKeySpecifier)[];
export type BusinessUnitAccreditationFieldPolicy = {
	accreditation?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	dateUploaded?: FieldPolicy<any> | FieldReadFunction<any>,
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	expires?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isApproved?: FieldPolicy<any> | FieldReadFunction<any>,
	membershipId?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedBy?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessUnitAccreditationDocumentKeySpecifier = ('file' | 'fileName' | 'id' | BusinessUnitAccreditationDocumentKeySpecifier)[];
export type BusinessUnitAccreditationDocumentFieldPolicy = {
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	fileName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessUnitCountTypeKeySpecifier = ('count' | 'errors' | BusinessUnitCountTypeKeySpecifier)[];
export type BusinessUnitCountTypeFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessUnitInfoKeySpecifier = ('accreditations' | 'address' | 'addressExtra' | 'backgroundPhoto' | 'businessType' | 'city' | 'country' | 'county' | 'description' | 'farmId' | 'houseNumber' | 'id' | 'isMember' | 'locationsCount' | 'mobile' | 'name' | 'owner' | 'phone' | 'postcode' | 'profilePhoto' | 'tbStatus' | 'unitsOfMeasurement' | BusinessUnitInfoKeySpecifier)[];
export type BusinessUnitInfoFieldPolicy = {
	accreditations?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	addressExtra?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	businessType?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	county?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	farmId?: FieldPolicy<any> | FieldReadFunction<any>,
	houseNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isMember?: FieldPolicy<any> | FieldReadFunction<any>,
	locationsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	mobile?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	postcode?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	tbStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	unitsOfMeasurement?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessUnitInterfaceKeySpecifier = ('id' | 'name' | BusinessUnitInterfaceKeySpecifier)[];
export type BusinessUnitInterfaceFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessUnitSettingsFaqTypeKeySpecifier = ('countries' | 'createdAt' | 'description' | 'id' | 'isActive' | 'title' | 'updatedAt' | BusinessUnitSettingsFaqTypeKeySpecifier)[];
export type BusinessUnitSettingsFaqTypeFieldPolicy = {
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessUnitSettingsTypeKeySpecifier = ('sizeUnit' | BusinessUnitSettingsTypeKeySpecifier)[];
export type BusinessUnitSettingsTypeFieldPolicy = {
	sizeUnit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessUnitStatusKeySpecifier = ('businessunitSet' | 'id' | 'name' | BusinessUnitStatusKeySpecifier)[];
export type BusinessUnitStatusFieldPolicy = {
	businessunitSet?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessUnitSubscriptionKeySpecifier = ('archived' | 'billingPeriodStart' | 'businessUnit' | 'businessUnitId' | 'createdAt' | 'discountCode' | 'id' | 'isActive' | 'paymentCoupon' | 'paymentCouponId' | 'paymentMethod' | 'paymentMethodId' | 'status' | 'subscriptionPlan' | 'subscriptionPlanId' | BusinessUnitSubscriptionKeySpecifier)[];
export type BusinessUnitSubscriptionFieldPolicy = {
	archived?: FieldPolicy<any> | FieldReadFunction<any>,
	billingPeriodStart?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	discountCode?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentCoupon?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentCouponId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionPlan?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionPlanId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessUnitTargetKeySpecifier = ('animalType' | 'businessUnit' | 'createdAt' | 'description' | 'details' | 'id' | 'name' | 'targetWeightType' | 'updatedAt' | BusinessUnitTargetKeySpecifier)[];
export type BusinessUnitTargetFieldPolicy = {
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	details?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	targetWeightType?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessUnitUserKeySpecifier = ('businessUnit' | 'id' | 'isOwner' | 'role' | 'status' | 'user' | BusinessUnitUserKeySpecifier)[];
export type BusinessUnitUserFieldPolicy = {
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CalfColourObjectTypeKeySpecifier = ('name' | 'slug' | CalfColourObjectTypeKeySpecifier)[];
export type CalfColourObjectTypeFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CalfulatorObjectTypeKeySpecifier = ('basePrice' | 'basePriceDivisor' | 'birthWeight' | 'breedClassification' | 'createdAt' | 'createdBy' | 'description' | 'firstFiftyAmberFactor' | 'firstFiftyGreenFactor' | 'firstFiftyRedFactor' | 'id' | 'isMale' | 'overFiftyAmberFactor' | 'overFiftyGreenFactor' | 'overFiftyRedFactor' | 'updatedAt' | CalfulatorObjectTypeKeySpecifier)[];
export type CalfulatorObjectTypeFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	basePriceDivisor?: FieldPolicy<any> | FieldReadFunction<any>,
	birthWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	breedClassification?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	firstFiftyAmberFactor?: FieldPolicy<any> | FieldReadFunction<any>,
	firstFiftyGreenFactor?: FieldPolicy<any> | FieldReadFunction<any>,
	firstFiftyRedFactor?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isMale?: FieldPolicy<any> | FieldReadFunction<any>,
	overFiftyAmberFactor?: FieldPolicy<any> | FieldReadFunction<any>,
	overFiftyGreenFactor?: FieldPolicy<any> | FieldReadFunction<any>,
	overFiftyRedFactor?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CancelFarmSystemTaskPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | CancelFarmSystemTaskPayloadKeySpecifier)[];
export type CancelFarmSystemTaskPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryOfSaleKeySpecifier = ('category' | 'id' | 'position' | CategoryOfSaleKeySpecifier)[];
export type CategoryOfSaleFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryOfSaleConnectionKeySpecifier = ('edges' | 'pageInfo' | CategoryOfSaleConnectionKeySpecifier)[];
export type CategoryOfSaleConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryOfSaleEdgeKeySpecifier = ('cursor' | 'node' | CategoryOfSaleEdgeKeySpecifier)[];
export type CategoryOfSaleEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChartDataItemKeySpecifier = ('animals' | 'data' | ChartDataItemKeySpecifier)[];
export type ChartDataItemFieldPolicy = {
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChartDataObjectTypeKeySpecifier = ('title' | 'value' | ChartDataObjectTypeKeySpecifier)[];
export type ChartDataObjectTypeFieldPolicy = {
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChartObjectTypeKeySpecifier = ('dataParam' | 'layoutSize' | 'reportType' | ChartObjectTypeKeySpecifier)[];
export type ChartObjectTypeFieldPolicy = {
	dataParam?: FieldPolicy<any> | FieldReadFunction<any>,
	layoutSize?: FieldPolicy<any> | FieldReadFunction<any>,
	reportType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckCommitDeliveryPayloadKeySpecifier = ('animalErrors' | 'clientMutationId' | 'delivery' | 'errors' | 'success' | CheckCommitDeliveryPayloadKeySpecifier)[];
export type CheckCommitDeliveryPayloadFieldPolicy = {
	animalErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckFieldPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'valid' | CheckFieldPayloadKeySpecifier)[];
export type CheckFieldPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	valid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChoiceKeySpecifier = ('label' | 'value' | ChoiceKeySpecifier)[];
export type ChoiceFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CloseLotPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'lot' | CloseLotPayloadKeySpecifier)[];
export type CloseLotPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	lot?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CommitDeliveryAsyncPayloadKeySpecifier = ('clientMutationId' | 'delivery' | 'errors' | 'success' | 'task' | CommitDeliveryAsyncPayloadKeySpecifier)[];
export type CommitDeliveryAsyncPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>,
	task?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CommitDeliveryPayloadKeySpecifier = ('clientMutationId' | 'delivery' | 'errors' | 'success' | CommitDeliveryPayloadKeySpecifier)[];
export type CommitDeliveryPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CommonFarmSystemTypeKeySpecifier = ('credentials' | 'errorMessage' | 'farm' | 'id' | 'integrationSystem' | 'status' | CommonFarmSystemTypeKeySpecifier)[];
export type CommonFarmSystemTypeFieldPolicy = {
	credentials?: FieldPolicy<any> | FieldReadFunction<any>,
	errorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	farm?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	integrationSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CompatMoveAnimalsOffFarmPayloadKeySpecifier = ('animals' | 'clientMutationId' | 'errors' | 'success' | CompatMoveAnimalsOffFarmPayloadKeySpecifier)[];
export type CompatMoveAnimalsOffFarmPayloadFieldPolicy = {
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CompetentAuthorityKeySpecifier = ('abattoirSet' | 'id' | 'name' | CompetentAuthorityKeySpecifier)[];
export type CompetentAuthorityFieldPolicy = {
	abattoirSet?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CompleteInvitationPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'token' | 'user' | CompleteInvitationPayloadKeySpecifier)[];
export type CompleteInvitationPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactObjectTypeKeySpecifier = ('addressLine1' | 'addressLine2' | 'businessUnit' | 'city' | 'contactType' | 'country' | 'createdAt' | 'email' | 'farmId' | 'id' | 'name' | 'organisationName' | 'phoneNumber' | 'postcode' | 'state' | 'updatedAt' | ContactObjectTypeKeySpecifier)[];
export type ContactObjectTypeFieldPolicy = {
	addressLine1?: FieldPolicy<any> | FieldReadFunction<any>,
	addressLine2?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	contactType?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	farmId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organisationName?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	postcode?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactsConnectionKeySpecifier = ('edges' | 'pageInfo' | ContactsConnectionKeySpecifier)[];
export type ContactsConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactsEdgeKeySpecifier = ('cursor' | 'node' | ContactsEdgeKeySpecifier)[];
export type ContactsEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConvertBatchPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'importId' | 'success' | ConvertBatchPayloadKeySpecifier)[];
export type ConvertBatchPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	importId?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CountryKeySpecifier = ('abattoirSet' | 'code' | 'contactSet' | 'currencySet' | 'deliveryaddressSet' | 'emptystateSet' | 'id' | 'integrationsystemSet' | 'isoAlpha2' | 'isoAlpha3' | 'isoNumber' | 'name' | 'region' | 'sexclassificationSet' | 'subCode' | 'visualIdPrefix' | CountryKeySpecifier)[];
export type CountryFieldPolicy = {
	abattoirSet?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	contactSet?: FieldPolicy<any> | FieldReadFunction<any>,
	currencySet?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryaddressSet?: FieldPolicy<any> | FieldReadFunction<any>,
	emptystateSet?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	integrationsystemSet?: FieldPolicy<any> | FieldReadFunction<any>,
	isoAlpha2?: FieldPolicy<any> | FieldReadFunction<any>,
	isoAlpha3?: FieldPolicy<any> | FieldReadFunction<any>,
	isoNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	region?: FieldPolicy<any> | FieldReadFunction<any>,
	sexclassificationSet?: FieldPolicy<any> | FieldReadFunction<any>,
	subCode?: FieldPolicy<any> | FieldReadFunction<any>,
	visualIdPrefix?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CouponKeySpecifier = ('currency' | 'id' | 'isPercent' | 'name' | 'priceOff' | CouponKeySpecifier)[];
export type CouponFieldPolicy = {
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isPercent?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	priceOff?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateAnimalFilterPayloadKeySpecifier = ('animalFilter' | 'clientMutationId' | 'errors' | CreateAnimalFilterPayloadKeySpecifier)[];
export type CreateAnimalFilterPayloadFieldPolicy = {
	animalFilter?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateAnimalPayloadKeySpecifier = ('animal' | 'clientMutationId' | 'errors' | CreateAnimalPayloadKeySpecifier)[];
export type CreateAnimalPayloadFieldPolicy = {
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateAnimalsAlertsPayloadKeySpecifier = ('animalAlerts' | 'clientMutationId' | 'errors' | CreateAnimalsAlertsPayloadKeySpecifier)[];
export type CreateAnimalsAlertsPayloadFieldPolicy = {
	animalAlerts?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateBankAccountPayloadKeySpecifier = ('bankAccount' | 'clientMutationId' | 'errors' | CreateBankAccountPayloadKeySpecifier)[];
export type CreateBankAccountPayloadFieldPolicy = {
	bankAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateBankDetailsPayloadKeySpecifier = ('bankDetails' | 'clientMutationId' | 'errors' | CreateBankDetailsPayloadKeySpecifier)[];
export type CreateBankDetailsPayloadFieldPolicy = {
	bankDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateBatchPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'group' | CreateBatchPayloadKeySpecifier)[];
export type CreateBatchPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateBusinessUnitAccreditationPayloadKeySpecifier = ('businessUnitAccreditation' | 'clientMutationId' | 'errors' | CreateBusinessUnitAccreditationPayloadKeySpecifier)[];
export type CreateBusinessUnitAccreditationPayloadFieldPolicy = {
	businessUnitAccreditation?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateBusinessUnitTargetPayloadKeySpecifier = ('businessUnitTarget' | 'clientMutationId' | 'errors' | CreateBusinessUnitTargetPayloadKeySpecifier)[];
export type CreateBusinessUnitTargetPayloadFieldPolicy = {
	businessUnitTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateContactPayloadKeySpecifier = ('clientMutationId' | 'contact' | 'errors' | CreateContactPayloadKeySpecifier)[];
export type CreateContactPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateDeliveryPayloadKeySpecifier = ('clientMutationId' | 'delivery' | 'errors' | 'success' | CreateDeliveryPayloadKeySpecifier)[];
export type CreateDeliveryPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateDistributionListPayloadKeySpecifier = ('clientMutationId' | 'distributionList' | 'errors' | CreateDistributionListPayloadKeySpecifier)[];
export type CreateDistributionListPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	distributionList?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateDownloadPayloadKeySpecifier = ('clientMutationId' | 'downloadId' | 'errors' | 'success' | CreateDownloadPayloadKeySpecifier)[];
export type CreateDownloadPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	downloadId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateFarmSystemPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'farmSystem' | CreateFarmSystemPayloadKeySpecifier)[];
export type CreateFarmSystemPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	farmSystem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateFieldPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'field' | CreateFieldPayloadKeySpecifier)[];
export type CreateFieldPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateFinancialTransactionPayloadKeySpecifier = ('animalErrors' | 'clientMutationId' | 'errors' | 'financialTransaction' | CreateFinancialTransactionPayloadKeySpecifier)[];
export type CreateFinancialTransactionPayloadFieldPolicy = {
	animalErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	financialTransaction?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateGroupPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'group' | CreateGroupPayloadKeySpecifier)[];
export type CreateGroupPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateLiveSessionPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'liveSession' | 'success' | CreateLiveSessionPayloadKeySpecifier)[];
export type CreateLiveSessionPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	liveSession?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateLotPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'lot' | CreateLotPayloadKeySpecifier)[];
export type CreateLotPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	lot?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateOfferForLotPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'offer' | CreateOfferForLotPayloadKeySpecifier)[];
export type CreateOfferForLotPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	offer?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreatePreferredBuyersPayloadKeySpecifier = ('buyers' | 'clientMutationId' | 'errors' | CreatePreferredBuyersPayloadKeySpecifier)[];
export type CreatePreferredBuyersPayloadFieldPolicy = {
	buyers?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreatePreferredSuppliersPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'suppliers' | CreatePreferredSuppliersPayloadKeySpecifier)[];
export type CreatePreferredSuppliersPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	suppliers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateProducerGroupPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'producerGroup' | CreateProducerGroupPayloadKeySpecifier)[];
export type CreateProducerGroupPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	producerGroup?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateSirePayloadKeySpecifier = ('clientMutationId' | 'errors' | 'sire' | 'success' | CreateSirePayloadKeySpecifier)[];
export type CreateSirePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	sire?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateStripeCheckoutSessionPayloadKeySpecifier = ('clientMutationId' | 'sessionUrl' | CreateStripeCheckoutSessionPayloadKeySpecifier)[];
export type CreateStripeCheckoutSessionPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateStripePortalSessionPayloadKeySpecifier = ('clientMutationId' | 'sessionUrl' | CreateStripePortalSessionPayloadKeySpecifier)[];
export type CreateStripePortalSessionPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateTagPayloadKeySpecifier = ('animalTag' | 'clientMutationId' | 'errors' | 'success' | CreateTagPayloadKeySpecifier)[];
export type CreateTagPayloadFieldPolicy = {
	animalTag?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateUpdateInProgressCrushAppSessionPayloadKeySpecifier = ('clientMutationId' | 'crushAppSession' | 'errors' | CreateUpdateInProgressCrushAppSessionPayloadKeySpecifier)[];
export type CreateUpdateInProgressCrushAppSessionPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	crushAppSession?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateWeightPayloadKeySpecifier = ('animal' | 'clientMutationId' | 'errors' | 'success' | 'weight' | CreateWeightPayloadKeySpecifier)[];
export type CreateWeightPayloadFieldPolicy = {
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CrushActionErrorsKeySpecifier = ('action' | 'metadata' | 'validationErrors' | CrushActionErrorsKeySpecifier)[];
export type CrushActionErrorsFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	validationErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CrushActionValidationErrorsKeySpecifier = ('code' | 'errorMessages' | 'field' | CrushActionValidationErrorsKeySpecifier)[];
export type CrushActionValidationErrorsFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	errorMessages?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CrushAnimalNotSavedKeySpecifier = ('actionErrors' | 'animal' | 'newAnimalId' | CrushAnimalNotSavedKeySpecifier)[];
export type CrushAnimalNotSavedFieldPolicy = {
	actionErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	newAnimalId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CrushAnimalSavedKeySpecifier = ('animal' | CrushAnimalSavedKeySpecifier)[];
export type CrushAnimalSavedFieldPolicy = {
	animal?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CrushAppSessionConnectionKeySpecifier = ('edges' | 'pageInfo' | CrushAppSessionConnectionKeySpecifier)[];
export type CrushAppSessionConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CrushAppSessionEdgeKeySpecifier = ('cursor' | 'node' | CrushAppSessionEdgeKeySpecifier)[];
export type CrushAppSessionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CrushAppSessionObjectTypeKeySpecifier = ('animalType' | 'animals' | 'animalsNotSaved' | 'businessUnit' | 'createdAt' | 'groupsNotSaved' | 'id' | 'sessionConfig' | 'status' | 'updatedAt' | 'user' | CrushAppSessionObjectTypeKeySpecifier)[];
export type CrushAppSessionObjectTypeFieldPolicy = {
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsNotSaved?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	groupsNotSaved?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CrushGroupsNotSavedKeySpecifier = ('code' | 'errorMessage' | 'field' | 'index' | CrushGroupsNotSavedKeySpecifier)[];
export type CrushGroupsNotSavedFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	errorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	index?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CurrencyKeySpecifier = ('code' | 'country' | 'id' | 'name' | CurrencyKeySpecifier)[];
export type CurrencyFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DashboardObjectTypeKeySpecifier = ('charts' | 'filters' | 'slug' | 'title' | DashboardObjectTypeKeySpecifier)[];
export type DashboardObjectTypeFieldPolicy = {
	charts?: FieldPolicy<any> | FieldReadFunction<any>,
	filters?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteActivityBulkPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteActivityBulkPayloadKeySpecifier)[];
export type DeleteActivityBulkPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteAnimalFilterPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteAnimalFilterPayloadKeySpecifier)[];
export type DeleteAnimalFilterPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteAnimalsMedicineCoursePayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteAnimalsMedicineCoursePayloadKeySpecifier)[];
export type DeleteAnimalsMedicineCoursePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteBankAccountPayloadKeySpecifier = ('clientMutationId' | 'deleted' | 'errors' | DeleteBankAccountPayloadKeySpecifier)[];
export type DeleteBankAccountPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteBankDetailsPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteBankDetailsPayloadKeySpecifier)[];
export type DeleteBankDetailsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteBusinessUnitAccreditationPayloadKeySpecifier = ('clientMutationId' | 'success' | DeleteBusinessUnitAccreditationPayloadKeySpecifier)[];
export type DeleteBusinessUnitAccreditationPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteBusinessUnitTargetPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteBusinessUnitTargetPayloadKeySpecifier)[];
export type DeleteBusinessUnitTargetPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteCrushAppSessionPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteCrushAppSessionPayloadKeySpecifier)[];
export type DeleteCrushAppSessionPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDeliveryAddressPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteDeliveryAddressPayloadKeySpecifier)[];
export type DeleteDeliveryAddressPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDeliveryAnimalsPayloadKeySpecifier = ('animals' | 'clientMutationId' | 'delivery' | 'errors' | 'success' | DeleteDeliveryAnimalsPayloadKeySpecifier)[];
export type DeleteDeliveryAnimalsPayloadFieldPolicy = {
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDeliveryPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteDeliveryPayloadKeySpecifier)[];
export type DeleteDeliveryPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDiscountGridPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteDiscountGridPayloadKeySpecifier)[];
export type DeleteDiscountGridPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDistributionListPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteDistributionListPayloadKeySpecifier)[];
export type DeleteDistributionListPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteFarmSystemPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteFarmSystemPayloadKeySpecifier)[];
export type DeleteFarmSystemPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteFieldImagePayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteFieldImagePayloadKeySpecifier)[];
export type DeleteFieldImagePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteFieldPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteFieldPayloadKeySpecifier)[];
export type DeleteFieldPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteFinancialTransactionPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteFinancialTransactionPayloadKeySpecifier)[];
export type DeleteFinancialTransactionPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteGroupImagePayloadKeySpecifier = ('clientMutationId' | 'success' | DeleteGroupImagePayloadKeySpecifier)[];
export type DeleteGroupImagePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteGroupPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteGroupPayloadKeySpecifier)[];
export type DeleteGroupPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteGroupWithAnimalsPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteGroupWithAnimalsPayloadKeySpecifier)[];
export type DeleteGroupWithAnimalsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteLiveSessionPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteLiveSessionPayloadKeySpecifier)[];
export type DeleteLiveSessionPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteMedicineCoursePayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteMedicineCoursePayloadKeySpecifier)[];
export type DeleteMedicineCoursePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteMedicineCourseStagePayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteMedicineCourseStagePayloadKeySpecifier)[];
export type DeleteMedicineCourseStagePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeletePostPayloadKeySpecifier = ('clientMutationId' | 'success' | DeletePostPayloadKeySpecifier)[];
export type DeletePostPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteRegularWithdrawalPayloadKeySpecifier = ('clientMutationId' | 'deleted' | 'errors' | DeleteRegularWithdrawalPayloadKeySpecifier)[];
export type DeleteRegularWithdrawalPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteSirePayloadKeySpecifier = ('clientMutationId' | 'sire' | 'success' | DeleteSirePayloadKeySpecifier)[];
export type DeleteSirePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	sire?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteTagPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteTagPayloadKeySpecifier)[];
export type DeleteTagPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteUserFromFarmPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | DeleteUserFromFarmPayloadKeySpecifier)[];
export type DeleteUserFromFarmPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteWeightPayloadKeySpecifier = ('animal' | 'clientMutationId' | 'errors' | 'success' | DeleteWeightPayloadKeySpecifier)[];
export type DeleteWeightPayloadFieldPolicy = {
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliverAnimalOutPayloadKeySpecifier = ('animal' | 'clientMutationId' | 'delivery' | 'errors' | 'success' | DeliverAnimalOutPayloadKeySpecifier)[];
export type DeliverAnimalOutPayloadFieldPolicy = {
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliverAnimalsOutPayloadKeySpecifier = ('animals' | 'clientMutationId' | 'delivery' | 'errors' | 'success' | DeliverAnimalsOutPayloadKeySpecifier)[];
export type DeliverAnimalsOutPayloadFieldPolicy = {
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliverExistingAnimalPayloadKeySpecifier = ('animal' | 'clientMutationId' | 'delivery' | 'errors' | 'success' | DeliverExistingAnimalPayloadKeySpecifier)[];
export type DeliverExistingAnimalPayloadFieldPolicy = {
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliverExistingAnimalsPayloadKeySpecifier = ('animals' | 'clientMutationId' | 'delivery' | 'errors' | 'success' | DeliverExistingAnimalsPayloadKeySpecifier)[];
export type DeliverExistingAnimalsPayloadFieldPolicy = {
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliverNewAnimalPayloadKeySpecifier = ('animal' | 'clientMutationId' | 'delivery' | 'errors' | 'success' | DeliverNewAnimalPayloadKeySpecifier)[];
export type DeliverNewAnimalPayloadFieldPolicy = {
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliverPulledAnimalPayloadKeySpecifier = ('clientMutationId' | 'delivery' | 'errors' | 'success' | DeliverPulledAnimalPayloadKeySpecifier)[];
export type DeliverPulledAnimalPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryAddressInterfaceKeySpecifier = ('city' | 'country' | 'id' | 'locationId' | 'postcode' | 'unitName' | DeliveryAddressInterfaceKeySpecifier)[];
export type DeliveryAddressInterfaceFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	postcode?: FieldPolicy<any> | FieldReadFunction<any>,
	unitName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryAddressTypeKeySpecifier = ('addressLine1' | 'addressLine2' | 'city' | 'country' | 'farm' | 'id' | 'isDeleted' | 'locationId' | 'locationType' | 'pointLocation' | 'postcode' | 'primary' | 'unitName' | DeliveryAddressTypeKeySpecifier)[];
export type DeliveryAddressTypeFieldPolicy = {
	addressLine1?: FieldPolicy<any> | FieldReadFunction<any>,
	addressLine2?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	farm?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	locationType?: FieldPolicy<any> | FieldReadFunction<any>,
	pointLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	postcode?: FieldPolicy<any> | FieldReadFunction<any>,
	primary?: FieldPolicy<any> | FieldReadFunction<any>,
	unitName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryAffidavitConnectionKeySpecifier = ('edges' | 'pageInfo' | DeliveryAffidavitConnectionKeySpecifier)[];
export type DeliveryAffidavitConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryAffidavitEdgeKeySpecifier = ('cursor' | 'node' | DeliveryAffidavitEdgeKeySpecifier)[];
export type DeliveryAffidavitEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryAffidavitTypeKeySpecifier = ('name' | 'url' | DeliveryAffidavitTypeKeySpecifier)[];
export type DeliveryAffidavitTypeFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryAnimalErrorTypeKeySpecifier = ('animalId' | 'errors' | 'passportNumber' | DeliveryAnimalErrorTypeKeySpecifier)[];
export type DeliveryAnimalErrorTypeFieldPolicy = {
	animalId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	passportNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryConnectionKeySpecifier = ('count' | 'edges' | 'pageInfo' | DeliveryConnectionKeySpecifier)[];
export type DeliveryConnectionFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryConsignmentConnectionKeySpecifier = ('edges' | 'pageInfo' | DeliveryConsignmentConnectionKeySpecifier)[];
export type DeliveryConsignmentConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryConsignmentEdgeKeySpecifier = ('cursor' | 'node' | DeliveryConsignmentEdgeKeySpecifier)[];
export type DeliveryConsignmentEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryConsignmentTypeKeySpecifier = ('animalCount' | 'animals' | 'destination' | 'id' | 'source' | DeliveryConsignmentTypeKeySpecifier)[];
export type DeliveryConsignmentTypeFieldPolicy = {
	animalCount?: FieldPolicy<any> | FieldReadFunction<any>,
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	destination?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryEdgeKeySpecifier = ('cursor' | 'node' | DeliveryEdgeKeySpecifier)[];
export type DeliveryEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryLocationDetailsObjectTypeKeySpecifier = ('address' | 'email' | 'name' | 'postcode' | DeliveryLocationDetailsObjectTypeKeySpecifier)[];
export type DeliveryLocationDetailsObjectTypeFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	postcode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryLocationSummaryTypeKeySpecifier = ('hasMore' | 'locations' | DeliveryLocationSummaryTypeKeySpecifier)[];
export type DeliveryLocationSummaryTypeFieldPolicy = {
	hasMore?: FieldPolicy<any> | FieldReadFunction<any>,
	locations?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryLocationTypeKeySpecifier = ('address' | 'contact' | 'details' | 'hasDetails' | 'locationType' | 'ownerContact' | 'ownerPartner' | 'partner' | DeliveryLocationTypeKeySpecifier)[];
export type DeliveryLocationTypeFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	details?: FieldPolicy<any> | FieldReadFunction<any>,
	hasDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	locationType?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerContact?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerPartner?: FieldPolicy<any> | FieldReadFunction<any>,
	partner?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryOverviewTypeKeySpecifier = ('affidavits' | 'animalCount' | 'animalTypes' | 'animals' | 'consignments' | 'delivery' | DeliveryOverviewTypeKeySpecifier)[];
export type DeliveryOverviewTypeFieldPolicy = {
	affidavits?: FieldPolicy<any> | FieldReadFunction<any>,
	animalCount?: FieldPolicy<any> | FieldReadFunction<any>,
	animalTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	consignments?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryPartnerAddressConnectionKeySpecifier = ('edges' | 'pageInfo' | DeliveryPartnerAddressConnectionKeySpecifier)[];
export type DeliveryPartnerAddressConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryPartnerAddressEdgeKeySpecifier = ('cursor' | 'node' | DeliveryPartnerAddressEdgeKeySpecifier)[];
export type DeliveryPartnerAddressEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryPartnerAddressTypeKeySpecifier = ('id' | 'name' | 'partner' | DeliveryPartnerAddressTypeKeySpecifier)[];
export type DeliveryPartnerAddressTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	partner?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryPartnerConnectionKeySpecifier = ('edges' | 'pageInfo' | DeliveryPartnerConnectionKeySpecifier)[];
export type DeliveryPartnerConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryPartnerEdgeKeySpecifier = ('cursor' | 'node' | DeliveryPartnerEdgeKeySpecifier)[];
export type DeliveryPartnerEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryPartnerTypeKeySpecifier = ('addresses' | 'code' | 'id' | DeliveryPartnerTypeKeySpecifier)[];
export type DeliveryPartnerTypeFieldPolicy = {
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryReasonConnectionKeySpecifier = ('edges' | 'pageInfo' | DeliveryReasonConnectionKeySpecifier)[];
export type DeliveryReasonConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryReasonEdgeKeySpecifier = ('cursor' | 'node' | DeliveryReasonEdgeKeySpecifier)[];
export type DeliveryReasonEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryReasonTypeKeySpecifier = ('directions' | 'id' | 'slug' | 'title' | DeliveryReasonTypeKeySpecifier)[];
export type DeliveryReasonTypeFieldPolicy = {
	directions?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryTaskTypeKeySpecifier = ('id' | 'status' | DeliveryTaskTypeKeySpecifier)[];
export type DeliveryTaskTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryTypeKeySpecifier = ('actualSources' | 'animalCount' | 'animalTypes' | 'arrivedAt' | 'createdAt' | 'defaultDestination' | 'defaultSource' | 'destination' | 'destinationSummary' | 'direction' | 'id' | 'name' | 'reason' | 'sentAt' | 'source' | 'sourceSummary' | 'status' | 'updatedAt' | DeliveryTypeKeySpecifier)[];
export type DeliveryTypeFieldPolicy = {
	actualSources?: FieldPolicy<any> | FieldReadFunction<any>,
	animalCount?: FieldPolicy<any> | FieldReadFunction<any>,
	animalTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	arrivedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultDestination?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultSource?: FieldPolicy<any> | FieldReadFunction<any>,
	destination?: FieldPolicy<any> | FieldReadFunction<any>,
	destinationSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	sentAt?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DiagnosePregnancyPayloadKeySpecifier = ('animal' | 'clientMutationId' | 'errors' | 'success' | DiagnosePregnancyPayloadKeySpecifier)[];
export type DiagnosePregnancyPayloadFieldPolicy = {
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DiscountGridKeySpecifier = ('businessUnit' | 'createdAt' | 'file' | 'id' | 'name' | DiscountGridKeySpecifier)[];
export type DiscountGridFieldPolicy = {
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisposeMedicineLineItemPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'lineItem' | DisposeMedicineLineItemPayloadKeySpecifier)[];
export type DisposeMedicineLineItemPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	lineItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DistributionListConnectionKeySpecifier = ('count' | 'edges' | 'pageInfo' | DistributionListConnectionKeySpecifier)[];
export type DistributionListConnectionFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DistributionListEdgeKeySpecifier = ('cursor' | 'node' | DistributionListEdgeKeySpecifier)[];
export type DistributionListEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DistributionListObjectTypeKeySpecifier = ('businessUnit' | 'id' | 'name' | 'suppliers' | DistributionListObjectTypeKeySpecifier)[];
export type DistributionListObjectTypeFieldPolicy = {
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	suppliers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DjangoDebugKeySpecifier = ('exceptions' | 'sql' | DjangoDebugKeySpecifier)[];
export type DjangoDebugFieldPolicy = {
	exceptions?: FieldPolicy<any> | FieldReadFunction<any>,
	sql?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DjangoDebugExceptionKeySpecifier = ('excType' | 'message' | 'stack' | DjangoDebugExceptionKeySpecifier)[];
export type DjangoDebugExceptionFieldPolicy = {
	excType?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	stack?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DjangoDebugSQLKeySpecifier = ('alias' | 'duration' | 'encoding' | 'isSelect' | 'isSlow' | 'isoLevel' | 'params' | 'rawSql' | 'sql' | 'startTime' | 'stopTime' | 'transId' | 'transStatus' | 'vendor' | DjangoDebugSQLKeySpecifier)[];
export type DjangoDebugSQLFieldPolicy = {
	alias?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	encoding?: FieldPolicy<any> | FieldReadFunction<any>,
	isSelect?: FieldPolicy<any> | FieldReadFunction<any>,
	isSlow?: FieldPolicy<any> | FieldReadFunction<any>,
	isoLevel?: FieldPolicy<any> | FieldReadFunction<any>,
	params?: FieldPolicy<any> | FieldReadFunction<any>,
	rawSql?: FieldPolicy<any> | FieldReadFunction<any>,
	sql?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>,
	stopTime?: FieldPolicy<any> | FieldReadFunction<any>,
	transId?: FieldPolicy<any> | FieldReadFunction<any>,
	transStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DownloadConnectionKeySpecifier = ('edges' | 'pageInfo' | DownloadConnectionKeySpecifier)[];
export type DownloadConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DownloadEdgeKeySpecifier = ('cursor' | 'node' | DownloadEdgeKeySpecifier)[];
export type DownloadEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DownloadLinkKeySpecifier = ('link' | DownloadLinkKeySpecifier)[];
export type DownloadLinkFieldPolicy = {
	link?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DownloadObjectTypeKeySpecifier = ('createdAt' | 'downloadedFile' | 'id' | 'name' | 'status' | 'updatedAt' | DownloadObjectTypeKeySpecifier)[];
export type DownloadObjectTypeFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	downloadedFile?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DownloadOptionsObjectTypeKeySpecifier = ('slug' | 'variables' | DownloadOptionsObjectTypeKeySpecifier)[];
export type DownloadOptionsObjectTypeFieldPolicy = {
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	variables?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EditBankAccountPayloadKeySpecifier = ('bankAccount' | 'clientMutationId' | 'errors' | EditBankAccountPayloadKeySpecifier)[];
export type EditBankAccountPayloadFieldPolicy = {
	bankAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EditDeliveryAddressPayloadKeySpecifier = ('clientMutationId' | 'deliveryAddress' | 'errors' | EditDeliveryAddressPayloadKeySpecifier)[];
export type EditDeliveryAddressPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EditProducerGroupPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'producerGroup' | EditProducerGroupPayloadKeySpecifier)[];
export type EditProducerGroupPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	producerGroup?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EditRegularWithdrawalPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'regularWithdrawal' | EditRegularWithdrawalPayloadKeySpecifier)[];
export type EditRegularWithdrawalPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	regularWithdrawal?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmptyStateObjectTypeKeySpecifier = ('animalType' | 'button' | 'buttonLabel' | 'buttonLink' | 'countries' | 'id' | 'image' | 'isDisabled' | 'name' | 'page' | 'platform' | 'showButton' | 'text' | EmptyStateObjectTypeKeySpecifier)[];
export type EmptyStateObjectTypeFieldPolicy = {
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	button?: FieldPolicy<any> | FieldReadFunction<any>,
	buttonLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	buttonLink?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	isDisabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	platform?: FieldPolicy<any> | FieldReadFunction<any>,
	showButton?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntityKeySpecifier = ('id' | 'name' | EntityKeySpecifier)[];
export type EntityFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntityAlertConnectionKeySpecifier = ('activeAlertsCount' | 'edges' | 'pageInfo' | EntityAlertConnectionKeySpecifier)[];
export type EntityAlertConnectionFieldPolicy = {
	activeAlertsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntityAlertEdgeKeySpecifier = ('cursor' | 'node' | EntityAlertEdgeKeySpecifier)[];
export type EntityAlertEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntityAlertInterfaceKeySpecifier = ('alert' | 'entityType' | 'id' | EntityAlertInterfaceKeySpecifier)[];
export type EntityAlertInterfaceFieldPolicy = {
	alert?: FieldPolicy<any> | FieldReadFunction<any>,
	entityType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EstimatedFuturePriceTypeKeySpecifier = ('errors' | 'futurePrice' | EstimatedFuturePriceTypeKeySpecifier)[];
export type EstimatedFuturePriceTypeFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	futurePrice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExportAnimalsAsyncPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'export' | ExportAnimalsAsyncPayloadKeySpecifier)[];
export type ExportAnimalsAsyncPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	export?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExportResultKeySpecifier = ('id' | 'isReady' | 'url' | ExportResultKeySpecifier)[];
export type ExportResultFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isReady?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FarmAnimalDetailPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'farmAnimalDetail' | FarmAnimalDetailPayloadKeySpecifier)[];
export type FarmAnimalDetailPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	farmAnimalDetail?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FarmAnimalTypeKeySpecifier = ('accreditations' | 'animalNumber' | 'animalType' | 'conventional' | 'extensive' | 'farm' | 'farmAnimalTypeAccreditations' | 'healthStatuses' | 'id' | 'intensive' | 'organic' | 'pedigree' | 'systemType' | FarmAnimalTypeKeySpecifier)[];
export type FarmAnimalTypeFieldPolicy = {
	accreditations?: FieldPolicy<any> | FieldReadFunction<any>,
	animalNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	conventional?: FieldPolicy<any> | FieldReadFunction<any>,
	extensive?: FieldPolicy<any> | FieldReadFunction<any>,
	farm?: FieldPolicy<any> | FieldReadFunction<any>,
	farmAnimalTypeAccreditations?: FieldPolicy<any> | FieldReadFunction<any>,
	healthStatuses?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	intensive?: FieldPolicy<any> | FieldReadFunction<any>,
	organic?: FieldPolicy<any> | FieldReadFunction<any>,
	pedigree?: FieldPolicy<any> | FieldReadFunction<any>,
	systemType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FarmAnimalTypeAccreditationKeySpecifier = ('accreditation' | 'dateUploaded' | 'expires' | 'farmAnimalType' | 'id' | 'isApproved' | 'membershipId' | 'uploadedBy' | FarmAnimalTypeAccreditationKeySpecifier)[];
export type FarmAnimalTypeAccreditationFieldPolicy = {
	accreditation?: FieldPolicy<any> | FieldReadFunction<any>,
	dateUploaded?: FieldPolicy<any> | FieldReadFunction<any>,
	expires?: FieldPolicy<any> | FieldReadFunction<any>,
	farmAnimalType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isApproved?: FieldPolicy<any> | FieldReadFunction<any>,
	membershipId?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedBy?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FarmDetailChoicesKeySpecifier = ('healthStatuses' | 'systemTypes' | FarmDetailChoicesKeySpecifier)[];
export type FarmDetailChoicesFieldPolicy = {
	healthStatuses?: FieldPolicy<any> | FieldReadFunction<any>,
	systemTypes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FarmDetailHealthItemKeySpecifier = ('animalType' | 'slug' | 'title' | FarmDetailHealthItemKeySpecifier)[];
export type FarmDetailHealthItemFieldPolicy = {
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FarmDetailSystemItemKeySpecifier = ('animalType' | 'slug' | 'title' | FarmDetailSystemItemKeySpecifier)[];
export type FarmDetailSystemItemFieldPolicy = {
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FarmMovementConnectionKeySpecifier = ('edges' | 'pageInfo' | FarmMovementConnectionKeySpecifier)[];
export type FarmMovementConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FarmMovementEdgeKeySpecifier = ('cursor' | 'node' | FarmMovementEdgeKeySpecifier)[];
export type FarmMovementEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FarmMovementTypeKeySpecifier = ('destination' | 'id' | 'movedAt' | 'movementType' | 'passportNumber' | 'source' | FarmMovementTypeKeySpecifier)[];
export type FarmMovementTypeFieldPolicy = {
	destination?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	movedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	movementType?: FieldPolicy<any> | FieldReadFunction<any>,
	passportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FarmPlanImportXLSPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'task' | FarmPlanImportXLSPayloadKeySpecifier)[];
export type FarmPlanImportXLSPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	task?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FarmSystemTaskTypeKeySpecifier = ('action' | 'createdItems' | 'doneAt' | 'id' | 'isAborted' | 'newNumberItems' | 'processedNumberItems' | 'producedFromTask' | 'producedTask' | 'status' | 'totalNumberItems' | 'uncreatedItems' | 'updatedItems' | 'updatedNumberItems' | FarmSystemTaskTypeKeySpecifier)[];
export type FarmSystemTaskTypeFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	createdItems?: FieldPolicy<any> | FieldReadFunction<any>,
	doneAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isAborted?: FieldPolicy<any> | FieldReadFunction<any>,
	newNumberItems?: FieldPolicy<any> | FieldReadFunction<any>,
	processedNumberItems?: FieldPolicy<any> | FieldReadFunction<any>,
	producedFromTask?: FieldPolicy<any> | FieldReadFunction<any>,
	producedTask?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	totalNumberItems?: FieldPolicy<any> | FieldReadFunction<any>,
	uncreatedItems?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedItems?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedNumberItems?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FarmSystemTypeKeySpecifier = ('credentials' | 'errorMessage' | 'farm' | 'id' | 'integrationSystem' | 'status' | FarmSystemTypeKeySpecifier)[];
export type FarmSystemTypeFieldPolicy = {
	credentials?: FieldPolicy<any> | FieldReadFunction<any>,
	errorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	farm?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	integrationSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FavoriteActivityTemplatePayloadKeySpecifier = ('activityTemplate' | 'clientMutationId' | 'errors' | FavoriteActivityTemplatePayloadKeySpecifier)[];
export type FavoriteActivityTemplatePayloadFieldPolicy = {
	activityTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FavouriteObjectTypeKeySpecifier = ('businessUnit' | 'id' | 'itemDescription' | 'itemId' | 'itemName' | 'itemType' | 'user' | FavouriteObjectTypeKeySpecifier)[];
export type FavouriteObjectTypeFieldPolicy = {
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	itemDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	itemName?: FieldPolicy<any> | FieldReadFunction<any>,
	itemType?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FeatureCollectionObjectTypeKeySpecifier = ('features' | 'type' | FeatureCollectionObjectTypeKeySpecifier)[];
export type FeatureCollectionObjectTypeFieldPolicy = {
	features?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FeatureObjectTypeKeySpecifier = ('geometry' | 'properties' | 'type' | FeatureObjectTypeKeySpecifier)[];
export type FeatureObjectTypeFieldPolicy = {
	geometry?: FieldPolicy<any> | FieldReadFunction<any>,
	properties?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FieldKeySpecifier = ('animalAlerts' | 'animalAlertsCount' | 'animals' | 'avgAge' | 'avgDlwg' | 'avgEstimatedWeight' | 'avgRecordedWeight' | 'batches' | 'businessUnitId' | 'colour' | 'description' | 'fieldArea' | 'fieldDensity' | 'fieldSize' | 'groupsCount' | 'id' | 'image' | 'images' | 'isDeleted' | 'isHoldingPen' | 'isOrganic' | 'isYard' | 'itemtransactionSet' | 'location' | 'name' | 'notifications' | 'pastureTypes' | 'size' | 'sizeUnit' | 'summaryMetrics' | 'tasks' | 'tasksCount' | FieldKeySpecifier)[];
export type FieldFieldPolicy = {
	animalAlerts?: FieldPolicy<any> | FieldReadFunction<any>,
	animalAlertsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	avgAge?: FieldPolicy<any> | FieldReadFunction<any>,
	avgDlwg?: FieldPolicy<any> | FieldReadFunction<any>,
	avgEstimatedWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	avgRecordedWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	batches?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitId?: FieldPolicy<any> | FieldReadFunction<any>,
	colour?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldArea?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldDensity?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldSize?: FieldPolicy<any> | FieldReadFunction<any>,
	groupsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	isHoldingPen?: FieldPolicy<any> | FieldReadFunction<any>,
	isOrganic?: FieldPolicy<any> | FieldReadFunction<any>,
	isYard?: FieldPolicy<any> | FieldReadFunction<any>,
	itemtransactionSet?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	pastureTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	sizeUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	summaryMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	tasksCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FieldImageKeySpecifier = ('createdAt' | 'field' | 'id' | 'image' | FieldImageKeySpecifier)[];
export type FieldImageFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FilterObjectTypeKeySpecifier = ('displayName' | 'filterName' | 'filterType' | FilterObjectTypeKeySpecifier)[];
export type FilterObjectTypeFieldPolicy = {
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	filterName?: FieldPolicy<any> | FieldReadFunction<any>,
	filterType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FinancialTransactionKeySpecifier = ('amount' | 'animalsCount' | 'counterparty' | 'createdAt' | 'date' | 'id' | 'label' | 'notes' | 'recordType' | 'totalWeight' | 'transactionAnimals' | 'updatedAt' | 'valueAllocationMethod' | FinancialTransactionKeySpecifier)[];
export type FinancialTransactionFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	counterparty?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	recordType?: FieldPolicy<any> | FieldReadFunction<any>,
	totalWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	valueAllocationMethod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FinancialTransactionAnimalKeySpecifier = ('allocatedValue' | 'animal' | 'weightLastUpdated' | 'weightValue' | FinancialTransactionAnimalKeySpecifier)[];
export type FinancialTransactionAnimalFieldPolicy = {
	allocatedValue?: FieldPolicy<any> | FieldReadFunction<any>,
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	weightLastUpdated?: FieldPolicy<any> | FieldReadFunction<any>,
	weightValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FinancialTransactionAnimalConnectionKeySpecifier = ('edges' | 'pageInfo' | FinancialTransactionAnimalConnectionKeySpecifier)[];
export type FinancialTransactionAnimalConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FinancialTransactionAnimalEdgeKeySpecifier = ('cursor' | 'node' | FinancialTransactionAnimalEdgeKeySpecifier)[];
export type FinancialTransactionAnimalEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FinancialTransactionAnimalErrorObjectTypeKeySpecifier = ('animal' | 'errors' | FinancialTransactionAnimalErrorObjectTypeKeySpecifier)[];
export type FinancialTransactionAnimalErrorObjectTypeFieldPolicy = {
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FinancialTransactionConnectionKeySpecifier = ('count' | 'edges' | 'pageInfo' | FinancialTransactionConnectionKeySpecifier)[];
export type FinancialTransactionConnectionFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FinancialTransactionEdgeKeySpecifier = ('cursor' | 'node' | FinancialTransactionEdgeKeySpecifier)[];
export type FinancialTransactionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FormTypeKeySpecifier = ('choices' | 'editable' | 'id' | 'label' | 'labelId' | 'maxDigits' | 'maxValue' | 'minValue' | 'name' | 'required' | 'type' | FormTypeKeySpecifier)[];
export type FormTypeFieldPolicy = {
	choices?: FieldPolicy<any> | FieldReadFunction<any>,
	editable?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	labelId?: FieldPolicy<any> | FieldReadFunction<any>,
	maxDigits?: FieldPolicy<any> | FieldReadFunction<any>,
	maxValue?: FieldPolicy<any> | FieldReadFunction<any>,
	minValue?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	required?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ForwardContractKeySpecifier = ('businessUnit' | 'createdAt' | 'createdBy' | 'details' | 'id' | 'offer' | 'status' | 'updatedAt' | 'want' | ForwardContractKeySpecifier)[];
export type ForwardContractFieldPolicy = {
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	details?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	offer?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	want?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GeometryObjectTypeKeySpecifier = ('coordinates' | 'type' | GeometryObjectTypeKeySpecifier)[];
export type GeometryObjectTypeFieldPolicy = {
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GlobalFoggleTypeKeySpecifier = ('description' | 'featureName' | 'globalState' | GlobalFoggleTypeKeySpecifier)[];
export type GlobalFoggleTypeFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	featureName?: FieldPolicy<any> | FieldReadFunction<any>,
	globalState?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupKeySpecifier = ('ageMaxMonths' | 'ageMinMonths' | 'animalAlerts' | 'animalAlertsCount' | 'animalBreeds' | 'animalType' | 'animalTypeId' | 'animals' | 'animalsNumberCache' | 'animalsOffFarmCount' | 'animalsToSaleCount' | 'averageAge' | 'averageDobInBatch' | 'avgDlwg' | 'avgEstimatedWeight' | 'avgRecordedWeight' | 'batchDateOnFarm' | 'businessUnit' | 'businessUnitId' | 'businessUnitTarget' | 'businessUnitTargetId' | 'category' | 'createdAt' | 'currentWeightInfo' | 'daysTillTarget' | 'description' | 'field' | 'gendersInBatch' | 'growthRate' | 'hasNotifications' | 'id' | 'identifiedAnimalsCount' | 'images' | 'isBatch' | 'isDeleted' | 'isPurchased' | 'itemtransactionSet' | 'lot' | 'maxAge' | 'maxDaysOnFarm' | 'minAge' | 'minDaysOnFarm' | 'name' | 'notifications' | 'numberOfUnidentifiedAnimalsInBatch' | 'summaryMetrics' | 'targetDate' | 'targetWeight' | 'tasks' | 'tasksCnt' | 'timeOnFarm' | 'unreadNotificationsCount' | 'updatedAt' | 'weightInfo' | GroupKeySpecifier)[];
export type GroupFieldPolicy = {
	ageMaxMonths?: FieldPolicy<any> | FieldReadFunction<any>,
	ageMinMonths?: FieldPolicy<any> | FieldReadFunction<any>,
	animalAlerts?: FieldPolicy<any> | FieldReadFunction<any>,
	animalAlertsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	animalBreeds?: FieldPolicy<any> | FieldReadFunction<any>,
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	animalTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsNumberCache?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsOffFarmCount?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsToSaleCount?: FieldPolicy<any> | FieldReadFunction<any>,
	averageAge?: FieldPolicy<any> | FieldReadFunction<any>,
	averageDobInBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	avgDlwg?: FieldPolicy<any> | FieldReadFunction<any>,
	avgEstimatedWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	avgRecordedWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	batchDateOnFarm?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitId?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitTargetId?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currentWeightInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	daysTillTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	gendersInBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	growthRate?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNotifications?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	identifiedAnimalsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	isBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	isPurchased?: FieldPolicy<any> | FieldReadFunction<any>,
	itemtransactionSet?: FieldPolicy<any> | FieldReadFunction<any>,
	lot?: FieldPolicy<any> | FieldReadFunction<any>,
	maxAge?: FieldPolicy<any> | FieldReadFunction<any>,
	maxDaysOnFarm?: FieldPolicy<any> | FieldReadFunction<any>,
	minAge?: FieldPolicy<any> | FieldReadFunction<any>,
	minDaysOnFarm?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfUnidentifiedAnimalsInBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	summaryMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	targetDate?: FieldPolicy<any> | FieldReadFunction<any>,
	targetWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	tasksCnt?: FieldPolicy<any> | FieldReadFunction<any>,
	timeOnFarm?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadNotificationsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	weightInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupCategoryObjectTypeKeySpecifier = ('name' | 'slug' | GroupCategoryObjectTypeKeySpecifier)[];
export type GroupCategoryObjectTypeFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupChartDataKeySpecifier = ('age' | 'growth' | 'sales' | GroupChartDataKeySpecifier)[];
export type GroupChartDataFieldPolicy = {
	age?: FieldPolicy<any> | FieldReadFunction<any>,
	growth?: FieldPolicy<any> | FieldReadFunction<any>,
	sales?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupExtendedListKeySpecifier = ('groups' | 'groupsCount' | GroupExtendedListKeySpecifier)[];
export type GroupExtendedListFieldPolicy = {
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	groupsCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupImageKeySpecifier = ('createdAt' | 'group' | 'id' | 'image' | GroupImageKeySpecifier)[];
export type GroupImageFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupReportTypeKeySpecifier = ('id' | 'position' | 'reportSet' | 'title' | GroupReportTypeKeySpecifier)[];
export type GroupReportTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	reportSet?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupWeightInfoKeySpecifier = ('avgWeight' | 'maxWeight' | 'minWeight' | GroupWeightInfoKeySpecifier)[];
export type GroupWeightInfoFieldPolicy = {
	avgWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	maxWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	minWeight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HerdDoggIntegrationObjectTypeKeySpecifier = ('createdAt' | 'expiresAt' | 'isConnected' | 'user' | HerdDoggIntegrationObjectTypeKeySpecifier)[];
export type HerdDoggIntegrationObjectTypeFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	isConnected?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HowDidYouHearAboutBreedrChoicesKeySpecifier = ('choice' | 'id' | 'slug' | HowDidYouHearAboutBreedrChoicesKeySpecifier)[];
export type HowDidYouHearAboutBreedrChoicesFieldPolicy = {
	choice?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImportCsvPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'taskId' | 'uploadTaskId' | ImportCsvPayloadKeySpecifier)[];
export type ImportCsvPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	taskId?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadTaskId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImportResultKeySpecifier = ('animals' | 'businessUnitId' | 'createdGroupsCount' | 'errorRows' | 'errors' | 'failedActivitiesUrl' | 'failedAnimalsUrl' | 'importedActivitiesCount' | 'importedAnimalIds' | 'importedAnimalsCount' | 'isDone' | 'processedRows' | 'rejectedRowsUrl' | 'results' | 'rowErrors' | 'totalRows' | 'updatedAnimals' | ImportResultKeySpecifier)[];
export type ImportResultFieldPolicy = {
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdGroupsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	errorRows?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	failedActivitiesUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	failedAnimalsUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	importedActivitiesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	importedAnimalIds?: FieldPolicy<any> | FieldReadFunction<any>,
	importedAnimalsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	isDone?: FieldPolicy<any> | FieldReadFunction<any>,
	processedRows?: FieldPolicy<any> | FieldReadFunction<any>,
	rejectedRowsUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>,
	rowErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRows?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAnimals?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImportResultErrorKeySpecifier = ('errors' | 'rowIndex' | ImportResultErrorKeySpecifier)[];
export type ImportResultErrorFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	rowIndex?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImportResultRowKeySpecifier = ('errors' | 'rowIndex' | ImportResultRowKeySpecifier)[];
export type ImportResultRowFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	rowIndex?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImportResultRowConnectionKeySpecifier = ('edges' | 'pageInfo' | ImportResultRowConnectionKeySpecifier)[];
export type ImportResultRowConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImportResultRowEdgeKeySpecifier = ('cursor' | 'node' | ImportResultRowEdgeKeySpecifier)[];
export type ImportResultRowEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IntegrationSystemTypeKeySpecifier = ('fields' | 'helpLink' | 'id' | 'isAutomatedSystem' | 'logo' | 'name' | 'slug' | 'systemType' | 'website' | IntegrationSystemTypeKeySpecifier)[];
export type IntegrationSystemTypeFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	helpLink?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isAutomatedSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	logo?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	systemType?: FieldPolicy<any> | FieldReadFunction<any>,
	website?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IntercomCarouselKeySpecifier = ('carouselId' | 'description' | 'id' | 'key' | IntercomCarouselKeySpecifier)[];
export type IntercomCarouselFieldPolicy = {
	carouselId?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InventoryInfoTypeKeySpecifier = ('activeIngredients' | 'batchNumber' | 'id' | 'name' | 'stockItemId' | 'totalOriginalVolume' | 'totalRemainingVolume' | 'volumeUnits' | 'withdrawalNotes' | 'withdrawalPeriodDays' | 'withdrawalPeriodDaysCattleDairy' | 'withdrawalPeriodDaysCattleMeat' | 'withdrawalPeriodDaysPigs' | 'withdrawalPeriodDaysSheep' | InventoryInfoTypeKeySpecifier)[];
export type InventoryInfoTypeFieldPolicy = {
	activeIngredients?: FieldPolicy<any> | FieldReadFunction<any>,
	batchNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	stockItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	totalOriginalVolume?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRemainingVolume?: FieldPolicy<any> | FieldReadFunction<any>,
	volumeUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalPeriodDays?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalPeriodDaysCattleDairy?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalPeriodDaysCattleMeat?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalPeriodDaysPigs?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalPeriodDaysSheep?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InviteUserPayloadKeySpecifier = ('businessUnitUser' | 'clientMutationId' | 'errors' | InviteUserPayloadKeySpecifier)[];
export type InviteUserPayloadFieldPolicy = {
	businessUnitUser?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceKeySpecifier = ('acceptPayByInvoice' | 'businessUnit' | 'createdAt' | 'createdBy' | 'createdFor' | 'currency' | 'details' | 'finalPrice' | 'id' | 'invoiceNumber' | 'offer' | 'paymentMethod' | 'price' | 'priceUnit' | 'shippingDetails' | 'status' | 'totalPrice' | 'updatedAt' | InvoiceKeySpecifier)[];
export type InvoiceFieldPolicy = {
	acceptPayByInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdFor?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	details?: FieldPolicy<any> | FieldReadFunction<any>,
	finalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	offer?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	priceUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemTransactionConnectionKeySpecifier = ('edges' | 'pageInfo' | ItemTransactionConnectionKeySpecifier)[];
export type ItemTransactionConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemTransactionEdgeKeySpecifier = ('cursor' | 'node' | ItemTransactionEdgeKeySpecifier)[];
export type ItemTransactionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemTransactionTypeKeySpecifier = ('activity' | 'batchNumber' | 'cost' | 'date' | 'expiryDate' | 'id' | 'longDescription' | 'medicineName' | 'quantity' | 'quantityUnits' | 'reason' | 'shortDescription' | 'sku' | 'supplierName' | 'totalAmount' | 'transactionType' | 'valueDescription' | 'volumeUnits' | ItemTransactionTypeKeySpecifier)[];
export type ItemTransactionTypeFieldPolicy = {
	activity?: FieldPolicy<any> | FieldReadFunction<any>,
	batchNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	expiryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	longDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	medicineName?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	shortDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierName?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionType?: FieldPolicy<any> | FieldReadFunction<any>,
	valueDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	volumeUnits?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabelNumberObjectTypeKeySpecifier = ('x' | 'y' | LabelNumberObjectTypeKeySpecifier)[];
export type LabelNumberObjectTypeFieldPolicy = {
	x?: FieldPolicy<any> | FieldReadFunction<any>,
	y?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeaveGroupPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | LeaveGroupPayloadKeySpecifier)[];
export type LeaveGroupPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LineItemTypeKeySpecifier = ('batchNumber' | 'bottleNumber' | 'businessUnit' | 'cost' | 'createdAt' | 'expiryDate' | 'id' | 'itemtransactionSet' | 'name' | 'notes' | 'originalQuantity' | 'originalVolume' | 'purchaseDate' | 'quantity' | 'quantityUnits' | 'sku' | 'skuSource' | 'stockItem' | 'supplierName' | 'totalVolume' | 'updatedAt' | 'volumeUnits' | LineItemTypeKeySpecifier)[];
export type LineItemTypeFieldPolicy = {
	batchNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	bottleNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	expiryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	itemtransactionSet?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	originalQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	originalVolume?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseDate?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>,
	skuSource?: FieldPolicy<any> | FieldReadFunction<any>,
	stockItem?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierName?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVolume?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	volumeUnits?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinkHerdDoggAccountPayloadKeySpecifier = ('clientMutationId' | 'success' | LinkHerdDoggAccountPayloadKeySpecifier)[];
export type LinkHerdDoggAccountPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LitterSizeObjectTypeKeySpecifier = ('name' | 'slug' | LitterSizeObjectTypeKeySpecifier)[];
export type LitterSizeObjectTypeFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LiveAnimalSalePayloadKeySpecifier = ('animals' | 'clientMutationId' | 'errors' | 'success' | LiveAnimalSalePayloadKeySpecifier)[];
export type LiveAnimalSalePayloadFieldPolicy = {
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LiveSessionKeySpecifier = ('animalErrors' | 'animalType' | 'animals' | 'businessUnit' | 'createdAt' | 'createdOnDeviceAt' | 'id' | 'name' | 'sessionAnimals' | 'sessionErrors' | 'sessionOwner' | 'sessionStatus' | 'updatedAt' | LiveSessionKeySpecifier)[];
export type LiveSessionFieldPolicy = {
	animalErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdOnDeviceAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LiveSessionAnimalErrorKeySpecifier = ('animal' | 'animalIdentifier' | 'code' | 'createdAt' | 'id' | 'isDeleted' | 'liveSession' | 'message' | 'updatedAt' | LiveSessionAnimalErrorKeySpecifier)[];
export type LiveSessionAnimalErrorFieldPolicy = {
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	animalIdentifier?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	liveSession?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LiveSessionConnectionKeySpecifier = ('edges' | 'pageInfo' | LiveSessionConnectionKeySpecifier)[];
export type LiveSessionConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LiveSessionEdgeKeySpecifier = ('cursor' | 'node' | LiveSessionEdgeKeySpecifier)[];
export type LiveSessionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LiveSessionErrorKeySpecifier = ('code' | 'createdAt' | 'id' | 'isDeleted' | 'liveSession' | 'message' | LiveSessionErrorKeySpecifier)[];
export type LiveSessionErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	liveSession?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LoadCrushAppSessionPayloadKeySpecifier = ('animalType' | 'clientMutationId' | 'crushAppSession' | 'errors' | LoadCrushAppSessionPayloadKeySpecifier)[];
export type LoadCrushAppSessionPayloadFieldPolicy = {
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	crushAppSession?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocationSearchBusinessUnitKeySpecifier = ('city' | 'unitName' | LocationSearchBusinessUnitKeySpecifier)[];
export type LocationSearchBusinessUnitFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	unitName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LogActivityBulkPayloadKeySpecifier = ('animals' | 'clientMutationId' | 'errors' | 'success' | LogActivityBulkPayloadKeySpecifier)[];
export type LogActivityBulkPayloadFieldPolicy = {
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LogBirthIntoBatchPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | LogBirthIntoBatchPayloadKeySpecifier)[];
export type LogBirthIntoBatchPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LogStillBirthPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | LogStillBirthPayloadKeySpecifier)[];
export type LogStillBirthPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LotKeySpecifier = ('actualCloseDate' | 'actualSellPrice' | 'animalsAverageAge' | 'animalsAverageCurrentWeight' | 'animalsAverageGrowthRate' | 'animalsAverageTimesWeighed' | 'animalsCount' | 'animalsCountBreedAndGender' | 'animalsMaxNumberMoves' | 'animalsNumberSires' | 'animalsNumberWithdrawals' | 'breeds' | 'businessUnit' | 'businessUnitId' | 'categoryOfSale' | 'currency' | 'currencyId' | 'declaredAnimalsCount' | 'deliveredAnimals' | 'deliveryAddress' | 'description' | 'expiresAt' | 'gradingFile' | 'id' | 'images' | 'imagesThumb' | 'isBreedrGuaranteed' | 'isExpired' | 'isPublic' | 'isTbFree' | 'name' | 'offersPendingCount' | 'plannedCloseDate' | 'preMovementTestDate' | 'price' | 'pricePerItem' | 'pricePerKgOnCreation' | 'priceUnit' | 'publicLink' | 'referenceCode' | 'shareType' | 'startDate' | 'status' | 'tbRequirements' | 'totalPrice' | 'tradingType' | 'tradingTypeId' | 'unreadNotificationsCount' | LotKeySpecifier)[];
export type LotFieldPolicy = {
	actualCloseDate?: FieldPolicy<any> | FieldReadFunction<any>,
	actualSellPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsAverageAge?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsAverageCurrentWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsAverageGrowthRate?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsAverageTimesWeighed?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsCountBreedAndGender?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsMaxNumberMoves?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsNumberSires?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsNumberWithdrawals?: FieldPolicy<any> | FieldReadFunction<any>,
	breeds?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitId?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryOfSale?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyId?: FieldPolicy<any> | FieldReadFunction<any>,
	declaredAnimalsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveredAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	gradingFile?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	imagesThumb?: FieldPolicy<any> | FieldReadFunction<any>,
	isBreedrGuaranteed?: FieldPolicy<any> | FieldReadFunction<any>,
	isExpired?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	isTbFree?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	offersPendingCount?: FieldPolicy<any> | FieldReadFunction<any>,
	plannedCloseDate?: FieldPolicy<any> | FieldReadFunction<any>,
	preMovementTestDate?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	pricePerItem?: FieldPolicy<any> | FieldReadFunction<any>,
	pricePerKgOnCreation?: FieldPolicy<any> | FieldReadFunction<any>,
	priceUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	publicLink?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceCode?: FieldPolicy<any> | FieldReadFunction<any>,
	shareType?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	tbRequirements?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingType?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadNotificationsCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LotBuyerReceivedAnimalsPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'lot' | LotBuyerReceivedAnimalsPayloadKeySpecifier)[];
export type LotBuyerReceivedAnimalsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	lot?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LotImageKeySpecifier = ('id' | 'lot' | 'photo' | 'position' | 'thumbnailMedium' | 'thumbnailSmall' | LotImageKeySpecifier)[];
export type LotImageFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lot?: FieldPolicy<any> | FieldReadFunction<any>,
	photo?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailMedium?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailSmall?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LotImageThumbnailTypeKeySpecifier = ('imageAspectRatio512x512' | 'imageAspectRatio1024x1024' | 'imageSquare32x32' | 'imageSquare64x64' | 'imageSquare96x96' | 'imageSquare128x128' | LotImageThumbnailTypeKeySpecifier)[];
export type LotImageThumbnailTypeFieldPolicy = {
	imageAspectRatio512x512?: FieldPolicy<any> | FieldReadFunction<any>,
	imageAspectRatio1024x1024?: FieldPolicy<any> | FieldReadFunction<any>,
	imageSquare32x32?: FieldPolicy<any> | FieldReadFunction<any>,
	imageSquare64x64?: FieldPolicy<any> | FieldReadFunction<any>,
	imageSquare96x96?: FieldPolicy<any> | FieldReadFunction<any>,
	imageSquare128x128?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LotInfoKeySpecifier = ('expiresAt' | 'id' | 'isExpired' | 'status' | LotInfoKeySpecifier)[];
export type LotInfoFieldPolicy = {
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isExpired?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LotSellerSentAnimalsPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'lot' | LotSellerSentAnimalsPayloadKeySpecifier)[];
export type LotSellerSentAnimalsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	lot?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MarkAnimalsAsDeadPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | MarkAnimalsAsDeadPayloadKeySpecifier)[];
export type MarkAnimalsAsDeadPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MarkAsDoneAnimalsAlertsPayloadKeySpecifier = ('animalAlerts' | 'clientMutationId' | 'errors' | MarkAsDoneAnimalsAlertsPayloadKeySpecifier)[];
export type MarkAsDoneAnimalsAlertsPayloadFieldPolicy = {
	animalAlerts?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MarkAsPaidLotOfferPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'offer' | MarkAsPaidLotOfferPayloadKeySpecifier)[];
export type MarkAsPaidLotOfferPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	offer?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MarkReadMessagePayloadKeySpecifier = ('clientMutationId' | 'messages' | MarkReadMessagePayloadKeySpecifier)[];
export type MarkReadMessagePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	messages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MarkReadNotificationsPayloadKeySpecifier = ('clientMutationId' | 'notifications' | MarkReadNotificationsPayloadKeySpecifier)[];
export type MarkReadNotificationsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MeasuredWeightEventTypeKeySpecifier = ('id' | 'rawUnit' | 'rawValue' | 'recordedAt' | MeasuredWeightEventTypeKeySpecifier)[];
export type MeasuredWeightEventTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	rawUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	rawValue?: FieldPolicy<any> | FieldReadFunction<any>,
	recordedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MeasurementChartDataKeySpecifier = ('age' | 'avg' | 'dailyLiveWeightGain' | 'daysToTarget' | 'daysToTargetWeight' | 'diffTargetDailyLiveWeightGain' | 'high' | 'low' | 'onTargetWeight' | 'targetDailyLiveWeightGain' | 'timestamp' | 'value' | MeasurementChartDataKeySpecifier)[];
export type MeasurementChartDataFieldPolicy = {
	age?: FieldPolicy<any> | FieldReadFunction<any>,
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	dailyLiveWeightGain?: FieldPolicy<any> | FieldReadFunction<any>,
	daysToTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	daysToTargetWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	diffTargetDailyLiveWeightGain?: FieldPolicy<any> | FieldReadFunction<any>,
	high?: FieldPolicy<any> | FieldReadFunction<any>,
	low?: FieldPolicy<any> | FieldReadFunction<any>,
	onTargetWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	targetDailyLiveWeightGain?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MedicineActiveIngredientTypeKeySpecifier = ('ingredient' | 'noahId' | MedicineActiveIngredientTypeKeySpecifier)[];
export type MedicineActiveIngredientTypeFieldPolicy = {
	ingredient?: FieldPolicy<any> | FieldReadFunction<any>,
	noahId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MedicineApplicationMethodTypeKeySpecifier = ('applicationMethod' | MedicineApplicationMethodTypeKeySpecifier)[];
export type MedicineApplicationMethodTypeFieldPolicy = {
	applicationMethod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MedicineCourseObjectTypeKeySpecifier = ('businessUnit' | 'id' | 'name' | 'reason' | 'stages' | MedicineCourseObjectTypeKeySpecifier)[];
export type MedicineCourseObjectTypeFieldPolicy = {
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	stages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MedicineCourseStageObjectTypeKeySpecifier = ('amount' | 'daysAfter' | 'id' | 'units' | MedicineCourseStageObjectTypeKeySpecifier)[];
export type MedicineCourseStageObjectTypeFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	daysAfter?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	units?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MedicineGTINTypeKeySpecifier = ('description' | 'doNotSync' | 'gtinNumber' | 'id' | 'quantity' | 'quantityUnits' | 'volume' | 'volumeUnits' | MedicineGTINTypeKeySpecifier)[];
export type MedicineGTINTypeFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	doNotSync?: FieldPolicy<any> | FieldReadFunction<any>,
	gtinNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	volume?: FieldPolicy<any> | FieldReadFunction<any>,
	volumeUnits?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MedicineTypeKeySpecifier = ('activeIngredient' | 'applicableAnimalTypes' | 'applicationMethod' | 'barcode' | 'commonName' | 'description' | 'gtin' | 'id' | 'isDisabled' | 'manName' | 'manufacturer' | 'medicineActiveIngredients' | 'medicinewithdrawalSet' | 'noahId' | MedicineTypeKeySpecifier)[];
export type MedicineTypeFieldPolicy = {
	activeIngredient?: FieldPolicy<any> | FieldReadFunction<any>,
	applicableAnimalTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	applicationMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	barcode?: FieldPolicy<any> | FieldReadFunction<any>,
	commonName?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	gtin?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDisabled?: FieldPolicy<any> | FieldReadFunction<any>,
	manName?: FieldPolicy<any> | FieldReadFunction<any>,
	manufacturer?: FieldPolicy<any> | FieldReadFunction<any>,
	medicineActiveIngredients?: FieldPolicy<any> | FieldReadFunction<any>,
	medicinewithdrawalSet?: FieldPolicy<any> | FieldReadFunction<any>,
	noahId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MedicineWithdrawalTypeKeySpecifier = ('animalType' | 'id' | 'medicine' | 'notes' | 'useWithdrawalPeriod' | 'withdrawalPeriodDays' | 'withdrawalType' | MedicineWithdrawalTypeKeySpecifier)[];
export type MedicineWithdrawalTypeFieldPolicy = {
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	medicine?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	useWithdrawalPeriod?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalPeriodDays?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MergeAnimalTagsPayloadKeySpecifier = ('animals' | 'clientMutationId' | 'errors' | MergeAnimalTagsPayloadKeySpecifier)[];
export type MergeAnimalTagsPayloadFieldPolicy = {
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MergeGroupsToGroupPayloadKeySpecifier = ('animals' | 'clientMutationId' | 'errors' | 'groups' | 'success' | MergeGroupsToGroupPayloadKeySpecifier)[];
export type MergeGroupsToGroupPayloadFieldPolicy = {
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MessageKeySpecifier = ('addressee' | 'attachment' | 'body' | 'createdAt' | 'id' | 'isRead' | 'metaData' | 'readBy' | 'referenceId' | 'relatedToSlug' | 'sender' | 'title' | 'type' | 'updatedAt' | MessageKeySpecifier)[];
export type MessageFieldPolicy = {
	addressee?: FieldPolicy<any> | FieldReadFunction<any>,
	attachment?: FieldPolicy<any> | FieldReadFunction<any>,
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isRead?: FieldPolicy<any> | FieldReadFunction<any>,
	metaData?: FieldPolicy<any> | FieldReadFunction<any>,
	readBy?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceId?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedToSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	sender?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MessageConnectionKeySpecifier = ('edges' | 'pageInfo' | 'unreadTotalCount' | MessageConnectionKeySpecifier)[];
export type MessageConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadTotalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MessageEdgeKeySpecifier = ('cursor' | 'node' | MessageEdgeKeySpecifier)[];
export type MessageEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MoveAnimalsToFieldPayloadKeySpecifier = ('animals' | 'clientMutationId' | 'errors' | 'fields' | 'groups' | 'success' | MoveAnimalsToFieldPayloadKeySpecifier)[];
export type MoveAnimalsToFieldPayloadFieldPolicy = {
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MoveAnimalsToGroupPayloadKeySpecifier = ('activities' | 'animals' | 'clientMutationId' | 'errors' | 'groups' | 'success' | MoveAnimalsToGroupPayloadKeySpecifier)[];
export type MoveAnimalsToGroupPayloadFieldPolicy = {
	activities?: FieldPolicy<any> | FieldReadFunction<any>,
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MoveGroupsToFieldPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'fields' | 'groups' | 'success' | MoveGroupsToFieldPayloadKeySpecifier)[];
export type MoveGroupsToFieldPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MovementLocationTypeKeySpecifier = ('regulatoryId' | MovementLocationTypeKeySpecifier)[];
export type MovementLocationTypeFieldPolicy = {
	regulatoryId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('acceptDelivery' | 'acceptInvitation' | 'addAnimalsMedicineCourse' | 'addAnimalsToFinancialTransaction' | 'addDeliveryAddress' | 'addMedicineCourse' | 'addMedicineCourseStage' | 'addMedicineLineItem' | 'addRegularWithdrawal' | 'administerAnimalsMedicineCourseStage' | 'animalsExportAsync' | 'aphisImportCsv' | 'approveEmail' | 'attachDeliveryAffidavit' | 'bcmsImportCsv' | 'bcmsServiceRequestGeneratePdf' | 'birthAnimal' | 'cancelFarmSystemTask' | 'checkCommitDelivery' | 'checkField' | 'closeLot' | 'commitDelivery' | 'commitDeliveryAsync' | 'compatMoveAnimalsOffFarm' | 'completeInvite' | 'convertBatch' | 'createAnimal' | 'createAnimalFilter' | 'createAnimalsAlerts' | 'createBankAccount' | 'createBankDetails' | 'createBatch' | 'createBusinessUnitAccreditation' | 'createBusinessUnitTarget' | 'createContact' | 'createDelivery' | 'createDistributionList' | 'createDownload' | 'createFarmSystem' | 'createField' | 'createFinancialTransaction' | 'createGroup' | 'createLiveSession' | 'createLot' | 'createOfferForLot' | 'createPreferredBuyers' | 'createPreferredSuppliers' | 'createProducerGroup' | 'createSire' | 'createStripeCheckoutSession' | 'createStripePortalSession' | 'createTag' | 'createUpdateInProgressCrushAppSession' | 'createWeight' | 'debug' | 'deleteActivityBulk' | 'deleteAnimalFilter' | 'deleteAnimalsMedicineCourse' | 'deleteBankAccount' | 'deleteBankDetails' | 'deleteBusinessUnitAccreditation' | 'deleteBusinessUnitTarget' | 'deleteCrushAppSession' | 'deleteDelivery' | 'deleteDeliveryAddress' | 'deleteDeliveryAnimals' | 'deleteDiscountGrid' | 'deleteDistributionList' | 'deleteFarmSystem' | 'deleteField' | 'deleteFieldImage' | 'deleteFinancialTransaction' | 'deleteGroup' | 'deleteGroupImage' | 'deleteGroupWithAnimals' | 'deleteLiveSession' | 'deleteMedicineCourse' | 'deleteMedicineCourseStage' | 'deletePost' | 'deleteRegularWithdrawal' | 'deleteSire' | 'deleteTag' | 'deleteUserFromFarm' | 'deleteWeight' | 'deliverAnimalOut' | 'deliverAnimalsOut' | 'deliverExistingAnimal' | 'deliverExistingAnimals' | 'deliverNewAnimal' | 'deliverPulledAnimal' | 'diagnosePregnancy' | 'disposeMedicineLineItem' | 'editBankAccount' | 'editDeliveryAddress' | 'editProducerGroup' | 'editRegularWithdrawal' | 'exportAnimalsAsync' | 'farmAnimalDetail' | 'farmPlanImportXls' | 'favoriteActivityTemplate' | 'importCsv' | 'inviteUser' | 'leaveGroup' | 'linkHerdDoggAccount' | 'liveAnimalSale' | 'loadCrushAppSession' | 'logActivityBulk' | 'logBirthIntoBatch' | 'logStillBirth' | 'lotBuyerReceivedAnimals' | 'lotSellerSentAnimals' | 'markAnimalsAsDead' | 'markAsDoneAnimalsAlerts' | 'markAsPaidLotOffer' | 'markReadMessage' | 'markReadNotifications' | 'mergeAnimalTags' | 'mergeGroupsToGroup' | 'moveAnimalsToField' | 'moveAnimalsToGroup' | 'moveGroupsToField' | 'offerMarkAsRead' | 'onboardAnimal' | 'postToGroup' | 'reInviteUser' | 'registerDeviceId' | 'regulatoryTransactionApprovalsAbort' | 'regulatoryTransactionApprovalsChangeDate' | 'regulatoryTransactionApprovalsResponse' | 'regulatoryTransactionApprovalsRetry' | 'rejectDelivery' | 'removeAnimalsFromFinancialTransaction' | 'responseToLotOffer' | 'restoreAnimals' | 'retrieveChannel' | 'saveCrushAppSession' | 'saveCrushAppSessionEnhanced' | 'sendApprove' | 'sendCode' | 'sendCompleteBcmsSetupEmail' | 'sendMessage' | 'sendResetPasswordEmail' | 'setFavourite' | 'signUp' | 'signUpUser' | 'snoozeAnimalsAlerts' | 'softDeleteAnimals' | 'splitField' | 'startFarmSystemTask' | 'termsAndConditionsAccept' | 'transferOwnership' | 'truTestImportXls' | 'undoDelivery' | 'unlinkHerdDoggAccount' | 'unregisterDeviceId' | 'unsetFavourite' | 'updateAnimal' | 'updateAnimalFilter' | 'updateBankDetails' | 'updateBatch' | 'updateBusinessUnitAccreditation' | 'updateBusinessUnitSettings' | 'updateBusinessUnitTarget' | 'updateBusinessUnitUser' | 'updateContact' | 'updateDelivery' | 'updateDistributionList' | 'updateEmail' | 'updateFarmSystem' | 'updateField' | 'updateFinancialTransaction' | 'updateGroup' | 'updateIdentifierPreferences' | 'updateLiveSession' | 'updateLot' | 'updateMedicineCourse' | 'updateMedicineCourseStage' | 'updateMobileClientState' | 'updateNotificationSettings' | 'updateOrganisation' | 'updatePartnerDelivery' | 'updatePassword' | 'updatePost' | 'updatePreferredBusinessUnit' | 'updatePreferredBusinessUnitStatus' | 'updatePreviousKeeper' | 'updateSire' | 'updateTag' | 'updateUserInfo' | 'uploadCsv' | 'uploadDiscountGrid' | 'uploadFileSource' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	acceptDelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	acceptInvitation?: FieldPolicy<any> | FieldReadFunction<any>,
	addAnimalsMedicineCourse?: FieldPolicy<any> | FieldReadFunction<any>,
	addAnimalsToFinancialTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	addDeliveryAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	addMedicineCourse?: FieldPolicy<any> | FieldReadFunction<any>,
	addMedicineCourseStage?: FieldPolicy<any> | FieldReadFunction<any>,
	addMedicineLineItem?: FieldPolicy<any> | FieldReadFunction<any>,
	addRegularWithdrawal?: FieldPolicy<any> | FieldReadFunction<any>,
	administerAnimalsMedicineCourseStage?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsExportAsync?: FieldPolicy<any> | FieldReadFunction<any>,
	aphisImportCsv?: FieldPolicy<any> | FieldReadFunction<any>,
	approveEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	attachDeliveryAffidavit?: FieldPolicy<any> | FieldReadFunction<any>,
	bcmsImportCsv?: FieldPolicy<any> | FieldReadFunction<any>,
	bcmsServiceRequestGeneratePdf?: FieldPolicy<any> | FieldReadFunction<any>,
	birthAnimal?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelFarmSystemTask?: FieldPolicy<any> | FieldReadFunction<any>,
	checkCommitDelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	checkField?: FieldPolicy<any> | FieldReadFunction<any>,
	closeLot?: FieldPolicy<any> | FieldReadFunction<any>,
	commitDelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	commitDeliveryAsync?: FieldPolicy<any> | FieldReadFunction<any>,
	compatMoveAnimalsOffFarm?: FieldPolicy<any> | FieldReadFunction<any>,
	completeInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	convertBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	createAnimal?: FieldPolicy<any> | FieldReadFunction<any>,
	createAnimalFilter?: FieldPolicy<any> | FieldReadFunction<any>,
	createAnimalsAlerts?: FieldPolicy<any> | FieldReadFunction<any>,
	createBankAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	createBankDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	createBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	createBusinessUnitAccreditation?: FieldPolicy<any> | FieldReadFunction<any>,
	createBusinessUnitTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	createContact?: FieldPolicy<any> | FieldReadFunction<any>,
	createDelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	createDistributionList?: FieldPolicy<any> | FieldReadFunction<any>,
	createDownload?: FieldPolicy<any> | FieldReadFunction<any>,
	createFarmSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	createField?: FieldPolicy<any> | FieldReadFunction<any>,
	createFinancialTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	createGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	createLiveSession?: FieldPolicy<any> | FieldReadFunction<any>,
	createLot?: FieldPolicy<any> | FieldReadFunction<any>,
	createOfferForLot?: FieldPolicy<any> | FieldReadFunction<any>,
	createPreferredBuyers?: FieldPolicy<any> | FieldReadFunction<any>,
	createPreferredSuppliers?: FieldPolicy<any> | FieldReadFunction<any>,
	createProducerGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	createSire?: FieldPolicy<any> | FieldReadFunction<any>,
	createStripeCheckoutSession?: FieldPolicy<any> | FieldReadFunction<any>,
	createStripePortalSession?: FieldPolicy<any> | FieldReadFunction<any>,
	createTag?: FieldPolicy<any> | FieldReadFunction<any>,
	createUpdateInProgressCrushAppSession?: FieldPolicy<any> | FieldReadFunction<any>,
	createWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	debug?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteActivityBulk?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAnimalFilter?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAnimalsMedicineCourse?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBankAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBankDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBusinessUnitAccreditation?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBusinessUnitTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCrushAppSession?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDeliveryAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDeliveryAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDiscountGrid?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDistributionList?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteFarmSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteField?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteFieldImage?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteFinancialTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteGroupImage?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteGroupWithAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLiveSession?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMedicineCourse?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMedicineCourseStage?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePost?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteRegularWithdrawal?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSire?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTag?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUserFromFarm?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	deliverAnimalOut?: FieldPolicy<any> | FieldReadFunction<any>,
	deliverAnimalsOut?: FieldPolicy<any> | FieldReadFunction<any>,
	deliverExistingAnimal?: FieldPolicy<any> | FieldReadFunction<any>,
	deliverExistingAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	deliverNewAnimal?: FieldPolicy<any> | FieldReadFunction<any>,
	deliverPulledAnimal?: FieldPolicy<any> | FieldReadFunction<any>,
	diagnosePregnancy?: FieldPolicy<any> | FieldReadFunction<any>,
	disposeMedicineLineItem?: FieldPolicy<any> | FieldReadFunction<any>,
	editBankAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	editDeliveryAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	editProducerGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	editRegularWithdrawal?: FieldPolicy<any> | FieldReadFunction<any>,
	exportAnimalsAsync?: FieldPolicy<any> | FieldReadFunction<any>,
	farmAnimalDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	farmPlanImportXls?: FieldPolicy<any> | FieldReadFunction<any>,
	favoriteActivityTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	importCsv?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteUser?: FieldPolicy<any> | FieldReadFunction<any>,
	leaveGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	linkHerdDoggAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	liveAnimalSale?: FieldPolicy<any> | FieldReadFunction<any>,
	loadCrushAppSession?: FieldPolicy<any> | FieldReadFunction<any>,
	logActivityBulk?: FieldPolicy<any> | FieldReadFunction<any>,
	logBirthIntoBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	logStillBirth?: FieldPolicy<any> | FieldReadFunction<any>,
	lotBuyerReceivedAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	lotSellerSentAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	markAnimalsAsDead?: FieldPolicy<any> | FieldReadFunction<any>,
	markAsDoneAnimalsAlerts?: FieldPolicy<any> | FieldReadFunction<any>,
	markAsPaidLotOffer?: FieldPolicy<any> | FieldReadFunction<any>,
	markReadMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	markReadNotifications?: FieldPolicy<any> | FieldReadFunction<any>,
	mergeAnimalTags?: FieldPolicy<any> | FieldReadFunction<any>,
	mergeGroupsToGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	moveAnimalsToField?: FieldPolicy<any> | FieldReadFunction<any>,
	moveAnimalsToGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	moveGroupsToField?: FieldPolicy<any> | FieldReadFunction<any>,
	offerMarkAsRead?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardAnimal?: FieldPolicy<any> | FieldReadFunction<any>,
	postToGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	reInviteUser?: FieldPolicy<any> | FieldReadFunction<any>,
	registerDeviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryTransactionApprovalsAbort?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryTransactionApprovalsChangeDate?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryTransactionApprovalsResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryTransactionApprovalsRetry?: FieldPolicy<any> | FieldReadFunction<any>,
	rejectDelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	removeAnimalsFromFinancialTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	responseToLotOffer?: FieldPolicy<any> | FieldReadFunction<any>,
	restoreAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	retrieveChannel?: FieldPolicy<any> | FieldReadFunction<any>,
	saveCrushAppSession?: FieldPolicy<any> | FieldReadFunction<any>,
	saveCrushAppSessionEnhanced?: FieldPolicy<any> | FieldReadFunction<any>,
	sendApprove?: FieldPolicy<any> | FieldReadFunction<any>,
	sendCode?: FieldPolicy<any> | FieldReadFunction<any>,
	sendCompleteBcmsSetupEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	sendResetPasswordEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	setFavourite?: FieldPolicy<any> | FieldReadFunction<any>,
	signUp?: FieldPolicy<any> | FieldReadFunction<any>,
	signUpUser?: FieldPolicy<any> | FieldReadFunction<any>,
	snoozeAnimalsAlerts?: FieldPolicy<any> | FieldReadFunction<any>,
	softDeleteAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	splitField?: FieldPolicy<any> | FieldReadFunction<any>,
	startFarmSystemTask?: FieldPolicy<any> | FieldReadFunction<any>,
	termsAndConditionsAccept?: FieldPolicy<any> | FieldReadFunction<any>,
	transferOwnership?: FieldPolicy<any> | FieldReadFunction<any>,
	truTestImportXls?: FieldPolicy<any> | FieldReadFunction<any>,
	undoDelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	unlinkHerdDoggAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	unregisterDeviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	unsetFavourite?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAnimal?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAnimalFilter?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBankDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBatch?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBusinessUnitAccreditation?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBusinessUnitSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBusinessUnitTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBusinessUnitUser?: FieldPolicy<any> | FieldReadFunction<any>,
	updateContact?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDistributionList?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFarmSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateField?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFinancialTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	updateGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	updateIdentifierPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLiveSession?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLot?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMedicineCourse?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMedicineCourseStage?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMobileClientState?: FieldPolicy<any> | FieldReadFunction<any>,
	updateNotificationSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	updateOrganisation?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePartnerDelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePassword?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePost?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePreferredBusinessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePreferredBusinessUnitStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePreviousKeeper?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSire?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTag?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUserInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadCsv?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadDiscountGrid?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadFileSource?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NeogenEPDKeySpecifier = ('animal' | 'averageDailyGainAcc' | 'averageDailyGainEpd' | 'averageDailyGainPct' | 'birthWeightAcc' | 'birthWeightEpd' | 'birthWeightPct' | 'fatAcc' | 'fatEpd' | 'fatPct' | 'fx' | 'hotCarcassWeightAcc' | 'hotCarcassWeightEpd' | 'hotCarcassWeightPct' | 'marblingAcc' | 'marblingEpd' | 'marblingPct' | 'milkAcc' | 'milkEpd' | 'milkPct' | 'residualFeedIntakeAcc' | 'residualFeedIntakeEpd' | 'residualFeedIntakePct' | 'ribeyeAreaAcc' | 'ribeyeAreaEpd' | 'ribeyeAreaPct' | 'totalIndex' | 'weaningWeightAcc' | 'weaningWeightEpd' | 'weaningWeightPct' | NeogenEPDKeySpecifier)[];
export type NeogenEPDFieldPolicy = {
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	averageDailyGainAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	averageDailyGainEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	averageDailyGainPct?: FieldPolicy<any> | FieldReadFunction<any>,
	birthWeightAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	birthWeightEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	birthWeightPct?: FieldPolicy<any> | FieldReadFunction<any>,
	fatAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	fatEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	fatPct?: FieldPolicy<any> | FieldReadFunction<any>,
	fx?: FieldPolicy<any> | FieldReadFunction<any>,
	hotCarcassWeightAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	hotCarcassWeightEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	hotCarcassWeightPct?: FieldPolicy<any> | FieldReadFunction<any>,
	marblingAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	marblingEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	marblingPct?: FieldPolicy<any> | FieldReadFunction<any>,
	milkAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	milkEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	milkPct?: FieldPolicy<any> | FieldReadFunction<any>,
	residualFeedIntakeAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	residualFeedIntakeEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	residualFeedIntakePct?: FieldPolicy<any> | FieldReadFunction<any>,
	ribeyeAreaAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	ribeyeAreaEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	ribeyeAreaPct?: FieldPolicy<any> | FieldReadFunction<any>,
	totalIndex?: FieldPolicy<any> | FieldReadFunction<any>,
	weaningWeightAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	weaningWeightEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	weaningWeightPct?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NewsletterEmailSettingsKeySpecifier = ('frequency' | 'isEmail' | 'isMarketing' | NewsletterEmailSettingsKeySpecifier)[];
export type NewsletterEmailSettingsFieldPolicy = {
	frequency?: FieldPolicy<any> | FieldReadFunction<any>,
	isEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	isMarketing?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationKeySpecifier = ('addressee' | 'attachment' | 'body' | 'context' | 'createdAt' | 'id' | 'isRead' | 'metaData' | 'readBy' | 'referenceId' | 'relatedToSlug' | 'title' | 'toSpecificUser' | 'type' | 'updatedAt' | NotificationKeySpecifier)[];
export type NotificationFieldPolicy = {
	addressee?: FieldPolicy<any> | FieldReadFunction<any>,
	attachment?: FieldPolicy<any> | FieldReadFunction<any>,
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	context?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isRead?: FieldPolicy<any> | FieldReadFunction<any>,
	metaData?: FieldPolicy<any> | FieldReadFunction<any>,
	readBy?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceId?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedToSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	toSpecificUser?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationConnectionKeySpecifier = ('edges' | 'pageInfo' | 'unreadAnimalsCount' | 'unreadCount' | 'unreadFavouriteCount' | 'unreadFieldsCount' | 'unreadGroupsCount' | 'unreadIds' | 'unreadLotsCount' | 'unreadMyAnimalsCount' | 'unreadMyTradingCount' | 'unreadPurchasesCount' | 'unreadWantsCount' | NotificationConnectionKeySpecifier)[];
export type NotificationConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadAnimalsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadCount?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadFavouriteCount?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadFieldsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadGroupsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadIds?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadLotsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadMyAnimalsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadMyTradingCount?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadPurchasesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadWantsCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationEdgeKeySpecifier = ('cursor' | 'node' | NotificationEdgeKeySpecifier)[];
export type NotificationEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationSettingItemKeySpecifier = ('isEmail' | 'isSiteNotification' | 'notificationTypes' | NotificationSettingItemKeySpecifier)[];
export type NotificationSettingItemFieldPolicy = {
	isEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	isSiteNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationTypes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationSettingItemTypeKeySpecifier = ('description' | 'enabled' | 'name' | 'slug' | NotificationSettingItemTypeKeySpecifier)[];
export type NotificationSettingItemTypeFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationSettingsKeySpecifier = ('animalActivity' | 'dailyDigest' | 'id' | 'integrations' | 'isMarketingEmails' | 'isNewsEmails' | 'isProductEmails' | 'isResearchEmails' | 'isSystemEmails' | 'newsletter' | 'systemNotificationSettings' | 'trading' | 'user' | NotificationSettingsKeySpecifier)[];
export type NotificationSettingsFieldPolicy = {
	animalActivity?: FieldPolicy<any> | FieldReadFunction<any>,
	dailyDigest?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	integrations?: FieldPolicy<any> | FieldReadFunction<any>,
	isMarketingEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	isNewsEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	isProductEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	isResearchEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	isSystemEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	newsletter?: FieldPolicy<any> | FieldReadFunction<any>,
	systemNotificationSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	trading?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationTypeItemKeySpecifier = ('category' | 'slug' | 'title' | NotificationTypeItemKeySpecifier)[];
export type NotificationTypeItemFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OfferKeySpecifier = ('actualStatus' | 'businessUnit' | 'collectionDate' | 'comment' | 'createdAt' | 'createdBy' | 'currency' | 'forwardcontractSet' | 'hasAcceptedListing' | 'hasFeedback' | 'id' | 'invoice' | 'invoiceId' | 'invoiceStatus' | 'lot' | 'lotBasedOnWant' | 'lotId' | 'lotStatus' | 'notifications' | 'offeredNumber' | 'price' | 'priceUnit' | 'producedLot' | 'producedLotInterface' | 'purchaseOfferId' | 'purchaseOfferStatus' | 'readBy' | 'responseDate' | 'status' | 'totalPriceOnCreation' | 'totalRevenue' | 'unreadNotificationsCount' | 'updatedAt' | 'want' | OfferKeySpecifier)[];
export type OfferFieldPolicy = {
	actualStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionDate?: FieldPolicy<any> | FieldReadFunction<any>,
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	forwardcontractSet?: FieldPolicy<any> | FieldReadFunction<any>,
	hasAcceptedListing?: FieldPolicy<any> | FieldReadFunction<any>,
	hasFeedback?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invoice?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceId?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	lot?: FieldPolicy<any> | FieldReadFunction<any>,
	lotBasedOnWant?: FieldPolicy<any> | FieldReadFunction<any>,
	lotId?: FieldPolicy<any> | FieldReadFunction<any>,
	lotStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	offeredNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	priceUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	producedLot?: FieldPolicy<any> | FieldReadFunction<any>,
	producedLotInterface?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseOfferId?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseOfferStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	readBy?: FieldPolicy<any> | FieldReadFunction<any>,
	responseDate?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPriceOnCreation?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRevenue?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadNotificationsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	want?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OfferConnectionKeySpecifier = ('edges' | 'offersCount' | 'offersUnreadCount' | 'pageInfo' | OfferConnectionKeySpecifier)[];
export type OfferConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	offersCount?: FieldPolicy<any> | FieldReadFunction<any>,
	offersUnreadCount?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OfferEdgeKeySpecifier = ('cursor' | 'node' | OfferEdgeKeySpecifier)[];
export type OfferEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OfferMarkAsReadPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | OfferMarkAsReadPayloadKeySpecifier)[];
export type OfferMarkAsReadPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OnboardAnimalPayloadKeySpecifier = ('animal' | 'clientMutationId' | 'errors' | 'success' | OnboardAnimalPayloadKeySpecifier)[];
export type OnboardAnimalPayloadFieldPolicy = {
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OptionChoiceKeySpecifier = ('label' | 'value' | OptionChoiceKeySpecifier)[];
export type OptionChoiceFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganisationKeySpecifier = ('businessType' | 'businessUnits' | 'country' | 'currency' | 'id' | 'members' | 'name' | 'numberOfFarms' | 'owner' | OrganisationKeySpecifier)[];
export type OrganisationFieldPolicy = {
	businessType?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	members?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfFarms?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganisationBusinessUnitsKeySpecifier = ('businessUnits' | 'organisation' | OrganisationBusinessUnitsKeySpecifier)[];
export type OrganisationBusinessUnitsFieldPolicy = {
	businessUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	organisation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganisationMemberKeySpecifier = ('id' | 'organisation' | 'user' | OrganisationMemberKeySpecifier)[];
export type OrganisationMemberFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	organisation?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OwnLotKeySpecifier = ('acceptedOffer' | 'accreditations' | 'actualCloseDate' | 'actualSellPrice' | 'advertDetails' | 'animalType' | 'animals' | 'animalsAverageAge' | 'animalsAverageCurrentWeight' | 'animalsAverageGrowthRate' | 'animalsAverageTimesWeighed' | 'animalsCount' | 'animalsCountBreedAndGender' | 'animalsMaxNumberMoves' | 'animalsNumberSires' | 'animalsNumberWithdrawals' | 'assignedAnimals' | 'breedingStatus' | 'breeds' | 'businessUnit' | 'businessUnitId' | 'canRespondToOffer' | 'categoryOfSale' | 'createdAt' | 'createdBy' | 'currency' | 'currencyId' | 'declaredAnimalsCount' | 'deliveredAnimals' | 'deliveryAddress' | 'description' | 'distributionLists' | 'expiresAt' | 'fromOffer' | 'fromWant' | 'gradingFile' | 'id' | 'images' | 'imagesThumb' | 'isAcceptOffers' | 'isAuction' | 'isBreedrGuaranteed' | 'isBvdFree' | 'isCarcass' | 'isExpired' | 'isPublic' | 'isTbFree' | 'isWetChecked' | 'lotConfigurableSellerMessage' | 'lotOffers' | 'metaData' | 'name' | 'offers' | 'offersPendingCount' | 'pedigreeStatus' | 'plannedCloseDate' | 'preMovementTestDate' | 'price' | 'pricePerItem' | 'pricePerKgOnCreation' | 'priceUnit' | 'producedByOffer' | 'publicLink' | 'referenceCode' | 'shareToGroups' | 'shareType' | 'sharedTo' | 'shippingDetails' | 'startDate' | 'status' | 'tbRequirements' | 'totalPrice' | 'tradingType' | 'tradingTypeId' | 'unreadNotificationsCount' | 'updatedAt' | OwnLotKeySpecifier)[];
export type OwnLotFieldPolicy = {
	acceptedOffer?: FieldPolicy<any> | FieldReadFunction<any>,
	accreditations?: FieldPolicy<any> | FieldReadFunction<any>,
	actualCloseDate?: FieldPolicy<any> | FieldReadFunction<any>,
	actualSellPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	advertDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsAverageAge?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsAverageCurrentWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsAverageGrowthRate?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsAverageTimesWeighed?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsCountBreedAndGender?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsMaxNumberMoves?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsNumberSires?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsNumberWithdrawals?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	breedingStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	breeds?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitId?: FieldPolicy<any> | FieldReadFunction<any>,
	canRespondToOffer?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryOfSale?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyId?: FieldPolicy<any> | FieldReadFunction<any>,
	declaredAnimalsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveredAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	distributionLists?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	fromOffer?: FieldPolicy<any> | FieldReadFunction<any>,
	fromWant?: FieldPolicy<any> | FieldReadFunction<any>,
	gradingFile?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	imagesThumb?: FieldPolicy<any> | FieldReadFunction<any>,
	isAcceptOffers?: FieldPolicy<any> | FieldReadFunction<any>,
	isAuction?: FieldPolicy<any> | FieldReadFunction<any>,
	isBreedrGuaranteed?: FieldPolicy<any> | FieldReadFunction<any>,
	isBvdFree?: FieldPolicy<any> | FieldReadFunction<any>,
	isCarcass?: FieldPolicy<any> | FieldReadFunction<any>,
	isExpired?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	isTbFree?: FieldPolicy<any> | FieldReadFunction<any>,
	isWetChecked?: FieldPolicy<any> | FieldReadFunction<any>,
	lotConfigurableSellerMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	lotOffers?: FieldPolicy<any> | FieldReadFunction<any>,
	metaData?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	offers?: FieldPolicy<any> | FieldReadFunction<any>,
	offersPendingCount?: FieldPolicy<any> | FieldReadFunction<any>,
	pedigreeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	plannedCloseDate?: FieldPolicy<any> | FieldReadFunction<any>,
	preMovementTestDate?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	pricePerItem?: FieldPolicy<any> | FieldReadFunction<any>,
	pricePerKgOnCreation?: FieldPolicy<any> | FieldReadFunction<any>,
	priceUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	producedByOffer?: FieldPolicy<any> | FieldReadFunction<any>,
	publicLink?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceCode?: FieldPolicy<any> | FieldReadFunction<any>,
	shareToGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	shareType?: FieldPolicy<any> | FieldReadFunction<any>,
	sharedTo?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	tbRequirements?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingType?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadNotificationsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OwnLotConnectionKeySpecifier = ('edges' | 'pageInfo' | OwnLotConnectionKeySpecifier)[];
export type OwnLotConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OwnLotEdgeKeySpecifier = ('cursor' | 'node' | OwnLotEdgeKeySpecifier)[];
export type OwnLotEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OwnWantKeySpecifier = ('acceptedAnimalsCount' | 'acceptedNumber' | 'accreditations' | 'actualBuyPrice' | 'advertDetails' | 'animalType' | 'animalTypeId' | 'awaitingAcceptanceOffersCount' | 'awaitingGradingOffersCount' | 'awaitingPaymentOffersCount' | 'breedingStatus' | 'breeds' | 'businessUnit' | 'businessUnitId' | 'createdAt' | 'createdBy' | 'currency' | 'currencyId' | 'dateNeeded' | 'deliveredAnimalsCount' | 'description' | 'discountGrid' | 'distributionLists' | 'files' | 'forwardcontractSet' | 'hideRequestedNumber' | 'id' | 'isAcceptOffers' | 'isBvdFree' | 'isCarcass' | 'isForwardContractAllowed' | 'isPedigree' | 'isPublic' | 'isStandardDeductions' | 'isTbFree' | 'isWetChecked' | 'lastStatus' | 'location' | 'name' | 'offer' | 'offerDeadline' | 'offerId' | 'pedigreeStatus' | 'pendingAnimalsCount' | 'pendingOffersCount' | 'price' | 'priceDetails' | 'priceNotes' | 'priceUnit' | 'privateShareCount' | 'privateShareMaxDistance' | 'privateSharePostcode' | 'producedLots' | 'recurringDetails' | 'reference' | 'requestedNumber' | 'rflId' | 'shareToGroups' | 'shareType' | 'sharedTo' | 'shippingTerms' | 'status' | 'totalAmount' | 'tradingType' | 'tradingTypeId' | 'updatedAt' | 'usage' | 'wantOffers' | OwnWantKeySpecifier)[];
export type OwnWantFieldPolicy = {
	acceptedAnimalsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	acceptedNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	accreditations?: FieldPolicy<any> | FieldReadFunction<any>,
	actualBuyPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	advertDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	animalTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	awaitingAcceptanceOffersCount?: FieldPolicy<any> | FieldReadFunction<any>,
	awaitingGradingOffersCount?: FieldPolicy<any> | FieldReadFunction<any>,
	awaitingPaymentOffersCount?: FieldPolicy<any> | FieldReadFunction<any>,
	breedingStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	breeds?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyId?: FieldPolicy<any> | FieldReadFunction<any>,
	dateNeeded?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveredAnimalsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	discountGrid?: FieldPolicy<any> | FieldReadFunction<any>,
	distributionLists?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	forwardcontractSet?: FieldPolicy<any> | FieldReadFunction<any>,
	hideRequestedNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isAcceptOffers?: FieldPolicy<any> | FieldReadFunction<any>,
	isBvdFree?: FieldPolicy<any> | FieldReadFunction<any>,
	isCarcass?: FieldPolicy<any> | FieldReadFunction<any>,
	isForwardContractAllowed?: FieldPolicy<any> | FieldReadFunction<any>,
	isPedigree?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	isStandardDeductions?: FieldPolicy<any> | FieldReadFunction<any>,
	isTbFree?: FieldPolicy<any> | FieldReadFunction<any>,
	isWetChecked?: FieldPolicy<any> | FieldReadFunction<any>,
	lastStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	offer?: FieldPolicy<any> | FieldReadFunction<any>,
	offerDeadline?: FieldPolicy<any> | FieldReadFunction<any>,
	offerId?: FieldPolicy<any> | FieldReadFunction<any>,
	pedigreeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingAnimalsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingOffersCount?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	priceDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	priceNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	priceUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	privateShareCount?: FieldPolicy<any> | FieldReadFunction<any>,
	privateShareMaxDistance?: FieldPolicy<any> | FieldReadFunction<any>,
	privateSharePostcode?: FieldPolicy<any> | FieldReadFunction<any>,
	producedLots?: FieldPolicy<any> | FieldReadFunction<any>,
	recurringDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	reference?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	rflId?: FieldPolicy<any> | FieldReadFunction<any>,
	shareToGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	shareType?: FieldPolicy<any> | FieldReadFunction<any>,
	sharedTo?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingTerms?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingType?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>,
	wantOffers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | PageInfoKeySpecifier)[];
export type PageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageInfoObjectTypeKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | PageInfoObjectTypeKeySpecifier)[];
export type PageInfoObjectTypeFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PastureTypeKeySpecifier = ('id' | 'name' | PastureTypeKeySpecifier)[];
export type PastureTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentMethodKeySpecifier = ('businessUnit' | 'businessUnitId' | 'createdAt' | 'createdBy' | 'createdById' | 'extraData' | 'id' | 'isDefault' | 'provider' | 'token' | 'type' | 'updatedAt' | PaymentMethodKeySpecifier)[];
export type PaymentMethodFieldPolicy = {
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdById?: FieldPolicy<any> | FieldReadFunction<any>,
	extraData?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendoUserKeySpecifier = ('data' | PendoUserKeySpecifier)[];
export type PendoUserFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PerformanceChartDataKeySpecifier = ('avg' | 'contexts' | 'dates' | 'high' | 'low' | 'measurements' | 'predictions' | 'references' | 'targetWeights' | PerformanceChartDataKeySpecifier)[];
export type PerformanceChartDataFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	contexts?: FieldPolicy<any> | FieldReadFunction<any>,
	dates?: FieldPolicy<any> | FieldReadFunction<any>,
	high?: FieldPolicy<any> | FieldReadFunction<any>,
	low?: FieldPolicy<any> | FieldReadFunction<any>,
	measurements?: FieldPolicy<any> | FieldReadFunction<any>,
	predictions?: FieldPolicy<any> | FieldReadFunction<any>,
	references?: FieldPolicy<any> | FieldReadFunction<any>,
	targetWeights?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PieChartDataObjectTypeKeySpecifier = ('data' | 'title' | PieChartDataObjectTypeKeySpecifier)[];
export type PieChartDataObjectTypeFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PostToGroupPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'post' | PostToGroupPayloadKeySpecifier)[];
export type PostToGroupPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	post?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PostTypeKeySpecifier = ('attachment' | 'author' | 'body' | 'id' | 'producerGroup' | 'publish' | 'title' | 'updated' | PostTypeKeySpecifier)[];
export type PostTypeFieldPolicy = {
	attachment?: FieldPolicy<any> | FieldReadFunction<any>,
	author?: FieldPolicy<any> | FieldReadFunction<any>,
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	producerGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	publish?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PreferredBusinessUnitKeySpecifier = ('animalTypes' | 'buyer' | 'buyerId' | 'commonStatus' | 'createdAt' | 'createdBy' | 'createdByBusinessUnit' | 'createdById' | 'fieldsman' | 'id' | 'priceAdjustment' | 'status' | 'supplier' | 'supplierId' | 'tacDescription' | 'tacTitle' | 'termsAcceptedAt' | PreferredBusinessUnitKeySpecifier)[];
export type PreferredBusinessUnitFieldPolicy = {
	animalTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	buyer?: FieldPolicy<any> | FieldReadFunction<any>,
	buyerId?: FieldPolicy<any> | FieldReadFunction<any>,
	commonStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByBusinessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	createdById?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldsman?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	priceAdjustment?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	supplier?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierId?: FieldPolicy<any> | FieldReadFunction<any>,
	tacDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	tacTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	termsAcceptedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProcessedItemKeySpecifier = ('id' | ProcessedItemKeySpecifier)[];
export type ProcessedItemFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProducerGroupMemberTypeKeySpecifier = ('businessUnitUser' | 'firstName' | 'id' | 'isAdmin' | 'lastName' | 'profilePhoto' | 'status' | ProducerGroupMemberTypeKeySpecifier)[];
export type ProducerGroupMemberTypeFieldPolicy = {
	businessUnitUser?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProducerGroupTypeKeySpecifier = ('backgroundPhoto' | 'businessUnitUsers' | 'channelUrl' | 'createdBy' | 'description' | 'id' | 'isMyGroup' | 'memberTypeId' | 'members' | 'name' | 'owner' | 'profilePhoto' | 'status' | ProducerGroupTypeKeySpecifier)[];
export type ProducerGroupTypeFieldPolicy = {
	backgroundPhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	channelUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isMyGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	memberTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	members?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublicAnimalKeySpecifier = ('ageCategory' | 'animalBreeds' | 'animalColour' | 'animalType' | 'birthInformation' | 'breedPercentages' | 'breeding' | 'cphCount' | 'currentWeight' | 'damPassportNumber' | 'dateMovedToFarm' | 'daysToTargetWeight' | 'dob' | 'eId' | 'eIdCleaned' | 'estimatedAgeOn' | 'estimatedCarcassWeight' | 'estimatedWeightOn' | 'gender' | 'growthRate' | 'growthRateSinceConception' | 'growthRateSinceLastWeighLog' | 'id' | 'images' | 'isArchived' | 'isBcmsSynced' | 'isCastrated' | 'isMale' | 'isPregnant' | 'isRegulatorySynced' | 'isSoftDeleted' | 'lastRegulatorySyncedDate' | 'lastWeight' | 'location' | 'name' | 'ownerId' | 'passportNumber' | 'predicatedDateReady' | 'predictedDateReady' | 'predictedWeightAtDelivery' | 'pregnancyDueDate' | 'sexClassification' | 'sirePassportNumber' | 'softDeletedAt' | 'targetDailyLiveWeightGain' | 'targetLiveWeight' | 'visualId' | 'withdrawalEnd' | PublicAnimalKeySpecifier)[];
export type PublicAnimalFieldPolicy = {
	ageCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	animalBreeds?: FieldPolicy<any> | FieldReadFunction<any>,
	animalColour?: FieldPolicy<any> | FieldReadFunction<any>,
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	birthInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	breedPercentages?: FieldPolicy<any> | FieldReadFunction<any>,
	breeding?: FieldPolicy<any> | FieldReadFunction<any>,
	cphCount?: FieldPolicy<any> | FieldReadFunction<any>,
	currentWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	damPassportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	dateMovedToFarm?: FieldPolicy<any> | FieldReadFunction<any>,
	daysToTargetWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	dob?: FieldPolicy<any> | FieldReadFunction<any>,
	eId?: FieldPolicy<any> | FieldReadFunction<any>,
	eIdCleaned?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedAgeOn?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedCarcassWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedWeightOn?: FieldPolicy<any> | FieldReadFunction<any>,
	gender?: FieldPolicy<any> | FieldReadFunction<any>,
	growthRate?: FieldPolicy<any> | FieldReadFunction<any>,
	growthRateSinceConception?: FieldPolicy<any> | FieldReadFunction<any>,
	growthRateSinceLastWeighLog?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	isArchived?: FieldPolicy<any> | FieldReadFunction<any>,
	isBcmsSynced?: FieldPolicy<any> | FieldReadFunction<any>,
	isCastrated?: FieldPolicy<any> | FieldReadFunction<any>,
	isMale?: FieldPolicy<any> | FieldReadFunction<any>,
	isPregnant?: FieldPolicy<any> | FieldReadFunction<any>,
	isRegulatorySynced?: FieldPolicy<any> | FieldReadFunction<any>,
	isSoftDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	lastRegulatorySyncedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	lastWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerId?: FieldPolicy<any> | FieldReadFunction<any>,
	passportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	predicatedDateReady?: FieldPolicy<any> | FieldReadFunction<any>,
	predictedDateReady?: FieldPolicy<any> | FieldReadFunction<any>,
	predictedWeightAtDelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	pregnancyDueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	sexClassification?: FieldPolicy<any> | FieldReadFunction<any>,
	sirePassportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	softDeletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	targetDailyLiveWeightGain?: FieldPolicy<any> | FieldReadFunction<any>,
	targetLiveWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	visualId?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalEnd?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublicBirthInformationKeySpecifier = ('birthAbnormalities' | 'birthPresentation' | 'birthSize' | 'birthVigor' | 'birthWeight' | 'birthingDifficulty' | 'calfColour' | 'id' | 'isStillborn' | 'litterSize' | PublicBirthInformationKeySpecifier)[];
export type PublicBirthInformationFieldPolicy = {
	birthAbnormalities?: FieldPolicy<any> | FieldReadFunction<any>,
	birthPresentation?: FieldPolicy<any> | FieldReadFunction<any>,
	birthSize?: FieldPolicy<any> | FieldReadFunction<any>,
	birthVigor?: FieldPolicy<any> | FieldReadFunction<any>,
	birthWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	birthingDifficulty?: FieldPolicy<any> | FieldReadFunction<any>,
	calfColour?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isStillborn?: FieldPolicy<any> | FieldReadFunction<any>,
	litterSize?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublicBusinessUnitKeySpecifier = ('id' | 'name' | 'primaryLocation' | PublicBusinessUnitKeySpecifier)[];
export type PublicBusinessUnitFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryLocation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublicDeliveryAddressTypeKeySpecifier = ('city' | 'country' | 'id' | 'locationId' | 'postcode' | 'unitName' | PublicDeliveryAddressTypeKeySpecifier)[];
export type PublicDeliveryAddressTypeFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	postcode?: FieldPolicy<any> | FieldReadFunction<any>,
	unitName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublicLotKeySpecifier = ('actualCloseDate' | 'actualSellPrice' | 'animalType' | 'animals' | 'animalsAverageAge' | 'animalsAverageCurrentWeight' | 'animalsAverageGrowthRate' | 'animalsAverageTimesWeighed' | 'animalsCount' | 'animalsCountBreedAndGender' | 'animalsMaxNumberMoves' | 'animalsNumberSires' | 'animalsNumberWithdrawals' | 'breeds' | 'businessUnit' | 'businessUnitId' | 'categoryOfSale' | 'createdBy' | 'currency' | 'currencyId' | 'declaredAnimalsCount' | 'deliveredAnimals' | 'deliveryAddress' | 'description' | 'distance' | 'expiresAt' | 'gradingFile' | 'id' | 'images' | 'imagesThumb' | 'isAcceptedMyOffer' | 'isBreedrGuaranteed' | 'isExpired' | 'isPublic' | 'isTbFree' | 'name' | 'offers' | 'offersPendingCount' | 'plannedCloseDate' | 'preMovementTestDate' | 'price' | 'pricePerItem' | 'pricePerKgOnCreation' | 'priceUnit' | 'publicLink' | 'referenceCode' | 'shareType' | 'startDate' | 'status' | 'tbRequirements' | 'totalPrice' | 'tradingType' | 'tradingTypeId' | 'unreadNotificationsCount' | PublicLotKeySpecifier)[];
export type PublicLotFieldPolicy = {
	actualCloseDate?: FieldPolicy<any> | FieldReadFunction<any>,
	actualSellPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsAverageAge?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsAverageCurrentWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsAverageGrowthRate?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsAverageTimesWeighed?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsCountBreedAndGender?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsMaxNumberMoves?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsNumberSires?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsNumberWithdrawals?: FieldPolicy<any> | FieldReadFunction<any>,
	breeds?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitId?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryOfSale?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyId?: FieldPolicy<any> | FieldReadFunction<any>,
	declaredAnimalsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveredAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	gradingFile?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	imagesThumb?: FieldPolicy<any> | FieldReadFunction<any>,
	isAcceptedMyOffer?: FieldPolicy<any> | FieldReadFunction<any>,
	isBreedrGuaranteed?: FieldPolicy<any> | FieldReadFunction<any>,
	isExpired?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	isTbFree?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	offers?: FieldPolicy<any> | FieldReadFunction<any>,
	offersPendingCount?: FieldPolicy<any> | FieldReadFunction<any>,
	plannedCloseDate?: FieldPolicy<any> | FieldReadFunction<any>,
	preMovementTestDate?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	pricePerItem?: FieldPolicy<any> | FieldReadFunction<any>,
	pricePerKgOnCreation?: FieldPolicy<any> | FieldReadFunction<any>,
	priceUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	publicLink?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceCode?: FieldPolicy<any> | FieldReadFunction<any>,
	shareType?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	tbRequirements?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingType?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadNotificationsCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublicLotConnectionKeySpecifier = ('edges' | 'pageInfo' | PublicLotConnectionKeySpecifier)[];
export type PublicLotConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublicLotEdgeKeySpecifier = ('cursor' | 'node' | PublicLotEdgeKeySpecifier)[];
export type PublicLotEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublicWantKeySpecifier = ('acceptedNumber' | 'accreditations' | 'advertDetails' | 'animalType' | 'animalTypeId' | 'breedingStatus' | 'breeds' | 'businessUnit' | 'businessUnitId' | 'currency' | 'currencyId' | 'dateNeeded' | 'description' | 'discountGrid' | 'files' | 'id' | 'isAcceptOffers' | 'isBvdFree' | 'isCarcass' | 'isForwardContractAllowed' | 'isPedigree' | 'isPublic' | 'isStandardDeductions' | 'isTbFree' | 'lastStatus' | 'location' | 'name' | 'pedigreeStatus' | 'price' | 'priceDetails' | 'priceNotes' | 'priceUnit' | 'privateShareCount' | 'privateShareMaxDistance' | 'privateSharePostcode' | 'recurringDetails' | 'requestedNumber' | 'rflId' | 'shareType' | 'shippingTerms' | 'status' | 'totalAmount' | 'tradingType' | 'tradingTypeId' | 'usage' | PublicWantKeySpecifier)[];
export type PublicWantFieldPolicy = {
	acceptedNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	accreditations?: FieldPolicy<any> | FieldReadFunction<any>,
	advertDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	animalTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	breedingStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	breeds?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitId?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyId?: FieldPolicy<any> | FieldReadFunction<any>,
	dateNeeded?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	discountGrid?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isAcceptOffers?: FieldPolicy<any> | FieldReadFunction<any>,
	isBvdFree?: FieldPolicy<any> | FieldReadFunction<any>,
	isCarcass?: FieldPolicy<any> | FieldReadFunction<any>,
	isForwardContractAllowed?: FieldPolicy<any> | FieldReadFunction<any>,
	isPedigree?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	isStandardDeductions?: FieldPolicy<any> | FieldReadFunction<any>,
	isTbFree?: FieldPolicy<any> | FieldReadFunction<any>,
	lastStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	pedigreeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	priceDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	priceNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	priceUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	privateShareCount?: FieldPolicy<any> | FieldReadFunction<any>,
	privateShareMaxDistance?: FieldPolicy<any> | FieldReadFunction<any>,
	privateSharePostcode?: FieldPolicy<any> | FieldReadFunction<any>,
	recurringDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	rflId?: FieldPolicy<any> | FieldReadFunction<any>,
	shareType?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingTerms?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingType?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('abattoirEstablishments' | 'abattoirParts' | 'abattoirs' | 'accreditation' | 'activities' | 'activityTemplateField' | 'activityTemplateFieldUnits' | 'activityTemplates' | 'activityTypes' | 'alertTypes' | 'alerts' | 'americanAngusEpd' | 'ancestorTree' | 'animal' | 'animalAlerts' | 'animalBreeds' | 'animalConditions' | 'animalFilterAlerts' | 'animalFilters' | 'animalOffspring' | 'animalSnapshot' | 'animalTags' | 'animalTypes' | 'animalTypesPublic' | 'animals' | 'animalsCount' | 'animalsExtended' | 'animalsPage' | 'animalsPaginated' | 'bankDetails' | 'barChartData' | 'batchUploadFormat' | 'batchUploadFormats' | 'birthInformation' | 'blockchainAnimalDataByKillNumber' | 'blockchainAnimalDataByPassport' | 'breedrBankDetails' | 'breedseek' | 'businessTypes' | 'businessUnit' | 'businessUnitBreeds' | 'businessUnitInfo' | 'businessUnitStatistic' | 'businessUnitStatuses' | 'businessUnitTargets' | 'businessUnitUsers' | 'businessUnits' | 'buyingLot' | 'buyingLots' | 'calfColours' | 'calfulatorInputs' | 'categoriesOfSale' | 'chartData' | 'competentAuthorities' | 'contact' | 'contacts' | 'contacts2' | 'countBusinessUnits' | 'countries' | 'crushAppSession' | 'crushAppSessions' | 'currencies' | 'dashboard' | 'dashboards' | 'debug' | 'deliveries' | 'delivery' | 'deliveryAddresses' | 'deliveryPartnerAddresses' | 'deliveryPartners' | 'deliveryReasons' | 'deliveryTask' | 'discountGrids' | 'distributionList' | 'distributionLists' | 'download' | 'downloads' | 'emptyState' | 'estimatedFuturePriceBasedOnWeight' | 'exportResult' | 'farmDetailChoices' | 'farmMovements' | 'farmSystemTask' | 'farmSystems' | 'favourites' | 'field' | 'fields' | 'financialTransaction' | 'financialTransactions' | 'getInvoiceLink' | 'getRegularWithdrawals' | 'getWithdrawTransactionHistory' | 'globalFoggle' | 'group' | 'groupCategories' | 'groupChartData' | 'groups' | 'groupsExtended' | 'hasUnsyncedAnimals' | 'howDidYouHearAboutBreedrChoices' | 'importResult' | 'integrationSystems' | 'intercomCarousels' | 'inventoryInfo' | 'invoice' | 'isCphUnique' | 'itemTransactions' | 'lineItem' | 'lineItems' | 'litterSizes' | 'liveSessions' | 'mainReport' | 'medicine' | 'medicines' | 'messages' | 'myAccountBalance' | 'myBankAccounts' | 'myLot' | 'myLots' | 'myWant' | 'myWants' | 'neogenEpd' | 'notificationSettings' | 'notificationTypes' | 'notifications' | 'offers' | 'organisationBusinessUnits' | 'organisations' | 'pastureTypes' | 'pendoUser' | 'performanceChartData' | 'pieChartData' | 'posts' | 'preferredBusinessUnit' | 'preferredBusinessUnits' | 'producerGroup' | 'producerGroups' | 'publicLot' | 'publicLots' | 'quicksightEmbedUrl' | 'quicksightReport' | 'regions' | 'regulatoryApprovals' | 'regulatoryTransactionApprovalSummary' | 'regulatoryTransactionApprovals' | 'regulatoryTransactionApprovalsWithWarning' | 'regulatoryTransactionWarnings' | 'reportEmbedUrl' | 'reports' | 'roles' | 'searchBusinessUnits' | 'searchUser' | 'sendBirdUser' | 'settingsFaq' | 'sexClassifications' | 'sire' | 'sires' | 'sisenseEmbedUrl' | 'smokeTest' | 'stockItem' | 'stockItems' | 'stocktakeAnimals' | 'subscriptionCatalog' | 'subscriptionInvoices' | 'subscriptionStatus' | 'supplyChainPages' | 'tableData' | 'targetWeightType' | 'termsAndConditions' | 'tradingTypes' | 'userExists' | 'userInfo' | 'videoGroups' | 'wantTemplates' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	abattoirEstablishments?: FieldPolicy<any> | FieldReadFunction<any>,
	abattoirParts?: FieldPolicy<any> | FieldReadFunction<any>,
	abattoirs?: FieldPolicy<any> | FieldReadFunction<any>,
	accreditation?: FieldPolicy<any> | FieldReadFunction<any>,
	activities?: FieldPolicy<any> | FieldReadFunction<any>,
	activityTemplateField?: FieldPolicy<any> | FieldReadFunction<any>,
	activityTemplateFieldUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	activityTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	activityTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	alertTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	alerts?: FieldPolicy<any> | FieldReadFunction<any>,
	americanAngusEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	ancestorTree?: FieldPolicy<any> | FieldReadFunction<any>,
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	animalAlerts?: FieldPolicy<any> | FieldReadFunction<any>,
	animalBreeds?: FieldPolicy<any> | FieldReadFunction<any>,
	animalConditions?: FieldPolicy<any> | FieldReadFunction<any>,
	animalFilterAlerts?: FieldPolicy<any> | FieldReadFunction<any>,
	animalFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	animalOffspring?: FieldPolicy<any> | FieldReadFunction<any>,
	animalSnapshot?: FieldPolicy<any> | FieldReadFunction<any>,
	animalTags?: FieldPolicy<any> | FieldReadFunction<any>,
	animalTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	animalTypesPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsExtended?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsPage?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsPaginated?: FieldPolicy<any> | FieldReadFunction<any>,
	bankDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	barChartData?: FieldPolicy<any> | FieldReadFunction<any>,
	batchUploadFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	batchUploadFormats?: FieldPolicy<any> | FieldReadFunction<any>,
	birthInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	blockchainAnimalDataByKillNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	blockchainAnimalDataByPassport?: FieldPolicy<any> | FieldReadFunction<any>,
	breedrBankDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	breedseek?: FieldPolicy<any> | FieldReadFunction<any>,
	businessTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitBreeds?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitStatistic?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitStatuses?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitTargets?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	buyingLot?: FieldPolicy<any> | FieldReadFunction<any>,
	buyingLots?: FieldPolicy<any> | FieldReadFunction<any>,
	calfColours?: FieldPolicy<any> | FieldReadFunction<any>,
	calfulatorInputs?: FieldPolicy<any> | FieldReadFunction<any>,
	categoriesOfSale?: FieldPolicy<any> | FieldReadFunction<any>,
	chartData?: FieldPolicy<any> | FieldReadFunction<any>,
	competentAuthorities?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	contacts2?: FieldPolicy<any> | FieldReadFunction<any>,
	countBusinessUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	crushAppSession?: FieldPolicy<any> | FieldReadFunction<any>,
	crushAppSessions?: FieldPolicy<any> | FieldReadFunction<any>,
	currencies?: FieldPolicy<any> | FieldReadFunction<any>,
	dashboard?: FieldPolicy<any> | FieldReadFunction<any>,
	dashboards?: FieldPolicy<any> | FieldReadFunction<any>,
	debug?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveries?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryAddresses?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryPartnerAddresses?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryPartners?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryReasons?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryTask?: FieldPolicy<any> | FieldReadFunction<any>,
	discountGrids?: FieldPolicy<any> | FieldReadFunction<any>,
	distributionList?: FieldPolicy<any> | FieldReadFunction<any>,
	distributionLists?: FieldPolicy<any> | FieldReadFunction<any>,
	download?: FieldPolicy<any> | FieldReadFunction<any>,
	downloads?: FieldPolicy<any> | FieldReadFunction<any>,
	emptyState?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedFuturePriceBasedOnWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	exportResult?: FieldPolicy<any> | FieldReadFunction<any>,
	farmDetailChoices?: FieldPolicy<any> | FieldReadFunction<any>,
	farmMovements?: FieldPolicy<any> | FieldReadFunction<any>,
	farmSystemTask?: FieldPolicy<any> | FieldReadFunction<any>,
	farmSystems?: FieldPolicy<any> | FieldReadFunction<any>,
	favourites?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	financialTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	financialTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	getInvoiceLink?: FieldPolicy<any> | FieldReadFunction<any>,
	getRegularWithdrawals?: FieldPolicy<any> | FieldReadFunction<any>,
	getWithdrawTransactionHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	globalFoggle?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>,
	groupCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	groupChartData?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	groupsExtended?: FieldPolicy<any> | FieldReadFunction<any>,
	hasUnsyncedAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	howDidYouHearAboutBreedrChoices?: FieldPolicy<any> | FieldReadFunction<any>,
	importResult?: FieldPolicy<any> | FieldReadFunction<any>,
	integrationSystems?: FieldPolicy<any> | FieldReadFunction<any>,
	intercomCarousels?: FieldPolicy<any> | FieldReadFunction<any>,
	inventoryInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	invoice?: FieldPolicy<any> | FieldReadFunction<any>,
	isCphUnique?: FieldPolicy<any> | FieldReadFunction<any>,
	itemTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	lineItem?: FieldPolicy<any> | FieldReadFunction<any>,
	lineItems?: FieldPolicy<any> | FieldReadFunction<any>,
	litterSizes?: FieldPolicy<any> | FieldReadFunction<any>,
	liveSessions?: FieldPolicy<any> | FieldReadFunction<any>,
	mainReport?: FieldPolicy<any> | FieldReadFunction<any>,
	medicine?: FieldPolicy<any> | FieldReadFunction<any>,
	medicines?: FieldPolicy<any> | FieldReadFunction<any>,
	messages?: FieldPolicy<any> | FieldReadFunction<any>,
	myAccountBalance?: FieldPolicy<any> | FieldReadFunction<any>,
	myBankAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	myLot?: FieldPolicy<any> | FieldReadFunction<any>,
	myLots?: FieldPolicy<any> | FieldReadFunction<any>,
	myWant?: FieldPolicy<any> | FieldReadFunction<any>,
	myWants?: FieldPolicy<any> | FieldReadFunction<any>,
	neogenEpd?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	offers?: FieldPolicy<any> | FieldReadFunction<any>,
	organisationBusinessUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	organisations?: FieldPolicy<any> | FieldReadFunction<any>,
	pastureTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	pendoUser?: FieldPolicy<any> | FieldReadFunction<any>,
	performanceChartData?: FieldPolicy<any> | FieldReadFunction<any>,
	pieChartData?: FieldPolicy<any> | FieldReadFunction<any>,
	posts?: FieldPolicy<any> | FieldReadFunction<any>,
	preferredBusinessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	preferredBusinessUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	producerGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	producerGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	publicLot?: FieldPolicy<any> | FieldReadFunction<any>,
	publicLots?: FieldPolicy<any> | FieldReadFunction<any>,
	quicksightEmbedUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	quicksightReport?: FieldPolicy<any> | FieldReadFunction<any>,
	regions?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryApprovals?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryTransactionApprovalSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryTransactionApprovals?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryTransactionApprovalsWithWarning?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryTransactionWarnings?: FieldPolicy<any> | FieldReadFunction<any>,
	reportEmbedUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	reports?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>,
	searchBusinessUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	searchUser?: FieldPolicy<any> | FieldReadFunction<any>,
	sendBirdUser?: FieldPolicy<any> | FieldReadFunction<any>,
	settingsFaq?: FieldPolicy<any> | FieldReadFunction<any>,
	sexClassifications?: FieldPolicy<any> | FieldReadFunction<any>,
	sire?: FieldPolicy<any> | FieldReadFunction<any>,
	sires?: FieldPolicy<any> | FieldReadFunction<any>,
	sisenseEmbedUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	smokeTest?: FieldPolicy<any> | FieldReadFunction<any>,
	stockItem?: FieldPolicy<any> | FieldReadFunction<any>,
	stockItems?: FieldPolicy<any> | FieldReadFunction<any>,
	stocktakeAnimals?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionCatalog?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionInvoices?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	supplyChainPages?: FieldPolicy<any> | FieldReadFunction<any>,
	tableData?: FieldPolicy<any> | FieldReadFunction<any>,
	targetWeightType?: FieldPolicy<any> | FieldReadFunction<any>,
	termsAndConditions?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	userExists?: FieldPolicy<any> | FieldReadFunction<any>,
	userInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	videoGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	wantTemplates?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuicksightParameterKeySpecifier = ('code' | 'value' | QuicksightParameterKeySpecifier)[];
export type QuicksightParameterFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuicksightReportTypeKeySpecifier = ('embedUrl' | 'parameters' | QuicksightReportTypeKeySpecifier)[];
export type QuicksightReportTypeFieldPolicy = {
	embedUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	parameters?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReInviteUserPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | ReInviteUserPayloadKeySpecifier)[];
export type ReInviteUserPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReferenceChartDataKeySpecifier = ('context' | 'label' | 'rfl' | 'timestamp' | 'value' | ReferenceChartDataKeySpecifier)[];
export type ReferenceChartDataFieldPolicy = {
	context?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	rfl?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegionKeySpecifier = ('code' | 'enabled' | 'name' | RegionKeySpecifier)[];
export type RegionFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegisterDeviceIdPayloadKeySpecifier = ('clientMutationId' | 'success' | RegisterDeviceIdPayloadKeySpecifier)[];
export type RegisterDeviceIdPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegularWithdrawalTypeKeySpecifier = ('amount' | 'bankAccount' | 'createdAt' | 'createdBy' | 'currency' | 'id' | 'recurringTime' | 'updatedAt' | RegularWithdrawalTypeKeySpecifier)[];
export type RegularWithdrawalTypeFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	bankAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	recurringTime?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegulatoryAddressTypeKeySpecifier = ('description' | 'regulatoryId' | RegulatoryAddressTypeKeySpecifier)[];
export type RegulatoryAddressTypeFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegulatoryApprovalConnectionKeySpecifier = ('edges' | 'pageInfo' | RegulatoryApprovalConnectionKeySpecifier)[];
export type RegulatoryApprovalConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegulatoryApprovalEdgeKeySpecifier = ('cursor' | 'node' | RegulatoryApprovalEdgeKeySpecifier)[];
export type RegulatoryApprovalEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegulatoryApprovalTypeKeySpecifier = ('animal' | 'destination' | 'id' | 'movedAt' | 'regulatoryType' | 'source' | 'transactions' | RegulatoryApprovalTypeKeySpecifier)[];
export type RegulatoryApprovalTypeFieldPolicy = {
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	destination?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	movedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryType?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	transactions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegulatoryTransactionApprovalSummaryTypeKeySpecifier = ('failed' | 'id' | 'inProgress' | 'pending' | 'successful' | 'type' | RegulatoryTransactionApprovalSummaryTypeKeySpecifier)[];
export type RegulatoryTransactionApprovalSummaryTypeFieldPolicy = {
	failed?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inProgress?: FieldPolicy<any> | FieldReadFunction<any>,
	pending?: FieldPolicy<any> | FieldReadFunction<any>,
	successful?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegulatoryTransactionApprovalTypeKeySpecifier = ('actualStatus' | 'animal' | 'approvalStatus' | 'businessUnit' | 'createdAt' | 'departureLocation' | 'dependsOnRegulatoryTransactionApproval' | 'destination' | 'destinationLocation' | 'id' | 'integrationSystem' | 'linkedToRegulatoryTransactionApproval' | 'lot' | 'reasonOfFailure' | 'regulatoryTransactions' | 'source' | 'sourceActivity' | 'transactionTypes' | 'updatedAt' | RegulatoryTransactionApprovalTypeKeySpecifier)[];
export type RegulatoryTransactionApprovalTypeFieldPolicy = {
	actualStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	approvalStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	departureLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	dependsOnRegulatoryTransactionApproval?: FieldPolicy<any> | FieldReadFunction<any>,
	destination?: FieldPolicy<any> | FieldReadFunction<any>,
	destinationLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	integrationSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedToRegulatoryTransactionApproval?: FieldPolicy<any> | FieldReadFunction<any>,
	lot?: FieldPolicy<any> | FieldReadFunction<any>,
	reasonOfFailure?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceActivity?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegulatoryTransactionApprovalsAbortPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'regulatoryTransactionApprovals' | RegulatoryTransactionApprovalsAbortPayloadKeySpecifier)[];
export type RegulatoryTransactionApprovalsAbortPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryTransactionApprovals?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegulatoryTransactionApprovalsChangeDatePayloadKeySpecifier = ('clientMutationId' | 'errors' | 'regulatoryTransactionApprovals' | RegulatoryTransactionApprovalsChangeDatePayloadKeySpecifier)[];
export type RegulatoryTransactionApprovalsChangeDatePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryTransactionApprovals?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegulatoryTransactionApprovalsResponsePayloadKeySpecifier = ('clientMutationId' | 'errors' | 'regulatoryTransactionApprovals' | RegulatoryTransactionApprovalsResponsePayloadKeySpecifier)[];
export type RegulatoryTransactionApprovalsResponsePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryTransactionApprovals?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegulatoryTransactionApprovalsRetryPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'regulatoryTransactionApprovals' | RegulatoryTransactionApprovalsRetryPayloadKeySpecifier)[];
export type RegulatoryTransactionApprovalsRetryPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	regulatoryTransactionApprovals?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegulatoryTransactionTypeKeySpecifier = ('id' | 'status' | 'type' | RegulatoryTransactionTypeKeySpecifier)[];
export type RegulatoryTransactionTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegulatoryTransactionWarningsObjectTypeKeySpecifier = ('count' | 'lapseOfTime' | 'type' | RegulatoryTransactionWarningsObjectTypeKeySpecifier)[];
export type RegulatoryTransactionWarningsObjectTypeFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	lapseOfTime?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RejectDeliveryPayloadKeySpecifier = ('clientMutationId' | 'delivery' | 'errors' | 'success' | RejectDeliveryPayloadKeySpecifier)[];
export type RejectDeliveryPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RemoveAnimalsFromFinancialTransactionPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'financialTransaction' | 'success' | RemoveAnimalsFromFinancialTransactionPayloadKeySpecifier)[];
export type RemoveAnimalsFromFinancialTransactionPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	financialTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportTypeKeySpecifier = ('applyProducerGroup' | 'businessTypes' | 'businessUnit' | 'defaultFilters' | 'group' | 'id' | 'needUpgrade' | 'position' | 'regions' | 'reportType' | 'slug' | 'species' | 'subscriptionPlans' | 'title' | 'url' | ReportTypeKeySpecifier)[];
export type ReportTypeFieldPolicy = {
	applyProducerGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	businessTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	needUpgrade?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	regions?: FieldPolicy<any> | FieldReadFunction<any>,
	reportType?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	species?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionPlans?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ResponseToLotOfferPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'offer' | ResponseToLotOfferPayloadKeySpecifier)[];
export type ResponseToLotOfferPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	offer?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RestoreAnimalsPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | RestoreAnimalsPayloadKeySpecifier)[];
export type RestoreAnimalsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RetrieveChannelPayloadKeySpecifier = ('channelUrl' | 'clientMutationId' | 'errors' | RetrieveChannelPayloadKeySpecifier)[];
export type RetrieveChannelPayloadFieldPolicy = {
	channelUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoleKeySpecifier = ('id' | 'name' | RoleKeySpecifier)[];
export type RoleFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaveCrushAppSessionEnhancedPayloadKeySpecifier = ('activities' | 'animalAlerts' | 'animalType' | 'animals' | 'animalsNotSaved' | 'animalsSaved' | 'clientMutationId' | 'crushAppSession' | 'errors' | 'fields' | 'groups' | 'groupsNotSaved' | SaveCrushAppSessionEnhancedPayloadKeySpecifier)[];
export type SaveCrushAppSessionEnhancedPayloadFieldPolicy = {
	activities?: FieldPolicy<any> | FieldReadFunction<any>,
	animalAlerts?: FieldPolicy<any> | FieldReadFunction<any>,
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsNotSaved?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsSaved?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	crushAppSession?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	groupsNotSaved?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaveCrushAppSessionPayloadKeySpecifier = ('activities' | 'animalAlerts' | 'animalType' | 'animals' | 'clientMutationId' | 'crushAppSession' | 'errors' | 'fields' | 'groups' | SaveCrushAppSessionPayloadKeySpecifier)[];
export type SaveCrushAppSessionPayloadFieldPolicy = {
	activities?: FieldPolicy<any> | FieldReadFunction<any>,
	animalAlerts?: FieldPolicy<any> | FieldReadFunction<any>,
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	animals?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	crushAppSession?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScotMovesConnectionTypeKeySpecifier = ('credentials' | 'errorMessage' | 'farm' | 'id' | 'integrationSystem' | 'location' | 'status' | ScotMovesConnectionTypeKeySpecifier)[];
export type ScotMovesConnectionTypeFieldPolicy = {
	credentials?: FieldPolicy<any> | FieldReadFunction<any>,
	errorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	farm?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	integrationSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SearchBusinessUnitKeySpecifier = ('id' | 'location' | 'name' | 'profilePhoto' | 'users' | SearchBusinessUnitKeySpecifier)[];
export type SearchBusinessUnitFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePhoto?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SearchableFieldObjectTypeKeySpecifier = ('field' | 'label' | SearchableFieldObjectTypeKeySpecifier)[];
export type SearchableFieldObjectTypeFieldPolicy = {
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendApprovePayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | SendApprovePayloadKeySpecifier)[];
export type SendApprovePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendBirdUserKeySpecifier = ('accessToken' | 'userId' | SendBirdUserKeySpecifier)[];
export type SendBirdUserFieldPolicy = {
	accessToken?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendCodePayloadKeySpecifier = ('clientMutationId' | 'errors' | 'status' | SendCodePayloadKeySpecifier)[];
export type SendCodePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendCompleteBcmsSetupEmailPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | SendCompleteBcmsSetupEmailPayloadKeySpecifier)[];
export type SendCompleteBcmsSetupEmailPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendMessagePayloadKeySpecifier = ('clientMutationId' | 'success' | SendMessagePayloadKeySpecifier)[];
export type SendMessagePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendResetPasswordEmailPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | SendResetPasswordEmailPayloadKeySpecifier)[];
export type SendResetPasswordEmailPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SeriesObjectTypeKeySpecifier = ('data' | 'label' | SeriesObjectTypeKeySpecifier)[];
export type SeriesObjectTypeFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SessionAnimalKeySpecifier = ('animal' | 'scannedAt' | SessionAnimalKeySpecifier)[];
export type SessionAnimalFieldPolicy = {
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	scannedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SessionAnimalConnectionKeySpecifier = ('edges' | 'pageInfo' | SessionAnimalConnectionKeySpecifier)[];
export type SessionAnimalConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SessionAnimalEdgeKeySpecifier = ('cursor' | 'node' | SessionAnimalEdgeKeySpecifier)[];
export type SessionAnimalEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SetFavouritePayloadKeySpecifier = ('clientMutationId' | 'favourite' | SetFavouritePayloadKeySpecifier)[];
export type SetFavouritePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	favourite?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SexClassificationKeySpecifier = ('animalType' | 'slug' | 'title' | SexClassificationKeySpecifier)[];
export type SexClassificationFieldPolicy = {
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SignUpPayloadKeySpecifier = ('businessUnit' | 'clientMutationId' | 'errors' | 'success' | SignUpPayloadKeySpecifier)[];
export type SignUpPayloadFieldPolicy = {
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SignUpUserPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'isInvited' | 'organisation' | 'token' | 'user' | SignUpUserPayloadKeySpecifier)[];
export type SignUpUserPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	isInvited?: FieldPolicy<any> | FieldReadFunction<any>,
	organisation?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SireKeySpecifier = ('animalSet' | 'businessUnit' | 'created' | 'id' | 'isDeleted' | 'name' | 'passportNumber' | 'passportNumberCleaned' | 'pedigree' | 'registrationNumber' | 'sire' | 'updated' | SireKeySpecifier)[];
export type SireFieldPolicy = {
	animalSet?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	passportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	passportNumberCleaned?: FieldPolicy<any> | FieldReadFunction<any>,
	pedigree?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	sire?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SnoozeAnimalsAlertsPayloadKeySpecifier = ('animalAlerts' | 'clientMutationId' | 'errors' | SnoozeAnimalsAlertsPayloadKeySpecifier)[];
export type SnoozeAnimalsAlertsPayloadFieldPolicy = {
	animalAlerts?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SoftDeleteAnimalsPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | SoftDeleteAnimalsPayloadKeySpecifier)[];
export type SoftDeleteAnimalsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SplitFieldPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'field' | SplitFieldPayloadKeySpecifier)[];
export type SplitFieldPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StartFarmSystemTaskPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'id' | StartFarmSystemTaskPayloadKeySpecifier)[];
export type StartFarmSystemTaskPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StatisticKeySpecifier = ('animalsPurchased' | 'animalsSold' | 'income' | 'nextDeliveryDate' | 'purchases' | StatisticKeySpecifier)[];
export type StatisticFieldPolicy = {
	animalsPurchased?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsSold?: FieldPolicy<any> | FieldReadFunction<any>,
	income?: FieldPolicy<any> | FieldReadFunction<any>,
	nextDeliveryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	purchases?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StockItemListTypeKeySpecifier = ('activeIngredient' | 'applicationMethod' | 'businessUnit' | 'createdAt' | 'id' | 'lineItems' | 'manufacturer' | 'manufacturerName' | 'medicineType' | 'name' | 'numberOfBatches' | 'quantityUnits' | 'remainingVolume' | 'species' | 'totalQuantity' | 'totalVolume' | 'updatedAt' | 'withdrawal' | 'withdrawalNotes' | 'withdrawalPeriodDaysCattleDairy' | 'withdrawalPeriodDaysCattleMeat' | 'withdrawalPeriodDaysPigs' | 'withdrawalPeriodDaysSheep' | StockItemListTypeKeySpecifier)[];
export type StockItemListTypeFieldPolicy = {
	activeIngredient?: FieldPolicy<any> | FieldReadFunction<any>,
	applicationMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lineItems?: FieldPolicy<any> | FieldReadFunction<any>,
	manufacturer?: FieldPolicy<any> | FieldReadFunction<any>,
	manufacturerName?: FieldPolicy<any> | FieldReadFunction<any>,
	medicineType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfBatches?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	remainingVolume?: FieldPolicy<any> | FieldReadFunction<any>,
	species?: FieldPolicy<any> | FieldReadFunction<any>,
	totalQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVolume?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawal?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalPeriodDaysCattleDairy?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalPeriodDaysCattleMeat?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalPeriodDaysPigs?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalPeriodDaysSheep?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StocktakeObjectTypeKeySpecifier = ('age' | 'ageCategory' | 'alerts' | 'allAlertsCount' | 'alternativeId' | 'animalBreeds' | 'animalColour' | 'animalSubtype' | 'animalType' | 'animalTypeId' | 'birthInformation' | 'breedPercentages' | 'breedSocietyRegistration' | 'breeding' | 'breedrId' | 'brucellosisId' | 'buyerName' | 'children' | 'cphCount' | 'createdAt' | 'currentAlertsCount' | 'currentHighUrgencyAlertsCount' | 'currentWeight' | 'dam' | 'damId' | 'damPassportNumber' | 'dateLeftFarm' | 'dateMovedToFarm' | 'daysToTargetWeight' | 'deadAt' | 'deliveryDate' | 'description' | 'dob' | 'eId' | 'eIdCleaned' | 'eIdsHistory' | 'estimatedAgeOn' | 'estimatedCarcassWeight' | 'estimatedWeightOn' | 'field' | 'fieldId' | 'gender' | 'group' | 'groupId' | 'growthRate' | 'growthRateSinceConception' | 'growthRateSinceLastWeighLog' | 'hasPreviousKeeperInfo' | 'herdDoggId' | 'id' | 'images' | 'impactStatus' | 'isArchived' | 'isBcmsSynced' | 'isBirthed' | 'isCastrated' | 'isDead' | 'isMale' | 'isOnFarm' | 'isPedigree' | 'isPregnant' | 'isRegulatorySynced' | 'isSoftDeleted' | 'killFatScore' | 'killFatScoreInt' | 'killQuality' | 'killQualityInt' | 'killWeight' | 'lastRegulatorySyncedDate' | 'lastWeight' | 'latestPurchasePrice' | 'linkToMySire' | 'location' | 'lot' | 'metaData' | 'name' | 'notifications' | 'offerId' | 'owner' | 'ownerId' | 'ownersHistory' | 'parentageChecked' | 'passportNumber' | 'pedigree' | 'pedigreeId' | 'performanceCategory' | 'predicatedDateReady' | 'predictedDateReady' | 'predictedWeightAtDelivery' | 'predictedWeights' | 'pregnancyDueDate' | 'previousKeeper' | 'registrationStatus' | 'relatedMeatLabels' | 'rflId' | 'sexClassification' | 'sire' | 'sireId' | 'sireIsPedigree' | 'sirePassportNumber' | 'sireStuds' | 'softDeletedAt' | 'studSiredId' | 'tags' | 'targetDailyLiveWeightGain' | 'targetLiveWeight' | 'tattoo' | 'trichId' | 'trioVerified' | 'tsuBarcode' | 'uhfId' | 'unreadNotificationsCount' | 'updatedAt' | 'updatedBy' | 'visualId' | 'visualIdsHistory' | 'withdrawalEnd' | 'withdrawalStart' | StocktakeObjectTypeKeySpecifier)[];
export type StocktakeObjectTypeFieldPolicy = {
	age?: FieldPolicy<any> | FieldReadFunction<any>,
	ageCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	alerts?: FieldPolicy<any> | FieldReadFunction<any>,
	allAlertsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	alternativeId?: FieldPolicy<any> | FieldReadFunction<any>,
	animalBreeds?: FieldPolicy<any> | FieldReadFunction<any>,
	animalColour?: FieldPolicy<any> | FieldReadFunction<any>,
	animalSubtype?: FieldPolicy<any> | FieldReadFunction<any>,
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	animalTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	birthInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	breedPercentages?: FieldPolicy<any> | FieldReadFunction<any>,
	breedSocietyRegistration?: FieldPolicy<any> | FieldReadFunction<any>,
	breeding?: FieldPolicy<any> | FieldReadFunction<any>,
	breedrId?: FieldPolicy<any> | FieldReadFunction<any>,
	brucellosisId?: FieldPolicy<any> | FieldReadFunction<any>,
	buyerName?: FieldPolicy<any> | FieldReadFunction<any>,
	children?: FieldPolicy<any> | FieldReadFunction<any>,
	cphCount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currentAlertsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	currentHighUrgencyAlertsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	currentWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	dam?: FieldPolicy<any> | FieldReadFunction<any>,
	damId?: FieldPolicy<any> | FieldReadFunction<any>,
	damPassportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	dateLeftFarm?: FieldPolicy<any> | FieldReadFunction<any>,
	dateMovedToFarm?: FieldPolicy<any> | FieldReadFunction<any>,
	daysToTargetWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	deadAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	dob?: FieldPolicy<any> | FieldReadFunction<any>,
	eId?: FieldPolicy<any> | FieldReadFunction<any>,
	eIdCleaned?: FieldPolicy<any> | FieldReadFunction<any>,
	eIdsHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedAgeOn?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedCarcassWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedWeightOn?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldId?: FieldPolicy<any> | FieldReadFunction<any>,
	gender?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>,
	groupId?: FieldPolicy<any> | FieldReadFunction<any>,
	growthRate?: FieldPolicy<any> | FieldReadFunction<any>,
	growthRateSinceConception?: FieldPolicy<any> | FieldReadFunction<any>,
	growthRateSinceLastWeighLog?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousKeeperInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	herdDoggId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	impactStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	isArchived?: FieldPolicy<any> | FieldReadFunction<any>,
	isBcmsSynced?: FieldPolicy<any> | FieldReadFunction<any>,
	isBirthed?: FieldPolicy<any> | FieldReadFunction<any>,
	isCastrated?: FieldPolicy<any> | FieldReadFunction<any>,
	isDead?: FieldPolicy<any> | FieldReadFunction<any>,
	isMale?: FieldPolicy<any> | FieldReadFunction<any>,
	isOnFarm?: FieldPolicy<any> | FieldReadFunction<any>,
	isPedigree?: FieldPolicy<any> | FieldReadFunction<any>,
	isPregnant?: FieldPolicy<any> | FieldReadFunction<any>,
	isRegulatorySynced?: FieldPolicy<any> | FieldReadFunction<any>,
	isSoftDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	killFatScore?: FieldPolicy<any> | FieldReadFunction<any>,
	killFatScoreInt?: FieldPolicy<any> | FieldReadFunction<any>,
	killQuality?: FieldPolicy<any> | FieldReadFunction<any>,
	killQualityInt?: FieldPolicy<any> | FieldReadFunction<any>,
	killWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	lastRegulatorySyncedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	lastWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	latestPurchasePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	linkToMySire?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	lot?: FieldPolicy<any> | FieldReadFunction<any>,
	metaData?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	offerId?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerId?: FieldPolicy<any> | FieldReadFunction<any>,
	ownersHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	parentageChecked?: FieldPolicy<any> | FieldReadFunction<any>,
	passportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	pedigree?: FieldPolicy<any> | FieldReadFunction<any>,
	pedigreeId?: FieldPolicy<any> | FieldReadFunction<any>,
	performanceCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	predicatedDateReady?: FieldPolicy<any> | FieldReadFunction<any>,
	predictedDateReady?: FieldPolicy<any> | FieldReadFunction<any>,
	predictedWeightAtDelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	predictedWeights?: FieldPolicy<any> | FieldReadFunction<any>,
	pregnancyDueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	previousKeeper?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedMeatLabels?: FieldPolicy<any> | FieldReadFunction<any>,
	rflId?: FieldPolicy<any> | FieldReadFunction<any>,
	sexClassification?: FieldPolicy<any> | FieldReadFunction<any>,
	sire?: FieldPolicy<any> | FieldReadFunction<any>,
	sireId?: FieldPolicy<any> | FieldReadFunction<any>,
	sireIsPedigree?: FieldPolicy<any> | FieldReadFunction<any>,
	sirePassportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	sireStuds?: FieldPolicy<any> | FieldReadFunction<any>,
	softDeletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	studSiredId?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	targetDailyLiveWeightGain?: FieldPolicy<any> | FieldReadFunction<any>,
	targetLiveWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	tattoo?: FieldPolicy<any> | FieldReadFunction<any>,
	trichId?: FieldPolicy<any> | FieldReadFunction<any>,
	trioVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	tsuBarcode?: FieldPolicy<any> | FieldReadFunction<any>,
	uhfId?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadNotificationsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	visualId?: FieldPolicy<any> | FieldReadFunction<any>,
	visualIdsHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalStart?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StocktakeObjectTypeConnectionKeySpecifier = ('edges' | 'pageInfo' | StocktakeObjectTypeConnectionKeySpecifier)[];
export type StocktakeObjectTypeConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StocktakeObjectTypeEdgeKeySpecifier = ('cursor' | 'node' | StocktakeObjectTypeEdgeKeySpecifier)[];
export type StocktakeObjectTypeEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionActivationTokenTypeKeySpecifier = ('behaviour' | 'catalog' | 'id' | SubscriptionActivationTokenTypeKeySpecifier)[];
export type SubscriptionActivationTokenTypeFieldPolicy = {
	behaviour?: FieldPolicy<any> | FieldReadFunction<any>,
	catalog?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionCatalogChoiceTypeKeySpecifier = ('slug' | SubscriptionCatalogChoiceTypeKeySpecifier)[];
export type SubscriptionCatalogChoiceTypeFieldPolicy = {
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionCatalogTypeKeySpecifier = ('choices' | 'id' | SubscriptionCatalogTypeKeySpecifier)[];
export type SubscriptionCatalogTypeFieldPolicy = {
	choices?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionInvoiceKeySpecifier = ('amountPaid' | 'businessUnitSubscription' | 'createdAt' | 'currency' | 'date' | 'id' | 'invoicePdf' | 'paid' | 'paymentSystem' | 'subscriptionData' | SubscriptionInvoiceKeySpecifier)[];
export type SubscriptionInvoiceFieldPolicy = {
	amountPaid?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitSubscription?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invoicePdf?: FieldPolicy<any> | FieldReadFunction<any>,
	paid?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionData?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionInvoiceConnectionKeySpecifier = ('edges' | 'pageInfo' | SubscriptionInvoiceConnectionKeySpecifier)[];
export type SubscriptionInvoiceConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionInvoiceEdgeKeySpecifier = ('cursor' | 'node' | SubscriptionInvoiceEdgeKeySpecifier)[];
export type SubscriptionInvoiceEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionPlanKeySpecifier = ('currency' | 'description' | 'duration' | 'features' | 'id' | 'interval' | 'isActive' | 'isRecurring' | 'name' | 'price' | 'prices' | 'tradingPlan' | 'trialPeriod' | 'updatedAt' | SubscriptionPlanKeySpecifier)[];
export type SubscriptionPlanFieldPolicy = {
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	features?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	interval?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isRecurring?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	prices?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingPlan?: FieldPolicy<any> | FieldReadFunction<any>,
	trialPeriod?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionPlanFeatureKeySpecifier = ('isActive' | 'slug' | SubscriptionPlanFeatureKeySpecifier)[];
export type SubscriptionPlanFeatureFieldPolicy = {
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionPriceKeySpecifier = ('currency' | 'description' | 'duration' | 'id' | 'interval' | 'isActive' | 'isRecurring' | 'name' | 'price' | 'trialPeriod' | 'updatedAt' | SubscriptionPriceKeySpecifier)[];
export type SubscriptionPriceFieldPolicy = {
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	interval?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isRecurring?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	trialPeriod?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionStatusTypeKeySpecifier = ('activationTokens' | 'animalTypes' | 'features' | 'hasStripeState' | 'hasStripeSubscriptions' | 'isSubscribed' | 'tier' | SubscriptionStatusTypeKeySpecifier)[];
export type SubscriptionStatusTypeFieldPolicy = {
	activationTokens?: FieldPolicy<any> | FieldReadFunction<any>,
	animalTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	features?: FieldPolicy<any> | FieldReadFunction<any>,
	hasStripeState?: FieldPolicy<any> | FieldReadFunction<any>,
	hasStripeSubscriptions?: FieldPolicy<any> | FieldReadFunction<any>,
	isSubscribed?: FieldPolicy<any> | FieldReadFunction<any>,
	tier?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SummaryMetricsKeySpecifier = ('animalTypeId' | 'animalsCount' | 'breedrCode' | 'femaleCount' | 'maleCount' | 'regBreedCode' | SummaryMetricsKeySpecifier)[];
export type SummaryMetricsFieldPolicy = {
	animalTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	animalsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	breedrCode?: FieldPolicy<any> | FieldReadFunction<any>,
	femaleCount?: FieldPolicy<any> | FieldReadFunction<any>,
	maleCount?: FieldPolicy<any> | FieldReadFunction<any>,
	regBreedCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SupplyChainPageObjectTypeKeySpecifier = ('accreditation' | 'banner' | 'bullets' | 'id' | 'subregion' | 'text' | 'title' | 'url' | SupplyChainPageObjectTypeKeySpecifier)[];
export type SupplyChainPageObjectTypeFieldPolicy = {
	accreditation?: FieldPolicy<any> | FieldReadFunction<any>,
	banner?: FieldPolicy<any> | FieldReadFunction<any>,
	bullets?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	subregion?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SystemCredentialFieldTypeKeySpecifier = ('fieldLabel' | 'fieldName' | 'fieldType' | 'id' | 'inputMask' | 'integrationSystem' | 'maxLength' | 'minLength' | 'placeholder' | SystemCredentialFieldTypeKeySpecifier)[];
export type SystemCredentialFieldTypeFieldPolicy = {
	fieldLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldName?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inputMask?: FieldPolicy<any> | FieldReadFunction<any>,
	integrationSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	maxLength?: FieldPolicy<any> | FieldReadFunction<any>,
	minLength?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TableColumnDataObjectTypeKeySpecifier = ('accessor' | 'displayName' | 'sortable' | TableColumnDataObjectTypeKeySpecifier)[];
export type TableColumnDataObjectTypeFieldPolicy = {
	accessor?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	sortable?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TableDataObjectTypeKeySpecifier = ('columns' | 'data' | 'download' | 'pageInfo' | 'searchableField' | 'title' | TableDataObjectTypeKeySpecifier)[];
export type TableDataObjectTypeFieldPolicy = {
	columns?: FieldPolicy<any> | FieldReadFunction<any>,
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	download?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	searchableField?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagSchemaInterfaceKeySpecifier = ('animalTypes' | 'color' | 'isRemovable' | 'name' | 'ownership' | 'slug' | 'tagId' | 'textColor' | 'valueType' | TagSchemaInterfaceKeySpecifier)[];
export type TagSchemaInterfaceFieldPolicy = {
	animalTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	isRemovable?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	ownership?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	tagId?: FieldPolicy<any> | FieldReadFunction<any>,
	textColor?: FieldPolicy<any> | FieldReadFunction<any>,
	valueType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TargetWeightTypeKeySpecifier = ('id' | 'name' | TargetWeightTypeKeySpecifier)[];
export type TargetWeightTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskKeySpecifier = ('assignedBy' | 'assignedTo' | 'attachments' | 'comments' | 'createdAt' | 'createdBy' | 'dueDatetime' | 'id' | 'name' | 'relatedEntryId' | 'updatedAt' | TaskKeySpecifier)[];
export type TaskFieldPolicy = {
	assignedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedTo?: FieldPolicy<any> | FieldReadFunction<any>,
	attachments?: FieldPolicy<any> | FieldReadFunction<any>,
	comments?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDatetime?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedEntryId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskAttachmentKeySpecifier = ('file' | 'id' | 'task' | 'uploadedAt' | 'uploadedBy' | TaskAttachmentKeySpecifier)[];
export type TaskAttachmentFieldPolicy = {
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	task?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedBy?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskConnectionKeySpecifier = ('edges' | 'pageInfo' | TaskConnectionKeySpecifier)[];
export type TaskConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskEdgeKeySpecifier = ('cursor' | 'node' | TaskEdgeKeySpecifier)[];
export type TaskEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TermsAndConditionsAcceptPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | TermsAndConditionsAcceptPayloadKeySpecifier)[];
export type TermsAndConditionsAcceptPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TermsAndConditionsObjectTypeKeySpecifier = ('description' | 'descriptionMarkdown' | 'id' | 'title' | 'type' | TermsAndConditionsObjectTypeKeySpecifier)[];
export type TermsAndConditionsObjectTypeFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionMarkdown?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TimestampChartDataKeySpecifier = ('timestamp' | TimestampChartDataKeySpecifier)[];
export type TimestampChartDataFieldPolicy = {
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TradingPlanKeySpecifier = ('businessUnits' | 'commission' | 'id' | 'isActive' | 'minimumFeeAmount' | 'name' | 'paidBy' | 'subscriptionplanSet' | TradingPlanKeySpecifier)[];
export type TradingPlanFieldPolicy = {
	businessUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	commission?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumFeeAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	paidBy?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionplanSet?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TradingStartUpMessageTypeKeySpecifier = ('helpUser' | 'id' | 'startUpMessage' | 'startUpType' | TradingStartUpMessageTypeKeySpecifier)[];
export type TradingStartUpMessageTypeFieldPolicy = {
	helpUser?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	startUpMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	startUpType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TradingTypeKeySpecifier = ('description' | 'id' | 'name' | 'slug' | 'templates' | TradingTypeKeySpecifier)[];
export type TradingTypeFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	templates?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransferOwnershipPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | TransferOwnershipPayloadKeySpecifier)[];
export type TransferOwnershipPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TruTestImportXlsPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'task' | TruTestImportXlsPayloadKeySpecifier)[];
export type TruTestImportXlsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	task?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnRegisterDeviceIdPayloadKeySpecifier = ('clientMutationId' | 'success' | UnRegisterDeviceIdPayloadKeySpecifier)[];
export type UnRegisterDeviceIdPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UndoDeliveryPayloadKeySpecifier = ('clientMutationId' | 'delivery' | 'errors' | 'success' | UndoDeliveryPayloadKeySpecifier)[];
export type UndoDeliveryPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnitOfMeasurementKeySpecifier = ('businessUnit' | 'code' | 'id' | 'longDescription' | 'measurementType' | UnitOfMeasurementKeySpecifier)[];
export type UnitOfMeasurementFieldPolicy = {
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	longDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	measurementType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnlinkHerdDoggAccountPayloadKeySpecifier = ('clientMutationId' | 'success' | UnlinkHerdDoggAccountPayloadKeySpecifier)[];
export type UnlinkHerdDoggAccountPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnprocessedAnimalKeySpecifier = ('breed' | 'date' | 'dob' | 'eId' | 'id' | 'passportNumber' | 'sex' | 'weight' | UnprocessedAnimalKeySpecifier)[];
export type UnprocessedAnimalFieldPolicy = {
	breed?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	dob?: FieldPolicy<any> | FieldReadFunction<any>,
	eId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	passportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	sex?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnprocessedItemKeySpecifier = ('id' | UnprocessedItemKeySpecifier)[];
export type UnprocessedItemFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnsetFavouritePayloadKeySpecifier = ('clientMutationId' | 'favourite' | UnsetFavouritePayloadKeySpecifier)[];
export type UnsetFavouritePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	favourite?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateAnimalFilterPayloadKeySpecifier = ('animalFilter' | 'clientMutationId' | 'errors' | UpdateAnimalFilterPayloadKeySpecifier)[];
export type UpdateAnimalFilterPayloadFieldPolicy = {
	animalFilter?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateAnimalPayloadKeySpecifier = ('animal' | 'clientMutationId' | 'errors' | UpdateAnimalPayloadKeySpecifier)[];
export type UpdateAnimalPayloadFieldPolicy = {
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateBankDetailsPayloadKeySpecifier = ('bankDetails' | 'clientMutationId' | 'errors' | UpdateBankDetailsPayloadKeySpecifier)[];
export type UpdateBankDetailsPayloadFieldPolicy = {
	bankDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateBatchPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'group' | UpdateBatchPayloadKeySpecifier)[];
export type UpdateBatchPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateBusinessUnitAccreditationPayloadKeySpecifier = ('businessUnitAccreditation' | 'clientMutationId' | 'errors' | UpdateBusinessUnitAccreditationPayloadKeySpecifier)[];
export type UpdateBusinessUnitAccreditationPayloadFieldPolicy = {
	businessUnitAccreditation?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateBusinessUnitSettingsPayloadKeySpecifier = ('clientMutationId' | 'enableBcmsPushTransactions' | 'errors' | 'killOut' | 'tbStatus' | UpdateBusinessUnitSettingsPayloadKeySpecifier)[];
export type UpdateBusinessUnitSettingsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	enableBcmsPushTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	killOut?: FieldPolicy<any> | FieldReadFunction<any>,
	tbStatus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateBusinessUnitTargetPayloadKeySpecifier = ('businessUnitTarget' | 'clientMutationId' | 'errors' | UpdateBusinessUnitTargetPayloadKeySpecifier)[];
export type UpdateBusinessUnitTargetPayloadFieldPolicy = {
	businessUnitTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateBusinessUnitUserPayloadKeySpecifier = ('businessUnitUser' | 'clientMutationId' | 'errors' | UpdateBusinessUnitUserPayloadKeySpecifier)[];
export type UpdateBusinessUnitUserPayloadFieldPolicy = {
	businessUnitUser?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateContactPayloadKeySpecifier = ('clientMutationId' | 'contact' | 'errors' | UpdateContactPayloadKeySpecifier)[];
export type UpdateContactPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDeliveryPayloadKeySpecifier = ('clientMutationId' | 'delivery' | 'errors' | 'success' | UpdateDeliveryPayloadKeySpecifier)[];
export type UpdateDeliveryPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDistributionListPayloadKeySpecifier = ('clientMutationId' | 'distributionList' | 'errors' | UpdateDistributionListPayloadKeySpecifier)[];
export type UpdateDistributionListPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	distributionList?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateEmailPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | UpdateEmailPayloadKeySpecifier)[];
export type UpdateEmailPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateFarmSystemPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'farmSystem' | UpdateFarmSystemPayloadKeySpecifier)[];
export type UpdateFarmSystemPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	farmSystem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateFieldPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'field' | UpdateFieldPayloadKeySpecifier)[];
export type UpdateFieldPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateFinancialTransactionPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'financialTransaction' | UpdateFinancialTransactionPayloadKeySpecifier)[];
export type UpdateFinancialTransactionPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	financialTransaction?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateGroupPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'group' | UpdateGroupPayloadKeySpecifier)[];
export type UpdateGroupPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateIdentifierPreferencesPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | UpdateIdentifierPreferencesPayloadKeySpecifier)[];
export type UpdateIdentifierPreferencesPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateLiveSessionPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'liveSession' | 'success' | UpdateLiveSessionPayloadKeySpecifier)[];
export type UpdateLiveSessionPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	liveSession?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateLotPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'lot' | UpdateLotPayloadKeySpecifier)[];
export type UpdateLotPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	lot?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateMedicineCoursePayloadKeySpecifier = ('clientMutationId' | 'errors' | 'medicineCourse' | 'success' | UpdateMedicineCoursePayloadKeySpecifier)[];
export type UpdateMedicineCoursePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	medicineCourse?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateMedicineCourseStagePayloadKeySpecifier = ('clientMutationId' | 'errors' | 'medicineCourseStage' | 'success' | UpdateMedicineCourseStagePayloadKeySpecifier)[];
export type UpdateMedicineCourseStagePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	medicineCourseStage?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateMobileClientStatePayloadKeySpecifier = ('clientMutationId' | 'data' | 'errors' | 'success' | UpdateMobileClientStatePayloadKeySpecifier)[];
export type UpdateMobileClientStatePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateNotificationSettingsPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'notificationSettings' | UpdateNotificationSettingsPayloadKeySpecifier)[];
export type UpdateNotificationSettingsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationSettings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateOrganisationPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'organisation' | UpdateOrganisationPayloadKeySpecifier)[];
export type UpdateOrganisationPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	organisation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatePartnerDeliveryPayloadKeySpecifier = ('clientMutationId' | 'delivery' | 'errors' | 'success' | UpdatePartnerDeliveryPayloadKeySpecifier)[];
export type UpdatePartnerDeliveryPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatePasswordPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | UpdatePasswordPayloadKeySpecifier)[];
export type UpdatePasswordPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatePostPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'post' | UpdatePostPayloadKeySpecifier)[];
export type UpdatePostPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	post?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatePreferredBusinessUnitPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'preferredBusinessUnit' | UpdatePreferredBusinessUnitPayloadKeySpecifier)[];
export type UpdatePreferredBusinessUnitPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	preferredBusinessUnit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatePreferredBusinessUnitStatusPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'preferredBusinessUnit' | UpdatePreferredBusinessUnitStatusPayloadKeySpecifier)[];
export type UpdatePreferredBusinessUnitStatusPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	preferredBusinessUnit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatePreviousKeeperPayloadKeySpecifier = ('animal' | 'clientMutationId' | 'errors' | 'success' | UpdatePreviousKeeperPayloadKeySpecifier)[];
export type UpdatePreviousKeeperPayloadFieldPolicy = {
	animal?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateSirePayloadKeySpecifier = ('clientMutationId' | 'errors' | 'sire' | 'success' | UpdateSirePayloadKeySpecifier)[];
export type UpdateSirePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	sire?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateTagPayloadKeySpecifier = ('animalTag' | 'clientMutationId' | 'errors' | 'success' | UpdateTagPayloadKeySpecifier)[];
export type UpdateTagPayloadFieldPolicy = {
	animalTag?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateUserPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'user' | UpdateUserPayloadKeySpecifier)[];
export type UpdateUserPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadCsvPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'fields' | 'id' | 'rows' | 'totalColumns' | 'totalRows' | UploadCsvPayloadKeySpecifier)[];
export type UploadCsvPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	rows?: FieldPolicy<any> | FieldReadFunction<any>,
	totalColumns?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadDiscountGridPayloadKeySpecifier = ('clientMutationId' | 'discountGrid' | 'errors' | UploadDiscountGridPayloadKeySpecifier)[];
export type UploadDiscountGridPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	discountGrid?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadFileSourcePayloadKeySpecifier = ('clientMutationId' | 'errors' | 'id' | UploadFileSourcePayloadKeySpecifier)[];
export type UploadFileSourcePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UrlKeySpecifier = ('parameters' | 'url' | UrlKeySpecifier)[];
export type UrlFieldPolicy = {
	parameters?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserKeySpecifier = ('about' | 'alertSet' | 'animalFilters' | 'animalSet' | 'approvedEmail' | 'approvedStatus' | 'assignByTasks' | 'assignToTasks' | 'businessUnits' | 'calfulatorSet' | 'createdTasks' | 'dateJoined' | 'deviceIds' | 'email' | 'farmSystemTasks' | 'favourites' | 'firstName' | 'id' | 'image' | 'imagesThumb' | 'intercomUserHash' | 'isActive' | 'isTermsAccepted' | 'itemtransactionSet' | 'jobTitle' | 'lastLogin' | 'lastName' | 'marketingEmails' | 'messages' | 'metaData' | 'mobileClientState' | 'newsEmails' | 'notificationSettings' | 'organisation' | 'organisations' | 'permissions' | 'phone' | 'productEmails' | 'researchEmails' | 'sendbirdAccessToken' | 'sentMessages' | 'status' | 'systemEmails' | 'tasksAttachments' | 'tradingstartupmessageSet' | 'workers' | UserKeySpecifier)[];
export type UserFieldPolicy = {
	about?: FieldPolicy<any> | FieldReadFunction<any>,
	alertSet?: FieldPolicy<any> | FieldReadFunction<any>,
	animalFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	animalSet?: FieldPolicy<any> | FieldReadFunction<any>,
	approvedEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	approvedStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	assignByTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	assignToTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	calfulatorSet?: FieldPolicy<any> | FieldReadFunction<any>,
	createdTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	dateJoined?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceIds?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	farmSystemTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	favourites?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	imagesThumb?: FieldPolicy<any> | FieldReadFunction<any>,
	intercomUserHash?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isTermsAccepted?: FieldPolicy<any> | FieldReadFunction<any>,
	itemtransactionSet?: FieldPolicy<any> | FieldReadFunction<any>,
	jobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	lastLogin?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	marketingEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	messages?: FieldPolicy<any> | FieldReadFunction<any>,
	metaData?: FieldPolicy<any> | FieldReadFunction<any>,
	mobileClientState?: FieldPolicy<any> | FieldReadFunction<any>,
	newsEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	organisation?: FieldPolicy<any> | FieldReadFunction<any>,
	organisations?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	productEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	researchEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	sendbirdAccessToken?: FieldPolicy<any> | FieldReadFunction<any>,
	sentMessages?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	systemEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	tasksAttachments?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingstartupmessageSet?: FieldPolicy<any> | FieldReadFunction<any>,
	workers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserImageThumbnailTypeKeySpecifier = ('imageAspectRatio512x512' | 'imageAspectRatio1024x1024' | 'imageSquare32x32' | 'imageSquare64x64' | 'imageSquare96x96' | 'imageSquare128x128' | UserImageThumbnailTypeKeySpecifier)[];
export type UserImageThumbnailTypeFieldPolicy = {
	imageAspectRatio512x512?: FieldPolicy<any> | FieldReadFunction<any>,
	imageAspectRatio1024x1024?: FieldPolicy<any> | FieldReadFunction<any>,
	imageSquare32x32?: FieldPolicy<any> | FieldReadFunction<any>,
	imageSquare64x64?: FieldPolicy<any> | FieldReadFunction<any>,
	imageSquare96x96?: FieldPolicy<any> | FieldReadFunction<any>,
	imageSquare128x128?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserPublicInfoKeySpecifier = ('businessUnitUserId' | 'displayName' | 'email' | 'firstName' | 'id' | 'image' | 'lastName' | 'phone' | UserPublicInfoKeySpecifier)[];
export type UserPublicInfoFieldPolicy = {
	businessUnitUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ValidationErrorKeySpecifier = ('code' | 'field' | 'message' | ValidationErrorKeySpecifier)[];
export type ValidationErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ValidationErrorTypeKeySpecifier = ('code' | 'message' | ValidationErrorTypeKeySpecifier)[];
export type ValidationErrorTypeFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VideoGroupTypeKeySpecifier = ('id' | 'position' | 'slug' | 'title' | 'videos' | VideoGroupTypeKeySpecifier)[];
export type VideoGroupTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	videos?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VideoTypeKeySpecifier = ('description' | 'disabled' | 'groups' | 'id' | 'platform' | 'position' | 'slug' | 'thumbnail' | 'title' | 'url' | 'youtubeId' | VideoTypeKeySpecifier)[];
export type VideoTypeFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	disabled?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	platform?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	youtubeId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WantKeySpecifier = ('acceptedNumber' | 'accreditations' | 'advertDetails' | 'animalType' | 'animalTypeId' | 'breedingStatus' | 'breeds' | 'businessUnit' | 'businessUnitId' | 'currency' | 'currencyId' | 'dateNeeded' | 'description' | 'discountGrid' | 'files' | 'id' | 'isAcceptOffers' | 'isBvdFree' | 'isCarcass' | 'isForwardContractAllowed' | 'isPedigree' | 'isPublic' | 'isStandardDeductions' | 'isTbFree' | 'lastStatus' | 'location' | 'name' | 'pedigreeStatus' | 'price' | 'priceDetails' | 'priceNotes' | 'priceUnit' | 'privateShareCount' | 'privateShareMaxDistance' | 'privateSharePostcode' | 'recurringDetails' | 'requestedNumber' | 'rflId' | 'shareType' | 'shippingTerms' | 'status' | 'totalAmount' | 'tradingType' | 'tradingTypeId' | 'usage' | WantKeySpecifier)[];
export type WantFieldPolicy = {
	acceptedNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	accreditations?: FieldPolicy<any> | FieldReadFunction<any>,
	advertDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	animalType?: FieldPolicy<any> | FieldReadFunction<any>,
	animalTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	breedingStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	breeds?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitId?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyId?: FieldPolicy<any> | FieldReadFunction<any>,
	dateNeeded?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	discountGrid?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isAcceptOffers?: FieldPolicy<any> | FieldReadFunction<any>,
	isBvdFree?: FieldPolicy<any> | FieldReadFunction<any>,
	isCarcass?: FieldPolicy<any> | FieldReadFunction<any>,
	isForwardContractAllowed?: FieldPolicy<any> | FieldReadFunction<any>,
	isPedigree?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	isStandardDeductions?: FieldPolicy<any> | FieldReadFunction<any>,
	isTbFree?: FieldPolicy<any> | FieldReadFunction<any>,
	lastStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	pedigreeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	priceDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	priceNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	priceUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	privateShareCount?: FieldPolicy<any> | FieldReadFunction<any>,
	privateShareMaxDistance?: FieldPolicy<any> | FieldReadFunction<any>,
	privateSharePostcode?: FieldPolicy<any> | FieldReadFunction<any>,
	recurringDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	rflId?: FieldPolicy<any> | FieldReadFunction<any>,
	shareType?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingTerms?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingType?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WantConnectionKeySpecifier = ('edges' | 'pageInfo' | 'wantsCount' | WantConnectionKeySpecifier)[];
export type WantConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	wantsCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WantEdgeKeySpecifier = ('cursor' | 'node' | WantEdgeKeySpecifier)[];
export type WantEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WantFileKeySpecifier = ('file' | 'fileName' | 'id' | 'want' | WantFileKeySpecifier)[];
export type WantFileFieldPolicy = {
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	fileName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	want?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WantTemplateKeySpecifier = ('advertDetails' | 'breeds' | 'businessUnit' | 'businessUnitId' | 'createdAt' | 'createdBy' | 'dateNeeded' | 'discountGrid' | 'distributionLists' | 'hideRequestedNumber' | 'id' | 'isPublic' | 'location' | 'name' | 'offerDeadline' | 'price' | 'priceNotes' | 'priceUnit' | 'privateShareMaxDistance' | 'privateSharePostcode' | 'reference' | 'requestedNumber' | 'shareToGroups' | 'shareType' | 'sharedTo' | 'shippingTerms' | 'tradingType' | 'updatedAt' | WantTemplateKeySpecifier)[];
export type WantTemplateFieldPolicy = {
	advertDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	breeds?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnitId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	dateNeeded?: FieldPolicy<any> | FieldReadFunction<any>,
	discountGrid?: FieldPolicy<any> | FieldReadFunction<any>,
	distributionLists?: FieldPolicy<any> | FieldReadFunction<any>,
	hideRequestedNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	offerDeadline?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	priceNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	priceUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	privateShareMaxDistance?: FieldPolicy<any> | FieldReadFunction<any>,
	privateSharePostcode?: FieldPolicy<any> | FieldReadFunction<any>,
	reference?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	shareToGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	shareType?: FieldPolicy<any> | FieldReadFunction<any>,
	sharedTo?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingTerms?: FieldPolicy<any> | FieldReadFunction<any>,
	tradingType?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WeightActivityLogKeySpecifier = ('date' | 'value' | WeightActivityLogKeySpecifier)[];
export type WeightActivityLogFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WeightChartDataKeySpecifier = ('timestamp' | 'value' | WeightChartDataKeySpecifier)[];
export type WeightChartDataFieldPolicy = {
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WithdrawTransactionHistoryTypeKeySpecifier = ('amount' | 'balanceAccount' | 'body' | 'createdAt' | 'currency' | 'id' | 'paymentPayload' | 'paymentResponse' | 'title' | 'updatedAt' | WithdrawTransactionHistoryTypeKeySpecifier)[];
export type WithdrawTransactionHistoryTypeFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	balanceAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentPayload?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	Abattoir?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AbattoirKeySpecifier | (() => undefined | AbattoirKeySpecifier),
		fields?: AbattoirFieldPolicy,
	},
	AbattoirConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AbattoirConnectionKeySpecifier | (() => undefined | AbattoirConnectionKeySpecifier),
		fields?: AbattoirConnectionFieldPolicy,
	},
	AbattoirEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AbattoirEdgeKeySpecifier | (() => undefined | AbattoirEdgeKeySpecifier),
		fields?: AbattoirEdgeFieldPolicy,
	},
	AbattoirEstablishment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AbattoirEstablishmentKeySpecifier | (() => undefined | AbattoirEstablishmentKeySpecifier),
		fields?: AbattoirEstablishmentFieldPolicy,
	},
	AbattoirPart?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AbattoirPartKeySpecifier | (() => undefined | AbattoirPartKeySpecifier),
		fields?: AbattoirPartFieldPolicy,
	},
	AcceptDeliveryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AcceptDeliveryPayloadKeySpecifier | (() => undefined | AcceptDeliveryPayloadKeySpecifier),
		fields?: AcceptDeliveryPayloadFieldPolicy,
	},
	AcceptInvitationPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AcceptInvitationPayloadKeySpecifier | (() => undefined | AcceptInvitationPayloadKeySpecifier),
		fields?: AcceptInvitationPayloadFieldPolicy,
	},
	Accreditation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccreditationKeySpecifier | (() => undefined | AccreditationKeySpecifier),
		fields?: AccreditationFieldPolicy,
	},
	ActiveIdentifierPreferencesType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActiveIdentifierPreferencesTypeKeySpecifier | (() => undefined | ActiveIdentifierPreferencesTypeKeySpecifier),
		fields?: ActiveIdentifierPreferencesTypeFieldPolicy,
	},
	ActivityConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityConnectionKeySpecifier | (() => undefined | ActivityConnectionKeySpecifier),
		fields?: ActivityConnectionFieldPolicy,
	},
	ActivityEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityEdgeKeySpecifier | (() => undefined | ActivityEdgeKeySpecifier),
		fields?: ActivityEdgeFieldPolicy,
	},
	ActivityLog?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityLogKeySpecifier | (() => undefined | ActivityLogKeySpecifier),
		fields?: ActivityLogFieldPolicy,
	},
	ActivityPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityPayloadKeySpecifier | (() => undefined | ActivityPayloadKeySpecifier),
		fields?: ActivityPayloadFieldPolicy,
	},
	ActivityPayloadData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityPayloadDataKeySpecifier | (() => undefined | ActivityPayloadDataKeySpecifier),
		fields?: ActivityPayloadDataFieldPolicy,
	},
	ActivityTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityTemplateKeySpecifier | (() => undefined | ActivityTemplateKeySpecifier),
		fields?: ActivityTemplateFieldPolicy,
	},
	ActivityTemplateField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityTemplateFieldKeySpecifier | (() => undefined | ActivityTemplateFieldKeySpecifier),
		fields?: ActivityTemplateFieldFieldPolicy,
	},
	ActivityTemplateFieldOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityTemplateFieldOptionKeySpecifier | (() => undefined | ActivityTemplateFieldOptionKeySpecifier),
		fields?: ActivityTemplateFieldOptionFieldPolicy,
	},
	ActivityTemplateFieldUnit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityTemplateFieldUnitKeySpecifier | (() => undefined | ActivityTemplateFieldUnitKeySpecifier),
		fields?: ActivityTemplateFieldUnitFieldPolicy,
	},
	ActivityType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityTypeKeySpecifier | (() => undefined | ActivityTypeKeySpecifier),
		fields?: ActivityTypeFieldPolicy,
	},
	AddAnimalsMedicineCoursePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddAnimalsMedicineCoursePayloadKeySpecifier | (() => undefined | AddAnimalsMedicineCoursePayloadKeySpecifier),
		fields?: AddAnimalsMedicineCoursePayloadFieldPolicy,
	},
	AddAnimalsToFinancialTransactionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddAnimalsToFinancialTransactionPayloadKeySpecifier | (() => undefined | AddAnimalsToFinancialTransactionPayloadKeySpecifier),
		fields?: AddAnimalsToFinancialTransactionPayloadFieldPolicy,
	},
	AddDeliveryAddressPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddDeliveryAddressPayloadKeySpecifier | (() => undefined | AddDeliveryAddressPayloadKeySpecifier),
		fields?: AddDeliveryAddressPayloadFieldPolicy,
	},
	AddMedicineCoursePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddMedicineCoursePayloadKeySpecifier | (() => undefined | AddMedicineCoursePayloadKeySpecifier),
		fields?: AddMedicineCoursePayloadFieldPolicy,
	},
	AddMedicineCourseStagePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddMedicineCourseStagePayloadKeySpecifier | (() => undefined | AddMedicineCourseStagePayloadKeySpecifier),
		fields?: AddMedicineCourseStagePayloadFieldPolicy,
	},
	AddMedicineLineItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddMedicineLineItemPayloadKeySpecifier | (() => undefined | AddMedicineLineItemPayloadKeySpecifier),
		fields?: AddMedicineLineItemPayloadFieldPolicy,
	},
	AddRegularWithdrawalPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddRegularWithdrawalPayloadKeySpecifier | (() => undefined | AddRegularWithdrawalPayloadKeySpecifier),
		fields?: AddRegularWithdrawalPayloadFieldPolicy,
	},
	AdministerAnimalsMedicineCourseStagePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdministerAnimalsMedicineCourseStagePayloadKeySpecifier | (() => undefined | AdministerAnimalsMedicineCourseStagePayloadKeySpecifier),
		fields?: AdministerAnimalsMedicineCourseStagePayloadFieldPolicy,
	},
	AlertObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertObjectTypeKeySpecifier | (() => undefined | AlertObjectTypeKeySpecifier),
		fields?: AlertObjectTypeFieldPolicy,
	},
	AlertType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertTypeKeySpecifier | (() => undefined | AlertTypeKeySpecifier),
		fields?: AlertTypeFieldPolicy,
	},
	AmericanAngusEPD?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AmericanAngusEPDKeySpecifier | (() => undefined | AmericanAngusEPDKeySpecifier),
		fields?: AmericanAngusEPDFieldPolicy,
	},
	AncestorType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AncestorTypeKeySpecifier | (() => undefined | AncestorTypeKeySpecifier),
		fields?: AncestorTypeFieldPolicy,
	},
	Animal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalKeySpecifier | (() => undefined | AnimalKeySpecifier),
		fields?: AnimalFieldPolicy,
	},
	AnimalAlert?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalAlertKeySpecifier | (() => undefined | AnimalAlertKeySpecifier),
		fields?: AnimalAlertFieldPolicy,
	},
	AnimalAlertObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalAlertObjectTypeKeySpecifier | (() => undefined | AnimalAlertObjectTypeKeySpecifier),
		fields?: AnimalAlertObjectTypeFieldPolicy,
	},
	AnimalBreed?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalBreedKeySpecifier | (() => undefined | AnimalBreedKeySpecifier),
		fields?: AnimalBreedFieldPolicy,
	},
	AnimalBreedGender?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalBreedGenderKeySpecifier | (() => undefined | AnimalBreedGenderKeySpecifier),
		fields?: AnimalBreedGenderFieldPolicy,
	},
	AnimalColour?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalColourKeySpecifier | (() => undefined | AnimalColourKeySpecifier),
		fields?: AnimalColourFieldPolicy,
	},
	AnimalConditionType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalConditionTypeKeySpecifier | (() => undefined | AnimalConditionTypeKeySpecifier),
		fields?: AnimalConditionTypeFieldPolicy,
	},
	AnimalConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalConnectionKeySpecifier | (() => undefined | AnimalConnectionKeySpecifier),
		fields?: AnimalConnectionFieldPolicy,
	},
	AnimalConnection2?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalConnection2KeySpecifier | (() => undefined | AnimalConnection2KeySpecifier),
		fields?: AnimalConnection2FieldPolicy,
	},
	AnimalConnection2Edge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalConnection2EdgeKeySpecifier | (() => undefined | AnimalConnection2EdgeKeySpecifier),
		fields?: AnimalConnection2EdgeFieldPolicy,
	},
	AnimalFilterAlertObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalFilterAlertObjectTypeKeySpecifier | (() => undefined | AnimalFilterAlertObjectTypeKeySpecifier),
		fields?: AnimalFilterAlertObjectTypeFieldPolicy,
	},
	AnimalFilterObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalFilterObjectTypeKeySpecifier | (() => undefined | AnimalFilterObjectTypeKeySpecifier),
		fields?: AnimalFilterObjectTypeFieldPolicy,
	},
	AnimalImage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalImageKeySpecifier | (() => undefined | AnimalImageKeySpecifier),
		fields?: AnimalImageFieldPolicy,
	},
	AnimalInterface?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalInterfaceKeySpecifier | (() => undefined | AnimalInterfaceKeySpecifier),
		fields?: AnimalInterfaceFieldPolicy,
	},
	AnimalOffspringObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalOffspringObjectTypeKeySpecifier | (() => undefined | AnimalOffspringObjectTypeKeySpecifier),
		fields?: AnimalOffspringObjectTypeFieldPolicy,
	},
	AnimalPagePaginatedType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalPagePaginatedTypeKeySpecifier | (() => undefined | AnimalPagePaginatedTypeKeySpecifier),
		fields?: AnimalPagePaginatedTypeFieldPolicy,
	},
	AnimalPreviousKeeperType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalPreviousKeeperTypeKeySpecifier | (() => undefined | AnimalPreviousKeeperTypeKeySpecifier),
		fields?: AnimalPreviousKeeperTypeFieldPolicy,
	},
	AnimalSnapshotType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalSnapshotTypeKeySpecifier | (() => undefined | AnimalSnapshotTypeKeySpecifier),
		fields?: AnimalSnapshotTypeFieldPolicy,
	},
	AnimalTagOverviewConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalTagOverviewConnectionKeySpecifier | (() => undefined | AnimalTagOverviewConnectionKeySpecifier),
		fields?: AnimalTagOverviewConnectionFieldPolicy,
	},
	AnimalTagOverviewEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalTagOverviewEdgeKeySpecifier | (() => undefined | AnimalTagOverviewEdgeKeySpecifier),
		fields?: AnimalTagOverviewEdgeFieldPolicy,
	},
	AnimalTagOverviewType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalTagOverviewTypeKeySpecifier | (() => undefined | AnimalTagOverviewTypeKeySpecifier),
		fields?: AnimalTagOverviewTypeFieldPolicy,
	},
	AnimalTagSchemaType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalTagSchemaTypeKeySpecifier | (() => undefined | AnimalTagSchemaTypeKeySpecifier),
		fields?: AnimalTagSchemaTypeFieldPolicy,
	},
	AnimalTagType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalTagTypeKeySpecifier | (() => undefined | AnimalTagTypeKeySpecifier),
		fields?: AnimalTagTypeFieldPolicy,
	},
	AnimalType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalTypeKeySpecifier | (() => undefined | AnimalTypeKeySpecifier),
		fields?: AnimalTypeFieldPolicy,
	},
	AnimalTypePublic?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalTypePublicKeySpecifier | (() => undefined | AnimalTypePublicKeySpecifier),
		fields?: AnimalTypePublicFieldPolicy,
	},
	AnimalsCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalsCountKeySpecifier | (() => undefined | AnimalsCountKeySpecifier),
		fields?: AnimalsCountFieldPolicy,
	},
	AnimalsExportAsyncPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalsExportAsyncPayloadKeySpecifier | (() => undefined | AnimalsExportAsyncPayloadKeySpecifier),
		fields?: AnimalsExportAsyncPayloadFieldPolicy,
	},
	AnimalsPaginatedConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalsPaginatedConnectionKeySpecifier | (() => undefined | AnimalsPaginatedConnectionKeySpecifier),
		fields?: AnimalsPaginatedConnectionFieldPolicy,
	},
	AnimalsPaginatedEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnimalsPaginatedEdgeKeySpecifier | (() => undefined | AnimalsPaginatedEdgeKeySpecifier),
		fields?: AnimalsPaginatedEdgeFieldPolicy,
	},
	AphisImportCsvPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AphisImportCsvPayloadKeySpecifier | (() => undefined | AphisImportCsvPayloadKeySpecifier),
		fields?: AphisImportCsvPayloadFieldPolicy,
	},
	ApproveEmailPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ApproveEmailPayloadKeySpecifier | (() => undefined | ApproveEmailPayloadKeySpecifier),
		fields?: ApproveEmailPayloadFieldPolicy,
	},
	AttachDeliveryAffidavitPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttachDeliveryAffidavitPayloadKeySpecifier | (() => undefined | AttachDeliveryAffidavitPayloadKeySpecifier),
		fields?: AttachDeliveryAffidavitPayloadFieldPolicy,
	},
	BalanceAccountType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BalanceAccountTypeKeySpecifier | (() => undefined | BalanceAccountTypeKeySpecifier),
		fields?: BalanceAccountTypeFieldPolicy,
	},
	BandChartData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BandChartDataKeySpecifier | (() => undefined | BandChartDataKeySpecifier),
		fields?: BandChartDataFieldPolicy,
	},
	BankAccountDetailsObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BankAccountDetailsObjectTypeKeySpecifier | (() => undefined | BankAccountDetailsObjectTypeKeySpecifier),
		fields?: BankAccountDetailsObjectTypeFieldPolicy,
	},
	BankAccountType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BankAccountTypeKeySpecifier | (() => undefined | BankAccountTypeKeySpecifier),
		fields?: BankAccountTypeFieldPolicy,
	},
	BarChartDataObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BarChartDataObjectTypeKeySpecifier | (() => undefined | BarChartDataObjectTypeKeySpecifier),
		fields?: BarChartDataObjectTypeFieldPolicy,
	},
	Batch?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BatchKeySpecifier | (() => undefined | BatchKeySpecifier),
		fields?: BatchFieldPolicy,
	},
	BatchNameObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BatchNameObjectTypeKeySpecifier | (() => undefined | BatchNameObjectTypeKeySpecifier),
		fields?: BatchNameObjectTypeFieldPolicy,
	},
	BatchUploadFormat?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BatchUploadFormatKeySpecifier | (() => undefined | BatchUploadFormatKeySpecifier),
		fields?: BatchUploadFormatFieldPolicy,
	},
	BatchUploadFormatColumn?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BatchUploadFormatColumnKeySpecifier | (() => undefined | BatchUploadFormatColumnKeySpecifier),
		fields?: BatchUploadFormatColumnFieldPolicy,
	},
	BatchUploadFormatOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BatchUploadFormatOptionKeySpecifier | (() => undefined | BatchUploadFormatOptionKeySpecifier),
		fields?: BatchUploadFormatOptionFieldPolicy,
	},
	BcmsConnectionType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BcmsConnectionTypeKeySpecifier | (() => undefined | BcmsConnectionTypeKeySpecifier),
		fields?: BcmsConnectionTypeFieldPolicy,
	},
	BcmsImportCsvPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BcmsImportCsvPayloadKeySpecifier | (() => undefined | BcmsImportCsvPayloadKeySpecifier),
		fields?: BcmsImportCsvPayloadFieldPolicy,
	},
	BcmsServiceRequestGeneratePdfPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BcmsServiceRequestGeneratePdfPayloadKeySpecifier | (() => undefined | BcmsServiceRequestGeneratePdfPayloadKeySpecifier),
		fields?: BcmsServiceRequestGeneratePdfPayloadFieldPolicy,
	},
	BirthAnimalPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BirthAnimalPayloadKeySpecifier | (() => undefined | BirthAnimalPayloadKeySpecifier),
		fields?: BirthAnimalPayloadFieldPolicy,
	},
	BirthInformation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BirthInformationKeySpecifier | (() => undefined | BirthInformationKeySpecifier),
		fields?: BirthInformationFieldPolicy,
	},
	BlockchainAnimalData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BlockchainAnimalDataKeySpecifier | (() => undefined | BlockchainAnimalDataKeySpecifier),
		fields?: BlockchainAnimalDataFieldPolicy,
	},
	BlockchainCarcassGradingInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BlockchainCarcassGradingInfoKeySpecifier | (() => undefined | BlockchainCarcassGradingInfoKeySpecifier),
		fields?: BlockchainCarcassGradingInfoFieldPolicy,
	},
	BlockchainMedicationInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BlockchainMedicationInfoKeySpecifier | (() => undefined | BlockchainMedicationInfoKeySpecifier),
		fields?: BlockchainMedicationInfoFieldPolicy,
	},
	BlockchainMoveInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BlockchainMoveInfoKeySpecifier | (() => undefined | BlockchainMoveInfoKeySpecifier),
		fields?: BlockchainMoveInfoFieldPolicy,
	},
	BlockchainWeightInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BlockchainWeightInfoKeySpecifier | (() => undefined | BlockchainWeightInfoKeySpecifier),
		fields?: BlockchainWeightInfoFieldPolicy,
	},
	BreedPercentage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BreedPercentageKeySpecifier | (() => undefined | BreedPercentageKeySpecifier),
		fields?: BreedPercentageFieldPolicy,
	},
	BreedrBankAccountDetailsObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BreedrBankAccountDetailsObjectTypeKeySpecifier | (() => undefined | BreedrBankAccountDetailsObjectTypeKeySpecifier),
		fields?: BreedrBankAccountDetailsObjectTypeFieldPolicy,
	},
	BreedseekData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BreedseekDataKeySpecifier | (() => undefined | BreedseekDataKeySpecifier),
		fields?: BreedseekDataFieldPolicy,
	},
	BulletObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BulletObjectTypeKeySpecifier | (() => undefined | BulletObjectTypeKeySpecifier),
		fields?: BulletObjectTypeFieldPolicy,
	},
	BusinessType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessTypeKeySpecifier | (() => undefined | BusinessTypeKeySpecifier),
		fields?: BusinessTypeFieldPolicy,
	},
	BusinessUnit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessUnitKeySpecifier | (() => undefined | BusinessUnitKeySpecifier),
		fields?: BusinessUnitFieldPolicy,
	},
	BusinessUnitAccreditation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessUnitAccreditationKeySpecifier | (() => undefined | BusinessUnitAccreditationKeySpecifier),
		fields?: BusinessUnitAccreditationFieldPolicy,
	},
	BusinessUnitAccreditationDocument?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessUnitAccreditationDocumentKeySpecifier | (() => undefined | BusinessUnitAccreditationDocumentKeySpecifier),
		fields?: BusinessUnitAccreditationDocumentFieldPolicy,
	},
	BusinessUnitCountType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessUnitCountTypeKeySpecifier | (() => undefined | BusinessUnitCountTypeKeySpecifier),
		fields?: BusinessUnitCountTypeFieldPolicy,
	},
	BusinessUnitInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessUnitInfoKeySpecifier | (() => undefined | BusinessUnitInfoKeySpecifier),
		fields?: BusinessUnitInfoFieldPolicy,
	},
	BusinessUnitInterface?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessUnitInterfaceKeySpecifier | (() => undefined | BusinessUnitInterfaceKeySpecifier),
		fields?: BusinessUnitInterfaceFieldPolicy,
	},
	BusinessUnitSettingsFaqType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessUnitSettingsFaqTypeKeySpecifier | (() => undefined | BusinessUnitSettingsFaqTypeKeySpecifier),
		fields?: BusinessUnitSettingsFaqTypeFieldPolicy,
	},
	BusinessUnitSettingsType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessUnitSettingsTypeKeySpecifier | (() => undefined | BusinessUnitSettingsTypeKeySpecifier),
		fields?: BusinessUnitSettingsTypeFieldPolicy,
	},
	BusinessUnitStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessUnitStatusKeySpecifier | (() => undefined | BusinessUnitStatusKeySpecifier),
		fields?: BusinessUnitStatusFieldPolicy,
	},
	BusinessUnitSubscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessUnitSubscriptionKeySpecifier | (() => undefined | BusinessUnitSubscriptionKeySpecifier),
		fields?: BusinessUnitSubscriptionFieldPolicy,
	},
	BusinessUnitTarget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessUnitTargetKeySpecifier | (() => undefined | BusinessUnitTargetKeySpecifier),
		fields?: BusinessUnitTargetFieldPolicy,
	},
	BusinessUnitUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessUnitUserKeySpecifier | (() => undefined | BusinessUnitUserKeySpecifier),
		fields?: BusinessUnitUserFieldPolicy,
	},
	CalfColourObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CalfColourObjectTypeKeySpecifier | (() => undefined | CalfColourObjectTypeKeySpecifier),
		fields?: CalfColourObjectTypeFieldPolicy,
	},
	CalfulatorObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CalfulatorObjectTypeKeySpecifier | (() => undefined | CalfulatorObjectTypeKeySpecifier),
		fields?: CalfulatorObjectTypeFieldPolicy,
	},
	CancelFarmSystemTaskPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CancelFarmSystemTaskPayloadKeySpecifier | (() => undefined | CancelFarmSystemTaskPayloadKeySpecifier),
		fields?: CancelFarmSystemTaskPayloadFieldPolicy,
	},
	CategoryOfSale?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryOfSaleKeySpecifier | (() => undefined | CategoryOfSaleKeySpecifier),
		fields?: CategoryOfSaleFieldPolicy,
	},
	CategoryOfSaleConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryOfSaleConnectionKeySpecifier | (() => undefined | CategoryOfSaleConnectionKeySpecifier),
		fields?: CategoryOfSaleConnectionFieldPolicy,
	},
	CategoryOfSaleEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryOfSaleEdgeKeySpecifier | (() => undefined | CategoryOfSaleEdgeKeySpecifier),
		fields?: CategoryOfSaleEdgeFieldPolicy,
	},
	ChartDataItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChartDataItemKeySpecifier | (() => undefined | ChartDataItemKeySpecifier),
		fields?: ChartDataItemFieldPolicy,
	},
	ChartDataObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChartDataObjectTypeKeySpecifier | (() => undefined | ChartDataObjectTypeKeySpecifier),
		fields?: ChartDataObjectTypeFieldPolicy,
	},
	ChartObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChartObjectTypeKeySpecifier | (() => undefined | ChartObjectTypeKeySpecifier),
		fields?: ChartObjectTypeFieldPolicy,
	},
	CheckCommitDeliveryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckCommitDeliveryPayloadKeySpecifier | (() => undefined | CheckCommitDeliveryPayloadKeySpecifier),
		fields?: CheckCommitDeliveryPayloadFieldPolicy,
	},
	CheckFieldPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckFieldPayloadKeySpecifier | (() => undefined | CheckFieldPayloadKeySpecifier),
		fields?: CheckFieldPayloadFieldPolicy,
	},
	Choice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChoiceKeySpecifier | (() => undefined | ChoiceKeySpecifier),
		fields?: ChoiceFieldPolicy,
	},
	CloseLotPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CloseLotPayloadKeySpecifier | (() => undefined | CloseLotPayloadKeySpecifier),
		fields?: CloseLotPayloadFieldPolicy,
	},
	CommitDeliveryAsyncPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CommitDeliveryAsyncPayloadKeySpecifier | (() => undefined | CommitDeliveryAsyncPayloadKeySpecifier),
		fields?: CommitDeliveryAsyncPayloadFieldPolicy,
	},
	CommitDeliveryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CommitDeliveryPayloadKeySpecifier | (() => undefined | CommitDeliveryPayloadKeySpecifier),
		fields?: CommitDeliveryPayloadFieldPolicy,
	},
	CommonFarmSystemType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CommonFarmSystemTypeKeySpecifier | (() => undefined | CommonFarmSystemTypeKeySpecifier),
		fields?: CommonFarmSystemTypeFieldPolicy,
	},
	CompatMoveAnimalsOffFarmPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CompatMoveAnimalsOffFarmPayloadKeySpecifier | (() => undefined | CompatMoveAnimalsOffFarmPayloadKeySpecifier),
		fields?: CompatMoveAnimalsOffFarmPayloadFieldPolicy,
	},
	CompetentAuthority?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CompetentAuthorityKeySpecifier | (() => undefined | CompetentAuthorityKeySpecifier),
		fields?: CompetentAuthorityFieldPolicy,
	},
	CompleteInvitationPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CompleteInvitationPayloadKeySpecifier | (() => undefined | CompleteInvitationPayloadKeySpecifier),
		fields?: CompleteInvitationPayloadFieldPolicy,
	},
	ContactObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactObjectTypeKeySpecifier | (() => undefined | ContactObjectTypeKeySpecifier),
		fields?: ContactObjectTypeFieldPolicy,
	},
	ContactsConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactsConnectionKeySpecifier | (() => undefined | ContactsConnectionKeySpecifier),
		fields?: ContactsConnectionFieldPolicy,
	},
	ContactsEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactsEdgeKeySpecifier | (() => undefined | ContactsEdgeKeySpecifier),
		fields?: ContactsEdgeFieldPolicy,
	},
	ConvertBatchPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConvertBatchPayloadKeySpecifier | (() => undefined | ConvertBatchPayloadKeySpecifier),
		fields?: ConvertBatchPayloadFieldPolicy,
	},
	Country?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CountryKeySpecifier | (() => undefined | CountryKeySpecifier),
		fields?: CountryFieldPolicy,
	},
	Coupon?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CouponKeySpecifier | (() => undefined | CouponKeySpecifier),
		fields?: CouponFieldPolicy,
	},
	CreateAnimalFilterPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateAnimalFilterPayloadKeySpecifier | (() => undefined | CreateAnimalFilterPayloadKeySpecifier),
		fields?: CreateAnimalFilterPayloadFieldPolicy,
	},
	CreateAnimalPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateAnimalPayloadKeySpecifier | (() => undefined | CreateAnimalPayloadKeySpecifier),
		fields?: CreateAnimalPayloadFieldPolicy,
	},
	CreateAnimalsAlertsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateAnimalsAlertsPayloadKeySpecifier | (() => undefined | CreateAnimalsAlertsPayloadKeySpecifier),
		fields?: CreateAnimalsAlertsPayloadFieldPolicy,
	},
	CreateBankAccountPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateBankAccountPayloadKeySpecifier | (() => undefined | CreateBankAccountPayloadKeySpecifier),
		fields?: CreateBankAccountPayloadFieldPolicy,
	},
	CreateBankDetailsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateBankDetailsPayloadKeySpecifier | (() => undefined | CreateBankDetailsPayloadKeySpecifier),
		fields?: CreateBankDetailsPayloadFieldPolicy,
	},
	CreateBatchPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateBatchPayloadKeySpecifier | (() => undefined | CreateBatchPayloadKeySpecifier),
		fields?: CreateBatchPayloadFieldPolicy,
	},
	CreateBusinessUnitAccreditationPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateBusinessUnitAccreditationPayloadKeySpecifier | (() => undefined | CreateBusinessUnitAccreditationPayloadKeySpecifier),
		fields?: CreateBusinessUnitAccreditationPayloadFieldPolicy,
	},
	CreateBusinessUnitTargetPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateBusinessUnitTargetPayloadKeySpecifier | (() => undefined | CreateBusinessUnitTargetPayloadKeySpecifier),
		fields?: CreateBusinessUnitTargetPayloadFieldPolicy,
	},
	CreateContactPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateContactPayloadKeySpecifier | (() => undefined | CreateContactPayloadKeySpecifier),
		fields?: CreateContactPayloadFieldPolicy,
	},
	CreateDeliveryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateDeliveryPayloadKeySpecifier | (() => undefined | CreateDeliveryPayloadKeySpecifier),
		fields?: CreateDeliveryPayloadFieldPolicy,
	},
	CreateDistributionListPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateDistributionListPayloadKeySpecifier | (() => undefined | CreateDistributionListPayloadKeySpecifier),
		fields?: CreateDistributionListPayloadFieldPolicy,
	},
	CreateDownloadPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateDownloadPayloadKeySpecifier | (() => undefined | CreateDownloadPayloadKeySpecifier),
		fields?: CreateDownloadPayloadFieldPolicy,
	},
	CreateFarmSystemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateFarmSystemPayloadKeySpecifier | (() => undefined | CreateFarmSystemPayloadKeySpecifier),
		fields?: CreateFarmSystemPayloadFieldPolicy,
	},
	CreateFieldPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateFieldPayloadKeySpecifier | (() => undefined | CreateFieldPayloadKeySpecifier),
		fields?: CreateFieldPayloadFieldPolicy,
	},
	CreateFinancialTransactionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateFinancialTransactionPayloadKeySpecifier | (() => undefined | CreateFinancialTransactionPayloadKeySpecifier),
		fields?: CreateFinancialTransactionPayloadFieldPolicy,
	},
	CreateGroupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateGroupPayloadKeySpecifier | (() => undefined | CreateGroupPayloadKeySpecifier),
		fields?: CreateGroupPayloadFieldPolicy,
	},
	CreateLiveSessionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateLiveSessionPayloadKeySpecifier | (() => undefined | CreateLiveSessionPayloadKeySpecifier),
		fields?: CreateLiveSessionPayloadFieldPolicy,
	},
	CreateLotPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateLotPayloadKeySpecifier | (() => undefined | CreateLotPayloadKeySpecifier),
		fields?: CreateLotPayloadFieldPolicy,
	},
	CreateOfferForLotPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateOfferForLotPayloadKeySpecifier | (() => undefined | CreateOfferForLotPayloadKeySpecifier),
		fields?: CreateOfferForLotPayloadFieldPolicy,
	},
	CreatePreferredBuyersPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreatePreferredBuyersPayloadKeySpecifier | (() => undefined | CreatePreferredBuyersPayloadKeySpecifier),
		fields?: CreatePreferredBuyersPayloadFieldPolicy,
	},
	CreatePreferredSuppliersPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreatePreferredSuppliersPayloadKeySpecifier | (() => undefined | CreatePreferredSuppliersPayloadKeySpecifier),
		fields?: CreatePreferredSuppliersPayloadFieldPolicy,
	},
	CreateProducerGroupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateProducerGroupPayloadKeySpecifier | (() => undefined | CreateProducerGroupPayloadKeySpecifier),
		fields?: CreateProducerGroupPayloadFieldPolicy,
	},
	CreateSirePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateSirePayloadKeySpecifier | (() => undefined | CreateSirePayloadKeySpecifier),
		fields?: CreateSirePayloadFieldPolicy,
	},
	CreateStripeCheckoutSessionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateStripeCheckoutSessionPayloadKeySpecifier | (() => undefined | CreateStripeCheckoutSessionPayloadKeySpecifier),
		fields?: CreateStripeCheckoutSessionPayloadFieldPolicy,
	},
	CreateStripePortalSessionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateStripePortalSessionPayloadKeySpecifier | (() => undefined | CreateStripePortalSessionPayloadKeySpecifier),
		fields?: CreateStripePortalSessionPayloadFieldPolicy,
	},
	CreateTagPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateTagPayloadKeySpecifier | (() => undefined | CreateTagPayloadKeySpecifier),
		fields?: CreateTagPayloadFieldPolicy,
	},
	CreateUpdateInProgressCrushAppSessionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateUpdateInProgressCrushAppSessionPayloadKeySpecifier | (() => undefined | CreateUpdateInProgressCrushAppSessionPayloadKeySpecifier),
		fields?: CreateUpdateInProgressCrushAppSessionPayloadFieldPolicy,
	},
	CreateWeightPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateWeightPayloadKeySpecifier | (() => undefined | CreateWeightPayloadKeySpecifier),
		fields?: CreateWeightPayloadFieldPolicy,
	},
	CrushActionErrors?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CrushActionErrorsKeySpecifier | (() => undefined | CrushActionErrorsKeySpecifier),
		fields?: CrushActionErrorsFieldPolicy,
	},
	CrushActionValidationErrors?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CrushActionValidationErrorsKeySpecifier | (() => undefined | CrushActionValidationErrorsKeySpecifier),
		fields?: CrushActionValidationErrorsFieldPolicy,
	},
	CrushAnimalNotSaved?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CrushAnimalNotSavedKeySpecifier | (() => undefined | CrushAnimalNotSavedKeySpecifier),
		fields?: CrushAnimalNotSavedFieldPolicy,
	},
	CrushAnimalSaved?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CrushAnimalSavedKeySpecifier | (() => undefined | CrushAnimalSavedKeySpecifier),
		fields?: CrushAnimalSavedFieldPolicy,
	},
	CrushAppSessionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CrushAppSessionConnectionKeySpecifier | (() => undefined | CrushAppSessionConnectionKeySpecifier),
		fields?: CrushAppSessionConnectionFieldPolicy,
	},
	CrushAppSessionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CrushAppSessionEdgeKeySpecifier | (() => undefined | CrushAppSessionEdgeKeySpecifier),
		fields?: CrushAppSessionEdgeFieldPolicy,
	},
	CrushAppSessionObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CrushAppSessionObjectTypeKeySpecifier | (() => undefined | CrushAppSessionObjectTypeKeySpecifier),
		fields?: CrushAppSessionObjectTypeFieldPolicy,
	},
	CrushGroupsNotSaved?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CrushGroupsNotSavedKeySpecifier | (() => undefined | CrushGroupsNotSavedKeySpecifier),
		fields?: CrushGroupsNotSavedFieldPolicy,
	},
	Currency?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CurrencyKeySpecifier | (() => undefined | CurrencyKeySpecifier),
		fields?: CurrencyFieldPolicy,
	},
	DashboardObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DashboardObjectTypeKeySpecifier | (() => undefined | DashboardObjectTypeKeySpecifier),
		fields?: DashboardObjectTypeFieldPolicy,
	},
	DeleteActivityBulkPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteActivityBulkPayloadKeySpecifier | (() => undefined | DeleteActivityBulkPayloadKeySpecifier),
		fields?: DeleteActivityBulkPayloadFieldPolicy,
	},
	DeleteAnimalFilterPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteAnimalFilterPayloadKeySpecifier | (() => undefined | DeleteAnimalFilterPayloadKeySpecifier),
		fields?: DeleteAnimalFilterPayloadFieldPolicy,
	},
	DeleteAnimalsMedicineCoursePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteAnimalsMedicineCoursePayloadKeySpecifier | (() => undefined | DeleteAnimalsMedicineCoursePayloadKeySpecifier),
		fields?: DeleteAnimalsMedicineCoursePayloadFieldPolicy,
	},
	DeleteBankAccountPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteBankAccountPayloadKeySpecifier | (() => undefined | DeleteBankAccountPayloadKeySpecifier),
		fields?: DeleteBankAccountPayloadFieldPolicy,
	},
	DeleteBankDetailsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteBankDetailsPayloadKeySpecifier | (() => undefined | DeleteBankDetailsPayloadKeySpecifier),
		fields?: DeleteBankDetailsPayloadFieldPolicy,
	},
	DeleteBusinessUnitAccreditationPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteBusinessUnitAccreditationPayloadKeySpecifier | (() => undefined | DeleteBusinessUnitAccreditationPayloadKeySpecifier),
		fields?: DeleteBusinessUnitAccreditationPayloadFieldPolicy,
	},
	DeleteBusinessUnitTargetPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteBusinessUnitTargetPayloadKeySpecifier | (() => undefined | DeleteBusinessUnitTargetPayloadKeySpecifier),
		fields?: DeleteBusinessUnitTargetPayloadFieldPolicy,
	},
	DeleteCrushAppSessionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteCrushAppSessionPayloadKeySpecifier | (() => undefined | DeleteCrushAppSessionPayloadKeySpecifier),
		fields?: DeleteCrushAppSessionPayloadFieldPolicy,
	},
	DeleteDeliveryAddressPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDeliveryAddressPayloadKeySpecifier | (() => undefined | DeleteDeliveryAddressPayloadKeySpecifier),
		fields?: DeleteDeliveryAddressPayloadFieldPolicy,
	},
	DeleteDeliveryAnimalsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDeliveryAnimalsPayloadKeySpecifier | (() => undefined | DeleteDeliveryAnimalsPayloadKeySpecifier),
		fields?: DeleteDeliveryAnimalsPayloadFieldPolicy,
	},
	DeleteDeliveryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDeliveryPayloadKeySpecifier | (() => undefined | DeleteDeliveryPayloadKeySpecifier),
		fields?: DeleteDeliveryPayloadFieldPolicy,
	},
	DeleteDiscountGridPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDiscountGridPayloadKeySpecifier | (() => undefined | DeleteDiscountGridPayloadKeySpecifier),
		fields?: DeleteDiscountGridPayloadFieldPolicy,
	},
	DeleteDistributionListPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDistributionListPayloadKeySpecifier | (() => undefined | DeleteDistributionListPayloadKeySpecifier),
		fields?: DeleteDistributionListPayloadFieldPolicy,
	},
	DeleteFarmSystemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteFarmSystemPayloadKeySpecifier | (() => undefined | DeleteFarmSystemPayloadKeySpecifier),
		fields?: DeleteFarmSystemPayloadFieldPolicy,
	},
	DeleteFieldImagePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteFieldImagePayloadKeySpecifier | (() => undefined | DeleteFieldImagePayloadKeySpecifier),
		fields?: DeleteFieldImagePayloadFieldPolicy,
	},
	DeleteFieldPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteFieldPayloadKeySpecifier | (() => undefined | DeleteFieldPayloadKeySpecifier),
		fields?: DeleteFieldPayloadFieldPolicy,
	},
	DeleteFinancialTransactionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteFinancialTransactionPayloadKeySpecifier | (() => undefined | DeleteFinancialTransactionPayloadKeySpecifier),
		fields?: DeleteFinancialTransactionPayloadFieldPolicy,
	},
	DeleteGroupImagePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteGroupImagePayloadKeySpecifier | (() => undefined | DeleteGroupImagePayloadKeySpecifier),
		fields?: DeleteGroupImagePayloadFieldPolicy,
	},
	DeleteGroupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteGroupPayloadKeySpecifier | (() => undefined | DeleteGroupPayloadKeySpecifier),
		fields?: DeleteGroupPayloadFieldPolicy,
	},
	DeleteGroupWithAnimalsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteGroupWithAnimalsPayloadKeySpecifier | (() => undefined | DeleteGroupWithAnimalsPayloadKeySpecifier),
		fields?: DeleteGroupWithAnimalsPayloadFieldPolicy,
	},
	DeleteLiveSessionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteLiveSessionPayloadKeySpecifier | (() => undefined | DeleteLiveSessionPayloadKeySpecifier),
		fields?: DeleteLiveSessionPayloadFieldPolicy,
	},
	DeleteMedicineCoursePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteMedicineCoursePayloadKeySpecifier | (() => undefined | DeleteMedicineCoursePayloadKeySpecifier),
		fields?: DeleteMedicineCoursePayloadFieldPolicy,
	},
	DeleteMedicineCourseStagePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteMedicineCourseStagePayloadKeySpecifier | (() => undefined | DeleteMedicineCourseStagePayloadKeySpecifier),
		fields?: DeleteMedicineCourseStagePayloadFieldPolicy,
	},
	DeletePostPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeletePostPayloadKeySpecifier | (() => undefined | DeletePostPayloadKeySpecifier),
		fields?: DeletePostPayloadFieldPolicy,
	},
	DeleteRegularWithdrawalPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteRegularWithdrawalPayloadKeySpecifier | (() => undefined | DeleteRegularWithdrawalPayloadKeySpecifier),
		fields?: DeleteRegularWithdrawalPayloadFieldPolicy,
	},
	DeleteSirePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteSirePayloadKeySpecifier | (() => undefined | DeleteSirePayloadKeySpecifier),
		fields?: DeleteSirePayloadFieldPolicy,
	},
	DeleteTagPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteTagPayloadKeySpecifier | (() => undefined | DeleteTagPayloadKeySpecifier),
		fields?: DeleteTagPayloadFieldPolicy,
	},
	DeleteUserFromFarmPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteUserFromFarmPayloadKeySpecifier | (() => undefined | DeleteUserFromFarmPayloadKeySpecifier),
		fields?: DeleteUserFromFarmPayloadFieldPolicy,
	},
	DeleteWeightPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteWeightPayloadKeySpecifier | (() => undefined | DeleteWeightPayloadKeySpecifier),
		fields?: DeleteWeightPayloadFieldPolicy,
	},
	DeliverAnimalOutPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliverAnimalOutPayloadKeySpecifier | (() => undefined | DeliverAnimalOutPayloadKeySpecifier),
		fields?: DeliverAnimalOutPayloadFieldPolicy,
	},
	DeliverAnimalsOutPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliverAnimalsOutPayloadKeySpecifier | (() => undefined | DeliverAnimalsOutPayloadKeySpecifier),
		fields?: DeliverAnimalsOutPayloadFieldPolicy,
	},
	DeliverExistingAnimalPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliverExistingAnimalPayloadKeySpecifier | (() => undefined | DeliverExistingAnimalPayloadKeySpecifier),
		fields?: DeliverExistingAnimalPayloadFieldPolicy,
	},
	DeliverExistingAnimalsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliverExistingAnimalsPayloadKeySpecifier | (() => undefined | DeliverExistingAnimalsPayloadKeySpecifier),
		fields?: DeliverExistingAnimalsPayloadFieldPolicy,
	},
	DeliverNewAnimalPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliverNewAnimalPayloadKeySpecifier | (() => undefined | DeliverNewAnimalPayloadKeySpecifier),
		fields?: DeliverNewAnimalPayloadFieldPolicy,
	},
	DeliverPulledAnimalPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliverPulledAnimalPayloadKeySpecifier | (() => undefined | DeliverPulledAnimalPayloadKeySpecifier),
		fields?: DeliverPulledAnimalPayloadFieldPolicy,
	},
	DeliveryAddressInterface?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryAddressInterfaceKeySpecifier | (() => undefined | DeliveryAddressInterfaceKeySpecifier),
		fields?: DeliveryAddressInterfaceFieldPolicy,
	},
	DeliveryAddressType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryAddressTypeKeySpecifier | (() => undefined | DeliveryAddressTypeKeySpecifier),
		fields?: DeliveryAddressTypeFieldPolicy,
	},
	DeliveryAffidavitConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryAffidavitConnectionKeySpecifier | (() => undefined | DeliveryAffidavitConnectionKeySpecifier),
		fields?: DeliveryAffidavitConnectionFieldPolicy,
	},
	DeliveryAffidavitEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryAffidavitEdgeKeySpecifier | (() => undefined | DeliveryAffidavitEdgeKeySpecifier),
		fields?: DeliveryAffidavitEdgeFieldPolicy,
	},
	DeliveryAffidavitType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryAffidavitTypeKeySpecifier | (() => undefined | DeliveryAffidavitTypeKeySpecifier),
		fields?: DeliveryAffidavitTypeFieldPolicy,
	},
	DeliveryAnimalErrorType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryAnimalErrorTypeKeySpecifier | (() => undefined | DeliveryAnimalErrorTypeKeySpecifier),
		fields?: DeliveryAnimalErrorTypeFieldPolicy,
	},
	DeliveryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryConnectionKeySpecifier | (() => undefined | DeliveryConnectionKeySpecifier),
		fields?: DeliveryConnectionFieldPolicy,
	},
	DeliveryConsignmentConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryConsignmentConnectionKeySpecifier | (() => undefined | DeliveryConsignmentConnectionKeySpecifier),
		fields?: DeliveryConsignmentConnectionFieldPolicy,
	},
	DeliveryConsignmentEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryConsignmentEdgeKeySpecifier | (() => undefined | DeliveryConsignmentEdgeKeySpecifier),
		fields?: DeliveryConsignmentEdgeFieldPolicy,
	},
	DeliveryConsignmentType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryConsignmentTypeKeySpecifier | (() => undefined | DeliveryConsignmentTypeKeySpecifier),
		fields?: DeliveryConsignmentTypeFieldPolicy,
	},
	DeliveryEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryEdgeKeySpecifier | (() => undefined | DeliveryEdgeKeySpecifier),
		fields?: DeliveryEdgeFieldPolicy,
	},
	DeliveryLocationDetailsObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryLocationDetailsObjectTypeKeySpecifier | (() => undefined | DeliveryLocationDetailsObjectTypeKeySpecifier),
		fields?: DeliveryLocationDetailsObjectTypeFieldPolicy,
	},
	DeliveryLocationSummaryType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryLocationSummaryTypeKeySpecifier | (() => undefined | DeliveryLocationSummaryTypeKeySpecifier),
		fields?: DeliveryLocationSummaryTypeFieldPolicy,
	},
	DeliveryLocationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryLocationTypeKeySpecifier | (() => undefined | DeliveryLocationTypeKeySpecifier),
		fields?: DeliveryLocationTypeFieldPolicy,
	},
	DeliveryOverviewType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryOverviewTypeKeySpecifier | (() => undefined | DeliveryOverviewTypeKeySpecifier),
		fields?: DeliveryOverviewTypeFieldPolicy,
	},
	DeliveryPartnerAddressConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryPartnerAddressConnectionKeySpecifier | (() => undefined | DeliveryPartnerAddressConnectionKeySpecifier),
		fields?: DeliveryPartnerAddressConnectionFieldPolicy,
	},
	DeliveryPartnerAddressEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryPartnerAddressEdgeKeySpecifier | (() => undefined | DeliveryPartnerAddressEdgeKeySpecifier),
		fields?: DeliveryPartnerAddressEdgeFieldPolicy,
	},
	DeliveryPartnerAddressType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryPartnerAddressTypeKeySpecifier | (() => undefined | DeliveryPartnerAddressTypeKeySpecifier),
		fields?: DeliveryPartnerAddressTypeFieldPolicy,
	},
	DeliveryPartnerConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryPartnerConnectionKeySpecifier | (() => undefined | DeliveryPartnerConnectionKeySpecifier),
		fields?: DeliveryPartnerConnectionFieldPolicy,
	},
	DeliveryPartnerEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryPartnerEdgeKeySpecifier | (() => undefined | DeliveryPartnerEdgeKeySpecifier),
		fields?: DeliveryPartnerEdgeFieldPolicy,
	},
	DeliveryPartnerType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryPartnerTypeKeySpecifier | (() => undefined | DeliveryPartnerTypeKeySpecifier),
		fields?: DeliveryPartnerTypeFieldPolicy,
	},
	DeliveryReasonConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryReasonConnectionKeySpecifier | (() => undefined | DeliveryReasonConnectionKeySpecifier),
		fields?: DeliveryReasonConnectionFieldPolicy,
	},
	DeliveryReasonEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryReasonEdgeKeySpecifier | (() => undefined | DeliveryReasonEdgeKeySpecifier),
		fields?: DeliveryReasonEdgeFieldPolicy,
	},
	DeliveryReasonType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryReasonTypeKeySpecifier | (() => undefined | DeliveryReasonTypeKeySpecifier),
		fields?: DeliveryReasonTypeFieldPolicy,
	},
	DeliveryTaskType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryTaskTypeKeySpecifier | (() => undefined | DeliveryTaskTypeKeySpecifier),
		fields?: DeliveryTaskTypeFieldPolicy,
	},
	DeliveryType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryTypeKeySpecifier | (() => undefined | DeliveryTypeKeySpecifier),
		fields?: DeliveryTypeFieldPolicy,
	},
	DiagnosePregnancyPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DiagnosePregnancyPayloadKeySpecifier | (() => undefined | DiagnosePregnancyPayloadKeySpecifier),
		fields?: DiagnosePregnancyPayloadFieldPolicy,
	},
	DiscountGrid?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DiscountGridKeySpecifier | (() => undefined | DiscountGridKeySpecifier),
		fields?: DiscountGridFieldPolicy,
	},
	DisposeMedicineLineItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisposeMedicineLineItemPayloadKeySpecifier | (() => undefined | DisposeMedicineLineItemPayloadKeySpecifier),
		fields?: DisposeMedicineLineItemPayloadFieldPolicy,
	},
	DistributionListConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DistributionListConnectionKeySpecifier | (() => undefined | DistributionListConnectionKeySpecifier),
		fields?: DistributionListConnectionFieldPolicy,
	},
	DistributionListEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DistributionListEdgeKeySpecifier | (() => undefined | DistributionListEdgeKeySpecifier),
		fields?: DistributionListEdgeFieldPolicy,
	},
	DistributionListObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DistributionListObjectTypeKeySpecifier | (() => undefined | DistributionListObjectTypeKeySpecifier),
		fields?: DistributionListObjectTypeFieldPolicy,
	},
	DjangoDebug?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DjangoDebugKeySpecifier | (() => undefined | DjangoDebugKeySpecifier),
		fields?: DjangoDebugFieldPolicy,
	},
	DjangoDebugException?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DjangoDebugExceptionKeySpecifier | (() => undefined | DjangoDebugExceptionKeySpecifier),
		fields?: DjangoDebugExceptionFieldPolicy,
	},
	DjangoDebugSQL?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DjangoDebugSQLKeySpecifier | (() => undefined | DjangoDebugSQLKeySpecifier),
		fields?: DjangoDebugSQLFieldPolicy,
	},
	DownloadConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DownloadConnectionKeySpecifier | (() => undefined | DownloadConnectionKeySpecifier),
		fields?: DownloadConnectionFieldPolicy,
	},
	DownloadEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DownloadEdgeKeySpecifier | (() => undefined | DownloadEdgeKeySpecifier),
		fields?: DownloadEdgeFieldPolicy,
	},
	DownloadLink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DownloadLinkKeySpecifier | (() => undefined | DownloadLinkKeySpecifier),
		fields?: DownloadLinkFieldPolicy,
	},
	DownloadObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DownloadObjectTypeKeySpecifier | (() => undefined | DownloadObjectTypeKeySpecifier),
		fields?: DownloadObjectTypeFieldPolicy,
	},
	DownloadOptionsObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DownloadOptionsObjectTypeKeySpecifier | (() => undefined | DownloadOptionsObjectTypeKeySpecifier),
		fields?: DownloadOptionsObjectTypeFieldPolicy,
	},
	EditBankAccountPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EditBankAccountPayloadKeySpecifier | (() => undefined | EditBankAccountPayloadKeySpecifier),
		fields?: EditBankAccountPayloadFieldPolicy,
	},
	EditDeliveryAddressPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EditDeliveryAddressPayloadKeySpecifier | (() => undefined | EditDeliveryAddressPayloadKeySpecifier),
		fields?: EditDeliveryAddressPayloadFieldPolicy,
	},
	EditProducerGroupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EditProducerGroupPayloadKeySpecifier | (() => undefined | EditProducerGroupPayloadKeySpecifier),
		fields?: EditProducerGroupPayloadFieldPolicy,
	},
	EditRegularWithdrawalPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EditRegularWithdrawalPayloadKeySpecifier | (() => undefined | EditRegularWithdrawalPayloadKeySpecifier),
		fields?: EditRegularWithdrawalPayloadFieldPolicy,
	},
	EmptyStateObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmptyStateObjectTypeKeySpecifier | (() => undefined | EmptyStateObjectTypeKeySpecifier),
		fields?: EmptyStateObjectTypeFieldPolicy,
	},
	Entity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntityKeySpecifier | (() => undefined | EntityKeySpecifier),
		fields?: EntityFieldPolicy,
	},
	EntityAlertConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntityAlertConnectionKeySpecifier | (() => undefined | EntityAlertConnectionKeySpecifier),
		fields?: EntityAlertConnectionFieldPolicy,
	},
	EntityAlertEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntityAlertEdgeKeySpecifier | (() => undefined | EntityAlertEdgeKeySpecifier),
		fields?: EntityAlertEdgeFieldPolicy,
	},
	EntityAlertInterface?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntityAlertInterfaceKeySpecifier | (() => undefined | EntityAlertInterfaceKeySpecifier),
		fields?: EntityAlertInterfaceFieldPolicy,
	},
	EstimatedFuturePriceType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EstimatedFuturePriceTypeKeySpecifier | (() => undefined | EstimatedFuturePriceTypeKeySpecifier),
		fields?: EstimatedFuturePriceTypeFieldPolicy,
	},
	ExportAnimalsAsyncPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExportAnimalsAsyncPayloadKeySpecifier | (() => undefined | ExportAnimalsAsyncPayloadKeySpecifier),
		fields?: ExportAnimalsAsyncPayloadFieldPolicy,
	},
	ExportResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExportResultKeySpecifier | (() => undefined | ExportResultKeySpecifier),
		fields?: ExportResultFieldPolicy,
	},
	FarmAnimalDetailPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FarmAnimalDetailPayloadKeySpecifier | (() => undefined | FarmAnimalDetailPayloadKeySpecifier),
		fields?: FarmAnimalDetailPayloadFieldPolicy,
	},
	FarmAnimalType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FarmAnimalTypeKeySpecifier | (() => undefined | FarmAnimalTypeKeySpecifier),
		fields?: FarmAnimalTypeFieldPolicy,
	},
	FarmAnimalTypeAccreditation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FarmAnimalTypeAccreditationKeySpecifier | (() => undefined | FarmAnimalTypeAccreditationKeySpecifier),
		fields?: FarmAnimalTypeAccreditationFieldPolicy,
	},
	FarmDetailChoices?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FarmDetailChoicesKeySpecifier | (() => undefined | FarmDetailChoicesKeySpecifier),
		fields?: FarmDetailChoicesFieldPolicy,
	},
	FarmDetailHealthItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FarmDetailHealthItemKeySpecifier | (() => undefined | FarmDetailHealthItemKeySpecifier),
		fields?: FarmDetailHealthItemFieldPolicy,
	},
	FarmDetailSystemItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FarmDetailSystemItemKeySpecifier | (() => undefined | FarmDetailSystemItemKeySpecifier),
		fields?: FarmDetailSystemItemFieldPolicy,
	},
	FarmMovementConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FarmMovementConnectionKeySpecifier | (() => undefined | FarmMovementConnectionKeySpecifier),
		fields?: FarmMovementConnectionFieldPolicy,
	},
	FarmMovementEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FarmMovementEdgeKeySpecifier | (() => undefined | FarmMovementEdgeKeySpecifier),
		fields?: FarmMovementEdgeFieldPolicy,
	},
	FarmMovementType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FarmMovementTypeKeySpecifier | (() => undefined | FarmMovementTypeKeySpecifier),
		fields?: FarmMovementTypeFieldPolicy,
	},
	FarmPlanImportXLSPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FarmPlanImportXLSPayloadKeySpecifier | (() => undefined | FarmPlanImportXLSPayloadKeySpecifier),
		fields?: FarmPlanImportXLSPayloadFieldPolicy,
	},
	FarmSystemTaskType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FarmSystemTaskTypeKeySpecifier | (() => undefined | FarmSystemTaskTypeKeySpecifier),
		fields?: FarmSystemTaskTypeFieldPolicy,
	},
	FarmSystemType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FarmSystemTypeKeySpecifier | (() => undefined | FarmSystemTypeKeySpecifier),
		fields?: FarmSystemTypeFieldPolicy,
	},
	FavoriteActivityTemplatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FavoriteActivityTemplatePayloadKeySpecifier | (() => undefined | FavoriteActivityTemplatePayloadKeySpecifier),
		fields?: FavoriteActivityTemplatePayloadFieldPolicy,
	},
	FavouriteObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FavouriteObjectTypeKeySpecifier | (() => undefined | FavouriteObjectTypeKeySpecifier),
		fields?: FavouriteObjectTypeFieldPolicy,
	},
	FeatureCollectionObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FeatureCollectionObjectTypeKeySpecifier | (() => undefined | FeatureCollectionObjectTypeKeySpecifier),
		fields?: FeatureCollectionObjectTypeFieldPolicy,
	},
	FeatureObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FeatureObjectTypeKeySpecifier | (() => undefined | FeatureObjectTypeKeySpecifier),
		fields?: FeatureObjectTypeFieldPolicy,
	},
	Field?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FieldKeySpecifier | (() => undefined | FieldKeySpecifier),
		fields?: FieldFieldPolicy,
	},
	FieldImage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FieldImageKeySpecifier | (() => undefined | FieldImageKeySpecifier),
		fields?: FieldImageFieldPolicy,
	},
	FilterObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FilterObjectTypeKeySpecifier | (() => undefined | FilterObjectTypeKeySpecifier),
		fields?: FilterObjectTypeFieldPolicy,
	},
	FinancialTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FinancialTransactionKeySpecifier | (() => undefined | FinancialTransactionKeySpecifier),
		fields?: FinancialTransactionFieldPolicy,
	},
	FinancialTransactionAnimal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FinancialTransactionAnimalKeySpecifier | (() => undefined | FinancialTransactionAnimalKeySpecifier),
		fields?: FinancialTransactionAnimalFieldPolicy,
	},
	FinancialTransactionAnimalConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FinancialTransactionAnimalConnectionKeySpecifier | (() => undefined | FinancialTransactionAnimalConnectionKeySpecifier),
		fields?: FinancialTransactionAnimalConnectionFieldPolicy,
	},
	FinancialTransactionAnimalEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FinancialTransactionAnimalEdgeKeySpecifier | (() => undefined | FinancialTransactionAnimalEdgeKeySpecifier),
		fields?: FinancialTransactionAnimalEdgeFieldPolicy,
	},
	FinancialTransactionAnimalErrorObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FinancialTransactionAnimalErrorObjectTypeKeySpecifier | (() => undefined | FinancialTransactionAnimalErrorObjectTypeKeySpecifier),
		fields?: FinancialTransactionAnimalErrorObjectTypeFieldPolicy,
	},
	FinancialTransactionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FinancialTransactionConnectionKeySpecifier | (() => undefined | FinancialTransactionConnectionKeySpecifier),
		fields?: FinancialTransactionConnectionFieldPolicy,
	},
	FinancialTransactionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FinancialTransactionEdgeKeySpecifier | (() => undefined | FinancialTransactionEdgeKeySpecifier),
		fields?: FinancialTransactionEdgeFieldPolicy,
	},
	FormType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FormTypeKeySpecifier | (() => undefined | FormTypeKeySpecifier),
		fields?: FormTypeFieldPolicy,
	},
	ForwardContract?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ForwardContractKeySpecifier | (() => undefined | ForwardContractKeySpecifier),
		fields?: ForwardContractFieldPolicy,
	},
	GeometryObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GeometryObjectTypeKeySpecifier | (() => undefined | GeometryObjectTypeKeySpecifier),
		fields?: GeometryObjectTypeFieldPolicy,
	},
	GlobalFoggleType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GlobalFoggleTypeKeySpecifier | (() => undefined | GlobalFoggleTypeKeySpecifier),
		fields?: GlobalFoggleTypeFieldPolicy,
	},
	Group?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupKeySpecifier | (() => undefined | GroupKeySpecifier),
		fields?: GroupFieldPolicy,
	},
	GroupCategoryObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupCategoryObjectTypeKeySpecifier | (() => undefined | GroupCategoryObjectTypeKeySpecifier),
		fields?: GroupCategoryObjectTypeFieldPolicy,
	},
	GroupChartData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupChartDataKeySpecifier | (() => undefined | GroupChartDataKeySpecifier),
		fields?: GroupChartDataFieldPolicy,
	},
	GroupExtendedList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupExtendedListKeySpecifier | (() => undefined | GroupExtendedListKeySpecifier),
		fields?: GroupExtendedListFieldPolicy,
	},
	GroupImage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupImageKeySpecifier | (() => undefined | GroupImageKeySpecifier),
		fields?: GroupImageFieldPolicy,
	},
	GroupReportType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupReportTypeKeySpecifier | (() => undefined | GroupReportTypeKeySpecifier),
		fields?: GroupReportTypeFieldPolicy,
	},
	GroupWeightInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupWeightInfoKeySpecifier | (() => undefined | GroupWeightInfoKeySpecifier),
		fields?: GroupWeightInfoFieldPolicy,
	},
	HerdDoggIntegrationObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HerdDoggIntegrationObjectTypeKeySpecifier | (() => undefined | HerdDoggIntegrationObjectTypeKeySpecifier),
		fields?: HerdDoggIntegrationObjectTypeFieldPolicy,
	},
	HowDidYouHearAboutBreedrChoices?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HowDidYouHearAboutBreedrChoicesKeySpecifier | (() => undefined | HowDidYouHearAboutBreedrChoicesKeySpecifier),
		fields?: HowDidYouHearAboutBreedrChoicesFieldPolicy,
	},
	ImportCsvPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImportCsvPayloadKeySpecifier | (() => undefined | ImportCsvPayloadKeySpecifier),
		fields?: ImportCsvPayloadFieldPolicy,
	},
	ImportResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImportResultKeySpecifier | (() => undefined | ImportResultKeySpecifier),
		fields?: ImportResultFieldPolicy,
	},
	ImportResultError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImportResultErrorKeySpecifier | (() => undefined | ImportResultErrorKeySpecifier),
		fields?: ImportResultErrorFieldPolicy,
	},
	ImportResultRow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImportResultRowKeySpecifier | (() => undefined | ImportResultRowKeySpecifier),
		fields?: ImportResultRowFieldPolicy,
	},
	ImportResultRowConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImportResultRowConnectionKeySpecifier | (() => undefined | ImportResultRowConnectionKeySpecifier),
		fields?: ImportResultRowConnectionFieldPolicy,
	},
	ImportResultRowEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImportResultRowEdgeKeySpecifier | (() => undefined | ImportResultRowEdgeKeySpecifier),
		fields?: ImportResultRowEdgeFieldPolicy,
	},
	IntegrationSystemType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IntegrationSystemTypeKeySpecifier | (() => undefined | IntegrationSystemTypeKeySpecifier),
		fields?: IntegrationSystemTypeFieldPolicy,
	},
	IntercomCarousel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IntercomCarouselKeySpecifier | (() => undefined | IntercomCarouselKeySpecifier),
		fields?: IntercomCarouselFieldPolicy,
	},
	InventoryInfoType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InventoryInfoTypeKeySpecifier | (() => undefined | InventoryInfoTypeKeySpecifier),
		fields?: InventoryInfoTypeFieldPolicy,
	},
	InviteUserPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InviteUserPayloadKeySpecifier | (() => undefined | InviteUserPayloadKeySpecifier),
		fields?: InviteUserPayloadFieldPolicy,
	},
	Invoice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceKeySpecifier | (() => undefined | InvoiceKeySpecifier),
		fields?: InvoiceFieldPolicy,
	},
	ItemTransactionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemTransactionConnectionKeySpecifier | (() => undefined | ItemTransactionConnectionKeySpecifier),
		fields?: ItemTransactionConnectionFieldPolicy,
	},
	ItemTransactionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemTransactionEdgeKeySpecifier | (() => undefined | ItemTransactionEdgeKeySpecifier),
		fields?: ItemTransactionEdgeFieldPolicy,
	},
	ItemTransactionType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemTransactionTypeKeySpecifier | (() => undefined | ItemTransactionTypeKeySpecifier),
		fields?: ItemTransactionTypeFieldPolicy,
	},
	LabelNumberObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabelNumberObjectTypeKeySpecifier | (() => undefined | LabelNumberObjectTypeKeySpecifier),
		fields?: LabelNumberObjectTypeFieldPolicy,
	},
	LeaveGroupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeaveGroupPayloadKeySpecifier | (() => undefined | LeaveGroupPayloadKeySpecifier),
		fields?: LeaveGroupPayloadFieldPolicy,
	},
	LineItemType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LineItemTypeKeySpecifier | (() => undefined | LineItemTypeKeySpecifier),
		fields?: LineItemTypeFieldPolicy,
	},
	LinkHerdDoggAccountPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinkHerdDoggAccountPayloadKeySpecifier | (() => undefined | LinkHerdDoggAccountPayloadKeySpecifier),
		fields?: LinkHerdDoggAccountPayloadFieldPolicy,
	},
	LitterSizeObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LitterSizeObjectTypeKeySpecifier | (() => undefined | LitterSizeObjectTypeKeySpecifier),
		fields?: LitterSizeObjectTypeFieldPolicy,
	},
	LiveAnimalSalePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LiveAnimalSalePayloadKeySpecifier | (() => undefined | LiveAnimalSalePayloadKeySpecifier),
		fields?: LiveAnimalSalePayloadFieldPolicy,
	},
	LiveSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LiveSessionKeySpecifier | (() => undefined | LiveSessionKeySpecifier),
		fields?: LiveSessionFieldPolicy,
	},
	LiveSessionAnimalError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LiveSessionAnimalErrorKeySpecifier | (() => undefined | LiveSessionAnimalErrorKeySpecifier),
		fields?: LiveSessionAnimalErrorFieldPolicy,
	},
	LiveSessionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LiveSessionConnectionKeySpecifier | (() => undefined | LiveSessionConnectionKeySpecifier),
		fields?: LiveSessionConnectionFieldPolicy,
	},
	LiveSessionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LiveSessionEdgeKeySpecifier | (() => undefined | LiveSessionEdgeKeySpecifier),
		fields?: LiveSessionEdgeFieldPolicy,
	},
	LiveSessionError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LiveSessionErrorKeySpecifier | (() => undefined | LiveSessionErrorKeySpecifier),
		fields?: LiveSessionErrorFieldPolicy,
	},
	LoadCrushAppSessionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LoadCrushAppSessionPayloadKeySpecifier | (() => undefined | LoadCrushAppSessionPayloadKeySpecifier),
		fields?: LoadCrushAppSessionPayloadFieldPolicy,
	},
	LocationSearchBusinessUnit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocationSearchBusinessUnitKeySpecifier | (() => undefined | LocationSearchBusinessUnitKeySpecifier),
		fields?: LocationSearchBusinessUnitFieldPolicy,
	},
	LogActivityBulkPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LogActivityBulkPayloadKeySpecifier | (() => undefined | LogActivityBulkPayloadKeySpecifier),
		fields?: LogActivityBulkPayloadFieldPolicy,
	},
	LogBirthIntoBatchPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LogBirthIntoBatchPayloadKeySpecifier | (() => undefined | LogBirthIntoBatchPayloadKeySpecifier),
		fields?: LogBirthIntoBatchPayloadFieldPolicy,
	},
	LogStillBirthPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LogStillBirthPayloadKeySpecifier | (() => undefined | LogStillBirthPayloadKeySpecifier),
		fields?: LogStillBirthPayloadFieldPolicy,
	},
	Lot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LotKeySpecifier | (() => undefined | LotKeySpecifier),
		fields?: LotFieldPolicy,
	},
	LotBuyerReceivedAnimalsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LotBuyerReceivedAnimalsPayloadKeySpecifier | (() => undefined | LotBuyerReceivedAnimalsPayloadKeySpecifier),
		fields?: LotBuyerReceivedAnimalsPayloadFieldPolicy,
	},
	LotImage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LotImageKeySpecifier | (() => undefined | LotImageKeySpecifier),
		fields?: LotImageFieldPolicy,
	},
	LotImageThumbnailType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LotImageThumbnailTypeKeySpecifier | (() => undefined | LotImageThumbnailTypeKeySpecifier),
		fields?: LotImageThumbnailTypeFieldPolicy,
	},
	LotInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LotInfoKeySpecifier | (() => undefined | LotInfoKeySpecifier),
		fields?: LotInfoFieldPolicy,
	},
	LotSellerSentAnimalsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LotSellerSentAnimalsPayloadKeySpecifier | (() => undefined | LotSellerSentAnimalsPayloadKeySpecifier),
		fields?: LotSellerSentAnimalsPayloadFieldPolicy,
	},
	MarkAnimalsAsDeadPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MarkAnimalsAsDeadPayloadKeySpecifier | (() => undefined | MarkAnimalsAsDeadPayloadKeySpecifier),
		fields?: MarkAnimalsAsDeadPayloadFieldPolicy,
	},
	MarkAsDoneAnimalsAlertsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MarkAsDoneAnimalsAlertsPayloadKeySpecifier | (() => undefined | MarkAsDoneAnimalsAlertsPayloadKeySpecifier),
		fields?: MarkAsDoneAnimalsAlertsPayloadFieldPolicy,
	},
	MarkAsPaidLotOfferPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MarkAsPaidLotOfferPayloadKeySpecifier | (() => undefined | MarkAsPaidLotOfferPayloadKeySpecifier),
		fields?: MarkAsPaidLotOfferPayloadFieldPolicy,
	},
	MarkReadMessagePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MarkReadMessagePayloadKeySpecifier | (() => undefined | MarkReadMessagePayloadKeySpecifier),
		fields?: MarkReadMessagePayloadFieldPolicy,
	},
	MarkReadNotificationsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MarkReadNotificationsPayloadKeySpecifier | (() => undefined | MarkReadNotificationsPayloadKeySpecifier),
		fields?: MarkReadNotificationsPayloadFieldPolicy,
	},
	MeasuredWeightEventType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MeasuredWeightEventTypeKeySpecifier | (() => undefined | MeasuredWeightEventTypeKeySpecifier),
		fields?: MeasuredWeightEventTypeFieldPolicy,
	},
	MeasurementChartData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MeasurementChartDataKeySpecifier | (() => undefined | MeasurementChartDataKeySpecifier),
		fields?: MeasurementChartDataFieldPolicy,
	},
	MedicineActiveIngredientType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MedicineActiveIngredientTypeKeySpecifier | (() => undefined | MedicineActiveIngredientTypeKeySpecifier),
		fields?: MedicineActiveIngredientTypeFieldPolicy,
	},
	MedicineApplicationMethodType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MedicineApplicationMethodTypeKeySpecifier | (() => undefined | MedicineApplicationMethodTypeKeySpecifier),
		fields?: MedicineApplicationMethodTypeFieldPolicy,
	},
	MedicineCourseObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MedicineCourseObjectTypeKeySpecifier | (() => undefined | MedicineCourseObjectTypeKeySpecifier),
		fields?: MedicineCourseObjectTypeFieldPolicy,
	},
	MedicineCourseStageObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MedicineCourseStageObjectTypeKeySpecifier | (() => undefined | MedicineCourseStageObjectTypeKeySpecifier),
		fields?: MedicineCourseStageObjectTypeFieldPolicy,
	},
	MedicineGTINType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MedicineGTINTypeKeySpecifier | (() => undefined | MedicineGTINTypeKeySpecifier),
		fields?: MedicineGTINTypeFieldPolicy,
	},
	MedicineType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MedicineTypeKeySpecifier | (() => undefined | MedicineTypeKeySpecifier),
		fields?: MedicineTypeFieldPolicy,
	},
	MedicineWithdrawalType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MedicineWithdrawalTypeKeySpecifier | (() => undefined | MedicineWithdrawalTypeKeySpecifier),
		fields?: MedicineWithdrawalTypeFieldPolicy,
	},
	MergeAnimalTagsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MergeAnimalTagsPayloadKeySpecifier | (() => undefined | MergeAnimalTagsPayloadKeySpecifier),
		fields?: MergeAnimalTagsPayloadFieldPolicy,
	},
	MergeGroupsToGroupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MergeGroupsToGroupPayloadKeySpecifier | (() => undefined | MergeGroupsToGroupPayloadKeySpecifier),
		fields?: MergeGroupsToGroupPayloadFieldPolicy,
	},
	Message?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MessageKeySpecifier | (() => undefined | MessageKeySpecifier),
		fields?: MessageFieldPolicy,
	},
	MessageConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MessageConnectionKeySpecifier | (() => undefined | MessageConnectionKeySpecifier),
		fields?: MessageConnectionFieldPolicy,
	},
	MessageEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MessageEdgeKeySpecifier | (() => undefined | MessageEdgeKeySpecifier),
		fields?: MessageEdgeFieldPolicy,
	},
	MoveAnimalsToFieldPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MoveAnimalsToFieldPayloadKeySpecifier | (() => undefined | MoveAnimalsToFieldPayloadKeySpecifier),
		fields?: MoveAnimalsToFieldPayloadFieldPolicy,
	},
	MoveAnimalsToGroupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MoveAnimalsToGroupPayloadKeySpecifier | (() => undefined | MoveAnimalsToGroupPayloadKeySpecifier),
		fields?: MoveAnimalsToGroupPayloadFieldPolicy,
	},
	MoveGroupsToFieldPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MoveGroupsToFieldPayloadKeySpecifier | (() => undefined | MoveGroupsToFieldPayloadKeySpecifier),
		fields?: MoveGroupsToFieldPayloadFieldPolicy,
	},
	MovementLocationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MovementLocationTypeKeySpecifier | (() => undefined | MovementLocationTypeKeySpecifier),
		fields?: MovementLocationTypeFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	NeogenEPD?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NeogenEPDKeySpecifier | (() => undefined | NeogenEPDKeySpecifier),
		fields?: NeogenEPDFieldPolicy,
	},
	NewsletterEmailSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NewsletterEmailSettingsKeySpecifier | (() => undefined | NewsletterEmailSettingsKeySpecifier),
		fields?: NewsletterEmailSettingsFieldPolicy,
	},
	Notification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationKeySpecifier | (() => undefined | NotificationKeySpecifier),
		fields?: NotificationFieldPolicy,
	},
	NotificationConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationConnectionKeySpecifier | (() => undefined | NotificationConnectionKeySpecifier),
		fields?: NotificationConnectionFieldPolicy,
	},
	NotificationEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationEdgeKeySpecifier | (() => undefined | NotificationEdgeKeySpecifier),
		fields?: NotificationEdgeFieldPolicy,
	},
	NotificationSettingItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationSettingItemKeySpecifier | (() => undefined | NotificationSettingItemKeySpecifier),
		fields?: NotificationSettingItemFieldPolicy,
	},
	NotificationSettingItemType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationSettingItemTypeKeySpecifier | (() => undefined | NotificationSettingItemTypeKeySpecifier),
		fields?: NotificationSettingItemTypeFieldPolicy,
	},
	NotificationSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationSettingsKeySpecifier | (() => undefined | NotificationSettingsKeySpecifier),
		fields?: NotificationSettingsFieldPolicy,
	},
	NotificationTypeItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationTypeItemKeySpecifier | (() => undefined | NotificationTypeItemKeySpecifier),
		fields?: NotificationTypeItemFieldPolicy,
	},
	Offer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OfferKeySpecifier | (() => undefined | OfferKeySpecifier),
		fields?: OfferFieldPolicy,
	},
	OfferConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OfferConnectionKeySpecifier | (() => undefined | OfferConnectionKeySpecifier),
		fields?: OfferConnectionFieldPolicy,
	},
	OfferEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OfferEdgeKeySpecifier | (() => undefined | OfferEdgeKeySpecifier),
		fields?: OfferEdgeFieldPolicy,
	},
	OfferMarkAsReadPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OfferMarkAsReadPayloadKeySpecifier | (() => undefined | OfferMarkAsReadPayloadKeySpecifier),
		fields?: OfferMarkAsReadPayloadFieldPolicy,
	},
	OnboardAnimalPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OnboardAnimalPayloadKeySpecifier | (() => undefined | OnboardAnimalPayloadKeySpecifier),
		fields?: OnboardAnimalPayloadFieldPolicy,
	},
	OptionChoice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OptionChoiceKeySpecifier | (() => undefined | OptionChoiceKeySpecifier),
		fields?: OptionChoiceFieldPolicy,
	},
	Organisation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganisationKeySpecifier | (() => undefined | OrganisationKeySpecifier),
		fields?: OrganisationFieldPolicy,
	},
	OrganisationBusinessUnits?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganisationBusinessUnitsKeySpecifier | (() => undefined | OrganisationBusinessUnitsKeySpecifier),
		fields?: OrganisationBusinessUnitsFieldPolicy,
	},
	OrganisationMember?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganisationMemberKeySpecifier | (() => undefined | OrganisationMemberKeySpecifier),
		fields?: OrganisationMemberFieldPolicy,
	},
	OwnLot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OwnLotKeySpecifier | (() => undefined | OwnLotKeySpecifier),
		fields?: OwnLotFieldPolicy,
	},
	OwnLotConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OwnLotConnectionKeySpecifier | (() => undefined | OwnLotConnectionKeySpecifier),
		fields?: OwnLotConnectionFieldPolicy,
	},
	OwnLotEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OwnLotEdgeKeySpecifier | (() => undefined | OwnLotEdgeKeySpecifier),
		fields?: OwnLotEdgeFieldPolicy,
	},
	OwnWant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OwnWantKeySpecifier | (() => undefined | OwnWantKeySpecifier),
		fields?: OwnWantFieldPolicy,
	},
	PageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageInfoKeySpecifier | (() => undefined | PageInfoKeySpecifier),
		fields?: PageInfoFieldPolicy,
	},
	PageInfoObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageInfoObjectTypeKeySpecifier | (() => undefined | PageInfoObjectTypeKeySpecifier),
		fields?: PageInfoObjectTypeFieldPolicy,
	},
	PastureType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PastureTypeKeySpecifier | (() => undefined | PastureTypeKeySpecifier),
		fields?: PastureTypeFieldPolicy,
	},
	PaymentMethod?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentMethodKeySpecifier | (() => undefined | PaymentMethodKeySpecifier),
		fields?: PaymentMethodFieldPolicy,
	},
	PendoUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendoUserKeySpecifier | (() => undefined | PendoUserKeySpecifier),
		fields?: PendoUserFieldPolicy,
	},
	PerformanceChartData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PerformanceChartDataKeySpecifier | (() => undefined | PerformanceChartDataKeySpecifier),
		fields?: PerformanceChartDataFieldPolicy,
	},
	PieChartDataObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PieChartDataObjectTypeKeySpecifier | (() => undefined | PieChartDataObjectTypeKeySpecifier),
		fields?: PieChartDataObjectTypeFieldPolicy,
	},
	PostToGroupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PostToGroupPayloadKeySpecifier | (() => undefined | PostToGroupPayloadKeySpecifier),
		fields?: PostToGroupPayloadFieldPolicy,
	},
	PostType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PostTypeKeySpecifier | (() => undefined | PostTypeKeySpecifier),
		fields?: PostTypeFieldPolicy,
	},
	PreferredBusinessUnit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PreferredBusinessUnitKeySpecifier | (() => undefined | PreferredBusinessUnitKeySpecifier),
		fields?: PreferredBusinessUnitFieldPolicy,
	},
	ProcessedItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProcessedItemKeySpecifier | (() => undefined | ProcessedItemKeySpecifier),
		fields?: ProcessedItemFieldPolicy,
	},
	ProducerGroupMemberType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProducerGroupMemberTypeKeySpecifier | (() => undefined | ProducerGroupMemberTypeKeySpecifier),
		fields?: ProducerGroupMemberTypeFieldPolicy,
	},
	ProducerGroupType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProducerGroupTypeKeySpecifier | (() => undefined | ProducerGroupTypeKeySpecifier),
		fields?: ProducerGroupTypeFieldPolicy,
	},
	PublicAnimal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublicAnimalKeySpecifier | (() => undefined | PublicAnimalKeySpecifier),
		fields?: PublicAnimalFieldPolicy,
	},
	PublicBirthInformation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublicBirthInformationKeySpecifier | (() => undefined | PublicBirthInformationKeySpecifier),
		fields?: PublicBirthInformationFieldPolicy,
	},
	PublicBusinessUnit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublicBusinessUnitKeySpecifier | (() => undefined | PublicBusinessUnitKeySpecifier),
		fields?: PublicBusinessUnitFieldPolicy,
	},
	PublicDeliveryAddressType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublicDeliveryAddressTypeKeySpecifier | (() => undefined | PublicDeliveryAddressTypeKeySpecifier),
		fields?: PublicDeliveryAddressTypeFieldPolicy,
	},
	PublicLot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublicLotKeySpecifier | (() => undefined | PublicLotKeySpecifier),
		fields?: PublicLotFieldPolicy,
	},
	PublicLotConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublicLotConnectionKeySpecifier | (() => undefined | PublicLotConnectionKeySpecifier),
		fields?: PublicLotConnectionFieldPolicy,
	},
	PublicLotEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublicLotEdgeKeySpecifier | (() => undefined | PublicLotEdgeKeySpecifier),
		fields?: PublicLotEdgeFieldPolicy,
	},
	PublicWant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublicWantKeySpecifier | (() => undefined | PublicWantKeySpecifier),
		fields?: PublicWantFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	QuicksightParameter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuicksightParameterKeySpecifier | (() => undefined | QuicksightParameterKeySpecifier),
		fields?: QuicksightParameterFieldPolicy,
	},
	QuicksightReportType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuicksightReportTypeKeySpecifier | (() => undefined | QuicksightReportTypeKeySpecifier),
		fields?: QuicksightReportTypeFieldPolicy,
	},
	ReInviteUserPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReInviteUserPayloadKeySpecifier | (() => undefined | ReInviteUserPayloadKeySpecifier),
		fields?: ReInviteUserPayloadFieldPolicy,
	},
	ReferenceChartData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReferenceChartDataKeySpecifier | (() => undefined | ReferenceChartDataKeySpecifier),
		fields?: ReferenceChartDataFieldPolicy,
	},
	Region?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegionKeySpecifier | (() => undefined | RegionKeySpecifier),
		fields?: RegionFieldPolicy,
	},
	RegisterDeviceIdPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegisterDeviceIdPayloadKeySpecifier | (() => undefined | RegisterDeviceIdPayloadKeySpecifier),
		fields?: RegisterDeviceIdPayloadFieldPolicy,
	},
	RegularWithdrawalType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegularWithdrawalTypeKeySpecifier | (() => undefined | RegularWithdrawalTypeKeySpecifier),
		fields?: RegularWithdrawalTypeFieldPolicy,
	},
	RegulatoryAddressType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegulatoryAddressTypeKeySpecifier | (() => undefined | RegulatoryAddressTypeKeySpecifier),
		fields?: RegulatoryAddressTypeFieldPolicy,
	},
	RegulatoryApprovalConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegulatoryApprovalConnectionKeySpecifier | (() => undefined | RegulatoryApprovalConnectionKeySpecifier),
		fields?: RegulatoryApprovalConnectionFieldPolicy,
	},
	RegulatoryApprovalEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegulatoryApprovalEdgeKeySpecifier | (() => undefined | RegulatoryApprovalEdgeKeySpecifier),
		fields?: RegulatoryApprovalEdgeFieldPolicy,
	},
	RegulatoryApprovalType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegulatoryApprovalTypeKeySpecifier | (() => undefined | RegulatoryApprovalTypeKeySpecifier),
		fields?: RegulatoryApprovalTypeFieldPolicy,
	},
	RegulatoryTransactionApprovalSummaryType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegulatoryTransactionApprovalSummaryTypeKeySpecifier | (() => undefined | RegulatoryTransactionApprovalSummaryTypeKeySpecifier),
		fields?: RegulatoryTransactionApprovalSummaryTypeFieldPolicy,
	},
	RegulatoryTransactionApprovalType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegulatoryTransactionApprovalTypeKeySpecifier | (() => undefined | RegulatoryTransactionApprovalTypeKeySpecifier),
		fields?: RegulatoryTransactionApprovalTypeFieldPolicy,
	},
	RegulatoryTransactionApprovalsAbortPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegulatoryTransactionApprovalsAbortPayloadKeySpecifier | (() => undefined | RegulatoryTransactionApprovalsAbortPayloadKeySpecifier),
		fields?: RegulatoryTransactionApprovalsAbortPayloadFieldPolicy,
	},
	RegulatoryTransactionApprovalsChangeDatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegulatoryTransactionApprovalsChangeDatePayloadKeySpecifier | (() => undefined | RegulatoryTransactionApprovalsChangeDatePayloadKeySpecifier),
		fields?: RegulatoryTransactionApprovalsChangeDatePayloadFieldPolicy,
	},
	RegulatoryTransactionApprovalsResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegulatoryTransactionApprovalsResponsePayloadKeySpecifier | (() => undefined | RegulatoryTransactionApprovalsResponsePayloadKeySpecifier),
		fields?: RegulatoryTransactionApprovalsResponsePayloadFieldPolicy,
	},
	RegulatoryTransactionApprovalsRetryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegulatoryTransactionApprovalsRetryPayloadKeySpecifier | (() => undefined | RegulatoryTransactionApprovalsRetryPayloadKeySpecifier),
		fields?: RegulatoryTransactionApprovalsRetryPayloadFieldPolicy,
	},
	RegulatoryTransactionType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegulatoryTransactionTypeKeySpecifier | (() => undefined | RegulatoryTransactionTypeKeySpecifier),
		fields?: RegulatoryTransactionTypeFieldPolicy,
	},
	RegulatoryTransactionWarningsObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegulatoryTransactionWarningsObjectTypeKeySpecifier | (() => undefined | RegulatoryTransactionWarningsObjectTypeKeySpecifier),
		fields?: RegulatoryTransactionWarningsObjectTypeFieldPolicy,
	},
	RejectDeliveryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RejectDeliveryPayloadKeySpecifier | (() => undefined | RejectDeliveryPayloadKeySpecifier),
		fields?: RejectDeliveryPayloadFieldPolicy,
	},
	RemoveAnimalsFromFinancialTransactionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RemoveAnimalsFromFinancialTransactionPayloadKeySpecifier | (() => undefined | RemoveAnimalsFromFinancialTransactionPayloadKeySpecifier),
		fields?: RemoveAnimalsFromFinancialTransactionPayloadFieldPolicy,
	},
	ReportType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportTypeKeySpecifier | (() => undefined | ReportTypeKeySpecifier),
		fields?: ReportTypeFieldPolicy,
	},
	ResponseToLotOfferPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ResponseToLotOfferPayloadKeySpecifier | (() => undefined | ResponseToLotOfferPayloadKeySpecifier),
		fields?: ResponseToLotOfferPayloadFieldPolicy,
	},
	RestoreAnimalsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RestoreAnimalsPayloadKeySpecifier | (() => undefined | RestoreAnimalsPayloadKeySpecifier),
		fields?: RestoreAnimalsPayloadFieldPolicy,
	},
	RetrieveChannelPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RetrieveChannelPayloadKeySpecifier | (() => undefined | RetrieveChannelPayloadKeySpecifier),
		fields?: RetrieveChannelPayloadFieldPolicy,
	},
	Role?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoleKeySpecifier | (() => undefined | RoleKeySpecifier),
		fields?: RoleFieldPolicy,
	},
	SaveCrushAppSessionEnhancedPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaveCrushAppSessionEnhancedPayloadKeySpecifier | (() => undefined | SaveCrushAppSessionEnhancedPayloadKeySpecifier),
		fields?: SaveCrushAppSessionEnhancedPayloadFieldPolicy,
	},
	SaveCrushAppSessionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaveCrushAppSessionPayloadKeySpecifier | (() => undefined | SaveCrushAppSessionPayloadKeySpecifier),
		fields?: SaveCrushAppSessionPayloadFieldPolicy,
	},
	ScotMovesConnectionType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScotMovesConnectionTypeKeySpecifier | (() => undefined | ScotMovesConnectionTypeKeySpecifier),
		fields?: ScotMovesConnectionTypeFieldPolicy,
	},
	SearchBusinessUnit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SearchBusinessUnitKeySpecifier | (() => undefined | SearchBusinessUnitKeySpecifier),
		fields?: SearchBusinessUnitFieldPolicy,
	},
	SearchableFieldObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SearchableFieldObjectTypeKeySpecifier | (() => undefined | SearchableFieldObjectTypeKeySpecifier),
		fields?: SearchableFieldObjectTypeFieldPolicy,
	},
	SendApprovePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendApprovePayloadKeySpecifier | (() => undefined | SendApprovePayloadKeySpecifier),
		fields?: SendApprovePayloadFieldPolicy,
	},
	SendBirdUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendBirdUserKeySpecifier | (() => undefined | SendBirdUserKeySpecifier),
		fields?: SendBirdUserFieldPolicy,
	},
	SendCodePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendCodePayloadKeySpecifier | (() => undefined | SendCodePayloadKeySpecifier),
		fields?: SendCodePayloadFieldPolicy,
	},
	SendCompleteBcmsSetupEmailPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendCompleteBcmsSetupEmailPayloadKeySpecifier | (() => undefined | SendCompleteBcmsSetupEmailPayloadKeySpecifier),
		fields?: SendCompleteBcmsSetupEmailPayloadFieldPolicy,
	},
	SendMessagePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendMessagePayloadKeySpecifier | (() => undefined | SendMessagePayloadKeySpecifier),
		fields?: SendMessagePayloadFieldPolicy,
	},
	SendResetPasswordEmailPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendResetPasswordEmailPayloadKeySpecifier | (() => undefined | SendResetPasswordEmailPayloadKeySpecifier),
		fields?: SendResetPasswordEmailPayloadFieldPolicy,
	},
	SeriesObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SeriesObjectTypeKeySpecifier | (() => undefined | SeriesObjectTypeKeySpecifier),
		fields?: SeriesObjectTypeFieldPolicy,
	},
	SessionAnimal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SessionAnimalKeySpecifier | (() => undefined | SessionAnimalKeySpecifier),
		fields?: SessionAnimalFieldPolicy,
	},
	SessionAnimalConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SessionAnimalConnectionKeySpecifier | (() => undefined | SessionAnimalConnectionKeySpecifier),
		fields?: SessionAnimalConnectionFieldPolicy,
	},
	SessionAnimalEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SessionAnimalEdgeKeySpecifier | (() => undefined | SessionAnimalEdgeKeySpecifier),
		fields?: SessionAnimalEdgeFieldPolicy,
	},
	SetFavouritePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SetFavouritePayloadKeySpecifier | (() => undefined | SetFavouritePayloadKeySpecifier),
		fields?: SetFavouritePayloadFieldPolicy,
	},
	SexClassification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SexClassificationKeySpecifier | (() => undefined | SexClassificationKeySpecifier),
		fields?: SexClassificationFieldPolicy,
	},
	SignUpPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SignUpPayloadKeySpecifier | (() => undefined | SignUpPayloadKeySpecifier),
		fields?: SignUpPayloadFieldPolicy,
	},
	SignUpUserPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SignUpUserPayloadKeySpecifier | (() => undefined | SignUpUserPayloadKeySpecifier),
		fields?: SignUpUserPayloadFieldPolicy,
	},
	Sire?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SireKeySpecifier | (() => undefined | SireKeySpecifier),
		fields?: SireFieldPolicy,
	},
	SnoozeAnimalsAlertsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SnoozeAnimalsAlertsPayloadKeySpecifier | (() => undefined | SnoozeAnimalsAlertsPayloadKeySpecifier),
		fields?: SnoozeAnimalsAlertsPayloadFieldPolicy,
	},
	SoftDeleteAnimalsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SoftDeleteAnimalsPayloadKeySpecifier | (() => undefined | SoftDeleteAnimalsPayloadKeySpecifier),
		fields?: SoftDeleteAnimalsPayloadFieldPolicy,
	},
	SplitFieldPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SplitFieldPayloadKeySpecifier | (() => undefined | SplitFieldPayloadKeySpecifier),
		fields?: SplitFieldPayloadFieldPolicy,
	},
	StartFarmSystemTaskPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StartFarmSystemTaskPayloadKeySpecifier | (() => undefined | StartFarmSystemTaskPayloadKeySpecifier),
		fields?: StartFarmSystemTaskPayloadFieldPolicy,
	},
	Statistic?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StatisticKeySpecifier | (() => undefined | StatisticKeySpecifier),
		fields?: StatisticFieldPolicy,
	},
	StockItemListType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StockItemListTypeKeySpecifier | (() => undefined | StockItemListTypeKeySpecifier),
		fields?: StockItemListTypeFieldPolicy,
	},
	StocktakeObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StocktakeObjectTypeKeySpecifier | (() => undefined | StocktakeObjectTypeKeySpecifier),
		fields?: StocktakeObjectTypeFieldPolicy,
	},
	StocktakeObjectTypeConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StocktakeObjectTypeConnectionKeySpecifier | (() => undefined | StocktakeObjectTypeConnectionKeySpecifier),
		fields?: StocktakeObjectTypeConnectionFieldPolicy,
	},
	StocktakeObjectTypeEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StocktakeObjectTypeEdgeKeySpecifier | (() => undefined | StocktakeObjectTypeEdgeKeySpecifier),
		fields?: StocktakeObjectTypeEdgeFieldPolicy,
	},
	SubscriptionActivationTokenType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionActivationTokenTypeKeySpecifier | (() => undefined | SubscriptionActivationTokenTypeKeySpecifier),
		fields?: SubscriptionActivationTokenTypeFieldPolicy,
	},
	SubscriptionCatalogChoiceType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionCatalogChoiceTypeKeySpecifier | (() => undefined | SubscriptionCatalogChoiceTypeKeySpecifier),
		fields?: SubscriptionCatalogChoiceTypeFieldPolicy,
	},
	SubscriptionCatalogType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionCatalogTypeKeySpecifier | (() => undefined | SubscriptionCatalogTypeKeySpecifier),
		fields?: SubscriptionCatalogTypeFieldPolicy,
	},
	SubscriptionInvoice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionInvoiceKeySpecifier | (() => undefined | SubscriptionInvoiceKeySpecifier),
		fields?: SubscriptionInvoiceFieldPolicy,
	},
	SubscriptionInvoiceConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionInvoiceConnectionKeySpecifier | (() => undefined | SubscriptionInvoiceConnectionKeySpecifier),
		fields?: SubscriptionInvoiceConnectionFieldPolicy,
	},
	SubscriptionInvoiceEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionInvoiceEdgeKeySpecifier | (() => undefined | SubscriptionInvoiceEdgeKeySpecifier),
		fields?: SubscriptionInvoiceEdgeFieldPolicy,
	},
	SubscriptionPlan?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionPlanKeySpecifier | (() => undefined | SubscriptionPlanKeySpecifier),
		fields?: SubscriptionPlanFieldPolicy,
	},
	SubscriptionPlanFeature?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionPlanFeatureKeySpecifier | (() => undefined | SubscriptionPlanFeatureKeySpecifier),
		fields?: SubscriptionPlanFeatureFieldPolicy,
	},
	SubscriptionPrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionPriceKeySpecifier | (() => undefined | SubscriptionPriceKeySpecifier),
		fields?: SubscriptionPriceFieldPolicy,
	},
	SubscriptionStatusType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionStatusTypeKeySpecifier | (() => undefined | SubscriptionStatusTypeKeySpecifier),
		fields?: SubscriptionStatusTypeFieldPolicy,
	},
	SummaryMetrics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SummaryMetricsKeySpecifier | (() => undefined | SummaryMetricsKeySpecifier),
		fields?: SummaryMetricsFieldPolicy,
	},
	SupplyChainPageObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SupplyChainPageObjectTypeKeySpecifier | (() => undefined | SupplyChainPageObjectTypeKeySpecifier),
		fields?: SupplyChainPageObjectTypeFieldPolicy,
	},
	SystemCredentialFieldType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SystemCredentialFieldTypeKeySpecifier | (() => undefined | SystemCredentialFieldTypeKeySpecifier),
		fields?: SystemCredentialFieldTypeFieldPolicy,
	},
	TableColumnDataObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TableColumnDataObjectTypeKeySpecifier | (() => undefined | TableColumnDataObjectTypeKeySpecifier),
		fields?: TableColumnDataObjectTypeFieldPolicy,
	},
	TableDataObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TableDataObjectTypeKeySpecifier | (() => undefined | TableDataObjectTypeKeySpecifier),
		fields?: TableDataObjectTypeFieldPolicy,
	},
	TagSchemaInterface?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagSchemaInterfaceKeySpecifier | (() => undefined | TagSchemaInterfaceKeySpecifier),
		fields?: TagSchemaInterfaceFieldPolicy,
	},
	TargetWeightType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TargetWeightTypeKeySpecifier | (() => undefined | TargetWeightTypeKeySpecifier),
		fields?: TargetWeightTypeFieldPolicy,
	},
	Task?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskKeySpecifier | (() => undefined | TaskKeySpecifier),
		fields?: TaskFieldPolicy,
	},
	TaskAttachment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskAttachmentKeySpecifier | (() => undefined | TaskAttachmentKeySpecifier),
		fields?: TaskAttachmentFieldPolicy,
	},
	TaskConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskConnectionKeySpecifier | (() => undefined | TaskConnectionKeySpecifier),
		fields?: TaskConnectionFieldPolicy,
	},
	TaskEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskEdgeKeySpecifier | (() => undefined | TaskEdgeKeySpecifier),
		fields?: TaskEdgeFieldPolicy,
	},
	TermsAndConditionsAcceptPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TermsAndConditionsAcceptPayloadKeySpecifier | (() => undefined | TermsAndConditionsAcceptPayloadKeySpecifier),
		fields?: TermsAndConditionsAcceptPayloadFieldPolicy,
	},
	TermsAndConditionsObjectType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TermsAndConditionsObjectTypeKeySpecifier | (() => undefined | TermsAndConditionsObjectTypeKeySpecifier),
		fields?: TermsAndConditionsObjectTypeFieldPolicy,
	},
	TimestampChartData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TimestampChartDataKeySpecifier | (() => undefined | TimestampChartDataKeySpecifier),
		fields?: TimestampChartDataFieldPolicy,
	},
	TradingPlan?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TradingPlanKeySpecifier | (() => undefined | TradingPlanKeySpecifier),
		fields?: TradingPlanFieldPolicy,
	},
	TradingStartUpMessageType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TradingStartUpMessageTypeKeySpecifier | (() => undefined | TradingStartUpMessageTypeKeySpecifier),
		fields?: TradingStartUpMessageTypeFieldPolicy,
	},
	TradingType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TradingTypeKeySpecifier | (() => undefined | TradingTypeKeySpecifier),
		fields?: TradingTypeFieldPolicy,
	},
	TransferOwnershipPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransferOwnershipPayloadKeySpecifier | (() => undefined | TransferOwnershipPayloadKeySpecifier),
		fields?: TransferOwnershipPayloadFieldPolicy,
	},
	TruTestImportXlsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TruTestImportXlsPayloadKeySpecifier | (() => undefined | TruTestImportXlsPayloadKeySpecifier),
		fields?: TruTestImportXlsPayloadFieldPolicy,
	},
	UnRegisterDeviceIdPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnRegisterDeviceIdPayloadKeySpecifier | (() => undefined | UnRegisterDeviceIdPayloadKeySpecifier),
		fields?: UnRegisterDeviceIdPayloadFieldPolicy,
	},
	UndoDeliveryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UndoDeliveryPayloadKeySpecifier | (() => undefined | UndoDeliveryPayloadKeySpecifier),
		fields?: UndoDeliveryPayloadFieldPolicy,
	},
	UnitOfMeasurement?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnitOfMeasurementKeySpecifier | (() => undefined | UnitOfMeasurementKeySpecifier),
		fields?: UnitOfMeasurementFieldPolicy,
	},
	UnlinkHerdDoggAccountPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnlinkHerdDoggAccountPayloadKeySpecifier | (() => undefined | UnlinkHerdDoggAccountPayloadKeySpecifier),
		fields?: UnlinkHerdDoggAccountPayloadFieldPolicy,
	},
	UnprocessedAnimal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnprocessedAnimalKeySpecifier | (() => undefined | UnprocessedAnimalKeySpecifier),
		fields?: UnprocessedAnimalFieldPolicy,
	},
	UnprocessedItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnprocessedItemKeySpecifier | (() => undefined | UnprocessedItemKeySpecifier),
		fields?: UnprocessedItemFieldPolicy,
	},
	UnsetFavouritePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnsetFavouritePayloadKeySpecifier | (() => undefined | UnsetFavouritePayloadKeySpecifier),
		fields?: UnsetFavouritePayloadFieldPolicy,
	},
	UpdateAnimalFilterPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateAnimalFilterPayloadKeySpecifier | (() => undefined | UpdateAnimalFilterPayloadKeySpecifier),
		fields?: UpdateAnimalFilterPayloadFieldPolicy,
	},
	UpdateAnimalPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateAnimalPayloadKeySpecifier | (() => undefined | UpdateAnimalPayloadKeySpecifier),
		fields?: UpdateAnimalPayloadFieldPolicy,
	},
	UpdateBankDetailsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateBankDetailsPayloadKeySpecifier | (() => undefined | UpdateBankDetailsPayloadKeySpecifier),
		fields?: UpdateBankDetailsPayloadFieldPolicy,
	},
	UpdateBatchPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateBatchPayloadKeySpecifier | (() => undefined | UpdateBatchPayloadKeySpecifier),
		fields?: UpdateBatchPayloadFieldPolicy,
	},
	UpdateBusinessUnitAccreditationPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateBusinessUnitAccreditationPayloadKeySpecifier | (() => undefined | UpdateBusinessUnitAccreditationPayloadKeySpecifier),
		fields?: UpdateBusinessUnitAccreditationPayloadFieldPolicy,
	},
	UpdateBusinessUnitSettingsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateBusinessUnitSettingsPayloadKeySpecifier | (() => undefined | UpdateBusinessUnitSettingsPayloadKeySpecifier),
		fields?: UpdateBusinessUnitSettingsPayloadFieldPolicy,
	},
	UpdateBusinessUnitTargetPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateBusinessUnitTargetPayloadKeySpecifier | (() => undefined | UpdateBusinessUnitTargetPayloadKeySpecifier),
		fields?: UpdateBusinessUnitTargetPayloadFieldPolicy,
	},
	UpdateBusinessUnitUserPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateBusinessUnitUserPayloadKeySpecifier | (() => undefined | UpdateBusinessUnitUserPayloadKeySpecifier),
		fields?: UpdateBusinessUnitUserPayloadFieldPolicy,
	},
	UpdateContactPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateContactPayloadKeySpecifier | (() => undefined | UpdateContactPayloadKeySpecifier),
		fields?: UpdateContactPayloadFieldPolicy,
	},
	UpdateDeliveryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDeliveryPayloadKeySpecifier | (() => undefined | UpdateDeliveryPayloadKeySpecifier),
		fields?: UpdateDeliveryPayloadFieldPolicy,
	},
	UpdateDistributionListPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDistributionListPayloadKeySpecifier | (() => undefined | UpdateDistributionListPayloadKeySpecifier),
		fields?: UpdateDistributionListPayloadFieldPolicy,
	},
	UpdateEmailPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateEmailPayloadKeySpecifier | (() => undefined | UpdateEmailPayloadKeySpecifier),
		fields?: UpdateEmailPayloadFieldPolicy,
	},
	UpdateFarmSystemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateFarmSystemPayloadKeySpecifier | (() => undefined | UpdateFarmSystemPayloadKeySpecifier),
		fields?: UpdateFarmSystemPayloadFieldPolicy,
	},
	UpdateFieldPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateFieldPayloadKeySpecifier | (() => undefined | UpdateFieldPayloadKeySpecifier),
		fields?: UpdateFieldPayloadFieldPolicy,
	},
	UpdateFinancialTransactionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateFinancialTransactionPayloadKeySpecifier | (() => undefined | UpdateFinancialTransactionPayloadKeySpecifier),
		fields?: UpdateFinancialTransactionPayloadFieldPolicy,
	},
	UpdateGroupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateGroupPayloadKeySpecifier | (() => undefined | UpdateGroupPayloadKeySpecifier),
		fields?: UpdateGroupPayloadFieldPolicy,
	},
	UpdateIdentifierPreferencesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateIdentifierPreferencesPayloadKeySpecifier | (() => undefined | UpdateIdentifierPreferencesPayloadKeySpecifier),
		fields?: UpdateIdentifierPreferencesPayloadFieldPolicy,
	},
	UpdateLiveSessionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateLiveSessionPayloadKeySpecifier | (() => undefined | UpdateLiveSessionPayloadKeySpecifier),
		fields?: UpdateLiveSessionPayloadFieldPolicy,
	},
	UpdateLotPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateLotPayloadKeySpecifier | (() => undefined | UpdateLotPayloadKeySpecifier),
		fields?: UpdateLotPayloadFieldPolicy,
	},
	UpdateMedicineCoursePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateMedicineCoursePayloadKeySpecifier | (() => undefined | UpdateMedicineCoursePayloadKeySpecifier),
		fields?: UpdateMedicineCoursePayloadFieldPolicy,
	},
	UpdateMedicineCourseStagePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateMedicineCourseStagePayloadKeySpecifier | (() => undefined | UpdateMedicineCourseStagePayloadKeySpecifier),
		fields?: UpdateMedicineCourseStagePayloadFieldPolicy,
	},
	UpdateMobileClientStatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateMobileClientStatePayloadKeySpecifier | (() => undefined | UpdateMobileClientStatePayloadKeySpecifier),
		fields?: UpdateMobileClientStatePayloadFieldPolicy,
	},
	UpdateNotificationSettingsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateNotificationSettingsPayloadKeySpecifier | (() => undefined | UpdateNotificationSettingsPayloadKeySpecifier),
		fields?: UpdateNotificationSettingsPayloadFieldPolicy,
	},
	UpdateOrganisationPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateOrganisationPayloadKeySpecifier | (() => undefined | UpdateOrganisationPayloadKeySpecifier),
		fields?: UpdateOrganisationPayloadFieldPolicy,
	},
	UpdatePartnerDeliveryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatePartnerDeliveryPayloadKeySpecifier | (() => undefined | UpdatePartnerDeliveryPayloadKeySpecifier),
		fields?: UpdatePartnerDeliveryPayloadFieldPolicy,
	},
	UpdatePasswordPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatePasswordPayloadKeySpecifier | (() => undefined | UpdatePasswordPayloadKeySpecifier),
		fields?: UpdatePasswordPayloadFieldPolicy,
	},
	UpdatePostPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatePostPayloadKeySpecifier | (() => undefined | UpdatePostPayloadKeySpecifier),
		fields?: UpdatePostPayloadFieldPolicy,
	},
	UpdatePreferredBusinessUnitPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatePreferredBusinessUnitPayloadKeySpecifier | (() => undefined | UpdatePreferredBusinessUnitPayloadKeySpecifier),
		fields?: UpdatePreferredBusinessUnitPayloadFieldPolicy,
	},
	UpdatePreferredBusinessUnitStatusPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatePreferredBusinessUnitStatusPayloadKeySpecifier | (() => undefined | UpdatePreferredBusinessUnitStatusPayloadKeySpecifier),
		fields?: UpdatePreferredBusinessUnitStatusPayloadFieldPolicy,
	},
	UpdatePreviousKeeperPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatePreviousKeeperPayloadKeySpecifier | (() => undefined | UpdatePreviousKeeperPayloadKeySpecifier),
		fields?: UpdatePreviousKeeperPayloadFieldPolicy,
	},
	UpdateSirePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateSirePayloadKeySpecifier | (() => undefined | UpdateSirePayloadKeySpecifier),
		fields?: UpdateSirePayloadFieldPolicy,
	},
	UpdateTagPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateTagPayloadKeySpecifier | (() => undefined | UpdateTagPayloadKeySpecifier),
		fields?: UpdateTagPayloadFieldPolicy,
	},
	UpdateUserPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateUserPayloadKeySpecifier | (() => undefined | UpdateUserPayloadKeySpecifier),
		fields?: UpdateUserPayloadFieldPolicy,
	},
	UploadCsvPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadCsvPayloadKeySpecifier | (() => undefined | UploadCsvPayloadKeySpecifier),
		fields?: UploadCsvPayloadFieldPolicy,
	},
	UploadDiscountGridPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadDiscountGridPayloadKeySpecifier | (() => undefined | UploadDiscountGridPayloadKeySpecifier),
		fields?: UploadDiscountGridPayloadFieldPolicy,
	},
	UploadFileSourcePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadFileSourcePayloadKeySpecifier | (() => undefined | UploadFileSourcePayloadKeySpecifier),
		fields?: UploadFileSourcePayloadFieldPolicy,
	},
	Url?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UrlKeySpecifier | (() => undefined | UrlKeySpecifier),
		fields?: UrlFieldPolicy,
	},
	User?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier),
		fields?: UserFieldPolicy,
	},
	UserImageThumbnailType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserImageThumbnailTypeKeySpecifier | (() => undefined | UserImageThumbnailTypeKeySpecifier),
		fields?: UserImageThumbnailTypeFieldPolicy,
	},
	UserPublicInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserPublicInfoKeySpecifier | (() => undefined | UserPublicInfoKeySpecifier),
		fields?: UserPublicInfoFieldPolicy,
	},
	ValidationError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ValidationErrorKeySpecifier | (() => undefined | ValidationErrorKeySpecifier),
		fields?: ValidationErrorFieldPolicy,
	},
	ValidationErrorType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ValidationErrorTypeKeySpecifier | (() => undefined | ValidationErrorTypeKeySpecifier),
		fields?: ValidationErrorTypeFieldPolicy,
	},
	VideoGroupType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VideoGroupTypeKeySpecifier | (() => undefined | VideoGroupTypeKeySpecifier),
		fields?: VideoGroupTypeFieldPolicy,
	},
	VideoType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VideoTypeKeySpecifier | (() => undefined | VideoTypeKeySpecifier),
		fields?: VideoTypeFieldPolicy,
	},
	Want?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WantKeySpecifier | (() => undefined | WantKeySpecifier),
		fields?: WantFieldPolicy,
	},
	WantConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WantConnectionKeySpecifier | (() => undefined | WantConnectionKeySpecifier),
		fields?: WantConnectionFieldPolicy,
	},
	WantEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WantEdgeKeySpecifier | (() => undefined | WantEdgeKeySpecifier),
		fields?: WantEdgeFieldPolicy,
	},
	WantFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WantFileKeySpecifier | (() => undefined | WantFileKeySpecifier),
		fields?: WantFileFieldPolicy,
	},
	WantTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WantTemplateKeySpecifier | (() => undefined | WantTemplateKeySpecifier),
		fields?: WantTemplateFieldPolicy,
	},
	WeightActivityLog?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WeightActivityLogKeySpecifier | (() => undefined | WeightActivityLogKeySpecifier),
		fields?: WeightActivityLogFieldPolicy,
	},
	WeightChartData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WeightChartDataKeySpecifier | (() => undefined | WeightChartDataKeySpecifier),
		fields?: WeightChartDataFieldPolicy,
	},
	WithdrawTransactionHistoryType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WithdrawTransactionHistoryTypeKeySpecifier | (() => undefined | WithdrawTransactionHistoryTypeKeySpecifier),
		fields?: WithdrawTransactionHistoryTypeFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;